export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type ClassRequestQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type ClassRequestQuery = {
  __typename?: "Query";
  classRequest: {
    __typename?: "ClassRequest";
    uid: string;
    age: number;
    content: string;
  } | null;
};

export type CreateActivityMutationVariables = Exact<{
  title: Scalars["String"];
  classRequestUid?: InputMaybe<Scalars["ID"]>;
  attribution?: InputMaybe<Attribution>;
  activityType?: InputMaybe<CreateActivityType>;
  classroomType?: InputMaybe<ClassroomType>;
  format?: InputMaybe<EducatorSelectedFormat>;
}>;

export type CreateActivityMutation = {
  __typename?: "Mutation";
  createActivity: {
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    saveCount: number | null;
    archived_at: any | null;
    upsell_activity_uid: string | null;
    why_me: string | null;
    parental_guidance: string | null;
    sources: string | null;
    materials: string | null;
    hasSections: boolean;
    has_external_resources: boolean | null;
    attributes: Array<{
      __typename?: "EntityAttribute";
      key: string;
      value: string;
      entity_type: string;
      source: string | null;
    }>;
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    details: { __typename?: "ActivityDetails"; asyncTime: string | null };
    leaderDetails: {
      __typename?: "ActivityLeaderDetails";
      uid: string;
      requestedListingAt: any | null;
      welcomeMessage: {
        __typename?: "WelcomeMessage";
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        }> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        } | null;
      } | null;
    };
    externalResources: Array<{
      __typename?: "ExternalResource";
      uid: string;
      name: string;
      url: string | null;
    }>;
  };
};

export type DeleteSectionsMutationVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type DeleteSectionsMutation = {
  __typename?: "Mutation";
  deleteSections: {
    __typename?: "Activity";
    uid: string;
    hasSections: boolean;
  };
};

export type FormatEditModalActiveSectionsQueryVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type FormatEditModalActiveSectionsQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    enrollmentCount: number;
    paginatedFilteredSections: {
      __typename?: "SectionList";
      totalCount: number;
      data: Array<{
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        filledSpaceCount: number;
        meetings: Array<{ __typename?: "Meeting"; uid: string; end_time: any }>;
      }>;
    };
  };
};

export type ApprovedExternalResourcesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ApprovedExternalResourcesQuery = {
  __typename?: "Query";
  approvedExternalResources: Array<{
    __typename?: "ExternalResource";
    name: string;
    uid: string;
    url: string | null;
    category: string | null;
  } | null>;
};

export type DeleteExternalResourceMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type DeleteExternalResourceMutation = {
  __typename?: "Mutation";
  deleteExternalResource: boolean;
};

export type ActivityExternalResourcesQueryVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type ActivityExternalResourcesQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    age_min: number | null;
    externalResources: Array<{
      __typename?: "ExternalResource";
      uid: string;
      name: string;
      url: string | null;
      policy_type: ExternalResourcePolicy | null;
    }>;
  };
};

export type IsExternalResourceAllowedQueryVariables = Exact<{
  resourceUrl: Scalars["String"];
}>;

export type IsExternalResourceAllowedQuery = {
  __typename?: "Query";
  policyForExternalResource: ExternalResourcePolicy | null;
};

export type AddExternalResource2MutationVariables = Exact<{
  activityUid: Scalars["ID"];
  input: ExternalResourceInput;
}>;

export type AddExternalResource2Mutation = {
  __typename?: "Mutation";
  addExternalResource: { __typename?: "ExternalResource"; uid: string };
};

export type ActivityStatusLabel_ActivityFragment = {
  __typename?: "Activity";
  archived_at: any | null;
  published_at: any | null;
  requested_listing_at: any | null;
  approvalStatus: {
    __typename?: "ActivityApprovalStatus";
    action: string;
    message_to_teacher: string | null;
  } | null;
};

export type CreateNewBundleMutationVariables = Exact<{
  createBundleInput: CreateBundleInput;
}>;

export type CreateNewBundleMutation = {
  __typename?: "Mutation";
  createNewBundle: { __typename?: "Bundle"; uid: string };
};

export type ActivityForCalendarFragmentFragment = {
  __typename?: "Activity";
  uid: string;
  slug_id: string;
  published_at: any | null;
  title: string;
  titleTranslated: string | null;
  url: string;
  path: string;
  hasTeacherSchedule: boolean;
  isClub: boolean;
  isFlexSchedule: boolean;
  isSelfPaced: boolean;
  isOneTime: boolean;
  duration_minutes: number | null;
  duration_weeks: number | null;
  weekly_meetings: number | null;
  is_ongoing_weekly: boolean;
  size_min: number | null;
  size_max: number | null;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type CreateClassRequestMutationVariables = Exact<{
  age: Scalars["Int"];
  content: Scalars["String"];
}>;

export type CreateClassRequestMutation = {
  __typename?: "Mutation";
  createClassRequest: {
    __typename?: "ClassRequest";
    uid: string;
    age: number;
    content: string;
  } | null;
};

export type ClassScheduleRequest_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  slug_id: string;
  title: string;
  titleTranslated: string | null;
};

export type LearnerScheduleEventsQueryVariables = Exact<{
  start: Scalars["DateTime"];
  limit?: InputMaybe<Scalars["Int"]>;
  learnerUid: Scalars["ID"];
}>;

export type LearnerScheduleEventsQuery = {
  __typename?: "Query";
  learnerScheduleEvents: {
    __typename?: "ScheduleEvents";
    events: Array<{ __typename?: "ScheduleEvent"; uid: string }>;
  };
};

export type GetConciergeAiAssistantPromptOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetConciergeAiAssistantPromptOptionsQuery = {
  __typename?: "Query";
  getConciergeAiAssistantPromptOptions: Array<{
    __typename?: "ConciergeAiAssistantPromptOption";
    uid: string;
    promptName: string;
  }>;
};

export type AskConciergeAiAssistantQueryVariables = Exact<{
  activitySlugId: Scalars["String"];
  promptUid?: InputMaybe<Scalars["ID"]>;
  rawPrompt?: InputMaybe<Scalars["String"]>;
}>;

export type AskConciergeAiAssistantQuery = {
  __typename?: "Query";
  askConciergeAiAssistant: {
    __typename?: "ConciergeAiAssistantResponse";
    prompt: string;
    response: string;
  };
};

export type ExperimentOverridesQueryVariables = Exact<{ [key: string]: never }>;

export type ExperimentOverridesQuery = {
  __typename?: "Query";
  experimentOverrides: Array<{
    __typename?: "ExperimentOverride";
    name: string;
    variants: Array<string>;
  }>;
};

export type EnrollmentManagerCard_EnrollmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  isPaused: boolean;
  ongoingStartTime: any | null;
  isEnded: boolean;
  ongoingEndTime: any | null;
  cancellationType: EnrollmentCancellationType | null;
  withdrawnAt: any | null;
  isWithdrawn: boolean;
  learner: {
    __typename?: "Learner";
    uid: string;
    avatar: string | null;
    name: string | null;
    age: number | null;
    isBlocked: boolean | null;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      timeZone: string | null;
    };
  } | null;
  pauseWindow: {
    __typename?: "EnrollmentPauseWindow";
    uid: string;
    startDate: any;
    pauseReason: string;
  } | null;
  upcomingPausedMeeting: { __typename?: "Meeting"; start_time: any } | null;
};

export type EnrollmentManagerCard_SectionFragment = {
  __typename?: "Section";
  uid: string;
  currentUserCanManage: boolean;
  is_self_paced: boolean;
  teacher_support_start_time: any | null;
  start_time: any | null;
  end_time: any | null;
  canceled_at: any | null;
  deleted_at: any | null;
  published_at: any | null;
  leader: { __typename?: "Leader"; uid: string };
  activity: {
    __typename?: "Activity";
    hasTeacherSchedule: boolean;
    is_ongoing_weekly: boolean;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
  };
};

export type MeetingRescheduleRequestBanner_MeetingsFragment = {
  __typename: "Meeting";
  uid: string;
  start_time: any;
  end_time: any;
  rescheduleRequests: Array<{
    __typename: "MeetingRequest";
    uid: string;
    created_at: any;
    expires_at: any;
    start_time: any;
    end_time: any;
    status: MeetingRequestStatus;
    message: string | null;
    is_recurring: boolean;
  }>;
};

export type AcceptMeetingRescheduleMutationVariables = Exact<{
  requestUid: Scalars["ID"];
}>;

export type AcceptMeetingRescheduleMutation = {
  __typename?: "Mutation";
  acceptMeetingReschedule: Array<{
    __typename: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    rescheduleRequests: Array<{
      __typename: "MeetingRequest";
      uid: string;
      created_at: any;
      expires_at: any;
      start_time: any;
      end_time: any;
      status: MeetingRequestStatus;
      message: string | null;
      is_recurring: boolean;
    }>;
  }>;
};

export type NewMeetingRequestBanner_MeetingRequestsFragment = {
  __typename: "MeetingRequest";
  uid: string;
  created_at: any;
  start_time: any;
  end_time: any;
  expires_at: any;
  status: MeetingRequestStatus;
  is_recurring: boolean;
};

export type NewMeetingRequestBanner_EnrollmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  price_cents: number | null;
  section: {
    __typename?: "Section";
    uid: string;
    leader: {
      __typename?: "Leader";
      uid: string;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    };
  } | null;
};

export type DeclineMeetingRequestsMutationVariables = Exact<{
  requestUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type DeclineMeetingRequestsMutation = {
  __typename?: "Mutation";
  declineMeetingRequests: Array<{
    __typename: "MeetingRequest";
    uid: string;
    created_at: any;
    start_time: any;
    end_time: any;
    expires_at: any;
    status: MeetingRequestStatus;
    is_recurring: boolean;
  }>;
};

export type OneOnOneRescheduleModal_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  hasTeacherSchedule: boolean;
  price_cents: number | null;
  esaStatus: EsaStatus;
  is_ongoing_weekly: boolean;
  isClub: boolean;
  title: string;
  titleTranslated: string | null;
  weekly_meetings: number | null;
  duration_weeks: number | null;
  isFlexSchedule: boolean;
  isSelfPaced: boolean;
  published_at: any | null;
  size_max: number | null;
  allows_recurring_payment: boolean | null;
  enrollableTimes: Array<{
    __typename?: "EnrollableTime";
    startTime: any;
    endTime: any;
    teacher: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      hasBackgroundCheckExpired: boolean | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    };
  }>;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
  refundPolicy: {
    __typename?: "RefundPolicy";
    name: string;
    description: string;
    type: RefundPolicyType;
  };
};

export type OneOnOneUpcomingMeetings_MeetingsFragment = {
  __typename?: "Meeting";
  uid: string;
  start_time: any;
  end_time: any;
  created_at: any | null;
  deleted_at: any | null;
  paidAt: any | null;
  oneOnOneTenderType: Array<TenderType> | null;
  canParentUpdate: boolean | null;
  billedOn: any;
  recurring: boolean | null;
  refundableAmountCents: number;
  refundableAmountCredits: number | null;
  recurringSchedule: {
    __typename?: "RecurringSchedule";
    uid: string;
    end_at: any | null;
  } | null;
};

export type OneOnOneUpcomingMeetings_PendingMeetingsFragment = {
  __typename?: "EnrollmentMeetingPurchase";
  startTime: any;
  endTime: any;
  uid: string;
  activityUid: string | null;
  enrollmentUid: string | null;
  meetingUid: string | null;
  orderSlugId: string;
  confirmedAt: any | null;
};

export type OneOnOneUpcomingMeetings_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  slug_id: string;
  hasTeacherSchedule: boolean;
  price_cents: number | null;
  esaStatus: EsaStatus;
  is_ongoing_weekly: boolean;
  isClub: boolean;
  title: string;
  titleTranslated: string | null;
  weekly_meetings: number | null;
  duration_weeks: number | null;
  isFlexSchedule: boolean;
  isSelfPaced: boolean;
  published_at: any | null;
  size_max: number | null;
  allows_recurring_payment: boolean | null;
  refundPolicy: {
    __typename?: "RefundPolicy";
    name: string;
    description: string;
    type: RefundPolicyType;
    creditDescription: string | null;
  };
  enrollableTimes: Array<{
    __typename?: "EnrollableTime";
    startTime: any;
    endTime: any;
    teacher: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      hasBackgroundCheckExpired: boolean | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    };
  }>;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type TeacherCard_LeaderFragment = {
  __typename?: "Leader";
  uid: string;
  leader_link: string | null;
  name: string | null;
  photo: string | null;
  timeZone: string | null;
  details: { __typename?: "LeaderDetails"; headline: string | null };
};

export type TeacherCard_SectionFragment = {
  __typename?: "Section";
  uid: string;
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    leader: {
      __typename?: "Leader";
      uid: string;
      leader_link: string | null;
      name: string | null;
      photo: string | null;
      timeZone: string | null;
      details: { __typename?: "LeaderDetails"; headline: string | null };
    };
  };
  leader: {
    __typename?: "Leader";
    uid: string;
    leader_link: string | null;
    name: string | null;
    photo: string | null;
    timeZone: string | null;
    details: { __typename?: "LeaderDetails"; headline: string | null };
  };
};

export type RecordingsTabAiMeetingSummaryQueryVariables = Exact<{
  meetingUid: Scalars["ID"];
}>;

export type RecordingsTabAiMeetingSummaryQuery = {
  __typename?: "Query";
  meetingAiSummary: {
    __typename?: "MeetingAiSummary";
    ai_summary_text: string;
    edited_summary_text: string | null;
  } | null;
};

export type RecordingsTabMeetingsQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  startBefore: Scalars["DateTime"];
  limit: Scalars["Int"];
}>;

export type RecordingsTabMeetingsQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    duration_minutes: number | null;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      recordingAvailability: RecordingAvailability;
      hasAiSummary: boolean;
      classRecordings: Array<
        | {
            __typename?: "ClassRecording";
            uid: string;
            playUrl: string | null;
            startTime: any;
            endTime: any;
          }
        | {
            __typename?: "ZoomRecording";
            uid: string;
            playUrl: string;
            startTime: any;
            endTime: any;
          }
      >;
      recordingRequests: Array<{
        __typename?: "RecordingRequest";
        message: string;
        requestedBy: { __typename?: "Learner"; uid: string };
      }>;
    }>;
  } | null;
};

export type EnrollmentAdminRow_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  is_ongoing_weekly: boolean;
  isClub: boolean;
};

export type EnrollmentAdminRow_EnrollmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  ongoingStartTime: any | null;
  ongoing_start_time: any | null;
  ongoingEndTime: any | null;
  ongoing_end_time: any | null;
  ongoingStoppedAt: any | null;
  ongoing_stopped_at: any | null;
  orderSlugId: string | null;
  isEnded: boolean;
  isPaused: boolean;
  isPrepay: boolean;
  created_at: any | null;
  createdAt: any;
  withdrawn_at: any | null;
  withdrawnAt: any | null;
  confirmed_at: any | null;
  confirmedAt: any | null;
  currency_code: CurrencyCode;
  exchange_rate: number;
  refundableAmountCents: number;
  hasPaymentSchedule: boolean;
  isPendingEsaOrder: boolean;
  learner: { __typename?: "Learner"; uid: string } | null;
  parent: { __typename?: "Parent"; uid: string; name: string | null };
  payments: Array<{
    __typename?: "EnrollmentPayment";
    uid: string;
    paid_at: any | null;
    purchase_order_id: string | null;
    esa_order_id: string | null;
  }>;
  refundPolicy: { __typename?: "RefundPolicy"; name: string } | null;
  details: { __typename?: "EnrollmentDetails"; message: string | null };
  lastSectionTransfer: {
    __typename?: "SectionTransfer";
    timestamp: any;
    fromSection: {
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
    } | null;
  } | null;
  ongoingSectionTransferredFrom: {
    __typename?: "SectionTransfer";
    timestamp: any;
    fromSection: {
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
    } | null;
  } | null;
  fundingProgramInvoice: {
    __typename?: "FundingProgramInvoice";
    uid: string;
    awardId: string;
  } | null;
};

export type EnrollmentAdminRow_GiftEnrollmentFragment = {
  __typename?: "GiftEnrollment";
  uid: string;
  isPaused: boolean;
  isEnded: boolean;
  giftClaimedAt: any | null;
  createdAt: any;
  confirmedAt: any | null;
  withdrawnAt: any | null;
  withdrawn_at: any | null;
  ongoingStoppedAt: any | null;
  ongoingStartTime: any | null;
  ongoingEndTime: any | null;
  ongoing_stopped_at: any | null;
  currency_code: CurrencyCode;
  exchange_rate: number;
  amount_in_local_currency: number;
  ongoing_start_time: any | null;
  ongoing_end_time: any | null;
  hasPaymentSchedule: boolean;
  orderSlugId: string | null;
  canBeWithdrawn: boolean;
  canBeStopped: boolean;
  canBePaused: boolean;
  priceCents: number | null;
  currentUserIsPurchaser: boolean;
  refundableAmountCents: number;
  lastSectionTransfer: {
    __typename?: "SectionTransfer";
    timestamp: any;
    fromSection: {
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
    } | null;
  } | null;
  ongoingSectionTransferredFrom: {
    __typename?: "SectionTransfer";
    timestamp: any;
    fromSection: {
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
    } | null;
  } | null;
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  } | null;
  learner: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    isVerified: boolean;
    isBlocked: boolean | null;
    blockedByUserUid: string | null;
    blockedAt: any | null;
  } | null;
  buyer: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  };
  pricingOffer: {
    __typename?: "PricingOffer";
    name: string;
    buyerOrgName: string | null;
    isFinancialAid: boolean;
  } | null;
  details: {
    __typename?: "EnrollmentDetails";
    name: string | null;
    age: string | null;
    attendedAt: any | null;
    message: string | null;
  };
  payments: Array<{
    __typename?: "EnrollmentPayment";
    uid: string;
    amount_cents: number | null;
    order_slug_id: string | null;
    stripe_charge_id: string | null;
    purchase_order_id: string | null;
    esa_order_id: string | null;
    intercom_url: string | null;
    last4: string | null;
    created_at: any | null;
    paid_at: any | null;
    disbursed_at: any | null;
    payout_uid: string | null;
    start_time: any | null;
    end_time: any | null;
    unrefundedCents: number;
    isOngoingRefundable: boolean;
    voucher_name: string | null;
    pricing_offer_uid: string | null;
    credit_transaction_uid: string | null;
    credit_account_type: string | null;
    coupon_code_uid: string | null;
    currency_code: CurrencyCode | null;
    exchange_rate: number | null;
    invoice_uid: string | null;
    funding_program_invoice_uid: string | null;
    service_fee_percentage: number | null;
    couponCode: {
      __typename?: "CouponCode";
      code: string;
      coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
  }>;
  refundPolicy: {
    __typename?: "RefundPolicy";
    type: RefundPolicyType;
    name: string;
    description: string;
  } | null;
  paymentSchedule: {
    __typename?: "PaymentSchedule";
    uid: string;
    stoppedAt: any | null;
    endTime: any | null;
  } | null;
  pauseWindow: {
    __typename?: "EnrollmentPauseWindow";
    uid: string;
    startDate: any;
    endDate: any;
    canBeCanceled: boolean;
    pauseReason: string;
  } | null;
};

export type EnrollmentAdminRow_SectionFragment = {
  __typename?: "Section";
  uid: string;
  start_time: any | null;
  end_time: any | null;
  leader: { __typename?: "Leader"; name: string | null };
  activity: {
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    subject: string | null;
    title: string;
    titleTranslated: string | null;
    price_cents: number | null;
    isClub: boolean;
    duration_weeks: number | null;
    is_ongoing_weekly: boolean;
    weekly_meetings: number | null;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  };
};

export type EnrollmentAdminRow_EnrollingParentFragment = {
  __typename?: "Parent";
  uid: string;
};

export type EnrollmentAdminRow_PaymentFragment = {
  __typename?: "EnrollmentPayment";
  uid: string;
  amount_cents: number | null;
  amount_credits: number | null;
  order_slug_id: string | null;
  intercom_url: string | null;
  paid_at: any | null;
  disbursed_at: any | null;
  payout_uid: string | null;
  start_time: any | null;
  end_time: any | null;
  unrefundedCents: number;
  unrefundedCredits: number | null;
  voucher_name: string | null;
  last4: string | null;
  stripe_charge_id: string | null;
  purchase_order_id: string | null;
  credit_transaction_uid: string | null;
  credit_account_type: string | null;
  coupon_code_uid: string | null;
  pricing_offer_uid: string | null;
  esa_order_id: string | null;
  invoice_uid: string | null;
  currency_code: CurrencyCode | null;
  exchange_rate: number | null;
  funding_program_invoice_uid: string | null;
  service_fee_percentage: number | null;
  oneOnOneMeeting: {
    __typename?: "Meeting";
    uid: string;
    start_time: any;
  } | null;
  organization: {
    __typename?: "Organization";
    uid: string;
    name: string;
    state: string | null;
    logoUrl: string | null;
    urlName: string | null;
  } | null;
  refunds: Array<{
    __typename?: "EnrollmentPaymentRefund";
    uid: string;
    user_uid: string;
    amount_cents: number;
    amount_credits: number | null;
    refunded_at: any | null;
    reason: string | null;
    user_role: string | null;
    note: string | null;
    reduces_teacher_payout: boolean;
    amount_in_local_currency: number | null;
    currency_code: CurrencyCode | null;
    exchange_rate: number | null;
    addOutschoolCreditTransaction: {
      __typename?: "CreditTransaction";
      uid: string;
      amount_cents: number;
      expiresAt: any | null;
      unspentCents: number | null;
    } | null;
  }>;
  couponCode: {
    __typename?: "CouponCode";
    code: string;
    coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
  } | null;
};

export type FollowedUserFragmentFragment = {
  __typename?: "FollowedUser";
  uid: string;
  followed_uid: string;
  created_at: any;
  leader: {
    __typename?: "Leader";
    uid: string;
    name: string | null;
    leader_link: string | null;
    created_at: any | null;
    photo: string | null;
    suspended_at: any | null;
    cityState: string | null;
    socialOptOut: boolean;
    is_crosslister: boolean | null;
    timeZone: string | null;
    hasAvailabilitySet: boolean;
    approved: boolean;
    hasBackgroundCheckExpired: boolean | null;
    details: {
      __typename?: "LeaderDetails";
      about: string | null;
      headline: string | null;
      headlineTranslated: string | null;
      countryOfResidence: string | null;
    };
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    teacherForSellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
    } | null;
  };
};

export type FollowedTeachersQueryVariables = Exact<{ [key: string]: never }>;

export type FollowedTeachersQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    followedUsers: Array<{
      __typename?: "FollowedUser";
      uid: string;
      followed_uid: string;
      created_at: any;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        created_at: any | null;
        photo: string | null;
        suspended_at: any | null;
        cityState: string | null;
        socialOptOut: boolean;
        is_crosslister: boolean | null;
        timeZone: string | null;
        hasAvailabilitySet: boolean;
        approved: boolean;
        hasBackgroundCheckExpired: boolean | null;
        details: {
          __typename?: "LeaderDetails";
          about: string | null;
          headline: string | null;
          headlineTranslated: string | null;
          countryOfResidence: string | null;
        };
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: {
          __typename?: "SellerOrg";
          uid: string;
          name: string;
        } | null;
      };
    }>;
  } | null;
};

export type FollowUserMutationVariables = Exact<{
  userUid: Scalars["ID"];
  referer?: InputMaybe<Scalars["String"]>;
  attribution?: InputMaybe<Attribution>;
}>;

export type FollowUserMutation = {
  __typename?: "Mutation";
  followUser: {
    __typename?: "FollowedUser";
    uid: string;
    followed_uid: string;
    created_at: any;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    };
  };
};

export type LearnerInterestTopicsFragmentFragment = {
  __typename?: "Child";
  uid: string;
  name: string | null;
  age: number | null;
  interestTopics: {
    __typename?: "TopicsConnection";
    topics: Array<{ __typename?: "Topic"; uid: string; label: string }>;
  };
};

export type AddChildrenMutationVariables = Exact<{
  childInputs: Array<ChildInput> | ChildInput;
}>;

export type AddChildrenMutation = {
  __typename?: "Mutation";
  addChildren: Array<{
    __typename?: "Child";
    uid: string;
    name: string | null;
    age: number | null;
    birthMonth: number | null;
    date_of_birth: any | null;
    birthYear: number | null;
    email: string | null;
    avatar: string | null;
    unlockedAvatars: Array<string>;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    email_confirmed_at: any | null;
    hasMarketingConsent: boolean | null;
    hasHealthConsent: boolean | null;
    isLoginEnabled: boolean;
    username: string | null;
    hasPassword: boolean;
    hasEsaMembership: boolean;
    esaMembershipProgram: string | null;
    interestTopics: {
      __typename?: "TopicsConnection";
      topics: Array<{ __typename?: "Topic"; uid: string; label: string }>;
    };
    attributes: Array<{
      __typename?: "EntityAttribute";
      uid: string;
      key: string;
      value: string;
      source: string | null;
    }>;
    entityAvailabilitySchedule: {
      __typename?: "EntityAvailabilitySchedule";
      entityAvailabilities: Array<{
        __typename?: "EntityAvailability";
        startHour: number;
        startMinute: number;
        day: number;
        endHour: number;
        endMinute: number;
        uid: string;
      }>;
    } | null;
  }>;
};

export type SendMessageToOutschoolMutationVariables = Exact<{
  messageInput: MessageInput;
}>;

export type SendMessageToOutschoolMutation = {
  __typename?: "Mutation";
  sendMessageToOutschool: boolean;
};

export type SendMessageToUserMutationVariables = Exact<{
  messageInput: MessageInput;
  recipientUids: Array<Scalars["ID"]> | Scalars["ID"];
  previousMessageUid?: InputMaybe<Scalars["ID"]>;
}>;

export type SendMessageToUserMutation = {
  __typename?: "Mutation";
  sendMessage: {
    __typename?: "Message";
    uid: string;
    subject: string | null;
    action: string | null;
    content: string | null;
    created_at: any;
    activity_uid: string | null;
    section_uid: string | null;
    thread_uid: string;
    sender: {
      __typename?: "Sender";
      uid: string;
      name: string | null;
      photo: string | null;
    };
    participants: Array<{
      __typename?: "Participant";
      uid: string;
      name: string | null;
      photo: string | null;
      timeZone: string | null;
      headline: string | null;
      leader_link: string | null;
      isLearner: boolean;
      role: ParticipantRole | null;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    }>;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
  };
};

export type EducatorSendMessageToUserMutationVariables = Exact<{
  messageInput: MessageInput;
  recipientUids: Array<Scalars["ID"]> | Scalars["ID"];
  previousMessageUid?: InputMaybe<Scalars["ID"]>;
}>;

export type EducatorSendMessageToUserMutation = {
  __typename?: "Mutation";
  sendMessage: {
    __typename?: "Message";
    uid: string;
    subject: string | null;
    action: string | null;
    content: string | null;
    created_at: any;
    activity_uid: string | null;
    section_uid: string | null;
    thread_uid: string;
    sender: {
      __typename?: "Sender";
      uid: string;
      name: string | null;
      photo: string | null;
    };
    participants: Array<{
      __typename?: "Participant";
      uid: string;
      name: string | null;
      photo: string | null;
      timeZone: string | null;
      headline: string | null;
      leader_link: string | null;
      isLearner: boolean;
      role: ParticipantRole | null;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    }>;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
  };
};

export type SubscribeToCreationEmailsMutationVariables = Exact<{
  attribution?: InputMaybe<Attribution>;
}>;

export type SubscribeToCreationEmailsMutation = {
  __typename?: "Mutation";
  subscribeToCreationEmails: boolean;
};

export type OrganizationEditForm_OrganizationFragment = {
  __typename?: "Organization";
  deletedAt: any | null;
  name: string;
  type: OrganizationType;
  address: string | null;
  state: string | null;
  notes: string | null;
  urlName: string | null;
  logoUrl: string | null;
  invoiceEmail: string | null;
  techSupportEmail: string | null;
  trustSafetyEmail: string | null;
  totalCapCents: number | null;
};

export type SavedClassListsForParentProfileQueryVariables = Exact<{
  uid: Scalars["ID"];
  profileLinkUid?: InputMaybe<Scalars["String"]>;
  publicView?: InputMaybe<Scalars["Boolean"]>;
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
}>;

export type SavedClassListsForParentProfileQuery = {
  __typename?: "Query";
  savedClassListsForParentProfile: Array<{
    __typename?: "SavedClassList";
    uid: string;
    name: string;
    privacyStatus: SavedClassListStatus;
    listings: Array<{
      __typename?: "Listing";
      insertionId: string | null;
      sectionCount: number;
      openSectionCount: number;
      upcomingSectionCount: number;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
            fileSize: number | null;
          };
        } | null;
        credentials: Array<{
          __typename?: "TeacherCredential";
          uid: string;
          degreeType: DegreeType | null;
          degreeSubject: DegreeSubject | null;
        }>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
      activity: {
        __typename?: "Activity";
        uid: string;
        isIncludedWithMembership: boolean;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        quickSummary: string | null;
        isClub: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        hasTeacherSchedule: boolean;
        size_max: number | null;
        user_uid: string;
        slug_id: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        recentReviews?: Array<{
          __typename?: "PublicReview";
          uid: string;
          activity_star_rating: number | null;
          details: {
            __typename?: "PublicReviewDetails";
            publicReview: string | null;
          } | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            publicName: string | null;
          };
        }>;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
    } | null>;
  }>;
};

export type ReviewableSectionFragment = {
  __typename?: "ReviewableSection";
  activity_uid: string;
  section_uid: string;
  feedback_uid: string | null;
  can_review: boolean;
};

export type SectionsForReviewQueryVariables = Exact<{ [key: string]: never }>;

export type SectionsForReviewQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    enrolledSectionsThatNeedReview: Array<{
      __typename?: "ReviewableSection";
      activity_uid: string;
      section_uid: string;
      feedback_uid: string | null;
      can_review: boolean;
    } | null>;
  } | null;
};

export type ParentScheduleCalendar_EnrollmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  confirmedAt: any | null;
  withdrawnAt: any | null;
  ongoingStartTime: any | null;
  ongoingEndTime: any | null;
  learner: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    created_at: any;
    isVerified: boolean;
  } | null;
  section: {
    __typename?: "Section";
    uid: string;
    start_time: any | null;
    end_time: any | null;
    meetingCount: number;
    deleted_at: any | null;
    published_at: any | null;
    canceled_at: any | null;
    filledSpaceCount: number;
    validEnrollmentCount: number;
    activity: {
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      published_at: any | null;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      hasTeacherSchedule: boolean;
      isClub: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      is_ongoing_weekly: boolean;
      size_min: number | null;
      size_max: number | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
      };
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    meetings: Array<{
      __typename?: "Meeting";
      sectionSequenceNumber: number;
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    }>;
  } | null;
  pauseWindow: {
    __typename?: "EnrollmentPauseWindow";
    uid: string;
    startDate: any;
    endDate: any;
  } | null;
};

export type ReferralsQueryVariables = Exact<{ [key: string]: never }>;

export type ReferralsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    totalReferralEarnings: number;
    referredParents: Array<{
      __typename?: "ParentReferral";
      firstName: string;
      status: ParentReferralStatus;
      claimedAmountCents: number;
    }>;
    referredTeachers: Array<{
      __typename?: "TeacherReferral";
      firstName: string;
      status: TeacherReferralStatus;
    }>;
  } | null;
};

export type OutreachReferralsQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]>;
}>;

export type OutreachReferralsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    outreachReferrals: {
      __typename?: "OutreachReferralConnection";
      edges: Array<{
        __typename?: "OutreachReferralEdge";
        node: {
          __typename?: "OutreachReferral";
          firstName: string;
          status: OutreachReferralStatus;
        };
      }>;
      pageInfo: {
        __typename?: "PageInfo";
        hasNextPage: boolean;
        lastCursor: string;
      };
    };
  } | null;
};

export type RequestListingMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  note?: InputMaybe<Scalars["String"]>;
}>;

export type RequestListingMutation = {
  __typename?: "Mutation";
  requestListing: {
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
  };
};

export type ReviewReminderTopNoticeBarQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ReviewReminderTopNoticeBarQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    enrolledSectionThatNeedsReview: {
      __typename?: "Section";
      uid: string;
      leader: {
        __typename?: "Leader";
        uid: string;
        photo: string | null;
        name: string | null;
      };
      activity: {
        __typename?: "Activity";
        uid: string;
        slug_id: string;
        titleTranslated: string | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
      };
    } | null;
  } | null;
};

export type TeacherOnboardingStatsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TeacherOnboardingStatsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    publicSectionCountIncludingUnpublished: number;
  } | null;
};

export type FilePreviewUrlQueryVariables = Exact<{
  uid: Scalars["String"];
}>;

export type FilePreviewUrlQuery = {
  __typename?: "Query";
  teacherCredentialFilePreviewURL: string;
};

export type TeacherEditProfileClassesListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TeacherEditProfileClassesListQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    activities: Array<{
      __typename?: "Activity";
      uid: string;
      title: string;
      hasTeacherSchedule: boolean;
    }>;
  } | null;
};

export type ClassesListQueryVariables = Exact<{ [key: string]: never }>;

export type ClassesListQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    activities: Array<{
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      saveCount: number | null;
      archived_at: any | null;
      upsell_activity_uid: string | null;
      why_me: string | null;
      parental_guidance: string | null;
      sources: string | null;
      materials: string | null;
      hasSections: boolean;
      has_external_resources: boolean | null;
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
      details: { __typename?: "ActivityDetails"; asyncTime: string | null };
      leaderDetails: {
        __typename?: "ActivityLeaderDetails";
        uid: string;
        requestedListingAt: any | null;
        welcomeMessage: {
          __typename?: "WelcomeMessage";
          text: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
            };
          }> | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
            };
          } | null;
        } | null;
      };
      externalResources: Array<{
        __typename?: "ExternalResource";
        uid: string;
        name: string;
        url: string | null;
      }>;
    }>;
  } | null;
};

export type GetTnsIncidentsQueryVariables = Exact<{
  userUid: Scalars["ID"];
  categoryOrActionFilter?: InputMaybe<Scalars["String"]>;
}>;

export type GetTnsIncidentsQuery = {
  __typename?: "Query";
  getTnsIncidentsSummary: {
    __typename?: "TnsIncidentsSummary";
    uid: string;
    totalStrikes: number;
    accountStatus: TnsAccountStatus;
    incidents: Array<{
      __typename?: "TnsIncident";
      uid: string;
      createdAt: any;
      strike: number;
      action: TnsAction;
      category: TnsActionCategory | null;
      notes: string | null;
      link: string | null;
      adminName: string;
      cumulativeStrikes: number;
    }>;
  };
};

export type GetEnrollmentPaymentRefundQueryVariables = Exact<{
  enrollmentPaymentRefundUid: Scalars["ID"];
}>;

export type GetEnrollmentPaymentRefundQuery = {
  __typename?: "Query";
  enrollmentPaymentRefund: {
    __typename?: "EnrollmentPaymentRefund";
    uid: string;
    reason: string | null;
    reduces_teacher_payout: boolean;
  };
};

export type UpdateEnrollmentPaymentRefundMutationMutationVariables = Exact<{
  userUid: Scalars["ID"];
  enrollmentPaymentRefundUid: Scalars["ID"];
  updates: EnrollmentPaymentRefundInput;
  adminUpdates: AdminEnrollmentPaymentRefundInput;
}>;

export type UpdateEnrollmentPaymentRefundMutationMutation = {
  __typename?: "Mutation";
  updateEnrollmentPaymentRefund: {
    __typename?: "EnrollmentPaymentRefund";
    uid: string;
    reduces_teacher_payout: boolean;
    reason: string | null;
  };
};

export type ChangeUserEmailMutationVariables = Exact<{
  email: Scalars["String"];
}>;

export type ChangeUserEmailMutation = {
  __typename?: "Mutation";
  changeCurrentUserEmail: {
    __typename?: "User";
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  };
};

export type ChangeCurrentUserOtherEmailMutationVariables = Exact<{
  otherEmail: Scalars["String"];
}>;

export type ChangeCurrentUserOtherEmailMutation = {
  __typename?: "Mutation";
  changeCurrentUserOtherEmail: {
    __typename?: "User";
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  };
};

export type DeleteCurrentUserOtherEmailMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type DeleteCurrentUserOtherEmailMutation = {
  __typename?: "Mutation";
  deleteCurrentUserOtherEmail: {
    __typename?: "User";
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  };
};

export type EsaCreditTransactionsQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
}>;

export type EsaCreditTransactionsQuery = {
  __typename?: "Query";
  transactionListings: {
    __typename?: "TransactionListings";
    totalCount: number;
    data: Array<
      | {
          __typename?: "ClassWalletTransactionListing";
          id: string;
          date: any;
          type: TransactionType;
          creditPurchase: {
            __typename?: "CreditPurchase";
            amount_cents: number;
            amount_granted_credits: number | null;
            learner: { __typename?: "Learner"; name: string | null } | null;
          } | null;
        }
      | {
          __typename?: "CreditTransactionListing";
          id: string;
          date: any;
          type: TransactionType;
          creditTransaction: {
            __typename?: "CreditTransaction";
            transaction_type: CreditTransactionType;
          };
          creditPurchase: {
            __typename?: "CreditPurchase";
            amount_cents: number;
            amount_granted_credits: number | null;
            learner: { __typename?: "Learner"; name: string | null } | null;
          } | null;
        }
      | {
          __typename?: "OrderTransactionListing";
          id: string;
          date: any;
          type: TransactionType;
        }
    >;
  };
};

export type PaidCategoryPageQueryVariables = Exact<{
  slug: Scalars["String"];
}>;

export type PaidCategoryPageQuery = {
  __typename?: "Query";
  categoryPage: {
    __typename?: "CategoryPage";
    title: string | null;
    heroImageUrl: string | null;
    searchFilters: {
      __typename?: "SavedSearchFilters";
      adminTags: Array<string> | null;
      age: string | null;
      capacityMax: number | null;
      capacityMin: number | null;
      delivery: string | null;
      dow: string | null;
      enabledBooleanFilters: string | null;
      endBy: string | null;
      endByTime: number | null;
      format: string | null;
      fundingPrograms: Array<string> | null;
      hasFilledOutUniqueLearningNeeds: boolean | null;
      languageOfInstruction: string | null;
      multiTermQuery: Array<string> | null;
      order: string | null;
      pricePerMeetingMax: number | null;
      pricePerMeetingMin: number | null;
      q: string | null;
      startAfter: string | null;
      startAfterTime: number | null;
      startBefore: string | null;
      theme: string | null;
      time: string | null;
      timeOfDay: string | null;
      timeZone: string | null;
      uniqueLearningNeeds: string | null;
    } | null;
  } | null;
};

export type GetSectionsForCopyClassPostModalQueryQueryVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type GetSectionsForCopyClassPostModalQueryQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    sections: Array<{
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
      deleted_at: any | null;
      canceled_at: any | null;
      published_at: any | null;
      ongoing_stopped_at: any | null;
    }>;
  };
};

export type GetClassPostsBySectionForCopyClassPostModalQueryQueryVariables =
  Exact<{
    sectionUid: Scalars["ID"];
    plainText?: InputMaybe<Scalars["Boolean"]>;
  }>;

export type GetClassPostsBySectionForCopyClassPostModalQueryQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    posts: Array<{
      __typename?: "ClassPost";
      uid: string;
      isWelcomePost: boolean;
      publishAt: any;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }>;
    unpublishedPosts: Array<{
      __typename?: "ClassPost";
      uid: string;
      isWelcomePost: boolean;
      publishAt: any;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }>;
  } | null;
};

export type MarkThreadAsReadMutationVariables = Exact<{
  threadUid: Scalars["ID"];
}>;

export type MarkThreadAsReadMutation = {
  __typename?: "Mutation";
  markPrivateClassMessageThreadAsRead: boolean;
};

export type OrgAdminViewTeacherCard_SectionFragment = {
  __typename?: "Section";
  uid: string;
  activity: { __typename?: "Activity"; uid: string };
  leader: { __typename?: "Leader"; uid: string; name: string | null };
};

export type OrgAdminViewTeacherCard_EnrollmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  learner: { __typename?: "Learner"; uid: string; name: string | null } | null;
};

export type OneOnOneClassroomEducatorViewSidebarQueryVariables = Exact<{
  uid: Scalars["ID"];
  startAfter: Scalars["DateTime"];
}>;

export type OneOnOneClassroomEducatorViewSidebarQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    currentUserCanManage: boolean;
    is_self_paced: boolean;
    teacher_support_start_time: any | null;
    start_time: any | null;
    end_time: any | null;
    canceled_at: any | null;
    deleted_at: any | null;
    published_at: any | null;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
    }>;
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      isPaused: boolean;
      ongoingStartTime: any | null;
      isEnded: boolean;
      ongoingEndTime: any | null;
      cancellationType: EnrollmentCancellationType | null;
      withdrawnAt: any | null;
      isWithdrawn: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        avatar: string | null;
        name: string | null;
        age: number | null;
        isBlocked: boolean | null;
        parent: {
          __typename?: "Parent";
          uid: string;
          name: string | null;
          timeZone: string | null;
        };
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        pauseReason: string;
      } | null;
      upcomingPausedMeeting: { __typename?: "Meeting"; start_time: any } | null;
    }>;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
    activity: {
      __typename?: "Activity";
      hasTeacherSchedule: boolean;
      uid: string;
      is_ongoing_weekly: boolean;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
    };
  } | null;
};

export type SellerOrgSectionReassignModal_SectionFragment = {
  __typename?: "Section";
  uid: string;
  leader: { __typename?: "Leader"; uid: string; name: string | null };
};

export type SellerOrgSectionReassignModal_SectionQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type SellerOrgSectionReassignModal_SectionQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
  } | null;
};

export type SellerOrgSectionReassignModal_UpdateSectionMutationVariables =
  Exact<{
    sectionUid: Scalars["ID"];
    updates?: InputMaybe<LeaderSectionInput>;
  }>;

export type SellerOrgSectionReassignModal_UpdateSectionMutation = {
  __typename?: "Mutation";
  updateSection: {
    __typename?: "Section";
    uid: string;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
  };
};

export type MessageThreadQueryQueryVariables = Exact<{
  threadUid: Scalars["ID"];
}>;

export type MessageThreadQueryQuery = {
  __typename?: "Query";
  messageThread: {
    __typename?: "MessageThread";
    uid: string;
    action: MessageThreadAction;
    isRead: boolean;
    isMarkedSpam: boolean;
    participants: Array<{
      __typename?: "Participant";
      uid: string;
      name: string | null;
      photo: string | null;
      timeZone: string | null;
      headline: string | null;
      leader_link: string | null;
      isLearner: boolean;
      role: ParticipantRole | null;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    }>;
    activity: {
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    } | null;
    section: {
      __typename?: "Section";
      filledSpaceCount: number;
      uid: string;
      activity_uid: string;
      start_time: any | null;
      end_time: any | null;
      teacher_support_start_time: any | null;
      startsAtNight: boolean | null;
      is_cross_listed: boolean;
      size_max: number | null;
      size_min: number | null;
      isPublished: boolean | null;
      price_cents: number | null;
      priceCredits: number | null;
      published_at: any | null;
      updated_at: any;
      canceled_at: any | null;
      deleted_at: any | null;
      ongoing_stopped_at: any | null;
      duration_minutes: number | null;
      usesOutschoolVideoChat: boolean;
      usersCanSendPrivateMessage: boolean;
      currentUserCanManage: boolean;
      isBuyable: boolean;
      allowsTeacherTransfer: boolean;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      } | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      details: {
        __typename?: "SectionDetails";
        autoScheduledDraft: boolean | null;
      };
      prepaidOngoingPeriodOptions: Array<{
        __typename?: "Period";
        startOfIsoWeek: any;
        endOfIsoWeek: any;
      }> | null;
    } | null;
    messages: Array<{
      __typename?: "Message";
      uid: string;
      subject: string | null;
      action: string | null;
      content: string | null;
      created_at: any;
      activity_uid: string | null;
      section_uid: string | null;
      thread_uid: string;
      sender: {
        __typename?: "Sender";
        uid: string;
        name: string | null;
        photo: string | null;
      };
      participants: Array<{
        __typename?: "Participant";
        uid: string;
        name: string | null;
        photo: string | null;
        timeZone: string | null;
        headline: string | null;
        leader_link: string | null;
        isLearner: boolean;
        role: ParticipantRole | null;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      }>;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      } | null;
    }>;
  };
};

export type MarkMessageThreadAsReadMutationVariables = Exact<{
  threadUid: Scalars["ID"];
}>;

export type MarkMessageThreadAsReadMutation = {
  __typename?: "Mutation";
  markMessageThreadAsRead: boolean;
};

export type MessageThreadOnlyMessagesQueryQueryVariables = Exact<{
  threadUid: Scalars["ID"];
}>;

export type MessageThreadOnlyMessagesQueryQuery = {
  __typename?: "Query";
  messageThread: {
    __typename?: "MessageThread";
    uid: string;
    messages: Array<{
      __typename?: "Message";
      uid: string;
      subject: string | null;
      action: string | null;
      content: string | null;
      created_at: any;
      activity_uid: string | null;
      section_uid: string | null;
      thread_uid: string;
      sender: {
        __typename?: "Sender";
        uid: string;
        name: string | null;
        photo: string | null;
      };
      participants: Array<{
        __typename?: "Participant";
        uid: string;
        name: string | null;
        photo: string | null;
        timeZone: string | null;
        headline: string | null;
        leader_link: string | null;
        isLearner: boolean;
        role: ParticipantRole | null;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      }>;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      } | null;
    }>;
  };
};

export type PrivateMessageThreadQueryQueryVariables = Exact<{
  threadUid: Scalars["ID"];
}>;

export type PrivateMessageThreadQueryQuery = {
  __typename?: "Query";
  privateMessageThread: {
    __typename?: "PrivateClassThread";
    uid: string;
    isRead: boolean;
    participants: Array<{
      __typename?: "Participant";
      uid: string;
      name: string | null;
      photo: string | null;
      timeZone: string | null;
      headline: string | null;
      leader_link: string | null;
      isLearner: boolean;
      role: ParticipantRole | null;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    }>;
    activity: {
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    } | null;
    section: {
      __typename?: "Section";
      filledSpaceCount: number;
      uid: string;
      activity_uid: string;
      start_time: any | null;
      end_time: any | null;
      teacher_support_start_time: any | null;
      startsAtNight: boolean | null;
      is_cross_listed: boolean;
      size_max: number | null;
      size_min: number | null;
      isPublished: boolean | null;
      price_cents: number | null;
      priceCredits: number | null;
      published_at: any | null;
      updated_at: any;
      canceled_at: any | null;
      deleted_at: any | null;
      ongoing_stopped_at: any | null;
      duration_minutes: number | null;
      usesOutschoolVideoChat: boolean;
      usersCanSendPrivateMessage: boolean;
      currentUserCanManage: boolean;
      isBuyable: boolean;
      allowsTeacherTransfer: boolean;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      } | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      details: {
        __typename?: "SectionDetails";
        autoScheduledDraft: boolean | null;
      };
      prepaidOngoingPeriodOptions: Array<{
        __typename?: "Period";
        startOfIsoWeek: any;
        endOfIsoWeek: any;
      }> | null;
    } | null;
    enrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
      withdrawn_at: any | null;
      usersCanCommunicate: boolean;
    } | null;
    messages: Array<{
      __typename?: "PrivateClassMessage";
      sentAt: any;
      content: string | null;
      uid: string;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      participants: Array<{
        __typename?: "Participant";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      }>;
    }>;
  };
};

export type ReadReceiptQueryQueryVariables = Exact<{
  messageUid: Scalars["ID"];
  audience: Audience;
}>;

export type ReadReceiptQueryQuery = {
  __typename?: "Query";
  isMessageRead: boolean;
};

export type UserDetailsQueryVariables = Exact<{
  userOneUid: Scalars["ID"];
  userTwoUid: Scalars["ID"];
}>;

export type UserDetailsQuery = {
  __typename?: "Query";
  userOneAsParent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    timeZone: string | null;
    enrollmentsWithTeacher: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      isEnded: boolean;
      isPaused: boolean;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
          isClub: boolean;
          published_at: any | null;
          is_ongoing_weekly: boolean;
          weekly_meetings: number | null;
          duration_weeks: number | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
        timeZone: string;
        privateNote: string | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
      } | null;
    }>;
  } | null;
  userTwoAsParent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    timeZone: string | null;
    enrollmentsWithTeacher: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      isEnded: boolean;
      isPaused: boolean;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
          isClub: boolean;
          published_at: any | null;
          is_ongoing_weekly: boolean;
          weekly_meetings: number | null;
          duration_weeks: number | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
        timeZone: string;
        privateNote: string | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
      } | null;
    }>;
  } | null;
};

export type ParentDetailsQueryQueryVariables = Exact<{
  parentUid: Scalars["ID"];
  teacherUid: Scalars["ID"];
}>;

export type ParentDetailsQueryQuery = {
  __typename?: "Query";
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    timeZone: string | null;
    hasSubscription: boolean;
    hasEnrollment: boolean;
    enrollmentsWithTeacher: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      isEnded: boolean;
      isPaused: boolean;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
          isClub: boolean;
          published_at: any | null;
          is_ongoing_weekly: boolean;
          weekly_meetings: number | null;
          duration_weeks: number | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
        timeZone: string;
        privateNote: string | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
      } | null;
    }>;
  } | null;
};

export type PrivateMessageThreadOnlyMessagesQueryQueryVariables = Exact<{
  threadUid: Scalars["ID"];
}>;

export type PrivateMessageThreadOnlyMessagesQueryQuery = {
  __typename?: "Query";
  privateMessageThread: {
    __typename?: "PrivateClassThread";
    uid: string;
    messages: Array<{
      __typename?: "PrivateClassMessage";
      uid: string;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
      };
      participants: Array<{
        __typename?: "Participant";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      }>;
    }>;
  };
};

export type ActivityEnrollableTimesModal_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  hasTeacherSchedule: boolean;
  autoSchedulingDaysNoticeMin: number | null;
  autoSchedulingDaysNoticeMax: number | null;
  esaStatus: EsaStatus;
  is_ongoing_weekly: boolean;
  isClub: boolean;
  isSelfPaced: boolean;
  duration_weeks: number | null;
  slug_id: string;
  title: string;
  enrollableTimes: Array<{
    __typename?: "EnrollableTime";
    startTime: any;
    endTime: any;
    teacher: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      hasBackgroundCheckExpired: boolean | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    };
  }>;
};

export type AcceptScheduleSuggestionMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  suggestedMeetings: Array<MeetingSuggestionInput> | MeetingSuggestionInput;
}>;

export type AcceptScheduleSuggestionMutation = {
  __typename?: "Mutation";
  acceptScheduleSuggestion: {
    __typename?: "Section";
    filledSpaceCount: number;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    activity: {
      __typename?: "Activity";
      uid: string;
      user_uid: string;
      slug_id: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      isClub: boolean;
      isIncludedWithMembership: boolean;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
  };
};

export type ClassDetailsSections_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  is_ongoing_weekly: boolean;
  paginatedFilteredSections: {
    __typename?: "SectionList";
    totalCount: number;
    data: Array<{
      __typename: "Section";
      uid: string;
      activity_uid: string;
      allowsLateEnrollment: boolean;
      canceled_at: any | null;
      created_at: any;
      currentUserCanManage: boolean;
      currentUserIsOwner: boolean;
      deleted_at: any | null;
      duration_minutes: number | null;
      end_time: any | null;
      filledSpaceCount: number;
      isBuyable: boolean;
      isInProgress: boolean;
      isPublished: boolean | null;
      ongoing_stopped_at: any | null;
      price_cents: number | null;
      published_at: any | null;
      start_time: any | null;
      size_max: number | null;
      size_min: number | null;
      updated_at: any;
      usesOutschoolVideoChat: boolean;
      validEnrollmentCount: number;
      details: {
        __typename?: "SectionDetails";
        autoScheduledDraft: boolean | null;
        onlineClassroom: {
          __typename?: "OnlineClassroom";
          type: string | null;
          url: string | null;
        } | null;
      };
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      meetings: Array<{
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      }>;
      meetingTimes: Array<{
        __typename?: "MeetingTime";
        dayOfWeek: number;
        hour: number;
        minute: number;
      }>;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      } | null;
      progress: {
        __typename?: "CourseProgress";
        currentWeek: number;
        pastMeetingCount: number;
        remainingMeetingCount: number;
        totalMeetingCount: number;
        nextMeeting: { __typename?: "Meeting"; start_time: any } | null;
      } | null;
    }>;
  };
};

export type ClassDetailsSectionsQueryVariables = Exact<{
  uid?: InputMaybe<Scalars["ID"]>;
  slugId?: InputMaybe<Scalars["String"]>;
  sectionFilter?: InputMaybe<SectionFilter>;
  esaBlackoutLengthDays?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  startAfter: Scalars["DateTime"];
}>;

export type ClassDetailsSectionsQuery = {
  __typename?: "Query";
  activity: {
    __typename: "Activity";
    uid: string;
    is_ongoing_weekly: boolean;
    paginatedFilteredSections: {
      __typename?: "SectionList";
      totalCount: number;
      data: Array<{
        __typename: "Section";
        uid: string;
        activity_uid: string;
        allowsLateEnrollment: boolean;
        canceled_at: any | null;
        created_at: any;
        currentUserCanManage: boolean;
        currentUserIsOwner: boolean;
        deleted_at: any | null;
        duration_minutes: number | null;
        end_time: any | null;
        filledSpaceCount: number;
        isBuyable: boolean;
        isInProgress: boolean;
        isPublished: boolean | null;
        ongoing_stopped_at: any | null;
        price_cents: number | null;
        published_at: any | null;
        start_time: any | null;
        size_max: number | null;
        size_min: number | null;
        updated_at: any;
        usesOutschoolVideoChat: boolean;
        validEnrollmentCount: number;
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
          onlineClassroom: {
            __typename?: "OnlineClassroom";
            type: string | null;
            url: string | null;
          } | null;
        };
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        }>;
        meetingTimes: Array<{
          __typename?: "MeetingTime";
          dayOfWeek: number;
          hour: number;
          minute: number;
        }>;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        progress: {
          __typename?: "CourseProgress";
          currentWeek: number;
          pastMeetingCount: number;
          remainingMeetingCount: number;
          totalMeetingCount: number;
          nextMeeting: { __typename?: "Meeting"; start_time: any } | null;
        } | null;
      }>;
    };
  };
};

export type ActivityEnrollableTimesQueryVariables = Exact<{
  uid: Scalars["ID"];
  esaState?: InputMaybe<Scalars["String"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  endBy?: InputMaybe<Scalars["DateTime"]>;
  filterByDow?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]>> | InputMaybe<Scalars["Int"]>
  >;
  recurringOnly?: InputMaybe<Scalars["Boolean"]>;
}>;

export type ActivityEnrollableTimesQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    hasTeacherSchedule: boolean;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    esaStatus: EsaStatus;
    is_ongoing_weekly: boolean;
    isClub: boolean;
    isSelfPaced: boolean;
    duration_weeks: number | null;
    slug_id: string;
    title: string;
    enrollableTimes: Array<{
      __typename?: "EnrollableTime";
      startTime: any;
      endTime: any;
      teacher: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        hasBackgroundCheckExpired: boolean | null;
        teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
    }>;
  };
};

export type ActivityDetailDescription_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  assessment: string | null;
  class_experience: string | null;
  has_external_resources: boolean | null;
  homework: string | null;
  learning_goals: string | null;
  materials: string | null;
  parental_guidance: string | null;
  sources: string | null;
  title: string;
  titleTranslated: string | null;
  weekly_meetings: number | null;
  welcomeAttachmentCount: number | null;
  why_me: string | null;
  duration_minutes: number | null;
  suggestedWeeklyMeetings: number | null;
  english_proficiency_level: EnglishProficiencyLevel | null;
  externalResources: Array<{
    __typename?: "ExternalResource";
    uid: string;
    name: string;
  }>;
  details: { __typename?: "ActivityDetails"; asyncTime: string | null };
  clubGuidelines: { __typename?: "WelcomeMessage"; text: string | null } | null;
};

export type ActivityOverview_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  completedEnrollmentCount: number;
  reviewCount: number;
  averageStarRating: number | null;
  isClub: boolean;
  title: string;
};

export type ActivityOverview_LeaderFragment = {
  __typename?: "Leader";
  uid: string;
  name: string | null;
  suspended_at: any | null;
  teacher_approved_at: any | null;
  reviewCount: number;
  averageActivityStarRating: number | null;
  photo: string | null;
  leader_link: string | null;
  educatorTiers: Array<EducatorTier>;
  details: {
    __typename?: "LeaderDetails";
    headline: string | null;
    about: string | null;
  };
  video: {
    __typename?: "Attachment";
    fileUrl: string;
    videoThumbnailUrl: string | null;
    file: { __typename?: "File"; url: string; thumbUrl: string | null };
  } | null;
  credentials: Array<{
    __typename?: "TeacherCredential";
    uid: string;
    degreeType: DegreeType | null;
    degreeSubject: DegreeSubject | null;
    certificateDiscipline: TeacherCertificateDiscipline | null;
    otherType: string | null;
    certificateState: TeacherCertificateState | null;
    name: string | null;
    degreeInstitution: string | null;
    degreeAdditionalInfo: string | null;
  }>;
  ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
};

export type ClassDetailsQuery_MeetingFragment = {
  __typename?: "Meeting";
  uid: string;
  start_time: any;
  end_time: any;
  deleted_at: any | null;
  created_at: any | null;
};

export type ClassDetailsQuery_SectionFragment = {
  __typename?: "Section";
  uid: string;
  activity_uid: string;
  allowsLateEnrollment: boolean;
  canceled_at: any | null;
  created_at: any;
  currentUserCanManage: boolean;
  currentUserIsOwner: boolean;
  deleted_at: any | null;
  duration_minutes: number | null;
  end_time: any | null;
  filledSpaceCount: number;
  isBuyable: boolean;
  isInProgress: boolean;
  isPublished: boolean | null;
  ongoing_stopped_at: any | null;
  price_cents: number | null;
  published_at: any | null;
  start_time: any | null;
  size_max: number | null;
  size_min: number | null;
  updated_at: any;
  usesOutschoolVideoChat: boolean;
  validEnrollmentCount: number;
  details: {
    __typename?: "SectionDetails";
    autoScheduledDraft: boolean | null;
    onlineClassroom: {
      __typename?: "OnlineClassroom";
      type: string | null;
      url: string | null;
    } | null;
  };
  leader: { __typename?: "Leader"; uid: string; name: string | null };
  meetings: Array<{
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
  }>;
  meetingTimes: Array<{
    __typename?: "MeetingTime";
    dayOfWeek: number;
    hour: number;
    minute: number;
  }>;
  nextOngoingMeeting: {
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
  } | null;
  progress: {
    __typename?: "CourseProgress";
    currentWeek: number;
    pastMeetingCount: number;
    remainingMeetingCount: number;
    totalMeetingCount: number;
    nextMeeting: { __typename?: "Meeting"; start_time: any } | null;
  } | null;
};

export type ClassDetailsQuery_AttachmentFragment = {
  __typename?: "Attachment";
  uid: string;
  fileUrl: string;
  conversionStatus: string | null;
  created_at: any;
  file: {
    __typename?: "File";
    filename: string;
    mimetype: string | null;
    size: number;
    url: string;
    thumbUrl: string | null;
  };
};

export type ClassDetailsQuery_ClassPreviewDataFragment = {
  __typename?: "ClassPreview";
  openLesson: {
    __typename?: "ClassPreviewOpenLesson";
    lessonTitle: string | null;
    lessonUid: string;
    lessonPostUid: string;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      externalVideoUrl: string | null;
      video: {
        __typename?: "Attachment";
        videoThumbnailUrl: string | null;
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
  lessons: Array<{
    __typename?: "ClassPreviewLesson";
    uid: string;
    title: string | null;
    orderIndex: number;
    posts: Array<{
      __typename?: "ClassPreviewPost";
      uid: string;
      title: string | null;
      orderIndex: number;
      blockType: string | null;
      estimatedDuration: number | null;
    }>;
  }>;
};

export type ClassDetailsQuery_LeaderFragment = {
  __typename?: "Leader";
  uid: string;
  approved: boolean;
  averageActivityStarRating: number | null;
  cityState: string | null;
  created_at: any | null;
  educatorTiers: Array<EducatorTier>;
  hasAvailabilitySet: boolean;
  hasBackgroundCheckExpired: boolean | null;
  is_crosslister: boolean | null;
  leader_link: string | null;
  name: string | null;
  photo: string | null;
  publishedClassCount: number;
  reviewCount: number;
  socialOptOut: boolean;
  successfulClassCount: number;
  suspended_at: any | null;
  teacher_approved_at: any | null;
  timeZone: string | null;
  details: {
    __typename?: "LeaderDetails";
    about: string | null;
    countryOfResidence: string | null;
    headline: string | null;
    headlineTranslated: string | null;
  };
  ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
  teacherForSellerOrg: {
    __typename?: "SellerOrg";
    uid: string;
    name: string;
  } | null;
  video: {
    __typename?: "Attachment";
    videoThumbnailUrl: string | null;
    uid: string;
    fileUrl: string;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
  credentials: Array<{
    __typename?: "TeacherCredential";
    uid: string;
    degreeType: DegreeType | null;
    degreeSubject: DegreeSubject | null;
    certificateDiscipline: TeacherCertificateDiscipline | null;
    otherType: string | null;
    certificateState: TeacherCertificateState | null;
    name: string | null;
    degreeInstitution: string | null;
    degreeAdditionalInfo: string | null;
  }>;
  leaderClassLinks: Array<{
    __typename?: "Bundle";
    uid: string;
    title: string;
    isOrdered: boolean;
    bundleElements: Array<{
      __typename?: "BundleElement";
      orderInBundle: number;
      activity: { __typename?: "Activity"; uid: string };
    }>;
  }>;
};

export type ClassDetailsQuery_SampleClubPostFragment = {
  __typename?: "SampleClubPost";
  text: string | null;
  attachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
    };
  }> | null;
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
    };
  } | null;
  comments: Array<{
    __typename?: "SampleClubPostComment";
    text: string | null;
  }>;
};

export type ClassDetailsQuery_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  age_max: number | null;
  age_min: number | null;
  grade_level_max: string | null;
  grade_level_min: string | null;
  url: string;
  path: string;
  allows_late_enrollments_for_fixed_length_classes: boolean;
  allows_recurring_payment: boolean | null;
  allowsFutureOngoingEnrollments: boolean;
  has_building_content: boolean | null;
  archived_at: any | null;
  assessment: string | null;
  autoSchedulingDaysNoticeMin: number | null;
  autoSchedulingDaysNoticeMax: number | null;
  averageStarRating: number | null;
  canEnroll: boolean;
  classFormat: EducatorSelectedFormat;
  class_experience: string | null;
  completedEnrollmentCount: number;
  disclaimer: string | null;
  duration_minutes: number | null;
  duration_weeks: number | null;
  english_proficiency_level: EnglishProficiencyLevel | null;
  esaStatus: EsaStatus;
  userApprovedFundingPrograms: Array<string> | null;
  first_listed_at: any | null;
  has_external_resources: boolean | null;
  hasTeacherSchedule: boolean;
  homework: string | null;
  grading_policy: string | null;
  is_ongoing_weekly: boolean;
  is_online: boolean;
  isAutoSchedulingEnabled: boolean | null;
  allowWaitlist: boolean | null;
  isClub: boolean;
  isFlexSchedule: boolean;
  isOneTime: boolean;
  isPublished: boolean;
  isRestricted: boolean;
  isSelfPaced: boolean;
  isSoldOut: boolean;
  languageOfInstruction: any | null;
  learning_goals: string | null;
  learningGoals: Array<string>;
  materials: string | null;
  meetingCount: number | null;
  parental_guidance: string | null;
  prerequisites: string | null;
  price_cents: number | null;
  priceCredits: number | null;
  perWeeklyCourseCredits: number | null;
  published_at: any | null;
  requested_listing_at: any | null;
  reviewCount: number;
  size_max: number | null;
  size_min: number | null;
  slug_id: string;
  sources: string | null;
  subject: string | null;
  suggestedWeeklyMeetings: number | null;
  summary: string | null;
  summaryTranslated: string | null;
  summaryForLearners: string | null;
  title: string;
  titleTranslated: string | null;
  upcomingAvailableSectionCount: number;
  upcomingSectionCount: number;
  activeSections: number;
  upsell_activity_uid: string | null;
  user_uid: string;
  wasPublishedInThePast: boolean;
  weekly_meetings: number | null;
  welcomeAttachmentCount: number | null;
  why_me: string | null;
  isIncludedWithMembership: boolean;
  approvalStatus: {
    __typename?: "ActivityApprovalStatus";
    action: string;
    message_to_teacher: string | null;
  } | null;
  attributes: Array<{
    __typename?: "EntityAttribute";
    key: string;
    value: string;
    source: string | null;
  }>;
  clubGuidelines: { __typename?: "WelcomeMessage"; text: string | null } | null;
  clubSection: {
    __typename?: "Section";
    uid: string;
    validEnrollmentCount: number;
    isBuyable: boolean;
  } | null;
  details: {
    __typename?: "ActivityDetails";
    isAIUsedForContentCreation: boolean | null;
    asyncTime: string | null;
  };
  photo: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
  externalResources: Array<{
    __typename?: "ExternalResource";
    uid: string;
    name: string;
    url: string | null;
  }>;
  leader: {
    __typename?: "Leader";
    uid: string;
    approved: boolean;
    averageActivityStarRating: number | null;
    cityState: string | null;
    created_at: any | null;
    educatorTiers: Array<EducatorTier>;
    hasAvailabilitySet: boolean;
    hasBackgroundCheckExpired: boolean | null;
    is_crosslister: boolean | null;
    leader_link: string | null;
    name: string | null;
    photo: string | null;
    publishedClassCount: number;
    reviewCount: number;
    socialOptOut: boolean;
    successfulClassCount: number;
    suspended_at: any | null;
    teacher_approved_at: any | null;
    timeZone: string | null;
    details: {
      __typename?: "LeaderDetails";
      about: string | null;
      countryOfResidence: string | null;
      headline: string | null;
      headlineTranslated: string | null;
    };
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    teacherForSellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
    } | null;
    video: {
      __typename?: "Attachment";
      videoThumbnailUrl: string | null;
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    credentials: Array<{
      __typename?: "TeacherCredential";
      uid: string;
      degreeType: DegreeType | null;
      degreeSubject: DegreeSubject | null;
      certificateDiscipline: TeacherCertificateDiscipline | null;
      otherType: string | null;
      certificateState: TeacherCertificateState | null;
      name: string | null;
      degreeInstitution: string | null;
      degreeAdditionalInfo: string | null;
    }>;
    leaderClassLinks: Array<{
      __typename?: "Bundle";
      uid: string;
      title: string;
      isOrdered: boolean;
      bundleElements: Array<{
        __typename?: "BundleElement";
        orderInBundle: number;
        activity: { __typename?: "Activity"; uid: string };
      }>;
    }>;
  };
  listingPrice: {
    __typename?: "ActivityListingPrice";
    priceCents: number;
    priceCredits: number;
    frequency: ListingPriceFrequency;
  } | null;
  refundPolicy: {
    __typename?: "RefundPolicy";
    name: string;
    description: string;
    type: RefundPolicyType;
  };
  relatedCategories: Array<{
    __typename?: "CategoryPage";
    uid: string;
    slug: string;
    basePath: string;
    nameTitleCased: string;
  } | null> | null;
  sampleClubPosts: Array<{
    __typename?: "SampleClubPost";
    text: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
      };
    }> | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
      };
    } | null;
    comments: Array<{
      __typename?: "SampleClubPostComment";
      text: string | null;
    }>;
  }> | null;
  savedClassLists: Array<{
    __typename?: "SavedClassList";
    uid: string;
    lastAddedToAt: any | null;
  }>;
  syllabus: {
    __typename?: "Syllabus";
    uid: string;
    published_at: string | null;
    lessons: Array<{
      __typename?: "Lesson";
      uid: string;
      title: string | null;
      description: string | null;
      week_number: number;
      order_within_week: number;
      lessonNumber: number | null;
      videoDurationSeconds: number;
      assignmentsCount: number;
      unit: {
        __typename?: "Unit";
        uid: string;
        title: string | null;
        unitNumber: number | null;
      } | null;
    }>;
  } | null;
  classPreview: {
    __typename?: "ClassPreview";
    openLesson: {
      __typename?: "ClassPreviewOpenLesson";
      lessonTitle: string | null;
      lessonUid: string;
      lessonPostUid: string;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        externalVideoUrl: string | null;
        video: {
          __typename?: "Attachment";
          videoThumbnailUrl: string | null;
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    };
    lessons: Array<{
      __typename?: "ClassPreviewLesson";
      uid: string;
      title: string | null;
      orderIndex: number;
      posts: Array<{
        __typename?: "ClassPreviewPost";
        uid: string;
        title: string | null;
        orderIndex: number;
        blockType: string | null;
        estimatedDuration: number | null;
      }>;
    }>;
  } | null;
  video: {
    __typename?: "Attachment";
    videoThumbnailUrl: string | null;
    uid: string;
    fileUrl: string;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
  proficiency_level: {
    __typename?: "ProficiencyLevel";
    level: Array<string | null> | null;
    text: string | null;
  } | null;
};

export type ClassDetailsNoSectionsQueryVariables = Exact<{
  uid?: InputMaybe<Scalars["ID"]>;
  slugId?: InputMaybe<Scalars["String"]>;
  esaState?: InputMaybe<Scalars["String"]>;
}>;

export type ClassDetailsNoSectionsQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    age_max: number | null;
    age_min: number | null;
    grade_level_max: string | null;
    grade_level_min: string | null;
    url: string;
    path: string;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allows_recurring_payment: boolean | null;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    archived_at: any | null;
    assessment: string | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    averageStarRating: number | null;
    canEnroll: boolean;
    classFormat: EducatorSelectedFormat;
    class_experience: string | null;
    completedEnrollmentCount: number;
    disclaimer: string | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    esaStatus: EsaStatus;
    userApprovedFundingPrograms: Array<string> | null;
    first_listed_at: any | null;
    has_external_resources: boolean | null;
    hasTeacherSchedule: boolean;
    homework: string | null;
    grading_policy: string | null;
    is_ongoing_weekly: boolean;
    is_online: boolean;
    isAutoSchedulingEnabled: boolean | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isFlexSchedule: boolean;
    isOneTime: boolean;
    isPublished: boolean;
    isRestricted: boolean;
    isSelfPaced: boolean;
    isSoldOut: boolean;
    languageOfInstruction: any | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    materials: string | null;
    meetingCount: number | null;
    parental_guidance: string | null;
    prerequisites: string | null;
    price_cents: number | null;
    priceCredits: number | null;
    perWeeklyCourseCredits: number | null;
    published_at: any | null;
    requested_listing_at: any | null;
    reviewCount: number;
    size_max: number | null;
    size_min: number | null;
    slug_id: string;
    sources: string | null;
    subject: string | null;
    suggestedWeeklyMeetings: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    summaryForLearners: string | null;
    title: string;
    titleTranslated: string | null;
    upcomingAvailableSectionCount: number;
    upcomingSectionCount: number;
    activeSections: number;
    upsell_activity_uid: string | null;
    user_uid: string;
    wasPublishedInThePast: boolean;
    weekly_meetings: number | null;
    welcomeAttachmentCount: number | null;
    why_me: string | null;
    isIncludedWithMembership: boolean;
    approvalStatus: {
      __typename?: "ActivityApprovalStatus";
      action: string;
      message_to_teacher: string | null;
    } | null;
    attributes: Array<{
      __typename?: "EntityAttribute";
      key: string;
      value: string;
      source: string | null;
    }>;
    clubGuidelines: {
      __typename?: "WelcomeMessage";
      text: string | null;
    } | null;
    clubSection: {
      __typename?: "Section";
      uid: string;
      validEnrollmentCount: number;
      isBuyable: boolean;
    } | null;
    details: {
      __typename?: "ActivityDetails";
      isAIUsedForContentCreation: boolean | null;
      asyncTime: string | null;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    externalResources: Array<{
      __typename?: "ExternalResource";
      uid: string;
      name: string;
      url: string | null;
    }>;
    leader: {
      __typename?: "Leader";
      uid: string;
      approved: boolean;
      averageActivityStarRating: number | null;
      cityState: string | null;
      created_at: any | null;
      educatorTiers: Array<EducatorTier>;
      hasAvailabilitySet: boolean;
      hasBackgroundCheckExpired: boolean | null;
      is_crosslister: boolean | null;
      leader_link: string | null;
      name: string | null;
      photo: string | null;
      publishedClassCount: number;
      reviewCount: number;
      socialOptOut: boolean;
      successfulClassCount: number;
      suspended_at: any | null;
      teacher_approved_at: any | null;
      timeZone: string | null;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        countryOfResidence: string | null;
        headline: string | null;
        headlineTranslated: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
      video: {
        __typename?: "Attachment";
        videoThumbnailUrl: string | null;
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      credentials: Array<{
        __typename?: "TeacherCredential";
        uid: string;
        degreeType: DegreeType | null;
        degreeSubject: DegreeSubject | null;
        certificateDiscipline: TeacherCertificateDiscipline | null;
        otherType: string | null;
        certificateState: TeacherCertificateState | null;
        name: string | null;
        degreeInstitution: string | null;
        degreeAdditionalInfo: string | null;
      }>;
      leaderClassLinks: Array<{
        __typename?: "Bundle";
        uid: string;
        title: string;
        isOrdered: boolean;
        bundleElements: Array<{
          __typename?: "BundleElement";
          orderInBundle: number;
          activity: { __typename?: "Activity"; uid: string };
        }>;
      }>;
    };
    listingPrice: {
      __typename?: "ActivityListingPrice";
      priceCents: number;
      priceCredits: number;
      frequency: ListingPriceFrequency;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    relatedCategories: Array<{
      __typename?: "CategoryPage";
      uid: string;
      slug: string;
      basePath: string;
      nameTitleCased: string;
    } | null> | null;
    sampleClubPosts: Array<{
      __typename?: "SampleClubPost";
      text: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      }> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      } | null;
      comments: Array<{
        __typename?: "SampleClubPostComment";
        text: string | null;
      }>;
    }> | null;
    savedClassLists: Array<{
      __typename?: "SavedClassList";
      uid: string;
      lastAddedToAt: any | null;
    }>;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        description: string | null;
        week_number: number;
        order_within_week: number;
        lessonNumber: number | null;
        videoDurationSeconds: number;
        assignmentsCount: number;
        unit: {
          __typename?: "Unit";
          uid: string;
          title: string | null;
          unitNumber: number | null;
        } | null;
      }>;
    } | null;
    classPreview: {
      __typename?: "ClassPreview";
      openLesson: {
        __typename?: "ClassPreviewOpenLesson";
        lessonTitle: string | null;
        lessonUid: string;
        lessonPostUid: string;
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          externalVideoUrl: string | null;
          video: {
            __typename?: "Attachment";
            videoThumbnailUrl: string | null;
            uid: string;
            fileUrl: string;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      };
      lessons: Array<{
        __typename?: "ClassPreviewLesson";
        uid: string;
        title: string | null;
        orderIndex: number;
        posts: Array<{
          __typename?: "ClassPreviewPost";
          uid: string;
          title: string | null;
          orderIndex: number;
          blockType: string | null;
          estimatedDuration: number | null;
        }>;
      }>;
    } | null;
    video: {
      __typename?: "Attachment";
      videoThumbnailUrl: string | null;
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
  };
};

export type SubjectLink_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  subject: string | null;
};

export type ActivityHeader_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  isClub: boolean;
  summary: string | null;
  summaryTranslated: string | null;
  title: string;
  titleTranslated: string | null;
  slug_id: string;
  isSoldOut: boolean;
  completedEnrollmentCount: number;
  reviewCount: number;
  averageStarRating: number | null;
  subject: string | null;
  price_cents: number | null;
  video: {
    __typename?: "Attachment";
    file: { __typename?: "File"; url: string; thumbUrl: string | null };
  } | null;
  sections: Array<{
    __typename?: "Section";
    uid: string;
    filledSpaceCount: number;
  }>;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
  savedClassLists: Array<{
    __typename?: "SavedClassList";
    uid: string;
    lastAddedToAt: any | null;
  }>;
};

export type ActivityHeader_LeaderFragment = {
  __typename?: "Leader";
  uid: string;
  publishedClassCount: number;
  name: string | null;
  suspended_at: any | null;
  teacher_approved_at: any | null;
  reviewCount: number;
  averageActivityStarRating: number | null;
  photo: string | null;
  leader_link: string | null;
  educatorTiers: Array<EducatorTier>;
  details: {
    __typename?: "LeaderDetails";
    headline: string | null;
    about: string | null;
  };
  video: {
    __typename?: "Attachment";
    fileUrl: string;
    videoThumbnailUrl: string | null;
    file: { __typename?: "File"; url: string; thumbUrl: string | null };
  } | null;
  credentials: Array<{
    __typename?: "TeacherCredential";
    uid: string;
    degreeType: DegreeType | null;
    degreeSubject: DegreeSubject | null;
    certificateDiscipline: TeacherCertificateDiscipline | null;
    otherType: string | null;
    certificateState: TeacherCertificateState | null;
    name: string | null;
    degreeInstitution: string | null;
    degreeAdditionalInfo: string | null;
  }>;
  ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
};

export type ScheduleSuggestionsQueryVariables = Exact<{
  uid: Scalars["ID"];
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  endAtDate?: InputMaybe<Scalars["DateTime"]>;
  startAfterTime?: InputMaybe<Scalars["Int"]>;
  endByTime?: InputMaybe<Scalars["Int"]>;
  dow?: InputMaybe<Scalars["String"]>;
  timeZone?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type ScheduleSuggestionsQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    scheduleSuggestions: Array<
      Array<{
        __typename?: "MeetingSuggestion";
        startTime: any | null;
        endTime: any | null;
      }>
    > | null;
  };
};

export type ResendEmailConfirmationMutationVariables = Exact<{
  userUid: Scalars["ID"];
}>;

export type ResendEmailConfirmationMutation = {
  __typename?: "Mutation";
  resendEmailConfirmation: boolean;
};

export type ResendOtherEmailConfirmationMutationVariables = Exact<{
  userUid: Scalars["ID"];
  otherEmail: Scalars["String"];
}>;

export type ResendOtherEmailConfirmationMutation = {
  __typename?: "Mutation";
  resendOtherEmailConfirmation: boolean;
};

export type SendTestEmailMutationVariables = Exact<{ [key: string]: never }>;

export type SendTestEmailMutation = {
  __typename?: "Mutation";
  sendTestEmail: boolean;
};

export type PauseOngoingModalBodyQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  startAfter: Scalars["DateTime"];
}>;

export type PauseOngoingModalBodyQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
    }>;
  } | null;
};

export type ActivityEnrollWithCharterPurchaseOrder_EnrollmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  section_uid: string | null;
  confirmed_at: any | null;
  withdrawn_at: any | null;
  isPrepay: boolean;
  confirmedAt: any | null;
  withdrawnAt: any | null;
  ongoingEndTime: any | null;
  isPaused: boolean;
  isEnded: boolean;
  section: {
    __typename?: "Section";
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      titleTranslated: string | null;
    };
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
  } | null;
  learner: {
    __typename?: "Learner";
    uid: string;
    age: number | null;
    name: string | null;
  } | null;
};

export type ActivitySummary_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  title: string;
  titleTranslated: string | null;
  weekly_meetings: number | null;
  duration_weeks: number | null;
  is_ongoing_weekly: boolean;
  isClub: boolean;
  isFlexSchedule: boolean;
  isSelfPaced: boolean;
  published_at: any | null;
  hasTeacherSchedule: boolean;
  size_max: number | null;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type ActivitySummary_SectionFragment = {
  __typename?: "Section";
  uid: string;
  start_time: any | null;
  end_time: any | null;
  allowsLateEnrollment: boolean;
  nextOngoingMeeting: {
    __typename?: "Meeting";
    uid: string;
    start_time: any;
  } | null;
  progress: {
    __typename?: "CourseProgress";
    pastMeetingCount: number;
    remainingMeetingCount: number;
    totalMeetingCount: number;
    nextMeeting: { __typename?: "Meeting"; start_time: any } | null;
  } | null;
};

export type EnrollmentMeetingPurchaseDuration_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  title: string;
  titleTranslated: string | null;
  weekly_meetings: number | null;
  duration_weeks: number | null;
  price_cents: number | null;
  isClub: boolean;
  is_ongoing_weekly: boolean;
  allows_recurring_payment: boolean | null;
  hasTeacherSchedule: boolean;
  size_max: number | null;
  refundPolicy: {
    __typename?: "RefundPolicy";
    name: string;
    description: string;
    type: RefundPolicyType;
  };
};

export type ValidateMeetingRequestsForPurchaseMutationVariables = Exact<{
  requestUids: Array<Scalars["String"]> | Scalars["String"];
  activityUid: Scalars["String"];
  enrollmentMeetingPurchaseUid: Scalars["String"];
  sectionUid?: InputMaybe<Scalars["String"]>;
}>;

export type ValidateMeetingRequestsForPurchaseMutation = {
  __typename?: "Mutation";
  validateMeetingRequestsForPurchase: {
    __typename?: "ValidateMeetingRequestsForPurchaseResponse";
    isValid: boolean;
    error: ValidateMeetingRequestsForPurchaseError | null;
  };
};

export type MultipleMeetingsModal_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  title: string;
  titleTranslated: string | null;
  suggestedWeeklyMeetings: number | null;
  details: { __typename?: "ActivityDetails"; photo: string | null };
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type AllOrganizationsQueryVariables = Exact<{ [key: string]: never }>;

export type AllOrganizationsQuery = {
  __typename?: "Query";
  organizations: Array<{
    __typename?: "Organization";
    uid: string;
    name: string;
    state: string | null;
    logoUrl: string | null;
    urlName: string | null;
  }>;
};

export type ResumeOngoingEnrollmentMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
}>;

export type ResumeOngoingEnrollmentMutation = {
  __typename?: "Mutation";
  resumeOngoingEnrollment: {
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type ActivityPromotableSectionsQueryVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type ActivityPromotableSectionsQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    promotableSections: Array<{ __typename?: "Section"; uid: string }>;
  };
};

export type GetLastUnrefundedEnrollmentPaymentQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
}>;

export type GetLastUnrefundedEnrollmentPaymentQuery = {
  __typename?: "Query";
  lastUnrefundedEnrollmentPayment: {
    __typename?: "EnrollmentPayment";
    uid: string;
    amount_cents: number | null;
    order_slug_id: string | null;
    stripe_charge_id: string | null;
    purchase_order_id: string | null;
    esa_order_id: string | null;
    intercom_url: string | null;
    last4: string | null;
    created_at: any | null;
    paid_at: any | null;
    disbursed_at: any | null;
    payout_uid: string | null;
    start_time: any | null;
    end_time: any | null;
    unrefundedCents: number;
    isOngoingRefundable: boolean;
    voucher_name: string | null;
    pricing_offer_uid: string | null;
    credit_transaction_uid: string | null;
    credit_account_type: string | null;
    coupon_code_uid: string | null;
    currency_code: CurrencyCode | null;
    exchange_rate: number | null;
    invoice_uid: string | null;
    funding_program_invoice_uid: string | null;
    service_fee_percentage: number | null;
    couponCode: {
      __typename?: "CouponCode";
      code: string;
      coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
  } | null;
};

export type RefundPolicy_ActivityFragment = {
  __typename?: "Activity";
  isClub: boolean;
  is_ongoing_weekly: boolean;
  allows_recurring_payment: boolean | null;
  hasTeacherSchedule: boolean;
  size_max: number | null;
  duration_weeks: number | null;
  weekly_meetings: number | null;
  refundPolicy: {
    __typename?: "RefundPolicy";
    name: string;
    description: string;
    type: RefundPolicyType;
  };
};

export type AgeWarning_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  age_min: number | null;
  age_max: number | null;
  strictAgeRange: {
    __typename?: "AgeRangeType";
    min: number;
    max: number;
  } | null;
};

export type AgeWarning_LearnerFragment = {
  __typename?: "Learner";
  uid: string;
  age: number | null;
};

export type AgeWarning_SectionFragment = {
  __typename?: "Section";
  uid: string;
  isPublished: boolean | null;
  details: {
    __typename?: "SectionDetails";
    autoScheduledDraft: boolean | null;
  };
};

export type ConflictWarning_EnrollmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  section: {
    __typename?: "Section";
    uid: string;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      titleTranslated: string | null;
    };
  } | null;
};

export type ConflictWarning_LearnerFragment = {
  __typename?: "Learner";
  uid: string;
  name: string | null;
};

export type EnrolledInOtherSectionWarning_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  weekly_meetings: number | null;
  duration_weeks: number | null;
  is_ongoing_weekly: boolean;
  size_max: number | null;
  published_at: any | null;
  isClub: boolean;
  hasTeacherSchedule: boolean;
};

export type EnrolledInOtherSectionWarning_EnrollmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  section: {
    __typename?: "Section";
    uid: string;
    start_time: any | null;
    end_time: any | null;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    } | null;
  } | null;
};

export type EnrolledInOtherSectionWarning_LearnerFragment = {
  __typename?: "Learner";
  uid: string;
  name: string | null;
};

export type OneOnOneEnrolledInOtherSectionWarning_EnrollmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  section: {
    __typename?: "Section";
    uid: string;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
  } | null;
};

export type EnrollmentWarnings_ActivityFragment = {
  __typename?: "Activity";
  hasTeacherSchedule: boolean;
  size_max: number | null;
  size_min: number | null;
  uid: string;
  age_min: number | null;
  age_max: number | null;
  weekly_meetings: number | null;
  duration_weeks: number | null;
  is_ongoing_weekly: boolean;
  published_at: any | null;
  isClub: boolean;
  strictAgeRange: {
    __typename?: "AgeRangeType";
    min: number;
    max: number;
  } | null;
};

export type EnrollmentWarnings_SectionFragment = {
  __typename?: "Section";
  uid: string;
  isPublished: boolean | null;
  details: {
    __typename?: "SectionDetails";
    autoScheduledDraft: boolean | null;
  };
};

export type EnrollmentWarnings_EnrollmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  section: {
    __typename?: "Section";
    uid: string;
    start_time: any | null;
    end_time: any | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      titleTranslated: string | null;
    };
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
  } | null;
};

export type EnrollmentWarnings_LearnerFragment = {
  __typename?: "Learner";
  uid: string;
  age: number | null;
  name: string | null;
};

export type LearnerItem_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  hasTeacherSchedule: boolean;
  size_max: number | null;
  size_min: number | null;
  age_min: number | null;
  age_max: number | null;
  weekly_meetings: number | null;
  duration_weeks: number | null;
  is_ongoing_weekly: boolean;
  published_at: any | null;
  isClub: boolean;
  strictAgeRange: {
    __typename?: "AgeRangeType";
    min: number;
    max: number;
  } | null;
};

export type LearnerItem_SectionFragment = {
  __typename?: "Section";
  uid: string;
  isPublished: boolean | null;
  details: {
    __typename?: "SectionDetails";
    autoScheduledDraft: boolean | null;
  };
};

export type LearnerItem_LearnerFragment = {
  __typename?: "Learner";
  uid: string;
  name: string | null;
  age: number | null;
};

export type GetLearnerItems_EnrollmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  confirmedAt: any | null;
  withdrawnAt: any | null;
  ongoingEndTime: any | null;
  isPaused: boolean;
  isEnded: boolean;
  learner: {
    __typename?: "Learner";
    uid: string;
    age: number | null;
    name: string | null;
  } | null;
  section: {
    __typename?: "Section";
    uid: string;
    start_time: any | null;
    end_time: any | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      titleTranslated: string | null;
    };
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
  } | null;
};

export type GetLearnerItems_EnrollmentWithMeetingPurchasesFragment = {
  __typename?: "Enrollment";
  uid: string;
  confirmedAt: any | null;
  withdrawnAt: any | null;
  ongoingEndTime: any | null;
  isPaused: boolean;
  isEnded: boolean;
  hasOverlappingPendingEnrollmentMeetingPurchase: boolean;
  learner: {
    __typename?: "Learner";
    uid: string;
    age: number | null;
    name: string | null;
  } | null;
  section: {
    __typename?: "Section";
    uid: string;
    start_time: any | null;
    end_time: any | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      titleTranslated: string | null;
    };
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
  } | null;
};

export type GetAdminEnrollmentPaymentRefundActionsQueryVariables = Exact<{
  enrollmentPaymentRefundUid: Scalars["ID"];
}>;

export type GetAdminEnrollmentPaymentRefundActionsQuery = {
  __typename?: "Query";
  adminEnrollmentPaymentRefundActions: Array<{
    __typename?: "AdminEnrollmentPaymentRefundAction";
    uid: string;
    notes: string;
  }> | null;
};

export type CreateEsaCreditPurchaseMutationVariables = Exact<{
  numCredits: Scalars["Int"];
  priceCents: Scalars["Int"];
  creditValue: Scalars["Int"];
  learnerInput: EsaCreditPurchaseLearnerInput;
  fundingProgram: Scalars["String"];
}>;

export type CreateEsaCreditPurchaseMutation = {
  __typename?: "Mutation";
  createEsaCreditPurchaseOrder: {
    __typename?: "OrderType";
    orderSlugId: string;
  };
};

export type GiftCardModalQueryVariables = Exact<{
  activityUid?: InputMaybe<Scalars["ID"]>;
  activitySlugId?: InputMaybe<Scalars["String"]>;
}>;

export type GiftCardModalQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    title: string;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  };
};

export type FeaturedTeacherCard_LeaderFragment = {
  __typename?: "Leader";
  uid: string;
  name: string | null;
  photo: string | null;
  leader_link: string | null;
  details: {
    __typename?: "LeaderDetails";
    headline: string | null;
    headlineTranslated: string | null;
  };
};

export type HomeWithNoTopicsQueryVariables = Exact<{ [key: string]: never }>;

export type HomeWithNoTopicsQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    popularTeachers: Array<{
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      leader_link: string | null;
      details: {
        __typename?: "LeaderDetails";
        headline: string | null;
        headlineTranslated: string | null;
      };
    }> | null;
  };
};

export type UpdateLearnerNoteMutationVariables = Exact<{
  learnerUid: Scalars["ID"];
  note: Scalars["String"];
}>;

export type UpdateLearnerNoteMutation = {
  __typename?: "Mutation";
  updateLearnerNote: {
    __typename?: "Learner";
    uid: string;
    privateNote: string | null;
  };
};

export type LearnerPrivateNote_LearnerFragment = {
  __typename?: "Learner";
  uid: string;
  timeZone: string;
  privateNote: string | null;
};

export type CtaJoinMembershipWrapper_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  slug_id: string;
  title: string;
  isClub: boolean;
};

export type ListingCarousel_ListingFragment = {
  __typename?: "Listing";
  insertionId: string | null;
  sectionCount: number;
  openSectionCount: number;
  upcomingSectionCount: number;
  leader: {
    __typename?: "Leader";
    uid: string;
    name: string | null;
    photo: string | null;
    leader_link: string | null;
    averageActivityStarRating: number | null;
    reviewCount: number;
    educatorTiers: Array<EducatorTier>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
        fileSize: number | null;
      };
    } | null;
    credentials: Array<{
      __typename?: "TeacherCredential";
      uid: string;
      degreeType: DegreeType | null;
      degreeSubject: DegreeSubject | null;
    }>;
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
  };
  activity: {
    __typename?: "Activity";
    uid: string;
    isIncludedWithMembership: boolean;
    averageStarRating?: number | null;
    reviewCount: number;
    age_min: number | null;
    age_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCreditsPerMeeting: number | null;
    quickSummary: string | null;
    isClub: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    hasTeacherSchedule: boolean;
    size_max: number | null;
    user_uid: string;
    slug_id: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    recentReviews?: Array<{
      __typename?: "PublicReview";
      uid: string;
      activity_star_rating: number | null;
      details: {
        __typename?: "PublicReviewDetails";
        publicReview: string | null;
      } | null;
      parent: { __typename?: "Parent"; uid: string; publicName: string | null };
    }>;
    clubSection: {
      __typename?: "Section";
      filledSpaceCount: number;
      clubPostCount: number;
    } | null;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      lessons: Array<{ __typename?: "Lesson"; uid: string }>;
    } | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
    } | null;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
    savedClassLists: Array<{
      __typename?: "SavedClassList";
      uid: string;
      lastAddedToAt: any | null;
    }>;
  };
  nextSection: {
    __typename?: "Section";
    uid: string;
    size_max: number | null;
    filledSpaceCount: number;
    start_time: any | null;
    end_time: any | null;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
    } | null;
  } | null;
};

export type ListingsByActivityUidsQueryVariables = Exact<{
  activityUids: Array<Scalars["ID"]> | Scalars["ID"];
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
}>;

export type ListingsByActivityUidsQuery = {
  __typename?: "Query";
  listingsByActivityUids: Array<{
    __typename?: "Listing";
    insertionId: string | null;
    sectionCount: number;
    openSectionCount: number;
    upcomingSectionCount: number;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      leader_link: string | null;
      averageActivityStarRating: number | null;
      reviewCount: number;
      educatorTiers: Array<EducatorTier>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
          fileSize: number | null;
        };
      } | null;
      credentials: Array<{
        __typename?: "TeacherCredential";
        uid: string;
        degreeType: DegreeType | null;
        degreeSubject: DegreeSubject | null;
      }>;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    };
    activity: {
      __typename?: "Activity";
      uid: string;
      isIncludedWithMembership: boolean;
      averageStarRating?: number | null;
      reviewCount: number;
      age_min: number | null;
      age_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCreditsPerMeeting: number | null;
      quickSummary: string | null;
      isClub: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      hasTeacherSchedule: boolean;
      size_max: number | null;
      user_uid: string;
      slug_id: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      recentReviews?: Array<{
        __typename?: "PublicReview";
        uid: string;
        activity_star_rating: number | null;
        details: {
          __typename?: "PublicReviewDetails";
          publicReview: string | null;
        } | null;
        parent: {
          __typename?: "Parent";
          uid: string;
          publicName: string | null;
        };
      }>;
      clubSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        clubPostCount: number;
      } | null;
      syllabus: {
        __typename?: "Syllabus";
        uid: string;
        lessons: Array<{ __typename?: "Lesson"; uid: string }>;
      } | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
      } | null;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      savedClassLists: Array<{
        __typename?: "SavedClassList";
        uid: string;
        lastAddedToAt: any | null;
      }>;
    };
    nextSection: {
      __typename?: "Section";
      uid: string;
      size_max: number | null;
      filledSpaceCount: number;
      start_time: any | null;
      end_time: any | null;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
      } | null;
    } | null;
  }>;
};

export type OtherListingsByTeacherQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
}>;

export type OtherListingsByTeacherQuery = {
  __typename?: "Query";
  listing: {
    __typename?: "Listing";
    similarListings: {
      __typename?: "SimilarListings";
      sameTeacher: Array<{
        __typename?: "Listing";
        insertionId: string | null;
        sectionCount: number;
        openSectionCount: number;
        upcomingSectionCount: number;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
          leader_link: string | null;
          averageActivityStarRating: number | null;
          reviewCount: number;
          educatorTiers: Array<EducatorTier>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
              fileSize: number | null;
            };
          } | null;
          credentials: Array<{
            __typename?: "TeacherCredential";
            uid: string;
            degreeType: DegreeType | null;
            degreeSubject: DegreeSubject | null;
          }>;
          ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        };
        activity: {
          __typename?: "Activity";
          uid: string;
          isIncludedWithMembership: boolean;
          averageStarRating?: number | null;
          reviewCount: number;
          age_min: number | null;
          age_max: number | null;
          duration_minutes: number | null;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          price_cents: number | null;
          priceCreditsPerMeeting: number | null;
          quickSummary: string | null;
          isClub: boolean;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          isOneTime: boolean;
          hasTeacherSchedule: boolean;
          size_max: number | null;
          user_uid: string;
          slug_id: string;
          title: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          summary: string | null;
          summaryTranslated: string | null;
          is_ongoing_weekly: boolean;
          subject: string | null;
          recentReviews?: Array<{
            __typename?: "PublicReview";
            uid: string;
            activity_star_rating: number | null;
            details: {
              __typename?: "PublicReviewDetails";
              publicReview: string | null;
            } | null;
            parent: {
              __typename?: "Parent";
              uid: string;
              publicName: string | null;
            };
          }>;
          clubSection: {
            __typename?: "Section";
            filledSpaceCount: number;
            clubPostCount: number;
          } | null;
          syllabus: {
            __typename?: "Syllabus";
            uid: string;
            lessons: Array<{ __typename?: "Lesson"; uid: string }>;
          } | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
          } | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          savedClassLists: Array<{
            __typename?: "SavedClassList";
            uid: string;
            lastAddedToAt: any | null;
          }>;
        };
        nextSection: {
          __typename?: "Section";
          uid: string;
          size_max: number | null;
          filledSpaceCount: number;
          start_time: any | null;
          end_time: any | null;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          } | null;
        } | null;
      }>;
    };
  } | null;
};

export type OtherListingsByTeacherMobileQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  skipRating: Scalars["Boolean"];
}>;

export type OtherListingsByTeacherMobileQuery = {
  __typename?: "Query";
  listing: {
    __typename?: "Listing";
    similarListings: {
      __typename?: "SimilarListings";
      sameTeacher: Array<{
        __typename?: "Listing";
        insertionId: string | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          user_uid: string;
          title: string;
          url: string;
          path: string;
          summary: string | null;
          summaryTranslated: string | null;
          quickSummary: string | null;
          weekly_meetings: number | null;
          duration_weeks: number | null;
          is_ongoing_weekly: boolean;
          isClub: boolean;
          published_at: any | null;
          size_max: number | null;
          size_min: number | null;
          hasTeacherSchedule: boolean;
          allows_recurring_payment: boolean | null;
          averageStarRating?: number | null;
          reviewCount: number;
          age_min: number | null;
          age_max: number | null;
          duration_minutes: number | null;
          price_cents: number | null;
          priceCreditsPerMeeting: number | null;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          canEnroll: boolean;
          isIncludedWithMembership: boolean;
          isOneTime: boolean;
          titleTranslated: string | null;
          slug_id: string;
          subject: string | null;
          syllabus: {
            __typename?: "Syllabus";
            uid: string;
            lessons: Array<{ __typename?: "Lesson"; uid: string }>;
          } | null;
          clubSection: {
            __typename?: "Section";
            filledSpaceCount: number;
            clubPostCount: number;
          } | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
          } | null;
          savedClassLists: Array<{
            __typename?: "SavedClassList";
            uid: string;
            lastAddedToAt: any | null;
          }>;
        };
        nextSection: {
          __typename?: "Section";
          uid: string;
          size_max: number | null;
          filledSpaceCount: number;
          start_time: any | null;
          end_time: any | null;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          } | null;
        } | null;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
          leader_link: string | null;
          averageActivityStarRating: number | null;
          reviewCount: number;
          educatorTiers: Array<EducatorTier>;
          ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        };
      }>;
    };
  } | null;
};

export type SimilarListingsQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
}>;

export type SimilarListingsQuery = {
  __typename?: "Query";
  listing: {
    __typename?: "Listing";
    similarListings: {
      __typename?: "SimilarListings";
      popular: Array<{
        __typename?: "Listing";
        insertionId: string | null;
        sectionCount: number;
        openSectionCount: number;
        upcomingSectionCount: number;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
          leader_link: string | null;
          averageActivityStarRating: number | null;
          reviewCount: number;
          educatorTiers: Array<EducatorTier>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
              fileSize: number | null;
            };
          } | null;
          credentials: Array<{
            __typename?: "TeacherCredential";
            uid: string;
            degreeType: DegreeType | null;
            degreeSubject: DegreeSubject | null;
          }>;
          ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        };
        activity: {
          __typename?: "Activity";
          uid: string;
          isIncludedWithMembership: boolean;
          averageStarRating?: number | null;
          reviewCount: number;
          age_min: number | null;
          age_max: number | null;
          duration_minutes: number | null;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          price_cents: number | null;
          priceCreditsPerMeeting: number | null;
          quickSummary: string | null;
          isClub: boolean;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          isOneTime: boolean;
          hasTeacherSchedule: boolean;
          size_max: number | null;
          user_uid: string;
          slug_id: string;
          title: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          summary: string | null;
          summaryTranslated: string | null;
          is_ongoing_weekly: boolean;
          subject: string | null;
          recentReviews?: Array<{
            __typename?: "PublicReview";
            uid: string;
            activity_star_rating: number | null;
            details: {
              __typename?: "PublicReviewDetails";
              publicReview: string | null;
            } | null;
            parent: {
              __typename?: "Parent";
              uid: string;
              publicName: string | null;
            };
          }>;
          clubSection: {
            __typename?: "Section";
            filledSpaceCount: number;
            clubPostCount: number;
          } | null;
          syllabus: {
            __typename?: "Syllabus";
            uid: string;
            lessons: Array<{ __typename?: "Lesson"; uid: string }>;
          } | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
          } | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          savedClassLists: Array<{
            __typename?: "SavedClassList";
            uid: string;
            lastAddedToAt: any | null;
          }>;
        };
        nextSection: {
          __typename?: "Section";
          uid: string;
          size_max: number | null;
          filledSpaceCount: number;
          start_time: any | null;
          end_time: any | null;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          } | null;
        } | null;
      }>;
    };
  } | null;
};

export type SimilarListingsElasticsearchQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
}>;

export type SimilarListingsElasticsearchQuery = {
  __typename?: "Query";
  listing: {
    __typename?: "Listing";
    similarListings: {
      __typename?: "SimilarListings";
      popularElasticsearch: Array<{
        __typename?: "Listing";
        insertionId: string | null;
        sectionCount: number;
        openSectionCount: number;
        upcomingSectionCount: number;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
          leader_link: string | null;
          averageActivityStarRating: number | null;
          reviewCount: number;
          educatorTiers: Array<EducatorTier>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
              fileSize: number | null;
            };
          } | null;
          credentials: Array<{
            __typename?: "TeacherCredential";
            uid: string;
            degreeType: DegreeType | null;
            degreeSubject: DegreeSubject | null;
          }>;
          ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        };
        activity: {
          __typename?: "Activity";
          uid: string;
          isIncludedWithMembership: boolean;
          averageStarRating?: number | null;
          reviewCount: number;
          age_min: number | null;
          age_max: number | null;
          duration_minutes: number | null;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          price_cents: number | null;
          priceCreditsPerMeeting: number | null;
          quickSummary: string | null;
          isClub: boolean;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          isOneTime: boolean;
          hasTeacherSchedule: boolean;
          size_max: number | null;
          user_uid: string;
          slug_id: string;
          title: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          summary: string | null;
          summaryTranslated: string | null;
          is_ongoing_weekly: boolean;
          subject: string | null;
          recentReviews?: Array<{
            __typename?: "PublicReview";
            uid: string;
            activity_star_rating: number | null;
            details: {
              __typename?: "PublicReviewDetails";
              publicReview: string | null;
            } | null;
            parent: {
              __typename?: "Parent";
              uid: string;
              publicName: string | null;
            };
          }>;
          clubSection: {
            __typename?: "Section";
            filledSpaceCount: number;
            clubPostCount: number;
          } | null;
          syllabus: {
            __typename?: "Syllabus";
            uid: string;
            lessons: Array<{ __typename?: "Lesson"; uid: string }>;
          } | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
          } | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          savedClassLists: Array<{
            __typename?: "SavedClassList";
            uid: string;
            lastAddedToAt: any | null;
          }>;
        };
        nextSection: {
          __typename?: "Section";
          uid: string;
          size_max: number | null;
          filledSpaceCount: number;
          start_time: any | null;
          end_time: any | null;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          } | null;
        } | null;
      }>;
    };
  } | null;
};

export type SimilarListingsMbaQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
}>;

export type SimilarListingsMbaQuery = {
  __typename?: "Query";
  listing: {
    __typename?: "Listing";
    similarListings: {
      __typename?: "SimilarListings";
      popularMBA: Array<{
        __typename?: "Listing";
        insertionId: string | null;
        sectionCount: number;
        openSectionCount: number;
        upcomingSectionCount: number;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
          leader_link: string | null;
          averageActivityStarRating: number | null;
          reviewCount: number;
          educatorTiers: Array<EducatorTier>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
              fileSize: number | null;
            };
          } | null;
          credentials: Array<{
            __typename?: "TeacherCredential";
            uid: string;
            degreeType: DegreeType | null;
            degreeSubject: DegreeSubject | null;
          }>;
          ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        };
        activity: {
          __typename?: "Activity";
          uid: string;
          isIncludedWithMembership: boolean;
          averageStarRating?: number | null;
          reviewCount: number;
          age_min: number | null;
          age_max: number | null;
          duration_minutes: number | null;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          price_cents: number | null;
          priceCreditsPerMeeting: number | null;
          quickSummary: string | null;
          isClub: boolean;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          isOneTime: boolean;
          hasTeacherSchedule: boolean;
          size_max: number | null;
          user_uid: string;
          slug_id: string;
          title: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          summary: string | null;
          summaryTranslated: string | null;
          is_ongoing_weekly: boolean;
          subject: string | null;
          recentReviews?: Array<{
            __typename?: "PublicReview";
            uid: string;
            activity_star_rating: number | null;
            details: {
              __typename?: "PublicReviewDetails";
              publicReview: string | null;
            } | null;
            parent: {
              __typename?: "Parent";
              uid: string;
              publicName: string | null;
            };
          }>;
          clubSection: {
            __typename?: "Section";
            filledSpaceCount: number;
            clubPostCount: number;
          } | null;
          syllabus: {
            __typename?: "Syllabus";
            uid: string;
            lessons: Array<{ __typename?: "Lesson"; uid: string }>;
          } | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
          } | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          savedClassLists: Array<{
            __typename?: "SavedClassList";
            uid: string;
            lastAddedToAt: any | null;
          }>;
        };
        nextSection: {
          __typename?: "Section";
          uid: string;
          size_max: number | null;
          filledSpaceCount: number;
          start_time: any | null;
          end_time: any | null;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          } | null;
        } | null;
      }>;
    };
  } | null;
};

export type SimilarListingsByTfIdfQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  skipRating: Scalars["Boolean"];
  limit?: InputMaybe<Scalars["Int"]>;
  withRecentReviews: Scalars["Boolean"];
}>;

export type SimilarListingsByTfIdfQuery = {
  __typename?: "Query";
  listing: {
    __typename?: "Listing";
    similarListings: {
      __typename?: "SimilarListings";
      tfidf: Array<{
        __typename?: "Listing";
        insertionId: string | null;
        sectionCount: number;
        openSectionCount: number;
        upcomingSectionCount: number;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
          leader_link: string | null;
          averageActivityStarRating: number | null;
          reviewCount: number;
          educatorTiers: Array<EducatorTier>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
              fileSize: number | null;
            };
          } | null;
          credentials: Array<{
            __typename?: "TeacherCredential";
            uid: string;
            degreeType: DegreeType | null;
            degreeSubject: DegreeSubject | null;
          }>;
          ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        };
        activity: {
          __typename?: "Activity";
          uid: string;
          isIncludedWithMembership: boolean;
          averageStarRating?: number | null;
          reviewCount: number;
          age_min: number | null;
          age_max: number | null;
          duration_minutes: number | null;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          price_cents: number | null;
          priceCreditsPerMeeting: number | null;
          quickSummary: string | null;
          isClub: boolean;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          isOneTime: boolean;
          hasTeacherSchedule: boolean;
          size_max: number | null;
          user_uid: string;
          slug_id: string;
          title: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          summary: string | null;
          summaryTranslated: string | null;
          is_ongoing_weekly: boolean;
          subject: string | null;
          recentReviews?: Array<{
            __typename?: "PublicReview";
            uid: string;
            activity_star_rating: number | null;
            details: {
              __typename?: "PublicReviewDetails";
              publicReview: string | null;
            } | null;
            parent: {
              __typename?: "Parent";
              uid: string;
              publicName: string | null;
            };
          }>;
          clubSection: {
            __typename?: "Section";
            filledSpaceCount: number;
            clubPostCount: number;
          } | null;
          syllabus: {
            __typename?: "Syllabus";
            uid: string;
            lessons: Array<{ __typename?: "Lesson"; uid: string }>;
          } | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
          } | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          savedClassLists: Array<{
            __typename?: "SavedClassList";
            uid: string;
            lastAddedToAt: any | null;
          }>;
        };
        nextSection: {
          __typename?: "Section";
          uid: string;
          size_max: number | null;
          filledSpaceCount: number;
          start_time: any | null;
          end_time: any | null;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          } | null;
        } | null;
      }>;
    };
  } | null;
};

export type AddToCollectionModal_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  savedClassLists: Array<{
    __typename?: "SavedClassList";
    uid: string;
    lastAddedToAt: any | null;
  }>;
};

export type TrackSaveClass_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  slug_id: string;
  title: string;
  titleTranslated: string | null;
  price_cents: number | null;
  subject: string | null;
};

export type SaveButton_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  title: string;
  titleTranslated: string | null;
  isClub: boolean;
  slug_id: string;
  price_cents: number | null;
  subject: string | null;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
  savedClassLists: Array<{
    __typename?: "SavedClassList";
    uid: string;
    lastAddedToAt: any | null;
  }>;
};

export type ListingCard_ListingFragment = {
  __typename?: "Listing";
  insertionId: string | null;
  sectionCount: number;
  openSectionCount: number;
  upcomingSectionCount: number;
  leader: {
    __typename?: "Leader";
    uid: string;
    name: string | null;
    photo: string | null;
    leader_link: string | null;
    averageActivityStarRating: number | null;
    reviewCount: number;
    educatorTiers: Array<EducatorTier>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
        fileSize: number | null;
      };
    } | null;
    credentials: Array<{
      __typename?: "TeacherCredential";
      uid: string;
      degreeType: DegreeType | null;
      degreeSubject: DegreeSubject | null;
    }>;
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
  };
  activity: {
    __typename?: "Activity";
    uid: string;
    isIncludedWithMembership: boolean;
    averageStarRating?: number | null;
    reviewCount: number;
    age_min: number | null;
    age_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCreditsPerMeeting: number | null;
    quickSummary: string | null;
    isClub: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    hasTeacherSchedule: boolean;
    size_max: number | null;
    user_uid: string;
    slug_id: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    recentReviews?: Array<{
      __typename?: "PublicReview";
      uid: string;
      activity_star_rating: number | null;
      details: {
        __typename?: "PublicReviewDetails";
        publicReview: string | null;
      } | null;
      parent: { __typename?: "Parent"; uid: string; publicName: string | null };
    }>;
    clubSection: {
      __typename?: "Section";
      filledSpaceCount: number;
      clubPostCount: number;
    } | null;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      lessons: Array<{ __typename?: "Lesson"; uid: string }>;
    } | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
    } | null;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
    savedClassLists: Array<{
      __typename?: "SavedClassList";
      uid: string;
      lastAddedToAt: any | null;
    }>;
  };
  nextSection: {
    __typename?: "Section";
    uid: string;
    size_max: number | null;
    filledSpaceCount: number;
    start_time: any | null;
    end_time: any | null;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
    } | null;
  } | null;
};

export type ActivityListing_ListingFragment = {
  __typename?: "Listing";
  insertionId: string | null;
  activity: {
    __typename?: "Activity";
    uid: string;
    user_uid: string;
    title: string;
    url: string;
    path: string;
    summary: string | null;
    summaryTranslated: string | null;
    quickSummary: string | null;
    weekly_meetings: number | null;
    duration_weeks: number | null;
    is_ongoing_weekly: boolean;
    isClub: boolean;
    published_at: any | null;
    size_max: number | null;
    size_min: number | null;
    hasTeacherSchedule: boolean;
    allows_recurring_payment: boolean | null;
    averageStarRating?: number | null;
    reviewCount: number;
    age_min: number | null;
    age_max: number | null;
    duration_minutes: number | null;
    price_cents: number | null;
    priceCreditsPerMeeting: number | null;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    canEnroll: boolean;
    isIncludedWithMembership: boolean;
    isOneTime: boolean;
    titleTranslated: string | null;
    slug_id: string;
    subject: string | null;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      lessons: Array<{ __typename?: "Lesson"; uid: string }>;
    } | null;
    clubSection: {
      __typename?: "Section";
      filledSpaceCount: number;
      clubPostCount: number;
    } | null;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
    } | null;
    savedClassLists: Array<{
      __typename?: "SavedClassList";
      uid: string;
      lastAddedToAt: any | null;
    }>;
  };
  nextSection: {
    __typename?: "Section";
    uid: string;
    size_max: number | null;
    filledSpaceCount: number;
    start_time: any | null;
    end_time: any | null;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
    } | null;
  } | null;
  leader: {
    __typename?: "Leader";
    uid: string;
    name: string | null;
    photo: string | null;
    leader_link: string | null;
    averageActivityStarRating: number | null;
    reviewCount: number;
    educatorTiers: Array<EducatorTier>;
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
  };
};

export type CancelOneOnOneModal_SelectedMeetingFragment = {
  __typename?: "Meeting";
  uid: string;
  start_time: any;
  end_time: any;
  recurring: boolean | null;
  paidAt: any | null;
  refundableAmountCents: number;
  refundableAmountCredits: number | null;
};

export type CancelOneOnOneModal_RefundPolicyFragment = {
  __typename?: "RefundPolicy";
  name: string;
  description: string;
  creditDescription: string | null;
};

export type EditableMeetingsQueryVariables = Exact<{
  uid: Scalars["ID"];
  skipDeletedMeetings: Scalars["Boolean"];
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type EditableMeetingsQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    meetingCount: number;
    futureMeetingCount: number;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
      holiday: { __typename?: "Holiday"; name: string } | null;
      lesson: {
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        week_number: number;
        order_within_week: number;
        lessonNumber: number | null;
      } | null;
    }>;
    deletedMeetings?: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
      holiday: { __typename?: "Holiday"; name: string } | null;
      lesson: {
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        week_number: number;
        order_within_week: number;
        lessonNumber: number | null;
      } | null;
    }>;
  } | null;
};

export type ActivityManageToolbarQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type ActivityManageToolbarQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    saveCount: number | null;
    archived_at: any | null;
    upsell_activity_uid: string | null;
    why_me: string | null;
    parental_guidance: string | null;
    sources: string | null;
    materials: string | null;
    hasSections: boolean;
    requested_listing_at: any | null;
    has_external_resources: boolean | null;
    selfPacedMigration: {
      __typename?: "SelfPacedMigrationStatus";
      hasConsented: boolean;
    } | null;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        week_number: number;
        order_within_week: number;
        title: string | null;
        description: string | null;
        lessonNumber: number | null;
        unit: { __typename?: "Unit"; uid: string; title: string | null } | null;
      }>;
    } | null;
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    details: { __typename?: "ActivityDetails"; asyncTime: string | null };
    leaderDetails: {
      __typename?: "ActivityLeaderDetails";
      uid: string;
      requestedListingAt: any | null;
      welcomeMessage: {
        __typename?: "WelcomeMessage";
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        }> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        } | null;
      } | null;
    };
    approvalStatus: {
      __typename?: "ActivityApprovalStatus";
      action: string;
      message_to_teacher: string | null;
    } | null;
    externalResources: Array<{
      __typename?: "ExternalResource";
      uid: string;
      name: string;
      url: string | null;
    }>;
  };
};

export type ClubManageToolbar_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  user_uid: string;
  title: string;
  titleTranslated: string | null;
  isClub: boolean;
};

export type ClubManageToolbar_SectionFragment = {
  __typename?: "Section";
  uid: string;
  published_at: any | null;
  deleted_at: any | null;
  canceled_at: any | null;
  start_time: any | null;
  end_time: any | null;
  size_max: number | null;
  currentUserCanManage: boolean;
};

export type OneOnOneManageToolbar_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  user_uid: string;
  title: string;
  titleTranslated: string | null;
  isClub: boolean;
  hasTeacherSchedule: boolean;
  archived_at: any | null;
  published_at: any | null;
  requested_listing_at: any | null;
  approvalStatus: {
    __typename?: "ActivityApprovalStatus";
    action: string;
    message_to_teacher: string | null;
  } | null;
};

export type SectionManageToolbar_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  user_uid: string;
  title: string;
  titleTranslated: string | null;
  is_ongoing_weekly: boolean;
  weekly_meetings: number | null;
  duration_weeks: number | null;
  isClub: boolean;
  published_at: any | null;
  hasTeacherSchedule: boolean;
  isSelfPaced: boolean;
};

export type SectionManageToolbar_SectionFragment = {
  __typename?: "Section";
  uid: string;
  published_at: any | null;
  deleted_at: any | null;
  canceled_at: any | null;
  start_time: any | null;
  end_time: any | null;
  startsAtNight: boolean | null;
  is_self_paced: boolean;
  currentUserCanManage: boolean;
  nextOngoingMeeting: {
    __typename?: "Meeting";
    uid: string;
    start_time: any;
  } | null;
  assignmentClassPosts: Array<{
    __typename?: "AssignmentClassPost";
    uid: string;
  }>;
  syllabus: {
    __typename?: "Syllabus";
    uid: string;
    published_at: string | null;
    layoutVersion: number;
  } | null;
};

export type ActivityPreviewByUidQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type ActivityPreviewByUidQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    titleTranslated: string | null;
    isFlexSchedule: boolean;
    size_max: number | null;
    isClub: boolean;
    weekly_meetings: number | null;
    duration_weeks: number | null;
    price_cents: number | null;
    is_ongoing_weekly: boolean;
    hasTeacherSchedule: boolean;
    isIncludedWithMembership: boolean;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      averageActivityStarRating: number | null;
      reviewCount: number;
    };
  };
};

export type ParentDashboardScheduleQueryQueryVariables = Exact<{
  start: Scalars["DateTime"];
  end: Scalars["DateTime"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
}>;

export type ParentDashboardScheduleQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    activeEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        created_at: any;
        isVerified: boolean;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        meetingCount: number;
        deleted_at: any | null;
        published_at: any | null;
        canceled_at: any | null;
        filledSpaceCount: number;
        validEnrollmentCount: number;
        activity: {
          __typename?: "Activity";
          uid: string;
          slug_id: string;
          published_at: any | null;
          title: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          hasTeacherSchedule: boolean;
          isClub: boolean;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          isOneTime: boolean;
          duration_minutes: number | null;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          is_ongoing_weekly: boolean;
          size_min: number | null;
          size_max: number | null;
          leader: {
            __typename?: "Leader";
            uid: string;
            name: string | null;
            photo: string | null;
            averageActivityStarRating: number | null;
            reviewCount: number;
          };
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
        };
        meetings: Array<{
          __typename?: "Meeting";
          sectionSequenceNumber: number;
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        }>;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
      } | null;
    } | null>;
  } | null;
};

export type AcceptNewPrivacyTermsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type AcceptNewPrivacyTermsMutation = {
  __typename?: "Mutation";
  acceptNewPrivacyTerms: boolean;
};

export type AllLearnerConsentNeedsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllLearnerConsentNeedsQuery = {
  __typename?: "Query";
  allLearnerConsentNeeds: {
    __typename?: "LearnerConsentNeeds";
    needsMarketingConsent: boolean;
    needsHealthConsent: boolean;
  };
};

export type SetAllLearnersConsentMutationVariables = Exact<{
  hasMarketingConsent?: InputMaybe<Scalars["Boolean"]>;
  hasHealthConsent?: InputMaybe<Scalars["Boolean"]>;
}>;

export type SetAllLearnersConsentMutation = {
  __typename?: "Mutation";
  setAllLearnersConsent: Array<{ __typename?: "Learner"; uid: string }>;
};

export type FavoritesSavedClassListQueryQueryVariables = Exact<{
  listUid?: InputMaybe<Scalars["String"]>;
  order?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  skipRating: Scalars["Boolean"];
  skipSavedActivities?: InputMaybe<Scalars["Boolean"]>;
}>;

export type FavoritesSavedClassListQueryQuery = {
  __typename?: "Query";
  savedClassList: {
    __typename?: "SavedClassList";
    uid: string;
    name: string;
    privacyStatus: SavedClassListStatus;
    ownerUid: string;
    activityCount: number;
    listings: Array<{
      __typename?: "Listing";
      insertionId: string | null;
      activity: {
        __typename?: "Activity";
        uid: string;
        user_uid: string;
        title: string;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        quickSummary: string | null;
        weekly_meetings: number | null;
        duration_weeks: number | null;
        is_ongoing_weekly: boolean;
        isClub: boolean;
        published_at: any | null;
        size_max: number | null;
        size_min: number | null;
        hasTeacherSchedule: boolean;
        allows_recurring_payment: boolean | null;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        canEnroll: boolean;
        isIncludedWithMembership: boolean;
        isOneTime: boolean;
        titleTranslated: string | null;
        slug_id: string;
        subject: string | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
    } | null>;
    owner: {
      __typename?: "User";
      uid: string;
      publicName: string | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        leader_link: string | null;
      } | null;
    };
  } | null;
  currentUser: {
    __typename?: "User";
    uid: string;
    learners: Array<{
      __typename?: "Learner";
      uid: string;
      name: string | null;
      savedClassList: { __typename?: "SavedClassList"; uid: string } | null;
    }>;
    savedClassLists: Array<{
      __typename?: "SavedClassList";
      uid: string;
      name: string;
      activityCount: number;
    }>;
    userDefaultSavedClassList: {
      __typename?: "SavedClassList";
      uid: string;
      activityCount: number;
    } | null;
  } | null;
};

export type LearnerFavoritesSavedClassListQueryQueryVariables = Exact<{
  learnerUid: Scalars["ID"];
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<Scalars["String"]>;
  skipRating: Scalars["Boolean"];
}>;

export type LearnerFavoritesSavedClassListQueryQuery = {
  __typename?: "Query";
  learnerProfile: {
    __typename?: "LearnerProfile";
    uid: string;
    favoritedClassList: {
      __typename?: "SavedClassList";
      listings: Array<{
        __typename?: "Listing";
        insertionId: string | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          user_uid: string;
          title: string;
          url: string;
          path: string;
          summary: string | null;
          summaryTranslated: string | null;
          quickSummary: string | null;
          weekly_meetings: number | null;
          duration_weeks: number | null;
          is_ongoing_weekly: boolean;
          isClub: boolean;
          published_at: any | null;
          size_max: number | null;
          size_min: number | null;
          hasTeacherSchedule: boolean;
          allows_recurring_payment: boolean | null;
          averageStarRating?: number | null;
          reviewCount: number;
          age_min: number | null;
          age_max: number | null;
          duration_minutes: number | null;
          price_cents: number | null;
          priceCreditsPerMeeting: number | null;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          canEnroll: boolean;
          isIncludedWithMembership: boolean;
          isOneTime: boolean;
          titleTranslated: string | null;
          slug_id: string;
          subject: string | null;
          syllabus: {
            __typename?: "Syllabus";
            uid: string;
            lessons: Array<{ __typename?: "Lesson"; uid: string }>;
          } | null;
          clubSection: {
            __typename?: "Section";
            filledSpaceCount: number;
            clubPostCount: number;
          } | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
          } | null;
          savedClassLists: Array<{
            __typename?: "SavedClassList";
            uid: string;
            lastAddedToAt: any | null;
          }>;
        };
        nextSection: {
          __typename?: "Section";
          uid: string;
          size_max: number | null;
          filledSpaceCount: number;
          start_time: any | null;
          end_time: any | null;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          } | null;
        } | null;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
          leader_link: string | null;
          averageActivityStarRating: number | null;
          reviewCount: number;
          educatorTiers: Array<EducatorTier>;
          ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        };
      } | null>;
    } | null;
  };
};

export type SubscriptionInsightsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SubscriptionInsightsQuery = {
  __typename?: "Query";
  subscriptionInsights: {
    __typename?: "SubscriptionInsights";
    memberSince: any;
    centsSavedFromCreditPurchases: number;
    creditUsage: Array<{
      __typename?: "CreditUsageItem";
      usedCredits: number | null;
      projectedCredits: number | null;
      startDate: any;
      endDate: any;
    }>;
  } | null;
  currentUser: {
    __typename?: "User";
    uid: string;
    freeMembershipEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      section: {
        __typename?: "Section";
        uid: string;
        activity: {
          __typename?: "Activity";
          uid: string;
          price_cents: number | null;
        };
      } | null;
    }>;
  } | null;
};

export type TranscriptsQueryQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars["DateTime"]>;
  endDate?: InputMaybe<Scalars["DateTime"]>;
  learnerUid?: InputMaybe<Scalars["String"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type TranscriptsQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    availableTranscriptYears: Array<number>;
    transcriptCount: number;
    learners: Array<{
      __typename?: "Learner";
      uid: string;
      name: string | null;
    }>;
    enrollmentsForTranscript: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      isEnded: boolean;
      completedEnrolledWeeks: number;
      hasCompletedLesson: boolean;
      hasPostedComment: boolean;
      details: { __typename?: "EnrollmentDetails"; attendedAt: any | null };
      pauseWindow: { __typename?: "EnrollmentPauseWindow"; uid: string } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        canceled_at: any | null;
        start_time: any | null;
        end_time: any | null;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          leader_link: string | null;
        };
        activity: {
          __typename?: "Activity";
          uid: string;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          title: string;
          titleTranslated: string | null;
          subject: string | null;
          slug_id: string;
          summary: string | null;
          isSelfPaced: boolean;
          hasTeacherSchedule: boolean;
          size_max: number | null;
        };
        currentUserPublicReview: {
          __typename?: "PublicReview";
          uid: string;
          currentUserCanEdit: boolean;
        } | null;
        meetings: Array<{ __typename?: "Meeting"; end_time: any }>;
      } | null;
    } | null>;
  } | null;
};

export type UpdateUseOtherFundsForMembershipsMutationVariables = Exact<{
  useOtherFundsForMemberships: Scalars["Boolean"];
}>;

export type UpdateUseOtherFundsForMembershipsMutation = {
  __typename?: "Mutation";
  updateCurrentUser: {
    __typename?: "User";
    uid: string;
    useOtherFundsForMemberships: boolean;
  };
};

export type UseOtherFundsForMembershipsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UseOtherFundsForMembershipsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    useOtherFundsForMemberships: boolean;
  } | null;
};

export type CanceledClassesQueryQueryVariables = Exact<{
  learnerUid?: InputMaybe<Scalars["ID"]>;
  page: Scalars["Int"];
  limit: Scalars["Int"];
}>;

export type CanceledClassesQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    canceledEnrollments: {
      __typename?: "PaginatedEnrollments";
      results: Array<{
        __typename?: "Enrollment";
        uid: string;
        confirmed_at: any | null;
        isPaused: boolean;
        ongoingStartTime: any | null;
        isEnded: boolean;
        ongoingEndTime: any | null;
        cancellationType: EnrollmentCancellationType | null;
        withdrawnAt: any | null;
        isWithdrawn: boolean;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        } | null;
        section: {
          __typename?: "Section";
          uid: string;
          canceled_at: any | null;
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          activity: {
            __typename?: "Activity";
            uid: string;
            slug_id: string;
            title: string;
            isSelfPaced: boolean;
            hasTeacherSchedule: boolean;
            isFlexSchedule: boolean;
            isOneTime: boolean;
            size_max: number | null;
            photo: { __typename?: "Attachment"; fileUrl: string } | null;
          };
        } | null;
        pauseWindow: {
          __typename?: "EnrollmentPauseWindow";
          uid: string;
          startDate: any;
          pauseReason: string;
        } | null;
        upcomingPausedMeeting: {
          __typename?: "Meeting";
          start_time: any;
        } | null;
      }>;
      pageInfo: {
        __typename?: "OffsetPageInfo";
        currentPage: number;
        totalPages: number;
        totalItems: number;
      } | null;
    };
  } | null;
};

export type CompletedClassesQueryQueryVariables = Exact<{
  learnerUid?: InputMaybe<Scalars["String"]>;
  page: Scalars["Int"];
  limit: Scalars["Int"];
}>;

export type CompletedClassesQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    learners: Array<{
      __typename?: "Learner";
      uid: string;
      name: string | null;
    }>;
    paginatedEnrollmentsForTranscript: {
      __typename?: "PaginatedEnrollments";
      results: Array<{
        __typename?: "Enrollment";
        uid: string;
        confirmed_at: any | null;
        ongoing_start_time: any | null;
        hasCompletedLesson: boolean;
        hasPostedComment: boolean;
        isPaused: boolean;
        ongoingStartTime: any | null;
        isEnded: boolean;
        ongoingEndTime: any | null;
        cancellationType: EnrollmentCancellationType | null;
        withdrawnAt: any | null;
        isWithdrawn: boolean;
        details: { __typename?: "EnrollmentDetails"; attendedAt: any | null };
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          avatar: string | null;
        } | null;
        section: {
          __typename?: "Section";
          uid: string;
          currentUserCanManage: boolean;
          is_self_paced: boolean;
          teacher_support_start_time: any | null;
          start_time: any | null;
          end_time: any | null;
          canceled_at: any | null;
          deleted_at: any | null;
          published_at: any | null;
          leader: {
            __typename?: "Leader";
            uid: string;
            name: string | null;
            leader_link: string | null;
            photo: string | null;
          };
          activity: {
            __typename?: "Activity";
            uid: string;
            title: string;
            slug_id: string;
            isClub: boolean;
            isSelfPaced: boolean;
            isFlexSchedule: boolean;
            isOneTime: boolean;
            hasTeacherSchedule: boolean;
            size_max: number | null;
            is_ongoing_weekly: boolean;
            photo: { __typename?: "Attachment"; fileUrl: string } | null;
            leader: { __typename?: "Leader"; name: string | null };
          };
          meetings: Array<{
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          }>;
          currentUserPublicReview: {
            __typename?: "PublicReview";
            uid: string;
            currentUserCanEdit: boolean;
          } | null;
        } | null;
        pauseWindow: {
          __typename?: "EnrollmentPauseWindow";
          uid: string;
          startDate: any;
          pauseReason: string;
        } | null;
        upcomingPausedMeeting: {
          __typename?: "Meeting";
          start_time: any;
        } | null;
      }>;
      pageInfo: {
        __typename?: "OffsetPageInfo";
        currentPage: number;
        totalPages: number;
        totalItems: number;
      } | null;
    };
  } | null;
};

export type EnrolledClassesForDateQueryQueryVariables = Exact<{
  start: Scalars["DateTime"];
  end: Scalars["DateTime"];
  page: Scalars["Int"];
  limit: Scalars["Int"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
}>;

export type EnrolledClassesForDateQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    paginatedActiveEnrollmentsForDate: {
      __typename?: "PaginatedEnrollments";
      results: Array<{
        __typename?: "Enrollment";
        uid: string;
        thisWeekPauseDeadline: any | null;
        canBeStopped: boolean;
        canBePaused: boolean;
        canBeWithdrawn: boolean;
        isEnded: boolean;
        isPaused: boolean;
        ongoingStartTime: any | null;
        ongoingEndTime: any | null;
        refundableAmountCents: number;
        confirmedAt: any | null;
        withdrawn_at: any | null;
        withdrawnAt: any | null;
        price_cents: number | null;
        priceCredits: number | null;
        service_fee_percentage: number;
        exchange_rate: number;
        hasCompletedLesson: boolean;
        hasPostedComment: boolean;
        buyer: {
          __typename?: "Parent";
          uid: string;
          name: string | null;
        } | null;
        details: {
          __typename?: "EnrollmentDetails";
          name: string | null;
          attendedAt: any | null;
        };
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          avatar: string | null;
        } | null;
        parent: { __typename?: "Parent"; uid: string; name: string | null };
        payments: Array<{
          __typename?: "EnrollmentPayment";
          uid: string;
          isOngoingRefundable: boolean;
          paid_at: any | null;
          unrefundedCents: number;
          end_time: any | null;
          service_fee_percentage: number | null;
          credit_transaction_uid: string | null;
          credit_account_type: string | null;
        }>;
        paymentSchedule: {
          __typename?: "PaymentSchedule";
          uid: string;
          stoppedAt: any | null;
        } | null;
        pauseWindow: {
          __typename?: "EnrollmentPauseWindow";
          uid: string;
          startDate: any;
          endDate: any;
          canBeCanceled: boolean;
          pauseReason: string;
        } | null;
        upcomingPausedMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
        refundPolicy: {
          __typename?: "RefundPolicy";
          name: string;
          description: string;
        } | null;
        section: {
          __typename?: "Section";
          uid: string;
          canceled_at: any | null;
          deleted_at: any | null;
          end_time: any | null;
          is_self_paced: boolean;
          price_cents: number | null;
          priceCredits: number | null;
          published_at: any | null;
          start_time: any | null;
          isBuyable: boolean;
          meetingTimes: Array<{
            __typename?: "MeetingTime";
            dayOfWeek: number;
            hour: number;
            minute: number;
          }>;
          activity: {
            __typename?: "Activity";
            uid: string;
            duration_weeks: number | null;
            duration_minutes: number | null;
            size_max: number | null;
            hasTeacherSchedule: boolean;
            isClub: boolean;
            isOneTime: boolean;
            is_ongoing_weekly: boolean;
            price_cents: number | null;
            priceCredits: number | null;
            published_at: any | null;
            title: string;
            titleTranslated: string | null;
            weekly_meetings: number | null;
            subject: string | null;
            averageStarRating: number | null;
            reviewCount: number;
            age_min: number | null;
            age_max: number | null;
            isFlexSchedule: boolean;
            isIncludedWithMembership: boolean;
            isSelfPaced: boolean;
            photo: { __typename?: "Attachment"; fileUrl: string } | null;
            leader: {
              __typename?: "Leader";
              uid: string;
              name: string | null;
              photo: string | null;
              leader_link: string | null;
              timeZone: string | null;
            };
          };
          leader: {
            __typename?: "Leader";
            uid: string;
            name: string | null;
            photo: string | null;
            leader_link: string | null;
            timeZone: string | null;
          };
          meetings: Array<{
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          }>;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          } | null;
        } | null;
      }>;
      pageInfo: {
        __typename?: "OffsetPageInfo";
        currentPage: number;
        totalPages: number;
        totalItems: number;
      } | null;
    };
  } | null;
};

export type EnrolledClassesQueryQueryVariables = Exact<{
  start: Scalars["DateTime"];
  end: Scalars["DateTime"];
  page: Scalars["Int"];
  limit: Scalars["Int"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
  includeRecapMeetings: Scalars["Boolean"];
  recapReferenceTime?: InputMaybe<Scalars["DateTime"]>;
}>;

export type EnrolledClassesQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    paginatedActiveEnrollments: {
      __typename?: "PaginatedEnrollments";
      results: Array<{
        __typename?: "Enrollment";
        uid: string;
        thisWeekPauseDeadline: any | null;
        canBeStopped: boolean;
        canBePaused: boolean;
        canBeWithdrawn: boolean;
        ongoingStartTime: any | null;
        refundableAmountCents: number;
        confirmedAt: any | null;
        price_cents: number | null;
        priceCredits: number | null;
        service_fee_percentage: number;
        currency_code: CurrencyCode;
        exchange_rate: number;
        hasCompletedLesson: boolean;
        hasPostedComment: boolean;
        isPaused: boolean;
        isEnded: boolean;
        ongoingEndTime: any | null;
        cancellationType: EnrollmentCancellationType | null;
        withdrawnAt: any | null;
        isWithdrawn: boolean;
        buyer: {
          __typename?: "Parent";
          uid: string;
          name: string | null;
        } | null;
        details: {
          __typename?: "EnrollmentDetails";
          name: string | null;
          attendedAt: any | null;
        };
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          avatar: string | null;
        } | null;
        parent: { __typename?: "Parent"; uid: string; name: string | null };
        payments: Array<{
          __typename?: "EnrollmentPayment";
          uid: string;
          isOngoingRefundable: boolean;
          paid_at: any | null;
          unrefundedCents: number;
          end_time: any | null;
          service_fee_percentage: number | null;
          credit_transaction_uid: string | null;
          credit_account_type: string | null;
          tax_cents: number;
        }>;
        paymentSchedule: {
          __typename?: "PaymentSchedule";
          uid: string;
          stoppedAt: any | null;
        } | null;
        pauseWindow: {
          __typename?: "EnrollmentPauseWindow";
          endDate: any;
          canBeCanceled: boolean;
          uid: string;
          startDate: any;
          pauseReason: string;
        } | null;
        upcomingPausedMeeting: {
          __typename?: "Meeting";
          uid: string;
          end_time: any;
          start_time: any;
        } | null;
        refundPolicy: {
          __typename?: "RefundPolicy";
          name: string;
          description: string;
        } | null;
        section: {
          __typename?: "Section";
          uid: string;
          price_cents: number | null;
          priceCredits: number | null;
          isBuyable: boolean;
          currentUserCanManage: boolean;
          is_self_paced: boolean;
          teacher_support_start_time: any | null;
          start_time: any | null;
          end_time: any | null;
          canceled_at: any | null;
          deleted_at: any | null;
          published_at: any | null;
          meetingTimes: Array<{
            __typename?: "MeetingTime";
            dayOfWeek: number;
            hour: number;
            minute: number;
          }>;
          activity: {
            __typename?: "Activity";
            uid: string;
            duration_weeks: number | null;
            duration_minutes: number | null;
            size_max: number | null;
            hasTeacherSchedule: boolean;
            isClub: boolean;
            isOneTime: boolean;
            price_cents: number | null;
            priceCredits: number | null;
            published_at: any | null;
            title: string;
            titleTranslated: string | null;
            weekly_meetings: number | null;
            subject: string | null;
            averageStarRating: number | null;
            reviewCount: number;
            age_min: number | null;
            age_max: number | null;
            isIncludedWithMembership: boolean;
            isFlexSchedule: boolean;
            isSelfPaced: boolean;
            is_ongoing_weekly: boolean;
            photo: { __typename?: "Attachment"; fileUrl: string } | null;
            leader: {
              __typename?: "Leader";
              uid: string;
              name: string | null;
              photo: string | null;
              leader_link: string | null;
              timeZone: string | null;
            };
          };
          leader: {
            __typename?: "Leader";
            uid: string;
            name: string | null;
            photo: string | null;
            leader_link: string | null;
            timeZone: string | null;
          };
          meetings: Array<{
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          }>;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          } | null;
          recentPastMeeting: Array<{
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            classRecordings: Array<
              | {
                  __typename?: "ClassRecording";
                  uid: string;
                  actionItems: Array<{
                    __typename?: "ClassRecordingInsight";
                    uid: string;
                    shortSummary: string;
                    longSummary: string;
                    videoStartTimestamp: string | null;
                    videoEndTimestamp: string | null;
                  }>;
                  teacherMoments: Array<{
                    __typename?: "ClassRecordingInsight";
                    uid: string;
                    shortSummary: string;
                    longSummary: string;
                    videoStartTimestamp: string | null;
                    videoEndTimestamp: string | null;
                  }>;
                }
              | { __typename?: "ZoomRecording"; uid: string }
            >;
          }>;
        } | null;
      }>;
      pageInfo: {
        __typename?: "OffsetPageInfo";
        currentPage: number;
        totalPages: number;
        totalItems: number;
      } | null;
    };
  } | null;
};

export type WaitlistedClassesQueryQueryVariables = Exact<{
  parentUid: Scalars["ID"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
  page: Scalars["Int"];
  limit: Scalars["Int"];
}>;

export type WaitlistedClassesQueryQuery = {
  __typename?: "Query";
  paginatedWaitlistSeatsForParent: {
    __typename?: "PaginatedWaitlistSeats";
    results: Array<{
      __typename?: "WaitlistSeat";
      uid: string;
      createdAt: any | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        avatar: string | null;
        age: number | null;
      };
      enrollment: { __typename?: "Enrollment"; uid: string } | null;
      section: {
        __typename?: "Section";
        uid: string;
        canceled_at: any | null;
        deleted_at: any | null;
        end_time: any | null;
        is_self_paced: boolean;
        price_cents: number | null;
        availableSpaces: number;
        published_at: any | null;
        start_time: any | null;
        waitlistSeatsCount: number | null;
        meetingDays: string | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          duration_weeks: number | null;
          size_max: number | null;
          hasTeacherSchedule: boolean;
          isClub: boolean;
          isOneTime: boolean;
          is_ongoing_weekly: boolean;
          price_cents: number | null;
          published_at: any | null;
          title: string;
          titleTranslated: string | null;
          slug_id: string;
          weekly_meetings: number | null;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          leader: {
            __typename?: "Leader";
            uid: string;
            name: string | null;
            photo: string | null;
            leader_link: string | null;
            timeZone: string | null;
          };
        };
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
          leader_link: string | null;
          timeZone: string | null;
        };
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        }>;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      };
    }>;
    pageInfo: {
      __typename?: "OffsetPageInfo";
      totalPages: number;
      totalItems: number;
      currentPage: number;
    } | null;
  };
};

export type ParentScheduleQueryQueryVariables = Exact<{
  start: Scalars["DateTime"];
  end: Scalars["DateTime"];
}>;

export type ParentScheduleQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    activeEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        created_at: any;
        isVerified: boolean;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        meetingCount: number;
        deleted_at: any | null;
        published_at: any | null;
        canceled_at: any | null;
        filledSpaceCount: number;
        validEnrollmentCount: number;
        activity: {
          __typename?: "Activity";
          uid: string;
          slug_id: string;
          published_at: any | null;
          title: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          hasTeacherSchedule: boolean;
          isClub: boolean;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          isOneTime: boolean;
          duration_minutes: number | null;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          is_ongoing_weekly: boolean;
          size_min: number | null;
          size_max: number | null;
          leader: {
            __typename?: "Leader";
            uid: string;
            name: string | null;
            photo: string | null;
            averageActivityStarRating: number | null;
            reviewCount: number;
          };
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
        };
        meetings: Array<{
          __typename?: "Meeting";
          sectionSequenceNumber: number;
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        }>;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
      } | null;
    } | null>;
  } | null;
};

export type ResendChildEmailConfirmationMutationVariables = Exact<{
  childUid: Scalars["ID"];
}>;

export type ResendChildEmailConfirmationMutation = {
  __typename?: "Mutation";
  resendChildEmailConfirmation: {
    __typename?: "Child";
    uid: string;
    name: string | null;
    age: number | null;
    birthMonth: number | null;
    date_of_birth: any | null;
    birthYear: number | null;
    email: string | null;
    avatar: string | null;
    unlockedAvatars: Array<string>;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    email_confirmed_at: any | null;
    hasMarketingConsent: boolean | null;
    hasHealthConsent: boolean | null;
    isLoginEnabled: boolean;
    username: string | null;
    hasPassword: boolean;
    hasEsaMembership: boolean;
    esaMembershipProgram: string | null;
    attributes: Array<{
      __typename?: "EntityAttribute";
      uid: string;
      key: string;
      value: string;
      source: string | null;
    }>;
    entityAvailabilitySchedule: {
      __typename?: "EntityAvailabilitySchedule";
      entityAvailabilities: Array<{
        __typename?: "EntityAvailability";
        startHour: number;
        startMinute: number;
        day: number;
        endHour: number;
        endMinute: number;
        uid: string;
      }>;
    } | null;
  };
};

export type LatestMembershipOrderQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LatestMembershipOrderQuery = {
  __typename?: "Query";
  latestMembershipOrder: {
    __typename?: "LatestMembershipOrder";
    orderSlugId: string | null;
  } | null;
};

export type CountPricingOffersOnOrgForEmailQueryVariables = Exact<{
  emailAddress: Scalars["String"];
  organizationUid: Scalars["ID"];
}>;

export type CountPricingOffersOnOrgForEmailQuery = {
  __typename?: "Query";
  countPricingOffersOnOrgForEmail: number;
};

export type PricingOfferEditForm_PricingOfferFragment = {
  __typename?: "PricingOffer";
  buyerOrgName: string | null;
  totalCapCents: number;
  userLimitCents: number;
  startAfter: any;
  endBy: any;
  requirePaymentMethod: boolean;
  discount: number | null;
  isFinancialAid: boolean;
  eligibleEmailDomains: Array<string>;
  deletedAt: any | null;
  includedEmailAddresses: Array<string>;
  excludedEmailAddresses: Array<string>;
  organizationUid: string | null;
};

export type ActivityRatingAndReviewsQueryVariables = Exact<{
  uid: Scalars["ID"];
  offset: Scalars["Int"];
  limit: Scalars["Int"];
  skipAggregates: Scalars["Boolean"];
  summaryVariant?: InputMaybe<Scalars["String"]>;
}>;

export type ActivityRatingAndReviewsQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    averageStarRating?: number | null;
    reviewCount?: number;
    reviewsWithTextCount?: number;
    recentReviews: Array<{
      __typename?: "PublicReview";
      uid: string;
      section_uid: string;
      currentUserCanEdit: boolean;
      currentUserCanRespond: boolean;
      activity_star_rating: number | null;
      currentUserMarkedHelpful: boolean | null;
      markedHelpfulCount: number;
      created_at: any;
      teacher_response: string | null;
      teacher_responded_at: any | null;
      details: {
        __typename?: "PublicReviewDetails";
        publicReview: string | null;
      } | null;
      activity: {
        __typename?: "Activity";
        uid: string;
        isClub: boolean;
        slug_id: string;
        title: string;
        user_uid: string;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          leader_link: string | null;
          photo: string | null;
        };
      } | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
    }>;
    reviewsWithAttachments: Array<{
      __typename?: "PublicReview";
      uid: string;
      section_uid: string;
      currentUserCanEdit: boolean;
      currentUserCanRespond: boolean;
      activity_star_rating: number | null;
      currentUserMarkedHelpful: boolean | null;
      markedHelpfulCount: number;
      created_at: any;
      teacher_response: string | null;
      teacher_responded_at: any | null;
      details: {
        __typename?: "PublicReviewDetails";
        publicReview: string | null;
      } | null;
      activity: {
        __typename?: "Activity";
        uid: string;
        isClub: boolean;
        slug_id: string;
        title: string;
        user_uid: string;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          leader_link: string | null;
          photo: string | null;
        };
      } | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
    }>;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      cityState: string | null;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    };
    feedbackSummary?: {
      __typename?: "TeacherFeedbackSummary";
      uid: string | null;
      pros: string | null;
      reviewSummaryBullets: Array<string> | null;
    } | null;
  };
};

export type PhotoFeedbackByUserQueryQueryVariables = Exact<{
  userUid: Scalars["ID"];
}>;

export type PhotoFeedbackByUserQueryQuery = {
  __typename?: "Query";
  photoFeedbackByUser: Array<{
    __typename?: "PublicReview";
    uid: string;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
  }>;
};

export type PublicReviewFragmentFragment = {
  __typename?: "PublicReview";
  uid: string;
  section_uid: string;
  currentUserCanEdit: boolean;
  currentUserCanRespond: boolean;
  activity_star_rating: number | null;
  currentUserMarkedHelpful: boolean | null;
  markedHelpfulCount: number;
  created_at: any;
  teacher_response: string | null;
  teacher_responded_at: any | null;
  details: {
    __typename?: "PublicReviewDetails";
    publicReview: string | null;
  } | null;
  activity: {
    __typename?: "Activity";
    uid: string;
    isClub: boolean;
    slug_id: string;
    title: string;
    user_uid: string;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      leader_link: string | null;
      photo: string | null;
    };
  } | null;
  attachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  };
};

export type PublicReviewsByParent_PublicReviewFragment = {
  __typename?: "PublicReview";
  uid: string;
  section_uid: string;
  currentUserCanEdit: boolean;
  currentUserCanRespond: boolean;
  activity_star_rating: number | null;
  currentUserMarkedHelpful: boolean | null;
  markedHelpfulCount: number;
  created_at: any;
  teacher_response: string | null;
  teacher_responded_at: any | null;
  activity: {
    __typename?: "Activity";
    uid: string;
    isClub: boolean;
    slug_id: string;
    title: string;
    user_uid: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      leader_link: string | null;
      photo: string | null;
      created_at: any | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      reviewCount: number;
      averageActivityStarRating: number | null;
      hasListings: boolean;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    };
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
  } | null;
  details: {
    __typename?: "PublicReviewDetails";
    publicReview: string | null;
  } | null;
  attachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  };
};

export type PublicReviewsOfLeaderQueryVariables = Exact<{
  leaderUid?: InputMaybe<Scalars["ID"]>;
  offset: Scalars["Int"];
  limit: Scalars["Int"];
  skipAggregates: Scalars["Boolean"];
  includeSummary: Scalars["Boolean"];
}>;

export type PublicReviewsOfLeaderQuery = {
  __typename?: "Query";
  publicProfile: {
    __typename?: "PublicProfile";
    uid: string;
    leader: {
      __typename?: "Leader";
      uid: string;
      averageActivityStarRating: number | null;
      reviewCount: number;
      reviewsWithTextCount?: number;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      hasListings: boolean;
      recentReviews: Array<{
        __typename?: "PublicReview";
        uid: string;
        section_uid: string;
        currentUserCanEdit: boolean;
        currentUserCanRespond: boolean;
        activity_star_rating: number | null;
        currentUserMarkedHelpful: boolean | null;
        markedHelpfulCount: number;
        created_at: any;
        teacher_response: string | null;
        teacher_responded_at: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          isClub: boolean;
          slug_id: string;
          title: string;
          user_uid: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          summary: string | null;
          summaryTranslated: string | null;
          is_ongoing_weekly: boolean;
          isIncludedWithMembership: boolean;
          leader: {
            __typename?: "Leader";
            uid: string;
            name: string | null;
            leader_link: string | null;
            photo: string | null;
          };
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
        } | null;
        details: {
          __typename?: "PublicReviewDetails";
          publicReview: string | null;
        } | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        parent: {
          __typename?: "Parent";
          uid: string;
          name: string | null;
          photo: string | null;
          publicName: string | null;
          introduction: string | null;
          created_at: any | null;
          deleted_at: any | null;
          timeZone: string | null;
          socialOptOut: boolean;
          consent_to_share_class_history: boolean | null;
          consent_to_share_favourites: boolean | null;
        };
      }>;
      feedbackSummary?: {
        __typename?: "TeacherFeedbackSummary";
        uid: string | null;
        pros: string | null;
        summary_variant: string | null;
      } | null;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    } | null;
  } | null;
};

export type RespondToReviewMutationVariables = Exact<{
  feedbackUid: Scalars["ID"];
  response: Scalars["String"];
}>;

export type RespondToReviewMutation = {
  __typename?: "Mutation";
  respondToReview: {
    __typename?: "PublicReview";
    uid: string;
    section_uid: string;
    currentUserCanEdit: boolean;
    currentUserCanRespond: boolean;
    activity_star_rating: number | null;
    currentUserMarkedHelpful: boolean | null;
    markedHelpfulCount: number;
    created_at: any;
    teacher_response: string | null;
    teacher_responded_at: any | null;
    details: {
      __typename?: "PublicReviewDetails";
      publicReview: string | null;
    } | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      isClub: boolean;
      slug_id: string;
      title: string;
      user_uid: string;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        photo: string | null;
      };
    } | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
  };
};

export type TextFeedbackByUserQueryQueryVariables = Exact<{
  userUid: Scalars["ID"];
  offset?: InputMaybe<Scalars["Int"]>;
}>;

export type TextFeedbackByUserQueryQuery = {
  __typename?: "Query";
  textFeedbackByUser: Array<{
    __typename?: "PublicReview";
    uid: string;
    activity_star_rating: number | null;
    created_at: any;
    details: {
      __typename?: "PublicReviewDetails";
      publicReview: string | null;
    } | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      isClub: boolean;
      slug_id: string;
      title: string;
      titleTranslated: string | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        created_at: any | null;
        photo: string | null;
        suspended_at: any | null;
        cityState: string | null;
        socialOptOut: boolean;
        is_crosslister: boolean | null;
        timeZone: string | null;
        hasAvailabilitySet: boolean;
        approved: boolean;
        hasBackgroundCheckExpired: boolean | null;
        reviewCount: number;
        averageActivityStarRating: number | null;
        hasListings: boolean;
        details: {
          __typename?: "LeaderDetails";
          about: string | null;
          headline: string | null;
          headlineTranslated: string | null;
          countryOfResidence: string | null;
        };
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: {
          __typename?: "SellerOrg";
          uid: string;
          name: string;
        } | null;
      };
    } | null;
  }>;
};

export type CreateNewCollectionMutationVariables = Exact<{
  name: Scalars["String"];
}>;

export type CreateNewCollectionMutation = {
  __typename?: "Mutation";
  createSavedClassList: {
    __typename?: "SavedClassList";
    uid: string;
    name: string;
  };
};

export type SavedActivityFragmentFragment = {
  __typename?: "SavedActivity";
  uid: string;
  activity_uid: string;
  created_at: any;
};

export type SaveActivityMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  referer?: InputMaybe<Scalars["String"]>;
  attribution?: InputMaybe<Attribution>;
}>;

export type SaveActivityMutation = {
  __typename?: "Mutation";
  saveActivity: {
    __typename?: "SavedActivity";
    uid: string;
    activity_uid: string;
    created_at: any;
  };
};

export type UnsaveActivityMutationVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type UnsaveActivityMutation = {
  __typename?: "Mutation";
  unsaveActivity: boolean;
};

export type SaveToCollectionsMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  referer?: InputMaybe<Scalars["String"]>;
  attribution?: InputMaybe<Attribution>;
  savedClassListUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SaveToCollectionsMutation = {
  __typename?: "Mutation";
  saveActivity: { __typename?: "SavedActivity"; uid: string };
};

export type UnsaveToCollectionsMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  savedClassListUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type UnsaveToCollectionsMutation = {
  __typename?: "Mutation";
  unsaveActivity: boolean;
};

export type RenameSavedClassListMutationVariables = Exact<{
  uid: Scalars["ID"];
  name: Scalars["String"];
}>;

export type RenameSavedClassListMutation = {
  __typename?: "Mutation";
  renameSavedClassList: boolean;
};

export type DeleteSavedClassListMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type DeleteSavedClassListMutation = {
  __typename?: "Mutation";
  deleteSavedClassList: boolean;
};

export type UpdateLastAddedToAtFragment = {
  __typename?: "SavedClassList";
  uid: string;
  lastAddedToAt: any | null;
};

export type RenameSavedClassListFragment = {
  __typename?: "SavedClassList";
  name: string;
};

export type SavedClassListQueryQueryVariables = Exact<{
  listUid?: InputMaybe<Scalars["String"]>;
  order?: InputMaybe<Scalars["String"]>;
  searchFilters: SearchFilters;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  skipRating: Scalars["Boolean"];
  skipSavedActivities?: InputMaybe<Scalars["Boolean"]>;
}>;

export type SavedClassListQueryQuery = {
  __typename?: "Query";
  savedClassList: {
    __typename?: "SavedClassList";
    uid: string;
    name: string;
    privacyStatus: SavedClassListStatus;
    ownerUid: string;
    activityCount: number;
    listings: Array<{
      __typename?: "Listing";
      insertionId: string | null;
      activity: {
        __typename?: "Activity";
        uid: string;
        user_uid: string;
        title: string;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        quickSummary: string | null;
        weekly_meetings: number | null;
        duration_weeks: number | null;
        is_ongoing_weekly: boolean;
        isClub: boolean;
        published_at: any | null;
        size_max: number | null;
        size_min: number | null;
        hasTeacherSchedule: boolean;
        allows_recurring_payment: boolean | null;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        canEnroll: boolean;
        isIncludedWithMembership: boolean;
        isOneTime: boolean;
        titleTranslated: string | null;
        slug_id: string;
        subject: string | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
    } | null>;
    owner: {
      __typename?: "User";
      uid: string;
      publicName: string | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        leader_link: string | null;
      } | null;
    };
  } | null;
  currentUser: {
    __typename?: "User";
    uid: string;
    learners: Array<{
      __typename?: "Learner";
      uid: string;
      name: string | null;
      savedClassList: { __typename?: "SavedClassList"; uid: string } | null;
    }>;
    savedClassLists: Array<{
      __typename?: "SavedClassList";
      uid: string;
      name: string;
      activityCount: number;
    }>;
    userDefaultSavedClassList: {
      __typename?: "SavedClassList";
      uid: string;
      activityCount: number;
    } | null;
  } | null;
};

export type CurrentUserSavedActivitiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrentUserSavedActivitiesQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    savedActivities: Array<{
      __typename?: "SavedActivity";
      uid: string;
      activity_uid: string;
      created_at: any;
    }>;
  } | null;
};

export type ListCurrentUserSavedClassListsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListCurrentUserSavedClassListsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    savedClassLists: Array<{
      __typename?: "SavedClassList";
      uid: string;
      name: string;
      lastAddedToAt: any | null;
    }>;
  } | null;
};

export type SavedSearchFragmentFragment = {
  __typename?: "SavedSearch";
  uid: string;
  createdAt: any;
  filters: {
    __typename?: "SavedSearchFilters";
    adminTags: Array<string> | null;
    age: string | null;
    capacityMax: number | null;
    capacityMin: number | null;
    curriculums: Array<string> | null;
    delivery: string | null;
    dow: string | null;
    enabledBooleanFilters: string | null;
    endBy: string | null;
    endByTime: number | null;
    englishProficiencyLevel: EnglishProficiencyLevel | null;
    format: string | null;
    fundingPrograms: Array<string> | null;
    gradeLevel: string | null;
    hasFilledOutUniqueLearningNeeds: boolean | null;
    includeInProgressFixedLengthLiveFormat: boolean | null;
    includedWithMembership: boolean | null;
    languageOfInstruction: string | null;
    multiTermQuery: Array<string> | null;
    order: string | null;
    pricePerMeetingMax: number | null;
    pricePerMeetingMin: number | null;
    q: string | null;
    standards: Array<string> | null;
    startAfter: string | null;
    startAfterTime: number | null;
    startBefore: string | null;
    theme: string | null;
    time: string | null;
    timeOfDay: string | null;
    timeZone: string | null;
    uniqueLearningNeeds: string | null;
    userName: string | null;
    userUid: string | null;
  };
};

export type SavedSearchesQueryQueryVariables = Exact<{ [key: string]: never }>;

export type SavedSearchesQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    savedSearches: Array<{
      __typename?: "SavedSearch";
      uid: string;
      createdAt: any;
      filters: {
        __typename?: "SavedSearchFilters";
        adminTags: Array<string> | null;
        age: string | null;
        capacityMax: number | null;
        capacityMin: number | null;
        curriculums: Array<string> | null;
        delivery: string | null;
        dow: string | null;
        enabledBooleanFilters: string | null;
        endBy: string | null;
        endByTime: number | null;
        englishProficiencyLevel: EnglishProficiencyLevel | null;
        format: string | null;
        fundingPrograms: Array<string> | null;
        gradeLevel: string | null;
        hasFilledOutUniqueLearningNeeds: boolean | null;
        includeInProgressFixedLengthLiveFormat: boolean | null;
        includedWithMembership: boolean | null;
        languageOfInstruction: string | null;
        multiTermQuery: Array<string> | null;
        order: string | null;
        pricePerMeetingMax: number | null;
        pricePerMeetingMin: number | null;
        q: string | null;
        standards: Array<string> | null;
        startAfter: string | null;
        startAfterTime: number | null;
        startBefore: string | null;
        theme: string | null;
        time: string | null;
        timeOfDay: string | null;
        timeZone: string | null;
        uniqueLearningNeeds: string | null;
        userName: string | null;
        userUid: string | null;
      };
    }>;
  } | null;
};

export type DeleteSavedSearchMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type DeleteSavedSearchMutation = {
  __typename?: "Mutation";
  deleteSavedSearch: {
    __typename?: "DeleteSavedSearchPayload";
    deletedSavedSearchUid: string;
  };
};

export type SaveSearchMutationMutationVariables = Exact<{
  filters: SearchFilters;
}>;

export type SaveSearchMutationMutation = {
  __typename?: "Mutation";
  saveSearch: {
    __typename?: "SavedSearch";
    uid: string;
    createdAt: any;
    filters: {
      __typename?: "SavedSearchFilters";
      adminTags: Array<string> | null;
      age: string | null;
      capacityMax: number | null;
      capacityMin: number | null;
      curriculums: Array<string> | null;
      delivery: string | null;
      dow: string | null;
      enabledBooleanFilters: string | null;
      endBy: string | null;
      endByTime: number | null;
      englishProficiencyLevel: EnglishProficiencyLevel | null;
      format: string | null;
      fundingPrograms: Array<string> | null;
      gradeLevel: string | null;
      hasFilledOutUniqueLearningNeeds: boolean | null;
      includeInProgressFixedLengthLiveFormat: boolean | null;
      includedWithMembership: boolean | null;
      languageOfInstruction: string | null;
      multiTermQuery: Array<string> | null;
      order: string | null;
      pricePerMeetingMax: number | null;
      pricePerMeetingMin: number | null;
      q: string | null;
      standards: Array<string> | null;
      startAfter: string | null;
      startAfterTime: number | null;
      startBefore: string | null;
      theme: string | null;
      time: string | null;
      timeOfDay: string | null;
      timeZone: string | null;
      uniqueLearningNeeds: string | null;
      userName: string | null;
      userUid: string | null;
    };
  };
};

export type SearchActivityListingsByActivityUidsQueryVariables = Exact<{
  activityUids: Array<Scalars["ID"]> | Scalars["ID"];
  skipRating: Scalars["Boolean"];
}>;

export type SearchActivityListingsByActivityUidsQuery = {
  __typename?: "Query";
  listingsByActivityUids: Array<{
    __typename?: "Listing";
    insertionId: string | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      user_uid: string;
      title: string;
      url: string;
      path: string;
      summary: string | null;
      summaryTranslated: string | null;
      quickSummary: string | null;
      weekly_meetings: number | null;
      duration_weeks: number | null;
      is_ongoing_weekly: boolean;
      isClub: boolean;
      published_at: any | null;
      size_max: number | null;
      size_min: number | null;
      hasTeacherSchedule: boolean;
      allows_recurring_payment: boolean | null;
      averageStarRating?: number | null;
      reviewCount: number;
      age_min: number | null;
      age_max: number | null;
      duration_minutes: number | null;
      price_cents: number | null;
      priceCreditsPerMeeting: number | null;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      canEnroll: boolean;
      isIncludedWithMembership: boolean;
      isOneTime: boolean;
      titleTranslated: string | null;
      slug_id: string;
      subject: string | null;
      syllabus: {
        __typename?: "Syllabus";
        uid: string;
        lessons: Array<{ __typename?: "Lesson"; uid: string }>;
      } | null;
      clubSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        clubPostCount: number;
      } | null;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
      } | null;
      savedClassLists: Array<{
        __typename?: "SavedClassList";
        uid: string;
        lastAddedToAt: any | null;
      }>;
    };
    nextSection: {
      __typename?: "Section";
      uid: string;
      size_max: number | null;
      filledSpaceCount: number;
      start_time: any | null;
      end_time: any | null;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      leader_link: string | null;
      averageActivityStarRating: number | null;
      reviewCount: number;
      educatorTiers: Array<EducatorTier>;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    };
  }>;
};

export type ParentSearchSuggestionsQueryVariables = Exact<{
  query: Scalars["String"];
  ignore: Array<Scalars["String"]> | Scalars["String"];
  size?: InputMaybe<Scalars["Int"]>;
}>;

export type ParentSearchSuggestionsQuery = {
  __typename?: "Query";
  searchSuggestions: {
    __typename?: "SearchSuggestions";
    popularTermSuggestions: Array<{
      __typename?: "PopularTerms";
      uid: string;
      category: string;
      subCategory: string;
    }>;
    topicSuggestions: Array<{
      __typename?: "Topic";
      uid: string;
      label: string;
      category: string | null;
    }>;
    teacherSuggestions: Array<{
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      leader_link: string | null;
    }>;
  };
};

export type SearchListingsQueryVariables = Exact<{
  searchFilters: SearchFilters;
  offset?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  cursor?: InputMaybe<Scalars["String"]>;
  skipRating: Scalars["Boolean"];
  matchNames?: InputMaybe<Scalars["Boolean"]>;
  referrer?: InputMaybe<Scalars["String"]>;
  includeMatchingSections?: InputMaybe<Scalars["Boolean"]>;
  source?: InputMaybe<Scalars["Boolean"]>;
  anonymousId?: InputMaybe<Scalars["String"]>;
  searchUid?: InputMaybe<Scalars["String"]>;
  pageImpressionId?: InputMaybe<Scalars["String"]>;
  isFuzzySearchEnabled?: InputMaybe<Scalars["Boolean"]>;
  pageLocation?: InputMaybe<Scalars["String"]>;
  useCase?: InputMaybe<SearchUseCase>;
  disableAutoApplyFilterTypes?: InputMaybe<
    Array<InputMaybe<AutoAppliedFilterType>> | InputMaybe<AutoAppliedFilterType>
  >;
  learnerPlanGoalUid?: InputMaybe<Scalars["String"]>;
  withRecentReviews: Scalars["Boolean"];
}>;

export type SearchListingsQuery = {
  __typename?: "Query";
  searchListings: {
    __typename?: "SearchListingsConnection";
    cursor: string | null;
    total: number | null;
    searchUid: string;
    listings: Array<{
      __typename?: "Listing";
      isAvailable: boolean | null;
      isIncludedWithMembership: boolean | null;
      insertionId: string | null;
      sectionCount: number;
      openSectionCount: number;
      upcomingSectionCount: number;
      activity: {
        __typename?: "Activity";
        uid: string;
        user_uid: string;
        title: string;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        quickSummary: string | null;
        weekly_meetings: number | null;
        duration_weeks: number | null;
        is_ongoing_weekly: boolean;
        isClub: boolean;
        published_at: any | null;
        size_max: number | null;
        size_min: number | null;
        hasTeacherSchedule: boolean;
        allows_recurring_payment: boolean | null;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        canEnroll: boolean;
        isIncludedWithMembership: boolean;
        isOneTime: boolean;
        titleTranslated: string | null;
        slug_id: string;
        subject: string | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        recentReviews?: Array<{
          __typename?: "PublicReview";
          uid: string;
          activity_star_rating: number | null;
          details: {
            __typename?: "PublicReviewDetails";
            publicReview: string | null;
          } | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            publicName: string | null;
          };
        }>;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
            fileSize: number | null;
          };
        } | null;
        credentials: Array<{
          __typename?: "TeacherCredential";
          uid: string;
          degreeType: DegreeType | null;
          degreeSubject: DegreeSubject | null;
        }>;
      };
    }>;
    autoAppliedFilters: {
      __typename?: "AutoAppliedFilters";
      gradeLevels: Array<string> | null;
    } | null;
  };
};

export type SectionRibbon_SectionFragment = {
  __typename?: "Section";
  size_max: number | null;
  filledSpaceCount: number;
};

export type SectionRibbon_ActivityFragment = {
  __typename?: "Activity";
  clubSection: {
    __typename?: "Section";
    filledSpaceCount: number;
    clubPostCount: number;
  } | null;
};

export type SearchSelectedTeacherHeaderQueryVariables = Exact<{
  uid?: InputMaybe<Scalars["ID"]>;
}>;

export type SearchSelectedTeacherHeaderQuery = {
  __typename?: "Query";
  publicProfile: {
    __typename?: "PublicProfile";
    uid: string;
    leader: {
      __typename?: "Leader";
      reviewCount: number;
      averageActivityStarRating: number | null;
      educatorTiers: Array<EducatorTier>;
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      hasListings: boolean;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    } | null;
  } | null;
};

export type SectionTeaser_SectionFragment = {
  __typename?: "Section";
  uid: string;
  start_time: any | null;
  end_time: any | null;
  nextOngoingMeeting: {
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
  } | null;
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    isClub: boolean;
    weekly_meetings: number | null;
    duration_weeks: number | null;
    is_ongoing_weekly: boolean;
    hasTeacherSchedule: boolean;
    published_at: any | null;
  };
};

export type VerifySellerOrgPinMutationVariables = Exact<{
  sellerOrgUid: Scalars["ID"];
  pin: Scalars["String"];
}>;

export type VerifySellerOrgPinMutation = {
  __typename?: "Mutation";
  verifySellerOrgPin: { __typename?: "VerifyPinResult"; success: boolean };
};

export type ChangePinMutationVariables = Exact<{
  userUid: Scalars["ID"];
  sellerOrgUid: Scalars["ID"];
  token: Scalars["String"];
  pin?: InputMaybe<Scalars["String"]>;
}>;

export type ChangePinMutation = {
  __typename?: "Mutation";
  changePin: { __typename?: "ChangePinResult"; hasPinSet: boolean };
};

export type CreateSellerOrgPinMutationVariables = Exact<{
  sellerOrgUid: Scalars["ID"];
  pin: Scalars["String"];
}>;

export type CreateSellerOrgPinMutation = {
  __typename?: "Mutation";
  createSellerOrgPin: boolean;
};

export type ActivityMetaTags_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  slug_id: string;
  title: string;
  titleTranslated: string | null;
  summary: string | null;
  age_min: number | null;
  age_max: number | null;
  published_at: any | null;
  price_cents: number | null;
  averageStarRating: number | null;
  reviewCount: number;
  duration_minutes: number | null;
  is_ongoing_weekly: boolean;
  isClub: boolean;
  leader: {
    __typename?: "Leader";
    uid: string;
    name: string | null;
    leader_link: string | null;
  };
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type ActivityMetaTags_SectionFragment = {
  __typename?: "Section";
  uid: string;
  price_cents: number | null;
};

export type EmailPreviewQueryVariables = Exact<{
  activityUid?: InputMaybe<Scalars["ID"]>;
  slugId?: InputMaybe<Scalars["String"]>;
  sectionUid: Scalars["ID"];
  skipSection: Scalars["Boolean"];
}>;

export type EmailPreviewQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      reviewCount: number;
      averageActivityStarRating: number | null;
      hasListings: boolean;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    };
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
  };
  section?: {
    __typename?: "Section";
    filledSpaceCount: number;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    }>;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
  } | null;
};

export type SendActivityInviteEmailMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  recipientEmails: Scalars["String"];
  isEnrolled?: InputMaybe<Scalars["Boolean"]>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
  customMessage?: InputMaybe<Scalars["String"]>;
  campaignPrefix?: InputMaybe<Scalars["String"]>;
}>;

export type SendActivityInviteEmailMutation = {
  __typename?: "Mutation";
  sendActivityInviteEmail: boolean;
};

export type ShareContainer_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  slug_id: string;
  title: string;
  titleTranslated: string | null;
};

export type CreateSubscriptionCreditPurchaseMutationVariables = Exact<{
  numCredits: Scalars["Int"];
  priceCents: Scalars["Int"];
  creditValue: Scalars["Int"];
  taxCalculationId?: InputMaybe<Scalars["String"]>;
}>;

export type CreateSubscriptionCreditPurchaseMutation = {
  __typename?: "Mutation";
  createSubscriptionCreditPurchaseOrder: {
    __typename?: "OrderType";
    orderSlugId: string;
  };
};

export type UpdateSubscriptionMutationVariables = Exact<{
  selectedPackage: Scalars["String"];
  paymentMethod?: InputMaybe<Scalars["String"]>;
  pricingOffer?: InputMaybe<PricingOfferInput>;
  creditAccountCents?: InputMaybe<Scalars["Int"]>;
}>;

export type UpdateSubscriptionMutation = {
  __typename?: "Mutation";
  updateSubscription: {
    __typename?: "SubscriptionInformation";
    subscriptionId: string | null;
    packageName: string | null;
    numCredits: number | null;
  } | null;
};

export type ChooseAPlanEnrollmentsQueryQueryVariables = Exact<{
  start: Scalars["DateTime"];
  end: Scalars["DateTime"];
}>;

export type ChooseAPlanEnrollmentsQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    activeEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      price_cents: number | null;
      ongoingStartTime: any | null;
      service_fee_percentage: number;
      section: {
        __typename?: "Section";
        uid: string;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          hasTeacherSchedule: boolean;
        };
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          paidAt: any | null;
        }>;
      } | null;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        scheduleType: PaymentScheduleTypes;
        amountCents: number | null;
      } | null;
    } | null>;
  } | null;
};

export type UpdateCurrentUserDetailsMutationVariables = Exact<{
  details?: InputMaybe<UserDetailsInput>;
}>;

export type UpdateCurrentUserDetailsMutation = {
  __typename?: "Mutation";
  updateCurrentUser: {
    __typename?: "User";
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  };
};

export type ActivityCostQueryVariables = Exact<{
  uid?: InputMaybe<Scalars["ID"]>;
  slugId?: InputMaybe<Scalars["String"]>;
}>;

export type ActivityCostQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    priceCredits: number | null;
    isClub: boolean;
    is_ongoing_weekly: boolean;
    hasTeacherSchedule: boolean;
    duration_weeks: number | null;
    perWeeklyCourseCredits: number | null;
  };
};

export type PauseSubscriptionMutationVariables = Exact<{
  willResumeAt?: InputMaybe<Scalars["DateTime"]>;
}>;

export type PauseSubscriptionMutation = {
  __typename?: "Mutation";
  pauseSubscription: boolean;
};

export type ResumeSubscriptionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ResumeSubscriptionMutation = {
  __typename?: "Mutation";
  resumeSubscription: boolean;
};

export type AvailableSubscriptionPackagesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AvailableSubscriptionPackagesQuery = {
  __typename?: "Query";
  availableSubscriptionPackages: Array<{
    __typename?: "SubscriptionPackageInformation";
    uid: string;
    amountCents: number;
    numCredits: number;
    creditValue: number;
    savingsPercentage: number;
    savingsCents: number;
    classPerWeekAvg: number;
    numFreeCredits: number;
  }>;
};

export type UpcomingChargesQueryQueryVariables = Exact<{
  start: Scalars["DateTime"];
  end: Scalars["DateTime"];
  includeLearner: Scalars["Boolean"];
}>;

export type UpcomingChargesQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    activeEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      canUseEsaMembership: boolean;
      upcomingCharges: Array<{
        __typename?: "UpcomingCharge";
        date: any;
        priceCents: number;
        priceCredits: number;
      }>;
      payments: Array<{
        __typename?: "EnrollmentPayment";
        credit_account_type: string | null;
      }>;
      learner?: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
      } | null;
    } | null>;
  } | null;
};

export type OngoingEarningsReportQueryVariables = Exact<{
  excludeOrgTeachers?: InputMaybe<Scalars["Boolean"]>;
}>;

export type OngoingEarningsReportQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      currentUserIsOwner: boolean | null;
    } | null;
    leaderSections: Array<{
      __typename?: "Section";
      uid: string;
      paidAmount: number | null;
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        titleTranslated: string | null;
        price_cents: number | null;
        is_ongoing_weekly: boolean;
      };
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      payouts: Array<{
        __typename?: "Payout";
        uid: string | null;
        amount_cents: number | null;
        created_at: any | null;
        startTime: any | null;
        numberOfEnrollments: number | null;
      }>;
    }>;
  } | null;
};

export type EarningsReportNewQueryVariables = Exact<{
  excludeOrgTeachers?: InputMaybe<Scalars["Boolean"]>;
  minDate?: InputMaybe<Scalars["DateTime"]>;
  maxDate?: InputMaybe<Scalars["DateTime"]>;
}>;

export type EarningsReportNewQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      currentUserIsOwner: boolean | null;
    } | null;
    leaderSections: Array<{
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
      price_cents: number | null;
      paidAmount: number | null;
      standardPayoutCents: number;
      enrollments: Array<{ __typename?: "Enrollment"; uid: string }>;
      unclaimedGiftEnrollments: Array<{
        __typename?: "GiftEnrollment";
        uid: string;
      }>;
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        titleTranslated: string | null;
        price_cents: number | null;
      };
      leader: { __typename?: "Leader"; uid: string; name: string | null };
    }>;
  } | null;
};

export type CreateStripeConnectAccountMutationMutationVariables = Exact<{
  countryOfResidence?: InputMaybe<Scalars["String"]>;
}>;

export type CreateStripeConnectAccountMutationMutation = {
  __typename?: "Mutation";
  createStripeConnectAccount: string;
};

export type CreateStripeExpressLoginLinkMutationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreateStripeExpressLoginLinkMutationMutation = {
  __typename?: "Mutation";
  createStripeExpressLoginLink: string;
};

export type CreateStripeConnectedAccountSessionMutationMutationVariables =
  Exact<{
    componentType?: InputMaybe<StripeConnectedAccountSessionComponentType>;
  }>;

export type CreateStripeConnectedAccountSessionMutationMutation = {
  __typename?: "Mutation";
  createStripeConnectedAccountSession: {
    __typename?: "StripeConnectedAccountSessionResult";
    stripeConnectedAccountId: string;
    accountSessionClientSecret: string;
  };
};

export type CurrentUserFeedbackQueryQueryVariables = Exact<{
  offset: Scalars["Int"];
  limit: Scalars["Int"];
}>;

export type CurrentUserFeedbackQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    leader: {
      __typename?: "Leader";
      uid: string;
      reviewCount: number;
      reviews: Array<{
        __typename?: "Feedback";
        uid: string;
        publicReview: string | null;
        leaderFeedback: string | null;
        activity_star_rating: number | null;
        createdAt: any;
        section: {
          __typename?: "Section";
          uid: string;
          activity: {
            __typename?: "Activity";
            uid: string;
            title: string;
            titleTranslated: string | null;
          };
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          enrollments: Array<{
            __typename?: "Enrollment";
            uid: string;
            learner: {
              __typename?: "Learner";
              uid: string;
              name: string | null;
            } | null;
          }>;
        };
        parent: { __typename?: "Parent"; uid: string; name: string | null };
        learners: Array<{
          __typename?: "Learner";
          uid: string;
          name: string | null;
        }>;
      }>;
    } | null;
  } | null;
};

export type TeacherHeader_LeaderFragment = {
  __typename?: "Leader";
  uid: string;
  reviewCount: number;
  averageActivityStarRating: number | null;
  educatorTiers: Array<EducatorTier>;
  name: string | null;
  leader_link: string | null;
  photo: string | null;
  video: {
    __typename?: "Attachment";
    file: { __typename?: "File"; url: string; thumbUrl: string | null };
  } | null;
  details: { __typename?: "LeaderDetails"; headline: string | null };
};

export type MarketingPageQueryQueryVariables = Exact<{ [key: string]: never }>;

export type MarketingPageQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    activities: Array<{
      __typename?: "Activity";
      uid: string;
      title: string;
      subject: string | null;
    }>;
  } | null;
};

export type UpdateAbandonedCartAutoMessageSettingsMutationVariables = Exact<{
  abandoned_cart_auto_message_template?: InputMaybe<Scalars["String"]>;
  abandoned_cart_auto_message_is_on: Scalars["Boolean"];
}>;

export type UpdateAbandonedCartAutoMessageSettingsMutation = {
  __typename?: "Mutation";
  updateAbandonedCartAutoMessageSettings: {
    __typename?: "TeacherMarketingSettings";
    abandoned_cart_auto_message_is_on: boolean;
    abandoned_cart_auto_message_template: string | null;
    abandoned_cart_auto_message_default: string;
  };
};

export type UpdateTeacherMarketingSettingsMutationVariables = Exact<{
  uid?: InputMaybe<Scalars["ID"]>;
  ai_review_summary_is_on?: InputMaybe<Scalars["Boolean"]>;
  ai_meeting_summary_is_on?: InputMaybe<Scalars["Boolean"]>;
  ai_action_items_is_on?: InputMaybe<Scalars["Boolean"]>;
  abandoned_cart_auto_message_template?: InputMaybe<Scalars["String"]>;
  abandoned_cart_auto_message_is_on?: InputMaybe<Scalars["Boolean"]>;
  away_mode_enabled?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UpdateTeacherMarketingSettingsMutation = {
  __typename?: "Mutation";
  updateTeacherMarketingSettings: {
    __typename?: "TeacherMarketingSettings";
    uid: string;
    ai_review_summary_is_on: boolean;
    ai_meeting_summary_is_on: boolean;
    ai_action_items_is_on: boolean;
    abandoned_cart_auto_message_is_on: boolean;
    abandoned_cart_auto_message_template: string | null;
    abandoned_cart_auto_message_default: string;
    away_mode_enabled: boolean;
  };
};

export type TeacherMarketingSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TeacherMarketingSettingsQuery = {
  __typename?: "Query";
  teacherMarketingSettings: {
    __typename?: "TeacherMarketingSettings";
    uid: string;
    ai_review_summary_is_on: boolean;
    ai_meeting_summary_is_on: boolean;
    ai_action_items_is_on: boolean;
    abandoned_cart_auto_message_is_on: boolean;
    abandoned_cart_auto_message_template: string | null;
    abandoned_cart_auto_message_default: string;
    coupon_prefix: string | null;
    away_mode_enabled: boolean;
  } | null;
};

export type TeacherMessage_MessageFragment = {
  __typename?: "Message";
  uid: string;
  subject: string | null;
  content: string | null;
  created_at: any;
  sender: {
    __typename?: "Sender";
    uid: string;
    name: string | null;
    photo: string | null;
    headline: string | null;
    leader_link: string | null;
    timeZone: string | null;
  };
};

export type TeacherMessages_MessageThreadFragment = {
  __typename?: "MessageThread";
  uid: string;
  messages: Array<{
    __typename?: "Message";
    uid: string;
    created_at: any;
    subject: string | null;
    content: string | null;
    sender: {
      __typename?: "Sender";
      uid: string;
      name: string | null;
      photo: string | null;
      headline: string | null;
      leader_link: string | null;
      timeZone: string | null;
    };
  }>;
};

export type TeacherMetrics_UserFragment = {
  __typename?: "User";
  uid: string;
  followerCount: number;
  leader: {
    __typename?: "Leader";
    uid: string;
    metrics: {
      __typename?: "LeaderMetrics";
      activeSections: number;
      repurchaseRate: number | null;
      averageActivityStarRating: number | null;
      learnersTaught: number;
    };
    listings: Array<{
      __typename?: "Listing";
      activity: { __typename?: "Activity"; uid: string; canEnroll: boolean };
    }>;
  } | null;
  sellerOrg: {
    __typename?: "SellerOrg";
    uid: string;
    currentUserIsTeacher: boolean | null;
    currentUserIsOwner: boolean | null;
  } | null;
};

export type TeacherProfileCard_UserFragment = {
  __typename?: "User";
  uid: string;
  name: string | null;
  introduction: string | null;
  created_at: any;
  photo: string | null;
  leader_link: string | null;
};

export type TeacherPublicScheduleCalendar_MeetingFragment = {
  __typename?: "Meeting";
  uid: string;
  start_time: any;
  end_time: any;
  sectionSequenceNumber: number;
  section: {
    __typename?: "Section";
    uid: string;
    size_min: number | null;
    size_max: number | null;
    filledSpaceCount: number;
    deleted_at: any | null;
    canceled_at: any | null;
    published_at: any | null;
    start_time: any | null;
    end_time: any | null;
    ongoing_stopped_at: any | null;
    meetingCount: number;
    isBuyable: boolean;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    } | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      title: string;
      titleTranslated: string | null;
      weekly_meetings: number | null;
      is_ongoing_weekly: boolean;
      duration_weeks: number | null;
      duration_minutes: number | null;
    };
  };
};

export type TeacherPublicScheduleCalendar_SectionFragment = {
  __typename?: "Section";
  uid: string;
  start_time: any | null;
  end_time: any | null;
  size_min: number | null;
  size_max: number | null;
  filledSpaceCount: number;
  ongoing_stopped_at: any | null;
  deleted_at: any | null;
  canceled_at: any | null;
  published_at: any | null;
  isBuyable: boolean;
  activity: {
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    title: string;
    titleTranslated: string | null;
    weekly_meetings: number | null;
    is_ongoing_weekly: boolean;
    duration_weeks: number | null;
    duration_minutes: number | null;
  };
};

export type TeacherPublicScheduleCalendarQueryVariables = Exact<{
  uid?: InputMaybe<Scalars["ID"]>;
  startAfter: Scalars["DateTime"];
  startBefore: Scalars["DateTime"];
}>;

export type TeacherPublicScheduleCalendarQuery = {
  __typename?: "Query";
  publicProfile: {
    __typename?: "PublicProfile";
    uid: string;
    leader: {
      __typename?: "Leader";
      uid: string;
      flexSections: {
        __typename?: "SectionConnection";
        edges: Array<{
          __typename?: "SectionEdge";
          node: {
            __typename?: "Section";
            uid: string;
            start_time: any | null;
            end_time: any | null;
            size_min: number | null;
            size_max: number | null;
            filledSpaceCount: number;
            ongoing_stopped_at: any | null;
            deleted_at: any | null;
            canceled_at: any | null;
            published_at: any | null;
            isBuyable: boolean;
            activity: {
              __typename?: "Activity";
              uid: string;
              slug_id: string;
              title: string;
              titleTranslated: string | null;
              weekly_meetings: number | null;
              is_ongoing_weekly: boolean;
              duration_weeks: number | null;
              duration_minutes: number | null;
            };
          };
        }>;
      };
      meetings: {
        __typename?: "MeetingConnection";
        edges: Array<{
          __typename?: "MeetingEdge";
          node: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            sectionSequenceNumber: number;
            section: {
              __typename?: "Section";
              uid: string;
              size_min: number | null;
              size_max: number | null;
              filledSpaceCount: number;
              deleted_at: any | null;
              canceled_at: any | null;
              published_at: any | null;
              start_time: any | null;
              end_time: any | null;
              ongoing_stopped_at: any | null;
              meetingCount: number;
              isBuyable: boolean;
              nextOngoingMeeting: {
                __typename?: "Meeting";
                uid: string;
                start_time: any;
              } | null;
              activity: {
                __typename?: "Activity";
                uid: string;
                slug_id: string;
                title: string;
                titleTranslated: string | null;
                weekly_meetings: number | null;
                is_ongoing_weekly: boolean;
                duration_weeks: number | null;
                duration_minutes: number | null;
              };
            };
          };
        }>;
      };
    } | null;
  } | null;
};

export type CreateSectionWithMeetingsMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  suggestedMeetings: Array<MeetingSuggestionInput> | MeetingSuggestionInput;
  makePublic: Scalars["Boolean"];
}>;

export type CreateSectionWithMeetingsMutation = {
  __typename?: "Mutation";
  createSectionWithMeetings: { __typename?: "Section"; uid: string };
};

export type TeacherStatsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type TeacherStatsQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    publicSectionCount: number;
    leader: {
      __typename?: "Leader";
      uid: string;
      metrics: {
        __typename?: "LeaderMetrics";
        hoursTaught: number;
        learnersTaught: number;
        lifetimeEarningsCents: number;
        monthlySummary: Array<{
          __typename?: "MonthlyLeaderMetric";
          month: string;
          students: number;
          payCents: number;
          hours: number;
        } | null>;
        classBreakdown: Array<{
          __typename?: "ActivityMetric";
          activityUid: string | null;
          activityTitle: string;
          classFormat: ClassFormat;
          sectionsDuringTimeFrame: number;
          uniqueStudents: number;
          hoursTaught: number;
          paidOutCents: number;
          reenrollmentPercentage: number;
          averageStarRating: number;
          numReviews: number;
          numSaves: number;
          numViewers90: number | null;
          numEnrollmentsUnwithdrawn90: number | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type GetEducatorActivityInsightsDownloadUrlQueryVariables = Exact<{
  period: EducatorInsightsDownloadPeriod;
}>;

export type GetEducatorActivityInsightsDownloadUrlQuery = {
  __typename?: "Query";
  getEducatorActivityInsightsDownloadUrl: string;
};

export type GetEducatorInsightsDownloadUrlQueryVariables = Exact<{
  period: EducatorInsightsDownloadPeriod;
}>;

export type GetEducatorInsightsDownloadUrlQuery = {
  __typename?: "Query";
  getEducatorInsightsDownloadUrl: string;
};

export type GetEducatorPayoutInsightsDownloadBoundsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetEducatorPayoutInsightsDownloadBoundsQuery = {
  __typename?: "Query";
  getEducatorPayoutInsightsDownloadBounds: {
    __typename?: "EducatorPayoutInsightsDownloadBounds";
    firstYear: number;
    firstMonth: number;
  };
};

export type GetEducatorPayoutInsightsDownloadUrlQueryVariables = Exact<{
  input: EducatorPayoutInsightsDownloadInput;
}>;

export type GetEducatorPayoutInsightsDownloadUrlQuery = {
  __typename?: "Query";
  getEducatorPayoutInsightsDownloadUrl: string;
};

export type GetPayoutsCsvUrlQueryVariables = Exact<{
  input: GetPayoutsCsvUrlInput;
}>;

export type GetPayoutsCsvUrlQuery = {
  __typename?: "Query";
  getPayoutsCsvUrl: string;
};

export type TeacherStatsOmniEmbedQueryQueryVariables = Exact<{
  dashboardId: Scalars["String"];
}>;

export type TeacherStatsOmniEmbedQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    omniEmbedDashboardUrl: string | null;
  } | null;
};

export type TeacherTagsQueryVariables = Exact<{ [key: string]: never }>;

export type TeacherTagsQuery = {
  __typename?: "Query";
  teacherTags: {
    __typename?: "TeacherTagsConnection";
    edges: Array<{
      __typename?: "TeacherTagEdge";
      node: { __typename?: "Tag"; uid: string; key: string; value: string };
    }>;
  };
};

export type AssignTeacherTagsMutationMutationVariables = Exact<{
  userUid: Scalars["ID"];
  tags: Array<TeacherTagInput> | TeacherTagInput;
}>;

export type AssignTeacherTagsMutationMutation = {
  __typename?: "Mutation";
  assignTeacherTags: {
    __typename?: "TeacherTagsConnection";
    edges: Array<{
      __typename?: "TeacherTagEdge";
      node: { __typename?: "Tag"; uid: string; key: string; value: string };
    }>;
  };
};

export type TeacherTags_LeaderFragment = {
  __typename?: "Leader";
  uid: string;
  tags: {
    __typename?: "TeacherTagsConnection";
    edges: Array<{
      __typename?: "TeacherTagEdge";
      node: { __typename?: "Tag"; uid: string; key: string; value: string };
    }>;
  };
};

export type ClassWalletCreditTransactionListingFragment = {
  __typename?: "ClassWalletTransactionListing";
  id: string;
  pendingOrderPayments: Array<{
    __typename?: "PendingOrderPayment";
    uid: string;
    amount_cents: number | null;
    exchange_rate: number | null;
    currency_code: string | null;
    coupon_code_uid: string | null;
  }> | null;
  creditPurchase: {
    __typename?: "CreditPurchase";
    amount_cents: number;
    amount_granted_cents: number;
    amount_granted_credits: number | null;
    learner: { __typename?: "Learner"; name: string | null } | null;
  } | null;
};

export type ClassWalletEnrollmentTransactionListingFragment = {
  __typename?: "ClassWalletTransactionListing";
  id: string;
  enrollments: Array<
    | {
        __typename?: "Enrollment";
        uid: string;
        purchasedAsGift: boolean;
        confirmedAt: any | null;
        withdrawnAt: any | null;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        } | null;
        section: { __typename?: "Section"; uid: string } | null;
      }
    | {
        __typename?: "GiftEnrollment";
        uid: string;
        purchasedAsGift: boolean;
        confirmedAt: any | null;
        withdrawnAt: any | null;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        } | null;
        section: { __typename?: "Section"; uid: string };
      }
  > | null;
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    titleTranslated: string | null;
    is_ongoing_weekly: boolean;
  } | null;
  pendingOrderPayments: Array<{
    __typename?: "PendingOrderPayment";
    uid: string;
    amount_cents: number | null;
    exchange_rate: number | null;
    currency_code: string | null;
    coupon_code_uid: string | null;
  }> | null;
};

export type CreditOfferTransactionListingFragment = {
  __typename?: "CreditTransactionListing";
  creditTransaction: {
    __typename?: "CreditTransaction";
    uid: string;
    amount_cents: number;
    amount_credits: number;
    transaction_type: CreditTransactionType;
  };
};

export type CreditPurchaseTransactionListingFragment = {
  __typename?: "OrderTransactionListing";
  payments: Array<{
    __typename?: "OrderPayment";
    uid: string;
    amount_cents: number;
    amount_credits: number | null;
    tender_type: string | null;
  }> | null;
  creditPurchase: {
    __typename?: "CreditPurchase";
    amount_cents: number;
    amount_granted_cents: number;
    amount_granted_credits: number | null;
    creditAccount: {
      __typename?: "CreditAccount";
      accountType: CreditAccountType | null;
    } | null;
  } | null;
};

export type EnrollmentTransactionListingFragment = {
  __typename?: "OrderTransactionListing";
  donation: {
    __typename?: "Donation";
    uid: string;
    amountCents: number;
    payments: Array<{
      __typename?: "OrderPayment";
      amount_cents: number;
    }> | null;
  } | null;
  payments: Array<{
    __typename?: "OrderPayment";
    uid: string;
    amount_cents: number;
    amount_credits: number | null;
    tender_type: string | null;
  }> | null;
  enrollments: Array<
    | {
        __typename?: "Enrollment";
        uid: string;
        purchasedAsGift: boolean;
        confirmedAt: any | null;
        withdrawnAt: any | null;
        hasPaymentSchedule: boolean;
        orderSlugId: string | null;
        ongoingStartTime: any | null;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        } | null;
        section: {
          __typename?: "Section";
          uid: string;
          start_time: any | null;
          activity: {
            __typename?: "Activity";
            uid: string;
            title: string;
            titleTranslated: string | null;
            is_ongoing_weekly: boolean;
            duration_minutes: number | null;
            leader: { __typename?: "Leader"; uid: string; name: string | null };
          };
        } | null;
        payments: Array<{
          __typename?: "EnrollmentPayment";
          amount_cents: number | null;
          order_slug_id: string | null;
          credit_transaction_uid: string | null;
          start_time: any | null;
          end_time: any | null;
          last4: string | null;
          paid_at: any | null;
          stripe_charge_id: string | null;
          refunds: Array<{
            __typename?: "EnrollmentPaymentRefund";
            uid: string;
            amount_cents: number;
          }>;
        }>;
      }
    | {
        __typename?: "GiftEnrollment";
        uid: string;
        purchasedAsGift: boolean;
        confirmedAt: any | null;
        withdrawnAt: any | null;
        hasPaymentSchedule: boolean;
        orderSlugId: string | null;
        ongoingStartTime: any | null;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        } | null;
        section: {
          __typename?: "Section";
          uid: string;
          start_time: any | null;
          activity: {
            __typename?: "Activity";
            uid: string;
            title: string;
            titleTranslated: string | null;
            is_ongoing_weekly: boolean;
            duration_minutes: number | null;
            leader: { __typename?: "Leader"; uid: string; name: string | null };
          };
        };
        payments: Array<{
          __typename?: "EnrollmentPayment";
          amount_cents: number | null;
          order_slug_id: string | null;
          credit_transaction_uid: string | null;
          start_time: any | null;
          end_time: any | null;
          last4: string | null;
          paid_at: any | null;
          stripe_charge_id: string | null;
          refunds: Array<{
            __typename?: "EnrollmentPaymentRefund";
            uid: string;
            amount_cents: number;
          }>;
        }>;
      }
  > | null;
  enrollmentPayments: Array<{
    __typename?: "EnrollmentPayment";
    amount_cents: number | null;
    exchange_rate: number | null;
    currency_code: CurrencyCode | null;
    credit_transaction_uid: string | null;
    pricing_offer_uid: string | null;
    esa_order_id: string | null;
    start_time: any | null;
    end_time: any | null;
    service_fee_percentage: number | null;
    refunds: Array<{
      __typename?: "EnrollmentPaymentRefund";
      uid: string;
      amount_cents: number;
      amount_credits: number | null;
      addOutschoolCreditTransaction: {
        __typename?: "CreditTransaction";
        uid: string;
        amount_cents: number;
        expiresAt: any | null;
        unspentCents: number | null;
      } | null;
    }>;
    couponCode: { __typename?: "CouponCode"; uid: string } | null;
  }> | null;
};

export type EsaMembershipCreditDepositTransactionListingFragment = {
  __typename?: "CreditTransactionListing";
  creditTransaction: {
    __typename?: "CreditTransaction";
    amount_cents: number;
    transaction_type: CreditTransactionType;
    amount_credits: number;
  };
  creditPurchase: {
    __typename?: "CreditPurchase";
    amount_cents: number;
    amount_granted_cents: number;
    amount_granted_credits: number | null;
    learner: { __typename?: "Learner"; name: string | null } | null;
  } | null;
};

export type GiftCardPurchaseTransactionListingFragment = {
  __typename?: "OrderTransactionListing";
  giftCard: {
    __typename?: "GiftCard";
    uid: string;
    recipientName: string;
    note: string | null;
    payments: Array<{ __typename?: "OrderPayment"; amount_cents: number }>;
  } | null;
};

export type GiftCardRedemptionTransactionListingFragment = {
  __typename?: "CreditTransactionListing";
  creditTransaction: {
    __typename?: "CreditTransaction";
    uid: string;
    amount_cents: number;
    transaction_type: CreditTransactionType;
    referralTransactionType: CreditReferralTransactionType | null;
    expiresAt: any | null;
    unspentCents: number | null;
    redeemedGiftCard: {
      __typename?: "GiftCard";
      purchaserName: string;
      note: string | null;
      redemptionCode: string | null;
    } | null;
  };
};

export type LearnerAllowancePaymentTransactionListingFragment = {
  __typename?: "OrderTransactionListing";
  learnerAllowancePayments: Array<{
    __typename?: "LearnerAllowancePayment";
    uid: string;
    learnerName: string | null;
    confirmedAt: any | null;
    amountCents: number | null;
    isRecurringPayment: boolean | null;
  }> | null;
};

export type LearnerAllowanceWithdrawalTransactionListingFragment = {
  __typename?: "CreditTransactionListing";
  creditTransaction: {
    __typename?: "CreditTransaction";
    uid: string;
    transaction_type: CreditTransactionType;
    amount_cents: number;
    referralTransactionType: CreditReferralTransactionType | null;
    expiresAt: any | null;
    unspentCents: number | null;
    referredUser: { __typename?: "User"; name: string | null } | null;
    referringUser: { __typename?: "User"; name: string | null } | null;
  };
};

export type ReferralTransactionListingFragment = {
  __typename?: "CreditTransactionListing";
  creditTransaction: {
    __typename?: "CreditTransaction";
    uid: string;
    amount_cents: number;
    transaction_type: CreditTransactionType;
    referralTransactionType: CreditReferralTransactionType | null;
    expiresAt: any | null;
    unspentCents: number | null;
    referredUser: { __typename?: "User"; name: string | null } | null;
    referringUser: { __typename?: "User"; name: string | null } | null;
  };
};

export type SubscriptionCreditDepositTransactionListingFragment = {
  __typename?: "CreditTransactionListing";
  creditTransaction: {
    __typename?: "CreditTransaction";
    transaction_type: CreditTransactionType;
    amount_credits: number;
  };
  subscriptionInvoice: {
    __typename?: "SubscriptionInvoice";
    period_start: any;
    period_end: any;
    amount_paid: number;
    currency_code: string;
    invoice_url: string | null;
    wasRefunded: boolean | null;
  } | null;
};

export type OrderTransactionListingFragmentFragment = {
  __typename?: "OrderTransactionListing";
  giftCard: {
    __typename?: "GiftCard";
    uid: string;
    recipientName: string;
    note: string | null;
    payments: Array<{ __typename?: "OrderPayment"; amount_cents: number }>;
  } | null;
  donation: {
    __typename?: "Donation";
    uid: string;
    amountCents: number;
    payments: Array<{
      __typename?: "OrderPayment";
      amount_cents: number;
    }> | null;
  } | null;
  payments: Array<{
    __typename?: "OrderPayment";
    uid: string;
    amount_cents: number;
    amount_credits: number | null;
    tender_type: string | null;
  }> | null;
  enrollments: Array<
    | {
        __typename?: "Enrollment";
        uid: string;
        purchasedAsGift: boolean;
        confirmedAt: any | null;
        withdrawnAt: any | null;
        hasPaymentSchedule: boolean;
        orderSlugId: string | null;
        ongoingStartTime: any | null;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        } | null;
        section: {
          __typename?: "Section";
          uid: string;
          start_time: any | null;
          activity: {
            __typename?: "Activity";
            uid: string;
            title: string;
            titleTranslated: string | null;
            is_ongoing_weekly: boolean;
            duration_minutes: number | null;
            leader: { __typename?: "Leader"; uid: string; name: string | null };
          };
        } | null;
        payments: Array<{
          __typename?: "EnrollmentPayment";
          amount_cents: number | null;
          order_slug_id: string | null;
          credit_transaction_uid: string | null;
          start_time: any | null;
          end_time: any | null;
          last4: string | null;
          paid_at: any | null;
          stripe_charge_id: string | null;
          refunds: Array<{
            __typename?: "EnrollmentPaymentRefund";
            uid: string;
            amount_cents: number;
          }>;
        }>;
      }
    | {
        __typename?: "GiftEnrollment";
        uid: string;
        purchasedAsGift: boolean;
        confirmedAt: any | null;
        withdrawnAt: any | null;
        hasPaymentSchedule: boolean;
        orderSlugId: string | null;
        ongoingStartTime: any | null;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        } | null;
        section: {
          __typename?: "Section";
          uid: string;
          start_time: any | null;
          activity: {
            __typename?: "Activity";
            uid: string;
            title: string;
            titleTranslated: string | null;
            is_ongoing_weekly: boolean;
            duration_minutes: number | null;
            leader: { __typename?: "Leader"; uid: string; name: string | null };
          };
        };
        payments: Array<{
          __typename?: "EnrollmentPayment";
          amount_cents: number | null;
          order_slug_id: string | null;
          credit_transaction_uid: string | null;
          start_time: any | null;
          end_time: any | null;
          last4: string | null;
          paid_at: any | null;
          stripe_charge_id: string | null;
          refunds: Array<{
            __typename?: "EnrollmentPaymentRefund";
            uid: string;
            amount_cents: number;
          }>;
        }>;
      }
  > | null;
  enrollmentPayments: Array<{
    __typename?: "EnrollmentPayment";
    amount_cents: number | null;
    exchange_rate: number | null;
    currency_code: CurrencyCode | null;
    credit_transaction_uid: string | null;
    pricing_offer_uid: string | null;
    esa_order_id: string | null;
    start_time: any | null;
    end_time: any | null;
    service_fee_percentage: number | null;
    refunds: Array<{
      __typename?: "EnrollmentPaymentRefund";
      uid: string;
      amount_cents: number;
      amount_credits: number | null;
      addOutschoolCreditTransaction: {
        __typename?: "CreditTransaction";
        uid: string;
        amount_cents: number;
        expiresAt: any | null;
        unspentCents: number | null;
      } | null;
    }>;
    couponCode: { __typename?: "CouponCode"; uid: string } | null;
  }> | null;
  learnerAllowancePayments: Array<{
    __typename?: "LearnerAllowancePayment";
    uid: string;
    learnerName: string | null;
    confirmedAt: any | null;
    amountCents: number | null;
    isRecurringPayment: boolean | null;
  }> | null;
  creditPurchase: {
    __typename?: "CreditPurchase";
    amount_cents: number;
    amount_granted_cents: number;
    amount_granted_credits: number | null;
    creditAccount: {
      __typename?: "CreditAccount";
      accountType: CreditAccountType | null;
    } | null;
  } | null;
};

export type CreditTransactionListingFragmentFragment = {
  __typename?: "CreditTransactionListing";
  creditTransaction: {
    __typename?: "CreditTransaction";
    uid: string;
    amount_cents: number;
    transaction_type: CreditTransactionType;
    referralTransactionType: CreditReferralTransactionType | null;
    expiresAt: any | null;
    unspentCents: number | null;
    admin_note: string | null;
    amount_credits: number;
    redeemedGiftCard: {
      __typename?: "GiftCard";
      purchaserName: string;
      note: string | null;
      redemptionCode: string | null;
    } | null;
    referredUser: { __typename?: "User"; name: string | null } | null;
    referringUser: { __typename?: "User"; name: string | null } | null;
  };
  subscriptionInvoice: {
    __typename?: "SubscriptionInvoice";
    period_start: any;
    period_end: any;
    amount_paid: number;
    currency_code: string;
    invoice_url: string | null;
    wasRefunded: boolean | null;
  } | null;
  creditPurchase: {
    __typename?: "CreditPurchase";
    amount_cents: number;
    amount_granted_cents: number;
    amount_granted_credits: number | null;
    learner: { __typename?: "Learner"; name: string | null } | null;
  } | null;
};

export type ClassWalletTransactionListingFragmentFragment = {
  __typename?: "ClassWalletTransactionListing";
  id: string;
  enrollments: Array<
    | {
        __typename?: "Enrollment";
        uid: string;
        purchasedAsGift: boolean;
        confirmedAt: any | null;
        withdrawnAt: any | null;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        } | null;
        section: { __typename?: "Section"; uid: string } | null;
      }
    | {
        __typename?: "GiftEnrollment";
        uid: string;
        purchasedAsGift: boolean;
        confirmedAt: any | null;
        withdrawnAt: any | null;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        } | null;
        section: { __typename?: "Section"; uid: string };
      }
  > | null;
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    titleTranslated: string | null;
    is_ongoing_weekly: boolean;
  } | null;
  pendingOrderPayments: Array<{
    __typename?: "PendingOrderPayment";
    uid: string;
    amount_cents: number | null;
    exchange_rate: number | null;
    currency_code: string | null;
    coupon_code_uid: string | null;
  }> | null;
  creditPurchase: {
    __typename?: "CreditPurchase";
    amount_cents: number;
    amount_granted_cents: number;
    amount_granted_credits: number | null;
    learner: { __typename?: "Learner"; name: string | null } | null;
  } | null;
};

export type TransactionListingsQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  learnerUid?: InputMaybe<Scalars["String"]>;
}>;

export type TransactionListingsQuery = {
  __typename?: "Query";
  transactionListings: {
    __typename?: "TransactionListings";
    totalCount: number;
    data: Array<
      | {
          __typename?: "ClassWalletTransactionListing";
          id: string;
          date: any;
          type: TransactionType;
          enrollments: Array<
            | {
                __typename?: "Enrollment";
                uid: string;
                purchasedAsGift: boolean;
                confirmedAt: any | null;
                withdrawnAt: any | null;
                learner: {
                  __typename?: "Learner";
                  uid: string;
                  name: string | null;
                } | null;
                section: { __typename?: "Section"; uid: string } | null;
              }
            | {
                __typename?: "GiftEnrollment";
                uid: string;
                purchasedAsGift: boolean;
                confirmedAt: any | null;
                withdrawnAt: any | null;
                learner: {
                  __typename?: "Learner";
                  uid: string;
                  name: string | null;
                } | null;
                section: { __typename?: "Section"; uid: string };
              }
          > | null;
          activity: {
            __typename?: "Activity";
            uid: string;
            title: string;
            titleTranslated: string | null;
            is_ongoing_weekly: boolean;
          } | null;
          pendingOrderPayments: Array<{
            __typename?: "PendingOrderPayment";
            uid: string;
            amount_cents: number | null;
            exchange_rate: number | null;
            currency_code: string | null;
            coupon_code_uid: string | null;
          }> | null;
          creditPurchase: {
            __typename?: "CreditPurchase";
            amount_cents: number;
            amount_granted_cents: number;
            amount_granted_credits: number | null;
            learner: { __typename?: "Learner"; name: string | null } | null;
          } | null;
        }
      | {
          __typename?: "CreditTransactionListing";
          id: string;
          date: any;
          type: TransactionType;
          creditTransaction: {
            __typename?: "CreditTransaction";
            uid: string;
            amount_cents: number;
            transaction_type: CreditTransactionType;
            referralTransactionType: CreditReferralTransactionType | null;
            expiresAt: any | null;
            unspentCents: number | null;
            admin_note: string | null;
            amount_credits: number;
            redeemedGiftCard: {
              __typename?: "GiftCard";
              purchaserName: string;
              note: string | null;
              redemptionCode: string | null;
            } | null;
            referredUser: { __typename?: "User"; name: string | null } | null;
            referringUser: { __typename?: "User"; name: string | null } | null;
          };
          subscriptionInvoice: {
            __typename?: "SubscriptionInvoice";
            period_start: any;
            period_end: any;
            amount_paid: number;
            currency_code: string;
            invoice_url: string | null;
            wasRefunded: boolean | null;
          } | null;
          creditPurchase: {
            __typename?: "CreditPurchase";
            amount_cents: number;
            amount_granted_cents: number;
            amount_granted_credits: number | null;
            learner: { __typename?: "Learner"; name: string | null } | null;
          } | null;
        }
      | {
          __typename?: "OrderTransactionListing";
          id: string;
          date: any;
          type: TransactionType;
          giftCard: {
            __typename?: "GiftCard";
            uid: string;
            recipientName: string;
            note: string | null;
            payments: Array<{
              __typename?: "OrderPayment";
              amount_cents: number;
            }>;
          } | null;
          donation: {
            __typename?: "Donation";
            uid: string;
            amountCents: number;
            payments: Array<{
              __typename?: "OrderPayment";
              amount_cents: number;
            }> | null;
          } | null;
          payments: Array<{
            __typename?: "OrderPayment";
            uid: string;
            amount_cents: number;
            amount_credits: number | null;
            tender_type: string | null;
          }> | null;
          enrollments: Array<
            | {
                __typename?: "Enrollment";
                uid: string;
                purchasedAsGift: boolean;
                confirmedAt: any | null;
                withdrawnAt: any | null;
                hasPaymentSchedule: boolean;
                orderSlugId: string | null;
                ongoingStartTime: any | null;
                learner: {
                  __typename?: "Learner";
                  uid: string;
                  name: string | null;
                } | null;
                section: {
                  __typename?: "Section";
                  uid: string;
                  start_time: any | null;
                  activity: {
                    __typename?: "Activity";
                    uid: string;
                    title: string;
                    titleTranslated: string | null;
                    is_ongoing_weekly: boolean;
                    duration_minutes: number | null;
                    leader: {
                      __typename?: "Leader";
                      uid: string;
                      name: string | null;
                    };
                  };
                } | null;
                payments: Array<{
                  __typename?: "EnrollmentPayment";
                  amount_cents: number | null;
                  order_slug_id: string | null;
                  credit_transaction_uid: string | null;
                  start_time: any | null;
                  end_time: any | null;
                  last4: string | null;
                  paid_at: any | null;
                  stripe_charge_id: string | null;
                  refunds: Array<{
                    __typename?: "EnrollmentPaymentRefund";
                    uid: string;
                    amount_cents: number;
                  }>;
                }>;
              }
            | {
                __typename?: "GiftEnrollment";
                uid: string;
                purchasedAsGift: boolean;
                confirmedAt: any | null;
                withdrawnAt: any | null;
                hasPaymentSchedule: boolean;
                orderSlugId: string | null;
                ongoingStartTime: any | null;
                learner: {
                  __typename?: "Learner";
                  uid: string;
                  name: string | null;
                } | null;
                section: {
                  __typename?: "Section";
                  uid: string;
                  start_time: any | null;
                  activity: {
                    __typename?: "Activity";
                    uid: string;
                    title: string;
                    titleTranslated: string | null;
                    is_ongoing_weekly: boolean;
                    duration_minutes: number | null;
                    leader: {
                      __typename?: "Leader";
                      uid: string;
                      name: string | null;
                    };
                  };
                };
                payments: Array<{
                  __typename?: "EnrollmentPayment";
                  amount_cents: number | null;
                  order_slug_id: string | null;
                  credit_transaction_uid: string | null;
                  start_time: any | null;
                  end_time: any | null;
                  last4: string | null;
                  paid_at: any | null;
                  stripe_charge_id: string | null;
                  refunds: Array<{
                    __typename?: "EnrollmentPaymentRefund";
                    uid: string;
                    amount_cents: number;
                  }>;
                }>;
              }
          > | null;
          enrollmentPayments: Array<{
            __typename?: "EnrollmentPayment";
            amount_cents: number | null;
            exchange_rate: number | null;
            currency_code: CurrencyCode | null;
            credit_transaction_uid: string | null;
            pricing_offer_uid: string | null;
            esa_order_id: string | null;
            start_time: any | null;
            end_time: any | null;
            service_fee_percentage: number | null;
            refunds: Array<{
              __typename?: "EnrollmentPaymentRefund";
              uid: string;
              amount_cents: number;
              amount_credits: number | null;
              addOutschoolCreditTransaction: {
                __typename?: "CreditTransaction";
                uid: string;
                amount_cents: number;
                expiresAt: any | null;
                unspentCents: number | null;
              } | null;
            }>;
            couponCode: { __typename?: "CouponCode"; uid: string } | null;
          }> | null;
          learnerAllowancePayments: Array<{
            __typename?: "LearnerAllowancePayment";
            uid: string;
            learnerName: string | null;
            confirmedAt: any | null;
            amountCents: number | null;
            isRecurringPayment: boolean | null;
          }> | null;
          creditPurchase: {
            __typename?: "CreditPurchase";
            amount_cents: number;
            amount_granted_cents: number;
            amount_granted_credits: number | null;
            creditAccount: {
              __typename?: "CreditAccount";
              accountType: CreditAccountType | null;
            } | null;
          } | null;
        }
    >;
  };
};

export type UrbanSitterCreditTransactionListingFragment = {
  __typename?: "CreditTransactionListing";
  creditTransaction: {
    __typename?: "CreditTransaction";
    uid: string;
    amount_cents: number;
    transaction_type: CreditTransactionType;
    expiresAt: any | null;
    unspentCents: number | null;
  };
};

export type VoucherTransactionListingFragment = {
  __typename?: "CreditTransactionListing";
  creditTransaction: {
    __typename?: "CreditTransaction";
    uid: string;
    amount_cents: number;
    transaction_type: CreditTransactionType;
    admin_note: string | null;
    expiresAt: any | null;
    unspentCents: number | null;
  };
};

export type TutorVideoCarouselQueryVariables = Exact<{ [key: string]: never }>;

export type TutorVideoCarouselQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    popularTutorListings: Array<{
      __typename?: "Listing";
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        video: {
          __typename?: "Attachment";
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: { __typename?: "File"; url: string; thumbUrl: string | null };
        } | null;
      };
    }>;
  };
};

export type CategoryPageGradeQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CategoryPageGradeQueryQuery = {
  __typename?: "Query";
  categoryPages: Array<{
    __typename?: "CategoryPage";
    nameTitleCased: string;
    basePath: string;
    slug: string;
  }> | null;
};

export type FeaturedTutorsQueryVariables = Exact<{
  activityFormat?: InputMaybe<ClassFormat>;
}>;

export type FeaturedTutorsQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    popularTeachers: Array<{
      __typename?: "Leader";
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      reviewCount: number;
      averageActivityStarRating: number | null;
      hasListings: boolean;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    }> | null;
  };
};

export type TutoringRelatedCategoriesQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TutoringRelatedCategoriesQueryQuery = {
  __typename?: "Query";
  categoryPage: {
    __typename?: "CategoryPage";
    related: Array<{
      __typename?: "CategoryPage";
      nameTitleCased: string;
      slug: string;
      basePath: string;
    } | null> | null;
    children: Array<{
      __typename?: "CategoryPage";
      nameTitleCased: string;
      slug: string;
      basePath: string;
    } | null> | null;
  } | null;
};

export type TeacherVideoModal_TeacherFragment = {
  __typename?: "Leader";
  uid: string;
  name: string | null;
  photo: string | null;
  leader_link: string | null;
  video: {
    __typename?: "Attachment";
    fileUrl: string;
    videoThumbnailUrl: string | null;
    file: { __typename?: "File"; url: string; thumbUrl: string | null };
  } | null;
};

export type Dashboard_EnrollmentsSummary_ByUserFragment = {
  __typename?: "PricingOfferEnrollmentsSummary";
  byUser: Array<{
    __typename?: "PricingOffersSummaryByUser";
    name: string;
    email: string;
    secondaryEmail: string | null;
    totalLimit: number | null;
    totalSpend: number;
    totalEnrollments: number;
    totalLearnerMinutes: number;
  } | null>;
};

export type Dashboard_EnrollmentsSummaryFragment = {
  __typename?: "PricingOfferEnrollmentsSummary";
  learnerCount: number;
  enrollmentCount: number;
  bySubject: Array<{
    __typename?: "PricingOffersSummaryGroup";
    label: string;
    count: number;
  } | null>;
  byClassType: Array<{
    __typename?: "PricingOffersSummaryGroup";
    label: string;
    count: number;
  } | null>;
  byLearnerAge: Array<{
    __typename?: "PricingOffersSummaryGroup";
    label: string;
    count: number;
  } | null>;
  learnersByUser: Array<{
    __typename?: "PricingOffersSummaryGroup";
    label: string;
    count: number;
  } | null>;
  byActivity: Array<{
    __typename?: "PricingOffersSummaryByActivity";
    title: string;
    subject: string;
    classType: string;
    priceCents: number;
    totalEnrollments: number;
    totalSpend: number;
  } | null>;
  byUser: Array<{
    __typename?: "PricingOffersSummaryByUser";
    name: string;
    email: string;
    secondaryEmail: string | null;
    totalLimit: number | null;
    totalSpend: number;
    totalEnrollments: number;
    totalLearnerMinutes: number;
  } | null>;
};

export type Dashboard_PaymentsByWeekFragment = {
  __typename?: "PricingOffersPaymentsByWeek";
  weekStart: any;
  userCount: number;
  newUserCount: number;
  totalSpend: number;
};

export type Dashboard_TransactionsFragment = {
  __typename?: "PricingOffersTransaction";
  name: string;
  email: string;
  secondaryEmail: string | null;
  orderSlugId: string | null;
  day: any;
  amountCents: number | null;
  amountRefundedCents: number | null;
};

export type PricingOfferDashboardQueryVariables = Exact<{
  uid: Scalars["String"];
}>;

export type PricingOfferDashboardQuery = {
  __typename?: "Query";
  pricingOffer: {
    __typename?: "PricingOffer";
    uid: string;
    name: string;
    buyerOrgName: string | null;
    offerRemainingCapCents: number | null;
    totalCapCents: number;
    userLimitCents: number;
  };
  pricingOfferEnrollmentsSummary: {
    __typename?: "PricingOfferEnrollmentsSummary";
    learnerCount: number;
    enrollmentCount: number;
    bySubject: Array<{
      __typename?: "PricingOffersSummaryGroup";
      label: string;
      count: number;
    } | null>;
    byClassType: Array<{
      __typename?: "PricingOffersSummaryGroup";
      label: string;
      count: number;
    } | null>;
    byLearnerAge: Array<{
      __typename?: "PricingOffersSummaryGroup";
      label: string;
      count: number;
    } | null>;
    learnersByUser: Array<{
      __typename?: "PricingOffersSummaryGroup";
      label: string;
      count: number;
    } | null>;
    byActivity: Array<{
      __typename?: "PricingOffersSummaryByActivity";
      title: string;
      subject: string;
      classType: string;
      priceCents: number;
      totalEnrollments: number;
      totalSpend: number;
    } | null>;
    byUser: Array<{
      __typename?: "PricingOffersSummaryByUser";
      name: string;
      email: string;
      secondaryEmail: string | null;
      totalLimit: number | null;
      totalSpend: number;
      totalEnrollments: number;
      totalLearnerMinutes: number;
    } | null>;
  };
  pricingOfferPaymentsByWeek: Array<{
    __typename?: "PricingOffersPaymentsByWeek";
    weekStart: any;
    userCount: number;
    newUserCount: number;
    totalSpend: number;
  } | null>;
};

export type PricingOfferOrgDashboardQueryVariables = Exact<{
  organizationUid: Scalars["String"];
}>;

export type PricingOfferOrgDashboardQuery = {
  __typename?: "Query";
  organization: {
    __typename?: "Organization";
    uid: string;
    name: string;
    totalCapCents: number | null;
    pricingOffers: Array<{
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      buyerOrgName: string | null;
      offerRemainingCapCents: number | null;
      totalCapCents: number;
      userLimitCents: number;
      deletedAt: any | null;
    }>;
  } | null;
  pricingOfferEnrollmentsSummary: {
    __typename?: "PricingOfferEnrollmentsSummary";
    learnerCount: number;
    enrollmentCount: number;
    bySubject: Array<{
      __typename?: "PricingOffersSummaryGroup";
      label: string;
      count: number;
    } | null>;
    byClassType: Array<{
      __typename?: "PricingOffersSummaryGroup";
      label: string;
      count: number;
    } | null>;
    byLearnerAge: Array<{
      __typename?: "PricingOffersSummaryGroup";
      label: string;
      count: number;
    } | null>;
    learnersByUser: Array<{
      __typename?: "PricingOffersSummaryGroup";
      label: string;
      count: number;
    } | null>;
    byActivity: Array<{
      __typename?: "PricingOffersSummaryByActivity";
      title: string;
      subject: string;
      classType: string;
      priceCents: number;
      totalEnrollments: number;
      totalSpend: number;
    } | null>;
    byUser: Array<{
      __typename?: "PricingOffersSummaryByUser";
      name: string;
      email: string;
      secondaryEmail: string | null;
      totalLimit: number | null;
      totalSpend: number;
      totalEnrollments: number;
      totalLearnerMinutes: number;
    } | null>;
  };
  pricingOfferPaymentsByWeek: Array<{
    __typename?: "PricingOffersPaymentsByWeek";
    weekStart: any;
    userCount: number;
    newUserCount: number;
    totalSpend: number;
  } | null>;
};

export type PricingOfferEnrollmentsSummaryByUserQueryVariables = Exact<{
  uid: Scalars["String"];
  dateFilter?: InputMaybe<DateFilterInput>;
}>;

export type PricingOfferEnrollmentsSummaryByUserQuery = {
  __typename?: "Query";
  pricingOfferEnrollmentsSummary: {
    __typename?: "PricingOfferEnrollmentsSummary";
    byUser: Array<{
      __typename?: "PricingOffersSummaryByUser";
      name: string;
      email: string;
      secondaryEmail: string | null;
      totalLimit: number | null;
      totalSpend: number;
      totalEnrollments: number;
      totalLearnerMinutes: number;
    } | null>;
  };
};

export type PricingOfferOrgEnrollmentsSummaryByUserQueryVariables = Exact<{
  organizationUid: Scalars["String"];
  dateFilter?: InputMaybe<DateFilterInput>;
}>;

export type PricingOfferOrgEnrollmentsSummaryByUserQuery = {
  __typename?: "Query";
  pricingOfferEnrollmentsSummary: {
    __typename?: "PricingOfferEnrollmentsSummary";
    byUser: Array<{
      __typename?: "PricingOffersSummaryByUser";
      name: string;
      email: string;
      secondaryEmail: string | null;
      totalLimit: number | null;
      totalSpend: number;
      totalEnrollments: number;
      totalLearnerMinutes: number;
    } | null>;
  };
};

export type PricingOfferTransactionsQueryVariables = Exact<{
  uid: Scalars["String"];
  dateFilter?: InputMaybe<DateFilterInput>;
}>;

export type PricingOfferTransactionsQuery = {
  __typename?: "Query";
  pricingOfferTransactions: Array<{
    __typename?: "PricingOffersTransaction";
    name: string;
    email: string;
    secondaryEmail: string | null;
    orderSlugId: string | null;
    day: any;
    amountCents: number | null;
    amountRefundedCents: number | null;
  } | null>;
};

export type PricingOfferOrgTransactionsQueryVariables = Exact<{
  organizationUid: Scalars["String"];
  dateFilter?: InputMaybe<DateFilterInput>;
}>;

export type PricingOfferOrgTransactionsQuery = {
  __typename?: "Query";
  pricingOfferTransactions: Array<{
    __typename?: "PricingOffersTransaction";
    name: string;
    email: string;
    secondaryEmail: string | null;
    orderSlugId: string | null;
    day: any;
    amountCents: number | null;
    amountRefundedCents: number | null;
  } | null>;
};

export type CurrentUserHasEnrolledQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrentUserHasEnrolledQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    hasEnrolled: boolean;
    hasCompletedAttributionSurvey: boolean;
  } | null;
};

export type CurrentUserPricingOfferAdminQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrentUserPricingOfferAdminQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    pricingOfferAdmin: {
      __typename?: "OrganizationAdmin";
      organization: { __typename?: "Organization"; uid: string };
    } | null;
  } | null;
};

export type CurrentUserPaymentMethodsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrentUserPaymentMethodsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    paymentMethods: Array<{
      __typename?: "PaymentMethod";
      uid: string;
      type: PaymentMethodType;
      brand: string;
      last4: string;
      expirationMonth: number;
      expirationYear: number;
      isCustomerDefault: boolean | null;
      isSubscriptionDefault: boolean;
      isBackUpForOffSessionCharges: boolean | null;
    }>;
  } | null;
};

export type DeletePaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars["ID"];
}>;

export type DeletePaymentMethodMutation = {
  __typename?: "Mutation";
  deletePaymentMethod: boolean;
};

export type SetDefaultPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars["ID"];
}>;

export type SetDefaultPaymentMethodMutation = {
  __typename?: "Mutation";
  setDefaultPaymentMethod: boolean;
};

export type SetBackUpPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars["ID"];
  isBackUpForOffSessionCharges: Scalars["Boolean"];
}>;

export type SetBackUpPaymentMethodMutation = {
  __typename?: "Mutation";
  setBackUpPaymentMethod: boolean;
};

export type CreateSetupIntentWithOptionalArgsMutationVariables = Exact<{
  skipSetPaymentMethodAsDefault?: InputMaybe<Scalars["Boolean"]>;
}>;

export type CreateSetupIntentWithOptionalArgsMutation = {
  __typename?: "Mutation";
  createSetupIntent: {
    __typename?: "SetupIntent";
    setupIntentClientId: string;
  };
};

export type CurrentUserPricingOffersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrentUserPricingOffersQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    pricingOffers: Array<{
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      organizationUid: string | null;
      remainingCapCents: number | null;
      discount: number | null;
      isFinancialAid: boolean;
      deletedAt: any | null;
    }> | null;
  } | null;
};

export type GiftCardFragmentFragment = {
  __typename?: "GiftCard";
  uid: string;
  orderSlugId: string;
  amountCents: number;
  note: string | null;
  recipientEmail: string;
  confirmedAt: any | null;
  redemptionCode: string | null;
  deliverAfter: any;
  deliveryTimezone: string;
  purchaser: { __typename?: "GiftCardPurchaser"; name: string; email: string };
  payments: Array<{ __typename?: "OrderPayment"; last4: string | null }>;
};

export type GiftCardAdminFragmentFragment = {
  __typename?: "GiftCard";
  uid: string;
  createdAt: any;
  orderSlugId: string;
  amountCents: number;
  note: string | null;
  recipientName: string;
  recipientEmail: string;
  purchaserName: string;
  purchaserEmail: string;
  confirmedAt: any | null;
  redeemedAt: any | null;
  deliveredAt: any | null;
  deletedAt: any | null;
  redemptionCode: string | null;
  deliverAfter: any;
  deliveryTimezone: string;
  status: GiftCardStatus;
  isCancelable: boolean;
  isEditable: boolean;
};

export type GiftCardQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type GiftCardQuery = {
  __typename?: "Query";
  giftCard: {
    __typename?: "GiftCard";
    uid: string;
    orderSlugId: string;
    amountCents: number;
    note: string | null;
    recipientEmail: string;
    confirmedAt: any | null;
    redemptionCode: string | null;
    deliverAfter: any;
    deliveryTimezone: string;
    purchaser: {
      __typename?: "GiftCardPurchaser";
      name: string;
      email: string;
    };
    payments: Array<{ __typename?: "OrderPayment"; last4: string | null }>;
  };
};

export type RedeemGiftCardMutationVariables = Exact<{
  redemptionCode: Scalars["String"];
}>;

export type RedeemGiftCardMutation = {
  __typename?: "Mutation";
  redeemGiftCard: {
    __typename?: "GiftCard";
    uid: string;
    orderSlugId: string;
    amountCents: number;
    note: string | null;
    recipientEmail: string;
    confirmedAt: any | null;
    redemptionCode: string | null;
    deliverAfter: any;
    deliveryTimezone: string;
    purchaser: {
      __typename?: "GiftCardPurchaser";
      name: string;
      email: string;
    };
    payments: Array<{ __typename?: "OrderPayment"; last4: string | null }>;
  };
};

export type AddGiftCardItemWithDeliveryDateToOrderMutationMutationVariables =
  Exact<{
    giftCardInput: GiftCardInputWithDeliveryDate;
  }>;

export type AddGiftCardItemWithDeliveryDateToOrderMutationMutation = {
  __typename?: "Mutation";
  addGiftCardItemWithDeliveryDateToOrder: {
    __typename?: "GiftCard";
    uid: string;
  };
};

export type UpdateGiftCardMutationVariables = Exact<{
  uid: Scalars["ID"];
  giftCardInput: GiftCardUpdateInput;
}>;

export type UpdateGiftCardMutation = {
  __typename?: "Mutation";
  updateGiftCard: {
    __typename?: "GiftCard";
    uid: string;
    createdAt: any;
    orderSlugId: string;
    amountCents: number;
    note: string | null;
    recipientName: string;
    recipientEmail: string;
    purchaserName: string;
    purchaserEmail: string;
    confirmedAt: any | null;
    redeemedAt: any | null;
    deliveredAt: any | null;
    deletedAt: any | null;
    redemptionCode: string | null;
    deliverAfter: any;
    deliveryTimezone: string;
    status: GiftCardStatus;
    isCancelable: boolean;
    isEditable: boolean;
  } | null;
};

export type CancelGiftCardMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type CancelGiftCardMutation = {
  __typename?: "Mutation";
  cancelGiftCard: { __typename?: "GiftCard"; uid: string } | null;
};

export type StartIdVerificationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type StartIdVerificationMutation = {
  __typename?: "Mutation";
  startIdVerification: any | null;
};

export type StartPersonaIdVerificationMutationVariables = Exact<{
  useConsolidatedFlow?: InputMaybe<Scalars["Boolean"]>;
}>;

export type StartPersonaIdVerificationMutation = {
  __typename?: "Mutation";
  startPersonaIdVerification: any | null;
};

export type IdVerificationStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type IdVerificationStatusQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    idVerificationStatus: IdvStatus;
  } | null;
};

export type NextMeetingOfLeaderReminderQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type NextMeetingOfLeaderReminderQueryQuery = {
  __typename?: "Query";
  nextMeetingOfLeaderReminder: {
    __typename?: "NextMeetingOfLeaderReminder";
    uid: string;
    startTime: any | null;
    sectionUid: string;
    activityTitle: string;
  } | null;
};

export type NextMeetingsOfParentReminderQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type NextMeetingsOfParentReminderQueryQuery = {
  __typename?: "Query";
  nextMeetingsOfParentReminder: Array<{
    __typename?: "NextMeetingsOfParentReminder";
    uid: string;
    startTime: any | null;
    sectionUid: string;
    learnerUid: string;
    canManage: boolean;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      titleTranslated: string | null;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      leader: {
        __typename?: "Leader";
        name: string | null;
        photo: string | null;
      };
    };
  }>;
};

export type PickLearnerQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type PickLearnerQuery = {
  __typename?: "Query";
  classroom: {
    __typename?: "Classroom";
    uid: string;
    section: {
      __typename?: "Section";
      uid: string;
      currentUserCanManage: boolean;
    };
  };
  learnersToPick: Array<{
    __typename?: "LearnerToPick";
    uid: string;
    name: string;
    age: number;
    enrollmentUid: string;
    isEnrollmentPaused: boolean;
  }>;
};

export type AddChildMutationVariables = Exact<{
  childInput: ChildInput;
}>;

export type AddChildMutation = {
  __typename?: "Mutation";
  addChild: {
    __typename?: "Child";
    uid: string;
    name: string | null;
    age: number | null;
    birthMonth: number | null;
    date_of_birth: any | null;
    birthYear: number | null;
    email: string | null;
    avatar: string | null;
    unlockedAvatars: Array<string>;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    email_confirmed_at: any | null;
    hasMarketingConsent: boolean | null;
    hasHealthConsent: boolean | null;
    isLoginEnabled: boolean;
    username: string | null;
    hasPassword: boolean;
    hasEsaMembership: boolean;
    esaMembershipProgram: string | null;
    attributes: Array<{
      __typename?: "EntityAttribute";
      uid: string;
      key: string;
      value: string;
      source: string | null;
    }>;
    entityAvailabilitySchedule: {
      __typename?: "EntityAvailabilitySchedule";
      entityAvailabilities: Array<{
        __typename?: "EntityAvailability";
        startHour: number;
        startMinute: number;
        day: number;
        endHour: number;
        endMinute: number;
        uid: string;
      }>;
    } | null;
  };
};

export type UpdateChildMutationVariables = Exact<{
  uid: Scalars["ID"];
  childInput: ChildInput;
}>;

export type UpdateChildMutation = {
  __typename?: "Mutation";
  updateChild: {
    __typename?: "Child";
    uid: string;
    name: string | null;
    age: number | null;
    birthMonth: number | null;
    date_of_birth: any | null;
    birthYear: number | null;
    email: string | null;
    avatar: string | null;
    unlockedAvatars: Array<string>;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    email_confirmed_at: any | null;
    hasMarketingConsent: boolean | null;
    hasHealthConsent: boolean | null;
    isLoginEnabled: boolean;
    username: string | null;
    hasPassword: boolean;
    hasEsaMembership: boolean;
    esaMembershipProgram: string | null;
    attributes: Array<{
      __typename?: "EntityAttribute";
      uid: string;
      key: string;
      value: string;
      source: string | null;
    }>;
    entityAvailabilitySchedule: {
      __typename?: "EntityAvailabilitySchedule";
      entityAvailabilities: Array<{
        __typename?: "EntityAvailability";
        startHour: number;
        startMinute: number;
        day: number;
        endHour: number;
        endMinute: number;
        uid: string;
      }>;
    } | null;
  };
};

export type DeleteChildMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type DeleteChildMutation = {
  __typename?: "Mutation";
  deleteChild: boolean;
};

export type CheckMeetingConflictsQueryVariables = Exact<{
  query: Array<MeetingConflictsQueryInput> | MeetingConflictsQueryInput;
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  sectionUid?: InputMaybe<Scalars["String"]>;
}>;

export type CheckMeetingConflictsQuery = {
  __typename?: "Query";
  checkMeetingConflicts: Array<{
    __typename?: "MeetingConflictResult";
    rangeUid: string;
    section: {
      __typename?: "Section";
      uid: string;
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        titleTranslated: string | null;
        hasTeacherSchedule: boolean;
      };
    };
  }>;
};

export type EnrollmentsQueryVariables = Exact<{
  userOneUid: Scalars["ID"];
  userTwoUid: Scalars["ID"];
}>;

export type EnrollmentsQuery = {
  __typename?: "Query";
  userOneAsParent: {
    __typename?: "Parent";
    uid: string;
    enrollmentsWithTeacher: Array<{ __typename?: "Enrollment"; uid: string }>;
  } | null;
  userTwoAsParent: {
    __typename?: "Parent";
    uid: string;
    enrollmentsWithTeacher: Array<{ __typename?: "Enrollment"; uid: string }>;
  } | null;
};

export type CreateOrderMutationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreateOrderMutationMutation = {
  __typename?: "Mutation";
  createOrder: { __typename?: "OrderType"; orderSlugId: string };
};

export type PricingBreakdownQueryQueryVariables = Exact<{
  pricingBreakdownInput: PricingBreakdownInput;
}>;

export type PricingBreakdownQueryQuery = {
  __typename?: "Query";
  pricingBreakdown: {
    __typename?: "PricingBreakdown";
    originalTotalCents: number;
    subtotalCents: number;
    totalCents: number;
    taxCents: number;
    taxCalculationId: string | null;
    pricingOfferCents: number;
    pricingOfferState: PricingOfferState;
    storedCreditCents: number;
    creditAccountState: CreditAccountState;
    stripeCents: number;
    couponCents: number;
    couponCredits: number | null;
    couponState: CouponState;
    enrollmentMeetingTotalCents: number | null;
    perEnrollmentCurrentWeekCents: number | null;
    perEnrollmentUpfrontCents: number | null;
    perEnrollmentWeeklyCents: number | null;
    perEnrollmentTotalWeeklyCents: number | null;
    hasProratedEnrollments: boolean | null;
    perEnrollmentUpfrontCredits: number | null;
    perEnrollmentWeeklyCredits: number | null;
    perEnrollmentTotalWeeklyCredits: number | null;
    perEnrollmentCurrentWeekCredits: number | null;
    subtotalCredits: number | null;
    totalCredits: number | null;
    serviceFeePercentage: number | null;
    esaMembershipCredits: number | null;
    esaMembershipAccountState: CreditAccountState | null;
    esaMembershipFundingProgram: string | null;
    subscriptionCredits: number | null;
    subscriptionAccountState: CreditAccountState | null;
    subscriptionOutstandingBalanceCents: number | null;
    subscriptionOutstandingBalanceCredits: number | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userOfferEmail: string | null;
      userLimitCents: number;
      requirePaymentMethod: boolean;
      buyerOrgName: string | null;
      remainingCapCents: number | null;
      organization: { __typename?: "Organization"; name: string } | null;
    } | null;
  };
};

export type OrganizationAdminFragmentFragment = {
  __typename?: "Organization";
  uid: string;
  deletedAt: any | null;
  name: string;
  type: OrganizationType;
  address: string | null;
  state: string | null;
  notes: string | null;
  urlName: string | null;
  logoUrl: string | null;
  invoiceEmail: string | null;
  techSupportEmail: string | null;
  trustSafetyEmail: string | null;
  totalCapCents: number | null;
  taxExempt: boolean | null;
  pricingOffers: Array<{
    __typename?: "PricingOffer";
    uid: string;
    name: string;
    buyerOrgName: string | null;
    deletedAt: any | null;
  }>;
};

export type ListOrganizationsQueryVariables = Exact<{
  types?: InputMaybe<
    Array<InputMaybe<OrganizationType>> | InputMaybe<OrganizationType>
  >;
  filter?: InputMaybe<OrganizationAdminFilter>;
}>;

export type ListOrganizationsQuery = {
  __typename?: "Query";
  organizations: Array<{
    __typename?: "Organization";
    uid: string;
    name: string;
    type: OrganizationType;
    deletedAt: any | null;
    isEsaOrMicrogrant: boolean | null;
    isOrgCommunityPartner: boolean | null;
  }>;
};

export type CreateOrganizationMutationVariables = Exact<{
  data: CreateOrganizationInput;
}>;

export type CreateOrganizationMutation = {
  __typename?: "Mutation";
  createOrganization: {
    __typename?: "Organization";
    uid: string;
    deletedAt: any | null;
    name: string;
    type: OrganizationType;
    address: string | null;
    state: string | null;
    notes: string | null;
    urlName: string | null;
    logoUrl: string | null;
    invoiceEmail: string | null;
    techSupportEmail: string | null;
    trustSafetyEmail: string | null;
    totalCapCents: number | null;
    taxExempt: boolean | null;
    pricingOffers: Array<{
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      buyerOrgName: string | null;
      deletedAt: any | null;
    }>;
  };
};

export type LoadOrganizationQueryVariables = Exact<{
  uidOrLink: Scalars["String"];
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
}>;

export type LoadOrganizationQuery = {
  __typename?: "Query";
  organization: {
    __typename?: "Organization";
    uid: string;
    deletedAt: any | null;
    name: string;
    type: OrganizationType;
    address: string | null;
    state: string | null;
    notes: string | null;
    urlName: string | null;
    logoUrl: string | null;
    invoiceEmail: string | null;
    techSupportEmail: string | null;
    trustSafetyEmail: string | null;
    totalCapCents: number | null;
    taxExempt: boolean | null;
    pricingOffers: Array<{
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      buyerOrgName: string | null;
      deletedAt: any | null;
    }>;
  } | null;
};

export type EditOrganizationMutationVariables = Exact<{
  uid: Scalars["ID"];
  data: UpdateOrganizationInput;
}>;

export type EditOrganizationMutation = {
  __typename?: "Mutation";
  updateOrganization: {
    __typename?: "Organization";
    uid: string;
    deletedAt: any | null;
    name: string;
    type: OrganizationType;
    address: string | null;
    state: string | null;
    notes: string | null;
    urlName: string | null;
    logoUrl: string | null;
    invoiceEmail: string | null;
    techSupportEmail: string | null;
    trustSafetyEmail: string | null;
    totalCapCents: number | null;
    taxExempt: boolean | null;
    pricingOffers: Array<{
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      buyerOrgName: string | null;
      deletedAt: any | null;
    }>;
  };
};

export type DeleteOrganizationMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type DeleteOrganizationMutation = {
  __typename?: "Mutation";
  deleteOrganization: {
    __typename?: "Organization";
    uid: string;
    deletedAt: any | null;
    name: string;
    type: OrganizationType;
    address: string | null;
    state: string | null;
    notes: string | null;
    urlName: string | null;
    logoUrl: string | null;
    invoiceEmail: string | null;
    techSupportEmail: string | null;
    trustSafetyEmail: string | null;
    totalCapCents: number | null;
    taxExempt: boolean | null;
    pricingOffers: Array<{
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      buyerOrgName: string | null;
      deletedAt: any | null;
    }>;
  };
};

export type StopPaymentScheduleMutationVariables = Exact<{
  stopPaymentScheduleInput: StopPaymentScheduleInput;
}>;

export type StopPaymentScheduleMutation = {
  __typename?: "Mutation";
  stopPaymentSchedule: boolean;
};

export type AdminPricingOffersQueryVariables = Exact<{
  filter: PricingOfferAdminFilter;
}>;

export type AdminPricingOffersQuery = {
  __typename?: "Query";
  pricingOffers: Array<{
    __typename?: "PricingOffer";
    uid: string;
    name: string;
    buyerOrgName: string | null;
    deletedAt: any | null;
  }>;
};

export type PricingOfferAdminFragmentFragment = {
  __typename?: "PricingOffer";
  uid: string;
  name: string;
  buyerOrgName: string | null;
  totalCapCents: number;
  userLimitCents: number;
  startAfter: any;
  endBy: any;
  requirePaymentMethod: boolean;
  discount: number | null;
  isFinancialAid: boolean;
  eligibleEmailDomains: Array<string>;
  deletedAt: any | null;
  eligibilityLastUpdatedAt: any | null;
  includedEmailAddresses: Array<string>;
  excludedEmailAddresses: Array<string>;
  organizationUid: string | null;
};

export type CreatePricingOfferMutationVariables = Exact<{
  data?: InputMaybe<CreatePricingOfferInput>;
}>;

export type CreatePricingOfferMutation = {
  __typename?: "Mutation";
  createPricingOffer: {
    __typename?: "PricingOffer";
    uid: string;
    name: string;
    buyerOrgName: string | null;
    totalCapCents: number;
    userLimitCents: number;
    startAfter: any;
    endBy: any;
    requirePaymentMethod: boolean;
    discount: number | null;
    isFinancialAid: boolean;
    eligibleEmailDomains: Array<string>;
    deletedAt: any | null;
    eligibilityLastUpdatedAt: any | null;
    includedEmailAddresses: Array<string>;
    excludedEmailAddresses: Array<string>;
    organizationUid: string | null;
  };
};

export type AdminPricingOfferQueryVariables = Exact<{
  uid: Scalars["String"];
}>;

export type AdminPricingOfferQuery = {
  __typename?: "Query";
  pricingOffer: {
    __typename?: "PricingOffer";
    uid: string;
    name: string;
    buyerOrgName: string | null;
    totalCapCents: number;
    userLimitCents: number;
    startAfter: any;
    endBy: any;
    requirePaymentMethod: boolean;
    discount: number | null;
    isFinancialAid: boolean;
    eligibleEmailDomains: Array<string>;
    deletedAt: any | null;
    eligibilityLastUpdatedAt: any | null;
    includedEmailAddresses: Array<string>;
    excludedEmailAddresses: Array<string>;
    organizationUid: string | null;
  };
};

export type EditPricingOfferMutationVariables = Exact<{
  uid: Scalars["String"];
  data?: InputMaybe<UpdatePricingOfferInput>;
}>;

export type EditPricingOfferMutation = {
  __typename?: "Mutation";
  updatePricingOffer: {
    __typename?: "PricingOffer";
    uid: string;
    name: string;
    buyerOrgName: string | null;
    totalCapCents: number;
    userLimitCents: number;
    startAfter: any;
    endBy: any;
    requirePaymentMethod: boolean;
    discount: number | null;
    isFinancialAid: boolean;
    eligibleEmailDomains: Array<string>;
    deletedAt: any | null;
    eligibilityLastUpdatedAt: any | null;
    includedEmailAddresses: Array<string>;
    excludedEmailAddresses: Array<string>;
    organizationUid: string | null;
  };
};

export type DeletePricingOfferMutationVariables = Exact<{
  uid: Scalars["String"];
}>;

export type DeletePricingOfferMutation = {
  __typename?: "Mutation";
  deletePricingOffer: {
    __typename?: "PricingOffer";
    uid: string;
    name: string;
    buyerOrgName: string | null;
    totalCapCents: number;
    userLimitCents: number;
    startAfter: any;
    endBy: any;
    requirePaymentMethod: boolean;
    discount: number | null;
    isFinancialAid: boolean;
    eligibleEmailDomains: Array<string>;
    deletedAt: any | null;
    eligibilityLastUpdatedAt: any | null;
    includedEmailAddresses: Array<string>;
    excludedEmailAddresses: Array<string>;
    organizationUid: string | null;
  };
};

export type SellerOrgAvailabilityScheduleSettingsFragment = {
  __typename?: "ScheduleSettings";
  uid: string;
  teacher: { __typename?: "Leader"; uid: string; name: string | null };
};

export type SellerOrgAvailabilityQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type SellerOrgAvailabilityQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    scheduleSettings: Array<{
      __typename?: "ScheduleSettings";
      uid: string;
      teacher: { __typename?: "Leader"; uid: string; name: string | null };
    }>;
  };
};

export type AssignOrgTeacherToActivityScheduleMutationVariables = Exact<{
  orgTeacherUid: Scalars["String"];
  activityUid: Scalars["String"];
}>;

export type AssignOrgTeacherToActivityScheduleMutation = {
  __typename?: "Mutation";
  assignOrgTeacherToActivitySchedule: {
    __typename?: "ScheduleSettings";
    uid: string;
    teacher: { __typename?: "Leader"; uid: string; name: string | null };
  };
};

export type UnassignOrgTeacherToActivityScheduleMutationVariables = Exact<{
  orgTeacherUid: Scalars["String"];
  activityUid: Scalars["String"];
}>;

export type UnassignOrgTeacherToActivityScheduleMutation = {
  __typename?: "Mutation";
  unassignOrgTeacherToActivitySchedule: {
    __typename?: "ScheduleSettings";
    uid: string;
    teacher: { __typename?: "Leader"; uid: string; name: string | null };
  };
};

export type ParentChildrenQueryVariables = Exact<{
  email: Scalars["String"];
}>;

export type ParentChildrenQuery = {
  __typename?: "Query";
  parentByEmail: {
    __typename?: "User";
    uid: string;
    name: string | null;
    email: string | null;
    created_at: any;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      section_uid: string | null;
      confirmed_at: any | null;
      withdrawn_at: any | null;
      isPrepay: boolean;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      section: {
        __typename?: "Section";
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
      } | null;
    } | null>;
  } | null;
};

export type TeacherSearchSuggestionsQueryVariables = Exact<{
  query: Scalars["String"];
  fundingProgram?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
}>;

export type TeacherSearchSuggestionsQuery = {
  __typename?: "Query";
  teacherSearchSuggestions: {
    __typename?: "TeacherSearchSuggestions";
    term: string;
    teachers: Array<{
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      leader_link: string | null;
      averageActivityStarRating: number | null;
      reviewCount: number;
      educatorTiers: Array<EducatorTier>;
    }>;
  };
};

export type GetUnsentMeetingSummariesSectionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUnsentMeetingSummariesSectionsQuery = {
  __typename?: "Query";
  unsentMeetingSummariesSections: Array<string>;
};

export type TrackUserAttributionSurveyResponseMutationVariables = Exact<{
  input: TrackUserAttributionSurveyResponseInput;
}>;

export type TrackUserAttributionSurveyResponseMutation = {
  __typename?: "Mutation";
  trackUserAttributionSurveyResponse: boolean | null;
};

export type CanReviewUpcomingMeetingForParentQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
}>;

export type CanReviewUpcomingMeetingForParentQuery = {
  __typename?: "Query";
  canReviewUpcomingMeeting: boolean | null;
};

export type EligibleCreditOfferQueryVariables = Exact<{ [key: string]: never }>;

export type EligibleCreditOfferQuery = {
  __typename?: "Query";
  eligibleCreditOffer: {
    __typename?: "CreditOffer";
    amountCredits: number;
    offerType: CreditOfferType;
    eligiblePlans: Array<number>;
  } | null;
};

export type EsaMembershipCreditBalancesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type EsaMembershipCreditBalancesQuery = {
  __typename?: "Query";
  esaMembershipCreditBalances: Array<{
    __typename?: "EsaMembershipCreditBalance";
    uid: string;
    availableCredits: number;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
    };
    fundingProgram: {
      __typename?: "EsaMembershipFundingProgram";
      abbreviation: string | null;
      name: string | null;
      isClassWallet: boolean | null;
    };
  }> | null;
};

export type EsaMembershipCreditBalancesFragmentFragment = {
  __typename?: "EsaMembershipCreditBalance";
  uid: string;
  availableCredits: number;
  learner: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
  };
  fundingProgram: {
    __typename?: "EsaMembershipFundingProgram";
    abbreviation: string | null;
    name: string | null;
    isClassWallet: boolean | null;
  };
};

export type HasNonEsaNonMembershipPurchaseQueryVariables = Exact<{
  [key: string]: never;
}>;

export type HasNonEsaNonMembershipPurchaseQuery = {
  __typename?: "Query";
  hasNonEsaNonMembershipPurchase: boolean;
};

export type SchoolPageQueryVariables = Exact<{
  slug: Scalars["String"];
}>;

export type SchoolPageQuery = {
  __typename?: "Query";
  schoolPage: {
    __typename?: "SchoolPage";
    uid: string;
    slug: string;
    name: string;
    basePath: string;
    address: string | null;
    city: string | null;
    state: string | null;
    startGrade: string | null;
    endGrade: string | null;
    schoolLevel: string | null;
    searchFilters: {
      __typename?: "SavedSearchFilters";
      age: string | null;
      delivery: string | null;
      dow: string | null;
      endBy: string | null;
      endByTime: number | null;
      format: string | null;
      languageOfInstruction: string | null;
      order: string | null;
      pricePerMeetingMax: number | null;
      pricePerMeetingMin: number | null;
      q: string | null;
      multiTermQuery: Array<string> | null;
      adminTags: Array<string> | null;
      startAfter: string | null;
      startAfterTime: number | null;
      theme: string | null;
      timeZone: string | null;
      capacityMax: number | null;
      gradeLevel: string | null;
    } | null;
  } | null;
};

export type SectionMeetings_RequestFragmentFragment = {
  __typename: "MeetingRequest";
  uid: string;
  start_time: any;
  end_time: any;
  status: MeetingRequestStatus;
  billedOn: any;
  is_recurring: boolean;
};

export type SectionMeetings_MeetingFragmentFragment = {
  __typename: "Meeting";
  uid: string;
  start_time: any;
  end_time: any;
  created_at: any | null;
  deleted_at: any | null;
  paidAt: any | null;
  billedOn: any;
  recurring: boolean | null;
  refundableAmountCents: number;
  refundableAmountCredits: number | null;
  recurringSchedule: {
    __typename: "RecurringSchedule";
    uid: string;
    end_at: any | null;
  } | null;
  rescheduleRequests: Array<{
    __typename: "MeetingRequest";
    uid: string;
    start_time: any;
    end_time: any;
    status: MeetingRequestStatus;
    billedOn: any;
    is_recurring: boolean;
  }>;
};

export type SectionMeetingsQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  startAfter: Scalars["DateTime"];
  startBefore: Scalars["DateTime"];
}>;

export type SectionMeetingsQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    meetingCount: number;
    latestProgressReportDate: any | null;
    uid: string;
    published_at: any | null;
    deleted_at: any | null;
    canceled_at: any | null;
    start_time: any | null;
    end_time: any | null;
    startsAtNight: boolean | null;
    is_self_paced: boolean;
    currentUserCanManage: boolean;
    activity: {
      __typename?: "Activity";
      uid: string;
      duration_minutes: number | null;
      price_cents: number | null;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      is_ongoing_weekly: boolean;
      weekly_meetings: number | null;
      duration_weeks: number | null;
      isClub: boolean;
      published_at: any | null;
      hasTeacherSchedule: boolean;
      isSelfPaced: boolean;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        creditDescription: string | null;
      };
    };
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        avatar: string | null;
        age: number | null;
      } | null;
      payments: Array<{
        __typename?: "EnrollmentPayment";
        paid_at: any | null;
        esa_order_id: string | null;
        order_slug_id: string | null;
        organization: { __typename?: "Organization"; uid: string } | null;
      }>;
      pauseWindow: { __typename?: "EnrollmentPauseWindow"; uid: string } | null;
    }>;
    meetings: Array<{
      __typename: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      created_at: any | null;
      deleted_at: any | null;
      paidAt: any | null;
      billedOn: any;
      recurring: boolean | null;
      refundableAmountCents: number;
      refundableAmountCredits: number | null;
      recurringSchedule: {
        __typename: "RecurringSchedule";
        uid: string;
        end_at: any | null;
      } | null;
      rescheduleRequests: Array<{
        __typename: "MeetingRequest";
        uid: string;
        start_time: any;
        end_time: any;
        status: MeetingRequestStatus;
        billedOn: any;
        is_recurring: boolean;
      }>;
    }>;
    meetingRequests: Array<{
      __typename: "MeetingRequest";
      uid: string;
      start_time: any;
      end_time: any;
      status: MeetingRequestStatus;
      billedOn: any;
      is_recurring: boolean;
    }>;
    meetingConflictInfo: Array<{
      __typename?: "SectionMeetingConflictInfo";
      meetingUid: string;
      conflictingSectionUid: string;
    }> | null;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    } | null;
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
    }>;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
    } | null;
  } | null;
};

export type CancelMeetingRequestMutationVariables = Exact<{
  requestUid: Scalars["ID"];
}>;

export type CancelMeetingRequestMutation = {
  __typename?: "Mutation";
  cancelMeetingRequest: boolean;
};

export type RequestMeetingRescheduleMutationVariables = Exact<{
  meetingUid: Scalars["ID"];
  proposedTime: StartEndTime;
  message: Scalars["String"];
  reschedulesFutureMeetings: Scalars["Boolean"];
}>;

export type RequestMeetingRescheduleMutation = {
  __typename?: "Mutation";
  requestMeetingReschedule: {
    __typename: "MeetingRequest";
    uid: string;
    start_time: any;
    end_time: any;
    status: MeetingRequestStatus;
    billedOn: any;
    is_recurring: boolean;
  };
};

export type RequestMeetingsMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  proposedTimes: Array<StartEndTime> | StartEndTime;
  isRecurring?: InputMaybe<Scalars["Boolean"]>;
}>;

export type RequestMeetingsMutation = {
  __typename?: "Mutation";
  requestMeetings: Array<{
    __typename: "MeetingRequest";
    uid: string;
    start_time: any;
    end_time: any;
    status: MeetingRequestStatus;
    billedOn: any;
    is_recurring: boolean;
  }>;
};

export type SubscriptionCreditBalanceQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SubscriptionCreditBalanceQuery = {
  __typename?: "Query";
  subscriptionCreditBalance: {
    __typename?: "SubscriptionCreditBalance";
    uid: string;
    status: string | null;
    currentStatus: CurrentSubscriptionStatus;
    nextBillingCycleStatus: NextBillingCycleSubscriptionStatus | null;
    subscriptionId: string | null;
    checkoutId: string | null;
    balance: number;
    openToBuy: number;
    packageName: string | null;
    numCredits: number | null;
    creditValue: number | null;
    availableCredits: number | null;
    billingCycleStart: any | null;
    billingCycleEnd: any | null;
    pausedAt: any | null;
    willResumeAt: any | null;
    cancelAtPeriodEnd: boolean | null;
    amountCents: number | null;
    numPaused: number | null;
    lastPausedDate: any | null;
    isRefundable: boolean | null;
    upcomingPackage: {
      __typename?: "SubscriptionPackageInformation";
      packageName: string;
      numCredits: number;
      creditValue: number;
      amountCents: number;
    } | null;
  } | null;
};

export type SubscriptionCreditBalanceFragmentFragment = {
  __typename?: "SubscriptionCreditBalance";
  uid: string;
  status: string | null;
  currentStatus: CurrentSubscriptionStatus;
  nextBillingCycleStatus: NextBillingCycleSubscriptionStatus | null;
  subscriptionId: string | null;
  checkoutId: string | null;
  balance: number;
  openToBuy: number;
  packageName: string | null;
  numCredits: number | null;
  creditValue: number | null;
  availableCredits: number | null;
  billingCycleStart: any | null;
  billingCycleEnd: any | null;
  pausedAt: any | null;
  willResumeAt: any | null;
  cancelAtPeriodEnd: boolean | null;
  amountCents: number | null;
  numPaused: number | null;
  lastPausedDate: any | null;
  isRefundable: boolean | null;
  upcomingPackage: {
    __typename?: "SubscriptionPackageInformation";
    packageName: string;
    numCredits: number;
    creditValue: number;
    amountCents: number;
  } | null;
};

export type TeacherStripeConnectedAccountStatusQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TeacherStripeConnectedAccountStatusQueryQuery = {
  __typename?: "Query";
  teacherStripeConnectedAccountStatus: {
    __typename?: "TeacherStripeConnectedAccountStatusResult";
    stripeConnectedAccountId: string | null;
    status: StripeConnectedAccountStatus;
  };
};

export type TrackClassPageImpressionMutationVariables = Exact<{
  input: TrackClassPageImpressionInput;
}>;

export type TrackClassPageImpressionMutation = {
  __typename?: "Mutation";
  trackClassPageImpression: boolean | null;
};

export type UserWalletSummaryQueryVariables = Exact<{ [key: string]: never }>;

export type UserWalletSummaryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    walletSummary: {
      __typename?: "UserWalletSummary";
      pricingOffersTotalCents: number;
      creditAccountBalanceCents: number;
      totalBalanceCents: number;
      pricingOffers: Array<{
        __typename?: "PricingOfferSummary";
        uid: string;
        remainingCapCents: number;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
        organizationUid: string | null;
      }>;
    };
  } | null;
};

export type FeatureFlagsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type FeatureFlagsQueryQuery = {
  __typename?: "Query";
  featureFlags: Array<string>;
};

export type AccountSectionNewQueryVariables = Exact<{
  uid: Scalars["ID"];
  learnerOrEnrollmentUid: Scalars["String"];
  hasSelection: Scalars["Boolean"];
}>;

export type AccountSectionNewQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    filledSpaceCount: number;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    created_at: any;
    validEnrollmentCount: number;
    isAutoCanceled: boolean;
    currentUserIsOwner: boolean;
    paidAmount: number | null;
    is_self_paced: boolean;
    meetings: Array<{
      __typename?: "Meeting";
      refundableAmountCents: number;
      paidAt: any | null;
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    }>;
    currentUserGiftEnrollments: Array<{
      __typename?: "GiftEnrollment";
      uid: string;
      giftClaimedAt: any | null;
      createdAt: any;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      withdrawn_at: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      hasPaymentSchedule: boolean;
      isEnded: boolean;
      isPaused: boolean;
      orderSlugId: string | null;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      priceCents: number | null;
      currentUserIsPurchaser: boolean;
      refundableAmountCents: number;
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      payments: Array<{
        __typename?: "EnrollmentPayment";
        uid: string;
        amount_cents: number | null;
        order_slug_id: string | null;
        stripe_charge_id: string | null;
        purchase_order_id: string | null;
        esa_order_id: string | null;
        intercom_url: string | null;
        last4: string | null;
        created_at: any | null;
        paid_at: any | null;
        disbursed_at: any | null;
        payout_uid: string | null;
        start_time: any | null;
        end_time: any | null;
        unrefundedCents: number;
        isOngoingRefundable: boolean;
        voucher_name: string | null;
        pricing_offer_uid: string | null;
        credit_transaction_uid: string | null;
        credit_account_type: string | null;
        coupon_code_uid: string | null;
        currency_code: CurrencyCode | null;
        exchange_rate: number | null;
        invoice_uid: string | null;
        funding_program_invoice_uid: string | null;
        service_fee_percentage: number | null;
        couponCode: {
          __typename?: "CouponCode";
          code: string;
          coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
        } | null;
        pricingOffer: {
          __typename?: "PricingOffer";
          name: string;
          buyerOrgName: string | null;
          isFinancialAid: boolean;
        } | null;
      }>;
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
    }>;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      price_cents: number | null;
      titleTranslated: string | null;
      weekly_meetings: number | null;
      duration_weeks: number | null;
      is_ongoing_weekly: boolean;
      isClub: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      published_at: any | null;
      hasTeacherSchedule: boolean;
      size_max: number | null;
      user_uid: string;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      is_crosslister: boolean | null;
    };
    feedbacks: Array<{
      __typename?: "FeedbackForLeader";
      uid: string;
      activity_star_rating: number | null;
      created_at: any;
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        timeZone: string | null;
      };
      details: {
        __typename?: "FeedbackForLeaderDetails";
        leaderFeedback: string | null;
      };
    }>;
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
      } | null;
    }>;
    selectedEnrollment?:
      | {
          __typename?: "Enrollment";
          hasPaymentSchedule: boolean;
          uid: string;
          isFirstOutschoolClass: boolean;
          isRepeatLearnerOfTeacher: boolean;
          section_uid: string | null;
          created_at: any | null;
          confirmed_at: any | null;
          withdrawn_at: any | null;
          ongoing_stopped_at: any | null;
          ongoing_start_time: any | null;
          ongoing_end_time: any | null;
          price_cents: number | null;
          usersCanCommunicate: boolean;
          purchasedAsGift: boolean;
          isPaused: boolean;
          isEnded: boolean;
          createdAt: any;
          confirmedAt: any | null;
          withdrawnAt: any | null;
          ongoingStoppedAt: any | null;
          ongoingStartTime: any | null;
          ongoingEndTime: any | null;
          canBeWithdrawn: boolean;
          canBeStopped: boolean;
          priceCents: number | null;
          refundableAmountCents: number;
          currency_code: CurrencyCode;
          exchange_rate: number;
          amount_in_local_currency: number;
          learner: {
            __typename?: "Learner";
            uid: string;
            timeZone: string;
            privateNote: string | null;
            name: string | null;
            age: number | null;
            avatar: string | null;
            pronoun: string | null;
            intro: string | null;
            deleted_at: any | null;
            isVerified: boolean;
            isBlocked: boolean | null;
            blockedByUserUid: string | null;
            blockedAt: any | null;
          } | null;
          parent: {
            __typename?: "Parent";
            hasSubscription: boolean;
            canPayWithSubscriptionCredits: boolean;
            uid: string;
            name: string | null;
            photo: string | null;
            publicName: string | null;
            introduction: string | null;
            created_at: any | null;
            deleted_at: any | null;
            timeZone: string | null;
            socialOptOut: boolean;
            consent_to_share_class_history: boolean | null;
            consent_to_share_favourites: boolean | null;
          };
          siblings: Array<{
            __typename?: "Sibling";
            learner: {
              __typename?: "Learner";
              uid: string;
              name: string | null;
              age: number | null;
              avatar: string | null;
              pronoun: string | null;
              intro: string | null;
              deleted_at: any | null;
              isVerified: boolean;
              isBlocked: boolean | null;
              blockedByUserUid: string | null;
              blockedAt: any | null;
            };
            currentOrLastSection: {
              __typename?: "Section";
              filledSpaceCount: number;
              uid: string;
              activity_uid: string;
              start_time: any | null;
              end_time: any | null;
              teacher_support_start_time: any | null;
              startsAtNight: boolean | null;
              is_cross_listed: boolean;
              size_max: number | null;
              size_min: number | null;
              isPublished: boolean | null;
              price_cents: number | null;
              priceCredits: number | null;
              published_at: any | null;
              updated_at: any;
              canceled_at: any | null;
              deleted_at: any | null;
              ongoing_stopped_at: any | null;
              duration_minutes: number | null;
              usesOutschoolVideoChat: boolean;
              usersCanSendPrivateMessage: boolean;
              currentUserCanManage: boolean;
              isBuyable: boolean;
              allowsTeacherTransfer: boolean;
              nextOngoingMeeting: {
                __typename?: "Meeting";
                uid: string;
                start_time: any;
                end_time: any;
                deleted_at: any | null;
                created_at: any | null;
              } | null;
              leader: {
                __typename?: "Leader";
                uid: string;
                name: string | null;
              };
              details: {
                __typename?: "SectionDetails";
                autoScheduledDraft: boolean | null;
              };
              prepaidOngoingPeriodOptions: Array<{
                __typename?: "Period";
                startOfIsoWeek: any;
                endOfIsoWeek: any;
              }> | null;
            };
          }>;
          otherSections: Array<{
            __typename?: "Section";
            uid: string;
            filledSpaceCount: number;
            activity_uid: string;
            start_time: any | null;
            end_time: any | null;
            teacher_support_start_time: any | null;
            startsAtNight: boolean | null;
            is_cross_listed: boolean;
            size_max: number | null;
            size_min: number | null;
            isPublished: boolean | null;
            price_cents: number | null;
            priceCredits: number | null;
            published_at: any | null;
            updated_at: any;
            canceled_at: any | null;
            deleted_at: any | null;
            ongoing_stopped_at: any | null;
            duration_minutes: number | null;
            usesOutschoolVideoChat: boolean;
            usersCanSendPrivateMessage: boolean;
            currentUserCanManage: boolean;
            isBuyable: boolean;
            allowsTeacherTransfer: boolean;
            nextOngoingMeeting: {
              __typename?: "Meeting";
              uid: string;
              start_time: any;
              end_time: any;
              deleted_at: any | null;
              created_at: any | null;
            } | null;
            leader: { __typename?: "Leader"; uid: string; name: string | null };
            details: {
              __typename?: "SectionDetails";
              autoScheduledDraft: boolean | null;
            };
            prepaidOngoingPeriodOptions: Array<{
              __typename?: "Period";
              startOfIsoWeek: any;
              endOfIsoWeek: any;
            }> | null;
            activity: {
              __typename?: "Activity";
              uid: string;
              title: string;
              isClub: boolean;
              weekly_meetings: number | null;
              duration_weeks: number | null;
              is_ongoing_weekly: boolean;
              hasTeacherSchedule: boolean;
              published_at: any | null;
            };
          }>;
          paymentSchedule: {
            __typename?: "PaymentSchedule";
            uid: string;
          } | null;
          clubVerificationVideo: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
          payments: Array<{
            __typename?: "EnrollmentPayment";
            uid: string;
            unrefundedCredits: number | null;
            amount_cents: number | null;
            order_slug_id: string | null;
            stripe_charge_id: string | null;
            purchase_order_id: string | null;
            esa_order_id: string | null;
            intercom_url: string | null;
            last4: string | null;
            created_at: any | null;
            paid_at: any | null;
            disbursed_at: any | null;
            payout_uid: string | null;
            start_time: any | null;
            end_time: any | null;
            unrefundedCents: number;
            isOngoingRefundable: boolean;
            voucher_name: string | null;
            pricing_offer_uid: string | null;
            credit_transaction_uid: string | null;
            credit_account_type: string | null;
            coupon_code_uid: string | null;
            currency_code: CurrencyCode | null;
            exchange_rate: number | null;
            invoice_uid: string | null;
            funding_program_invoice_uid: string | null;
            service_fee_percentage: number | null;
            organization: {
              __typename?: "Organization";
              uid: string;
              name: string;
              state: string | null;
              logoUrl: string | null;
              urlName: string | null;
            } | null;
            refunds: Array<{
              __typename?: "EnrollmentPaymentRefund";
              uid: string;
              user_uid: string;
              amount_cents: number;
              amount_credits: number | null;
              refunded_at: any | null;
              reason: string | null;
              user_role: string | null;
              note: string | null;
              reduces_teacher_payout: boolean;
              amount_in_local_currency: number | null;
              currency_code: CurrencyCode | null;
              exchange_rate: number | null;
              addOutschoolCreditTransaction: {
                __typename?: "CreditTransaction";
                uid: string;
                amount_cents: number;
                expiresAt: any | null;
                unspentCents: number | null;
              } | null;
            }>;
            couponCode: {
              __typename?: "CouponCode";
              code: string;
              coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
            } | null;
            pricingOffer: {
              __typename?: "PricingOffer";
              name: string;
              buyerOrgName: string | null;
              isFinancialAid: boolean;
            } | null;
          }>;
          pauseWindow: {
            __typename?: "EnrollmentPauseWindow";
            uid: string;
            startDate: any;
            endDate: any;
          } | null;
          buyer: {
            __typename?: "Parent";
            uid: string;
            name: string | null;
            photo: string | null;
            publicName: string | null;
            introduction: string | null;
            created_at: any | null;
            deleted_at: any | null;
            timeZone: string | null;
            socialOptOut: boolean;
            consent_to_share_class_history: boolean | null;
            consent_to_share_favourites: boolean | null;
          } | null;
          pricingOffer: {
            __typename?: "PricingOffer";
            name: string;
            buyerOrgName: string | null;
            isFinancialAid: boolean;
          } | null;
          details: {
            __typename?: "EnrollmentDetails";
            name: string | null;
            age: string | null;
            attendedAt: any | null;
            message: string | null;
          };
          refundPolicy: {
            __typename?: "RefundPolicy";
            type: RefundPolicyType;
            name: string;
            description: string;
          } | null;
        }
      | {
          __typename?: "GiftEnrollment";
          hasPaymentSchedule: boolean;
          withdrawn_at: any | null;
          ongoing_stopped_at: any | null;
          ongoing_start_time: any | null;
          ongoing_end_time: any | null;
          giftClaimedAt: any | null;
          currentUserIsPurchaser: boolean;
          isPaused: boolean;
          isEnded: boolean;
          uid: string;
          createdAt: any;
          confirmedAt: any | null;
          withdrawnAt: any | null;
          ongoingStoppedAt: any | null;
          ongoingStartTime: any | null;
          ongoingEndTime: any | null;
          canBeWithdrawn: boolean;
          canBeStopped: boolean;
          priceCents: number | null;
          refundableAmountCents: number;
          currency_code: CurrencyCode;
          exchange_rate: number;
          amount_in_local_currency: number;
          learner: {
            __typename?: "Learner";
            uid: string;
            timeZone: string;
            privateNote: string | null;
            name: string | null;
            age: number | null;
            avatar: string | null;
            pronoun: string | null;
            intro: string | null;
            deleted_at: any | null;
            isVerified: boolean;
            isBlocked: boolean | null;
            blockedByUserUid: string | null;
            blockedAt: any | null;
          } | null;
          parent: {
            __typename?: "Parent";
            hasSubscription: boolean;
            canPayWithSubscriptionCredits: boolean;
            uid: string;
            name: string | null;
            photo: string | null;
            publicName: string | null;
            introduction: string | null;
            created_at: any | null;
            deleted_at: any | null;
            timeZone: string | null;
            socialOptOut: boolean;
            consent_to_share_class_history: boolean | null;
            consent_to_share_favourites: boolean | null;
          } | null;
          paymentSchedule: {
            __typename?: "PaymentSchedule";
            uid: string;
          } | null;
          payments: Array<{
            __typename?: "EnrollmentPayment";
            uid: string;
            unrefundedCredits: number | null;
            amount_cents: number | null;
            order_slug_id: string | null;
            stripe_charge_id: string | null;
            purchase_order_id: string | null;
            esa_order_id: string | null;
            intercom_url: string | null;
            last4: string | null;
            created_at: any | null;
            paid_at: any | null;
            disbursed_at: any | null;
            payout_uid: string | null;
            start_time: any | null;
            end_time: any | null;
            unrefundedCents: number;
            isOngoingRefundable: boolean;
            voucher_name: string | null;
            pricing_offer_uid: string | null;
            credit_transaction_uid: string | null;
            credit_account_type: string | null;
            coupon_code_uid: string | null;
            currency_code: CurrencyCode | null;
            exchange_rate: number | null;
            invoice_uid: string | null;
            funding_program_invoice_uid: string | null;
            service_fee_percentage: number | null;
            organization: {
              __typename?: "Organization";
              uid: string;
              name: string;
              state: string | null;
              logoUrl: string | null;
              urlName: string | null;
            } | null;
            refunds: Array<{
              __typename?: "EnrollmentPaymentRefund";
              uid: string;
              user_uid: string;
              amount_cents: number;
              amount_credits: number | null;
              refunded_at: any | null;
              reason: string | null;
              user_role: string | null;
              note: string | null;
              reduces_teacher_payout: boolean;
              amount_in_local_currency: number | null;
              currency_code: CurrencyCode | null;
              exchange_rate: number | null;
              addOutschoolCreditTransaction: {
                __typename?: "CreditTransaction";
                uid: string;
                amount_cents: number;
                expiresAt: any | null;
                unspentCents: number | null;
              } | null;
            }>;
            couponCode: {
              __typename?: "CouponCode";
              code: string;
              coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
            } | null;
            pricingOffer: {
              __typename?: "PricingOffer";
              name: string;
              buyerOrgName: string | null;
              isFinancialAid: boolean;
            } | null;
          }>;
          pauseWindow: {
            __typename?: "EnrollmentPauseWindow";
            uid: string;
            startDate: any;
            endDate: any;
          } | null;
          buyer: {
            __typename?: "Parent";
            uid: string;
            name: string | null;
            photo: string | null;
            publicName: string | null;
            introduction: string | null;
            created_at: any | null;
            deleted_at: any | null;
            timeZone: string | null;
            socialOptOut: boolean;
            consent_to_share_class_history: boolean | null;
            consent_to_share_favourites: boolean | null;
          };
          pricingOffer: {
            __typename?: "PricingOffer";
            name: string;
            buyerOrgName: string | null;
            isFinancialAid: boolean;
          } | null;
          details: {
            __typename?: "EnrollmentDetails";
            name: string | null;
            age: string | null;
            attendedAt: any | null;
            message: string | null;
          };
          refundPolicy: {
            __typename?: "RefundPolicy";
            type: RefundPolicyType;
            name: string;
            description: string;
          } | null;
        }
      | null;
    learnerEnrollmentPayments?: Array<{
      __typename?: "EnrollmentPayment";
      amount_credits: number | null;
      unrefundedCredits: number | null;
      credit_account_type: string | null;
      uid: string;
      amount_cents: number | null;
      order_slug_id: string | null;
      stripe_charge_id: string | null;
      purchase_order_id: string | null;
      esa_order_id: string | null;
      intercom_url: string | null;
      last4: string | null;
      created_at: any | null;
      paid_at: any | null;
      disbursed_at: any | null;
      payout_uid: string | null;
      start_time: any | null;
      end_time: any | null;
      unrefundedCents: number;
      isOngoingRefundable: boolean;
      voucher_name: string | null;
      pricing_offer_uid: string | null;
      credit_transaction_uid: string | null;
      coupon_code_uid: string | null;
      currency_code: CurrencyCode | null;
      exchange_rate: number | null;
      invoice_uid: string | null;
      funding_program_invoice_uid: string | null;
      service_fee_percentage: number | null;
      oneOnOneMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
      } | null;
      refunds: Array<{
        __typename?: "EnrollmentPaymentRefund";
        amount_credits: number | null;
        uid: string;
        user_uid: string;
        amount_cents: number;
        refunded_at: any | null;
        reason: string | null;
        user_role: string | null;
        note: string | null;
        reduces_teacher_payout: boolean;
        amount_in_local_currency: number | null;
        currency_code: CurrencyCode | null;
        exchange_rate: number | null;
        addOutschoolCreditTransaction: {
          __typename?: "CreditTransaction";
          uid: string;
          amount_cents: number;
          expiresAt: any | null;
          unspentCents: number | null;
        } | null;
      }>;
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        state: string | null;
        logoUrl: string | null;
        urlName: string | null;
      } | null;
      couponCode: {
        __typename?: "CouponCode";
        code: string;
        coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
    }>;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
    checklist: {
      __typename?: "SectionChecklist";
      autoCanceledAt: any | null;
      grandfatheredAt2017Rate: boolean | null;
    };
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
    }>;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
    } | null;
  } | null;
};

export type ActivityActionFragmentFragment = {
  __typename?: "ActivityAction";
  uid: string;
  created_at: any;
  action: string;
  notes: string | null;
  message_to_teacher: string | null;
};

export type ActivityEditPageQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type ActivityEditPageQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    isSelfPaced: boolean;
    hasSections: boolean;
    lockedClassFormats: Array<ClassFormat>;
    wasPublishedInThePast: boolean;
    suggestedWeeklyMeetings: number | null;
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    tags: string | null;
    archived_at: any | null;
    canRequestListing: boolean;
    isSelfPacedEnrollmentEnabled: boolean;
    saveCount: number | null;
    requested_listing_at: any | null;
    upsell_activity_uid: string | null;
    why_me: string | null;
    parental_guidance: string | null;
    sources: string | null;
    materials: string | null;
    has_external_resources: boolean | null;
    selfPacedMigration: {
      __typename?: "SelfPacedMigrationStatus";
      hasConsented: boolean;
      consentedAt: any | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      type: RefundPolicyType;
      description: string;
    };
    attributes: Array<{
      __typename?: "EntityAttribute";
      key: string;
      value: string;
      entity_type: string;
      source: string | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    videoForLearners: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      publishedClassCount: number;
      hasAvailabilitySet: boolean;
      listings: Array<{
        __typename?: "Listing";
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
      }>;
    };
    leaderDetails: {
      __typename?: "ActivityLeaderDetails";
      uid: string;
      requestedListingAt: any | null;
      classRequest: {
        __typename?: "ClassRequest";
        uid: string;
        age: number;
        content: string;
      } | null;
      welcomeMessage: {
        __typename?: "WelcomeMessage";
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        }> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        } | null;
      } | null;
    };
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    pricingAdjustments: {
      __typename?: "PricingAdjustment";
      weeklySurchargePercentage: number | null;
    };
    pricingInfo: {
      __typename?: "PricingInfo";
      totalPriceCentsForUpfrontPayment: number;
      totalPriceCentsForWeeklyPayments: number;
      weeklyPriceCentsForUpfrontPayment: number;
      weeklyPriceCentsForWeeklyPayments: number;
      upfrontDiscountPercentage: number;
    } | null;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        week_number: number;
        order_within_week: number;
        title: string | null;
        description: string | null;
        lessonNumber: number | null;
        unit: { __typename?: "Unit"; uid: string; title: string | null } | null;
        lessonPosts: Array<{
          __typename?: "LessonPost";
          uid: string;
          blockType: BlockType | null;
          messageContent: {
            __typename?: "MessageContent";
            externalVideoUrl: string | null;
            video: { __typename?: "Attachment"; uid: string } | null;
          };
        }>;
        assignmentLessonPosts: Array<{
          __typename?: "AssignmentLessonPost";
          uid: string;
          messageContent: {
            __typename?: "MessageContent";
            externalVideoUrl: string | null;
            video: { __typename?: "Attachment"; uid: string } | null;
          };
        }>;
      }>;
    } | null;
    details: {
      __typename?: "ActivityDetails";
      asyncTime: string | null;
      isAIUsedForContentCreation: boolean | null;
    };
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    approvalStatus: {
      __typename?: "ActivityApprovalStatus";
      action: string;
      message_to_teacher: string | null;
    } | null;
    externalResources: Array<{
      __typename?: "ExternalResource";
      uid: string;
      name: string;
      url: string | null;
    }>;
  };
  refundPolicies: Array<{
    __typename?: "RefundPolicy";
    name: string;
    type: RefundPolicyType;
  }>;
};

export type CommonEnrollmentFormUserFragmentFragment = {
  __typename?: "User";
  consented_to_coppa_notice_at: any | null;
  uid: string;
  slug_id: string;
  name: string | null;
  email: string | null;
  isLearnerModeEnabled: boolean | null;
  confirmed_at: any | null;
  subscribed_at: any | null;
  email_bounced_at: any | null;
  default_currency: string | null;
  phone: string | null;
  photo: string | null;
  leader_subscribed_at: any | null;
  calendar_uid: string;
  intercomUserHash: string | null;
  payout_email: string | null;
  owner_of_seller_org_uid: string | null;
  admin_for_organization_uid: string | null;
  do_not_sell_my_personal_info: boolean;
  background_checked_at: any | null;
  background_check_started_at: any | null;
  interview_scheduled_at: any | null;
  interviewed_at: any | null;
  classroom_training_scheduled_at: any | null;
  classroom_trained_at: any | null;
  latestLegalName: string | null;
  hasCompletedRequiredProfessionalLearning: boolean;
  hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
  hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
  teacher_approved_at: any | null;
  is_crosslister: boolean | null;
  introduction: string | null;
  created_at: any;
  updated_at: any;
  deleted_at: any | null;
  suspended_at: any | null;
  is_admin: boolean | null;
  learner_uses_parent_mode: boolean;
  leader_link: string | null;
  unreadMessageThreadsCount: number;
  unreadPrivateClassMessageThreadsCount: number;
  unreadAssignmentCommentThreadsCount: number;
  roles: Array<string> | null;
  locale: UserLocale;
  isRecordingAutopostEnabled: boolean | null;
  learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
  anonymousId: string | null;
  wasReferred: boolean;
  isEducatorBetaTester: boolean | null;
  hasVerifiedIdentity: boolean | null;
  consent_to_share_class_history: boolean | null;
  consent_to_share_favourites: boolean | null;
  privacy_state: string | null;
  hasAcceptedNewPrivacyTerms: boolean;
  profile_link_uid: string | null;
  hasSubscription: boolean;
  hasEverSubscribed: boolean;
  hasEsaMembership: boolean;
  esaMembershipPrograms: Array<string> | null;
  canPayWithSubscriptionCredits: boolean;
  upgradablePackages: Array<number | null> | null;
  requiresMembershipForEnrollment: boolean | null;
  hasUsedPublicFunding: boolean | null;
  isCharterUser: boolean | null;
  children: Array<{
    __typename?: "Child";
    uid: string;
    name: string | null;
    age: number | null;
    birthMonth: number | null;
    date_of_birth: any | null;
    birthYear: number | null;
    email: string | null;
    avatar: string | null;
    unlockedAvatars: Array<string>;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    email_confirmed_at: any | null;
    hasMarketingConsent: boolean | null;
    hasHealthConsent: boolean | null;
    isLoginEnabled: boolean;
    username: string | null;
    hasPassword: boolean;
    hasEsaMembership: boolean;
    esaMembershipProgram: string | null;
    attributes: Array<{
      __typename?: "EntityAttribute";
      uid: string;
      key: string;
      value: string;
      source: string | null;
    }>;
    entityAvailabilitySchedule: {
      __typename?: "EntityAvailabilitySchedule";
      entityAvailabilities: Array<{
        __typename?: "EntityAvailability";
        startHour: number;
        startMinute: number;
        day: number;
        endHour: number;
        endMinute: number;
        uid: string;
      }>;
    } | null;
  }>;
  lastSubmittedEnrollments: Array<{
    __typename?: "Enrollment";
    uid: string;
    confirmedAt: any | null;
    withdrawnAt: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    learner: {
      __typename?: "Learner";
      uid: string;
      age: number | null;
      name: string | null;
    } | null;
    section: {
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        titleTranslated: string | null;
      };
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
      } | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
    } | null;
  }>;
  otherEmailDetails: Array<{
    __typename?: "OtherEmailDetails";
    uid: string;
    email: string;
    confirmed_at: any | null;
  } | null> | null;
  firstPaidEnrollment: {
    __typename?: "Enrollment";
    uid: string;
    confirmed_at: any | null;
  } | null;
  details: {
    __typename?: "UserDetails";
    about: string | null;
    headline: string | null;
    countryOfResidence: string | null;
    introduction: string | null;
    browserTimeZone: string | null;
    timeRangeAfterSchool: boolean | null;
    timeRangeSchool: boolean | null;
    timeRangeWeekend: boolean | null;
    socialOptOut: boolean | null;
    howFoundOutschool: string | null;
    howFoundOutschoolOther: string | null;
    educationApproach: string | null;
    adminDashboardUrl: string | null;
    experiments: Array<string | null> | null;
    bannerClosedAt: string | null;
  };
  location: {
    __typename?: "Location";
    address: string | null;
    city: string | null;
    lat: number | null;
    lng: number | null;
    timeZone: string | null;
    state: string | null;
  } | null;
  organizationAdmin: {
    __typename?: "OrganizationAdmin";
    organization: {
      __typename?: "Organization";
      uid: string;
      name: string;
      type: OrganizationType;
    };
  } | null;
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
  interfacePreferences: {
    __typename?: "InterfacePreferences";
    activityFormatDescriptionFlexHidden: boolean;
    activityFormatDescriptionOngoingHidden: boolean;
    activityFormatDescriptionOneTimeHidden: boolean;
    activityFormatDescriptionMultiDayHidden: boolean;
    defaultScheduleFilters: {
      __typename?: "UserScheduleFilters";
      startAfter: string | null;
      endBy: string | null;
      startAfterTime: number | null;
      endByTime: number | null;
      dow: string | null;
    };
  };
  schoolClosure: {
    __typename?: "SchoolClosure";
    application_status: FfapApplicationStatus | null;
    needs_assistance: boolean | null;
  } | null;
  pricingOffer: {
    __typename?: "PricingOffer";
    uid: string;
    name: string;
    userLimitCents: number;
    purchaseLimitCents: number | null;
    totalCapCents: number;
    startAfter: any;
    endBy: any;
    buyerOrgName: string | null;
    isTotalCapReached: boolean;
    remainingCapCents: number | null;
    requirePaymentMethod: boolean;
    isOfferLimitReached: boolean;
    userOfferEmail: string | null;
    discount: number | null;
    isFinancialAid: boolean;
  } | null;
  sellerOrg: {
    __typename?: "SellerOrg";
    uid: string;
    name: string;
    leader_link: string | null;
    currentUserIsOwner: boolean | null;
    currentUserIsTeacher: boolean | null;
    hasApprovedTeacherAccountForOwner: boolean | null;
  } | null;
  latestSellerOrgApplication: {
    __typename?: "SellerOrgApplication";
    uid: string;
    status: SellerOrgApplicationStatus;
    appliedAt: any | null;
    createdAt: any | null;
    approvedAt: any | null;
    rejectedAt: any | null;
    contractSignedAt: any | null;
    adminResponse: string | null;
  } | null;
  latestTeacherApplication: {
    __typename?: "TeacherApplication";
    uid: string;
    legal_name: string | null;
    status: TeacherApplicationStatus;
    submitted_at: any | null;
    reviewed_at: any | null;
    teaching_experience: string | null;
    teaching_credentials: string | null;
    class_types: string | null;
    online_profiles: string | null;
    sample_classes: string | null;
    class_subjects: Array<string | null> | null;
    age_ranges_taught: Array<string | null> | null;
    years_of_experience: string | null;
    how_did_you_hear_about_us: string | null;
    experience_types: Array<string | null> | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  } | null;
  leader: {
    __typename?: "Leader";
    uid: string;
    showCalendar: boolean | null;
    mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
  } | null;
  selfElectedStateFundingProgram: {
    __typename?: "SelfElectedStateFundingProgram";
    stateAbbreviation: string;
    stateName: string;
    fundingOptions: {
      __typename?: "SelfElectedStateFundingOptions";
      charter: boolean;
      reimbursement: boolean;
      statePortal: boolean;
      selfPay: boolean;
      otherProgramName: string | null;
      stateProgramName: string | null;
      stateDebitCard: boolean | null;
    };
  } | null;
  billingAddress: {
    __typename?: "BillingAddress";
    country: string | null;
    postalCode: string | null;
  } | null;
};

export type CommonEnrollmentFormActivityFragmentFragment = {
  __typename?: "Activity";
  uid: string;
  ecvCents: number | null;
  suggestedWeeklyMeetings: number | null;
  reviewCount: number;
  esaStatus: EsaStatus;
  slug_id: string;
  user_uid: string;
  title: string;
  titleTranslated: string | null;
  url: string;
  path: string;
  class_experience: string | null;
  learning_goals: string | null;
  learningGoals: Array<string>;
  assessment: string | null;
  homework: string | null;
  grading_policy: string | null;
  prerequisites: string | null;
  published_at: any | null;
  is_online: boolean;
  age_min: number | null;
  age_max: number | null;
  english_proficiency_level: EnglishProficiencyLevel | null;
  grade_level_min: string | null;
  grade_level_max: string | null;
  size_min: number | null;
  size_max: number | null;
  duration_minutes: number | null;
  duration_weeks: number | null;
  weekly_meetings: number | null;
  price_cents: number | null;
  priceCredits: number | null;
  summary: string | null;
  summaryTranslated: string | null;
  is_ongoing_weekly: boolean;
  subject: string | null;
  languageOfInstruction: any | null;
  summaryForLearners: string | null;
  allowWaitlist: boolean | null;
  isClub: boolean;
  isAutoSchedulingEnabled: boolean | null;
  autoSchedulingDaysNoticeMin: number | null;
  autoSchedulingDaysNoticeMax: number | null;
  allows_recurring_payment: boolean | null;
  allows_late_enrollments_for_fixed_length_classes: boolean;
  allowsFutureOngoingEnrollments: boolean;
  has_building_content: boolean | null;
  hasTeacherSchedule: boolean;
  isFlexSchedule: boolean;
  isSelfPaced: boolean;
  isOneTime: boolean;
  classFormat: EducatorSelectedFormat;
  classroomType: ClassroomType;
  isIncludedWithMembership: boolean;
  leader: {
    __typename?: "Leader";
    uid: string;
    name: string | null;
    leader_link: string | null;
    created_at: any | null;
    photo: string | null;
    suspended_at: any | null;
    cityState: string | null;
    socialOptOut: boolean;
    is_crosslister: boolean | null;
    timeZone: string | null;
    hasAvailabilitySet: boolean;
    approved: boolean;
    hasBackgroundCheckExpired: boolean | null;
    reviewCount: number;
    averageActivityStarRating: number | null;
    hasListings: boolean;
    details: {
      __typename?: "LeaderDetails";
      about: string | null;
      headline: string | null;
      headlineTranslated: string | null;
      countryOfResidence: string | null;
    };
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    teacherForSellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
    } | null;
    video: {
      __typename?: "Attachment";
      fileUrl: string;
      videoThumbnailUrl: string | null;
      file: { __typename?: "File"; url: string; thumbUrl: string | null };
    } | null;
  };
  strictAgeRange: {
    __typename?: "AgeRangeType";
    min: number;
    max: number;
  } | null;
  pricingInfo: {
    __typename?: "PricingInfo";
    totalPriceCentsForUpfrontPayment: number;
    totalPriceCentsForWeeklyPayments: number;
    weeklyPriceCentsForUpfrontPayment: number;
    weeklyPriceCentsForWeeklyPayments: number;
    upfrontDiscountPercentage: number;
    totalPriceCreditsForUpfrontPayment: number;
    weeklyPriceCreditsForUpfrontPayment: number;
    totalPriceCreditsForWeeklyPayments: number;
    weeklyPriceCreditsForWeeklyPayments: number;
  } | null;
  attributes: Array<{
    __typename?: "EntityAttribute";
    key: string;
    value: string;
  }>;
  proficiency_level: {
    __typename?: "ProficiencyLevel";
    level: Array<string | null> | null;
    text: string | null;
  } | null;
  refundPolicy: {
    __typename?: "RefundPolicy";
    name: string;
    description: string;
    type: RefundPolicyType;
  };
  photo: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
  photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type CommonEnrollmentFormSectionFragmentFragment = {
  __typename?: "Section";
  uid: string;
  filledSpaceCount: number;
  allowsLateEnrollment: boolean;
  activity_uid: string;
  start_time: any | null;
  end_time: any | null;
  teacher_support_start_time: any | null;
  startsAtNight: boolean | null;
  is_cross_listed: boolean;
  size_max: number | null;
  size_min: number | null;
  isPublished: boolean | null;
  price_cents: number | null;
  priceCredits: number | null;
  published_at: any | null;
  updated_at: any;
  canceled_at: any | null;
  deleted_at: any | null;
  ongoing_stopped_at: any | null;
  duration_minutes: number | null;
  usesOutschoolVideoChat: boolean;
  usersCanSendPrivateMessage: boolean;
  currentUserCanManage: boolean;
  isBuyable: boolean;
  allowsTeacherTransfer: boolean;
  leader: {
    __typename?: "Leader";
    uid: string;
    name: string | null;
    hasBackgroundCheckExpired: boolean | null;
    photo: string | null;
    leader_link: string | null;
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    video: {
      __typename?: "Attachment";
      fileUrl: string;
      videoThumbnailUrl: string | null;
      file: { __typename?: "File"; url: string; thumbUrl: string | null };
    } | null;
  };
  progress: {
    __typename?: "CourseProgress";
    pastMeetingCount: number;
    remainingMeetingCount: number;
    totalMeetingCount: number;
    nextMeeting: { __typename?: "Meeting"; start_time: any } | null;
  } | null;
  syllabus: {
    __typename?: "Syllabus";
    uid: string;
    lessons: Array<{ __typename?: "Lesson"; uid: string }>;
  } | null;
  nextOngoingMeeting: {
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
  } | null;
  details: {
    __typename?: "SectionDetails";
    autoScheduledDraft: boolean | null;
  };
  prepaidOngoingPeriodOptions: Array<{
    __typename?: "Period";
    startOfIsoWeek: any;
    endOfIsoWeek: any;
  }> | null;
};

export type ActivityEnrollQueryQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  esaState?: InputMaybe<Scalars["String"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
}>;

export type ActivityEnrollQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    consented_to_coppa_notice_at: any | null;
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    lastSubmittedEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  } | null;
  enrollmentForm: {
    __typename?: "EnrollmentForm";
    uid: string;
    waitlistSeatsCount: number;
    section: {
      __typename?: "Section";
      uid: string;
      filledSpaceCount: number;
      allowsLateEnrollment: boolean;
      activity_uid: string;
      start_time: any | null;
      end_time: any | null;
      teacher_support_start_time: any | null;
      startsAtNight: boolean | null;
      is_cross_listed: boolean;
      size_max: number | null;
      size_min: number | null;
      isPublished: boolean | null;
      price_cents: number | null;
      priceCredits: number | null;
      published_at: any | null;
      updated_at: any;
      canceled_at: any | null;
      deleted_at: any | null;
      ongoing_stopped_at: any | null;
      duration_minutes: number | null;
      usesOutschoolVideoChat: boolean;
      usersCanSendPrivateMessage: boolean;
      currentUserCanManage: boolean;
      isBuyable: boolean;
      allowsTeacherTransfer: boolean;
      meetings: Array<{
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
      }>;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        hasBackgroundCheckExpired: boolean | null;
        photo: string | null;
        leader_link: string | null;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        video: {
          __typename?: "Attachment";
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: { __typename?: "File"; url: string; thumbUrl: string | null };
        } | null;
      };
      progress: {
        __typename?: "CourseProgress";
        pastMeetingCount: number;
        remainingMeetingCount: number;
        totalMeetingCount: number;
        nextMeeting: { __typename?: "Meeting"; start_time: any } | null;
      } | null;
      syllabus: {
        __typename?: "Syllabus";
        uid: string;
        lessons: Array<{ __typename?: "Lesson"; uid: string }>;
      } | null;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      } | null;
      details: {
        __typename?: "SectionDetails";
        autoScheduledDraft: boolean | null;
      };
      prepaidOngoingPeriodOptions: Array<{
        __typename?: "Period";
        startOfIsoWeek: any;
        endOfIsoWeek: any;
      }> | null;
    };
    activity: {
      __typename?: "Activity";
      esaStatus: EsaStatus;
      allowsFutureOngoingEnrollments: boolean;
      uid: string;
      ecvCents: number | null;
      suggestedWeeklyMeetings: number | null;
      reviewCount: number;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        created_at: any | null;
        photo: string | null;
        suspended_at: any | null;
        cityState: string | null;
        socialOptOut: boolean;
        is_crosslister: boolean | null;
        timeZone: string | null;
        hasAvailabilitySet: boolean;
        approved: boolean;
        hasBackgroundCheckExpired: boolean | null;
        reviewCount: number;
        averageActivityStarRating: number | null;
        hasListings: boolean;
        details: {
          __typename?: "LeaderDetails";
          about: string | null;
          headline: string | null;
          headlineTranslated: string | null;
          countryOfResidence: string | null;
        };
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: {
          __typename?: "SellerOrg";
          uid: string;
          name: string;
        } | null;
        video: {
          __typename?: "Attachment";
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: { __typename?: "File"; url: string; thumbUrl: string | null };
        } | null;
      };
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      pricingInfo: {
        __typename?: "PricingInfo";
        totalPriceCentsForUpfrontPayment: number;
        totalPriceCentsForWeeklyPayments: number;
        weeklyPriceCentsForUpfrontPayment: number;
        weeklyPriceCentsForWeeklyPayments: number;
        upfrontDiscountPercentage: number;
        totalPriceCreditsForUpfrontPayment: number;
        weeklyPriceCreditsForUpfrontPayment: number;
        totalPriceCreditsForWeeklyPayments: number;
        weeklyPriceCreditsForWeeklyPayments: number;
      } | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        key: string;
        value: string;
      }>;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    currentUserEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      section_uid: string | null;
      price_cents: number | null;
      priceCents: number | null;
      created_at: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      withdrawnAt: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      isPrepay: boolean;
      hasCompletedLesson: boolean;
      hasPostedComment: boolean;
      refundableAmountCents: number;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      usersCanCommunicate: boolean;
      purchasedAsGift: boolean;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      siblings: Array<{
        __typename?: "Sibling";
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
        };
        currentOrLastSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          uid: string;
          activity_uid: string;
          start_time: any | null;
          end_time: any | null;
          teacher_support_start_time: any | null;
          startsAtNight: boolean | null;
          is_cross_listed: boolean;
          size_max: number | null;
          size_min: number | null;
          isPublished: boolean | null;
          price_cents: number | null;
          priceCredits: number | null;
          published_at: any | null;
          updated_at: any;
          canceled_at: any | null;
          deleted_at: any | null;
          ongoing_stopped_at: any | null;
          duration_minutes: number | null;
          usesOutschoolVideoChat: boolean;
          usersCanSendPrivateMessage: boolean;
          currentUserCanManage: boolean;
          isBuyable: boolean;
          allowsTeacherTransfer: boolean;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            deleted_at: any | null;
            created_at: any | null;
          } | null;
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          details: {
            __typename?: "SectionDetails";
            autoScheduledDraft: boolean | null;
          };
          prepaidOngoingPeriodOptions: Array<{
            __typename?: "Period";
            startOfIsoWeek: any;
            endOfIsoWeek: any;
          }> | null;
        };
      }>;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
        scheduleType: PaymentScheduleTypes;
        amountCents: number | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
    conflictingEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
    pendingEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
  } | null;
};

export type ActivitySelfPacedEnrollQueryQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  esaState?: InputMaybe<Scalars["String"]>;
}>;

export type ActivitySelfPacedEnrollQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    consented_to_coppa_notice_at: any | null;
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    lastSubmittedEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  } | null;
  selfPacedEnrollmentForm: {
    __typename?: "SelfPacedEnrollmentForm";
    uid: string;
    activity: {
      __typename?: "Activity";
      esaStatus: EsaStatus;
      isIncludedWithMembership: boolean;
      uid: string;
      ecvCents: number | null;
      suggestedWeeklyMeetings: number | null;
      reviewCount: number;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      syllabus: {
        __typename?: "Syllabus";
        uid: string;
        lessons: Array<{ __typename?: "Lesson"; uid: string }>;
      } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        created_at: any | null;
        photo: string | null;
        suspended_at: any | null;
        cityState: string | null;
        socialOptOut: boolean;
        is_crosslister: boolean | null;
        timeZone: string | null;
        hasAvailabilitySet: boolean;
        approved: boolean;
        hasBackgroundCheckExpired: boolean | null;
        reviewCount: number;
        averageActivityStarRating: number | null;
        hasListings: boolean;
        details: {
          __typename?: "LeaderDetails";
          about: string | null;
          headline: string | null;
          headlineTranslated: string | null;
          countryOfResidence: string | null;
        };
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: {
          __typename?: "SellerOrg";
          uid: string;
          name: string;
        } | null;
        video: {
          __typename?: "Attachment";
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: { __typename?: "File"; url: string; thumbUrl: string | null };
        } | null;
      };
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      pricingInfo: {
        __typename?: "PricingInfo";
        totalPriceCentsForUpfrontPayment: number;
        totalPriceCentsForWeeklyPayments: number;
        weeklyPriceCentsForUpfrontPayment: number;
        weeklyPriceCentsForWeeklyPayments: number;
        upfrontDiscountPercentage: number;
        totalPriceCreditsForUpfrontPayment: number;
        weeklyPriceCreditsForUpfrontPayment: number;
        totalPriceCreditsForWeeklyPayments: number;
        weeklyPriceCreditsForWeeklyPayments: number;
      } | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        key: string;
        value: string;
      }>;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    currentUserEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      section_uid: string | null;
      price_cents: number | null;
      priceCents: number | null;
      created_at: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      withdrawnAt: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      isPrepay: boolean;
      hasCompletedLesson: boolean;
      hasPostedComment: boolean;
      refundableAmountCents: number;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      usersCanCommunicate: boolean;
      purchasedAsGift: boolean;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      siblings: Array<{
        __typename?: "Sibling";
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
        };
        currentOrLastSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          uid: string;
          activity_uid: string;
          start_time: any | null;
          end_time: any | null;
          teacher_support_start_time: any | null;
          startsAtNight: boolean | null;
          is_cross_listed: boolean;
          size_max: number | null;
          size_min: number | null;
          isPublished: boolean | null;
          price_cents: number | null;
          priceCredits: number | null;
          published_at: any | null;
          updated_at: any;
          canceled_at: any | null;
          deleted_at: any | null;
          ongoing_stopped_at: any | null;
          duration_minutes: number | null;
          usesOutschoolVideoChat: boolean;
          usersCanSendPrivateMessage: boolean;
          currentUserCanManage: boolean;
          isBuyable: boolean;
          allowsTeacherTransfer: boolean;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            deleted_at: any | null;
            created_at: any | null;
          } | null;
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          details: {
            __typename?: "SectionDetails";
            autoScheduledDraft: boolean | null;
          };
          prepaidOngoingPeriodOptions: Array<{
            __typename?: "Period";
            startOfIsoWeek: any;
            endOfIsoWeek: any;
          }> | null;
        };
      }>;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
        scheduleType: PaymentScheduleTypes;
        amountCents: number | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
    pendingEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
  };
};

export type ActivityLeaderFragmentFragment = {
  __typename?: "Activity";
  saveCount: number | null;
  archived_at: any | null;
  upsell_activity_uid: string | null;
  why_me: string | null;
  parental_guidance: string | null;
  sources: string | null;
  materials: string | null;
  hasSections: boolean;
  has_external_resources: boolean | null;
  details: { __typename?: "ActivityDetails"; asyncTime: string | null };
  leaderDetails: {
    __typename?: "ActivityLeaderDetails";
    uid: string;
    requestedListingAt: any | null;
    welcomeMessage: {
      __typename?: "WelcomeMessage";
      text: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      }> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      } | null;
    } | null;
  };
  externalResources: Array<{
    __typename?: "ExternalResource";
    uid: string;
    name: string;
    url: string | null;
  }>;
};

export type ActivityAdminPendingOneOnOneEsaFragmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  orderSlugId: string | null;
  createdAt: any;
  withdrawn_at: any | null;
  withdrawnAt: any | null;
  confirmed_at: any | null;
  confirmedAt: any | null;
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    email: string | null;
    photo: string | null;
    timeZone: string | null;
  };
  learner: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    isVerified: boolean;
    isBlocked: boolean | null;
    blockedByUserUid: string | null;
    blockedAt: any | null;
  } | null;
  details: {
    __typename?: "EnrollmentDetails";
    name: string | null;
    age: string | null;
    attendedAt: any | null;
    message: string | null;
  };
  refundPolicy: { __typename?: "RefundPolicy"; name: string } | null;
};

export type ActivityAdminFragmentFragment = {
  __typename?: "Activity";
  tags: string | null;
  disclaimer: string | null;
  adminChecklist: {
    __typename?: "ActivityAdminChecklist";
    notes: string | null;
  };
  pendingOneOnOneEsaEnrollments: Array<{
    __typename?: "Enrollment";
    uid: string;
    orderSlugId: string | null;
    createdAt: any;
    withdrawn_at: any | null;
    withdrawnAt: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      email: string | null;
      photo: string | null;
      timeZone: string | null;
    };
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    refundPolicy: { __typename?: "RefundPolicy"; name: string } | null;
  }>;
};

export type ActivityStatusBannerFragmentFragment = {
  __typename?: "Activity";
  tags: string | null;
  archived_at: any | null;
  published_at: any | null;
  user_uid: string;
  canRequestListing: boolean;
  isSelfPaced: boolean;
  isSelfPacedEnrollmentEnabled: boolean;
  uid: string;
  saveCount: number | null;
  requested_listing_at: any | null;
  approvalStatus: {
    __typename?: "ActivityApprovalStatus";
    action: string;
    message_to_teacher: string | null;
  } | null;
};

export type ActivityAttributesFragmentFragment = {
  __typename?: "EntityAttribute";
  key: string;
  value: string;
  entity_type: string;
  source: string | null;
};

export type UpdateAutoSchedulingMutationVariables = Exact<{
  uids: Array<Scalars["ID"]> | Scalars["ID"];
  enabled?: InputMaybe<Scalars["Boolean"]>;
  minDaysNotice?: InputMaybe<Scalars["Int"]>;
  maxDaysNotice?: InputMaybe<Scalars["Int"]>;
}>;

export type UpdateAutoSchedulingMutation = {
  __typename?: "Mutation";
  updateActivitiesAutoScheduling: Array<{
    __typename?: "Activity";
    uid: string;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
  }>;
};

export type UpdateActivityMutationVariables = Exact<{
  uid: Scalars["ID"];
  updates?: InputMaybe<ActivityInput>;
  details?: InputMaybe<ActivityDetailsInput>;
}>;

export type UpdateActivityMutation = {
  __typename?: "Mutation";
  updateActivity: {
    __typename?: "Activity";
    isSelfPaced: boolean;
    suggestedWeeklyMeetings: number | null;
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    saveCount: number | null;
    archived_at: any | null;
    upsell_activity_uid: string | null;
    why_me: string | null;
    parental_guidance: string | null;
    sources: string | null;
    materials: string | null;
    hasSections: boolean;
    has_external_resources: boolean | null;
    selfPacedMigration: {
      __typename?: "SelfPacedMigrationStatus";
      hasConsented: boolean;
      consentedAt: any | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      type: RefundPolicyType;
      description: string;
    };
    attributes: Array<{
      __typename?: "EntityAttribute";
      key: string;
      value: string;
      entity_type: string;
      source: string | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    videoForLearners: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    clubWelcomeVideo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    clubBannerImage: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    clubGuidelines: {
      __typename?: "WelcomeMessage";
      text: string | null;
    } | null;
    sampleClubPost: {
      __typename?: "WelcomeMessage";
      text: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      }> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      } | null;
    } | null;
    sampleClubPosts: Array<{
      __typename?: "SampleClubPost";
      text: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      }> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      } | null;
      comments: Array<{
        __typename?: "SampleClubPostComment";
        text: string | null;
      }>;
    }> | null;
    pricingAdjustments: {
      __typename?: "PricingAdjustment";
      weeklySurchargePercentage: number | null;
    };
    pricingInfo: {
      __typename?: "PricingInfo";
      totalPriceCentsForUpfrontPayment: number;
      totalPriceCentsForWeeklyPayments: number;
      weeklyPriceCentsForUpfrontPayment: number;
      weeklyPriceCentsForWeeklyPayments: number;
      upfrontDiscountPercentage: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    details: { __typename?: "ActivityDetails"; asyncTime: string | null };
    leaderDetails: {
      __typename?: "ActivityLeaderDetails";
      uid: string;
      requestedListingAt: any | null;
      welcomeMessage: {
        __typename?: "WelcomeMessage";
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        }> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        } | null;
      } | null;
    };
    externalResources: Array<{
      __typename?: "ExternalResource";
      uid: string;
      name: string;
      url: string | null;
    }>;
  };
};

export type UpdateTeacherScheduleAvailabilityMutationVariables = Exact<{
  availableTimes: Array<AvailableTimesInput> | AvailableTimesInput;
  uidsToDelete: Array<Scalars["ID"]> | Scalars["ID"];
  activityUid: Scalars["ID"];
}>;

export type UpdateTeacherScheduleAvailabilityMutation = {
  __typename?: "Mutation";
  updateTeacherScheduleAvailability: boolean;
};

export type UpdateScheduleSettingsMutationVariables = Exact<{
  newScheduleSettings?: InputMaybe<ActivityScheduleSettingsInput>;
  activityUid: Scalars["ID"];
}>;

export type UpdateScheduleSettingsMutation = {
  __typename?: "Mutation";
  updateScheduleSettings: boolean;
};

export type UpdateTeacherScheduleMutationVariables = Exact<{
  input: ScheduleInput;
  activityUid: Scalars["ID"];
}>;

export type UpdateTeacherScheduleMutation = {
  __typename?: "Mutation";
  updateTeacherSchedule: boolean;
};

export type CreateSyllabusMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  layoutVersion?: InputMaybe<Scalars["Int"]>;
}>;

export type CreateSyllabusMutation = {
  __typename?: "Mutation";
  createSyllabus: { __typename?: "Syllabus"; uid: string };
};

export type DeleteSyllabusMutationVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type DeleteSyllabusMutation = {
  __typename?: "Mutation";
  deleteSyllabus: { __typename?: "Syllabus"; uid: string };
};

export type ActivityWaitlistQueryQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type ActivityWaitlistQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  } | null;
  enrollmentForm: {
    __typename?: "EnrollmentForm";
    section: {
      __typename?: "Section";
      filledSpaceCount: number;
      meetingDays: string | null;
      uid: string;
      activity_uid: string;
      start_time: any | null;
      end_time: any | null;
      teacher_support_start_time: any | null;
      startsAtNight: boolean | null;
      is_cross_listed: boolean;
      size_max: number | null;
      size_min: number | null;
      isPublished: boolean | null;
      price_cents: number | null;
      priceCredits: number | null;
      published_at: any | null;
      updated_at: any;
      canceled_at: any | null;
      deleted_at: any | null;
      ongoing_stopped_at: any | null;
      duration_minutes: number | null;
      usesOutschoolVideoChat: boolean;
      usersCanSendPrivateMessage: boolean;
      currentUserCanManage: boolean;
      isBuyable: boolean;
      allowsTeacherTransfer: boolean;
      leader: {
        __typename?: "Leader";
        hasBackgroundCheckExpired: boolean | null;
        uid: string;
        name: string | null;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      } | null;
      details: {
        __typename?: "SectionDetails";
        autoScheduledDraft: boolean | null;
      };
      prepaidOngoingPeriodOptions: Array<{
        __typename?: "Period";
        startOfIsoWeek: any;
        endOfIsoWeek: any;
      }> | null;
    };
    activity: {
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    currentUserEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      section_uid: string | null;
      price_cents: number | null;
      priceCents: number | null;
      created_at: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      withdrawnAt: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      isPrepay: boolean;
      hasCompletedLesson: boolean;
      hasPostedComment: boolean;
      refundableAmountCents: number;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      usersCanCommunicate: boolean;
      purchasedAsGift: boolean;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      siblings: Array<{
        __typename?: "Sibling";
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
        };
        currentOrLastSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          uid: string;
          activity_uid: string;
          start_time: any | null;
          end_time: any | null;
          teacher_support_start_time: any | null;
          startsAtNight: boolean | null;
          is_cross_listed: boolean;
          size_max: number | null;
          size_min: number | null;
          isPublished: boolean | null;
          price_cents: number | null;
          priceCredits: number | null;
          published_at: any | null;
          updated_at: any;
          canceled_at: any | null;
          deleted_at: any | null;
          ongoing_stopped_at: any | null;
          duration_minutes: number | null;
          usesOutschoolVideoChat: boolean;
          usersCanSendPrivateMessage: boolean;
          currentUserCanManage: boolean;
          isBuyable: boolean;
          allowsTeacherTransfer: boolean;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            deleted_at: any | null;
            created_at: any | null;
          } | null;
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          details: {
            __typename?: "SectionDetails";
            autoScheduledDraft: boolean | null;
          };
          prepaidOngoingPeriodOptions: Array<{
            __typename?: "Period";
            startOfIsoWeek: any;
            endOfIsoWeek: any;
          }> | null;
        };
      }>;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
        scheduleType: PaymentScheduleTypes;
        amountCents: number | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
  } | null;
};

export type UpdateSectionAdminMutationVariables = Exact<{
  uid: Scalars["ID"];
  updates: SectionAdminInput;
}>;

export type UpdateSectionAdminMutation = {
  __typename?: "Mutation";
  updateSectionAdmin: {
    __typename?: "Section";
    uid: string;
    notes: string | null;
    standardPayoutCents: number;
    zoomMeeting: { __typename?: "ZoomMeeting"; zoom_id: string | null } | null;
  };
};

export type MarkEnrollmentWithdrawnMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  withdrawnReason: Scalars["String"];
  withdrawnNote: Scalars["String"];
}>;

export type MarkEnrollmentWithdrawnMutation = {
  __typename?: "Mutation";
  markEnrollmentWithdrawn: {
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type MarkUnclaimedGiftWithdrawnMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  withdrawnReason: Scalars["String"];
  withdrawnNote: Scalars["String"];
}>;

export type MarkUnclaimedGiftWithdrawnMutation = {
  __typename?: "Mutation";
  markUnclaimedGiftWithdrawn: {
    __typename?: "GiftEnrollment";
    uid: string;
    giftClaimedAt: any | null;
    createdAt: any;
    confirmedAt: any | null;
    withdrawnAt: any | null;
    withdrawn_at: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    hasPaymentSchedule: boolean;
    isEnded: boolean;
    isPaused: boolean;
    orderSlugId: string | null;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    priceCents: number | null;
    currentUserIsPurchaser: boolean;
    refundableAmountCents: number;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    payments: Array<{
      __typename?: "EnrollmentPayment";
      uid: string;
      amount_cents: number | null;
      order_slug_id: string | null;
      stripe_charge_id: string | null;
      purchase_order_id: string | null;
      esa_order_id: string | null;
      intercom_url: string | null;
      last4: string | null;
      created_at: any | null;
      paid_at: any | null;
      disbursed_at: any | null;
      payout_uid: string | null;
      start_time: any | null;
      end_time: any | null;
      unrefundedCents: number;
      isOngoingRefundable: boolean;
      voucher_name: string | null;
      pricing_offer_uid: string | null;
      credit_transaction_uid: string | null;
      credit_account_type: string | null;
      coupon_code_uid: string | null;
      currency_code: CurrencyCode | null;
      exchange_rate: number | null;
      invoice_uid: string | null;
      funding_program_invoice_uid: string | null;
      service_fee_percentage: number | null;
      couponCode: {
        __typename?: "CouponCode";
        code: string;
        coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
    }>;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type MarkEnrollmentSubscriptionStoppedMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  reason: Scalars["String"];
  note: Scalars["String"];
}>;

export type MarkEnrollmentSubscriptionStoppedMutation = {
  __typename?: "Mutation";
  markEnrollmentSubscriptionStopped: {
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type MarkUnclaimedGiftSubscriptionStoppedMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  reason: Scalars["String"];
  note: Scalars["String"];
}>;

export type MarkUnclaimedGiftSubscriptionStoppedMutation = {
  __typename?: "Mutation";
  markUnclaimedGiftSubscriptionStopped: {
    __typename?: "GiftEnrollment";
    uid: string;
    giftClaimedAt: any | null;
    createdAt: any;
    confirmedAt: any | null;
    withdrawnAt: any | null;
    withdrawn_at: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    hasPaymentSchedule: boolean;
    isEnded: boolean;
    isPaused: boolean;
    orderSlugId: string | null;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    priceCents: number | null;
    currentUserIsPurchaser: boolean;
    refundableAmountCents: number;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    payments: Array<{
      __typename?: "EnrollmentPayment";
      uid: string;
      amount_cents: number | null;
      order_slug_id: string | null;
      stripe_charge_id: string | null;
      purchase_order_id: string | null;
      esa_order_id: string | null;
      intercom_url: string | null;
      last4: string | null;
      created_at: any | null;
      paid_at: any | null;
      disbursed_at: any | null;
      payout_uid: string | null;
      start_time: any | null;
      end_time: any | null;
      unrefundedCents: number;
      isOngoingRefundable: boolean;
      voucher_name: string | null;
      pricing_offer_uid: string | null;
      credit_transaction_uid: string | null;
      credit_account_type: string | null;
      coupon_code_uid: string | null;
      currency_code: CurrencyCode | null;
      exchange_rate: number | null;
      invoice_uid: string | null;
      funding_program_invoice_uid: string | null;
      service_fee_percentage: number | null;
      couponCode: {
        __typename?: "CouponCode";
        code: string;
        coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
    }>;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type MarkEnrollmentPaidMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
}>;

export type MarkEnrollmentPaidMutation = {
  __typename?: "Mutation";
  markEnrollmentPaid: {
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type CancelPendingEsaEnrollmentMutationVariables = Exact<{
  orderSlugId: Scalars["ID"];
}>;

export type CancelPendingEsaEnrollmentMutation = {
  __typename?: "Mutation";
  cancelPendingEsaEnrollment: boolean;
};

export type CancelPendingOneOnOneEsaEnrollmentMutationMutationVariables =
  Exact<{
    enrollmentUid: Scalars["ID"];
  }>;

export type CancelPendingOneOnOneEsaEnrollmentMutationMutation = {
  __typename?: "Mutation";
  cancelPendingOneOnOneEsaEnrollmentMutation: boolean;
};

export type MarkEnrollmentSubscriptionStoppedAtDateMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  endDate: Scalars["DateTime"];
  reason: Scalars["String"];
  note: Scalars["String"];
}>;

export type MarkEnrollmentSubscriptionStoppedAtDateMutation = {
  __typename?: "Mutation";
  markEnrollmentSubscriptionStoppedAtDate: {
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    payments: Array<{
      __typename?: "EnrollmentPayment";
      uid: string;
      amount_cents: number | null;
      order_slug_id: string | null;
      stripe_charge_id: string | null;
      purchase_order_id: string | null;
      esa_order_id: string | null;
      intercom_url: string | null;
      last4: string | null;
      created_at: any | null;
      paid_at: any | null;
      disbursed_at: any | null;
      payout_uid: string | null;
      start_time: any | null;
      end_time: any | null;
      unrefundedCents: number;
      isOngoingRefundable: boolean;
      voucher_name: string | null;
      pricing_offer_uid: string | null;
      credit_transaction_uid: string | null;
      credit_account_type: string | null;
      coupon_code_uid: string | null;
      currency_code: CurrencyCode | null;
      exchange_rate: number | null;
      invoice_uid: string | null;
      funding_program_invoice_uid: string | null;
      service_fee_percentage: number | null;
      refunds: Array<{
        __typename?: "EnrollmentPaymentRefund";
        uid: string;
        user_uid: string;
        amount_cents: number;
        amount_credits: number | null;
        refunded_at: any | null;
        reason: string | null;
        user_role: string | null;
        note: string | null;
        reduces_teacher_payout: boolean;
        amount_in_local_currency: number | null;
        currency_code: CurrencyCode | null;
        exchange_rate: number | null;
        addOutschoolCreditTransaction: {
          __typename?: "CreditTransaction";
          uid: string;
          amount_cents: number;
          expiresAt: any | null;
          unspentCents: number | null;
        } | null;
      }>;
      couponCode: {
        __typename?: "CouponCode";
        code: string;
        coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
    }>;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type AdminUserActionFragmentFragment = {
  __typename?: "AdminUserAction";
  uid: string;
  created_at: any;
  action: string;
  notes: string | null;
  customValue: string | null;
};

export type DeleteAdminUserIncidentMutationVariables = Exact<{
  incidentUid: Scalars["ID"];
}>;

export type DeleteAdminUserIncidentMutation = {
  __typename?: "Mutation";
  deleteAdminUserIncident: boolean;
};

export type UpdateAdminUserIncidentMutationVariables = Exact<{
  incidentUid: Scalars["ID"];
  category: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
}>;

export type UpdateAdminUserIncidentMutation = {
  __typename?: "Mutation";
  updateAdminUserIncident: {
    __typename?: "AdminUserIncident";
    uid: string;
    created_at: any;
    updated_at: any;
    category: string;
    notes: string | null;
    admin: { __typename?: "User"; uid: string; name: string | null };
  };
};

export type AddAdminUserIncidentMutationVariables = Exact<{
  userUid: Scalars["ID"];
  category: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
}>;

export type AddAdminUserIncidentMutation = {
  __typename?: "Mutation";
  addAdminUserIncident: {
    __typename?: "AdminUserIncident";
    uid: string;
    created_at: any;
    updated_at: any;
    category: string;
    notes: string | null;
    admin: { __typename?: "User"; uid: string; name: string | null };
  };
};

export type AddAdminUserActionMutationVariables = Exact<{
  userUid: Scalars["ID"];
  action: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
  customValue?: InputMaybe<Scalars["String"]>;
  confirmation?: InputMaybe<Scalars["String"]>;
  learnerUid?: InputMaybe<Scalars["String"]>;
  learnerName?: InputMaybe<Scalars["String"]>;
  learnerAge?: InputMaybe<Scalars["Int"]>;
  fundingProgram?: InputMaybe<Scalars["String"]>;
  orderNumber?: InputMaybe<Scalars["String"]>;
  learnerProgramId?: InputMaybe<Scalars["String"]>;
}>;

export type AddAdminUserActionMutation = {
  __typename?: "Mutation";
  addAdminUserAction: {
    __typename?: "AdminUserAction";
    uid: string;
    created_at: any;
    action: string;
    notes: string | null;
    customValue: string | null;
    admin: { __typename?: "User"; uid: string; name: string | null };
    user: {
      __typename?: "User";
      roles: Array<string> | null;
      teacher_featured_at: any | null;
      hasVerifiedIdentity: boolean | null;
      uid: string;
      slug_id: string;
      name: string | null;
      email: string | null;
      isLearnerModeEnabled: boolean | null;
      confirmed_at: any | null;
      subscribed_at: any | null;
      email_bounced_at: any | null;
      default_currency: string | null;
      phone: string | null;
      photo: string | null;
      leader_subscribed_at: any | null;
      calendar_uid: string;
      intercomUserHash: string | null;
      payout_email: string | null;
      owner_of_seller_org_uid: string | null;
      admin_for_organization_uid: string | null;
      do_not_sell_my_personal_info: boolean;
      background_checked_at: any | null;
      background_check_started_at: any | null;
      interview_scheduled_at: any | null;
      interviewed_at: any | null;
      classroom_training_scheduled_at: any | null;
      classroom_trained_at: any | null;
      latestLegalName: string | null;
      hasCompletedRequiredProfessionalLearning: boolean;
      hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
      hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
      teacher_approved_at: any | null;
      is_crosslister: boolean | null;
      introduction: string | null;
      created_at: any;
      updated_at: any;
      deleted_at: any | null;
      suspended_at: any | null;
      is_admin: boolean | null;
      learner_uses_parent_mode: boolean;
      leader_link: string | null;
      unreadMessageThreadsCount: number;
      unreadPrivateClassMessageThreadsCount: number;
      unreadAssignmentCommentThreadsCount: number;
      locale: UserLocale;
      isRecordingAutopostEnabled: boolean | null;
      learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
      anonymousId: string | null;
      wasReferred: boolean;
      isEducatorBetaTester: boolean | null;
      consented_to_coppa_notice_at: any | null;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
      privacy_state: string | null;
      hasAcceptedNewPrivacyTerms: boolean;
      profile_link_uid: string | null;
      hasSubscription: boolean;
      hasEverSubscribed: boolean;
      hasEsaMembership: boolean;
      esaMembershipPrograms: Array<string> | null;
      canPayWithSubscriptionCredits: boolean;
      upgradablePackages: Array<number | null> | null;
      requiresMembershipForEnrollment: boolean | null;
      hasUsedPublicFunding: boolean | null;
      isCharterUser: boolean | null;
      details: {
        __typename?: "UserDetails";
        holdMessages: boolean | null;
        about: string | null;
        headline: string | null;
        countryOfResidence: string | null;
        introduction: string | null;
        browserTimeZone: string | null;
        timeRangeAfterSchool: boolean | null;
        timeRangeSchool: boolean | null;
        timeRangeWeekend: boolean | null;
        socialOptOut: boolean | null;
        howFoundOutschool: string | null;
        howFoundOutschoolOther: string | null;
        educationApproach: string | null;
        adminDashboardUrl: string | null;
        experiments: Array<string | null> | null;
        bannerClosedAt: string | null;
      };
      adminActions: Array<{
        __typename?: "AdminUserAction";
        uid: string;
        created_at: any;
        action: string;
        notes: string | null;
        customValue: string | null;
        admin: { __typename?: "User"; uid: string; name: string | null };
      }>;
      otherEmailDetails: Array<{
        __typename?: "OtherEmailDetails";
        uid: string;
        email: string;
        confirmed_at: any | null;
      } | null> | null;
      firstPaidEnrollment: {
        __typename?: "Enrollment";
        uid: string;
        confirmed_at: any | null;
      } | null;
      location: {
        __typename?: "Location";
        address: string | null;
        city: string | null;
        lat: number | null;
        lng: number | null;
        timeZone: string | null;
        state: string | null;
      } | null;
      organizationAdmin: {
        __typename?: "OrganizationAdmin";
        organization: {
          __typename?: "Organization";
          uid: string;
          name: string;
          type: OrganizationType;
        };
      } | null;
      children: Array<{
        __typename?: "Child";
        uid: string;
        name: string | null;
        age: number | null;
        birthMonth: number | null;
        date_of_birth: any | null;
        birthYear: number | null;
        email: string | null;
        avatar: string | null;
        unlockedAvatars: Array<string>;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        email_confirmed_at: any | null;
        hasMarketingConsent: boolean | null;
        hasHealthConsent: boolean | null;
        isLoginEnabled: boolean;
        username: string | null;
        hasPassword: boolean;
        hasEsaMembership: boolean;
        esaMembershipProgram: string | null;
        attributes: Array<{
          __typename?: "EntityAttribute";
          uid: string;
          key: string;
          value: string;
          source: string | null;
        }>;
        entityAvailabilitySchedule: {
          __typename?: "EntityAvailabilitySchedule";
          entityAvailabilities: Array<{
            __typename?: "EntityAvailability";
            startHour: number;
            startMinute: number;
            day: number;
            endHour: number;
            endMinute: number;
            uid: string;
          }>;
        } | null;
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      interfacePreferences: {
        __typename?: "InterfacePreferences";
        activityFormatDescriptionFlexHidden: boolean;
        activityFormatDescriptionOngoingHidden: boolean;
        activityFormatDescriptionOneTimeHidden: boolean;
        activityFormatDescriptionMultiDayHidden: boolean;
        defaultScheduleFilters: {
          __typename?: "UserScheduleFilters";
          startAfter: string | null;
          endBy: string | null;
          startAfterTime: number | null;
          endByTime: number | null;
          dow: string | null;
        };
      };
      schoolClosure: {
        __typename?: "SchoolClosure";
        application_status: FfapApplicationStatus | null;
        needs_assistance: boolean | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        uid: string;
        name: string;
        userLimitCents: number;
        purchaseLimitCents: number | null;
        totalCapCents: number;
        startAfter: any;
        endBy: any;
        buyerOrgName: string | null;
        isTotalCapReached: boolean;
        remainingCapCents: number | null;
        requirePaymentMethod: boolean;
        isOfferLimitReached: boolean;
        userOfferEmail: string | null;
        discount: number | null;
        isFinancialAid: boolean;
      } | null;
      sellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
        leader_link: string | null;
        currentUserIsOwner: boolean | null;
        currentUserIsTeacher: boolean | null;
        hasApprovedTeacherAccountForOwner: boolean | null;
      } | null;
      latestSellerOrgApplication: {
        __typename?: "SellerOrgApplication";
        uid: string;
        status: SellerOrgApplicationStatus;
        appliedAt: any | null;
        createdAt: any | null;
        approvedAt: any | null;
        rejectedAt: any | null;
        contractSignedAt: any | null;
        adminResponse: string | null;
      } | null;
      latestTeacherApplication: {
        __typename?: "TeacherApplication";
        uid: string;
        legal_name: string | null;
        status: TeacherApplicationStatus;
        submitted_at: any | null;
        reviewed_at: any | null;
        teaching_experience: string | null;
        teaching_credentials: string | null;
        class_types: string | null;
        online_profiles: string | null;
        sample_classes: string | null;
        class_subjects: Array<string | null> | null;
        age_ranges_taught: Array<string | null> | null;
        years_of_experience: string | null;
        how_did_you_hear_about_us: string | null;
        experience_types: Array<string | null> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        showCalendar: boolean | null;
        mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
      } | null;
      selfElectedStateFundingProgram: {
        __typename?: "SelfElectedStateFundingProgram";
        stateAbbreviation: string;
        stateName: string;
        fundingOptions: {
          __typename?: "SelfElectedStateFundingOptions";
          charter: boolean;
          reimbursement: boolean;
          statePortal: boolean;
          selfPay: boolean;
          otherProgramName: string | null;
          stateProgramName: string | null;
          stateDebitCard: boolean | null;
        };
      } | null;
      billingAddress: {
        __typename?: "BillingAddress";
        country: string | null;
        postalCode: string | null;
      } | null;
    };
  };
};

export type RejectSellerOrgApplicationMutationVariables = Exact<{
  userUid: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
  isSendingEmail: Scalars["Boolean"];
}>;

export type RejectSellerOrgApplicationMutation = {
  __typename?: "Mutation";
  rejectSellerOrgApplication: {
    __typename?: "AdminUserAction";
    uid: string;
    created_at: any;
    action: string;
    notes: string | null;
    customValue: string | null;
    admin: { __typename?: "User"; uid: string; name: string | null };
    user: {
      __typename?: "User";
      roles: Array<string> | null;
      teacher_featured_at: any | null;
      uid: string;
      slug_id: string;
      name: string | null;
      email: string | null;
      isLearnerModeEnabled: boolean | null;
      confirmed_at: any | null;
      subscribed_at: any | null;
      email_bounced_at: any | null;
      default_currency: string | null;
      phone: string | null;
      photo: string | null;
      leader_subscribed_at: any | null;
      calendar_uid: string;
      intercomUserHash: string | null;
      payout_email: string | null;
      owner_of_seller_org_uid: string | null;
      admin_for_organization_uid: string | null;
      do_not_sell_my_personal_info: boolean;
      background_checked_at: any | null;
      background_check_started_at: any | null;
      interview_scheduled_at: any | null;
      interviewed_at: any | null;
      classroom_training_scheduled_at: any | null;
      classroom_trained_at: any | null;
      latestLegalName: string | null;
      hasCompletedRequiredProfessionalLearning: boolean;
      hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
      hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
      teacher_approved_at: any | null;
      is_crosslister: boolean | null;
      introduction: string | null;
      created_at: any;
      updated_at: any;
      deleted_at: any | null;
      suspended_at: any | null;
      is_admin: boolean | null;
      learner_uses_parent_mode: boolean;
      leader_link: string | null;
      unreadMessageThreadsCount: number;
      unreadPrivateClassMessageThreadsCount: number;
      unreadAssignmentCommentThreadsCount: number;
      locale: UserLocale;
      isRecordingAutopostEnabled: boolean | null;
      learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
      anonymousId: string | null;
      wasReferred: boolean;
      isEducatorBetaTester: boolean | null;
      consented_to_coppa_notice_at: any | null;
      hasVerifiedIdentity: boolean | null;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
      privacy_state: string | null;
      hasAcceptedNewPrivacyTerms: boolean;
      profile_link_uid: string | null;
      hasSubscription: boolean;
      hasEverSubscribed: boolean;
      hasEsaMembership: boolean;
      esaMembershipPrograms: Array<string> | null;
      canPayWithSubscriptionCredits: boolean;
      upgradablePackages: Array<number | null> | null;
      requiresMembershipForEnrollment: boolean | null;
      hasUsedPublicFunding: boolean | null;
      isCharterUser: boolean | null;
      details: {
        __typename?: "UserDetails";
        holdMessages: boolean | null;
        about: string | null;
        headline: string | null;
        countryOfResidence: string | null;
        introduction: string | null;
        browserTimeZone: string | null;
        timeRangeAfterSchool: boolean | null;
        timeRangeSchool: boolean | null;
        timeRangeWeekend: boolean | null;
        socialOptOut: boolean | null;
        howFoundOutschool: string | null;
        howFoundOutschoolOther: string | null;
        educationApproach: string | null;
        adminDashboardUrl: string | null;
        experiments: Array<string | null> | null;
        bannerClosedAt: string | null;
      };
      otherEmailDetails: Array<{
        __typename?: "OtherEmailDetails";
        uid: string;
        email: string;
        confirmed_at: any | null;
      } | null> | null;
      firstPaidEnrollment: {
        __typename?: "Enrollment";
        uid: string;
        confirmed_at: any | null;
      } | null;
      location: {
        __typename?: "Location";
        address: string | null;
        city: string | null;
        lat: number | null;
        lng: number | null;
        timeZone: string | null;
        state: string | null;
      } | null;
      organizationAdmin: {
        __typename?: "OrganizationAdmin";
        organization: {
          __typename?: "Organization";
          uid: string;
          name: string;
          type: OrganizationType;
        };
      } | null;
      children: Array<{
        __typename?: "Child";
        uid: string;
        name: string | null;
        age: number | null;
        birthMonth: number | null;
        date_of_birth: any | null;
        birthYear: number | null;
        email: string | null;
        avatar: string | null;
        unlockedAvatars: Array<string>;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        email_confirmed_at: any | null;
        hasMarketingConsent: boolean | null;
        hasHealthConsent: boolean | null;
        isLoginEnabled: boolean;
        username: string | null;
        hasPassword: boolean;
        hasEsaMembership: boolean;
        esaMembershipProgram: string | null;
        attributes: Array<{
          __typename?: "EntityAttribute";
          uid: string;
          key: string;
          value: string;
          source: string | null;
        }>;
        entityAvailabilitySchedule: {
          __typename?: "EntityAvailabilitySchedule";
          entityAvailabilities: Array<{
            __typename?: "EntityAvailability";
            startHour: number;
            startMinute: number;
            day: number;
            endHour: number;
            endMinute: number;
            uid: string;
          }>;
        } | null;
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      interfacePreferences: {
        __typename?: "InterfacePreferences";
        activityFormatDescriptionFlexHidden: boolean;
        activityFormatDescriptionOngoingHidden: boolean;
        activityFormatDescriptionOneTimeHidden: boolean;
        activityFormatDescriptionMultiDayHidden: boolean;
        defaultScheduleFilters: {
          __typename?: "UserScheduleFilters";
          startAfter: string | null;
          endBy: string | null;
          startAfterTime: number | null;
          endByTime: number | null;
          dow: string | null;
        };
      };
      schoolClosure: {
        __typename?: "SchoolClosure";
        application_status: FfapApplicationStatus | null;
        needs_assistance: boolean | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        uid: string;
        name: string;
        userLimitCents: number;
        purchaseLimitCents: number | null;
        totalCapCents: number;
        startAfter: any;
        endBy: any;
        buyerOrgName: string | null;
        isTotalCapReached: boolean;
        remainingCapCents: number | null;
        requirePaymentMethod: boolean;
        isOfferLimitReached: boolean;
        userOfferEmail: string | null;
        discount: number | null;
        isFinancialAid: boolean;
      } | null;
      sellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
        leader_link: string | null;
        currentUserIsOwner: boolean | null;
        currentUserIsTeacher: boolean | null;
        hasApprovedTeacherAccountForOwner: boolean | null;
      } | null;
      latestSellerOrgApplication: {
        __typename?: "SellerOrgApplication";
        uid: string;
        status: SellerOrgApplicationStatus;
        appliedAt: any | null;
        createdAt: any | null;
        approvedAt: any | null;
        rejectedAt: any | null;
        contractSignedAt: any | null;
        adminResponse: string | null;
      } | null;
      latestTeacherApplication: {
        __typename?: "TeacherApplication";
        uid: string;
        legal_name: string | null;
        status: TeacherApplicationStatus;
        submitted_at: any | null;
        reviewed_at: any | null;
        teaching_experience: string | null;
        teaching_credentials: string | null;
        class_types: string | null;
        online_profiles: string | null;
        sample_classes: string | null;
        class_subjects: Array<string | null> | null;
        age_ranges_taught: Array<string | null> | null;
        years_of_experience: string | null;
        how_did_you_hear_about_us: string | null;
        experience_types: Array<string | null> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        showCalendar: boolean | null;
        mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
      } | null;
      selfElectedStateFundingProgram: {
        __typename?: "SelfElectedStateFundingProgram";
        stateAbbreviation: string;
        stateName: string;
        fundingOptions: {
          __typename?: "SelfElectedStateFundingOptions";
          charter: boolean;
          reimbursement: boolean;
          statePortal: boolean;
          selfPay: boolean;
          otherProgramName: string | null;
          stateProgramName: string | null;
          stateDebitCard: boolean | null;
        };
      } | null;
      billingAddress: {
        __typename?: "BillingAddress";
        country: string | null;
        postalCode: string | null;
      } | null;
    };
  };
};

export type AssignTeacherToSellerOrgMutationVariables = Exact<{
  userUid: Scalars["ID"];
  sellerOrgUserUid: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
}>;

export type AssignTeacherToSellerOrgMutation = {
  __typename?: "Mutation";
  assignTeacherToSellerOrg: {
    __typename?: "AdminUserAction";
    uid: string;
    created_at: any;
    action: string;
    notes: string | null;
    customValue: string | null;
    admin: { __typename?: "User"; uid: string; name: string | null };
    user: {
      __typename?: "User";
      roles: Array<string> | null;
      teacher_featured_at: any | null;
      uid: string;
      slug_id: string;
      name: string | null;
      email: string | null;
      isLearnerModeEnabled: boolean | null;
      confirmed_at: any | null;
      subscribed_at: any | null;
      email_bounced_at: any | null;
      default_currency: string | null;
      phone: string | null;
      photo: string | null;
      leader_subscribed_at: any | null;
      calendar_uid: string;
      intercomUserHash: string | null;
      payout_email: string | null;
      owner_of_seller_org_uid: string | null;
      admin_for_organization_uid: string | null;
      do_not_sell_my_personal_info: boolean;
      background_checked_at: any | null;
      background_check_started_at: any | null;
      interview_scheduled_at: any | null;
      interviewed_at: any | null;
      classroom_training_scheduled_at: any | null;
      classroom_trained_at: any | null;
      latestLegalName: string | null;
      hasCompletedRequiredProfessionalLearning: boolean;
      hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
      hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
      teacher_approved_at: any | null;
      is_crosslister: boolean | null;
      introduction: string | null;
      created_at: any;
      updated_at: any;
      deleted_at: any | null;
      suspended_at: any | null;
      is_admin: boolean | null;
      learner_uses_parent_mode: boolean;
      leader_link: string | null;
      unreadMessageThreadsCount: number;
      unreadPrivateClassMessageThreadsCount: number;
      unreadAssignmentCommentThreadsCount: number;
      locale: UserLocale;
      isRecordingAutopostEnabled: boolean | null;
      learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
      anonymousId: string | null;
      wasReferred: boolean;
      isEducatorBetaTester: boolean | null;
      consented_to_coppa_notice_at: any | null;
      hasVerifiedIdentity: boolean | null;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
      privacy_state: string | null;
      hasAcceptedNewPrivacyTerms: boolean;
      profile_link_uid: string | null;
      hasSubscription: boolean;
      hasEverSubscribed: boolean;
      hasEsaMembership: boolean;
      esaMembershipPrograms: Array<string> | null;
      canPayWithSubscriptionCredits: boolean;
      upgradablePackages: Array<number | null> | null;
      requiresMembershipForEnrollment: boolean | null;
      hasUsedPublicFunding: boolean | null;
      isCharterUser: boolean | null;
      details: {
        __typename?: "UserDetails";
        holdMessages: boolean | null;
        about: string | null;
        headline: string | null;
        countryOfResidence: string | null;
        introduction: string | null;
        browserTimeZone: string | null;
        timeRangeAfterSchool: boolean | null;
        timeRangeSchool: boolean | null;
        timeRangeWeekend: boolean | null;
        socialOptOut: boolean | null;
        howFoundOutschool: string | null;
        howFoundOutschoolOther: string | null;
        educationApproach: string | null;
        adminDashboardUrl: string | null;
        experiments: Array<string | null> | null;
        bannerClosedAt: string | null;
      };
      otherEmailDetails: Array<{
        __typename?: "OtherEmailDetails";
        uid: string;
        email: string;
        confirmed_at: any | null;
      } | null> | null;
      firstPaidEnrollment: {
        __typename?: "Enrollment";
        uid: string;
        confirmed_at: any | null;
      } | null;
      location: {
        __typename?: "Location";
        address: string | null;
        city: string | null;
        lat: number | null;
        lng: number | null;
        timeZone: string | null;
        state: string | null;
      } | null;
      organizationAdmin: {
        __typename?: "OrganizationAdmin";
        organization: {
          __typename?: "Organization";
          uid: string;
          name: string;
          type: OrganizationType;
        };
      } | null;
      children: Array<{
        __typename?: "Child";
        uid: string;
        name: string | null;
        age: number | null;
        birthMonth: number | null;
        date_of_birth: any | null;
        birthYear: number | null;
        email: string | null;
        avatar: string | null;
        unlockedAvatars: Array<string>;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        email_confirmed_at: any | null;
        hasMarketingConsent: boolean | null;
        hasHealthConsent: boolean | null;
        isLoginEnabled: boolean;
        username: string | null;
        hasPassword: boolean;
        hasEsaMembership: boolean;
        esaMembershipProgram: string | null;
        attributes: Array<{
          __typename?: "EntityAttribute";
          uid: string;
          key: string;
          value: string;
          source: string | null;
        }>;
        entityAvailabilitySchedule: {
          __typename?: "EntityAvailabilitySchedule";
          entityAvailabilities: Array<{
            __typename?: "EntityAvailability";
            startHour: number;
            startMinute: number;
            day: number;
            endHour: number;
            endMinute: number;
            uid: string;
          }>;
        } | null;
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      interfacePreferences: {
        __typename?: "InterfacePreferences";
        activityFormatDescriptionFlexHidden: boolean;
        activityFormatDescriptionOngoingHidden: boolean;
        activityFormatDescriptionOneTimeHidden: boolean;
        activityFormatDescriptionMultiDayHidden: boolean;
        defaultScheduleFilters: {
          __typename?: "UserScheduleFilters";
          startAfter: string | null;
          endBy: string | null;
          startAfterTime: number | null;
          endByTime: number | null;
          dow: string | null;
        };
      };
      schoolClosure: {
        __typename?: "SchoolClosure";
        application_status: FfapApplicationStatus | null;
        needs_assistance: boolean | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        uid: string;
        name: string;
        userLimitCents: number;
        purchaseLimitCents: number | null;
        totalCapCents: number;
        startAfter: any;
        endBy: any;
        buyerOrgName: string | null;
        isTotalCapReached: boolean;
        remainingCapCents: number | null;
        requirePaymentMethod: boolean;
        isOfferLimitReached: boolean;
        userOfferEmail: string | null;
        discount: number | null;
        isFinancialAid: boolean;
      } | null;
      sellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
        leader_link: string | null;
        currentUserIsOwner: boolean | null;
        currentUserIsTeacher: boolean | null;
        hasApprovedTeacherAccountForOwner: boolean | null;
      } | null;
      latestSellerOrgApplication: {
        __typename?: "SellerOrgApplication";
        uid: string;
        status: SellerOrgApplicationStatus;
        appliedAt: any | null;
        createdAt: any | null;
        approvedAt: any | null;
        rejectedAt: any | null;
        contractSignedAt: any | null;
        adminResponse: string | null;
      } | null;
      latestTeacherApplication: {
        __typename?: "TeacherApplication";
        uid: string;
        legal_name: string | null;
        status: TeacherApplicationStatus;
        submitted_at: any | null;
        reviewed_at: any | null;
        teaching_experience: string | null;
        teaching_credentials: string | null;
        class_types: string | null;
        online_profiles: string | null;
        sample_classes: string | null;
        class_subjects: Array<string | null> | null;
        age_ranges_taught: Array<string | null> | null;
        years_of_experience: string | null;
        how_did_you_hear_about_us: string | null;
        experience_types: Array<string | null> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        showCalendar: boolean | null;
        mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
      } | null;
      selfElectedStateFundingProgram: {
        __typename?: "SelfElectedStateFundingProgram";
        stateAbbreviation: string;
        stateName: string;
        fundingOptions: {
          __typename?: "SelfElectedStateFundingOptions";
          charter: boolean;
          reimbursement: boolean;
          statePortal: boolean;
          selfPay: boolean;
          otherProgramName: string | null;
          stateProgramName: string | null;
          stateDebitCard: boolean | null;
        };
      } | null;
      billingAddress: {
        __typename?: "BillingAddress";
        country: string | null;
        postalCode: string | null;
      } | null;
    };
  };
};

export type MergeUserAccountMutationVariables = Exact<{
  userUid: Scalars["ID"];
  mergeAccountUserUid: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
}>;

export type MergeUserAccountMutation = {
  __typename?: "Mutation";
  mergeUserAccount: {
    __typename?: "AdminUserAction";
    uid: string;
    created_at: any;
    action: string;
    notes: string | null;
    customValue: string | null;
    admin: { __typename?: "User"; uid: string; name: string | null };
    user: {
      __typename?: "User";
      roles: Array<string> | null;
      teacher_featured_at: any | null;
      uid: string;
      slug_id: string;
      name: string | null;
      email: string | null;
      isLearnerModeEnabled: boolean | null;
      confirmed_at: any | null;
      subscribed_at: any | null;
      email_bounced_at: any | null;
      default_currency: string | null;
      phone: string | null;
      photo: string | null;
      leader_subscribed_at: any | null;
      calendar_uid: string;
      intercomUserHash: string | null;
      payout_email: string | null;
      owner_of_seller_org_uid: string | null;
      admin_for_organization_uid: string | null;
      do_not_sell_my_personal_info: boolean;
      background_checked_at: any | null;
      background_check_started_at: any | null;
      interview_scheduled_at: any | null;
      interviewed_at: any | null;
      classroom_training_scheduled_at: any | null;
      classroom_trained_at: any | null;
      latestLegalName: string | null;
      hasCompletedRequiredProfessionalLearning: boolean;
      hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
      hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
      teacher_approved_at: any | null;
      is_crosslister: boolean | null;
      introduction: string | null;
      created_at: any;
      updated_at: any;
      deleted_at: any | null;
      suspended_at: any | null;
      is_admin: boolean | null;
      learner_uses_parent_mode: boolean;
      leader_link: string | null;
      unreadMessageThreadsCount: number;
      unreadPrivateClassMessageThreadsCount: number;
      unreadAssignmentCommentThreadsCount: number;
      locale: UserLocale;
      isRecordingAutopostEnabled: boolean | null;
      learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
      anonymousId: string | null;
      wasReferred: boolean;
      isEducatorBetaTester: boolean | null;
      consented_to_coppa_notice_at: any | null;
      hasVerifiedIdentity: boolean | null;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
      privacy_state: string | null;
      hasAcceptedNewPrivacyTerms: boolean;
      profile_link_uid: string | null;
      hasSubscription: boolean;
      hasEverSubscribed: boolean;
      hasEsaMembership: boolean;
      esaMembershipPrograms: Array<string> | null;
      canPayWithSubscriptionCredits: boolean;
      upgradablePackages: Array<number | null> | null;
      requiresMembershipForEnrollment: boolean | null;
      hasUsedPublicFunding: boolean | null;
      isCharterUser: boolean | null;
      details: {
        __typename?: "UserDetails";
        holdMessages: boolean | null;
        about: string | null;
        headline: string | null;
        countryOfResidence: string | null;
        introduction: string | null;
        browserTimeZone: string | null;
        timeRangeAfterSchool: boolean | null;
        timeRangeSchool: boolean | null;
        timeRangeWeekend: boolean | null;
        socialOptOut: boolean | null;
        howFoundOutschool: string | null;
        howFoundOutschoolOther: string | null;
        educationApproach: string | null;
        adminDashboardUrl: string | null;
        experiments: Array<string | null> | null;
        bannerClosedAt: string | null;
      };
      otherEmailDetails: Array<{
        __typename?: "OtherEmailDetails";
        uid: string;
        email: string;
        confirmed_at: any | null;
      } | null> | null;
      firstPaidEnrollment: {
        __typename?: "Enrollment";
        uid: string;
        confirmed_at: any | null;
      } | null;
      location: {
        __typename?: "Location";
        address: string | null;
        city: string | null;
        lat: number | null;
        lng: number | null;
        timeZone: string | null;
        state: string | null;
      } | null;
      organizationAdmin: {
        __typename?: "OrganizationAdmin";
        organization: {
          __typename?: "Organization";
          uid: string;
          name: string;
          type: OrganizationType;
        };
      } | null;
      children: Array<{
        __typename?: "Child";
        uid: string;
        name: string | null;
        age: number | null;
        birthMonth: number | null;
        date_of_birth: any | null;
        birthYear: number | null;
        email: string | null;
        avatar: string | null;
        unlockedAvatars: Array<string>;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        email_confirmed_at: any | null;
        hasMarketingConsent: boolean | null;
        hasHealthConsent: boolean | null;
        isLoginEnabled: boolean;
        username: string | null;
        hasPassword: boolean;
        hasEsaMembership: boolean;
        esaMembershipProgram: string | null;
        attributes: Array<{
          __typename?: "EntityAttribute";
          uid: string;
          key: string;
          value: string;
          source: string | null;
        }>;
        entityAvailabilitySchedule: {
          __typename?: "EntityAvailabilitySchedule";
          entityAvailabilities: Array<{
            __typename?: "EntityAvailability";
            startHour: number;
            startMinute: number;
            day: number;
            endHour: number;
            endMinute: number;
            uid: string;
          }>;
        } | null;
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      interfacePreferences: {
        __typename?: "InterfacePreferences";
        activityFormatDescriptionFlexHidden: boolean;
        activityFormatDescriptionOngoingHidden: boolean;
        activityFormatDescriptionOneTimeHidden: boolean;
        activityFormatDescriptionMultiDayHidden: boolean;
        defaultScheduleFilters: {
          __typename?: "UserScheduleFilters";
          startAfter: string | null;
          endBy: string | null;
          startAfterTime: number | null;
          endByTime: number | null;
          dow: string | null;
        };
      };
      schoolClosure: {
        __typename?: "SchoolClosure";
        application_status: FfapApplicationStatus | null;
        needs_assistance: boolean | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        uid: string;
        name: string;
        userLimitCents: number;
        purchaseLimitCents: number | null;
        totalCapCents: number;
        startAfter: any;
        endBy: any;
        buyerOrgName: string | null;
        isTotalCapReached: boolean;
        remainingCapCents: number | null;
        requirePaymentMethod: boolean;
        isOfferLimitReached: boolean;
        userOfferEmail: string | null;
        discount: number | null;
        isFinancialAid: boolean;
      } | null;
      sellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
        leader_link: string | null;
        currentUserIsOwner: boolean | null;
        currentUserIsTeacher: boolean | null;
        hasApprovedTeacherAccountForOwner: boolean | null;
      } | null;
      latestSellerOrgApplication: {
        __typename?: "SellerOrgApplication";
        uid: string;
        status: SellerOrgApplicationStatus;
        appliedAt: any | null;
        createdAt: any | null;
        approvedAt: any | null;
        rejectedAt: any | null;
        contractSignedAt: any | null;
        adminResponse: string | null;
      } | null;
      latestTeacherApplication: {
        __typename?: "TeacherApplication";
        uid: string;
        legal_name: string | null;
        status: TeacherApplicationStatus;
        submitted_at: any | null;
        reviewed_at: any | null;
        teaching_experience: string | null;
        teaching_credentials: string | null;
        class_types: string | null;
        online_profiles: string | null;
        sample_classes: string | null;
        class_subjects: Array<string | null> | null;
        age_ranges_taught: Array<string | null> | null;
        years_of_experience: string | null;
        how_did_you_hear_about_us: string | null;
        experience_types: Array<string | null> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        showCalendar: boolean | null;
        mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
      } | null;
      selfElectedStateFundingProgram: {
        __typename?: "SelfElectedStateFundingProgram";
        stateAbbreviation: string;
        stateName: string;
        fundingOptions: {
          __typename?: "SelfElectedStateFundingOptions";
          charter: boolean;
          reimbursement: boolean;
          statePortal: boolean;
          selfPay: boolean;
          otherProgramName: string | null;
          stateProgramName: string | null;
          stateDebitCard: boolean | null;
        };
      } | null;
      billingAddress: {
        __typename?: "BillingAddress";
        country: string | null;
        postalCode: string | null;
      } | null;
    };
  };
};

export type AssignAsOrganizationAdminMutationVariables = Exact<{
  userUid: Scalars["ID"];
  organizationUid: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
}>;

export type AssignAsOrganizationAdminMutation = {
  __typename?: "Mutation";
  assignAsOrganizationAdmin: {
    __typename?: "AdminUserAction";
    uid: string;
    created_at: any;
    action: string;
    notes: string | null;
    customValue: string | null;
    admin: { __typename?: "User"; uid: string; name: string | null };
    user: {
      __typename?: "User";
      uid: string;
      roles: Array<string> | null;
      teacher_featured_at: any | null;
      slug_id: string;
      name: string | null;
      email: string | null;
      isLearnerModeEnabled: boolean | null;
      confirmed_at: any | null;
      subscribed_at: any | null;
      email_bounced_at: any | null;
      default_currency: string | null;
      phone: string | null;
      photo: string | null;
      leader_subscribed_at: any | null;
      calendar_uid: string;
      intercomUserHash: string | null;
      payout_email: string | null;
      owner_of_seller_org_uid: string | null;
      admin_for_organization_uid: string | null;
      do_not_sell_my_personal_info: boolean;
      background_checked_at: any | null;
      background_check_started_at: any | null;
      interview_scheduled_at: any | null;
      interviewed_at: any | null;
      classroom_training_scheduled_at: any | null;
      classroom_trained_at: any | null;
      latestLegalName: string | null;
      hasCompletedRequiredProfessionalLearning: boolean;
      hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
      hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
      teacher_approved_at: any | null;
      is_crosslister: boolean | null;
      introduction: string | null;
      created_at: any;
      updated_at: any;
      deleted_at: any | null;
      suspended_at: any | null;
      is_admin: boolean | null;
      learner_uses_parent_mode: boolean;
      leader_link: string | null;
      unreadMessageThreadsCount: number;
      unreadPrivateClassMessageThreadsCount: number;
      unreadAssignmentCommentThreadsCount: number;
      locale: UserLocale;
      isRecordingAutopostEnabled: boolean | null;
      learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
      anonymousId: string | null;
      wasReferred: boolean;
      isEducatorBetaTester: boolean | null;
      consented_to_coppa_notice_at: any | null;
      hasVerifiedIdentity: boolean | null;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
      privacy_state: string | null;
      hasAcceptedNewPrivacyTerms: boolean;
      profile_link_uid: string | null;
      hasSubscription: boolean;
      hasEverSubscribed: boolean;
      hasEsaMembership: boolean;
      esaMembershipPrograms: Array<string> | null;
      canPayWithSubscriptionCredits: boolean;
      upgradablePackages: Array<number | null> | null;
      requiresMembershipForEnrollment: boolean | null;
      hasUsedPublicFunding: boolean | null;
      isCharterUser: boolean | null;
      details: {
        __typename?: "UserDetails";
        holdMessages: boolean | null;
        about: string | null;
        headline: string | null;
        countryOfResidence: string | null;
        introduction: string | null;
        browserTimeZone: string | null;
        timeRangeAfterSchool: boolean | null;
        timeRangeSchool: boolean | null;
        timeRangeWeekend: boolean | null;
        socialOptOut: boolean | null;
        howFoundOutschool: string | null;
        howFoundOutschoolOther: string | null;
        educationApproach: string | null;
        adminDashboardUrl: string | null;
        experiments: Array<string | null> | null;
        bannerClosedAt: string | null;
      };
      otherEmailDetails: Array<{
        __typename?: "OtherEmailDetails";
        uid: string;
        email: string;
        confirmed_at: any | null;
      } | null> | null;
      firstPaidEnrollment: {
        __typename?: "Enrollment";
        uid: string;
        confirmed_at: any | null;
      } | null;
      location: {
        __typename?: "Location";
        address: string | null;
        city: string | null;
        lat: number | null;
        lng: number | null;
        timeZone: string | null;
        state: string | null;
      } | null;
      organizationAdmin: {
        __typename?: "OrganizationAdmin";
        organization: {
          __typename?: "Organization";
          uid: string;
          name: string;
          type: OrganizationType;
        };
      } | null;
      children: Array<{
        __typename?: "Child";
        uid: string;
        name: string | null;
        age: number | null;
        birthMonth: number | null;
        date_of_birth: any | null;
        birthYear: number | null;
        email: string | null;
        avatar: string | null;
        unlockedAvatars: Array<string>;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        email_confirmed_at: any | null;
        hasMarketingConsent: boolean | null;
        hasHealthConsent: boolean | null;
        isLoginEnabled: boolean;
        username: string | null;
        hasPassword: boolean;
        hasEsaMembership: boolean;
        esaMembershipProgram: string | null;
        attributes: Array<{
          __typename?: "EntityAttribute";
          uid: string;
          key: string;
          value: string;
          source: string | null;
        }>;
        entityAvailabilitySchedule: {
          __typename?: "EntityAvailabilitySchedule";
          entityAvailabilities: Array<{
            __typename?: "EntityAvailability";
            startHour: number;
            startMinute: number;
            day: number;
            endHour: number;
            endMinute: number;
            uid: string;
          }>;
        } | null;
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      interfacePreferences: {
        __typename?: "InterfacePreferences";
        activityFormatDescriptionFlexHidden: boolean;
        activityFormatDescriptionOngoingHidden: boolean;
        activityFormatDescriptionOneTimeHidden: boolean;
        activityFormatDescriptionMultiDayHidden: boolean;
        defaultScheduleFilters: {
          __typename?: "UserScheduleFilters";
          startAfter: string | null;
          endBy: string | null;
          startAfterTime: number | null;
          endByTime: number | null;
          dow: string | null;
        };
      };
      schoolClosure: {
        __typename?: "SchoolClosure";
        application_status: FfapApplicationStatus | null;
        needs_assistance: boolean | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        uid: string;
        name: string;
        userLimitCents: number;
        purchaseLimitCents: number | null;
        totalCapCents: number;
        startAfter: any;
        endBy: any;
        buyerOrgName: string | null;
        isTotalCapReached: boolean;
        remainingCapCents: number | null;
        requirePaymentMethod: boolean;
        isOfferLimitReached: boolean;
        userOfferEmail: string | null;
        discount: number | null;
        isFinancialAid: boolean;
      } | null;
      sellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
        leader_link: string | null;
        currentUserIsOwner: boolean | null;
        currentUserIsTeacher: boolean | null;
        hasApprovedTeacherAccountForOwner: boolean | null;
      } | null;
      latestSellerOrgApplication: {
        __typename?: "SellerOrgApplication";
        uid: string;
        status: SellerOrgApplicationStatus;
        appliedAt: any | null;
        createdAt: any | null;
        approvedAt: any | null;
        rejectedAt: any | null;
        contractSignedAt: any | null;
        adminResponse: string | null;
      } | null;
      latestTeacherApplication: {
        __typename?: "TeacherApplication";
        uid: string;
        legal_name: string | null;
        status: TeacherApplicationStatus;
        submitted_at: any | null;
        reviewed_at: any | null;
        teaching_experience: string | null;
        teaching_credentials: string | null;
        class_types: string | null;
        online_profiles: string | null;
        sample_classes: string | null;
        class_subjects: Array<string | null> | null;
        age_ranges_taught: Array<string | null> | null;
        years_of_experience: string | null;
        how_did_you_hear_about_us: string | null;
        experience_types: Array<string | null> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        showCalendar: boolean | null;
        mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
      } | null;
      selfElectedStateFundingProgram: {
        __typename?: "SelfElectedStateFundingProgram";
        stateAbbreviation: string;
        stateName: string;
        fundingOptions: {
          __typename?: "SelfElectedStateFundingOptions";
          charter: boolean;
          reimbursement: boolean;
          statePortal: boolean;
          selfPay: boolean;
          otherProgramName: string | null;
          stateProgramName: string | null;
          stateDebitCard: boolean | null;
        };
      } | null;
      billingAddress: {
        __typename?: "BillingAddress";
        country: string | null;
        postalCode: string | null;
      } | null;
    };
  };
};

export type AdminUserIncidentFragmentFragment = {
  __typename?: "AdminUserIncident";
  uid: string;
  created_at: any;
  updated_at: any;
  category: string;
  notes: string | null;
};

export type AgreementTemplateQueryQueryVariables = Exact<{
  uid?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
}>;

export type AgreementTemplateQueryQuery = {
  __typename?: "Query";
  agreementTemplate: {
    __typename?: "SellerOrgAgreementTemplate";
    uid: string;
    name: string;
    template: string;
    createdAt: any;
    updatedAt: any;
  };
};

export type ReferrerUserNameQueryVariables = Exact<{ [key: string]: never }>;

export type ReferrerUserNameQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    referrerNameOrEmail: string | null;
  } | null;
};

export type UpdateCurrentUserReferrerMutationVariables = Exact<{
  referrerCode: Scalars["String"];
}>;

export type UpdateCurrentUserReferrerMutation = {
  __typename?: "Mutation";
  updateCurrentUserReferrer: string;
};

export type LoginMutationVariables = Exact<{
  emailOrUsername: Scalars["String"];
  password: Scalars["String"];
  postLoginOption?: InputMaybe<PostLoginOption>;
  integrityToken?: InputMaybe<Scalars["String"]>;
}>;

export type LoginMutation = {
  __typename?: "Mutation";
  passwordLogin:
    | {
        __typename: "AuthenticationV2";
        refreshToken: string;
        sessionToken: string;
        learnerTransferToken: string | null;
      }
    | {
        __typename: "AuthenticationV1";
        sessionToken: string;
        learnerTransferToken: string | null;
      };
};

export type ChangePasswordMutationVariables = Exact<{
  uid: Scalars["ID"];
  token: Scalars["String"];
  password: Scalars["String"];
}>;

export type ChangePasswordMutation = {
  __typename?: "Mutation";
  changePassword: {
    __typename?: "AuthenticationV2";
    sessionToken: string;
    refreshToken: string;
  };
};

export type ChangeLearnerPasswordMutationVariables = Exact<{
  uid: Scalars["ID"];
  token: Scalars["String"];
  password: Scalars["String"];
}>;

export type ChangeLearnerPasswordMutation = {
  __typename?: "Mutation";
  changeLearnerPassword: {
    __typename?: "AuthTransferToken";
    transferToken: string;
  };
};

export type ConfirmEmailMutationVariables = Exact<{
  uid: Scalars["ID"];
  token: Scalars["String"];
}>;

export type ConfirmEmailMutation = {
  __typename?: "Mutation";
  confirmEmail: {
    __typename?: "AuthenticationV2";
    sessionToken: string;
    refreshToken: string;
  };
};

export type ConfirmOtherEmailMutationVariables = Exact<{
  uid: Scalars["ID"];
  token: Scalars["String"];
}>;

export type ConfirmOtherEmailMutation = {
  __typename?: "Mutation";
  confirmOtherEmail: boolean;
};

export type GetLearnerModeTransferTokenMutationVariables = Exact<{
  learnerUid: Scalars["ID"];
}>;

export type GetLearnerModeTransferTokenMutation = {
  __typename?: "Mutation";
  learnerModeTransferToken: {
    __typename?: "AuthTransferToken";
    transferToken: string;
  };
};

export type AvailabilityFragmentFragment = {
  __typename?: "Availability";
  updated_at: any | null;
  hourlyTimetable: {
    __typename?: "HourlyTimetable";
    mon: Array<number>;
    tue: Array<number>;
    wed: Array<number>;
    thu: Array<number>;
    fri: Array<number>;
    sat: Array<number>;
    sun: Array<number>;
  } | null;
};

type BaseEnrollmentFragment_Enrollment_Fragment = {
  __typename?: "Enrollment";
  uid: string;
  createdAt: any;
  confirmedAt: any | null;
  withdrawnAt: any | null;
  ongoingStoppedAt: any | null;
  ongoingStartTime: any | null;
  ongoingEndTime: any | null;
  canBeWithdrawn: boolean;
  canBeStopped: boolean;
  priceCents: number | null;
  refundableAmountCents: number;
  currency_code: CurrencyCode;
  exchange_rate: number;
  amount_in_local_currency: number;
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  };
  learner: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    isVerified: boolean;
    isBlocked: boolean | null;
    blockedByUserUid: string | null;
    blockedAt: any | null;
  } | null;
  buyer: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  } | null;
  pricingOffer: {
    __typename?: "PricingOffer";
    name: string;
    buyerOrgName: string | null;
    isFinancialAid: boolean;
  } | null;
  details: {
    __typename?: "EnrollmentDetails";
    name: string | null;
    age: string | null;
    attendedAt: any | null;
    message: string | null;
  };
  payments: Array<{
    __typename?: "EnrollmentPayment";
    uid: string;
    amount_cents: number | null;
    order_slug_id: string | null;
    stripe_charge_id: string | null;
    purchase_order_id: string | null;
    esa_order_id: string | null;
    intercom_url: string | null;
    last4: string | null;
    created_at: any | null;
    paid_at: any | null;
    disbursed_at: any | null;
    payout_uid: string | null;
    start_time: any | null;
    end_time: any | null;
    unrefundedCents: number;
    isOngoingRefundable: boolean;
    voucher_name: string | null;
    pricing_offer_uid: string | null;
    credit_transaction_uid: string | null;
    credit_account_type: string | null;
    coupon_code_uid: string | null;
    currency_code: CurrencyCode | null;
    exchange_rate: number | null;
    invoice_uid: string | null;
    funding_program_invoice_uid: string | null;
    service_fee_percentage: number | null;
    organization: {
      __typename?: "Organization";
      uid: string;
      name: string;
      state: string | null;
      logoUrl: string | null;
      urlName: string | null;
    } | null;
    refunds: Array<{
      __typename?: "EnrollmentPaymentRefund";
      uid: string;
      user_uid: string;
      amount_cents: number;
      amount_credits: number | null;
      refunded_at: any | null;
      reason: string | null;
      user_role: string | null;
      note: string | null;
      reduces_teacher_payout: boolean;
      amount_in_local_currency: number | null;
      currency_code: CurrencyCode | null;
      exchange_rate: number | null;
      addOutschoolCreditTransaction: {
        __typename?: "CreditTransaction";
        uid: string;
        amount_cents: number;
        expiresAt: any | null;
        unspentCents: number | null;
      } | null;
    }>;
    couponCode: {
      __typename?: "CouponCode";
      code: string;
      coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
  }>;
  refundPolicy: {
    __typename?: "RefundPolicy";
    type: RefundPolicyType;
    name: string;
    description: string;
  } | null;
};

type BaseEnrollmentFragment_GiftEnrollment_Fragment = {
  __typename?: "GiftEnrollment";
  uid: string;
  createdAt: any;
  confirmedAt: any | null;
  withdrawnAt: any | null;
  ongoingStoppedAt: any | null;
  ongoingStartTime: any | null;
  ongoingEndTime: any | null;
  canBeWithdrawn: boolean;
  canBeStopped: boolean;
  priceCents: number | null;
  refundableAmountCents: number;
  currency_code: CurrencyCode;
  exchange_rate: number;
  amount_in_local_currency: number;
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  } | null;
  learner: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    isVerified: boolean;
    isBlocked: boolean | null;
    blockedByUserUid: string | null;
    blockedAt: any | null;
  } | null;
  buyer: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  };
  pricingOffer: {
    __typename?: "PricingOffer";
    name: string;
    buyerOrgName: string | null;
    isFinancialAid: boolean;
  } | null;
  details: {
    __typename?: "EnrollmentDetails";
    name: string | null;
    age: string | null;
    attendedAt: any | null;
    message: string | null;
  };
  payments: Array<{
    __typename?: "EnrollmentPayment";
    uid: string;
    amount_cents: number | null;
    order_slug_id: string | null;
    stripe_charge_id: string | null;
    purchase_order_id: string | null;
    esa_order_id: string | null;
    intercom_url: string | null;
    last4: string | null;
    created_at: any | null;
    paid_at: any | null;
    disbursed_at: any | null;
    payout_uid: string | null;
    start_time: any | null;
    end_time: any | null;
    unrefundedCents: number;
    isOngoingRefundable: boolean;
    voucher_name: string | null;
    pricing_offer_uid: string | null;
    credit_transaction_uid: string | null;
    credit_account_type: string | null;
    coupon_code_uid: string | null;
    currency_code: CurrencyCode | null;
    exchange_rate: number | null;
    invoice_uid: string | null;
    funding_program_invoice_uid: string | null;
    service_fee_percentage: number | null;
    organization: {
      __typename?: "Organization";
      uid: string;
      name: string;
      state: string | null;
      logoUrl: string | null;
      urlName: string | null;
    } | null;
    refunds: Array<{
      __typename?: "EnrollmentPaymentRefund";
      uid: string;
      user_uid: string;
      amount_cents: number;
      amount_credits: number | null;
      refunded_at: any | null;
      reason: string | null;
      user_role: string | null;
      note: string | null;
      reduces_teacher_payout: boolean;
      amount_in_local_currency: number | null;
      currency_code: CurrencyCode | null;
      exchange_rate: number | null;
      addOutschoolCreditTransaction: {
        __typename?: "CreditTransaction";
        uid: string;
        amount_cents: number;
        expiresAt: any | null;
        unspentCents: number | null;
      } | null;
    }>;
    couponCode: {
      __typename?: "CouponCode";
      code: string;
      coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
  }>;
  refundPolicy: {
    __typename?: "RefundPolicy";
    type: RefundPolicyType;
    name: string;
    description: string;
  } | null;
};

export type BaseEnrollmentFragmentFragment =
  | BaseEnrollmentFragment_Enrollment_Fragment
  | BaseEnrollmentFragment_GiftEnrollment_Fragment;

export type BlockLearnerMutationVariables = Exact<{
  educatorUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
  reason: Scalars["String"];
  note?: InputMaybe<Scalars["String"]>;
}>;

export type BlockLearnerMutation = {
  __typename?: "Mutation";
  blockLearner: boolean;
};

export type UnblockLearnerMutationVariables = Exact<{
  educatorUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
}>;

export type UnblockLearnerMutation = {
  __typename?: "Mutation";
  unblockLearner: boolean;
};

export type CategoryPageQueryVariables = Exact<{
  slug: Scalars["String"];
}>;

export type CategoryPageQuery = {
  __typename?: "Query";
  categoryPage: {
    __typename?: "CategoryPage";
    uid: string;
    nameTitleCased: string;
    nameSentenceCased: string;
    reviewTitle: string;
    reviewTitleWithPhotos: string;
    slug: string;
    basePath: string;
    title: string | null;
    description: string | null;
    heroValueProps: string | null;
    heroImageUrl: string | null;
    belowFoldTitle: string | null;
    belowFoldDescription: string | null;
    searchFilters: {
      __typename?: "SavedSearchFilters";
      adminTags: Array<string> | null;
      age: string | null;
      capacityMax: number | null;
      capacityMin: number | null;
      delivery: string | null;
      dow: string | null;
      enabledBooleanFilters: string | null;
      endBy: string | null;
      endByTime: number | null;
      format: string | null;
      fundingPrograms: Array<string> | null;
      hasFilledOutUniqueLearningNeeds: boolean | null;
      languageOfInstruction: string | null;
      multiTermQuery: Array<string> | null;
      order: string | null;
      pricePerMeetingMax: number | null;
      pricePerMeetingMin: number | null;
      q: string | null;
      startAfter: string | null;
      startAfterTime: number | null;
      startBefore: string | null;
      theme: string | null;
      time: string | null;
      timeOfDay: string | null;
      timeZone: string | null;
      uniqueLearningNeeds: string | null;
      includedWithMembership: boolean | null;
    } | null;
    ancestors: Array<{
      __typename?: "CategoryPage";
      uid: string;
      nameTitleCased: string;
      nameSentenceCased: string;
      slug: string;
      basePath: string;
    } | null> | null;
    related: Array<{
      __typename?: "CategoryPage";
      uid: string;
      nameTitleCased: string;
      nameSentenceCased: string;
      slug: string;
      basePath: string;
    } | null> | null;
    parent: {
      __typename?: "CategoryPage";
      uid: string;
      nameTitleCased: string;
      nameSentenceCased: string;
      slug: string;
      basePath: string;
    } | null;
    siblings: Array<{
      __typename?: "CategoryPage";
      uid: string;
      nameTitleCased: string;
      nameSentenceCased: string;
      slug: string;
      basePath: string;
    } | null> | null;
    children: Array<{
      __typename?: "CategoryPage";
      uid: string;
      nameTitleCased: string;
      nameSentenceCased: string;
      slug: string;
      basePath: string;
    } | null> | null;
    grandparent: {
      __typename?: "CategoryPage";
      uid: string;
      nameTitleCased: string;
      nameSentenceCased: string;
      slug: string;
      basePath: string;
    } | null;
    parentalSiblings: Array<{
      __typename?: "CategoryPage";
      uid: string;
      nameTitleCased: string;
      nameSentenceCased: string;
      slug: string;
      basePath: string;
    } | null> | null;
  } | null;
};

export type CharterSchoolFragmentFragment = {
  __typename?: "Organization";
  uid: string;
  name: string;
  state: string | null;
  logoUrl: string | null;
  urlName: string | null;
};

export type UpdateClassPostMutationVariables = Exact<{
  classPostUid: Scalars["ID"];
  messageContentInput?: InputMaybe<MessageContentInput>;
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UpdateClassPostMutation = {
  __typename?: "Mutation";
  updateClassPost: {
    __typename?: "ClassPost";
    uid: string;
    isWelcomePost: boolean;
    publishAt: any;
    title: string | null;
    promotedAt: any | null;
    pinnedAt: any | null;
    mentionedEnrollmentUids: Array<string>;
    backgroundColor: string | null;
    score: number | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    commentsPreview: {
      __typename?: "CommentsPreview";
      remainingCommentsCount: number;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  };
};

export type ClassRequestFragmentFragment = {
  __typename?: "ClassRequest";
  uid: string;
  age: number;
  content: string;
};

export type ClassScheduleRequestFragmentFragment = {
  __typename?: "ClassScheduleRequest";
  uid: string;
  timeZone: string;
  message: string | null;
  created_at: any;
  parentEnrolledAt: any | null;
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  };
  timetable: {
    __typename?: "Timetable";
    mon: {
      __typename?: "TimetableTimes";
      f8_12: boolean;
      f12_4: boolean;
      f4_8: boolean;
    };
    tue: {
      __typename?: "TimetableTimes";
      f8_12: boolean;
      f12_4: boolean;
      f4_8: boolean;
    };
    wed: {
      __typename?: "TimetableTimes";
      f8_12: boolean;
      f12_4: boolean;
      f4_8: boolean;
    };
    thu: {
      __typename?: "TimetableTimes";
      f8_12: boolean;
      f12_4: boolean;
      f4_8: boolean;
    };
    fri: {
      __typename?: "TimetableTimes";
      f8_12: boolean;
      f12_4: boolean;
      f4_8: boolean;
    };
    sat: {
      __typename?: "TimetableTimes";
      f8_12: boolean;
      f12_4: boolean;
      f4_8: boolean;
    };
    sun: {
      __typename?: "TimetableTimes";
      f8_12: boolean;
      f12_4: boolean;
      f4_8: boolean;
    };
  };
};

export type CreateClassScheduleRequestMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  timetable: TimetableInput;
  timeZone: Scalars["String"];
  message: Scalars["String"];
}>;

export type CreateClassScheduleRequestMutation = {
  __typename?: "Mutation";
  createClassScheduleRequest: {
    __typename?: "ClassScheduleRequest";
    uid: string;
    timeZone: string;
    message: string | null;
    created_at: any;
    parentEnrolledAt: any | null;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    timetable: {
      __typename?: "Timetable";
      mon: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      tue: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      wed: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      thu: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      fri: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      sat: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      sun: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
    };
  };
};

export type LastClassScheduleRequestQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LastClassScheduleRequestQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    lastClassScheduleRequest: {
      __typename?: "ClassScheduleRequest";
      uid: string;
      timeZone: string;
      message: string | null;
      created_at: any;
      parentEnrolledAt: any | null;
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      timetable: {
        __typename?: "Timetable";
        mon: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        tue: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        wed: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        thu: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        fri: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        sat: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        sun: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
      };
    } | null;
  } | null;
};

type ClassStatusEnrollment_Enrollment_Fragment = {
  __typename?: "Enrollment";
  isPaused: boolean;
  ongoingStartTime: any | null;
  isEnded: boolean;
  ongoingEndTime: any | null;
  cancellationType: EnrollmentCancellationType | null;
  withdrawnAt: any | null;
  isWithdrawn: boolean;
  pauseWindow: {
    __typename?: "EnrollmentPauseWindow";
    uid: string;
    startDate: any;
    pauseReason: string;
  } | null;
  upcomingPausedMeeting: { __typename?: "Meeting"; start_time: any } | null;
};

type ClassStatusEnrollment_GiftEnrollment_Fragment = {
  __typename?: "GiftEnrollment";
  isPaused: boolean;
  ongoingStartTime: any | null;
  isEnded: boolean;
  ongoingEndTime: any | null;
  cancellationType: EnrollmentCancellationType | null;
  withdrawnAt: any | null;
  isWithdrawn: boolean;
  pauseWindow: {
    __typename?: "EnrollmentPauseWindow";
    uid: string;
    startDate: any;
    pauseReason: string;
  } | null;
  upcomingPausedMeeting: { __typename?: "Meeting"; start_time: any } | null;
};

export type ClassStatusEnrollmentFragment =
  | ClassStatusEnrollment_Enrollment_Fragment
  | ClassStatusEnrollment_GiftEnrollment_Fragment;

export type ClassStatusSectionFragment = {
  __typename?: "Section";
  currentUserCanManage: boolean;
  is_self_paced: boolean;
  teacher_support_start_time: any | null;
  start_time: any | null;
  end_time: any | null;
  canceled_at: any | null;
  deleted_at: any | null;
  published_at: any | null;
  activity: { __typename?: "Activity"; is_ongoing_weekly: boolean };
};

export type V2Teacher_AttachmentFragment = {
  __typename?: "Attachment";
  uid: string;
  fileUrl: string;
  videoThumbnailUrl: string | null;
  conversionStatus: string | null;
  created_at: any;
  file: {
    __typename?: "File";
    filename: string;
    mimetype: string | null;
    size: number;
    url: string;
    thumbUrl: string | null;
  };
};

export type V2Teacher_MessageContentFragment = {
  __typename?: "MessageContent";
  uid: string;
  text: string | null;
  originalMimeType: TextMimeType;
  externalVideoUrl: string | null;
  editedAt: any | null;
  htmlText: string | null;
  attachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
  imageAttachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
};

export type V2Teacher_LessonPostFragment = {
  __typename?: "LessonPost";
  uid: string;
  title: string | null;
  lessonUid: string;
  orderInLesson: number;
  deleted_at: any | null;
  is_posted_for_enrollments: boolean;
  is_posted_for_subscriptions: boolean;
  estimatedDuration: number | null;
  blockType: BlockType | null;
  isClassListingVideoPreview: boolean;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type V2Teacher_AssignmentLessonPostFragment = {
  __typename?: "AssignmentLessonPost";
  uid: string;
  title: string | null;
  lessonUid: string;
  orderInLesson: number;
  deleted_at: any | null;
  submissionRequirement: SubmissionRequirementType;
  isClassListingVideoPreview: boolean;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type V2Teacher_SyllabusFieldsFragment = {
  __typename?: "Syllabus";
  uid: string;
  isFrozen: boolean;
  published_at: string | null;
  layoutVersion: number;
  lessons: Array<{
    __typename?: "Lesson";
    uid: string;
    title: string | null;
    description: string | null;
    week_number: number;
    order_within_week: number;
    lessonPosts: Array<{
      __typename?: "LessonPost";
      uid: string;
      title: string | null;
      lessonUid: string;
      orderInLesson: number;
      deleted_at: any | null;
      is_posted_for_enrollments: boolean;
      is_posted_for_subscriptions: boolean;
      estimatedDuration: number | null;
      blockType: BlockType | null;
      isClassListingVideoPreview: boolean;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }>;
    assignmentLessonPosts: Array<{
      __typename?: "AssignmentLessonPost";
      uid: string;
      title: string | null;
      lessonUid: string;
      orderInLesson: number;
      deleted_at: any | null;
      submissionRequirement: SubmissionRequirementType;
      isClassListingVideoPreview: boolean;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }>;
  }>;
};

export type TeacherClassroomV2QueryVariables = Exact<{
  activityUid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type TeacherClassroomV2Query = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    draftSyllabus: {
      __typename?: "Syllabus";
      uid: string;
      isFrozen: boolean;
      published_at: string | null;
      layoutVersion: number;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        description: string | null;
        week_number: number;
        order_within_week: number;
        lessonPosts: Array<{
          __typename?: "LessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          is_posted_for_enrollments: boolean;
          is_posted_for_subscriptions: boolean;
          estimatedDuration: number | null;
          blockType: BlockType | null;
          isClassListingVideoPreview: boolean;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
        assignmentLessonPosts: Array<{
          __typename?: "AssignmentLessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          submissionRequirement: SubmissionRequirementType;
          isClassListingVideoPreview: boolean;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      }>;
    } | null;
    publishedSyllabus: {
      __typename?: "Syllabus";
      uid: string;
      isFrozen: boolean;
      published_at: string | null;
      layoutVersion: number;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        description: string | null;
        week_number: number;
        order_within_week: number;
        lessonPosts: Array<{
          __typename?: "LessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          is_posted_for_enrollments: boolean;
          is_posted_for_subscriptions: boolean;
          estimatedDuration: number | null;
          blockType: BlockType | null;
          isClassListingVideoPreview: boolean;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
        assignmentLessonPosts: Array<{
          __typename?: "AssignmentLessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          submissionRequirement: SubmissionRequirementType;
          isClassListingVideoPreview: boolean;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      }>;
    } | null;
  };
};

export type V2AddLessonPostMutationVariables = Exact<{
  createLessonPostInput: CreateLessonPostInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type V2AddLessonPostMutation = {
  __typename?: "Mutation";
  addLessonPost: {
    __typename?: "LessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    is_posted_for_enrollments: boolean;
    is_posted_for_subscriptions: boolean;
    estimatedDuration: number | null;
    blockType: BlockType | null;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type V2UpdateLessonPostMutationVariables = Exact<{
  lessonPostUid: Scalars["ID"];
  updateLessonPostInput: UpdateLessonPostInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type V2UpdateLessonPostMutation = {
  __typename?: "Mutation";
  updateLessonPost: {
    __typename?: "LessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    is_posted_for_enrollments: boolean;
    is_posted_for_subscriptions: boolean;
    estimatedDuration: number | null;
    blockType: BlockType | null;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type V2DeleteLessonPostMutationVariables = Exact<{
  lessonPostUid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type V2DeleteLessonPostMutation = {
  __typename?: "Mutation";
  deleteLessonPost: {
    __typename?: "LessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    is_posted_for_enrollments: boolean;
    is_posted_for_subscriptions: boolean;
    estimatedDuration: number | null;
    blockType: BlockType | null;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type V2AddAssignmentLessonPostMutationVariables = Exact<{
  createAssignmentLessonPostInput: CreateAssignmentLessonPostInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type V2AddAssignmentLessonPostMutation = {
  __typename?: "Mutation";
  addAssignmentLessonPost: {
    __typename?: "AssignmentLessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    submissionRequirement: SubmissionRequirementType;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type V2UpdateAssignmentLessonPostMutationVariables = Exact<{
  assignmentLessonPostUid: Scalars["ID"];
  updateAssignmentLessonPostInput: UpdateAssignmentLessonPostInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type V2UpdateAssignmentLessonPostMutation = {
  __typename?: "Mutation";
  updateAssignmentLessonPost: {
    __typename?: "AssignmentLessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    submissionRequirement: SubmissionRequirementType;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type V2DeleteAssignmentLessonPostMutationVariables = Exact<{
  assignmentLessonPostUid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type V2DeleteAssignmentLessonPostMutation = {
  __typename?: "Mutation";
  deleteAssignmentLessonPost: {
    __typename?: "AssignmentLessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    submissionRequirement: SubmissionRequirementType;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type V2ConvertLessonPostToAssignmentMutationVariables = Exact<{
  lessonPostUid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type V2ConvertLessonPostToAssignmentMutation = {
  __typename?: "Mutation";
  convertLessonPostToAssignmentLessonPost: {
    __typename?: "AssignmentLessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    submissionRequirement: SubmissionRequirementType;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type V2ConvertAssignmentToLessonPostMutationVariables = Exact<{
  assignmentLessonPostUid: Scalars["ID"];
  blockType: BlockType;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type V2ConvertAssignmentToLessonPostMutation = {
  __typename?: "Mutation";
  convertAssignmentLessonPostToLessonPost: {
    __typename?: "LessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    is_posted_for_enrollments: boolean;
    is_posted_for_subscriptions: boolean;
    estimatedDuration: number | null;
    blockType: BlockType | null;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type V2AddLessonMutationVariables = Exact<{
  syllabusUid: Scalars["ID"];
  previousLessonUid?: InputMaybe<Scalars["ID"]>;
  title?: InputMaybe<Scalars["String"]>;
}>;

export type V2AddLessonMutation = {
  __typename?: "Mutation";
  addLesson: {
    __typename?: "Syllabus";
    uid: string;
    lessons: Array<{
      __typename?: "Lesson";
      uid: string;
      title: string | null;
    }>;
  };
};

export type V2UpdateLessonMutationVariables = Exact<{
  lessonUid: Scalars["ID"];
  updates: LessonInput;
}>;

export type V2UpdateLessonMutation = {
  __typename?: "Mutation";
  updateLesson: {
    __typename?: "Syllabus";
    uid: string;
    lessons: Array<{
      __typename?: "Lesson";
      uid: string;
      title: string | null;
      description: string | null;
    }>;
  };
};

export type V2DeleteLessonMutationVariables = Exact<{
  lessonUid: Scalars["ID"];
}>;

export type V2DeleteLessonMutation = {
  __typename?: "Mutation";
  deleteLesson: { __typename?: "Syllabus"; uid: string };
};

export type V2ReorderLessonsMutationVariables = Exact<{
  syllabusUid: Scalars["ID"];
  orderedLessonUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type V2ReorderLessonsMutation = {
  __typename?: "Mutation";
  reorderLessons: {
    __typename?: "Syllabus";
    uid: string;
    lessons: Array<{
      __typename?: "Lesson";
      uid: string;
      order_within_week: number;
    }>;
  };
};

export type V2ReorderLessonItemsMutationVariables = Exact<{
  lessonUid: Scalars["ID"];
  orderedItemUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type V2ReorderLessonItemsMutation = {
  __typename?: "Mutation";
  reorderLessonItems: boolean;
};

export type V2CreateNewVersionMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  layoutVersion?: InputMaybe<Scalars["Int"]>;
}>;

export type V2CreateNewVersionMutation = {
  __typename?: "Mutation";
  createSyllabus: { __typename?: "Syllabus"; uid: string };
};

export type V2PublishSyllabusMutationVariables = Exact<{
  syllabusUid: Scalars["ID"];
}>;

export type V2PublishSyllabusMutation = {
  __typename?: "Mutation";
  publishSyllabus: { __typename?: "Syllabus"; uid: string };
};

export type V2DeleteDraftSyllabusMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  syllabusVersionUid?: InputMaybe<Scalars["ID"]>;
}>;

export type V2DeleteDraftSyllabusMutation = {
  __typename?: "Mutation";
  deleteSyllabus: { __typename?: "Syllabus"; uid: string };
};

export type ClubEditPageQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type ClubEditPageQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    tags: string | null;
    archived_at: any | null;
    canRequestListing: boolean;
    isSelfPacedEnrollmentEnabled: boolean;
    saveCount: number | null;
    requested_listing_at: any | null;
    upsell_activity_uid: string | null;
    why_me: string | null;
    parental_guidance: string | null;
    sources: string | null;
    materials: string | null;
    hasSections: boolean;
    has_external_resources: boolean | null;
    attributes: Array<{
      __typename?: "EntityAttribute";
      key: string;
      value: string;
      entity_type: string;
      source: string | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    videoForLearners: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    clubWelcomeVideo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    clubBannerImage: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    clubGuidelines: {
      __typename?: "WelcomeMessage";
      text: string | null;
    } | null;
    sampleClubPost: {
      __typename?: "WelcomeMessage";
      text: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      }> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      publishedClassCount: number;
      listings: Array<{
        __typename?: "Listing";
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
      }>;
      ownerOfSellerOrg: {
        __typename?: "SellerOrg";
        userIsOwner: boolean | null;
      } | null;
    };
    leaderDetails: {
      __typename?: "ActivityLeaderDetails";
      uid: string;
      requestedListingAt: any | null;
      classRequest: {
        __typename?: "ClassRequest";
        uid: string;
        age: number;
        content: string;
      } | null;
      welcomeMessage: {
        __typename?: "WelcomeMessage";
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        }> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        } | null;
      } | null;
    };
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    clubSection: {
      __typename?: "Section";
      uid: string;
      published_at: any | null;
      deleted_at: any | null;
      canceled_at: any | null;
      start_time: any | null;
      end_time: any | null;
      size_max: number | null;
      currentUserCanManage: boolean;
      moderators: Array<{
        __typename?: "Leader";
        uid: string;
        name: string | null;
      }>;
    } | null;
    sampleClubPosts: Array<{
      __typename?: "SampleClubPost";
      text: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      }> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      } | null;
      comments: Array<{
        __typename?: "SampleClubPostComment";
        text: string | null;
      }>;
    }> | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    approvalStatus: {
      __typename?: "ActivityApprovalStatus";
      action: string;
      message_to_teacher: string | null;
    } | null;
    details: { __typename?: "ActivityDetails"; asyncTime: string | null };
    externalResources: Array<{
      __typename?: "ExternalResource";
      uid: string;
      name: string;
      url: string | null;
    }>;
  };
};

export type CouponFieldsFragmentFragment = {
  __typename?: "Coupon";
  name: string;
  isFirstPurchaseOnly: boolean;
  maxUsesPerUser: number;
  maxAmountCentsPerUse: number | null;
  minPurchaseAmountCents: number | null;
  startsAt: any | null;
  expiresAt: any | null;
  description: string | null;
  maxUses: number | null;
};

export type CreateCouponMutationVariables = Exact<{
  couponInput: CouponCreateInput;
  couponActivityConstraintsInput?: InputMaybe<CouponActivityConstraintsInput>;
}>;

export type CreateCouponMutation = {
  __typename?: "Mutation";
  createCoupon: { __typename?: "Coupon"; uid: string };
};

export type CreateCouponWithCodeMutationVariables = Exact<{
  couponInput: CouponCreateInput;
  couponCodeInput: CouponCodeCreateInput;
  couponActivityConstraintsInput?: InputMaybe<CouponActivityConstraintsInput>;
}>;

export type CreateCouponWithCodeMutation = {
  __typename?: "Mutation";
  createCouponWithCode: { __typename?: "Coupon"; uid: string };
};

export type UpdateCouponMutationVariables = Exact<{
  uid: Scalars["ID"];
  input: CouponUpdateInput;
}>;

export type UpdateCouponMutation = {
  __typename?: "Mutation";
  updateCoupon: {
    __typename?: "Coupon";
    uid: string;
    name: string;
    isFirstPurchaseOnly: boolean;
    maxUsesPerUser: number;
    maxAmountCentsPerUse: number | null;
    minPurchaseAmountCents: number | null;
    startsAt: any | null;
    expiresAt: any | null;
    description: string | null;
    maxUses: number | null;
  };
};

export type MultiSelectClassesListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MultiSelectClassesListQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    activities: Array<{ __typename?: "Activity"; uid: string; title: string }>;
  } | null;
};

export type CouponCodeListQueryVariables = Exact<{
  filter: CouponCodeListFilter;
}>;

export type CouponCodeListQuery = {
  __typename?: "Query";
  couponCodeList: {
    __typename?: "CouponCodeList";
    totalCount: number;
    data: Array<{
      __typename?: "CouponCode";
      uid: string;
      code: string;
      createdBy: string | null;
    } | null>;
  };
};

export type TeacherCouponCodeListQueryVariables = Exact<{
  filter: CouponCodeListFilter;
  offset?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type TeacherCouponCodeListQuery = {
  __typename?: "Query";
  couponCodeList: {
    __typename?: "CouponCodeList";
    totalCount: number;
    data: Array<{
      __typename?: "CouponCode";
      uid: string;
      code: string;
      createdBy: string | null;
      couponUid: string | null;
      totalRedemption: number | null;
      coupon: {
        __typename?: "Coupon";
        uid: string;
        name: string;
        createdBy: string | null;
        description: string | null;
        maxUsesPerUser: number;
        maxAmountCentsPerUse: number | null;
        startsAt: any | null;
        expiresAt: any | null;
        maxUses: number | null;
        activities: Array<{
          __typename?: "Activity";
          uid: string;
          title: string;
          slug_id: string;
          isClub: boolean;
        } | null> | null;
      } | null;
    } | null>;
  };
};

export type CouponCodeRedemptionDetailsFragmentFragment = {
  __typename?: "CouponCodeRedemptionDetails";
  orderSlugId: string | null;
  enrollmentPayments: Array<{
    __typename?: "EnrollmentPayment";
    uid: string;
    order_slug_id: string | null;
    created_at: any | null;
  }>;
  enrollments: Array<{
    __typename?: "Enrollment";
    uid: string;
    confirmedAt: any | null;
    buyer: { __typename?: "Parent"; name: string | null } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
    } | null;
    section: {
      __typename?: "Section";
      uid: string;
      activity: {
        __typename?: "Activity";
        uid: string;
        slug_id: string;
        title: string;
        titleTranslated: string | null;
      };
    } | null;
  }>;
};

export type CouponCodeRedemptionDetailsListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  couponCodeUid: Scalars["String"];
}>;

export type CouponCodeRedemptionDetailsListQuery = {
  __typename?: "Query";
  couponCodeRedemptionDetailsList: {
    __typename?: "CouponCodeRedemptionDetailsList";
    totalCount: number | null;
    data: Array<{
      __typename?: "CouponCodeRedemptionDetails";
      orderSlugId: string | null;
      enrollmentPayments: Array<{
        __typename?: "EnrollmentPayment";
        uid: string;
        order_slug_id: string | null;
        created_at: any | null;
      }>;
      enrollments: Array<{
        __typename?: "Enrollment";
        uid: string;
        confirmedAt: any | null;
        buyer: { __typename?: "Parent"; name: string | null } | null;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        } | null;
        section: {
          __typename?: "Section";
          uid: string;
          activity: {
            __typename?: "Activity";
            uid: string;
            slug_id: string;
            title: string;
            titleTranslated: string | null;
          };
        } | null;
      }>;
    }>;
  } | null;
};

export type CouponListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]>;
  filter: CouponListFilter;
}>;

export type CouponListQuery = {
  __typename?: "Query";
  couponList: {
    __typename?: "CouponList";
    totalCount: number;
    data: Array<{
      __typename?: "Coupon";
      uid: string;
      name: string;
      createdBy: string | null;
      description: string | null;
      maxUsesPerUser: number;
      maxAmountCentsPerUse: number | null;
      minPurchaseAmountCents: number | null;
      percentOff: number | null;
      startsAt: any | null;
      expiresAt: any | null;
      activities: Array<{
        __typename?: "Activity";
        title: string;
      } | null> | null;
    } | null>;
  };
};

export type CouponQueryVariables = Exact<{
  uid: Scalars["String"];
}>;

export type CouponQuery = {
  __typename?: "Query";
  coupon: {
    __typename?: "Coupon";
    uid: string;
    name: string;
    isFirstPurchaseOnly: boolean;
    isBuyerFirstPurchaseOfClassFormatOnly: boolean | null;
    maxUsesPerUser: number;
    maxAmountCentsPerUse: number | null;
    minPurchaseAmountCents: number | null;
    percentOff: number | null;
    startsAt: any | null;
    expiresAt: any | null;
    deletedAt: any | null;
    description: string | null;
    maxUses: number | null;
    classFormatsAllowed: Array<CouponClassFormats | null> | null;
    subjectsAllowed: Array<string> | null;
    activities: Array<{
      __typename?: "Activity";
      uid: string;
      title: string;
      slug_id: string;
    } | null> | null;
  };
};

export type CouponCodeExistsQueryVariables = Exact<{
  code: Scalars["String"];
}>;

export type CouponCodeExistsQuery = {
  __typename?: "Query";
  couponCodeExists: boolean;
};

export type CreditAccountFragmentFragment = {
  __typename?: "CreditAccount";
  uid: string;
  openToBuy: number;
  balance: number;
  updatedAt: any | null;
  status: CreditAccountStatus | null;
};

export type CreditAccountQueryVariables = Exact<{ [key: string]: never }>;

export type CreditAccountQuery = {
  __typename?: "Query";
  creditBalance: {
    __typename?: "CreditAccount";
    uid: string;
    openToBuy: number;
    balance: number;
    updatedAt: any | null;
    status: CreditAccountStatus | null;
  } | null;
};

export type AcceptPaymentWithStoredCreditMutationVariables = Exact<{
  orderSlugId: Scalars["ID"];
  amountCents: Scalars["Int"];
  currencyCode?: InputMaybe<CurrencyCode>;
  exchangeRate?: InputMaybe<Scalars["Float"]>;
}>;

export type AcceptPaymentWithStoredCreditMutation = {
  __typename?: "Mutation";
  acceptPaymentWithStoredCredit: string;
};

export type AcceptPaymentWithSubscriptionCreditMutationVariables = Exact<{
  orderSlugId: Scalars["ID"];
  amountCredits: Scalars["Int"];
  currencyCode?: InputMaybe<CurrencyCode>;
  exchangeRate?: InputMaybe<Scalars["Float"]>;
}>;

export type AcceptPaymentWithSubscriptionCreditMutation = {
  __typename?: "Mutation";
  acceptPaymentWithSubscriptionCredit: boolean;
};

export type AcceptPaymentWithEsaMembershipCreditMutationVariables = Exact<{
  orderSlugId: Scalars["ID"];
  amountCredits: Scalars["Int"];
  currencyCode?: InputMaybe<CurrencyCode>;
  exchangeRate?: InputMaybe<Scalars["Float"]>;
  learnerUid: Scalars["ID"];
}>;

export type AcceptPaymentWithEsaMembershipCreditMutation = {
  __typename?: "Mutation";
  acceptPaymentWithEsaMembershipCredit: boolean;
};

export type UpdateCurrentUserMutationVariables = Exact<{
  name?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  subscribe?: InputMaybe<Scalars["Boolean"]>;
  photo?: InputMaybe<Scalars["String"]>;
  photo_uid?: InputMaybe<Scalars["ID"]>;
  phone?: InputMaybe<Scalars["String"]>;
  isLeader?: InputMaybe<Scalars["Boolean"]>;
  payout_email?: InputMaybe<Scalars["String"]>;
  video?: InputMaybe<Scalars["ID"]>;
  ageEmailSubscription?: InputMaybe<Scalars["Boolean"]>;
  details?: InputMaybe<UserDetailsInput>;
  locale?: InputMaybe<UserLocale>;
  location?: InputMaybe<LocationInput>;
  isRecordingAutopostEnabled?: InputMaybe<Scalars["Boolean"]>;
  consented_to_coppa_notice_at?: InputMaybe<Scalars["DateTime"]>;
  default_currency?: InputMaybe<Scalars["String"]>;
  learner_mode_switch_auth_requirement?: InputMaybe<LearnerModeSwitchAuthRequirement>;
  do_not_sell_my_personal_info?: InputMaybe<Scalars["Boolean"]>;
  teacherAttributes?: InputMaybe<TeacherAttributesInput>;
  consent_to_share_class_history?: InputMaybe<Scalars["Boolean"]>;
  consent_to_share_favourites?: InputMaybe<Scalars["Boolean"]>;
  privacy_state?: InputMaybe<Scalars["String"]>;
}>;

export type UpdateCurrentUserMutation = {
  __typename?: "Mutation";
  updateCurrentUser: {
    __typename?: "User";
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  };
};

export type AddDonationItemToOrderMutationVariables = Exact<{
  donationInput: DonationInput;
}>;

export type AddDonationItemToOrderMutation = {
  __typename?: "Mutation";
  addDonationItemToOrder: {
    __typename?: "Donation";
    orderSlugId: string;
    amountCents: number;
  };
};

export type EmailPreferenceFragmentFragment = {
  __typename?: "EmailPreference";
  id: string;
  name: string;
  label: string;
  description: string | null;
  isEnabled: boolean;
};

export type EmailPreferenceGroupFragmentFragment = {
  __typename?: "EmailPreference";
  id: string;
  name: string;
  label: string;
  description: string | null;
  isEnabled: boolean;
  childPreferences: Array<{
    __typename?: "EmailPreference";
    id: string;
    name: string;
    label: string;
    description: string | null;
    isEnabled: boolean;
    childPreferences: Array<{
      __typename?: "EmailPreference";
      id: string;
      name: string;
      label: string;
      description: string | null;
      isEnabled: boolean;
    }>;
  }>;
};

export type SubscribeToEmailMutationVariables = Exact<{
  name: Scalars["String"];
  token?: InputMaybe<Scalars["String"]>;
  attribution?: InputMaybe<Attribution>;
}>;

export type SubscribeToEmailMutation = {
  __typename?: "Mutation";
  subscribeToEmail: {
    __typename?: "EmailPreference";
    id: string;
    name: string;
    label: string;
    description: string | null;
    isEnabled: boolean;
  };
};

export type UnsubscribeFromEmailMutationVariables = Exact<{
  name: Scalars["String"];
  token?: InputMaybe<Scalars["String"]>;
  attribution?: InputMaybe<Attribution>;
}>;

export type UnsubscribeFromEmailMutation = {
  __typename?: "Mutation";
  unsubscribeFromEmail: {
    __typename?: "EmailPreference";
    id: string;
    name: string;
    label: string;
    description: string | null;
    isEnabled: boolean;
  };
};

export type UnsubscribeFromAllEmailsMutationVariables = Exact<{
  token?: InputMaybe<Scalars["String"]>;
  attribution?: InputMaybe<Attribution>;
}>;

export type UnsubscribeFromAllEmailsMutation = {
  __typename?: "Mutation";
  unsubscribeFromAllEmails: Array<{
    __typename?: "EmailPreference";
    id: string;
    name: string;
    label: string;
    description: string | null;
    isEnabled: boolean;
  }>;
};

export type EmailPreferencesQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type EmailPreferencesQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    emailPreferences: Array<{
      __typename?: "EmailPreference";
      id: string;
      name: string;
      label: string;
      description: string | null;
      isEnabled: boolean;
      childPreferences: Array<{
        __typename?: "EmailPreference";
        id: string;
        name: string;
        label: string;
        description: string | null;
        isEnabled: boolean;
        childPreferences: Array<{
          __typename?: "EmailPreference";
          id: string;
          name: string;
          label: string;
          description: string | null;
          isEnabled: boolean;
        }>;
      }>;
    }>;
  } | null;
};

export type EmailPreferencesByTokenQueryQueryVariables = Exact<{
  token: Scalars["String"];
}>;

export type EmailPreferencesByTokenQueryQuery = {
  __typename?: "Query";
  emailPreferences: Array<{
    __typename?: "EmailPreference";
    id: string;
    name: string;
    label: string;
    description: string | null;
    isEnabled: boolean;
    childPreferences: Array<{
      __typename?: "EmailPreference";
      id: string;
      name: string;
      label: string;
      description: string | null;
      isEnabled: boolean;
      childPreferences: Array<{
        __typename?: "EmailPreference";
        id: string;
        name: string;
        label: string;
        description: string | null;
        isEnabled: boolean;
      }>;
    }>;
  }>;
};

export type EnrollmentFragmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  section_uid: string | null;
  price_cents: number | null;
  priceCents: number | null;
  created_at: any | null;
  confirmed_at: any | null;
  confirmedAt: any | null;
  withdrawn_at: any | null;
  ongoing_stopped_at: any | null;
  currency_code: CurrencyCode;
  exchange_rate: number;
  amount_in_local_currency: number;
  ongoing_start_time: any | null;
  ongoing_end_time: any | null;
  withdrawnAt: any | null;
  ongoingStoppedAt: any | null;
  ongoingStartTime: any | null;
  ongoingEndTime: any | null;
  isPaused: boolean;
  isEnded: boolean;
  isPrepay: boolean;
  hasCompletedLesson: boolean;
  hasPostedComment: boolean;
  refundableAmountCents: number;
  canBeWithdrawn: boolean;
  canBeStopped: boolean;
  canBePaused: boolean;
  usersCanCommunicate: boolean;
  purchasedAsGift: boolean;
  pricingOffer: {
    __typename?: "PricingOffer";
    name: string;
    buyerOrgName: string | null;
    isFinancialAid: boolean;
  } | null;
  refundPolicy: {
    __typename?: "RefundPolicy";
    type: RefundPolicyType;
    name: string;
    description: string;
  } | null;
  details: {
    __typename?: "EnrollmentDetails";
    name: string | null;
    age: string | null;
    attendedAt: any | null;
    message: string | null;
  };
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  };
  buyer: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  } | null;
  learner: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    isVerified: boolean;
    isBlocked: boolean | null;
    blockedByUserUid: string | null;
    blockedAt: any | null;
  } | null;
  siblings: Array<{
    __typename?: "Sibling";
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    };
    currentOrLastSection: {
      __typename?: "Section";
      filledSpaceCount: number;
      uid: string;
      activity_uid: string;
      start_time: any | null;
      end_time: any | null;
      teacher_support_start_time: any | null;
      startsAtNight: boolean | null;
      is_cross_listed: boolean;
      size_max: number | null;
      size_min: number | null;
      isPublished: boolean | null;
      price_cents: number | null;
      priceCredits: number | null;
      published_at: any | null;
      updated_at: any;
      canceled_at: any | null;
      deleted_at: any | null;
      ongoing_stopped_at: any | null;
      duration_minutes: number | null;
      usesOutschoolVideoChat: boolean;
      usersCanSendPrivateMessage: boolean;
      currentUserCanManage: boolean;
      isBuyable: boolean;
      allowsTeacherTransfer: boolean;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      } | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      details: {
        __typename?: "SectionDetails";
        autoScheduledDraft: boolean | null;
      };
      prepaidOngoingPeriodOptions: Array<{
        __typename?: "Period";
        startOfIsoWeek: any;
        endOfIsoWeek: any;
      }> | null;
    };
  }>;
  paymentSchedule: {
    __typename?: "PaymentSchedule";
    uid: string;
    stoppedAt: any | null;
    endTime: any | null;
    scheduleType: PaymentScheduleTypes;
    amountCents: number | null;
  } | null;
  pauseWindow: {
    __typename?: "EnrollmentPauseWindow";
    uid: string;
    startDate: any;
    endDate: any;
    canBeCanceled: boolean;
    pauseReason: string;
  } | null;
};

export type EnrollmentHistoryQueryVariables = Exact<{
  uid: Scalars["ID"];
  offset?: InputMaybe<Scalars["Int"]>;
  skipRating: Scalars["Boolean"];
  profileLinkUid?: InputMaybe<Scalars["String"]>;
  publicView?: InputMaybe<Scalars["Boolean"]>;
}>;

export type EnrollmentHistoryQuery = {
  __typename?: "Query";
  pastEnrollmentsForParentProfile: Array<{
    __typename?: "Listing";
    insertionId: string | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      user_uid: string;
      title: string;
      url: string;
      path: string;
      summary: string | null;
      summaryTranslated: string | null;
      quickSummary: string | null;
      weekly_meetings: number | null;
      duration_weeks: number | null;
      is_ongoing_weekly: boolean;
      isClub: boolean;
      published_at: any | null;
      size_max: number | null;
      size_min: number | null;
      hasTeacherSchedule: boolean;
      allows_recurring_payment: boolean | null;
      averageStarRating?: number | null;
      reviewCount: number;
      age_min: number | null;
      age_max: number | null;
      duration_minutes: number | null;
      price_cents: number | null;
      priceCreditsPerMeeting: number | null;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      canEnroll: boolean;
      isIncludedWithMembership: boolean;
      isOneTime: boolean;
      titleTranslated: string | null;
      slug_id: string;
      subject: string | null;
      syllabus: {
        __typename?: "Syllabus";
        uid: string;
        lessons: Array<{ __typename?: "Lesson"; uid: string }>;
      } | null;
      clubSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        clubPostCount: number;
      } | null;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
      } | null;
      savedClassLists: Array<{
        __typename?: "SavedClassList";
        uid: string;
        lastAddedToAt: any | null;
      }>;
    };
    nextSection: {
      __typename?: "Section";
      uid: string;
      size_max: number | null;
      filledSpaceCount: number;
      start_time: any | null;
      end_time: any | null;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      leader_link: string | null;
      averageActivityStarRating: number | null;
      reviewCount: number;
      educatorTiers: Array<EducatorTier>;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    };
  } | null>;
};

export type EnrollmentListByStatusQueryVariables = Exact<{
  uid: Scalars["ID"];
  statusList?: InputMaybe<Array<EnrollmentStatus> | EnrollmentStatus>;
}>;

export type EnrollmentListByStatusQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    size_max: number | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      allowWaitlist: boolean | null;
      is_ongoing_weekly: boolean;
      hasTeacherSchedule: boolean;
      isClub: boolean;
      price_cents: number | null;
      isSelfPaced: boolean;
    };
    waitlistSeats: Array<{
      __typename?: "WaitlistSeat";
      uid: string;
      previouslyEnrolled: boolean | null;
      formerLearner: boolean | null;
      parent: { __typename?: "Parent"; uid: string; name: string | null };
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        isVerified: boolean;
        newOnOutschool: boolean | null;
      };
    }> | null;
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      isFirstOutschoolClass: boolean;
      isRepeatLearnerOfTeacher: boolean;
      createdAt: any;
      isEnrolled: boolean;
      isEnded: boolean;
      isWithdrawn: boolean;
      isPaused: boolean;
      isStartingSoon: boolean;
      ongoingStartTime: any | null;
      parent: { __typename?: "Parent"; uid: string; name: string | null };
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        newOnOutschool: boolean | null;
      } | null;
      otherSections: Array<{ __typename?: "Section"; uid: string }>;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        pauseReason: string;
      } | null;
    }>;
    unclaimedGiftEnrollments: Array<{
      __typename?: "GiftEnrollment";
      uid: string;
      createdAt: any;
      isEnrolled: boolean;
      isEnded: boolean;
      isWithdrawn: boolean;
      isPaused: boolean;
      buyer: { __typename?: "Parent"; uid: string; name: string | null };
    }>;
  } | null;
};

export type CreateEnrollmentFutureMeetingsMutationVariables = Exact<{
  activityUid: Scalars["String"];
  sectionUid: Scalars["String"];
  startTime: Scalars["DateTime"];
  endTime?: InputMaybe<Scalars["DateTime"]>;
  durationWeeks?: InputMaybe<Scalars["Int"]>;
  isRecurring?: InputMaybe<Scalars["Boolean"]>;
  meetingRequestUids?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>;
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  recurringScheduleUid?: InputMaybe<Scalars["ID"]>;
}>;

export type CreateEnrollmentFutureMeetingsMutation = {
  __typename?: "Mutation";
  createEnrollmentFutureMeetings: Array<{
    __typename?: "Meeting";
    uid: string;
  } | null> | null;
};

export type EnrollmentMeetingPurchaseFragmentFragment = {
  __typename?: "EnrollmentMeetingPurchase";
  uid: string;
  activityUid: string | null;
  enrollmentUid: string | null;
  meetingUid: string | null;
  orderSlugId: string;
  confirmedAt: any | null;
};

export type EnrollmentMeetingPurchaseQueryQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  startTime: Scalars["DateTime"];
  enrollmentUid?: InputMaybe<Scalars["ID"]>;
  meetingRequestUids?: InputMaybe<Array<Scalars["ID"]> | Scalars["ID"]>;
  orgTeacherUid?: InputMaybe<Scalars["ID"]>;
  esaState?: InputMaybe<Scalars["String"]>;
}>;

export type EnrollmentMeetingPurchaseQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    consented_to_coppa_notice_at: any | null;
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    lastSubmittedEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  } | null;
  enrollmentMeetingPurchaseForm: {
    __typename?: "EnrollmentMeetingPurchaseForm";
    canPayLater: boolean;
    activity: {
      __typename?: "Activity";
      uid: string;
      ecvCents: number | null;
      suggestedWeeklyMeetings: number | null;
      reviewCount: number;
      esaStatus: EsaStatus;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        created_at: any | null;
        photo: string | null;
        suspended_at: any | null;
        cityState: string | null;
        socialOptOut: boolean;
        is_crosslister: boolean | null;
        timeZone: string | null;
        hasAvailabilitySet: boolean;
        approved: boolean;
        hasBackgroundCheckExpired: boolean | null;
        reviewCount: number;
        averageActivityStarRating: number | null;
        hasListings: boolean;
        details: {
          __typename?: "LeaderDetails";
          about: string | null;
          headline: string | null;
          headlineTranslated: string | null;
          countryOfResidence: string | null;
        };
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: {
          __typename?: "SellerOrg";
          uid: string;
          name: string;
        } | null;
        video: {
          __typename?: "Attachment";
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: { __typename?: "File"; url: string; thumbUrl: string | null };
        } | null;
      };
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      pricingInfo: {
        __typename?: "PricingInfo";
        totalPriceCentsForUpfrontPayment: number;
        totalPriceCentsForWeeklyPayments: number;
        weeklyPriceCentsForUpfrontPayment: number;
        weeklyPriceCentsForWeeklyPayments: number;
        upfrontDiscountPercentage: number;
        totalPriceCreditsForUpfrontPayment: number;
        weeklyPriceCreditsForUpfrontPayment: number;
        totalPriceCreditsForWeeklyPayments: number;
        weeklyPriceCreditsForWeeklyPayments: number;
      } | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        key: string;
        value: string;
      }>;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    orgTeacher: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      reviewCount: number;
      averageActivityStarRating: number | null;
      hasListings: boolean;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    conflictingEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
    pendingEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      hasOverlappingPendingEnrollmentMeetingPurchase: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
    enrollmentsForActivityAndParent: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        age: number | null;
        name: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
    meetingRequests: Array<{
      __typename?: "MeetingRequest";
      uid: string;
      start_time: any;
      end_time: any;
      is_recurring: boolean;
      status: MeetingRequestStatus;
    }> | null;
  } | null;
};

export type EnrollmentMeetingPurchaseRecurringQueryQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  startTime: Scalars["DateTime"];
  endTime: Scalars["DateTime"];
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  includeFirstMeeting?: InputMaybe<Scalars["Boolean"]>;
}>;

export type EnrollmentMeetingPurchaseRecurringQueryQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    canScheduleContinuously: boolean;
    futureEnrollmentMeetingAvailability: Array<{
      __typename?: "EnrollmentMeetingPurchaseMeetingAvailability";
      startTime: any;
      endTime: any;
      isAvailable: boolean;
    }>;
  };
};

export type TransferEnrollmentMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  newSectionUid: Scalars["ID"];
}>;

export type TransferEnrollmentMutation = {
  __typename?: "Mutation";
  transferEnrollment: {
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    section: { __typename?: "Section"; uid: string } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  } | null;
};

export type TransferUnclaimedGiftEnrollmentMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  newSectionUid: Scalars["ID"];
}>;

export type TransferUnclaimedGiftEnrollmentMutation = {
  __typename?: "Mutation";
  transferUnclaimedGiftEnrollment: {
    __typename?: "GiftEnrollment";
    uid: string;
    giftClaimedAt: any | null;
    createdAt: any;
    confirmedAt: any | null;
    withdrawnAt: any | null;
    withdrawn_at: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    hasPaymentSchedule: boolean;
    isEnded: boolean;
    isPaused: boolean;
    orderSlugId: string | null;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    priceCents: number | null;
    currentUserIsPurchaser: boolean;
    refundableAmountCents: number;
    section: { __typename?: "Section"; uid: string };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    payments: Array<{
      __typename?: "EnrollmentPayment";
      uid: string;
      amount_cents: number | null;
      order_slug_id: string | null;
      stripe_charge_id: string | null;
      purchase_order_id: string | null;
      esa_order_id: string | null;
      intercom_url: string | null;
      last4: string | null;
      created_at: any | null;
      paid_at: any | null;
      disbursed_at: any | null;
      payout_uid: string | null;
      start_time: any | null;
      end_time: any | null;
      unrefundedCents: number;
      isOngoingRefundable: boolean;
      voucher_name: string | null;
      pricing_offer_uid: string | null;
      credit_transaction_uid: string | null;
      credit_account_type: string | null;
      coupon_code_uid: string | null;
      currency_code: CurrencyCode | null;
      exchange_rate: number | null;
      invoice_uid: string | null;
      funding_program_invoice_uid: string | null;
      service_fee_percentage: number | null;
      couponCode: {
        __typename?: "CouponCode";
        code: string;
        coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
    }>;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  } | null;
};

export type WithdrawAndRefundGiftEnrollmentMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  refundReason: Scalars["String"];
  refundNote: Scalars["String"];
  refundAllRemaining?: InputMaybe<Scalars["Boolean"]>;
}>;

export type WithdrawAndRefundGiftEnrollmentMutation = {
  __typename?: "Mutation";
  withdrawAndRefundGiftEnrollment: {
    __typename?: "GiftEnrollment";
    section: {
      __typename?: "Section";
      uid: string;
      currentUserGiftEnrollments: Array<{
        __typename?: "GiftEnrollment";
        uid: string;
        giftClaimedAt: any | null;
        createdAt: any;
        confirmedAt: any | null;
        withdrawnAt: any | null;
        withdrawn_at: any | null;
        ongoingStoppedAt: any | null;
        ongoingStartTime: any | null;
        ongoingEndTime: any | null;
        ongoing_stopped_at: any | null;
        currency_code: CurrencyCode;
        exchange_rate: number;
        amount_in_local_currency: number;
        ongoing_start_time: any | null;
        ongoing_end_time: any | null;
        hasPaymentSchedule: boolean;
        isEnded: boolean;
        isPaused: boolean;
        orderSlugId: string | null;
        canBeWithdrawn: boolean;
        canBeStopped: boolean;
        canBePaused: boolean;
        priceCents: number | null;
        currentUserIsPurchaser: boolean;
        refundableAmountCents: number;
        parent: {
          __typename?: "Parent";
          uid: string;
          name: string | null;
          photo: string | null;
          publicName: string | null;
          introduction: string | null;
          created_at: any | null;
          deleted_at: any | null;
          timeZone: string | null;
          socialOptOut: boolean;
          consent_to_share_class_history: boolean | null;
          consent_to_share_favourites: boolean | null;
        } | null;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
        } | null;
        buyer: {
          __typename?: "Parent";
          uid: string;
          name: string | null;
          photo: string | null;
          publicName: string | null;
          introduction: string | null;
          created_at: any | null;
          deleted_at: any | null;
          timeZone: string | null;
          socialOptOut: boolean;
          consent_to_share_class_history: boolean | null;
          consent_to_share_favourites: boolean | null;
        };
        pricingOffer: {
          __typename?: "PricingOffer";
          name: string;
          buyerOrgName: string | null;
          isFinancialAid: boolean;
        } | null;
        details: {
          __typename?: "EnrollmentDetails";
          name: string | null;
          age: string | null;
          attendedAt: any | null;
          message: string | null;
        };
        payments: Array<{
          __typename?: "EnrollmentPayment";
          uid: string;
          amount_cents: number | null;
          order_slug_id: string | null;
          stripe_charge_id: string | null;
          purchase_order_id: string | null;
          esa_order_id: string | null;
          intercom_url: string | null;
          last4: string | null;
          created_at: any | null;
          paid_at: any | null;
          disbursed_at: any | null;
          payout_uid: string | null;
          start_time: any | null;
          end_time: any | null;
          unrefundedCents: number;
          isOngoingRefundable: boolean;
          voucher_name: string | null;
          pricing_offer_uid: string | null;
          credit_transaction_uid: string | null;
          credit_account_type: string | null;
          coupon_code_uid: string | null;
          currency_code: CurrencyCode | null;
          exchange_rate: number | null;
          invoice_uid: string | null;
          funding_program_invoice_uid: string | null;
          service_fee_percentage: number | null;
          couponCode: {
            __typename?: "CouponCode";
            code: string;
            coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
          } | null;
          pricingOffer: {
            __typename?: "PricingOffer";
            name: string;
            buyerOrgName: string | null;
            isFinancialAid: boolean;
          } | null;
        }>;
        refundPolicy: {
          __typename?: "RefundPolicy";
          type: RefundPolicyType;
          name: string;
          description: string;
        } | null;
        paymentSchedule: {
          __typename?: "PaymentSchedule";
          uid: string;
          stoppedAt: any | null;
          endTime: any | null;
        } | null;
        pauseWindow: {
          __typename?: "EnrollmentPauseWindow";
          uid: string;
          startDate: any;
          endDate: any;
          canBeCanceled: boolean;
          pauseReason: string;
        } | null;
      }>;
    };
  };
};

export type WithdrawAndRefundEnrollmentMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  refundReason: Scalars["String"];
  refundNote: Scalars["String"];
  refundAllRemaining?: InputMaybe<Scalars["Boolean"]>;
}>;

export type WithdrawAndRefundEnrollmentMutation = {
  __typename?: "Mutation";
  withdrawAndRefundEnrollment: {
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    section: { __typename?: "Section"; uid: string } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type StopSubscriptionMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  reason?: InputMaybe<Scalars["String"]>;
  note?: InputMaybe<Scalars["String"]>;
  refundPaymentUids?: InputMaybe<Array<Scalars["ID"]> | Scalars["ID"]>;
}>;

export type StopSubscriptionMutation = {
  __typename?: "Mutation";
  stopSubscription: {
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    section: { __typename?: "Section"; uid: string } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type CreateEnrollmentsMutationVariables = Exact<{
  orderInput: OrderInput;
  esaState?: InputMaybe<Scalars["String"]>;
  isPrepay?: InputMaybe<Scalars["Boolean"]>;
}>;

export type CreateEnrollmentsMutation = {
  __typename?: "Mutation";
  createEnrollments: {
    __typename?: "Order";
    orderSlugId: string;
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      section_uid: string | null;
      price_cents: number | null;
      priceCents: number | null;
      created_at: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      withdrawnAt: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      isPrepay: boolean;
      hasCompletedLesson: boolean;
      hasPostedComment: boolean;
      refundableAmountCents: number;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      usersCanCommunicate: boolean;
      purchasedAsGift: boolean;
      pricingOffer: {
        __typename?: "PricingOffer";
        uid: string;
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      siblings: Array<{
        __typename?: "Sibling";
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
        };
        currentOrLastSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          uid: string;
          activity_uid: string;
          start_time: any | null;
          end_time: any | null;
          teacher_support_start_time: any | null;
          startsAtNight: boolean | null;
          is_cross_listed: boolean;
          size_max: number | null;
          size_min: number | null;
          isPublished: boolean | null;
          price_cents: number | null;
          priceCredits: number | null;
          published_at: any | null;
          updated_at: any;
          canceled_at: any | null;
          deleted_at: any | null;
          ongoing_stopped_at: any | null;
          duration_minutes: number | null;
          usesOutschoolVideoChat: boolean;
          usersCanSendPrivateMessage: boolean;
          currentUserCanManage: boolean;
          isBuyable: boolean;
          allowsTeacherTransfer: boolean;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            deleted_at: any | null;
            created_at: any | null;
          } | null;
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          details: {
            __typename?: "SectionDetails";
            autoScheduledDraft: boolean | null;
          };
          prepaidOngoingPeriodOptions: Array<{
            __typename?: "Period";
            startOfIsoWeek: any;
            endOfIsoWeek: any;
          }> | null;
        };
      }>;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
        scheduleType: PaymentScheduleTypes;
        amountCents: number | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
    }>;
    giftEnrollments: Array<{
      __typename?: "GiftEnrollment";
      uid: string;
      acceptGiftSlugId: string;
      confirmedAt: any | null;
    }> | null;
  };
};

export type CreateEnrollmentMeetingPurchaseMutationVariables = Exact<{
  orderInput: EnrollmentMeetingPurchaseOrderInput;
  esaState?: InputMaybe<Scalars["String"]>;
}>;

export type CreateEnrollmentMeetingPurchaseMutation = {
  __typename?: "Mutation";
  createEnrollmentMeetingPurchase: {
    __typename?: "EnrollmentMeetingPurchaseOrder";
    orderSlugId: string;
    enrollmentMeetingPurchase: {
      __typename?: "EnrollmentMeetingPurchase";
      uid: string;
      activityUid: string | null;
      enrollmentUid: string | null;
      meetingUid: string | null;
      orderSlugId: string;
      confirmedAt: any | null;
    };
  };
};

export type ClaimGiftEnrollmentMutationVariables = Exact<{
  acceptGiftSlugId: Scalars["ID"];
  learner: EnrollmentLearnerInput;
  recipientWillPurchaseOngoingExtension?: InputMaybe<Scalars["Boolean"]>;
}>;

export type ClaimGiftEnrollmentMutation = {
  __typename?: "Mutation";
  claimGiftEnrollment: {
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type CreateClubEnrollmentMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
}>;

export type CreateClubEnrollmentMutation = {
  __typename?: "Mutation";
  createClubEnrollment: {
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type PauseOngoingEnrollmentsMutationVariables = Exact<{
  input: Array<PauseOngoingEnrollmentInput> | PauseOngoingEnrollmentInput;
}>;

export type PauseOngoingEnrollmentsMutation = {
  __typename?: "Mutation";
  pauseOngoingEnrollments: Array<{
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  }>;
};

export type OneOnOneEnrollmentRepriceMutationMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  newPriceCents: Scalars["Int"];
}>;

export type OneOnOneEnrollmentRepriceMutationMutation = {
  __typename?: "Mutation";
  repriceTutoringEnrollment: {
    __typename?: "RepriceTutoringResult";
    canceledMeetingUids: Array<string>;
    enrollment: {
      __typename?: "Enrollment";
      uid: string;
      section_uid: string | null;
      price_cents: number | null;
      priceCents: number | null;
      created_at: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      withdrawnAt: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      isPrepay: boolean;
      hasCompletedLesson: boolean;
      hasPostedComment: boolean;
      refundableAmountCents: number;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      usersCanCommunicate: boolean;
      purchasedAsGift: boolean;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      siblings: Array<{
        __typename?: "Sibling";
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
        };
        currentOrLastSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          uid: string;
          activity_uid: string;
          start_time: any | null;
          end_time: any | null;
          teacher_support_start_time: any | null;
          startsAtNight: boolean | null;
          is_cross_listed: boolean;
          size_max: number | null;
          size_min: number | null;
          isPublished: boolean | null;
          price_cents: number | null;
          priceCredits: number | null;
          published_at: any | null;
          updated_at: any;
          canceled_at: any | null;
          deleted_at: any | null;
          ongoing_stopped_at: any | null;
          duration_minutes: number | null;
          usesOutschoolVideoChat: boolean;
          usersCanSendPrivateMessage: boolean;
          currentUserCanManage: boolean;
          isBuyable: boolean;
          allowsTeacherTransfer: boolean;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            deleted_at: any | null;
            created_at: any | null;
          } | null;
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          details: {
            __typename?: "SectionDetails";
            autoScheduledDraft: boolean | null;
          };
          prepaidOngoingPeriodOptions: Array<{
            __typename?: "Period";
            startOfIsoWeek: any;
            endOfIsoWeek: any;
          }> | null;
        };
      }>;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
        scheduleType: PaymentScheduleTypes;
        amountCents: number | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
    };
  };
};

export type CreateActivityOwnerLearnerEnrollmentMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
}>;

export type CreateActivityOwnerLearnerEnrollmentMutation = {
  __typename?: "Mutation";
  createActivityOwnerLearnerEnrollment: {
    __typename?: "Enrollment";
    uid: string;
    section_uid: string | null;
    price_cents: number | null;
    priceCents: number | null;
    created_at: any | null;
    confirmed_at: any | null;
    confirmedAt: any | null;
    withdrawn_at: any | null;
    ongoing_stopped_at: any | null;
    currency_code: CurrencyCode;
    exchange_rate: number;
    amount_in_local_currency: number;
    ongoing_start_time: any | null;
    ongoing_end_time: any | null;
    withdrawnAt: any | null;
    ongoingStoppedAt: any | null;
    ongoingStartTime: any | null;
    ongoingEndTime: any | null;
    isPaused: boolean;
    isEnded: boolean;
    isPrepay: boolean;
    hasCompletedLesson: boolean;
    hasPostedComment: boolean;
    refundableAmountCents: number;
    canBeWithdrawn: boolean;
    canBeStopped: boolean;
    canBePaused: boolean;
    usersCanCommunicate: boolean;
    purchasedAsGift: boolean;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      type: RefundPolicyType;
      name: string;
      description: string;
    } | null;
    details: {
      __typename?: "EnrollmentDetails";
      name: string | null;
      age: string | null;
      attendedAt: any | null;
      message: string | null;
    };
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    } | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    } | null;
    siblings: Array<{
      __typename?: "Sibling";
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
      currentOrLastSection: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
    }>;
    paymentSchedule: {
      __typename?: "PaymentSchedule";
      uid: string;
      stoppedAt: any | null;
      endTime: any | null;
      scheduleType: PaymentScheduleTypes;
      amountCents: number | null;
    } | null;
    pauseWindow: {
      __typename?: "EnrollmentPauseWindow";
      uid: string;
      startDate: any;
      endDate: any;
      canBeCanceled: boolean;
      pauseReason: string;
    } | null;
  };
};

export type EnrollmentPaymentFragmentFragment = {
  __typename?: "EnrollmentPayment";
  uid: string;
  amount_cents: number | null;
  order_slug_id: string | null;
  stripe_charge_id: string | null;
  purchase_order_id: string | null;
  esa_order_id: string | null;
  intercom_url: string | null;
  last4: string | null;
  created_at: any | null;
  paid_at: any | null;
  disbursed_at: any | null;
  payout_uid: string | null;
  start_time: any | null;
  end_time: any | null;
  unrefundedCents: number;
  isOngoingRefundable: boolean;
  voucher_name: string | null;
  pricing_offer_uid: string | null;
  credit_transaction_uid: string | null;
  credit_account_type: string | null;
  coupon_code_uid: string | null;
  currency_code: CurrencyCode | null;
  exchange_rate: number | null;
  invoice_uid: string | null;
  funding_program_invoice_uid: string | null;
  service_fee_percentage: number | null;
  couponCode: {
    __typename?: "CouponCode";
    code: string;
    coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
  } | null;
  pricingOffer: {
    __typename?: "PricingOffer";
    name: string;
    buyerOrgName: string | null;
    isFinancialAid: boolean;
  } | null;
};

export type EnrollmentPaymentReceiptFragmentFragment = {
  __typename?: "EnrollmentPayment";
  uid: string;
  amount_cents: number | null;
  amount_credits: number | null;
  order_slug_id: string | null;
  stripe_charge_id: string | null;
  purchase_order_id: string | null;
  pricing_offer_uid: string | null;
  esa_order_id: string | null;
  invoice_uid: string | null;
  funding_program_invoice_uid: string | null;
  intercom_url: string | null;
  last4: string | null;
  created_at: any | null;
  paid_at: any | null;
  disbursed_at: any | null;
  payout_uid: string | null;
  start_time: any | null;
  end_time: any | null;
  unrefundedCents: number;
  isOngoingRefundable: boolean;
  voucher_name: string | null;
  credit_transaction_uid: string | null;
  credit_account_type: string | null;
  service_fee_percentage: number | null;
  coupon_code_uid: string | null;
  currency_code: CurrencyCode | null;
  exchange_rate: number | null;
  stripeReceiptUrl: string | null;
  stripePaymentMethod: string | null;
  couponCode: {
    __typename?: "CouponCode";
    code: string;
    coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
  } | null;
  pricingOffer: {
    __typename?: "PricingOffer";
    name: string;
    buyerOrgName: string | null;
    isFinancialAid: boolean;
  } | null;
};

export type RefundEnrollmentMutationVariables = Exact<{
  enrollmentPaymentUid: Scalars["ID"];
  refundAmountCents: Scalars["Int"];
  reducesTeacherPayout: Scalars["Boolean"];
  refundReason: Scalars["String"];
  refundNote: Scalars["String"];
  refundType?: InputMaybe<RefundType>;
}>;

export type RefundEnrollmentMutation = {
  __typename?: "Mutation";
  refundEnrollmentPayment: {
    __typename?: "EnrollmentPayment";
    uid: string;
    amount_cents: number | null;
    order_slug_id: string | null;
    stripe_charge_id: string | null;
    purchase_order_id: string | null;
    esa_order_id: string | null;
    intercom_url: string | null;
    last4: string | null;
    created_at: any | null;
    paid_at: any | null;
    disbursed_at: any | null;
    payout_uid: string | null;
    start_time: any | null;
    end_time: any | null;
    unrefundedCents: number;
    isOngoingRefundable: boolean;
    voucher_name: string | null;
    pricing_offer_uid: string | null;
    credit_transaction_uid: string | null;
    credit_account_type: string | null;
    coupon_code_uid: string | null;
    currency_code: CurrencyCode | null;
    exchange_rate: number | null;
    invoice_uid: string | null;
    funding_program_invoice_uid: string | null;
    service_fee_percentage: number | null;
    refunds: Array<{
      __typename?: "EnrollmentPaymentRefund";
      uid: string;
      user_uid: string;
      amount_cents: number;
      amount_credits: number | null;
      refunded_at: any | null;
      reason: string | null;
      user_role: string | null;
      note: string | null;
      reduces_teacher_payout: boolean;
      amount_in_local_currency: number | null;
      currency_code: CurrencyCode | null;
      exchange_rate: number | null;
      addOutschoolCreditTransaction: {
        __typename?: "CreditTransaction";
        uid: string;
        amount_cents: number;
        expiresAt: any | null;
        unspentCents: number | null;
      } | null;
    }>;
    couponCode: {
      __typename?: "CouponCode";
      code: string;
      coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
  };
};

export type RefundEnrollmentCreditsMutationVariables = Exact<{
  enrollmentPaymentUid: Scalars["ID"];
  refundAmountCredits: Scalars["Int"];
  reducesTeacherPayout: Scalars["Boolean"];
  refundReason: Scalars["String"];
  refundNote: Scalars["String"];
  refundType?: InputMaybe<RefundType>;
}>;

export type RefundEnrollmentCreditsMutation = {
  __typename?: "Mutation";
  refundEnrollmentPaymentCredits: {
    __typename?: "EnrollmentPayment";
    uid: string;
    amount_cents: number | null;
    order_slug_id: string | null;
    stripe_charge_id: string | null;
    purchase_order_id: string | null;
    esa_order_id: string | null;
    intercom_url: string | null;
    last4: string | null;
    created_at: any | null;
    paid_at: any | null;
    disbursed_at: any | null;
    payout_uid: string | null;
    start_time: any | null;
    end_time: any | null;
    unrefundedCents: number;
    isOngoingRefundable: boolean;
    voucher_name: string | null;
    pricing_offer_uid: string | null;
    credit_transaction_uid: string | null;
    credit_account_type: string | null;
    coupon_code_uid: string | null;
    currency_code: CurrencyCode | null;
    exchange_rate: number | null;
    invoice_uid: string | null;
    funding_program_invoice_uid: string | null;
    service_fee_percentage: number | null;
    refunds: Array<{
      __typename?: "EnrollmentPaymentRefund";
      uid: string;
      user_uid: string;
      amount_cents: number;
      amount_credits: number | null;
      refunded_at: any | null;
      reason: string | null;
      user_role: string | null;
      note: string | null;
      reduces_teacher_payout: boolean;
      amount_in_local_currency: number | null;
      currency_code: CurrencyCode | null;
      exchange_rate: number | null;
      addOutschoolCreditTransaction: {
        __typename?: "CreditTransaction";
        uid: string;
        amount_cents: number;
        expiresAt: any | null;
        unspentCents: number | null;
      } | null;
    }>;
    couponCode: {
      __typename?: "CouponCode";
      code: string;
      coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
  };
};

export type EnrollmentPaymentRefundFragmentFragment = {
  __typename?: "EnrollmentPaymentRefund";
  uid: string;
  user_uid: string;
  amount_cents: number;
  amount_credits: number | null;
  refunded_at: any | null;
  reason: string | null;
  user_role: string | null;
  note: string | null;
  reduces_teacher_payout: boolean;
  amount_in_local_currency: number | null;
  currency_code: CurrencyCode | null;
  exchange_rate: number | null;
  addOutschoolCreditTransaction: {
    __typename?: "CreditTransaction";
    uid: string;
    amount_cents: number;
    expiresAt: any | null;
    unspentCents: number | null;
  } | null;
};

export type ExchangeRateQueryVariables = Exact<{
  currencyCode: CurrencyCode;
}>;

export type ExchangeRateQuery = {
  __typename?: "Query";
  exchangeRate: {
    __typename?: "ExchangeRate";
    uid: string;
    currency_code: CurrencyCode;
    exchange_rate: number;
  } | null;
};

export type ExternalResourceFragmentFragment = {
  __typename?: "ExternalResource";
  uid: string;
  name: string;
  url: string | null;
};

export type ActivityExternalResourceFragmentFragment = {
  __typename?: "Activity";
  has_external_resources: boolean | null;
  externalResources: Array<{
    __typename?: "ExternalResource";
    uid: string;
    name: string;
    url: string | null;
  }>;
};

export type FeedbackForLeaderFragmentFragment = {
  __typename?: "FeedbackForLeader";
  uid: string;
  activity_star_rating: number | null;
  created_at: any;
  details: {
    __typename?: "FeedbackForLeaderDetails";
    leaderFeedback: string | null;
  };
};

export type FeedbackFragmentFragment = {
  __typename?: "Feedback";
  uid: string;
  section_uid: string;
  currentUserCanEdit: boolean;
  activity_star_rating: number | null;
  publicReview: string | null;
  outschoolFeedback: string | null;
  leaderFeedback: string | null;
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  };
  attachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
};

export type DeleteReviewMutationVariables = Exact<{
  uid: Scalars["ID"];
  reason: Scalars["String"];
  note?: InputMaybe<Scalars["String"]>;
}>;

export type DeleteReviewMutation = {
  __typename?: "Mutation";
  deleteReview: boolean;
};

export type UnfollowUserMutationVariables = Exact<{
  userUid: Scalars["ID"];
}>;

export type UnfollowUserMutation = {
  __typename?: "Mutation";
  unfollowUser: boolean;
};

export type GiftEnrollmentFragmentFragment = {
  __typename?: "GiftEnrollment";
  uid: string;
  giftClaimedAt: any | null;
  createdAt: any;
  confirmedAt: any | null;
  withdrawnAt: any | null;
  withdrawn_at: any | null;
  ongoingStoppedAt: any | null;
  ongoingStartTime: any | null;
  ongoingEndTime: any | null;
  ongoing_stopped_at: any | null;
  currency_code: CurrencyCode;
  exchange_rate: number;
  amount_in_local_currency: number;
  ongoing_start_time: any | null;
  ongoing_end_time: any | null;
  hasPaymentSchedule: boolean;
  isEnded: boolean;
  isPaused: boolean;
  orderSlugId: string | null;
  canBeWithdrawn: boolean;
  canBeStopped: boolean;
  canBePaused: boolean;
  priceCents: number | null;
  currentUserIsPurchaser: boolean;
  refundableAmountCents: number;
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  } | null;
  learner: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    isVerified: boolean;
    isBlocked: boolean | null;
    blockedByUserUid: string | null;
    blockedAt: any | null;
  } | null;
  buyer: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  };
  pricingOffer: {
    __typename?: "PricingOffer";
    name: string;
    buyerOrgName: string | null;
    isFinancialAid: boolean;
  } | null;
  details: {
    __typename?: "EnrollmentDetails";
    name: string | null;
    age: string | null;
    attendedAt: any | null;
    message: string | null;
  };
  payments: Array<{
    __typename?: "EnrollmentPayment";
    uid: string;
    amount_cents: number | null;
    order_slug_id: string | null;
    stripe_charge_id: string | null;
    purchase_order_id: string | null;
    esa_order_id: string | null;
    intercom_url: string | null;
    last4: string | null;
    created_at: any | null;
    paid_at: any | null;
    disbursed_at: any | null;
    payout_uid: string | null;
    start_time: any | null;
    end_time: any | null;
    unrefundedCents: number;
    isOngoingRefundable: boolean;
    voucher_name: string | null;
    pricing_offer_uid: string | null;
    credit_transaction_uid: string | null;
    credit_account_type: string | null;
    coupon_code_uid: string | null;
    currency_code: CurrencyCode | null;
    exchange_rate: number | null;
    invoice_uid: string | null;
    funding_program_invoice_uid: string | null;
    service_fee_percentage: number | null;
    couponCode: {
      __typename?: "CouponCode";
      code: string;
      coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      name: string;
      buyerOrgName: string | null;
      isFinancialAid: boolean;
    } | null;
  }>;
  refundPolicy: {
    __typename?: "RefundPolicy";
    type: RefundPolicyType;
    name: string;
    description: string;
  } | null;
  paymentSchedule: {
    __typename?: "PaymentSchedule";
    uid: string;
    stoppedAt: any | null;
    endTime: any | null;
  } | null;
  pauseWindow: {
    __typename?: "EnrollmentPauseWindow";
    uid: string;
    startDate: any;
    endDate: any;
    canBeCanceled: boolean;
    pauseReason: string;
  } | null;
};

export type ActiveClassesQueryVariables = Exact<{ [key: string]: never }>;

export type ActiveClassesQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    futureEndingActivities: Array<{
      __typename?: "Activity";
      uid: string;
      age_max: number | null;
      age_min: number | null;
      weekly_meetings: number | null;
      duration_weeks: number | null;
      duration_minutes: number | null;
      title: string;
      classFormat: EducatorSelectedFormat;
      hasTeacherSchedule: boolean;
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    }>;
  } | null;
};

export type ActiveEnrollmentsByClassQueryVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type ActiveEnrollmentsByClassQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    currentAndFutureSections: Array<{
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
      filledSpaceCount: number;
      enrollments: Array<{
        __typename?: "Enrollment";
        parent: { __typename?: "Parent"; uid: string };
        learner: { __typename?: "Learner"; name: string | null } | null;
      }>;
    }>;
  };
};

export type ClassesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars["String"]>;
  activityType?: InputMaybe<CreateActivityType>;
}>;

export type ClassesQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    followerCount: number;
    leaderActivities: Array<{
      __typename?: "Activity";
      classFormat: EducatorSelectedFormat;
      uid: string;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      saveCount: number | null;
      archived_at: any | null;
      upsell_activity_uid: string | null;
      why_me: string | null;
      parental_guidance: string | null;
      sources: string | null;
      materials: string | null;
      hasSections: boolean;
      requested_listing_at: any | null;
      has_external_resources: boolean | null;
      leaderDetails: {
        __typename?: "ActivityLeaderDetails";
        uid: string;
        requestedListingAt: any | null;
        classRequest: {
          __typename?: "ClassRequest";
          uid: string;
          age: number;
          content: string;
        } | null;
        welcomeMessage: {
          __typename?: "WelcomeMessage";
          text: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
            };
          }> | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
            };
          } | null;
        } | null;
      };
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
      details: { __typename?: "ActivityDetails"; asyncTime: string | null };
      approvalStatus: {
        __typename?: "ActivityApprovalStatus";
        action: string;
        message_to_teacher: string | null;
      } | null;
      externalResources: Array<{
        __typename?: "ExternalResource";
        uid: string;
        name: string;
        url: string | null;
      }>;
    }>;
  } | null;
};

export type ClassLinksQueryVariables = Exact<{ [key: string]: never }>;

export type ClassLinksQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    leaderClassLinks: Array<{
      __typename?: "Bundle";
      uid: string;
      title: string;
      isOrdered: boolean;
      thumbnail: string | null;
      bundleElements: Array<{
        __typename?: "BundleElement";
        uid: string;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          age_min: number | null;
          age_max: number | null;
          photo: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    }>;
  } | null;
};

export type LeaderFragmentFragment = {
  __typename?: "Leader";
  uid: string;
  name: string | null;
  leader_link: string | null;
  created_at: any | null;
  photo: string | null;
  suspended_at: any | null;
  cityState: string | null;
  socialOptOut: boolean;
  is_crosslister: boolean | null;
  timeZone: string | null;
  hasAvailabilitySet: boolean;
  approved: boolean;
  hasBackgroundCheckExpired: boolean | null;
  reviewCount: number;
  averageActivityStarRating: number | null;
  hasListings: boolean;
  details: {
    __typename?: "LeaderDetails";
    about: string | null;
    headline: string | null;
    headlineTranslated: string | null;
    countryOfResidence: string | null;
  };
  ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
  teacherForSellerOrg: {
    __typename?: "SellerOrg";
    uid: string;
    name: string;
  } | null;
};

export type CreateOrUpdateLearnerSectionReviewMutationVariables = Exact<{
  learnerSectionReviewInput: LearnerSectionReviewInput;
}>;

export type CreateOrUpdateLearnerSectionReviewMutation = {
  __typename?: "Mutation";
  createOrUpdateLearnerSectionReview: {
    __typename?: "LearnerSectionReview";
    uid: string;
    name: ReviewName | null;
    response: {
      __typename?: "LearnerReviewResponse";
      vote: string | null;
    } | null;
  };
};

export type LearnersForParentInSectionQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type LearnersForParentInSectionQuery = {
  __typename?: "Query";
  learnersForParentInSection: Array<{
    __typename?: "Learner";
    uid: string;
  } | null>;
};

export type LightActivityFragmentFragment = {
  __typename?: "Activity";
  uid: string;
  user_uid: string;
  slug_id: string;
  title: string;
  titleTranslated: string | null;
  url: string;
  path: string;
  summary: string | null;
  summaryTranslated: string | null;
  is_ongoing_weekly: boolean;
  isClub: boolean;
  isIncludedWithMembership: boolean;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type CreateMeetingsMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  times: Array<StartEndTime> | StartEndTime;
}>;

export type CreateMeetingsMutation = {
  __typename?: "Mutation";
  createMeetings: Array<{
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
    holiday: { __typename?: "Holiday"; name: string } | null;
  }>;
};

export type CreateMeetingsWithLessonUidsMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  meetingDetails: Array<MeetingDetails> | MeetingDetails;
}>;

export type CreateMeetingsWithLessonUidsMutation = {
  __typename?: "Mutation";
  createMeetingsWithLessonUids: Array<{
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
    holiday: { __typename?: "Holiday"; name: string } | null;
    lesson: { __typename?: "Lesson"; uid: string; title: string | null } | null;
  }>;
};

export type UpdateMeetingsMutationVariables = Exact<{
  updateMeetingsInput: Array<UpdateMeetingInput> | UpdateMeetingInput;
}>;

export type UpdateMeetingsMutation = {
  __typename?: "Mutation";
  updateMeetings: Array<{
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
    holiday: { __typename?: "Holiday"; name: string } | null;
    lesson: { __typename?: "Lesson"; uid: string; title: string | null } | null;
  }>;
};

export type UpdateMeetingsLessonMutationVariables = Exact<{
  updateMeetingsLessonInput:
    | Array<UpdateMeetingLessonInput>
    | UpdateMeetingLessonInput;
}>;

export type UpdateMeetingsLessonMutation = {
  __typename?: "Mutation";
  updateMeetingsLesson: Array<{
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
    holiday: { __typename?: "Holiday"; name: string } | null;
    lesson: { __typename?: "Lesson"; uid: string; title: string | null } | null;
  }>;
};

export type DeleteMeetingMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type DeleteMeetingMutation = {
  __typename?: "Mutation";
  deleteMeeting: boolean;
};

export type CancelOneOnOneMeetingMutationVariables = Exact<{
  uid: Scalars["ID"];
  cancelReason: Scalars["String"];
  cancelNote?: InputMaybe<Scalars["String"]>;
  refundAmountCents?: InputMaybe<Scalars["Int"]>;
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
}>;

export type CancelOneOnOneMeetingMutation = {
  __typename?: "Mutation";
  cancelOneOnOneMeeting: {
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
  };
};

export type CancelAllOneOnOneSectionMeetingsMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  cancelReason: Scalars["String"];
  cancelNote?: InputMaybe<Scalars["String"]>;
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
}>;

export type CancelAllOneOnOneSectionMeetingsMutation = {
  __typename?: "Mutation";
  cancelAllOneOnOneSectionMeetings: boolean;
};

export type CancelOneOnOneRecurringMeetingsMutationVariables = Exact<{
  uid: Scalars["ID"];
  cancelReason: Scalars["String"];
  cancelNote?: InputMaybe<Scalars["String"]>;
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
}>;

export type CancelOneOnOneRecurringMeetingsMutation = {
  __typename?: "Mutation";
  cancelOneOnOneRecurringMeetings: Array<string | null>;
};

export type RescheduleMeetingMutationVariables = Exact<{
  uid: Scalars["ID"];
  startTime: Scalars["DateTime"];
  endTime: Scalars["DateTime"];
  rescheduleFutureRecurringMeetings: Scalars["Boolean"];
}>;

export type RescheduleMeetingMutation = {
  __typename?: "Mutation";
  rescheduleMeeting: Array<{
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
  }>;
};

export type MeetingReviewMutationForParentMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  rating: Scalars["Int"];
  type: MeetingReviewType;
  learnerUid: Scalars["ID"];
}>;

export type MeetingReviewMutationForParentMutation = {
  __typename?: "Mutation";
  createMeetingReview: {
    __typename?: "MeetingReview";
    uid: string;
    learnerUid: string;
    rating: number;
    meetingUid: string;
    sectionUid: string;
  };
};

export type RequestMergeAccountMutationVariables = Exact<{
  email: Scalars["String"];
}>;

export type RequestMergeAccountMutation = {
  __typename?: "Mutation";
  requestMergeAccount: boolean;
};

export type ConfirmMergeAccountMutationVariables = Exact<{
  email: Scalars["String"];
  token: Scalars["String"];
}>;

export type ConfirmMergeAccountMutation = {
  __typename?: "Mutation";
  confirmMergeAccount: {
    __typename?: "User";
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  };
};

export type SenderFragmentFragment = {
  __typename?: "Sender";
  uid: string;
  name: string | null;
  photo: string | null;
};

export type ParticipantFragmentFragment = {
  __typename?: "Participant";
  uid: string;
  name: string | null;
  photo: string | null;
  timeZone: string | null;
  headline: string | null;
  leader_link: string | null;
  isLearner: boolean;
  role: ParticipantRole | null;
  ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
  teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
};

export type EnrollmentWithTeacherFragmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  confirmed_at: any | null;
  withdrawn_at: any | null;
  ongoing_stopped_at: any | null;
  ongoing_start_time: any | null;
  ongoing_end_time: any | null;
  isEnded: boolean;
  isPaused: boolean;
  section: {
    __typename?: "Section";
    uid: string;
    start_time: any | null;
    end_time: any | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      titleTranslated: string | null;
      isClub: boolean;
      published_at: any | null;
      is_ongoing_weekly: boolean;
      weekly_meetings: number | null;
      duration_weeks: number | null;
    };
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    } | null;
  } | null;
  learner: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    isVerified: boolean;
    isBlocked: boolean | null;
    blockedByUserUid: string | null;
    blockedAt: any | null;
    timeZone: string;
    privateNote: string | null;
  } | null;
  pauseWindow: {
    __typename?: "EnrollmentPauseWindow";
    uid: string;
    startDate: any;
    endDate: any;
  } | null;
};

export type MessageFragmentFragment = {
  __typename?: "Message";
  uid: string;
  subject: string | null;
  action: string | null;
  content: string | null;
  created_at: any;
  activity_uid: string | null;
  section_uid: string | null;
  thread_uid: string;
  sender: {
    __typename?: "Sender";
    uid: string;
    name: string | null;
    photo: string | null;
  };
  participants: Array<{
    __typename?: "Participant";
    uid: string;
    name: string | null;
    photo: string | null;
    timeZone: string | null;
    headline: string | null;
    leader_link: string | null;
    isLearner: boolean;
    role: ParticipantRole | null;
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
  }>;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  } | null;
};

type MessageThreadFragment_MessageThread_Fragment = {
  __typename?: "MessageThread";
  uid: string;
  isRead: boolean;
  matchedSearchResults: Array<{
    __typename?: "ConversationSearchResult";
    threadUid: string;
    highlightedMatch: string;
  }> | null;
  participants: Array<{
    __typename?: "Participant";
    avatar: string | null;
    uid: string;
    name: string | null;
    photo: string | null;
    timeZone: string | null;
    headline: string | null;
    leader_link: string | null;
    isLearner: boolean;
    role: ParticipantRole | null;
    activitiesWithCurrentUser: Array<{
      __typename?: "Activity";
      uid: string;
    }> | null;
    parent: {
      __typename?: "Parent";
      uid: string;
      photo: string | null;
      publicName: string | null;
    } | null;
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
  }>;
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    titleTranslated: string | null;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  } | null;
  messages: Array<{
    __typename?: "Message";
    created_at: any;
    uid: string;
    activity_uid: string | null;
    section_uid: string | null;
    thread_uid: string;
    subject: string | null;
    content: string | null;
    sender: {
      __typename?: "Sender";
      uid: string;
      name: string | null;
      photo: string | null;
      timeZone: string | null;
      headline: string | null;
      leader_link: string | null;
    };
    participants: Array<{
      __typename?: "Participant";
      isLearner: boolean;
      avatar: string | null;
      uid: string;
      name: string | null;
      photo: string | null;
      timeZone: string | null;
      headline: string | null;
      leader_link: string | null;
      role: ParticipantRole | null;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    }>;
  }>;
};

type MessageThreadFragment_PrivateClassThread_Fragment = {
  __typename?: "PrivateClassThread";
  uid: string;
  isRead: boolean;
  matchedSearchResults: Array<{
    __typename?: "ConversationSearchResult";
    threadUid: string;
    highlightedMatch: string;
  }> | null;
  participants: Array<{
    __typename?: "Participant";
    avatar: string | null;
    uid: string;
    name: string | null;
    photo: string | null;
    timeZone: string | null;
    headline: string | null;
    leader_link: string | null;
    isLearner: boolean;
    role: ParticipantRole | null;
    activitiesWithCurrentUser: Array<{
      __typename?: "Activity";
      uid: string;
    }> | null;
    parent: {
      __typename?: "Parent";
      uid: string;
      photo: string | null;
      publicName: string | null;
    } | null;
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
  }>;
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    titleTranslated: string | null;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  } | null;
  messages: Array<{
    __typename?: "PrivateClassMessage";
    sentAt: any;
    uid: string;
    activity_uid: string;
    section_uid: string;
    thread_uid: string;
    subject: string | null;
    content: string | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    participants: Array<{
      __typename?: "Participant";
      isLearner: boolean;
      avatar: string | null;
      uid: string;
      name: string | null;
      photo: string | null;
      timeZone: string | null;
      headline: string | null;
      leader_link: string | null;
      role: ParticipantRole | null;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    }>;
  }>;
};

export type MessageThreadFragmentFragment =
  | MessageThreadFragment_MessageThread_Fragment
  | MessageThreadFragment_PrivateClassThread_Fragment;

export type RecentlyViewedQueryQueryVariables = Exact<{
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
  activityUids: Array<Scalars["ID"]> | Scalars["ID"];
  activeLearnerSearchFilters?: InputMaybe<SearchFilters>;
}>;

export type RecentlyViewedQueryQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    recentlyViewed: Array<{
      __typename?: "Listing";
      insertionId: string | null;
      sectionCount: number;
      openSectionCount: number;
      upcomingSectionCount: number;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
            fileSize: number | null;
          };
        } | null;
        credentials: Array<{
          __typename?: "TeacherCredential";
          uid: string;
          degreeType: DegreeType | null;
          degreeSubject: DegreeSubject | null;
        }>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
      activity: {
        __typename?: "Activity";
        uid: string;
        isIncludedWithMembership: boolean;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        quickSummary: string | null;
        isClub: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        hasTeacherSchedule: boolean;
        size_max: number | null;
        user_uid: string;
        slug_id: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        recentReviews?: Array<{
          __typename?: "PublicReview";
          uid: string;
          activity_star_rating: number | null;
          details: {
            __typename?: "PublicReviewDetails";
            publicReview: string | null;
          } | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            publicName: string | null;
          };
        }>;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
    }>;
  };
};

export type AggregatedUpsellQueryQueryVariables = Exact<{
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
  activeLearnerSearchFilters?: InputMaybe<SearchFilters>;
}>;

export type AggregatedUpsellQueryQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    aggregatedUpsell: Array<{
      __typename?: "Listing";
      insertionId: string | null;
      sectionCount: number;
      openSectionCount: number;
      upcomingSectionCount: number;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
            fileSize: number | null;
          };
        } | null;
        credentials: Array<{
          __typename?: "TeacherCredential";
          uid: string;
          degreeType: DegreeType | null;
          degreeSubject: DegreeSubject | null;
        }>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
      activity: {
        __typename?: "Activity";
        uid: string;
        isIncludedWithMembership: boolean;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        quickSummary: string | null;
        isClub: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        hasTeacherSchedule: boolean;
        size_max: number | null;
        user_uid: string;
        slug_id: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        recentReviews?: Array<{
          __typename?: "PublicReview";
          uid: string;
          activity_star_rating: number | null;
          details: {
            __typename?: "PublicReviewDetails";
            publicReview: string | null;
          } | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            publicName: string | null;
          };
        }>;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
    }>;
  };
};

export type FavouriteListingsQueryVariables = Exact<{
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
  activeLearnerSearchFilters?: InputMaybe<SearchFilters>;
}>;

export type FavouriteListingsQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    favoriteListings: Array<{
      __typename?: "Listing";
      insertionId: string | null;
      sectionCount: number;
      openSectionCount: number;
      upcomingSectionCount: number;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
            fileSize: number | null;
          };
        } | null;
        credentials: Array<{
          __typename?: "TeacherCredential";
          uid: string;
          degreeType: DegreeType | null;
          degreeSubject: DegreeSubject | null;
        }>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
      activity: {
        __typename?: "Activity";
        uid: string;
        isIncludedWithMembership: boolean;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        quickSummary: string | null;
        isClub: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        hasTeacherSchedule: boolean;
        size_max: number | null;
        user_uid: string;
        slug_id: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        recentReviews?: Array<{
          __typename?: "PublicReview";
          uid: string;
          activity_star_rating: number | null;
          details: {
            __typename?: "PublicReviewDetails";
            publicReview: string | null;
          } | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            publicName: string | null;
          };
        }>;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
    }> | null;
  };
};

export type StartingSoonQueryVariables = Exact<{
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
  activeLearnerSearchFilters?: InputMaybe<SearchFilters>;
}>;

export type StartingSoonQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    startingSoon: Array<{
      __typename?: "Listing";
      insertionId: string | null;
      sectionCount: number;
      openSectionCount: number;
      upcomingSectionCount: number;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
            fileSize: number | null;
          };
        } | null;
        credentials: Array<{
          __typename?: "TeacherCredential";
          uid: string;
          degreeType: DegreeType | null;
          degreeSubject: DegreeSubject | null;
        }>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
      activity: {
        __typename?: "Activity";
        uid: string;
        isIncludedWithMembership: boolean;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        quickSummary: string | null;
        isClub: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        hasTeacherSchedule: boolean;
        size_max: number | null;
        user_uid: string;
        slug_id: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        recentReviews?: Array<{
          __typename?: "PublicReview";
          uid: string;
          activity_star_rating: number | null;
          details: {
            __typename?: "PublicReviewDetails";
            publicReview: string | null;
          } | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            publicName: string | null;
          };
        }>;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
    }> | null;
  };
};

export type PersonalizedRecommendationsQueryVariables = Exact<{
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
  activeLearnerUid?: InputMaybe<Scalars["ID"]>;
}>;

export type PersonalizedRecommendationsQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    personalizedRecommendations: Array<{
      __typename?: "Listing";
      insertionId: string | null;
      sectionCount: number;
      openSectionCount: number;
      upcomingSectionCount: number;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
            fileSize: number | null;
          };
        } | null;
        credentials: Array<{
          __typename?: "TeacherCredential";
          uid: string;
          degreeType: DegreeType | null;
          degreeSubject: DegreeSubject | null;
        }>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
      activity: {
        __typename?: "Activity";
        uid: string;
        isIncludedWithMembership: boolean;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        quickSummary: string | null;
        isClub: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        hasTeacherSchedule: boolean;
        size_max: number | null;
        user_uid: string;
        slug_id: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        recentReviews?: Array<{
          __typename?: "PublicReview";
          uid: string;
          activity_star_rating: number | null;
          details: {
            __typename?: "PublicReviewDetails";
            publicReview: string | null;
          } | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            publicName: string | null;
          };
        }>;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
    }>;
  };
};

export type PopularTutorListingsQueryVariables = Exact<{
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
  activeLearnerSearchFilters?: InputMaybe<SearchFilters>;
}>;

export type PopularTutorListingsQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    popularTutorListings: Array<{
      __typename?: "Listing";
      insertionId: string | null;
      sectionCount: number;
      openSectionCount: number;
      upcomingSectionCount: number;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
            fileSize: number | null;
          };
        } | null;
        credentials: Array<{
          __typename?: "TeacherCredential";
          uid: string;
          degreeType: DegreeType | null;
          degreeSubject: DegreeSubject | null;
        }>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
      activity: {
        __typename?: "Activity";
        uid: string;
        isIncludedWithMembership: boolean;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        quickSummary: string | null;
        isClub: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        hasTeacherSchedule: boolean;
        size_max: number | null;
        user_uid: string;
        slug_id: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        recentReviews?: Array<{
          __typename?: "PublicReview";
          uid: string;
          activity_star_rating: number | null;
          details: {
            __typename?: "PublicReviewDetails";
            publicReview: string | null;
          } | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            publicName: string | null;
          };
        }>;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
    }>;
  };
};

export type ParentFragmentFragment = {
  __typename?: "Parent";
  uid: string;
  name: string | null;
  photo: string | null;
  publicName: string | null;
  introduction: string | null;
  created_at: any | null;
  deleted_at: any | null;
  timeZone: string | null;
  socialOptOut: boolean;
  consent_to_share_class_history: boolean | null;
  consent_to_share_favourites: boolean | null;
};

export type ParentLeaderFragmentFragment = {
  __typename?: "Parent";
  uid: string;
  name: string | null;
  photo: string | null;
  timeZone: string | null;
};

export type ParentAdminFragmentFragment = {
  __typename?: "Parent";
  uid: string;
  name: string | null;
  email: string | null;
  photo: string | null;
  timeZone: string | null;
};

export type PastTeachersForParentProfileQueryVariables = Exact<{
  uid: Scalars["ID"];
  profileLinkUid?: InputMaybe<Scalars["String"]>;
  publicView?: InputMaybe<Scalars["Boolean"]>;
}>;

export type PastTeachersForParentProfileQuery = {
  __typename?: "Query";
  pastTeachersForParentProfile: Array<{
    __typename?: "Leader";
    uid: string;
    name: string | null;
    leader_link: string | null;
    created_at: any | null;
    photo: string | null;
    suspended_at: any | null;
    cityState: string | null;
    socialOptOut: boolean;
    is_crosslister: boolean | null;
    timeZone: string | null;
    hasAvailabilitySet: boolean;
    approved: boolean;
    hasBackgroundCheckExpired: boolean | null;
    reviewCount: number;
    averageActivityStarRating: number | null;
    hasListings: boolean;
    video: {
      __typename?: "Attachment";
      videoThumbnailUrl: string | null;
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    details: {
      __typename?: "LeaderDetails";
      about: string | null;
      headline: string | null;
      headlineTranslated: string | null;
      countryOfResidence: string | null;
    };
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    teacherForSellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
    } | null;
  }>;
};

export type SettleOrderMutationVariables = Exact<{
  orderSlugId: Scalars["ID"];
  taxCalculationId?: InputMaybe<Scalars["String"]>;
  bulkPurchaseRecurringMeetingsInfo?: InputMaybe<
    Array<BulkPurchaseRecurringMeetingsInfo> | BulkPurchaseRecurringMeetingsInfo
  >;
  prepaidPurchaseStartDate?: InputMaybe<Scalars["DateTime"]>;
}>;

export type SettleOrderMutation = {
  __typename?: "Mutation";
  settleOrder: {
    __typename?: "Order";
    orderSlugId: string;
    isFirstPurchaseByUser: boolean;
    enrollments: Array<{
      __typename?: "Enrollment";
      isFirstPurchaseByUser: boolean;
      isFirstOutschoolClass: boolean;
      uid: string;
      section_uid: string | null;
      price_cents: number | null;
      priceCents: number | null;
      created_at: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      withdrawnAt: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      isPrepay: boolean;
      hasCompletedLesson: boolean;
      hasPostedComment: boolean;
      refundableAmountCents: number;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      usersCanCommunicate: boolean;
      purchasedAsGift: boolean;
      pricingOffer: {
        __typename?: "PricingOffer";
        uid: string;
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      payments: Array<{
        __typename?: "EnrollmentPayment";
        uid: string;
        amount_cents: number | null;
        order_slug_id: string | null;
        stripe_charge_id: string | null;
        purchase_order_id: string | null;
        esa_order_id: string | null;
        intercom_url: string | null;
        last4: string | null;
        created_at: any | null;
        paid_at: any | null;
        disbursed_at: any | null;
        payout_uid: string | null;
        start_time: any | null;
        end_time: any | null;
        unrefundedCents: number;
        isOngoingRefundable: boolean;
        voucher_name: string | null;
        pricing_offer_uid: string | null;
        credit_transaction_uid: string | null;
        credit_account_type: string | null;
        coupon_code_uid: string | null;
        currency_code: CurrencyCode | null;
        exchange_rate: number | null;
        invoice_uid: string | null;
        funding_program_invoice_uid: string | null;
        service_fee_percentage: number | null;
        couponCode: {
          __typename?: "CouponCode";
          code: string;
          coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
        } | null;
        pricingOffer: {
          __typename?: "PricingOffer";
          name: string;
          buyerOrgName: string | null;
          isFinancialAid: boolean;
        } | null;
      }>;
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      siblings: Array<{
        __typename?: "Sibling";
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
        };
        currentOrLastSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          uid: string;
          activity_uid: string;
          start_time: any | null;
          end_time: any | null;
          teacher_support_start_time: any | null;
          startsAtNight: boolean | null;
          is_cross_listed: boolean;
          size_max: number | null;
          size_min: number | null;
          isPublished: boolean | null;
          price_cents: number | null;
          priceCredits: number | null;
          published_at: any | null;
          updated_at: any;
          canceled_at: any | null;
          deleted_at: any | null;
          ongoing_stopped_at: any | null;
          duration_minutes: number | null;
          usesOutschoolVideoChat: boolean;
          usersCanSendPrivateMessage: boolean;
          currentUserCanManage: boolean;
          isBuyable: boolean;
          allowsTeacherTransfer: boolean;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            deleted_at: any | null;
            created_at: any | null;
          } | null;
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          details: {
            __typename?: "SectionDetails";
            autoScheduledDraft: boolean | null;
          };
          prepaidOngoingPeriodOptions: Array<{
            __typename?: "Period";
            startOfIsoWeek: any;
            endOfIsoWeek: any;
          }> | null;
        };
      }>;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
        scheduleType: PaymentScheduleTypes;
        amountCents: number | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
    }>;
    enrollmentMeetingPurchase: {
      __typename?: "EnrollmentMeetingPurchase";
      uid: string;
      activityUid: string | null;
      enrollmentUid: string | null;
      meetingUid: string | null;
      orderSlugId: string;
      confirmedAt: any | null;
    } | null;
    giftEnrollments: Array<{
      __typename?: "GiftEnrollment";
      uid: string;
      acceptGiftSlugId: string;
      price_cents: number | null;
      confirmedAt: any | null;
      currency_code: CurrencyCode;
      payments: Array<{
        __typename?: "EnrollmentPayment";
        uid: string;
        amount_cents: number | null;
        order_slug_id: string | null;
        stripe_charge_id: string | null;
        purchase_order_id: string | null;
        esa_order_id: string | null;
        intercom_url: string | null;
        last4: string | null;
        created_at: any | null;
        paid_at: any | null;
        disbursed_at: any | null;
        payout_uid: string | null;
        start_time: any | null;
        end_time: any | null;
        unrefundedCents: number;
        isOngoingRefundable: boolean;
        voucher_name: string | null;
        pricing_offer_uid: string | null;
        credit_transaction_uid: string | null;
        credit_account_type: string | null;
        coupon_code_uid: string | null;
        currency_code: CurrencyCode | null;
        exchange_rate: number | null;
        invoice_uid: string | null;
        funding_program_invoice_uid: string | null;
        service_fee_percentage: number | null;
        couponCode: {
          __typename?: "CouponCode";
          code: string;
          coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
        } | null;
        pricingOffer: {
          __typename?: "PricingOffer";
          name: string;
          buyerOrgName: string | null;
          isFinancialAid: boolean;
        } | null;
      }>;
    }> | null;
    giftCard: {
      __typename?: "GiftCard";
      uid: string;
      orderSlugId: string;
      amountCents: number;
      redemptionCode: string | null;
    } | null;
  };
};

export type SettleOrderEnrollmentMeetingPurchaseMutationVariables = Exact<{
  orderSlugId: Scalars["ID"];
  taxCalculationId?: InputMaybe<Scalars["String"]>;
  purchaseRecurringMeetingsInfo?: InputMaybe<PurchaseRecurringMeetingsInfo>;
  meetingRequestUids?: InputMaybe<Array<Scalars["ID"]> | Scalars["ID"]>;
}>;

export type SettleOrderEnrollmentMeetingPurchaseMutation = {
  __typename?: "Mutation";
  settleOrderEnrollmentMeetingPurchase: {
    __typename?: "Order";
    orderSlugId: string;
    isFirstPurchaseByUser: boolean;
    enrollments: Array<{
      __typename?: "Enrollment";
      isFirstPurchaseByUser: boolean;
      isFirstOutschoolClass: boolean;
      uid: string;
      section_uid: string | null;
      price_cents: number | null;
      priceCents: number | null;
      created_at: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      withdrawnAt: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      isPrepay: boolean;
      hasCompletedLesson: boolean;
      hasPostedComment: boolean;
      refundableAmountCents: number;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      usersCanCommunicate: boolean;
      purchasedAsGift: boolean;
      pricingOffer: {
        __typename?: "PricingOffer";
        uid: string;
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      payments: Array<{
        __typename?: "EnrollmentPayment";
        uid: string;
        amount_cents: number | null;
        order_slug_id: string | null;
        stripe_charge_id: string | null;
        purchase_order_id: string | null;
        esa_order_id: string | null;
        intercom_url: string | null;
        last4: string | null;
        created_at: any | null;
        paid_at: any | null;
        disbursed_at: any | null;
        payout_uid: string | null;
        start_time: any | null;
        end_time: any | null;
        unrefundedCents: number;
        isOngoingRefundable: boolean;
        voucher_name: string | null;
        pricing_offer_uid: string | null;
        credit_transaction_uid: string | null;
        credit_account_type: string | null;
        coupon_code_uid: string | null;
        currency_code: CurrencyCode | null;
        exchange_rate: number | null;
        invoice_uid: string | null;
        funding_program_invoice_uid: string | null;
        service_fee_percentage: number | null;
        couponCode: {
          __typename?: "CouponCode";
          code: string;
          coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
        } | null;
        pricingOffer: {
          __typename?: "PricingOffer";
          name: string;
          buyerOrgName: string | null;
          isFinancialAid: boolean;
        } | null;
      }>;
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      siblings: Array<{
        __typename?: "Sibling";
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
        };
        currentOrLastSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          uid: string;
          activity_uid: string;
          start_time: any | null;
          end_time: any | null;
          teacher_support_start_time: any | null;
          startsAtNight: boolean | null;
          is_cross_listed: boolean;
          size_max: number | null;
          size_min: number | null;
          isPublished: boolean | null;
          price_cents: number | null;
          priceCredits: number | null;
          published_at: any | null;
          updated_at: any;
          canceled_at: any | null;
          deleted_at: any | null;
          ongoing_stopped_at: any | null;
          duration_minutes: number | null;
          usesOutschoolVideoChat: boolean;
          usersCanSendPrivateMessage: boolean;
          currentUserCanManage: boolean;
          isBuyable: boolean;
          allowsTeacherTransfer: boolean;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            deleted_at: any | null;
            created_at: any | null;
          } | null;
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          details: {
            __typename?: "SectionDetails";
            autoScheduledDraft: boolean | null;
          };
          prepaidOngoingPeriodOptions: Array<{
            __typename?: "Period";
            startOfIsoWeek: any;
            endOfIsoWeek: any;
          }> | null;
        };
      }>;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
        scheduleType: PaymentScheduleTypes;
        amountCents: number | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
    }>;
    enrollmentMeetingPurchase: {
      __typename?: "EnrollmentMeetingPurchase";
      uid: string;
      activityUid: string | null;
      enrollmentUid: string | null;
      meetingUid: string | null;
      orderSlugId: string;
      confirmedAt: any | null;
    } | null;
  };
};

export type AcceptPaymentWithStripeMutationVariables = Exact<{
  orderSlugId: Scalars["ID"];
  amountCents: Scalars["Int"];
  orderPaymentUid?: InputMaybe<Scalars["ID"]>;
  charterSchoolUid?: InputMaybe<Scalars["ID"]>;
  purchaserName?: InputMaybe<Scalars["String"]>;
  purchaserEmail?: InputMaybe<Scalars["String"]>;
  exchangeRate?: InputMaybe<Scalars["Float"]>;
  currencyCode?: InputMaybe<CurrencyCode>;
  savePaymentMethod?: InputMaybe<Scalars["Boolean"]>;
}>;

export type AcceptPaymentWithStripeMutation = {
  __typename?: "Mutation";
  acceptPaymentWithStripe: {
    __typename?: "StripePaymentIntent";
    paymentIntentClientId: string;
    orderPaymentUid: string;
  };
};

export type AcceptPaymentWithPricingOfferMutationVariables = Exact<{
  orderSlugId: Scalars["ID"];
  amountCents: Scalars["Int"];
  pricingOfferUid: Scalars["ID"];
  exchangeRate?: InputMaybe<Scalars["Float"]>;
  currencyCode?: InputMaybe<Scalars["String"]>;
}>;

export type AcceptPaymentWithPricingOfferMutation = {
  __typename?: "Mutation";
  acceptPaymentWithPricingOffer: boolean;
};

export type AcceptPaymentWithPurchaseOrderMutationVariables = Exact<{
  orderSlugId: Scalars["ID"];
  amountCents: Scalars["Int"];
  charterSchoolUid: Scalars["String"];
  intercomUrl: Scalars["String"];
  purchaseOrderId: Scalars["String"];
}>;

export type AcceptPaymentWithPurchaseOrderMutation = {
  __typename?: "Mutation";
  acceptPaymentWithPurchaseOrder: boolean;
};

export type AcceptPaymentWithCouponCodeMutationVariables = Exact<{
  orderSlugId: Scalars["ID"];
  activityUid: Scalars["ID"];
  amountCents: Scalars["Int"];
  code: Scalars["String"];
  currencyCode?: InputMaybe<CurrencyCode>;
  exchangeRate?: InputMaybe<Scalars["Float"]>;
}>;

export type AcceptPaymentWithCouponCodeMutation = {
  __typename?: "Mutation";
  acceptPaymentWithCouponCode: CouponState;
};

export type AcceptPaymentWithClassWalletMutationVariables = Exact<{
  orderSlugId: Scalars["ID"];
  amountCents: Scalars["Int"];
  taxCalculationId?: InputMaybe<Scalars["String"]>;
  taxAmountCents?: InputMaybe<Scalars["Int"]>;
}>;

export type AcceptPaymentWithClassWalletMutation = {
  __typename?: "Mutation";
  acceptPaymentWithClassWallet: boolean;
};

export type CancelOrderMutationMutationVariables = Exact<{
  orderSlugId: Scalars["String"];
}>;

export type CancelOrderMutationMutation = {
  __typename?: "Mutation";
  cancelOrder: boolean;
};

export type TextFeedbackByUserQueryVariables = Exact<{
  userUid: Scalars["ID"];
  offset?: InputMaybe<Scalars["Int"]>;
}>;

export type TextFeedbackByUserQuery = {
  __typename?: "Query";
  textFeedbackByUser: Array<{
    __typename?: "PublicReview";
    uid: string;
    activity_star_rating: number | null;
    created_at: any;
    details: {
      __typename?: "PublicReviewDetails";
      publicReview: string | null;
    } | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      isClub: boolean;
      slug_id: string;
      title: string;
      titleTranslated: string | null;
    } | null;
  }>;
};

export type RandomCategoriesByFacetQueryVariables = Exact<{
  facet?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type RandomCategoriesByFacetQuery = {
  __typename?: "Query";
  randomCategoriesByFacet: Array<{
    __typename?: "CategoryPage";
    uid: string;
    basePath: string;
    nameTitleCased: string;
    slug: string;
  } | null> | null;
};

export type ReceiptQueryQueryVariables = Exact<{
  orderSlugId: Scalars["ID"];
}>;

export type ReceiptQueryQuery = {
  __typename?: "Query";
  order: {
    __typename?: "Order";
    orderSlugId: string;
    exchangeRate: number | null;
    currencyCode: CurrencyCode | null;
    totalAmountCents: number;
    subscriptionCreditsApplied: number;
    otherTendersApplied: number;
    taxCents: number;
    payments: Array<{
      __typename?: "OrderPayment";
      uid: string;
      order_slug_id: string | null;
      tender_type: string | null;
      amount_cents: number;
    }>;
    organization: { __typename?: "Organization"; name: string } | null;
    enrollments: Array<{
      __typename?: "Enrollment";
      hasPaymentSchedule: boolean;
      service_fee_percentage: number;
      uid: string;
      section_uid: string | null;
      price_cents: number | null;
      priceCents: number | null;
      created_at: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      withdrawnAt: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      isPrepay: boolean;
      hasCompletedLesson: boolean;
      hasPostedComment: boolean;
      refundableAmountCents: number;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      usersCanCommunicate: boolean;
      purchasedAsGift: boolean;
      payments: Array<{
        __typename?: "EnrollmentPayment";
        uid: string;
        amount_cents: number | null;
        amount_credits: number | null;
        order_slug_id: string | null;
        stripe_charge_id: string | null;
        purchase_order_id: string | null;
        pricing_offer_uid: string | null;
        esa_order_id: string | null;
        invoice_uid: string | null;
        funding_program_invoice_uid: string | null;
        intercom_url: string | null;
        last4: string | null;
        created_at: any | null;
        paid_at: any | null;
        disbursed_at: any | null;
        payout_uid: string | null;
        start_time: any | null;
        end_time: any | null;
        unrefundedCents: number;
        isOngoingRefundable: boolean;
        voucher_name: string | null;
        credit_transaction_uid: string | null;
        credit_account_type: string | null;
        service_fee_percentage: number | null;
        coupon_code_uid: string | null;
        currency_code: CurrencyCode | null;
        exchange_rate: number | null;
        stripeReceiptUrl: string | null;
        stripePaymentMethod: string | null;
        organization: {
          __typename?: "Organization";
          uid: string;
          name: string;
          state: string | null;
          logoUrl: string | null;
          urlName: string | null;
        } | null;
        refunds: Array<{
          __typename?: "EnrollmentPaymentRefund";
          uid: string;
          user_uid: string;
          amount_cents: number;
          amount_credits: number | null;
          refunded_at: any | null;
          reason: string | null;
          user_role: string | null;
          note: string | null;
          reduces_teacher_payout: boolean;
          amount_in_local_currency: number | null;
          currency_code: CurrencyCode | null;
          exchange_rate: number | null;
          addOutschoolCreditTransaction: {
            __typename?: "CreditTransaction";
            uid: string;
            amount_cents: number;
            expiresAt: any | null;
            unspentCents: number | null;
          } | null;
        }>;
        couponCode: {
          __typename?: "CouponCode";
          code: string;
          coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
        } | null;
        pricingOffer: {
          __typename?: "PricingOffer";
          name: string;
          buyerOrgName: string | null;
          isFinancialAid: boolean;
        } | null;
      }>;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      section: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        activity: {
          __typename?: "Activity";
          uid: string;
          slug_id: string;
          user_uid: string;
          title: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          class_experience: string | null;
          learning_goals: string | null;
          learningGoals: Array<string>;
          assessment: string | null;
          homework: string | null;
          grading_policy: string | null;
          prerequisites: string | null;
          published_at: any | null;
          is_online: boolean;
          age_min: number | null;
          age_max: number | null;
          english_proficiency_level: EnglishProficiencyLevel | null;
          grade_level_min: string | null;
          grade_level_max: string | null;
          size_min: number | null;
          size_max: number | null;
          duration_minutes: number | null;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          price_cents: number | null;
          priceCredits: number | null;
          summary: string | null;
          summaryTranslated: string | null;
          is_ongoing_weekly: boolean;
          subject: string | null;
          languageOfInstruction: any | null;
          summaryForLearners: string | null;
          allowWaitlist: boolean | null;
          isClub: boolean;
          isAutoSchedulingEnabled: boolean | null;
          autoSchedulingDaysNoticeMin: number | null;
          autoSchedulingDaysNoticeMax: number | null;
          allows_recurring_payment: boolean | null;
          allows_late_enrollments_for_fixed_length_classes: boolean;
          allowsFutureOngoingEnrollments: boolean;
          has_building_content: boolean | null;
          hasTeacherSchedule: boolean;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          isOneTime: boolean;
          classFormat: EducatorSelectedFormat;
          classroomType: ClassroomType;
          isIncludedWithMembership: boolean;
          strictAgeRange: {
            __typename?: "AgeRangeType";
            min: number;
            max: number;
          } | null;
          proficiency_level: {
            __typename?: "ProficiencyLevel";
            level: Array<string | null> | null;
            text: string | null;
          } | null;
          refundPolicy: {
            __typename?: "RefundPolicy";
            name: string;
            description: string;
            type: RefundPolicyType;
          };
          photo: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
          photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
        };
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        }>;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      siblings: Array<{
        __typename?: "Sibling";
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
        };
        currentOrLastSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          uid: string;
          activity_uid: string;
          start_time: any | null;
          end_time: any | null;
          teacher_support_start_time: any | null;
          startsAtNight: boolean | null;
          is_cross_listed: boolean;
          size_max: number | null;
          size_min: number | null;
          isPublished: boolean | null;
          price_cents: number | null;
          priceCredits: number | null;
          published_at: any | null;
          updated_at: any;
          canceled_at: any | null;
          deleted_at: any | null;
          ongoing_stopped_at: any | null;
          duration_minutes: number | null;
          usesOutschoolVideoChat: boolean;
          usersCanSendPrivateMessage: boolean;
          currentUserCanManage: boolean;
          isBuyable: boolean;
          allowsTeacherTransfer: boolean;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            deleted_at: any | null;
            created_at: any | null;
          } | null;
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          details: {
            __typename?: "SectionDetails";
            autoScheduledDraft: boolean | null;
          };
          prepaidOngoingPeriodOptions: Array<{
            __typename?: "Period";
            startOfIsoWeek: any;
            endOfIsoWeek: any;
          }> | null;
        };
      }>;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
        scheduleType: PaymentScheduleTypes;
        amountCents: number | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
    }>;
    enrollmentMeetingPurchase: {
      __typename?: "EnrollmentMeetingPurchase";
      uid: string;
      activityUid: string | null;
      enrollmentUid: string | null;
      meetingUid: string | null;
      orderSlugId: string;
      confirmedAt: any | null;
      activity: {
        __typename?: "Activity";
        uid: string;
        slug_id: string;
        user_uid: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        class_experience: string | null;
        learning_goals: string | null;
        learningGoals: Array<string>;
        assessment: string | null;
        homework: string | null;
        grading_policy: string | null;
        prerequisites: string | null;
        published_at: any | null;
        is_online: boolean;
        age_min: number | null;
        age_max: number | null;
        english_proficiency_level: EnglishProficiencyLevel | null;
        grade_level_min: string | null;
        grade_level_max: string | null;
        size_min: number | null;
        size_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCredits: number | null;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        languageOfInstruction: any | null;
        summaryForLearners: string | null;
        allowWaitlist: boolean | null;
        isClub: boolean;
        isAutoSchedulingEnabled: boolean | null;
        autoSchedulingDaysNoticeMin: number | null;
        autoSchedulingDaysNoticeMax: number | null;
        allows_recurring_payment: boolean | null;
        allows_late_enrollments_for_fixed_length_classes: boolean;
        allowsFutureOngoingEnrollments: boolean;
        has_building_content: boolean | null;
        hasTeacherSchedule: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        classFormat: EducatorSelectedFormat;
        classroomType: ClassroomType;
        isIncludedWithMembership: boolean;
        strictAgeRange: {
          __typename?: "AgeRangeType";
          min: number;
          max: number;
        } | null;
        proficiency_level: {
          __typename?: "ProficiencyLevel";
          level: Array<string | null> | null;
          text: string | null;
        } | null;
        refundPolicy: {
          __typename?: "RefundPolicy";
          name: string;
          description: string;
          type: RefundPolicyType;
        };
        photo: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
        photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
      } | null;
    } | null;
    enrollmentMeetingPurchases: Array<{
      __typename?: "EnrollmentMeetingPurchase";
      uid: string;
      activityUid: string | null;
      enrollmentUid: string | null;
      meetingUid: string | null;
      orderSlugId: string;
      confirmedAt: any | null;
      activity: {
        __typename?: "Activity";
        uid: string;
        slug_id: string;
        user_uid: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        class_experience: string | null;
        learning_goals: string | null;
        learningGoals: Array<string>;
        assessment: string | null;
        homework: string | null;
        grading_policy: string | null;
        prerequisites: string | null;
        published_at: any | null;
        is_online: boolean;
        age_min: number | null;
        age_max: number | null;
        english_proficiency_level: EnglishProficiencyLevel | null;
        grade_level_min: string | null;
        grade_level_max: string | null;
        size_min: number | null;
        size_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCredits: number | null;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        languageOfInstruction: any | null;
        summaryForLearners: string | null;
        allowWaitlist: boolean | null;
        isClub: boolean;
        isAutoSchedulingEnabled: boolean | null;
        autoSchedulingDaysNoticeMin: number | null;
        autoSchedulingDaysNoticeMax: number | null;
        allows_recurring_payment: boolean | null;
        allows_late_enrollments_for_fixed_length_classes: boolean;
        allowsFutureOngoingEnrollments: boolean;
        has_building_content: boolean | null;
        hasTeacherSchedule: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        classFormat: EducatorSelectedFormat;
        classroomType: ClassroomType;
        isIncludedWithMembership: boolean;
        strictAgeRange: {
          __typename?: "AgeRangeType";
          min: number;
          max: number;
        } | null;
        proficiency_level: {
          __typename?: "ProficiencyLevel";
          level: Array<string | null> | null;
          text: string | null;
        } | null;
        refundPolicy: {
          __typename?: "RefundPolicy";
          name: string;
          description: string;
          type: RefundPolicyType;
        };
        photo: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
        photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
      } | null;
    }> | null;
    giftEnrollments: Array<{
      __typename?: "GiftEnrollment";
      withdrawnAt: any | null;
      uid: string;
      giftClaimedAt: any | null;
      createdAt: any;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      hasPaymentSchedule: boolean;
      isEnded: boolean;
      isPaused: boolean;
      orderSlugId: string | null;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      priceCents: number | null;
      currentUserIsPurchaser: boolean;
      refundableAmountCents: number;
      payments: Array<{
        __typename?: "EnrollmentPayment";
        uid: string;
        amount_cents: number | null;
        amount_credits: number | null;
        order_slug_id: string | null;
        stripe_charge_id: string | null;
        purchase_order_id: string | null;
        pricing_offer_uid: string | null;
        esa_order_id: string | null;
        invoice_uid: string | null;
        funding_program_invoice_uid: string | null;
        intercom_url: string | null;
        last4: string | null;
        created_at: any | null;
        paid_at: any | null;
        disbursed_at: any | null;
        payout_uid: string | null;
        start_time: any | null;
        end_time: any | null;
        unrefundedCents: number;
        isOngoingRefundable: boolean;
        voucher_name: string | null;
        credit_transaction_uid: string | null;
        credit_account_type: string | null;
        service_fee_percentage: number | null;
        coupon_code_uid: string | null;
        currency_code: CurrencyCode | null;
        exchange_rate: number | null;
        stripeReceiptUrl: string | null;
        stripePaymentMethod: string | null;
        organization: {
          __typename?: "Organization";
          uid: string;
          name: string;
          state: string | null;
          logoUrl: string | null;
          urlName: string | null;
        } | null;
        refunds: Array<{
          __typename?: "EnrollmentPaymentRefund";
          uid: string;
          user_uid: string;
          amount_cents: number;
          amount_credits: number | null;
          refunded_at: any | null;
          reason: string | null;
          user_role: string | null;
          note: string | null;
          reduces_teacher_payout: boolean;
          amount_in_local_currency: number | null;
          currency_code: CurrencyCode | null;
          exchange_rate: number | null;
          addOutschoolCreditTransaction: {
            __typename?: "CreditTransaction";
            uid: string;
            amount_cents: number;
            expiresAt: any | null;
            unspentCents: number | null;
          } | null;
        }>;
        couponCode: {
          __typename?: "CouponCode";
          code: string;
          coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
        } | null;
        pricingOffer: {
          __typename?: "PricingOffer";
          name: string;
          buyerOrgName: string | null;
          isFinancialAid: boolean;
        } | null;
      }>;
      section: {
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        activity: {
          __typename?: "Activity";
          uid: string;
          slug_id: string;
          user_uid: string;
          title: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          class_experience: string | null;
          learning_goals: string | null;
          learningGoals: Array<string>;
          assessment: string | null;
          homework: string | null;
          grading_policy: string | null;
          prerequisites: string | null;
          published_at: any | null;
          is_online: boolean;
          age_min: number | null;
          age_max: number | null;
          english_proficiency_level: EnglishProficiencyLevel | null;
          grade_level_min: string | null;
          grade_level_max: string | null;
          size_min: number | null;
          size_max: number | null;
          duration_minutes: number | null;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          price_cents: number | null;
          priceCredits: number | null;
          summary: string | null;
          summaryTranslated: string | null;
          is_ongoing_weekly: boolean;
          subject: string | null;
          languageOfInstruction: any | null;
          summaryForLearners: string | null;
          allowWaitlist: boolean | null;
          isClub: boolean;
          isAutoSchedulingEnabled: boolean | null;
          autoSchedulingDaysNoticeMin: number | null;
          autoSchedulingDaysNoticeMax: number | null;
          allows_recurring_payment: boolean | null;
          allows_late_enrollments_for_fixed_length_classes: boolean;
          allowsFutureOngoingEnrollments: boolean;
          has_building_content: boolean | null;
          hasTeacherSchedule: boolean;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          isOneTime: boolean;
          classFormat: EducatorSelectedFormat;
          classroomType: ClassroomType;
          isIncludedWithMembership: boolean;
          strictAgeRange: {
            __typename?: "AgeRangeType";
            min: number;
            max: number;
          } | null;
          proficiency_level: {
            __typename?: "ProficiencyLevel";
            level: Array<string | null> | null;
            text: string | null;
          } | null;
          refundPolicy: {
            __typename?: "RefundPolicy";
            name: string;
            description: string;
            type: RefundPolicyType;
          };
          photo: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
          photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
        };
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        }>;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      };
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
    }> | null;
    donation: {
      __typename?: "Donation";
      orderSlugId: string;
      amountCents: number;
      confirmedAt: any | null;
    } | null;
    giftCard: {
      __typename?: "GiftCard";
      orderSlugId: string;
      amountCents: number;
      confirmedAt: any | null;
    } | null;
  };
};

export type RecentlyCompletedClassesQueryQueryVariables = Exact<{
  endDate?: InputMaybe<Scalars["DateTime"]>;
  learnerUid?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type RecentlyCompletedClassesQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    learners: Array<{
      __typename?: "Learner";
      uid: string;
      name: string | null;
    }>;
    enrollmentsForTranscript: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
      withdrawn_at: any | null;
      ongoing_start_time: any | null;
      ongoingEndTime: any | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        avatar: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        canceled_at: any | null;
        start_time: any | null;
        end_time: any | null;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          leader_link: string | null;
          photo: string | null;
        };
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          isSelfPaced: boolean;
          isOneTime: boolean;
          hasTeacherSchedule: boolean;
          size_max: number | null;
          photo: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        }>;
        currentUserPublicReview: {
          __typename?: "PublicReview";
          uid: string;
          currentUserCanEdit: boolean;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type DeleteClassRecordingMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type DeleteClassRecordingMutation = {
  __typename?: "Mutation";
  deleteClassRecording: boolean;
};

export type SampleClubPostFragmentFragment = {
  __typename?: "SampleClubPost";
  text: string | null;
  attachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
    };
  }> | null;
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
    };
  } | null;
  comments: Array<{
    __typename?: "SampleClubPostComment";
    text: string | null;
  }>;
};

export type UpdatePrivacyStatusesMutationVariables = Exact<{
  listUids: Array<Scalars["ID"]> | Scalars["ID"];
  privacyStatus: SavedClassListStatus;
}>;

export type UpdatePrivacyStatusesMutation = {
  __typename?: "Mutation";
  updatePrivacyStatuses: Array<{
    __typename?: "SavedClassList";
    uid: string;
    privacyStatus: SavedClassListStatus;
  }>;
};

export type SectionFragmentFragment = {
  __typename?: "Section";
  uid: string;
  activity_uid: string;
  start_time: any | null;
  end_time: any | null;
  teacher_support_start_time: any | null;
  startsAtNight: boolean | null;
  is_cross_listed: boolean;
  size_max: number | null;
  size_min: number | null;
  isPublished: boolean | null;
  price_cents: number | null;
  priceCredits: number | null;
  published_at: any | null;
  updated_at: any;
  canceled_at: any | null;
  deleted_at: any | null;
  ongoing_stopped_at: any | null;
  duration_minutes: number | null;
  usesOutschoolVideoChat: boolean;
  usersCanSendPrivateMessage: boolean;
  currentUserCanManage: boolean;
  isBuyable: boolean;
  allowsTeacherTransfer: boolean;
  nextOngoingMeeting: {
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
  } | null;
  leader: { __typename?: "Leader"; uid: string; name: string | null };
  details: {
    __typename?: "SectionDetails";
    autoScheduledDraft: boolean | null;
  };
  prepaidOngoingPeriodOptions: Array<{
    __typename?: "Period";
    startOfIsoWeek: any;
    endOfIsoWeek: any;
  }> | null;
};

export type SectionEnrolledFragmentFragment = {
  __typename?: "Section";
  details: {
    __typename?: "SectionDetails";
    onlineClassroom: {
      __typename?: "OnlineClassroom";
      type: string | null;
      url: string | null;
    } | null;
  };
};

export type SectionLeaderFragmentFragment = {
  __typename?: "Section";
  created_at: any;
  validEnrollmentCount: number;
  isAutoCanceled: boolean;
  currentUserCanManage: boolean;
  currentUserIsOwner: boolean;
  paidAmount: number | null;
  details: {
    __typename?: "SectionDetails";
    onlineClassroom: {
      __typename?: "OnlineClassroom";
      type: string | null;
      url: string | null;
    } | null;
  };
  checklist: {
    __typename?: "SectionChecklist";
    autoCanceledAt: any | null;
    grandfatheredAt2017Rate: boolean | null;
  };
};

export type SectionAdminFragmentFragment = {
  __typename?: "Section";
  notes: string | null;
  standardPayoutCents: number;
  zoomMeeting: { __typename?: "ZoomMeeting"; zoom_id: string | null } | null;
};

export type CreateSectionMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  attribution?: InputMaybe<Attribution>;
}>;

export type CreateSectionMutation = {
  __typename?: "Mutation";
  createSection: {
    __typename?: "Section";
    filledSpaceCount: number;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    created_at: any;
    validEnrollmentCount: number;
    isAutoCanceled: boolean;
    currentUserIsOwner: boolean;
    paidAmount: number | null;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    }>;
    activity: {
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    leader: {
      __typename?: "Leader";
      uid: string;
      is_crosslister: boolean | null;
      name: string | null;
    };
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
    checklist: {
      __typename?: "SectionChecklist";
      autoCanceledAt: any | null;
      grandfatheredAt2017Rate: boolean | null;
    };
  };
};

export type UpdateSectionMutationVariables = Exact<{
  uid: Scalars["ID"];
  updates?: InputMaybe<LeaderSectionInput>;
  details?: InputMaybe<LeaderSectionDetailInput>;
  onlineClassroom?: InputMaybe<OnlineClassroomInput>;
}>;

export type UpdateSectionMutation = {
  __typename?: "Mutation";
  updateSection: {
    __typename?: "Section";
    filledSpaceCount: number;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    created_at: any;
    validEnrollmentCount: number;
    isAutoCanceled: boolean;
    currentUserIsOwner: boolean;
    paidAmount: number | null;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    }>;
    leader: {
      __typename?: "Leader";
      uid: string;
      is_crosslister: boolean | null;
      name: string | null;
    };
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
    checklist: {
      __typename?: "SectionChecklist";
      autoCanceledAt: any | null;
      grandfatheredAt2017Rate: boolean | null;
    };
  };
};

export type StopOngoingSectionMutationMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  stopAfter?: InputMaybe<Scalars["DateTime"]>;
  cancellationNote?: InputMaybe<Scalars["String"]>;
  refundAmountCents?: InputMaybe<Scalars["Int"]>;
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
}>;

export type StopOngoingSectionMutationMutation = {
  __typename?: "Mutation";
  stopOngoingSection: {
    __typename?: "Section";
    filledSpaceCount: number;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    created_at: any;
    validEnrollmentCount: number;
    isAutoCanceled: boolean;
    currentUserIsOwner: boolean;
    paidAmount: number | null;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    }>;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
    checklist: {
      __typename?: "SectionChecklist";
      autoCanceledAt: any | null;
      grandfatheredAt2017Rate: boolean | null;
    };
  };
};

export type CancelSectionMutationMutationVariables = Exact<{
  uid: Scalars["ID"];
  cancellationNote?: InputMaybe<Scalars["String"]>;
  withdraw?: InputMaybe<Scalars["Boolean"]>;
  refundAmountCents?: InputMaybe<Scalars["Int"]>;
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
}>;

export type CancelSectionMutationMutation = {
  __typename?: "Mutation";
  cancelSection: {
    __typename?: "Section";
    filledSpaceCount: number;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    created_at: any;
    validEnrollmentCount: number;
    isAutoCanceled: boolean;
    currentUserIsOwner: boolean;
    paidAmount: number | null;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    }>;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
    checklist: {
      __typename?: "SectionChecklist";
      autoCanceledAt: any | null;
      grandfatheredAt2017Rate: boolean | null;
    };
  };
};

export type RefundAllEnrollmentsInSectionMutationVariables = Exact<{
  uid: Scalars["ID"];
  cancellationNote?: InputMaybe<Scalars["String"]>;
  shouldWithdrawEnrollments?: InputMaybe<Scalars["Boolean"]>;
  refundAmountCents?: InputMaybe<Scalars["Int"]>;
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
}>;

export type RefundAllEnrollmentsInSectionMutation = {
  __typename?: "Mutation";
  refundAllEnrollmentsInSection: {
    __typename?: "Section";
    filledSpaceCount: number;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    created_at: any;
    validEnrollmentCount: number;
    isAutoCanceled: boolean;
    currentUserIsOwner: boolean;
    paidAmount: number | null;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    }>;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
    checklist: {
      __typename?: "SectionChecklist";
      autoCanceledAt: any | null;
      grandfatheredAt2017Rate: boolean | null;
    };
  };
};

export type GenerateProgressReportMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  notes: Scalars["String"];
  reportLength?: InputMaybe<ReportLength>;
}>;

export type GenerateProgressReportMutation = {
  __typename?: "Mutation";
  generateProgressReport: string;
};

export type SendProgressReportMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
  text: Scalars["String"];
  details: ProgressReportDetailsInput;
}>;

export type SendProgressReportMutation = {
  __typename?: "Mutation";
  sendProgressReport: Array<{
    __typename?: "Message";
    uid: string;
    subject: string | null;
    action: string | null;
    content: string | null;
    created_at: any;
    activity_uid: string | null;
    section_uid: string | null;
    thread_uid: string;
    sender: {
      __typename?: "Sender";
      uid: string;
      name: string | null;
      photo: string | null;
    };
    participants: Array<{
      __typename?: "Participant";
      uid: string;
      name: string | null;
      photo: string | null;
      timeZone: string | null;
      headline: string | null;
      leader_link: string | null;
      isLearner: boolean;
      role: ParticipantRole | null;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    }>;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
  }>;
};

export type UpdateClassPostForPostManagementMutationVariables = Exact<{
  classPostUid: Scalars["ID"];
  messageContentInput?: InputMaybe<MessageContentInput>;
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  title?: InputMaybe<Scalars["String"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UpdateClassPostForPostManagementMutation = {
  __typename?: "Mutation";
  updateClassPost: {
    __typename?: "ClassPost";
    uid: string;
    isWelcomePost: boolean;
    publishAt: any;
    title: string | null;
    promotedAt: any | null;
    pinnedAt: any | null;
    mentionedEnrollmentUids: Array<string>;
    backgroundColor: string | null;
    score: number | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    commentsPreview: {
      __typename?: "CommentsPreview";
      remainingCommentsCount: number;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  };
};

export type DeleteClassPostForLessonMutationVariables = Exact<{
  classPostUid: Scalars["ID"];
}>;

export type DeleteClassPostForLessonMutation = {
  __typename?: "Mutation";
  deleteClassPostForLesson: boolean | null;
};

export type TeacherSectionsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars["String"]>;
  excludeOrgTeachers?: InputMaybe<Scalars["Boolean"]>;
  filterByTeacher?: InputMaybe<Scalars["String"]>;
  sectionsLimit?: InputMaybe<Scalars["Int"]>;
  sectionsOffset?: InputMaybe<Scalars["Int"]>;
  activityType?: InputMaybe<CreateActivityType>;
}>;

export type TeacherSectionsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    teacherAvailability: {
      __typename?: "Availability";
      updated_at: any | null;
      hourlyTimetable: {
        __typename?: "HourlyTimetable";
        mon: Array<number>;
        tue: Array<number>;
        wed: Array<number>;
        thu: Array<number>;
        fri: Array<number>;
        sat: Array<number>;
        sun: Array<number>;
      } | null;
    } | null;
    leaderSections: Array<{
      __typename?: "Section";
      filledSpaceCount: number;
      pausedLearnerCount: number;
      uid: string;
      activity_uid: string;
      start_time: any | null;
      end_time: any | null;
      teacher_support_start_time: any | null;
      startsAtNight: boolean | null;
      is_cross_listed: boolean;
      size_max: number | null;
      size_min: number | null;
      isPublished: boolean | null;
      price_cents: number | null;
      priceCredits: number | null;
      published_at: any | null;
      updated_at: any;
      canceled_at: any | null;
      deleted_at: any | null;
      ongoing_stopped_at: any | null;
      duration_minutes: number | null;
      usesOutschoolVideoChat: boolean;
      usersCanSendPrivateMessage: boolean;
      currentUserCanManage: boolean;
      isBuyable: boolean;
      allowsTeacherTransfer: boolean;
      created_at: any;
      validEnrollmentCount: number;
      isAutoCanceled: boolean;
      currentUserIsOwner: boolean;
      paidAmount: number | null;
      meetings: Array<{
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      }>;
      activity: {
        __typename?: "Activity";
        waitlistSeatsCount: number | null;
        uid: string;
        slug_id: string;
        user_uid: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        class_experience: string | null;
        learning_goals: string | null;
        learningGoals: Array<string>;
        assessment: string | null;
        homework: string | null;
        grading_policy: string | null;
        prerequisites: string | null;
        published_at: any | null;
        is_online: boolean;
        age_min: number | null;
        age_max: number | null;
        english_proficiency_level: EnglishProficiencyLevel | null;
        grade_level_min: string | null;
        grade_level_max: string | null;
        size_min: number | null;
        size_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCredits: number | null;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        languageOfInstruction: any | null;
        summaryForLearners: string | null;
        allowWaitlist: boolean | null;
        isClub: boolean;
        isAutoSchedulingEnabled: boolean | null;
        autoSchedulingDaysNoticeMin: number | null;
        autoSchedulingDaysNoticeMax: number | null;
        allows_recurring_payment: boolean | null;
        allows_late_enrollments_for_fixed_length_classes: boolean;
        allowsFutureOngoingEnrollments: boolean;
        has_building_content: boolean | null;
        hasTeacherSchedule: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        classFormat: EducatorSelectedFormat;
        classroomType: ClassroomType;
        isIncludedWithMembership: boolean;
        strictAgeRange: {
          __typename?: "AgeRangeType";
          min: number;
          max: number;
        } | null;
        proficiency_level: {
          __typename?: "ProficiencyLevel";
          level: Array<string | null> | null;
          text: string | null;
        } | null;
        refundPolicy: {
          __typename?: "RefundPolicy";
          name: string;
          description: string;
          type: RefundPolicyType;
        };
        photo: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
        photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
      };
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        is_crosslister: boolean | null;
      };
      enrollments: Array<{
        __typename?: "Enrollment";
        uid: string;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        } | null;
      }>;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      } | null;
      details: {
        __typename?: "SectionDetails";
        autoScheduledDraft: boolean | null;
        onlineClassroom: {
          __typename?: "OnlineClassroom";
          type: string | null;
          url: string | null;
        } | null;
      };
      prepaidOngoingPeriodOptions: Array<{
        __typename?: "Period";
        startOfIsoWeek: any;
        endOfIsoWeek: any;
      }> | null;
      checklist: {
        __typename?: "SectionChecklist";
        autoCanceledAt: any | null;
        grandfatheredAt2017Rate: boolean | null;
      };
    }>;
  } | null;
};

export type TeacherSectionQueryLessonFragmentFragment = {
  __typename?: "Lesson";
  uid: string;
  title: string | null;
  week_number: number;
  order_within_week: number;
  lessonNumber: number | null;
};

export type TeacherSectionQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type TeacherSectionQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    waitlistSeatsCount: number | null;
    filledSpaceCount: number;
    validEnrollmentCount: number;
    meetingCount: number;
    canBeCanceled: boolean;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    created_at: any;
    isAutoCanceled: boolean;
    currentUserIsOwner: boolean;
    paidAmount: number | null;
    is_self_paced: boolean;
    details: {
      __typename?: "SectionDetails";
      originalEndTime: any | null;
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    activity: {
      __typename?: "Activity";
      uid: string;
      meetingCount: number | null;
      waitlistSeatsCount: number | null;
      isClub: boolean;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      is_ongoing_weekly: boolean;
      weekly_meetings: number | null;
      duration_weeks: number | null;
      published_at: any | null;
      hasTeacherSchedule: boolean;
      isSelfPaced: boolean;
      slug_id: string;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      isFlexSchedule: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        week_number: number;
        order_within_week: number;
        lessonNumber: number | null;
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        }> | null;
      }>;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      is_crosslister: boolean | null;
    };
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
      withdrawn_at: any | null;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      isPaused: boolean;
      ongoingStartTime: any | null;
      isEnded: boolean;
      ongoingEndTime: any | null;
      cancellationType: EnrollmentCancellationType | null;
      withdrawnAt: any | null;
      isWithdrawn: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        avatar: string | null;
        name: string | null;
        age: number | null;
        isBlocked: boolean | null;
        parent: {
          __typename?: "Parent";
          uid: string;
          name: string | null;
          timeZone: string | null;
        };
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        pauseReason: string;
      } | null;
      upcomingPausedMeeting: { __typename?: "Meeting"; start_time: any } | null;
    }>;
    meetingConflictInfo: Array<{
      __typename?: "SectionMeetingConflictInfo";
      meetingUid: string;
      message: string;
      conflictingSectionUid: string;
    }> | null;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
    checklist: {
      __typename?: "SectionChecklist";
      autoCanceledAt: any | null;
      grandfatheredAt2017Rate: boolean | null;
    };
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
    }>;
  } | null;
};

export type SectionRecordingsPageQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type SectionRecordingsPageQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    created_at: any;
    validEnrollmentCount: number;
    isAutoCanceled: boolean;
    currentUserIsOwner: boolean;
    paidAmount: number | null;
    is_self_paced: boolean;
    activity: {
      __typename?: "Activity";
      uid: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      is_ongoing_weekly: boolean;
      weekly_meetings: number | null;
      duration_weeks: number | null;
      isClub: boolean;
      published_at: any | null;
      hasTeacherSchedule: boolean;
      isSelfPaced: boolean;
      slug_id: string;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      isFlexSchedule: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    feedbacks: Array<{
      __typename?: "FeedbackForLeader";
      uid: string;
      activity_star_rating: number | null;
      created_at: any;
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        timeZone: string | null;
      };
      details: {
        __typename?: "FeedbackForLeaderDetails";
        leaderFeedback: string | null;
      };
    }>;
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
      } | null;
    }>;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
    checklist: {
      __typename?: "SectionChecklist";
      autoCanceledAt: any | null;
      grandfatheredAt2017Rate: boolean | null;
    };
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
    }>;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
    } | null;
  } | null;
};

export type SellerOrgAgreementFragmentFragment = {
  __typename?: "SellerOrgAgreement";
  uid: string;
  createdAt: any;
  updatedAt: any;
  signedAt: any | null;
  agreement: string;
  legalName: string | null;
  legalEntityType: string | null;
  legalState: string | null;
  legalAddress: string | null;
  ownsBackgroundChecks: boolean | null;
  contractSignedBy: string | null;
  contractSignerTitle: string | null;
};

export type UpdateSellerOrgAgreementMutationVariables = Exact<{
  input: UpdateSellerOrgAgreementInput;
}>;

export type UpdateSellerOrgAgreementMutation = {
  __typename?: "Mutation";
  updateSellerOrgAgreement: {
    __typename?: "SellerOrgAgreement";
    uid: string;
    createdAt: any;
    updatedAt: any;
    signedAt: any | null;
    agreement: string;
    legalName: string | null;
    legalEntityType: string | null;
    legalState: string | null;
    legalAddress: string | null;
    ownsBackgroundChecks: boolean | null;
    contractSignedBy: string | null;
    contractSignerTitle: string | null;
  };
};

export type SignSellerOrgAgreementMutationVariables = Exact<{
  [key: string]: never;
}>;

export type SignSellerOrgAgreementMutation = {
  __typename?: "Mutation";
  signSellerOrgAgreement: {
    __typename?: "SellerOrgAgreement";
    uid: string;
    createdAt: any;
    updatedAt: any;
    signedAt: any | null;
    agreement: string;
    legalName: string | null;
    legalEntityType: string | null;
    legalState: string | null;
    legalAddress: string | null;
    ownsBackgroundChecks: boolean | null;
    contractSignedBy: string | null;
    contractSignerTitle: string | null;
  };
};

export type SellerOrgAgreementQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SellerOrgAgreementQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    latestSellerOrgAgreement: {
      __typename?: "SellerOrgAgreement";
      uid: string;
      createdAt: any;
      updatedAt: any;
      signedAt: any | null;
      agreement: string;
      legalName: string | null;
      legalEntityType: string | null;
      legalState: string | null;
      legalAddress: string | null;
      ownsBackgroundChecks: boolean | null;
      contractSignedBy: string | null;
      contractSignerTitle: string | null;
    } | null;
  } | null;
};

export type SellerOrgAgreementForUserQueryQueryVariables = Exact<{
  userUid: Scalars["String"];
}>;

export type SellerOrgAgreementForUserQueryQuery = {
  __typename?: "Query";
  user: {
    __typename?: "User";
    uid: string;
    latestSellerOrgAgreement: {
      __typename?: "SellerOrgAgreement";
      uid: string;
      createdAt: any;
      updatedAt: any;
      signedAt: any | null;
      agreement: string;
      legalName: string | null;
      legalEntityType: string | null;
      legalState: string | null;
      legalAddress: string | null;
      ownsBackgroundChecks: boolean | null;
      contractSignedBy: string | null;
      contractSignerTitle: string | null;
    } | null;
  } | null;
};

export type SellerOrgApplicationFragmentFragment = {
  __typename?: "SellerOrgApplication";
  uid: string;
  status: SellerOrgApplicationStatus;
  createdAt: any | null;
  updatedAt: any | null;
  appliedAt: any | null;
  contractSignedAt: any | null;
  approvedAt: any | null;
  rejectedAt: any | null;
  adminResponse: string | null;
  name: string | null;
  numberOfTeachers: string | null;
  countries: string | null;
  website: string | null;
  primaryContactName: string | null;
  primaryContactTitle: string | null;
  organizationPhone: string | null;
  whenFounded: string | null;
  teachersInfo: string | null;
  learnersInfo: string | null;
  classesInfo: string | null;
  firstClassDescription: string | null;
  sourcedFrom: string | null;
  publicReviews: string | null;
  additionalInfo: string | null;
};

export type UpdateSellerOrgApplicationMutationVariables = Exact<{
  formInput: SellerOrgApplicationInput;
}>;

export type UpdateSellerOrgApplicationMutation = {
  __typename?: "Mutation";
  updateSellerOrgApplication: {
    __typename?: "SellerOrgApplication";
    uid: string;
    status: SellerOrgApplicationStatus;
    createdAt: any | null;
    updatedAt: any | null;
    appliedAt: any | null;
    contractSignedAt: any | null;
    approvedAt: any | null;
    rejectedAt: any | null;
    adminResponse: string | null;
    name: string | null;
    numberOfTeachers: string | null;
    countries: string | null;
    website: string | null;
    primaryContactName: string | null;
    primaryContactTitle: string | null;
    organizationPhone: string | null;
    whenFounded: string | null;
    teachersInfo: string | null;
    learnersInfo: string | null;
    classesInfo: string | null;
    firstClassDescription: string | null;
    sourcedFrom: string | null;
    publicReviews: string | null;
    additionalInfo: string | null;
  };
};

export type SubmitSellerOrgApplicationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type SubmitSellerOrgApplicationMutation = {
  __typename?: "Mutation";
  submitSellerOrgApplication: {
    __typename?: "SellerOrgApplication";
    uid: string;
    status: SellerOrgApplicationStatus;
    createdAt: any | null;
    updatedAt: any | null;
    appliedAt: any | null;
    contractSignedAt: any | null;
    approvedAt: any | null;
    rejectedAt: any | null;
    adminResponse: string | null;
    name: string | null;
    numberOfTeachers: string | null;
    countries: string | null;
    website: string | null;
    primaryContactName: string | null;
    primaryContactTitle: string | null;
    organizationPhone: string | null;
    whenFounded: string | null;
    teachersInfo: string | null;
    learnersInfo: string | null;
    classesInfo: string | null;
    firstClassDescription: string | null;
    sourcedFrom: string | null;
    publicReviews: string | null;
    additionalInfo: string | null;
  };
};

export type SellerOrgApplicationQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SellerOrgApplicationQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      createdAt: any | null;
      updatedAt: any | null;
      appliedAt: any | null;
      contractSignedAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      adminResponse: string | null;
      name: string | null;
      numberOfTeachers: string | null;
      countries: string | null;
      website: string | null;
      primaryContactName: string | null;
      primaryContactTitle: string | null;
      organizationPhone: string | null;
      whenFounded: string | null;
      teachersInfo: string | null;
      learnersInfo: string | null;
      classesInfo: string | null;
      firstClassDescription: string | null;
      sourcedFrom: string | null;
      publicReviews: string | null;
      additionalInfo: string | null;
    } | null;
  } | null;
};

export type InviteTeacherToSellerOrgMutationVariables = Exact<{
  name: Scalars["String"];
  email: Scalars["String"];
}>;

export type InviteTeacherToSellerOrgMutation = {
  __typename?: "Mutation";
  inviteTeacherToSellerOrg: {
    __typename?: "User";
    uid: string;
    name: string | null;
    email: string | null;
    photo: string | null;
    confirmed_at: any | null;
    teacher_approved_at: any | null;
    backgroundChecked: boolean;
    background_checked_at: any | null;
    completed_trainings: Array<string> | null;
    hasBeenAssignedToSection: boolean;
    hasVerifiedIdentity: boolean | null;
  };
};

export type SellerOrgTeacherFragmentFragment = {
  __typename?: "User";
  uid: string;
  name: string | null;
  email: string | null;
  photo: string | null;
  confirmed_at: any | null;
  teacher_approved_at: any | null;
  backgroundChecked: boolean;
  background_checked_at: any | null;
  completed_trainings: Array<string> | null;
  hasBeenAssignedToSection: boolean;
  hasVerifiedIdentity: boolean | null;
};

export type SellerOrgTeachersQueryVariables = Exact<{ [key: string]: never }>;

export type SellerOrgTeachersQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      teachers: Array<{
        __typename?: "User";
        uid: string;
        name: string | null;
        email: string | null;
        photo: string | null;
        confirmed_at: any | null;
        teacher_approved_at: any | null;
        backgroundChecked: boolean;
        background_checked_at: any | null;
        completed_trainings: Array<string> | null;
        hasBeenAssignedToSection: boolean;
        hasVerifiedIdentity: boolean | null;
      }>;
    } | null;
  } | null;
};

export type AddModeratorToSectionMutationVariables = Exact<{
  sectionUid: Scalars["String"];
  userUid: Scalars["String"];
}>;

export type AddModeratorToSectionMutation = {
  __typename?: "Mutation";
  addSectionModerator: {
    __typename?: "Leader";
    uid: string;
    name: string | null;
  };
};

export type RemoveModeratorFromSectionMutationVariables = Exact<{
  sectionUid: Scalars["String"];
  userUid: Scalars["String"];
}>;

export type RemoveModeratorFromSectionMutation = {
  __typename?: "Mutation";
  removeSectionModerator: boolean;
};

export type SectionModeratorsFragmentFragment = {
  __typename?: "Section";
  uid: string;
  moderators: Array<{
    __typename?: "Leader";
    uid: string;
    name: string | null;
  }>;
};

export type StartBackgroundCheckMutationVariables = Exact<{
  userUid: Scalars["ID"];
  country: Scalars["String"];
}>;

export type StartBackgroundCheckMutation = {
  __typename?: "Mutation";
  startBackgroundCheck: string;
};

export type CreateTeacherApplicationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreateTeacherApplicationMutation = {
  __typename?: "Mutation";
  createTeacherApplication: {
    __typename?: "TeacherApplication";
    uid: string;
    legal_name: string | null;
    status: TeacherApplicationStatus;
    submitted_at: any | null;
    reviewed_at: any | null;
    teaching_experience: string | null;
    teaching_credentials: string | null;
    class_types: string | null;
    online_profiles: string | null;
    sample_classes: string | null;
    class_subjects: Array<string | null> | null;
    age_ranges_taught: Array<string | null> | null;
    years_of_experience: string | null;
    how_did_you_hear_about_us: string | null;
    experience_types: Array<string | null> | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type UpdateTeacherApplicationMutationVariables = Exact<{
  teacherApplicationUid: Scalars["ID"];
  teacherApplicationInput: TeacherApplicationInput;
}>;

export type UpdateTeacherApplicationMutation = {
  __typename?: "Mutation";
  updateTeacherApplication: {
    __typename?: "TeacherApplication";
    uid: string;
    legal_name: string | null;
    status: TeacherApplicationStatus;
    submitted_at: any | null;
    reviewed_at: any | null;
    teaching_experience: string | null;
    teaching_credentials: string | null;
    class_types: string | null;
    online_profiles: string | null;
    sample_classes: string | null;
    class_subjects: Array<string | null> | null;
    age_ranges_taught: Array<string | null> | null;
    years_of_experience: string | null;
    how_did_you_hear_about_us: string | null;
    experience_types: Array<string | null> | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type SubmitTeacherApplicationMutationVariables = Exact<{
  teacherApplicationUid: Scalars["ID"];
}>;

export type SubmitTeacherApplicationMutation = {
  __typename?: "Mutation";
  submitTeacherApplication: {
    __typename?: "TeacherApplication";
    uid: string;
    legal_name: string | null;
    status: TeacherApplicationStatus;
    submitted_at: any | null;
    reviewed_at: any | null;
    teaching_experience: string | null;
    teaching_credentials: string | null;
    class_types: string | null;
    online_profiles: string | null;
    sample_classes: string | null;
    class_subjects: Array<string | null> | null;
    age_ranges_taught: Array<string | null> | null;
    years_of_experience: string | null;
    how_did_you_hear_about_us: string | null;
    experience_types: Array<string | null> | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type TeacherApplicationQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TeacherApplicationQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    teacher_approved_at: any | null;
    latestLegalName: string | null;
    canTeacherStartBackgroundCheck: boolean;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
  } | null;
};

export type TeacherOnboardingQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TeacherOnboardingQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    latestLegalName: string | null;
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    teacherAvailability: {
      __typename?: "Availability";
      updated_at: any | null;
      hourlyTimetable: {
        __typename?: "HourlyTimetable";
        mon: Array<number>;
        tue: Array<number>;
        wed: Array<number>;
        thu: Array<number>;
        fri: Array<number>;
        sat: Array<number>;
        sun: Array<number>;
      } | null;
    } | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  } | null;
};

export type TeacherAttendanceFragmentFragment = {
  __typename?: "TeacherAttendance";
  uid: string;
  created_at: any;
};

export type UpdateTeacherAvailabilityMutationVariables = Exact<{
  availability: AvailabilityInput;
}>;

export type UpdateTeacherAvailabilityMutation = {
  __typename?: "Mutation";
  updateTeacherAvailability: {
    __typename?: "User";
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    teacherAvailability: {
      __typename?: "Availability";
      updated_at: any | null;
      hourlyTimetable: {
        __typename?: "HourlyTimetable";
        mon: Array<number>;
        tue: Array<number>;
        wed: Array<number>;
        thu: Array<number>;
        fri: Array<number>;
        sat: Array<number>;
        sun: Array<number>;
      } | null;
    } | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  };
};

export type AddAssignmentClassPostCommentMutationVariables = Exact<{
  assignmentClassPostUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
  messageContent: MessageContentInput;
}>;

export type AddAssignmentClassPostCommentMutation = {
  __typename?: "Mutation";
  addAssignmentClassPostComment: {
    __typename?: "AssignmentClassPostComment";
    uid: string;
    sentAt: any;
    threadForLearnerUid: string;
    isSubmission: boolean | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      text: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    replies: Array<{
      __typename?: "AssignmentClassPostComment";
      uid: string;
      sentAt: any;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }> | null;
  };
};

export type AssignmentClassPostCommentLatestActivityIsReadFragmentFragment = {
  __typename?: "AssignmentClassPostComment";
  uid: string;
  latestActivityIsRead: boolean;
};

export type MarkAssignmentClassPostCommentThreadsAsReadMutationVariables =
  Exact<{
    threads:
      | Array<AssignmentClassPostCommentThreadInput>
      | AssignmentClassPostCommentThreadInput;
  }>;

export type MarkAssignmentClassPostCommentThreadsAsReadMutation = {
  __typename?: "Mutation";
  markAssignmentClassPostCommentThreadsAsRead: boolean;
};

export type MarkAssignmentClassPostCommentThreadsAsUnreadMutationVariables =
  Exact<{
    threads:
      | Array<AssignmentClassPostCommentThreadInput>
      | AssignmentClassPostCommentThreadInput;
  }>;

export type MarkAssignmentClassPostCommentThreadsAsUnreadMutation = {
  __typename?: "Mutation";
  markAssignmentClassPostCommentThreadsAsUnread: boolean;
};

export type TeacherConversationAssignmentAttachmentFragmentFragment = {
  __typename?: "Attachment";
  uid: string;
  fileUrl: string;
  videoThumbnailUrl: string | null;
  conversionStatus: string | null;
  created_at: any;
  file: {
    __typename?: "File";
    filename: string;
    mimetype: string | null;
    size: number;
    url: string;
    thumbUrl: string | null;
  };
};

export type TeacherConversationAssignmentMessageContentFragmentFragment = {
  __typename?: "MessageContent";
  text: string | null;
  attachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
};

export type TeacherConversationAssignmentPreviewContentFragmentFragment = {
  __typename?: "MessageContent";
  text: string | null;
  attachments: Array<{ __typename?: "Attachment"; uid: string }>;
  video: { __typename?: "Attachment"; uid: string } | null;
};

export type TeacherConversationAssignmentsQueryVariables = Exact<{
  offset: Scalars["Int"];
  limit: Scalars["Int"];
}>;

export type TeacherConversationAssignmentsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    teacherAssignmentClassPostCommentThreads: Array<{
      __typename?: "AssignmentClassPostComment";
      uid: string;
      sentAt: any;
      latestActivityIsRead: boolean;
      latestActivityCanBeMarkedUnread: boolean;
      threadForLearnerUid: string;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        text: string | null;
        attachments: Array<{ __typename?: "Attachment"; uid: string }>;
        video: { __typename?: "Attachment"; uid: string } | null;
      };
      replies: Array<{
        __typename?: "AssignmentClassPostComment";
        uid: string;
        sentAt: any;
        messageContent: {
          __typename?: "MessageContent";
          text: string | null;
          attachments: Array<{ __typename?: "Attachment"; uid: string }>;
          video: { __typename?: "Attachment"; uid: string } | null;
        };
      }> | null;
      assignmentClassPost: {
        __typename?: "AssignmentClassPost";
        uid: string;
        title: string;
        created_at: any;
        publishAt: any;
        dueDate: any | null;
        section: {
          __typename?: "Section";
          uid: string;
          activity: { __typename?: "Activity"; uid: string; title: string };
        };
        lesson: {
          __typename?: "Lesson";
          uid: string;
          title: string | null;
        } | null;
      };
    }>;
  } | null;
};

export type TeacherConversationAssignmentDetailQueryVariables = Exact<{
  assignmentClassPostUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
}>;

export type TeacherConversationAssignmentDetailQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    teacherAssignmentClassPostCommentThreads: Array<{
      __typename?: "AssignmentClassPostComment";
      uid: string;
      sentAt: any;
      latestActivityIsRead: boolean;
      latestActivityCanBeMarkedUnread: boolean;
      threadForLearnerUid: string;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      replies: Array<{
        __typename?: "AssignmentClassPostComment";
        uid: string;
        sentAt: any;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          text: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }> | null;
      assignmentClassPost: {
        __typename?: "AssignmentClassPost";
        uid: string;
        title: string;
        created_at: any;
        publishAt: any;
        dueDate: any | null;
        section: {
          __typename?: "Section";
          uid: string;
          activity: { __typename?: "Activity"; uid: string; title: string };
        };
        lesson: {
          __typename?: "Lesson";
          uid: string;
          title: string | null;
        } | null;
      };
    }>;
  } | null;
};

export type MarkMessageThreadsAsUnreadMutationVariables = Exact<{
  threadUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type MarkMessageThreadsAsUnreadMutation = {
  __typename?: "Mutation";
  markMessageThreadsAsUnread: boolean;
};

export type MarkPrivateClassMessageThreadsAsUnreadMutationVariables = Exact<{
  threadUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type MarkPrivateClassMessageThreadsAsUnreadMutation = {
  __typename?: "Mutation";
  markPrivateClassMessageThreadsAsUnread: boolean;
};

export type MarkPrivateClassMessageThreadAsReadMutationVariables = Exact<{
  threadUid: Scalars["ID"];
}>;

export type MarkPrivateClassMessageThreadAsReadMutation = {
  __typename?: "Mutation";
  markPrivateClassMessageThreadAsRead: boolean;
};

export type MarkMessageThreadsAsSpamMutationVariables = Exact<{
  threadUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type MarkMessageThreadsAsSpamMutation = {
  __typename?: "Mutation";
  markMessageThreadsAsSpam: boolean;
};

export type UnmarkMessageThreadsAsSpamMutationVariables = Exact<{
  threadUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type UnmarkMessageThreadsAsSpamMutation = {
  __typename?: "Mutation";
  unmarkMessageThreadsAsSpam: boolean;
};

type MessageIsReadFragment_MessageThread_Fragment = {
  __typename: "MessageThread";
  isRead: boolean;
};

type MessageIsReadFragment_PrivateClassThread_Fragment = {
  __typename: "PrivateClassThread";
  isRead: boolean;
};

export type MessageIsReadFragmentFragment =
  | MessageIsReadFragment_MessageThread_Fragment
  | MessageIsReadFragment_PrivateClassThread_Fragment;

export type CreateTeacherCredentialMutationVariables = Exact<{
  credentialType: CredentialType;
  file: CredentialFileInput;
  teacherCertificateCredentialInput?: InputMaybe<TeacherCertificateCredentialInput>;
  collegeDegreeCredentialInput?: InputMaybe<CollegeDegreeCredentialInput>;
  otherCredentialInput?: InputMaybe<OtherCredentialInput>;
}>;

export type CreateTeacherCredentialMutation = {
  __typename?: "Mutation";
  createTeacherCredential: { __typename?: "TeacherCredential"; uid: string };
};

export type DeleteTeacherCredentialMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type DeleteTeacherCredentialMutation = {
  __typename?: "Mutation";
  deleteTeacherCredential: boolean;
};

export type TeacherCredentialsQueryVariables = Exact<{ [key: string]: never }>;

export type TeacherCredentialsQuery = {
  __typename?: "Query";
  teacherCredentials: Array<{
    __typename?: "TeacherCredential";
    certificateDiscipline: TeacherCertificateDiscipline | null;
    certificateExpireDate: any | null;
    certificateIssueDate: any | null;
    certificateNumber: string | null;
    certificateSecondaryDiscipline: TeacherCertificateDiscipline | null;
    certificateState: TeacherCertificateState | null;
    createdAt: any | null;
    credentialType: CredentialType;
    degreeInstitution: string | null;
    degreeIssueDate: any | null;
    degreeSubject: DegreeSubject | null;
    degreeType: DegreeType | null;
    otherDetails: string | null;
    otherType: string | null;
    name: string | null;
    uid: string;
  } | null> | null;
};

type TeacherMessagingMessageThreadFragment_MessageThread_Fragment = {
  __typename?: "MessageThread";
  uid: string;
  isRead: boolean;
  participants: Array<{
    __typename?: "Participant";
    avatar: string | null;
    uid: string;
    name: string | null;
    photo: string | null;
    timeZone: string | null;
    headline: string | null;
    leader_link: string | null;
    isLearner: boolean;
    role: ParticipantRole | null;
    activitiesWithCurrentUser: Array<{
      __typename?: "Activity";
      uid: string;
    }> | null;
    parent: {
      __typename?: "Parent";
      uid: string;
      photo: string | null;
      publicName: string | null;
    } | null;
    ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
  }>;
  matchedSearchResults: Array<{
    __typename?: "ConversationSearchResult";
    threadUid: string;
    highlightedMatch: string;
  }> | null;
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    titleTranslated: string | null;
    formatString: string;
    isSelfPaced: boolean;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  } | null;
  section: {
    __typename?: "Section";
    uid: string;
    currentSectionLesson: {
      __typename?: "SectionLesson";
      lesson: {
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        lessonNumber: number | null;
      } | null;
    } | null;
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      parent: { __typename?: "Parent"; uid: string };
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
      } | null;
    }>;
  } | null;
  messages: Array<{
    __typename?: "Message";
    created_at: any;
    uid: string;
    activity_uid: string | null;
    section_uid: string | null;
    thread_uid: string;
    subject: string | null;
    content: string | null;
    sender: {
      __typename?: "Sender";
      uid: string;
      name: string | null;
      photo: string | null;
      timeZone: string | null;
      headline: string | null;
      leader_link: string | null;
    };
    participants: Array<{
      __typename?: "Participant";
      isLearner: boolean;
      avatar: string | null;
      uid: string;
      name: string | null;
      photo: string | null;
      timeZone: string | null;
      headline: string | null;
      leader_link: string | null;
      role: ParticipantRole | null;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    }>;
  }>;
};

type TeacherMessagingMessageThreadFragment_PrivateClassThread_Fragment = {
  __typename?: "PrivateClassThread";
  uid: string;
  isRead: boolean;
  enrollment: {
    __typename?: "Enrollment";
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      avatar: string | null;
    } | null;
    parent: {
      __typename?: "Parent";
      uid: string;
      photo: string | null;
      publicName: string | null;
    };
  } | null;
  matchedSearchResults: Array<{
    __typename?: "ConversationSearchResult";
    threadUid: string;
    highlightedMatch: string;
  }> | null;
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    titleTranslated: string | null;
    formatString: string;
    isSelfPaced: boolean;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  } | null;
  section: {
    __typename?: "Section";
    uid: string;
    currentSectionLesson: {
      __typename?: "SectionLesson";
      lesson: {
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        lessonNumber: number | null;
      } | null;
    } | null;
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      parent: { __typename?: "Parent"; uid: string };
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
      } | null;
    }>;
  } | null;
  messages: Array<{
    __typename?: "PrivateClassMessage";
    sentAt: any;
    uid: string;
    activity_uid: string;
    section_uid: string;
    thread_uid: string;
    subject: string | null;
    content: string | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
  }>;
};

export type TeacherMessagingMessageThreadFragmentFragment =
  | TeacherMessagingMessageThreadFragment_MessageThread_Fragment
  | TeacherMessagingMessageThreadFragment_PrivateClassThread_Fragment;

export type TeacherMessagingConversationsQueryVariables = Exact<{
  offset: Scalars["Int"];
  limit: Scalars["Int"];
  filters?: InputMaybe<ConversationFiltersInput>;
  audience?: InputMaybe<Audience>;
  messageSelection?: InputMaybe<MessageSelection>;
  viewAsOrgTeacherUid?: InputMaybe<Scalars["String"]>;
}>;

export type TeacherMessagingConversationsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    conversationsCount: number;
    conversations: Array<
      | {
          __typename?: "MessageThread";
          uid: string;
          isRead: boolean;
          participants: Array<{
            __typename?: "Participant";
            avatar: string | null;
            uid: string;
            name: string | null;
            photo: string | null;
            timeZone: string | null;
            headline: string | null;
            leader_link: string | null;
            isLearner: boolean;
            role: ParticipantRole | null;
            activitiesWithCurrentUser: Array<{
              __typename?: "Activity";
              uid: string;
            }> | null;
            parent: {
              __typename?: "Parent";
              uid: string;
              photo: string | null;
              publicName: string | null;
            } | null;
            ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
            teacherForSellerOrg: {
              __typename?: "SellerOrg";
              uid: string;
            } | null;
          }>;
          matchedSearchResults: Array<{
            __typename?: "ConversationSearchResult";
            threadUid: string;
            highlightedMatch: string;
          }> | null;
          activity: {
            __typename?: "Activity";
            uid: string;
            title: string;
            titleTranslated: string | null;
            formatString: string;
            isSelfPaced: boolean;
            photo: { __typename?: "Attachment"; fileUrl: string } | null;
          } | null;
          section: {
            __typename?: "Section";
            uid: string;
            currentSectionLesson: {
              __typename?: "SectionLesson";
              lesson: {
                __typename?: "Lesson";
                uid: string;
                title: string | null;
                lessonNumber: number | null;
              } | null;
            } | null;
            enrollments: Array<{
              __typename?: "Enrollment";
              uid: string;
              parent: { __typename?: "Parent"; uid: string };
              learner: {
                __typename?: "Learner";
                uid: string;
                name: string | null;
              } | null;
            }>;
          } | null;
          messages: Array<{
            __typename?: "Message";
            created_at: any;
            uid: string;
            activity_uid: string | null;
            section_uid: string | null;
            thread_uid: string;
            subject: string | null;
            content: string | null;
            sender: {
              __typename?: "Sender";
              uid: string;
              name: string | null;
              photo: string | null;
              timeZone: string | null;
              headline: string | null;
              leader_link: string | null;
            };
            participants: Array<{
              __typename?: "Participant";
              isLearner: boolean;
              avatar: string | null;
              uid: string;
              name: string | null;
              photo: string | null;
              timeZone: string | null;
              headline: string | null;
              leader_link: string | null;
              role: ParticipantRole | null;
              ownerOfSellerOrg: {
                __typename?: "SellerOrg";
                uid: string;
              } | null;
              teacherForSellerOrg: {
                __typename?: "SellerOrg";
                uid: string;
              } | null;
            }>;
          }>;
        }
      | {
          __typename?: "PrivateClassThread";
          uid: string;
          isRead: boolean;
          enrollment: {
            __typename?: "Enrollment";
            learner: {
              __typename?: "Learner";
              uid: string;
              name: string | null;
              avatar: string | null;
            } | null;
            parent: {
              __typename?: "Parent";
              uid: string;
              photo: string | null;
              publicName: string | null;
            };
          } | null;
          matchedSearchResults: Array<{
            __typename?: "ConversationSearchResult";
            threadUid: string;
            highlightedMatch: string;
          }> | null;
          activity: {
            __typename?: "Activity";
            uid: string;
            title: string;
            titleTranslated: string | null;
            formatString: string;
            isSelfPaced: boolean;
            photo: { __typename?: "Attachment"; fileUrl: string } | null;
          } | null;
          section: {
            __typename?: "Section";
            uid: string;
            currentSectionLesson: {
              __typename?: "SectionLesson";
              lesson: {
                __typename?: "Lesson";
                uid: string;
                title: string | null;
                lessonNumber: number | null;
              } | null;
            } | null;
            enrollments: Array<{
              __typename?: "Enrollment";
              uid: string;
              parent: { __typename?: "Parent"; uid: string };
              learner: {
                __typename?: "Learner";
                uid: string;
                name: string | null;
              } | null;
            }>;
          } | null;
          messages: Array<{
            __typename?: "PrivateClassMessage";
            sentAt: any;
            uid: string;
            activity_uid: string;
            section_uid: string;
            thread_uid: string;
            subject: string | null;
            content: string | null;
            sender: {
              __typename?: "MessageSender";
              uid: string;
              name: string | null;
              photo: string | null;
              avatar: string | null;
              isLearner: boolean;
            };
          }>;
        }
    >;
  } | null;
};

export type TeacherScheduleSectionFragmentFragment = {
  __typename?: "Section";
  uid: string;
  activity_uid: string;
  start_time: any | null;
  end_time: any | null;
  startsAtNight: boolean | null;
  is_cross_listed: boolean;
  size_max: number | null;
  size_min: number | null;
  isPublished: boolean | null;
  price_cents: number | null;
  priceCredits: number | null;
  published_at: any | null;
  updated_at: any;
  canceled_at: any | null;
  deleted_at: any | null;
  ongoing_stopped_at: any | null;
  duration_minutes: number | null;
  usesOutschoolVideoChat: boolean;
  usersCanSendPrivateMessage: boolean;
  currentUserCanManage: boolean;
  isBuyable: boolean;
  nextOngoingMeeting: {
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
  } | null;
  leader: { __typename?: "Leader"; uid: string; name: string | null };
  details: {
    __typename?: "SectionDetails";
    autoScheduledDraft: boolean | null;
  };
};

export type TeacherScheduleQueryQueryVariables = Exact<{
  start: Scalars["DateTime"];
  end: Scalars["DateTime"];
  excludeOrgTeachers?: InputMaybe<Scalars["Boolean"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  filterByTeacher?: InputMaybe<Scalars["ID"]>;
}>;

export type TeacherScheduleQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    calendar_uid: string;
    name: string | null;
    email: string | null;
    completed_trainings: Array<string> | null;
    backgroundChecked: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    hasBeenAssignedToSection: boolean;
    hasVerifiedIdentity: boolean | null;
    teacher_approved_at: any | null;
    canTeacherStartBackgroundCheck: boolean;
    location: { __typename?: "Location"; timeZone: string | null } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      status: TeacherApplicationStatus;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
    } | null;
    teacherAvailability: {
      __typename?: "Availability";
      updated_at: any | null;
      hourlyTimetable: {
        __typename?: "HourlyTimetable";
        mon: Array<number>;
        tue: Array<number>;
        wed: Array<number>;
        thu: Array<number>;
        fri: Array<number>;
        sat: Array<number>;
        sun: Array<number>;
      } | null;
    } | null;
    teacherFlexSections: Array<{
      __typename?: "Section";
      uid: string;
      filledSpaceCount: number;
      activity_uid: string;
      start_time: any | null;
      end_time: any | null;
      startsAtNight: boolean | null;
      is_cross_listed: boolean;
      size_max: number | null;
      size_min: number | null;
      isPublished: boolean | null;
      price_cents: number | null;
      priceCredits: number | null;
      published_at: any | null;
      updated_at: any;
      canceled_at: any | null;
      deleted_at: any | null;
      ongoing_stopped_at: any | null;
      duration_minutes: number | null;
      usesOutschoolVideoChat: boolean;
      usersCanSendPrivateMessage: boolean;
      currentUserCanManage: boolean;
      isBuyable: boolean;
      activity: {
        __typename?: "Activity";
        uid: string;
        slug_id: string;
        published_at: any | null;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        hasTeacherSchedule: boolean;
        isClub: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        is_ongoing_weekly: boolean;
        size_min: number | null;
        size_max: number | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
      };
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      } | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      details: {
        __typename?: "SectionDetails";
        autoScheduledDraft: boolean | null;
      };
    }>;
    leaderActivities: Array<{
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      published_at: any | null;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      hasTeacherSchedule: boolean;
      isClub: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      is_ongoing_weekly: boolean;
      size_min: number | null;
      size_max: number | null;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
    }>;
    teacherMeetings: Array<{
      __typename?: "Meeting";
      uid: string;
      sectionSequenceNumber: number;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
      section: {
        __typename?: "Section";
        uid: string;
        filledSpaceCount: number;
        meetingCount: number;
        pausedLearnerCount: number;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        activity: {
          __typename?: "Activity";
          uid: string;
          slug_id: string;
          published_at: any | null;
          title: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          hasTeacherSchedule: boolean;
          isClub: boolean;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          isOneTime: boolean;
          duration_minutes: number | null;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          is_ongoing_weekly: boolean;
          size_min: number | null;
          size_max: number | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
        };
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        enrollments: Array<{
          __typename?: "Enrollment";
          uid: string;
          learner: {
            __typename?: "Learner";
            uid: string;
            name: string | null;
          } | null;
        }>;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
      };
    }>;
  } | null;
};

export type SectionAssignmentsPageAssignmentFragment = {
  __typename?: "AssignmentClassPost";
  uid: string;
  title: string;
  created_at: any;
  deleted_at: any | null;
  publishAt: any;
  dueDate: any | null;
  submissionRequirement: SubmissionRequirementType;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
  lesson: {
    __typename?: "Lesson";
    uid: string;
    title: string | null;
    lessonNumber: number | null;
  } | null;
  comments: Array<{
    __typename?: "AssignmentClassPostComment";
    uid: string;
    sentAt: any;
    threadForLearnerUid: string;
    isSubmission: boolean | null;
    replies: Array<{
      __typename?: "AssignmentClassPostComment";
      uid: string;
      sentAt: any;
      threadForLearnerUid: string;
      isSubmission: boolean | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }> | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  }>;
};

export type SectionAssignmentsPageQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type SectionAssignmentsPageQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    published_at: any | null;
    deleted_at: any | null;
    canceled_at: any | null;
    start_time: any | null;
    end_time: any | null;
    startsAtNight: boolean | null;
    is_self_paced: boolean;
    currentUserCanManage: boolean;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        lessonNumber: number | null;
        assignmentClassPosts: Array<{
          __typename?: "AssignmentClassPost";
          uid: string;
          title: string;
          submissionRequirement: SubmissionRequirementType;
          dueDate: any | null;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
          comments: Array<{
            __typename?: "AssignmentClassPostComment";
            uid: string;
            sentAt: any;
            isSubmission: boolean | null;
            messageContent: {
              __typename?: "MessageContent";
              uid: string;
              text: string | null;
              originalMimeType: TextMimeType;
              externalVideoUrl: string | null;
              editedAt: any | null;
              htmlText: string | null;
              attachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              imageAttachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              video: {
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              } | null;
            };
          }>;
        }>;
      }>;
    } | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      is_ongoing_weekly: boolean;
      weekly_meetings: number | null;
      duration_weeks: number | null;
      isClub: boolean;
      published_at: any | null;
      hasTeacherSchedule: boolean;
      isSelfPaced: boolean;
    };
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
      title: string;
      created_at: any;
      deleted_at: any | null;
      publishAt: any;
      dueDate: any | null;
      submissionRequirement: SubmissionRequirementType;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      lesson: {
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        lessonNumber: number | null;
      } | null;
      comments: Array<{
        __typename?: "AssignmentClassPostComment";
        uid: string;
        sentAt: any;
        threadForLearnerUid: string;
        isSubmission: boolean | null;
        replies: Array<{
          __typename?: "AssignmentClassPostComment";
          uid: string;
          sentAt: any;
          threadForLearnerUid: string;
          isSubmission: boolean | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }> | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    }>;
    enrollments: Array<{ __typename?: "Enrollment"; uid: string }>;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    } | null;
  } | null;
};

export type TeacherCommentOnAssignmentMutationVariables = Exact<{
  assignmentClassPostUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
  messageContentInput: MessageContentInput;
}>;

export type TeacherCommentOnAssignmentMutation = {
  __typename?: "Mutation";
  addAssignmentClassPostComment: {
    __typename?: "AssignmentClassPostComment";
    uid: string;
    sentAt: any;
    threadForLearnerUid: string;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type TimetableFragmentFragment = {
  __typename?: "Timetable";
  mon: {
    __typename?: "TimetableTimes";
    f8_12: boolean;
    f12_4: boolean;
    f4_8: boolean;
  };
  tue: {
    __typename?: "TimetableTimes";
    f8_12: boolean;
    f12_4: boolean;
    f4_8: boolean;
  };
  wed: {
    __typename?: "TimetableTimes";
    f8_12: boolean;
    f12_4: boolean;
    f4_8: boolean;
  };
  thu: {
    __typename?: "TimetableTimes";
    f8_12: boolean;
    f12_4: boolean;
    f4_8: boolean;
  };
  fri: {
    __typename?: "TimetableTimes";
    f8_12: boolean;
    f12_4: boolean;
    f4_8: boolean;
  };
  sat: {
    __typename?: "TimetableTimes";
    f8_12: boolean;
    f12_4: boolean;
    f4_8: boolean;
  };
  sun: {
    __typename?: "TimetableTimes";
    f8_12: boolean;
    f12_4: boolean;
    f4_8: boolean;
  };
};

export type TimetableTimesFragmentFragment = {
  __typename?: "TimetableTimes";
  f8_12: boolean;
  f12_4: boolean;
  f4_8: boolean;
};

export type TopLevelCategoryPagesQueryVariables = Exact<{
  taxonomy?: InputMaybe<Scalars["String"]>;
}>;

export type TopLevelCategoryPagesQuery = {
  __typename?: "Query";
  topLevelCategoryPages: Array<{
    __typename?: "CategoryPage";
    uid: string;
    nameTitleCased: string;
    nameSentenceCased: string;
    slug: string;
    title: string | null;
    description: string | null;
  } | null> | null;
};

export type TrackOrderCompletedMutationVariables = Exact<{
  properties: TrackOrderCompletedProperties;
}>;

export type TrackOrderCompletedMutation = {
  __typename?: "Mutation";
  trackOrderCompleted: boolean | null;
};

export type TrackNewBuyerAcquiredMutationVariables = Exact<{
  properties: TrackNewBuyerAcquiredProperties;
}>;

export type TrackNewBuyerAcquiredMutation = {
  __typename?: "Mutation";
  trackNewBuyerAcquired: boolean | null;
};

export type ActivitySectionsQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type ActivitySectionsQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    paginatedFilteredSections: {
      __typename?: "SectionList";
      data: Array<{
        __typename?: "Section";
        filledSpaceCount: number;
        user_uid: string | null;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        created_at: any;
        validEnrollmentCount: number;
        isAutoCanceled: boolean;
        currentUserIsOwner: boolean;
        paidAmount: number | null;
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        }>;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
          onlineClassroom: {
            __typename?: "OnlineClassroom";
            type: string | null;
            url: string | null;
          } | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
        checklist: {
          __typename?: "SectionChecklist";
          autoCanceledAt: any | null;
          grandfatheredAt2017Rate: boolean | null;
        };
      }>;
    };
  };
};

export type UnavailableBlockFragmentFragment = {
  __typename?: "UnavailableBlock";
  uid: string;
  startTime: any;
  endTime: any;
};

export type UpcomingClassesQueryVariables = Exact<{
  uid?: InputMaybe<Scalars["ID"]>;
  includeSchedule: Scalars["Boolean"];
  flexSectionsOffset: Scalars["String"];
  meetingsOffset: Scalars["String"];
}>;

export type UpcomingClassesQuery = {
  __typename?: "Query";
  publicProfile: {
    __typename?: "PublicProfile";
    uid: string;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      flexSections?: {
        __typename?: "SectionConnection";
        edges: Array<{
          __typename?: "SectionEdge";
          node: {
            __typename?: "Section";
            uid: string;
            start_time: any | null;
            end_time: any | null;
            deleted_at: any | null;
            canceled_at: any | null;
            published_at: any | null;
            isBuyable: boolean;
            meetingCount: number;
            leader: {
              __typename?: "Leader";
              uid: string;
              name: string | null;
              teacherForSellerOrg: {
                __typename?: "SellerOrg";
                uid: string;
              } | null;
            };
            activity: {
              __typename?: "Activity";
              uid: string;
              title: string;
              titleTranslated: string | null;
              age_min: number | null;
              age_max: number | null;
              is_ongoing_weekly: boolean;
              weekly_meetings: number | null;
              duration_weeks: number | null;
              isClub: boolean;
              photo: {
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              } | null;
            };
          };
        }>;
      };
      meetings?: {
        __typename?: "MeetingConnection";
        edges: Array<{
          __typename?: "MeetingEdge";
          node: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            sectionSequenceNumber: number;
            section: {
              __typename?: "Section";
              uid: string;
              start_time: any | null;
              end_time: any | null;
              deleted_at: any | null;
              canceled_at: any | null;
              published_at: any | null;
              isBuyable: boolean;
              meetingCount: number;
              nextOngoingMeeting: {
                __typename?: "Meeting";
                uid: string;
                start_time: any;
              } | null;
              leader: {
                __typename?: "Leader";
                uid: string;
                name: string | null;
                teacherForSellerOrg: {
                  __typename?: "SellerOrg";
                  uid: string;
                  name: string;
                } | null;
              };
              activity: {
                __typename?: "Activity";
                uid: string;
                title: string;
                titleTranslated: string | null;
                age_min: number | null;
                age_max: number | null;
                is_ongoing_weekly: boolean;
                weekly_meetings: number | null;
                duration_weeks: number | null;
                isClub: boolean;
                photo: {
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                } | null;
              };
            };
          };
        }>;
      };
    } | null;
  } | null;
};

export type MergeLearnerMutationVariables = Exact<{
  targetLearnerUid: Scalars["ID"];
  sourceLearnerUid: Scalars["ID"];
}>;

export type MergeLearnerMutation = {
  __typename?: "Mutation";
  mergeLearner: boolean;
};

export type SetLearnerUnlockableAvatarsMutationVariables = Exact<{
  learnerUid: Scalars["String"];
  value: Array<Scalars["String"]> | Scalars["String"];
}>;

export type SetLearnerUnlockableAvatarsMutation = {
  __typename?: "Mutation";
  setLearnerUnlockableAvatars: boolean;
};

export type UserAdminQueryVariables = Exact<{
  uid: Scalars["String"];
  skipIncidents?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UserAdminQuery = {
  __typename?: "Query";
  user: {
    __typename?: "User";
    completed_trainings: Array<string> | null;
    teacher_featured_at: any | null;
    roles: Array<string> | null;
    hasVerifiedIdentity: boolean | null;
    idVerificationStatus: IdvStatus;
    seller_org_admin_teacher_account_uid: string | null;
    number_of_merges: number;
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      type: string | null;
      typeDetail: string | null;
      description: string | null;
      timeInBusiness: string | null;
      learnerTypes: string | null;
      alreadyApprovedTeacher: boolean | null;
      alreadyApprovedTeacherEmail: string | null;
      numberOfClassesPerWeek: string | null;
      numberOfStudentsOnAverage: string | null;
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
      updatedAt: any | null;
      name: string | null;
      numberOfTeachers: string | null;
      countries: string | null;
      website: string | null;
      primaryContactName: string | null;
      primaryContactTitle: string | null;
      organizationPhone: string | null;
      whenFounded: string | null;
      teachersInfo: string | null;
      learnersInfo: string | null;
      classesInfo: string | null;
      firstClassDescription: string | null;
      sourcedFrom: string | null;
      publicReviews: string | null;
      additionalInfo: string | null;
    } | null;
    latestSellerOrgAgreement: {
      __typename?: "SellerOrgAgreement";
      uid: string;
      createdAt: any;
      updatedAt: any;
      signedAt: any | null;
      agreement: string;
      legalName: string | null;
      legalEntityType: string | null;
      legalState: string | null;
      legalAddress: string | null;
      ownsBackgroundChecks: boolean | null;
      contractSignedBy: string | null;
      contractSignerTitle: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      holdMessages: boolean | null;
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    adminIncidents?: Array<{
      __typename?: "AdminUserIncident";
      uid: string;
      created_at: any;
      updated_at: any;
      category: string;
      notes: string | null;
      admin: { __typename?: "User"; uid: string; name: string | null };
    }>;
    adminActions: Array<{
      __typename?: "AdminUserAction";
      fundingProgram: string | null;
      learnerName: string | null;
      orderNumber: string | null;
      creditValue: number | null;
      learnerProgramId: string | null;
      uid: string;
      created_at: any;
      action: string;
      notes: string | null;
      customValue: string | null;
      admin: { __typename?: "User"; uid: string; name: string | null };
    }>;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      adminMetrics: {
        __typename?: "AdminLeaderMetrics";
        totalAttendances: number;
        lateAttendances: number;
        missedAttendances: number;
        lastMinuteCancelledSections: number;
        lastMinuteCancelledEnrollments: number;
        numIncidents: number;
      };
      credentials: Array<{
        __typename?: "TeacherCredential";
        certificateDiscipline: TeacherCertificateDiscipline | null;
        certificateExpireDate: any | null;
        certificateNumber: string | null;
        certificateSecondaryDiscipline: TeacherCertificateDiscipline | null;
        certificateState: TeacherCertificateState | null;
        createdAt: any | null;
        credentialType: CredentialType;
        degreeInstitution: string | null;
        degreeSubject: DegreeSubject | null;
        degreeType: DegreeType | null;
        otherDetails: string | null;
        otherType: string | null;
        uid: string;
      }>;
      tags: {
        __typename?: "TeacherTagsConnection";
        edges: Array<{
          __typename?: "TeacherTagEdge";
          node: { __typename?: "Tag"; uid: string; key: string; value: string };
        }>;
      };
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      ownsBackgroundChecks: boolean;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  } | null;
};

export type LearnerQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type LearnerQuery = {
  __typename?: "Query";
  learner: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    isVerified: boolean;
    isBlocked: boolean | null;
    blockedByUserUid: string | null;
    blockedAt: any | null;
  } | null;
};

export type WaitlistSeatsForParentQueryVariables = Exact<{
  parentUid: Scalars["ID"];
  sectionUid?: InputMaybe<Scalars["ID"]>;
}>;

export type WaitlistSeatsForParentQuery = {
  __typename?: "Query";
  waitlistSeatsForParent: Array<{
    __typename?: "WaitlistSeat";
    uid: string;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    };
    enrollment: { __typename?: "Enrollment"; uid: string } | null;
    section: {
      __typename?: "Section";
      uid: string;
      filledSpaceCount: number;
      size_max: number | null;
      published_at: any | null;
      canceled_at: any | null;
      deleted_at: any | null;
    };
  } | null>;
};

export type WaitlistSummaryForActivityQueryVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type WaitlistSummaryForActivityQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    allowWaitlist: boolean | null;
    isClub: boolean;
    weekly_meetings: number | null;
    duration_weeks: number | null;
    is_ongoing_weekly: boolean;
    published_at: any | null;
    hasTeacherSchedule: boolean;
    sections: Array<{
      __typename?: "Section";
      filledSpaceCount: number;
      waitlistSeatsCount: number | null;
      uid: string;
      activity_uid: string;
      start_time: any | null;
      end_time: any | null;
      teacher_support_start_time: any | null;
      startsAtNight: boolean | null;
      is_cross_listed: boolean;
      size_max: number | null;
      size_min: number | null;
      isPublished: boolean | null;
      price_cents: number | null;
      priceCredits: number | null;
      published_at: any | null;
      updated_at: any;
      canceled_at: any | null;
      deleted_at: any | null;
      ongoing_stopped_at: any | null;
      duration_minutes: number | null;
      usesOutschoolVideoChat: boolean;
      usersCanSendPrivateMessage: boolean;
      currentUserCanManage: boolean;
      isBuyable: boolean;
      allowsTeacherTransfer: boolean;
      created_at: any;
      validEnrollmentCount: number;
      isAutoCanceled: boolean;
      currentUserIsOwner: boolean;
      paidAmount: number | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      } | null;
      details: {
        __typename?: "SectionDetails";
        autoScheduledDraft: boolean | null;
        onlineClassroom: {
          __typename?: "OnlineClassroom";
          type: string | null;
          url: string | null;
        } | null;
      };
      prepaidOngoingPeriodOptions: Array<{
        __typename?: "Period";
        startOfIsoWeek: any;
        endOfIsoWeek: any;
      }> | null;
      checklist: {
        __typename?: "SectionChecklist";
        autoCanceledAt: any | null;
        grandfatheredAt2017Rate: boolean | null;
      };
    }>;
  };
};

export type WaitlistSeatFragmentFragment = {
  __typename?: "WaitlistSeat";
  uid: string;
  createdAt: any | null;
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    introduction: string | null;
    created_at: any | null;
    deleted_at: any | null;
    timeZone: string | null;
    socialOptOut: boolean;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
  };
  learner: { __typename?: "Learner"; uid: string; name: string | null };
  section: { __typename?: "Section"; uid: string };
  enrollment: { __typename?: "Enrollment"; uid: string } | null;
};

export type UpdateWaitlistMutationVariables = Exact<{
  createInputs: Array<CreateWaitlistSeatInput> | CreateWaitlistSeatInput;
  deleteInputs: Array<Scalars["String"]> | Scalars["String"];
}>;

export type UpdateWaitlistMutation = {
  __typename?: "Mutation";
  createWaitlistSeats: Array<{
    __typename?: "WaitlistSeat";
    uid: string;
    createdAt: any | null;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    learner: { __typename?: "Learner"; uid: string; name: string | null };
    section: { __typename?: "Section"; uid: string };
    enrollment: { __typename?: "Enrollment"; uid: string } | null;
  }>;
  deleteWaitlistSeats: Array<{
    __typename?: "WaitlistSeat";
    uid: string;
    createdAt: any | null;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    learner: { __typename?: "Learner"; uid: string; name: string | null };
    section: { __typename?: "Section"; uid: string };
    enrollment: { __typename?: "Enrollment"; uid: string } | null;
  }>;
};

export type FeedbackForCategorySearchFiltersQueryVariables = Exact<{
  searchFilters: SearchFilters;
  pageLocation?: InputMaybe<Scalars["String"]>;
}>;

export type FeedbackForCategorySearchFiltersQuery = {
  __typename?: "Query";
  feedbackForCategorySearchFilters: {
    __typename?: "FeedbackForCategoryPageResult";
    searchUid: string | null;
    hasPhotos: Array<{
      __typename?: "PublicReview";
      uid: string;
      section_uid: string;
      currentUserCanEdit: boolean;
      currentUserCanRespond: boolean;
      activity_star_rating: number | null;
      currentUserMarkedHelpful: boolean | null;
      markedHelpfulCount: number;
      created_at: any;
      teacher_response: string | null;
      teacher_responded_at: any | null;
      activity: {
        __typename?: "Activity";
        title: string;
        titleTranslated: string | null;
        path: string;
        isClub: boolean;
        slug_id: string;
        uid: string;
        user_uid: string;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          leader_link: string | null;
          photo: string | null;
        };
      } | null;
      parent: {
        __typename?: "Parent";
        publicName: string | null;
        photo: string | null;
        uid: string;
        name: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      details: {
        __typename?: "PublicReviewDetails";
        publicReview: string | null;
      } | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
    } | null> | null;
    noPhotos: Array<{
      __typename?: "PublicReview";
      uid: string;
      section_uid: string;
      currentUserCanEdit: boolean;
      currentUserCanRespond: boolean;
      activity_star_rating: number | null;
      currentUserMarkedHelpful: boolean | null;
      markedHelpfulCount: number;
      created_at: any;
      teacher_response: string | null;
      teacher_responded_at: any | null;
      activity: {
        __typename?: "Activity";
        title: string;
        titleTranslated: string | null;
        path: string;
        isClub: boolean;
        slug_id: string;
        uid: string;
        user_uid: string;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          leader_link: string | null;
          photo: string | null;
        };
      } | null;
      parent: {
        __typename?: "Parent";
        publicName: string | null;
        photo: string | null;
        uid: string;
        name: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      details: {
        __typename?: "PublicReviewDetails";
        publicReview: string | null;
      } | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
    } | null> | null;
  } | null;
};

export type AcceptGiftEnrollmentPageQueryQueryVariables = Exact<{
  acceptGiftSlugId: Scalars["ID"];
}>;

export type AcceptGiftEnrollmentPageQueryQuery = {
  __typename?: "Query";
  giftEnrollmentsForAcceptSlug: Array<{
    __typename?: "GiftEnrollment";
    giftClaimedAt: any | null;
    acceptGiftSlugId: string;
    ongoing_start_time: any | null;
    section: {
      __typename?: "Section";
      uid: string;
      activity_uid: string;
      start_time: any | null;
      end_time: any | null;
      teacher_support_start_time: any | null;
      startsAtNight: boolean | null;
      is_cross_listed: boolean;
      size_max: number | null;
      size_min: number | null;
      isPublished: boolean | null;
      price_cents: number | null;
      priceCredits: number | null;
      published_at: any | null;
      updated_at: any;
      canceled_at: any | null;
      deleted_at: any | null;
      ongoing_stopped_at: any | null;
      duration_minutes: number | null;
      usesOutschoolVideoChat: boolean;
      usersCanSendPrivateMessage: boolean;
      currentUserCanManage: boolean;
      isBuyable: boolean;
      allowsTeacherTransfer: boolean;
      activity: {
        __typename?: "Activity";
        uid: string;
        slug_id: string;
        user_uid: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        class_experience: string | null;
        learning_goals: string | null;
        learningGoals: Array<string>;
        assessment: string | null;
        homework: string | null;
        grading_policy: string | null;
        prerequisites: string | null;
        published_at: any | null;
        is_online: boolean;
        age_min: number | null;
        age_max: number | null;
        english_proficiency_level: EnglishProficiencyLevel | null;
        grade_level_min: string | null;
        grade_level_max: string | null;
        size_min: number | null;
        size_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCredits: number | null;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        languageOfInstruction: any | null;
        summaryForLearners: string | null;
        allowWaitlist: boolean | null;
        isClub: boolean;
        isAutoSchedulingEnabled: boolean | null;
        autoSchedulingDaysNoticeMin: number | null;
        autoSchedulingDaysNoticeMax: number | null;
        allows_recurring_payment: boolean | null;
        allows_late_enrollments_for_fixed_length_classes: boolean;
        allowsFutureOngoingEnrollments: boolean;
        has_building_content: boolean | null;
        hasTeacherSchedule: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        classFormat: EducatorSelectedFormat;
        classroomType: ClassroomType;
        isIncludedWithMembership: boolean;
        strictAgeRange: {
          __typename?: "AgeRangeType";
          min: number;
          max: number;
        } | null;
        proficiency_level: {
          __typename?: "ProficiencyLevel";
          level: Array<string | null> | null;
          text: string | null;
        } | null;
        refundPolicy: {
          __typename?: "RefundPolicy";
          name: string;
          description: string;
          type: RefundPolicyType;
        };
        photo: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
        photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
      };
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      } | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      details: {
        __typename?: "SectionDetails";
        autoScheduledDraft: boolean | null;
      };
      prepaidOngoingPeriodOptions: Array<{
        __typename?: "Period";
        startOfIsoWeek: any;
        endOfIsoWeek: any;
      }> | null;
    };
    buyer: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
    };
  }>;
};

export type ActivityAdminQueryQueryVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type ActivityAdminQueryQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    saveCount: number | null;
    archived_at: any | null;
    upsell_activity_uid: string | null;
    why_me: string | null;
    parental_guidance: string | null;
    sources: string | null;
    materials: string | null;
    hasSections: boolean;
    tags: string | null;
    disclaimer: string | null;
    has_external_resources: boolean | null;
    leader: {
      __typename?: "Leader";
      publishedClassCount: number;
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      reviewCount: number;
      averageActivityStarRating: number | null;
      hasListings: boolean;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    };
    actions: Array<{
      __typename?: "ActivityAction";
      uid: string;
      created_at: any;
      action: string;
      notes: string | null;
      message_to_teacher: string | null;
      user: { __typename?: "User"; uid: string; name: string | null };
    }>;
    sections: Array<{
      __typename?: "Section";
      uid: string;
      published_at: any | null;
      deleted_at: any | null;
      canceled_at: any | null;
      start_time: any | null;
      end_time: any | null;
      size_max: number | null;
      currentUserCanManage: boolean;
    }>;
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    details: { __typename?: "ActivityDetails"; asyncTime: string | null };
    leaderDetails: {
      __typename?: "ActivityLeaderDetails";
      uid: string;
      requestedListingAt: any | null;
      welcomeMessage: {
        __typename?: "WelcomeMessage";
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        }> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        } | null;
      } | null;
    };
    adminChecklist: {
      __typename?: "ActivityAdminChecklist";
      notes: string | null;
    };
    pendingOneOnOneEsaEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      orderSlugId: string | null;
      createdAt: any;
      withdrawn_at: any | null;
      withdrawnAt: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        email: string | null;
        photo: string | null;
        timeZone: string | null;
      };
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      refundPolicy: { __typename?: "RefundPolicy"; name: string } | null;
    }>;
    externalResources: Array<{
      __typename?: "ExternalResource";
      uid: string;
      name: string;
      url: string | null;
    }>;
  };
};

export type AddAdminActivityActionMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  action: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
  messageToTeacher?: InputMaybe<Scalars["String"]>;
}>;

export type AddAdminActivityActionMutation = {
  __typename?: "Mutation";
  addAdminActivityAction: {
    __typename?: "ActivityAction";
    uid: string;
    created_at: any;
    action: string;
    notes: string | null;
    message_to_teacher: string | null;
    user: { __typename?: "User"; uid: string; name: string | null };
    activity: {
      __typename?: "Activity";
      uid: string;
      published_at: any | null;
      leaderDetails: {
        __typename?: "ActivityLeaderDetails";
        uid: string;
        requestedListingAt: any | null;
      };
    };
  };
};

export type ActivityUnderReviewQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type ActivityUnderReviewQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    isUnderReReview: boolean;
    disclaimer: string | null;
    esaStatus: EsaStatus;
    first_listed_at: any | null;
    userApprovedFundingPrograms: Array<string> | null;
    isPublished: boolean;
    isRestricted: boolean;
    priceCredits: number | null;
    perWeeklyCourseCredits: number | null;
    wasPublishedInThePast: boolean;
    welcomeAttachmentCount: number | null;
    meetingCount: number | null;
    isIncludedWithMembership: boolean;
    suggestedWeeklyMeetings: number | null;
    reviewCount: number;
    averageStarRating: number | null;
    requested_listing_at: any | null;
    canRequestListing: boolean;
    isSoldOut: boolean;
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    tags: string | null;
    archived_at: any | null;
    isSelfPacedEnrollmentEnabled: boolean;
    saveCount: number | null;
    upsell_activity_uid: string | null;
    why_me: string | null;
    parental_guidance: string | null;
    sources: string | null;
    materials: string | null;
    hasSections: boolean;
    has_external_resources: boolean | null;
    completedEnrollmentCount: number;
    listingPrice: {
      __typename?: "ActivityListingPrice";
      priceCents: number;
      priceCredits: number;
      frequency: ListingPriceFrequency;
    } | null;
    details: {
      __typename?: "ActivityDetails";
      isAIUsedForContentCreation: boolean | null;
      asyncTime: string | null;
    };
    sections: Array<{
      __typename?: "Section";
      validEnrollmentCount: number;
      uid: string;
      filledSpaceCount: number;
    }>;
    attributes: Array<{
      __typename?: "EntityAttribute";
      key: string;
      value: string;
      entity_type: string;
      source: string | null;
    }>;
    clubSection: {
      __typename?: "Section";
      uid: string;
      validEnrollmentCount: number;
      isBuyable: boolean;
    } | null;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        description: string | null;
        week_number: number;
        order_within_week: number;
        lessonNumber: number | null;
        videoDurationSeconds: number;
        assignmentsCount: number;
        unit: {
          __typename?: "Unit";
          uid: string;
          title: string | null;
          unitNumber: number | null;
        } | null;
        lessonPosts: Array<{
          __typename?: "LessonPost";
          uid: string;
          messageContent: {
            __typename?: "MessageContent";
            externalVideoUrl: string | null;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
            } | null;
          };
        }>;
        assignmentLessonPosts: Array<{
          __typename?: "AssignmentLessonPost";
          uid: string;
          messageContent: {
            __typename?: "MessageContent";
            externalVideoUrl: string | null;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
            } | null;
          };
        }>;
      }>;
    } | null;
    video: {
      __typename?: "Attachment";
      videoThumbnailUrl: string | null;
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        url: string;
        thumbUrl: string | null;
        filename: string;
        mimetype: string | null;
        size: number;
      };
    } | null;
    videoForLearners: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    leader: {
      __typename?: "Leader";
      averageActivityStarRating: number | null;
      reviewCount: number;
      successfulClassCount: number;
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      hasListings: boolean;
      publishedClassCount: number;
      teacher_approved_at: any | null;
      educatorTiers: Array<EducatorTier>;
      video: {
        __typename?: "Attachment";
        fileUrl: string;
        videoThumbnailUrl: string | null;
        uid: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          url: string;
          thumbUrl: string | null;
          filename: string;
          mimetype: string | null;
          size: number;
        };
      } | null;
      credentials: Array<{
        __typename?: "TeacherCredential";
        uid: string;
        certificateIssueDate: any | null;
        degreeIssueDate: any | null;
        certificateDiscipline: TeacherCertificateDiscipline | null;
        certificateExpireDate: any | null;
        certificateDoesNotExpire: boolean | null;
        certificateNumber: string | null;
        certificateSecondaryDiscipline: TeacherCertificateDiscipline | null;
        certificateState: TeacherCertificateState | null;
        createdAt: any | null;
        credentialType: CredentialType;
        degreeInstitution: string | null;
        degreeSubject: DegreeSubject | null;
        degreeType: DegreeType | null;
        otherDetails: string | null;
        otherType: string | null;
        name: string | null;
        degreeAdditionalInfo: string | null;
      }>;
      leaderClassLinks: Array<{
        __typename?: "Bundle";
        uid: string;
        title: string;
        isOrdered: boolean;
        bundleElements: Array<{
          __typename?: "BundleElement";
          orderInBundle: number;
          activity: { __typename?: "Activity"; uid: string };
        }>;
      }>;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
      tags: {
        __typename?: "TeacherTagsConnection";
        edges: Array<{
          __typename?: "TeacherTagEdge";
          node: { __typename?: "Tag"; uid: string; key: string; value: string };
        }>;
      };
    };
    approvalCriteria: Array<{
      __typename?: "ApprovalCriterion";
      description: string;
      value: ApprovalCriterionValue;
    }>;
    actions: Array<{
      __typename?: "ActivityAction";
      llm_response: string | null;
      uid: string;
      created_at: any;
      action: string;
      notes: string | null;
      message_to_teacher: string | null;
      user: { __typename?: "User"; uid: string; name: string | null };
    }>;
    sampleClubPost: {
      __typename?: "WelcomeMessage";
      text: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        file: { __typename?: "File"; url: string; mimetype: string | null };
      }> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        file: { __typename?: "File"; url: string; mimetype: string | null };
      } | null;
    } | null;
    clubGuidelines: {
      __typename?: "WelcomeMessage";
      text: string | null;
    } | null;
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    approvalStatus: {
      __typename?: "ActivityApprovalStatus";
      action: string;
      message_to_teacher: string | null;
    } | null;
    leaderDetails: {
      __typename?: "ActivityLeaderDetails";
      uid: string;
      requestedListingAt: any | null;
      welcomeMessage: {
        __typename?: "WelcomeMessage";
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        }> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        } | null;
      } | null;
    };
    externalResources: Array<{
      __typename?: "ExternalResource";
      uid: string;
      name: string;
      url: string | null;
    }>;
    savedClassLists: Array<{
      __typename?: "SavedClassList";
      uid: string;
      lastAddedToAt: any | null;
    }>;
  };
};

export type ActivitySnapshotsQueryVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type ActivitySnapshotsQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    actions: Array<{
      __typename?: "ActivityAction";
      uid: string;
      created_at: any;
      action: string;
      notes: string | null;
      message_to_teacher: string | null;
      html_snapshot_s3_key: string | null;
      html_snapshot: string | null;
      llm_response: string | null;
      user: { __typename?: "User"; uid: string; name: string | null };
    }>;
  };
};

export type AddApprovalActivityActionMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  action: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
  messageToTeacher?: InputMaybe<Scalars["String"]>;
  htmlSnapshot?: InputMaybe<Scalars["String"]>;
  textSnapshotHash?: InputMaybe<Scalars["String"]>;
  reReviewRejectionType?: InputMaybe<ReReviewRejectionType>;
  reReviewTnsCategory?: InputMaybe<TnsActionCategory>;
}>;

export type AddApprovalActivityActionMutation = {
  __typename?: "Mutation";
  addApprovalActivityAction: {
    __typename?: "ActivityAction";
    uid: string;
    created_at: any;
    action: string;
    notes: string | null;
    message_to_teacher: string | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      published_at: any | null;
      leaderDetails: {
        __typename?: "ActivityLeaderDetails";
        uid: string;
        requestedListingAt: any | null;
      };
    };
  };
};

export type NextApprovalActivityUidQueryVariables = Exact<{
  mode?: InputMaybe<ActivityReviewMode>;
  subject?: InputMaybe<Scalars["String"]>;
  includeFlex?: InputMaybe<Scalars["Boolean"]>;
  previousActivityUid?: InputMaybe<Scalars["ID"]>;
  queue?: InputMaybe<ActivityReviewQueue>;
}>;

export type NextApprovalActivityUidQuery = {
  __typename?: "Query";
  nextApprovalActivityUid: string | null;
};

export type GetActivityApprovalAssistantPromptOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetActivityApprovalAssistantPromptOptionsQuery = {
  __typename?: "Query";
  getActivityApprovalAssistantPromptOptions: Array<{
    __typename?: "ActivityApprovalAssistantPromptOptions";
    uid: string;
    promptName: string;
  }>;
};

export type AskActivityApprovalAssistantMutationVariables = Exact<{
  activityUid: Scalars["String"];
  promptUid?: InputMaybe<Scalars["ID"]>;
  rawPrompt?: InputMaybe<Scalars["String"]>;
  htmlSnapshot: Scalars["String"];
  textSnapshotHash: Scalars["String"];
}>;

export type AskActivityApprovalAssistantMutation = {
  __typename?: "Mutation";
  askActivityApprovalAssistant: {
    __typename?: "ActivityApprovalAssistantResponse";
    prompt: string;
    response: string;
  };
};

export type ListActivitiesUnderReviewQueryVariables = Exact<{
  queue?: InputMaybe<ActivityReviewQueue>;
}>;

export type ListActivitiesUnderReviewQuery = {
  __typename?: "Query";
  listActivitiesUnderReview: Array<{
    __typename?: "ActivityInReview";
    uid: string;
    title: string;
    educatorName: string;
    subject: string;
    ageMin: number;
    ageMax: number;
    isFlex: boolean;
    requestedListingAt: any | null;
    reviewerNames: Array<string> | null;
    numActions: number;
    latestNote: string;
    queue: ActivityReviewQueue;
  }>;
};

export type UpdateActivityTagsMutationVariables = Exact<{
  uid: Scalars["ID"];
  updates?: InputMaybe<ActivityInput>;
}>;

export type UpdateActivityTagsMutation = {
  __typename?: "Mutation";
  updateActivity: { __typename?: "Activity"; uid: string; tags: string | null };
};

export type OrgTeacherScheduleSettingsQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type OrgTeacherScheduleSettingsQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    teacherScheduleSettings: Array<{
      __typename?: "ScheduleSettings";
      uid: string;
      mininumNoticeHours: number;
      maximumNoticeHours: number;
      bufferTimeMinutes: number;
      meetingsStartTimeIncrementsInMinutes: number;
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        titleTranslated: string | null;
      };
      availabilities: Array<{
        __typename?: "TeacherScheduleAvailability";
        uid: string | null;
        startTime: any | null;
        endTime: any | null;
        isRecurring: boolean | null;
        recurringEndTime: any | null;
        isUnavailable: boolean | null;
      }>;
    }>;
  } | null;
};

export type PrivateMeetingRequestsQueryVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type PrivateMeetingRequestsQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    isClub: boolean;
    slug_id: string;
    duration_minutes: number | null;
    privateMeetingRequests: Array<{
      __typename?: "MeetingRequest";
      uid: string;
      start_time: any;
      end_time: any;
      is_recurring: boolean;
      orgTeacher: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
      } | null;
    }>;
  };
};

export type AddPrivateMeetingRequestMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  proposedTime: StartEndTime;
  isRecurring: Scalars["Boolean"];
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
}>;

export type AddPrivateMeetingRequestMutation = {
  __typename?: "Mutation";
  addPrivateMeetingRequest: {
    __typename?: "MeetingRequest";
    uid: string;
    start_time: any;
    end_time: any;
    is_recurring: boolean;
    orgTeacher: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
    } | null;
  };
};

export type ActivityAvailability_ScheduleSettingsFragment = {
  __typename?: "ScheduleSettings";
  uid: string;
  mininumNoticeHours: number;
  maximumNoticeHours: number;
  bufferTimeMinutes: number;
  meetingsStartTimeIncrementsInMinutes: number;
  availabilities: Array<{
    __typename?: "TeacherScheduleAvailability";
    uid: string | null;
    startTime: any | null;
    endTime: any | null;
    isRecurring: boolean | null;
    recurringEndTime: any | null;
    isUnavailable: boolean | null;
  }>;
};

export type ActivityAvailability_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  title: string;
  titleTranslated: string | null;
  size_max: number | null;
  isClub: boolean;
  hasTeacherSchedule: boolean;
  autoSchedulingDaysNoticeMin: number | null;
  autoSchedulingDaysNoticeMax: number | null;
  esaStatus: EsaStatus;
  is_ongoing_weekly: boolean;
  isSelfPaced: boolean;
  duration_weeks: number | null;
  slug_id: string;
  user_uid: string;
  archived_at: any | null;
  published_at: any | null;
  requested_listing_at: any | null;
  scheduleSettings: Array<{
    __typename?: "ScheduleSettings";
    uid: string;
    mininumNoticeHours: number;
    maximumNoticeHours: number;
    bufferTimeMinutes: number;
    meetingsStartTimeIncrementsInMinutes: number;
    availabilities: Array<{
      __typename?: "TeacherScheduleAvailability";
      uid: string | null;
      startTime: any | null;
      endTime: any | null;
      isRecurring: boolean | null;
      recurringEndTime: any | null;
      isUnavailable: boolean | null;
    }>;
  }>;
  enrollableTimes: Array<{
    __typename?: "EnrollableTime";
    startTime: any;
    endTime: any;
    teacher: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      hasBackgroundCheckExpired: boolean | null;
      teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    };
  }>;
  approvalStatus: {
    __typename?: "ActivityApprovalStatus";
    action: string;
    message_to_teacher: string | null;
  } | null;
};

export type ActivityAvailabilityQueryVariables = Exact<{
  uid: Scalars["ID"];
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  esaState?: InputMaybe<Scalars["String"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  endBy?: InputMaybe<Scalars["DateTime"]>;
  filterByDow?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]>> | InputMaybe<Scalars["Int"]>
  >;
  recurringOnly?: InputMaybe<Scalars["Boolean"]>;
}>;

export type ActivityAvailabilityQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    titleTranslated: string | null;
    size_max: number | null;
    isClub: boolean;
    hasTeacherSchedule: boolean;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    esaStatus: EsaStatus;
    is_ongoing_weekly: boolean;
    isSelfPaced: boolean;
    duration_weeks: number | null;
    slug_id: string;
    user_uid: string;
    archived_at: any | null;
    published_at: any | null;
    requested_listing_at: any | null;
    scheduleSettings: Array<{
      __typename?: "ScheduleSettings";
      uid: string;
      mininumNoticeHours: number;
      maximumNoticeHours: number;
      bufferTimeMinutes: number;
      meetingsStartTimeIncrementsInMinutes: number;
      availabilities: Array<{
        __typename?: "TeacherScheduleAvailability";
        uid: string | null;
        startTime: any | null;
        endTime: any | null;
        isRecurring: boolean | null;
        recurringEndTime: any | null;
        isUnavailable: boolean | null;
      }>;
    }>;
    enrollableTimes: Array<{
      __typename?: "EnrollableTime";
      startTime: any;
      endTime: any;
      teacher: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        hasBackgroundCheckExpired: boolean | null;
        teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
    }>;
    approvalStatus: {
      __typename?: "ActivityApprovalStatus";
      action: string;
      message_to_teacher: string | null;
    } | null;
  };
};

export type ActivityCharterSchoolEnrollPageQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  esaState?: InputMaybe<Scalars["String"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
}>;

export type ActivityCharterSchoolEnrollPageQuery = {
  __typename?: "Query";
  enrollmentForm: {
    __typename?: "EnrollmentForm";
    section: {
      __typename?: "Section";
      uid: string;
      filledSpaceCount: number;
      allowsLateEnrollment: boolean;
      activity_uid: string;
      start_time: any | null;
      end_time: any | null;
      teacher_support_start_time: any | null;
      startsAtNight: boolean | null;
      is_cross_listed: boolean;
      size_max: number | null;
      size_min: number | null;
      isPublished: boolean | null;
      price_cents: number | null;
      priceCredits: number | null;
      published_at: any | null;
      updated_at: any;
      canceled_at: any | null;
      deleted_at: any | null;
      ongoing_stopped_at: any | null;
      duration_minutes: number | null;
      usesOutschoolVideoChat: boolean;
      usersCanSendPrivateMessage: boolean;
      currentUserCanManage: boolean;
      isBuyable: boolean;
      allowsTeacherTransfer: boolean;
      meetings: Array<{
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
      }>;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        hasBackgroundCheckExpired: boolean | null;
        photo: string | null;
        leader_link: string | null;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        video: {
          __typename?: "Attachment";
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: { __typename?: "File"; url: string; thumbUrl: string | null };
        } | null;
      };
      progress: {
        __typename?: "CourseProgress";
        pastMeetingCount: number;
        remainingMeetingCount: number;
        totalMeetingCount: number;
        nextMeeting: { __typename?: "Meeting"; start_time: any } | null;
      } | null;
      syllabus: {
        __typename?: "Syllabus";
        uid: string;
        lessons: Array<{ __typename?: "Lesson"; uid: string }>;
      } | null;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        deleted_at: any | null;
        created_at: any | null;
      } | null;
      details: {
        __typename?: "SectionDetails";
        autoScheduledDraft: boolean | null;
      };
      prepaidOngoingPeriodOptions: Array<{
        __typename?: "Period";
        startOfIsoWeek: any;
        endOfIsoWeek: any;
      }> | null;
    };
    activity: {
      __typename?: "Activity";
      uid: string;
      ecvCents: number | null;
      suggestedWeeklyMeetings: number | null;
      reviewCount: number;
      esaStatus: EsaStatus;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        created_at: any | null;
        photo: string | null;
        suspended_at: any | null;
        cityState: string | null;
        socialOptOut: boolean;
        is_crosslister: boolean | null;
        timeZone: string | null;
        hasAvailabilitySet: boolean;
        approved: boolean;
        hasBackgroundCheckExpired: boolean | null;
        reviewCount: number;
        averageActivityStarRating: number | null;
        hasListings: boolean;
        details: {
          __typename?: "LeaderDetails";
          about: string | null;
          headline: string | null;
          headlineTranslated: string | null;
          countryOfResidence: string | null;
        };
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: {
          __typename?: "SellerOrg";
          uid: string;
          name: string;
        } | null;
        video: {
          __typename?: "Attachment";
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: { __typename?: "File"; url: string; thumbUrl: string | null };
        } | null;
      };
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      pricingInfo: {
        __typename?: "PricingInfo";
        totalPriceCentsForUpfrontPayment: number;
        totalPriceCentsForWeeklyPayments: number;
        weeklyPriceCentsForUpfrontPayment: number;
        weeklyPriceCentsForWeeklyPayments: number;
        upfrontDiscountPercentage: number;
        totalPriceCreditsForUpfrontPayment: number;
        weeklyPriceCreditsForUpfrontPayment: number;
        totalPriceCreditsForWeeklyPayments: number;
        weeklyPriceCreditsForWeeklyPayments: number;
      } | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        key: string;
        value: string;
      }>;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    };
  } | null;
};

export type ActivityCharterSchoolEnrollSelfPacedQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  esaState?: InputMaybe<Scalars["String"]>;
}>;

export type ActivityCharterSchoolEnrollSelfPacedQuery = {
  __typename?: "Query";
  selfPacedEnrollmentForm: {
    __typename?: "SelfPacedEnrollmentForm";
    activity: {
      __typename?: "Activity";
      uid: string;
      ecvCents: number | null;
      suggestedWeeklyMeetings: number | null;
      reviewCount: number;
      esaStatus: EsaStatus;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        created_at: any | null;
        photo: string | null;
        suspended_at: any | null;
        cityState: string | null;
        socialOptOut: boolean;
        is_crosslister: boolean | null;
        timeZone: string | null;
        hasAvailabilitySet: boolean;
        approved: boolean;
        hasBackgroundCheckExpired: boolean | null;
        reviewCount: number;
        averageActivityStarRating: number | null;
        hasListings: boolean;
        details: {
          __typename?: "LeaderDetails";
          about: string | null;
          headline: string | null;
          headlineTranslated: string | null;
          countryOfResidence: string | null;
        };
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: {
          __typename?: "SellerOrg";
          uid: string;
          name: string;
        } | null;
        video: {
          __typename?: "Attachment";
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: { __typename?: "File"; url: string; thumbUrl: string | null };
        } | null;
      };
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      pricingInfo: {
        __typename?: "PricingInfo";
        totalPriceCentsForUpfrontPayment: number;
        totalPriceCentsForWeeklyPayments: number;
        weeklyPriceCentsForUpfrontPayment: number;
        weeklyPriceCentsForWeeklyPayments: number;
        upfrontDiscountPercentage: number;
        totalPriceCreditsForUpfrontPayment: number;
        weeklyPriceCreditsForUpfrontPayment: number;
        totalPriceCreditsForWeeklyPayments: number;
        weeklyPriceCreditsForWeeklyPayments: number;
      } | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        key: string;
        value: string;
      }>;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    };
  };
};

export type SimilarListingsUnpublishedQueryVariables = Exact<{
  activitySlugId: Scalars["String"];
  withRecentReviews: Scalars["Boolean"];
  skipRating: Scalars["Boolean"];
}>;

export type SimilarListingsUnpublishedQuery = {
  __typename?: "Query";
  similarListingsUnpublished: {
    __typename?: "SimilarListings";
    popularElasticsearch: Array<{
      __typename?: "Listing";
      insertionId: string | null;
      sectionCount: number;
      openSectionCount: number;
      upcomingSectionCount: number;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
            fileSize: number | null;
          };
        } | null;
        credentials: Array<{
          __typename?: "TeacherCredential";
          uid: string;
          degreeType: DegreeType | null;
          degreeSubject: DegreeSubject | null;
        }>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
      activity: {
        __typename?: "Activity";
        uid: string;
        isIncludedWithMembership: boolean;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        quickSummary: string | null;
        isClub: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        hasTeacherSchedule: boolean;
        size_max: number | null;
        user_uid: string;
        slug_id: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        recentReviews?: Array<{
          __typename?: "PublicReview";
          uid: string;
          activity_star_rating: number | null;
          details: {
            __typename?: "PublicReviewDetails";
            publicReview: string | null;
          } | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            publicName: string | null;
          };
        }>;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
    }>;
  };
};

export type ActivityLessonPostFragmentFragment = {
  __typename?: "LessonPost";
  uid: string;
  title: string | null;
  lessonUid: string;
  orderInLesson: number;
  deleted_at: any | null;
  is_posted_for_enrollments: boolean;
  is_posted_for_subscriptions: boolean;
  isClassListingVideoPreview: boolean;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type AssignmentLessonPostFragmentFragment = {
  __typename?: "AssignmentLessonPost";
  uid: string;
  title: string | null;
  lessonUid: string;
  orderInLesson: number;
  deleted_at: any | null;
  submissionRequirement: SubmissionRequirementType;
  isClassListingVideoPreview: boolean;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type ActivityPosts_LessonFragment = {
  __typename?: "Lesson";
  uid: string;
  title: string | null;
  description: string | null;
  week_number: number;
  order_within_week: number;
  lessonNumber: number | null;
  unit: {
    __typename?: "Unit";
    uid: string;
    title: string | null;
    unitNumber: number | null;
  } | null;
  lessonPosts: Array<{
    __typename?: "LessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    is_posted_for_enrollments: boolean;
    is_posted_for_subscriptions: boolean;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  }>;
  assignmentLessonPosts: Array<{
    __typename?: "AssignmentLessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    submissionRequirement: SubmissionRequirementType;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  }>;
};

export type ActivityLessonPostsQueryQueryVariables = Exact<{
  uid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
  preferDraft?: InputMaybe<Scalars["Boolean"]>;
}>;

export type ActivityLessonPostsQueryQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    duration_weeks: number | null;
    isSelfPaced: boolean;
    slug_id: string;
    user_uid: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    saveCount: number | null;
    archived_at: any | null;
    upsell_activity_uid: string | null;
    why_me: string | null;
    parental_guidance: string | null;
    sources: string | null;
    materials: string | null;
    hasSections: boolean;
    requested_listing_at: any | null;
    has_external_resources: boolean | null;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      layoutVersion: number;
      units: Array<{ __typename?: "Unit"; uid: string; title: string | null }>;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        description: string | null;
        week_number: number;
        order_within_week: number;
        lessonNumber: number | null;
        unit: {
          __typename?: "Unit";
          uid: string;
          title: string | null;
          unitNumber: number | null;
        } | null;
        lessonPosts: Array<{
          __typename?: "LessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          is_posted_for_enrollments: boolean;
          is_posted_for_subscriptions: boolean;
          isClassListingVideoPreview: boolean;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
        assignmentLessonPosts: Array<{
          __typename?: "AssignmentLessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          submissionRequirement: SubmissionRequirementType;
          isClassListingVideoPreview: boolean;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      }>;
    } | null;
    selfPacedMigration: {
      __typename?: "SelfPacedMigrationStatus";
      hasConsented: boolean;
      consentedAt: any | null;
    } | null;
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    details: { __typename?: "ActivityDetails"; asyncTime: string | null };
    leaderDetails: {
      __typename?: "ActivityLeaderDetails";
      uid: string;
      requestedListingAt: any | null;
      welcomeMessage: {
        __typename?: "WelcomeMessage";
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        }> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        } | null;
      } | null;
    };
    approvalStatus: {
      __typename?: "ActivityApprovalStatus";
      action: string;
      message_to_teacher: string | null;
    } | null;
    externalResources: Array<{
      __typename?: "ExternalResource";
      uid: string;
      name: string;
      url: string | null;
    }>;
  };
};

export type AddAssignmentLessonPostMutationVariables = Exact<{
  createAssignmentLessonPostInput: CreateAssignmentLessonPostInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type AddAssignmentLessonPostMutation = {
  __typename?: "Mutation";
  addAssignmentLessonPost: {
    __typename?: "AssignmentLessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    submissionRequirement: SubmissionRequirementType;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type DeleteAssignmentLessonPostMutationVariables = Exact<{
  assignmentLessonPostUid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type DeleteAssignmentLessonPostMutation = {
  __typename?: "Mutation";
  deleteAssignmentLessonPost: {
    __typename?: "AssignmentLessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    submissionRequirement: SubmissionRequirementType;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type UpdateAssignmentLessonPostMutationVariables = Exact<{
  assignmentLessonPostUid: Scalars["ID"];
  updateAssignmentLessonPostInput: UpdateAssignmentLessonPostInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UpdateAssignmentLessonPostMutation = {
  __typename?: "Mutation";
  updateAssignmentLessonPost: {
    __typename?: "AssignmentLessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    submissionRequirement: SubmissionRequirementType;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type ConvertAssignmentLessonPostToAssignmentClassPostMutationVariables =
  Exact<{
    assignmentLessonPostUid: Scalars["ID"];
    sectionUid: Scalars["ID"];
    publishAt?: InputMaybe<Scalars["DateTime"]>;
    plainText?: InputMaybe<Scalars["Boolean"]>;
  }>;

export type ConvertAssignmentLessonPostToAssignmentClassPostMutation = {
  __typename?: "Mutation";
  convertAssignmentLessonPostToAssignmentClassPost: {
    __typename?: "AssignmentClassPost";
    uid: string;
    title: string;
    created_at: any;
    deleted_at: any | null;
    publishAt: any;
    dueDate: any | null;
    submissionRequirement: SubmissionRequirementType;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    lesson: { __typename?: "Lesson"; uid: string; title: string | null } | null;
    lessonPost: {
      __typename?: "AssignmentLessonPost";
      uid: string;
      title: string | null;
      lessonUid: string;
      orderInLesson: number;
      deleted_at: any | null;
      submissionRequirement: SubmissionRequirementType;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    } | null;
  };
};

export type LessonPostFragmentFragment = {
  __typename?: "LessonPost";
  uid: string;
  title: string | null;
  lessonUid: string;
  orderInLesson: number;
  deleted_at: any | null;
  is_posted_for_enrollments: boolean;
  is_posted_for_subscriptions: boolean;
  isClassListingVideoPreview: boolean;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type AddLessonPostMutationVariables = Exact<{
  createLessonPostInput: CreateLessonPostInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type AddLessonPostMutation = {
  __typename?: "Mutation";
  addLessonPost: {
    __typename?: "LessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    is_posted_for_enrollments: boolean;
    is_posted_for_subscriptions: boolean;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type DeleteLessonPostMutationVariables = Exact<{
  lessonPostUid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type DeleteLessonPostMutation = {
  __typename?: "Mutation";
  deleteLessonPost: {
    __typename?: "LessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    is_posted_for_enrollments: boolean;
    is_posted_for_subscriptions: boolean;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type UpdateLessonPostMutationVariables = Exact<{
  lessonPostUid: Scalars["ID"];
  updateLessonPostInput: UpdateLessonPostInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UpdateLessonPostMutation = {
  __typename?: "Mutation";
  updateLessonPost: {
    __typename?: "LessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    is_posted_for_enrollments: boolean;
    is_posted_for_subscriptions: boolean;
    isClassListingVideoPreview: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type ConvertLessonPostToClassPostMutationVariables = Exact<{
  lessonPostUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type ConvertLessonPostToClassPostMutation = {
  __typename?: "Mutation";
  convertLessonPostToClassPost: {
    __typename?: "ClassPost";
    uid: string;
    isWelcomePost: boolean;
    publishAt: any;
    title: string | null;
    promotedAt: any | null;
    pinnedAt: any | null;
    mentionedEnrollmentUids: Array<string>;
    backgroundColor: string | null;
    score: number | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    commentsPreview: {
      __typename?: "CommentsPreview";
      remainingCommentsCount: number;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  };
};

export type MigrateSyllabusToV2MutationVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type MigrateSyllabusToV2Mutation = {
  __typename?: "Mutation";
  migrateSyllabusToV2: {
    __typename?: "Syllabus";
    uid: string;
    layoutVersion: number;
  };
};

export type ActivityScheduleQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type ActivityScheduleQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    waitlistSeatsCount: number | null;
    allowWaitlist: boolean | null;
    allApprovedFundingPrograms: Array<string> | null;
    requested_listing_at: any | null;
    canRequestListing: boolean;
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    saveCount: number | null;
    archived_at: any | null;
    upsell_activity_uid: string | null;
    why_me: string | null;
    parental_guidance: string | null;
    sources: string | null;
    materials: string | null;
    hasSections: boolean;
    tags: string | null;
    isSelfPacedEnrollmentEnabled: boolean;
    has_external_resources: boolean | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
    };
    selfPacedMigration: {
      __typename?: "SelfPacedMigrationStatus";
      hasConsented: boolean;
      consentedAt: any | null;
    } | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    bundles: Array<{
      __typename?: "Bundle";
      uid: string;
      title: string;
      thumbnail: string | null;
      isOrdered: boolean;
      bundleElements: Array<{
        __typename?: "BundleElement";
        uid: string;
        orderInBundle: number;
        activity: {
          __typename?: "Activity";
          age_min: number | null;
          age_max: number | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
        };
      }>;
    }>;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        week_number: number;
        order_within_week: number;
        title: string | null;
        description: string | null;
        lessonNumber: number | null;
        unit: { __typename?: "Unit"; uid: string; title: string | null } | null;
      }>;
    } | null;
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    details: { __typename?: "ActivityDetails"; asyncTime: string | null };
    leaderDetails: {
      __typename?: "ActivityLeaderDetails";
      uid: string;
      requestedListingAt: any | null;
      welcomeMessage: {
        __typename?: "WelcomeMessage";
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        }> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
          };
        } | null;
      } | null;
    };
    approvalStatus: {
      __typename?: "ActivityApprovalStatus";
      action: string;
      message_to_teacher: string | null;
    } | null;
    classScheduleRequests: Array<{
      __typename?: "ClassScheduleRequest";
      uid: string;
      timeZone: string;
      message: string | null;
      created_at: any;
      parentEnrolledAt: any | null;
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      timetable: {
        __typename?: "Timetable";
        mon: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        tue: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        wed: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        thu: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        fri: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        sat: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
        sun: {
          __typename?: "TimetableTimes";
          f8_12: boolean;
          f12_4: boolean;
          f4_8: boolean;
        };
      };
    }>;
    externalResources: Array<{
      __typename?: "ExternalResource";
      uid: string;
      name: string;
      url: string | null;
    }>;
  };
};

export type SectionsForActivityScheduleQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  filter?: InputMaybe<SectionFilter>;
  skipSectionFiltersForClub?: InputMaybe<Scalars["Boolean"]>;
  ignoreSelfPaced?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  forcedOrderBy?: InputMaybe<Scalars["String"]>;
}>;

export type SectionsForActivityScheduleQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    waitlistSeatsCount: number | null;
    paginatedFilteredSections: {
      __typename?: "SectionList";
      totalCount: number;
      data: Array<{
        __typename?: "Section";
        filledSpaceCount: number;
        waitlistSeatsCount: number | null;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        created_at: any;
        validEnrollmentCount: number;
        isAutoCanceled: boolean;
        currentUserIsOwner: boolean;
        paidAmount: number | null;
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        }>;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
          onlineClassroom: {
            __typename?: "OnlineClassroom";
            type: string | null;
            url: string | null;
          } | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
        checklist: {
          __typename?: "SectionChecklist";
          autoCanceledAt: any | null;
          grandfatheredAt2017Rate: boolean | null;
        };
      }>;
    };
  };
};

export type EnrollmentsForLearnerListQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  enrollmentParams?: InputMaybe<EnrollmentParamsInput>;
}>;

export type EnrollmentsForLearnerListQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    enrollmentCount: number;
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      section_uid: string | null;
      isRepeatLearnerOfTeacher: boolean;
      nextMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        avatar: string | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        activity: { __typename?: "Activity"; uid: string };
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      } | null;
    }>;
  };
};

export type ParentScheduleRequestsSection_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  title: string;
  titleTranslated: string | null;
  classScheduleRequests: Array<{
    __typename?: "ClassScheduleRequest";
    uid: string;
    timeZone: string;
    message: string | null;
    created_at: any;
    parentEnrolledAt: any | null;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
    };
    timetable: {
      __typename?: "Timetable";
      mon: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      tue: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      wed: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      thu: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      fri: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      sat: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
      sun: {
        __typename?: "TimetableTimes";
        f8_12: boolean;
        f12_4: boolean;
        f4_8: boolean;
      };
    };
  }>;
};

export type SelfPacedSectionsForLearnerListQueryVariables = Exact<{
  activityUid: Scalars["ID"];
  filter?: InputMaybe<SectionFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  sellerOrgTeacherUid?: InputMaybe<Scalars["String"]>;
  forcedOrderBy?: InputMaybe<Scalars["String"]>;
}>;

export type SelfPacedSectionsForLearnerListQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    waitlistSeatsCount: number | null;
    paginatedFilteredSections: {
      __typename?: "SectionList";
      totalCount: number;
      data: Array<{
        __typename?: "Section";
        is_self_paced: boolean;
        isSelfPacedReadOnly: boolean;
        isInProgress: boolean;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        enrollments: Array<{
          __typename?: "Enrollment";
          uid: string;
          section_uid: string | null;
          hasPaymentSchedule: boolean;
          learner: {
            __typename?: "Learner";
            uid: string;
            name: string | null;
            avatar: string | null;
          } | null;
        }>;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      }>;
    };
  };
};

export type AddTnsIncidentMutationVariables = Exact<{
  userUid: Scalars["ID"];
  action: TnsAction;
  category?: InputMaybe<TnsActionCategory>;
  link?: InputMaybe<Scalars["String"]>;
  notes?: InputMaybe<Scalars["String"]>;
}>;

export type AddTnsIncidentMutation = {
  __typename?: "Mutation";
  addUserIncident: boolean;
};

export type AddBulkGiftCardsMutationMutationVariables = Exact<{
  data: BulkGiftCardsInput;
}>;

export type AddBulkGiftCardsMutationMutation = {
  __typename?: "Mutation";
  addBulkGiftCards: {
    __typename?: "BulkGiftCardResponse";
    orderSlugId: string;
    redemptionCodes: Array<string>;
  };
};

export type GetBundleQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type GetBundleQuery = {
  __typename?: "Query";
  bundle: {
    __typename?: "Bundle";
    uid: string;
    title: string;
    description: string | null;
    isOrdered: boolean;
    thumbnail: string | null;
    discount: number | null;
    bundleElements: Array<{
      __typename?: "BundleElement";
      uid: string;
      orderInBundle: number;
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        age_min: number | null;
        age_max: number | null;
        archived_at: any | null;
        published_at: any | null;
        requested_listing_at: any | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        approvalStatus: {
          __typename?: "ActivityApprovalStatus";
          action: string;
          message_to_teacher: string | null;
        } | null;
      };
    }>;
  };
};

export type GetBundleEligibleActivitiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetBundleEligibleActivitiesQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    leaderActivities: Array<{
      __typename?: "Activity";
      uid: string;
      title: string;
      age_min: number | null;
      age_max: number | null;
      archived_at: any | null;
      published_at: any | null;
      requested_listing_at: any | null;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      approvalStatus: {
        __typename?: "ActivityApprovalStatus";
        action: string;
        message_to_teacher: string | null;
      } | null;
    }>;
  } | null;
};

export type UpdateBundleMutationVariables = Exact<{
  bundleUid: Scalars["ID"];
  updateBundleInput: UpdateBundleInput;
}>;

export type UpdateBundleMutation = {
  __typename?: "Mutation";
  updateBundle: { __typename?: "Bundle"; uid: string };
};

export type DeleteBundleMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type DeleteBundleMutation = {
  __typename?: "Mutation";
  deleteBundle: { __typename?: "Bundle"; uid: string };
};

export type CancelSubscriptionMutationVariables = Exact<{
  reason: Scalars["String"];
  feedback?: InputMaybe<Scalars["String"]>;
}>;

export type CancelSubscriptionMutation = {
  __typename?: "Mutation";
  cancelSubscription: boolean;
};

export type CategoryPagesByPageQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
}>;

export type CategoryPagesByPageQuery = {
  __typename?: "Query";
  categoryPagesByPage: {
    __typename?: "PaginatedCategoryPages";
    total: number | null;
    limit: number | null;
    count: number | null;
    offset: number | null;
    categoryPages: Array<{
      __typename?: "CategoryPage";
      uid: string;
      basePath: string;
      name: string;
      slug: string;
    } | null> | null;
  } | null;
};

export type HasPinSetQueryVariables = Exact<{ [key: string]: never }>;

export type HasPinSetQuery = {
  __typename?: "Query";
  hasPinSet: boolean | null;
};

export type UpdateSubscriptionPackageMutationVariables = Exact<{
  selectedPackage: Scalars["String"];
  paymentMethod?: InputMaybe<Scalars["String"]>;
  isImmediate?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UpdateSubscriptionPackageMutation = {
  __typename?: "Mutation";
  updateSubscription: {
    __typename?: "SubscriptionInformation";
    subscriptionId: string | null;
    packageName: string | null;
    numCredits: number | null;
  } | null;
};

export type ClassComparisonQueryVariables = Exact<{
  activityUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type ClassComparisonQuery = {
  __typename?: "Query";
  classComparison: {
    __typename?: "ClassComparison";
    comparedClasses: Array<{
      __typename?: "ComparedClass";
      activity: {
        __typename?: "Activity";
        uid: string;
        slug_id: string;
        title: string;
        titleTranslated: string | null;
        subject: string | null;
        weekly_meetings: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        priceCredits: number | null;
        priceCreditsPerMeeting: number | null;
        price_cents: number | null;
        is_ongoing_weekly: boolean;
        isSelfPaced: boolean;
        isFlexSchedule: boolean;
        hasTeacherSchedule: boolean;
        isOneTime: boolean;
        isClub: boolean;
        allows_recurring_payment: boolean | null;
        age_min: number | null;
        age_max: number | null;
        size_min: number | null;
        size_max: number | null;
        isIncludedWithMembership: boolean;
        reviewCount: number;
        averageStarRating: number | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        details: { __typename?: "ActivityDetails"; asyncTime: string | null };
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
          reviewCount: number;
          averageActivityStarRating: number | null;
          credentials: Array<{
            __typename?: "TeacherCredential";
            uid: string;
            name: string | null;
            degreeType: DegreeType | null;
            degreeSubject: DegreeSubject | null;
            degreeInstitution: string | null;
            certificateDiscipline: TeacherCertificateDiscipline | null;
            certificateState: TeacherCertificateState | null;
            otherType: string | null;
          }>;
          ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            file: { __typename?: "File"; url: string; thumbUrl: string | null };
          } | null;
        };
      };
    }>;
  };
};

export type ClassComparisonAiInsightsQueryVariables = Exact<{
  activityUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type ClassComparisonAiInsightsQuery = {
  __typename?: "Query";
  classComparisonAiInsights: {
    __typename?: "ClassComparisonAiInsights";
    comparedClassesAiInsights: Array<{
      __typename?: "ComparedClassAiInsights";
      activityUid: string;
      highlights: string | null;
      neurodivergentExperience: string | null;
      reviews: string | null;
      supplies: string | null;
    }>;
  };
};

export type ClassroomTimeBoundsQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type ClassroomTimeBoundsQuery = {
  __typename?: "Query";
  classroom: {
    __typename?: "Classroom";
    uid: string;
    section: {
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
      is_self_paced: boolean;
    };
    currentUserEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
    }>;
  };
};

export type ClassroomQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
  hasLearner: Scalars["Boolean"];
  startBefore: Scalars["DateTime"];
  start?: InputMaybe<Scalars["DateTime"]>;
  end?: InputMaybe<Scalars["DateTime"]>;
  plainText?: InputMaybe<Scalars["Boolean"]>;
  postFilter?: InputMaybe<ClassroomPostFilter>;
  postOrder?: InputMaybe<ClassroomPostOrder>;
}>;

export type ClassroomQuery = {
  __typename?: "Query";
  classroom: {
    __typename?: "Classroom";
    uid: string;
    usersCanHaveLiveMeeting: boolean;
    usersCanPost: boolean;
    usersCanComment: boolean;
    currentUserEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      isEnded: boolean;
      isPaused: boolean;
      usersCanCommunicate: boolean;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
      } | null;
    }>;
    section: {
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
      currentUserCanManage: boolean;
      filledSpaceCount: number;
      usesOutschoolVideoChat: boolean;
      latestProgressReportDate: any | null;
      isBuyable: boolean;
      published_at: any | null;
      deleted_at: any | null;
      canceled_at: any | null;
      startsAtNight: boolean | null;
      is_self_paced: boolean;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
      } | null;
      lastMeeting: Array<{
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
      }>;
      meetings: Array<{
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        recordingAvailability: RecordingAvailability;
        recordingRequests: Array<{
          __typename?: "RecordingRequest";
          requestedAt: any;
          message: string;
          requestedBy: {
            __typename?: "Learner";
            uid: string;
            name: string | null;
          };
        }>;
        classRecordings: Array<
          | {
              __typename?: "ClassRecording";
              uid: string;
              startTime: any;
              endTime: any;
            }
          | {
              __typename?: "ZoomRecording";
              uid: string;
              startTime: any;
              endTime: any;
            }
        >;
        attendances: Array<{
          __typename?: "Attendance";
          learner: { __typename?: "Learner"; name: string | null };
        }>;
      }>;
      assignmentClassPosts: Array<{
        __typename?: "AssignmentClassPost";
        uid: string;
      }>;
      syllabus: {
        __typename?: "Syllabus";
        uid: string;
        published_at: string | null;
        layoutVersion: number;
      } | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
    };
    activity: {
      __typename?: "Activity";
      uid: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      is_ongoing_weekly: boolean;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      is_online: boolean;
      hasTeacherSchedule: boolean;
      archived_at: any | null;
      published_at: any | null;
      requested_listing_at: any | null;
      isClub: boolean;
      isSelfPaced: boolean;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        photo: string | null;
        leader_link: string | null;
        name: string | null;
      };
      approvalStatus: {
        __typename?: "ActivityApprovalStatus";
        action: string;
        message_to_teacher: string | null;
      } | null;
    };
    learners: Array<{
      __typename?: "LearnerProfile";
      uid: string;
      name: string | null;
      avatar: string | null;
    }>;
    posts: Array<{
      __typename?: "ClassPost";
      uid: string;
      isWelcomePost: boolean;
      publishAt: any;
      title: string | null;
      promotedAt: any | null;
      pinnedAt: any | null;
      mentionedEnrollmentUids: Array<string>;
      backgroundColor: string | null;
      score: number | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      commentsPreview: {
        __typename?: "CommentsPreview";
        remainingCommentsCount: number;
        comments: Array<{
          __typename?: "ClassPostComment";
          uid: string;
          sendAt: any;
          mentionedEnrollmentUids: Array<string>;
          mentionedTeacherUid: string | null;
          backgroundColor: string | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      };
    }>;
    unpublishedPosts: Array<{
      __typename?: "ClassPost";
      uid: string;
      isWelcomePost: boolean;
      publishAt: any;
      title: string | null;
      promotedAt: any | null;
      pinnedAt: any | null;
      mentionedEnrollmentUids: Array<string>;
      backgroundColor: string | null;
      score: number | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      commentsPreview: {
        __typename?: "CommentsPreview";
        remainingCommentsCount: number;
        comments: Array<{
          __typename?: "ClassPostComment";
          uid: string;
          sendAt: any;
          mentionedEnrollmentUids: Array<string>;
          mentionedTeacherUid: string | null;
          backgroundColor: string | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      };
    }>;
    mentionNames: Array<{
      __typename?: "MentionName";
      id: string;
      display: string;
      avatar: string | null;
      learnerUid: string | null;
      startTime: any | null;
    }>;
  };
  learner?: { __typename?: "Learner"; uid: string; name: string | null } | null;
};

export type ClubManageListingQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type ClubManageListingQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    allApprovedFundingPrograms: Array<string> | null;
    saveCount: number | null;
    waitlistSeatsCount: number | null;
    requested_listing_at: any | null;
    canRequestListing: boolean;
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    tags: string | null;
    archived_at: any | null;
    isSelfPacedEnrollmentEnabled: boolean;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    sections: Array<{
      __typename?: "Section";
      filledSpaceCount: number;
      waitlistSeatsCount: number | null;
      uid: string;
      published_at: any | null;
      deleted_at: any | null;
      canceled_at: any | null;
      start_time: any | null;
      end_time: any | null;
      size_max: number | null;
      currentUserCanManage: boolean;
    }>;
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    approvalStatus: {
      __typename?: "ActivityApprovalStatus";
      action: string;
      message_to_teacher: string | null;
    } | null;
  };
};

export type FeaturedClubCard_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  slug_id: string;
  isClub: boolean;
  title: string;
  titleTranslated: string | null;
  summary: string | null;
  age_max: number | null;
  age_min: number | null;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
  sampleClubPost: {
    __typename?: "WelcomeMessage";
    text: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      file: { __typename?: "File"; url: string; mimetype: string | null };
    }> | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      file: { __typename?: "File"; url: string; mimetype: string | null };
    } | null;
  } | null;
  leader: {
    __typename?: "Leader";
    uid: string;
    name: string | null;
    photo: string | null;
  };
};

export type ClubCard_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  slug_id: string;
  isClub: boolean;
  title: string;
  titleTranslated: string | null;
  summary: string | null;
  age_min: number | null;
  age_max: number | null;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type ClubsLandingPageQueryVariables = Exact<{ [key: string]: never }>;

export type ClubsLandingPageQuery = {
  __typename?: "Query";
  featuredClubs: Array<{
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    isClub: boolean;
    title: string;
    titleTranslated: string | null;
    summary: string | null;
    age_max: number | null;
    age_min: number | null;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
    sampleClubPost: {
      __typename?: "WelcomeMessage";
      text: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        file: { __typename?: "File"; url: string; mimetype: string | null };
      }> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        file: { __typename?: "File"; url: string; mimetype: string | null };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
    };
  }>;
  popularClubs: Array<{
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    isClub: boolean;
    title: string;
    titleTranslated: string | null;
    summary: string | null;
    age_min: number | null;
    age_max: number | null;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  }>;
  clubCategories: Array<{
    __typename?: "ClubCategory";
    label: string;
    subject: string;
    activities: Array<{
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      isClub: boolean;
      title: string;
      titleTranslated: string | null;
      summary: string | null;
      age_min: number | null;
      age_max: number | null;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
    }>;
  }>;
};

export type ConfirmChildEmailMutationVariables = Exact<{
  childUid: Scalars["ID"];
  token: Scalars["String"];
}>;

export type ConfirmChildEmailMutation = {
  __typename?: "Mutation";
  confirmChildEmail: boolean;
};

export type SearchConversationFiltersQueryVariables = Exact<{
  searchQuery: Scalars["String"];
  audience: Audience;
  existingFilters?: InputMaybe<ConversationFiltersInput>;
}>;

export type SearchConversationFiltersQuery = {
  __typename?: "Query";
  searchConversationFilters: Array<{
    __typename?: "ConversationFilter";
    uid: string;
    type: ConversationFilterType;
    name: string;
    highlight: string | null;
    resultCount: number | null;
  }>;
};

export type ParticipantsQueryVariables = Exact<{
  uids: Array<Scalars["ID"]> | Scalars["ID"];
  audience: Audience;
}>;

export type ParticipantsQuery = {
  __typename?: "Query";
  participants: Array<{
    __typename?: "Participant";
    uid: string;
    name: string | null;
    timeZone: string | null;
  }>;
};

export type ActivityQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type ActivityQuery = {
  __typename?: "Query";
  activity: { __typename?: "Activity"; uid: string; title: string };
};

export type ConversationsQueryVariables = Exact<{
  offset: Scalars["Int"];
  limit: Scalars["Int"];
  filters?: InputMaybe<ConversationFiltersInput>;
  audience?: InputMaybe<Audience>;
  messageSelection?: InputMaybe<MessageSelection>;
  viewAsOrgTeacherUid?: InputMaybe<Scalars["String"]>;
}>;

export type ConversationsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    conversationsCount: number;
    conversations: Array<
      | {
          __typename?: "MessageThread";
          uid: string;
          isRead: boolean;
          matchedSearchResults: Array<{
            __typename?: "ConversationSearchResult";
            threadUid: string;
            highlightedMatch: string;
          }> | null;
          participants: Array<{
            __typename?: "Participant";
            avatar: string | null;
            uid: string;
            name: string | null;
            photo: string | null;
            timeZone: string | null;
            headline: string | null;
            leader_link: string | null;
            isLearner: boolean;
            role: ParticipantRole | null;
            activitiesWithCurrentUser: Array<{
              __typename?: "Activity";
              uid: string;
            }> | null;
            parent: {
              __typename?: "Parent";
              uid: string;
              photo: string | null;
              publicName: string | null;
            } | null;
            ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
            teacherForSellerOrg: {
              __typename?: "SellerOrg";
              uid: string;
            } | null;
          }>;
          activity: {
            __typename?: "Activity";
            uid: string;
            title: string;
            titleTranslated: string | null;
            photo: { __typename?: "Attachment"; fileUrl: string } | null;
          } | null;
          messages: Array<{
            __typename?: "Message";
            created_at: any;
            uid: string;
            activity_uid: string | null;
            section_uid: string | null;
            thread_uid: string;
            subject: string | null;
            content: string | null;
            sender: {
              __typename?: "Sender";
              uid: string;
              name: string | null;
              photo: string | null;
              timeZone: string | null;
              headline: string | null;
              leader_link: string | null;
            };
            participants: Array<{
              __typename?: "Participant";
              isLearner: boolean;
              avatar: string | null;
              uid: string;
              name: string | null;
              photo: string | null;
              timeZone: string | null;
              headline: string | null;
              leader_link: string | null;
              role: ParticipantRole | null;
              ownerOfSellerOrg: {
                __typename?: "SellerOrg";
                uid: string;
              } | null;
              teacherForSellerOrg: {
                __typename?: "SellerOrg";
                uid: string;
              } | null;
            }>;
          }>;
        }
      | {
          __typename?: "PrivateClassThread";
          uid: string;
          isRead: boolean;
          matchedSearchResults: Array<{
            __typename?: "ConversationSearchResult";
            threadUid: string;
            highlightedMatch: string;
          }> | null;
          participants: Array<{
            __typename?: "Participant";
            avatar: string | null;
            uid: string;
            name: string | null;
            photo: string | null;
            timeZone: string | null;
            headline: string | null;
            leader_link: string | null;
            isLearner: boolean;
            role: ParticipantRole | null;
            activitiesWithCurrentUser: Array<{
              __typename?: "Activity";
              uid: string;
            }> | null;
            parent: {
              __typename?: "Parent";
              uid: string;
              photo: string | null;
              publicName: string | null;
            } | null;
            ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
            teacherForSellerOrg: {
              __typename?: "SellerOrg";
              uid: string;
            } | null;
          }>;
          activity: {
            __typename?: "Activity";
            uid: string;
            title: string;
            titleTranslated: string | null;
            photo: { __typename?: "Attachment"; fileUrl: string } | null;
          } | null;
          messages: Array<{
            __typename?: "PrivateClassMessage";
            sentAt: any;
            uid: string;
            activity_uid: string;
            section_uid: string;
            thread_uid: string;
            subject: string | null;
            content: string | null;
            sender: {
              __typename?: "MessageSender";
              uid: string;
              name: string | null;
              photo: string | null;
              avatar: string | null;
              isLearner: boolean;
            };
            participants: Array<{
              __typename?: "Participant";
              isLearner: boolean;
              avatar: string | null;
              uid: string;
              name: string | null;
              photo: string | null;
              timeZone: string | null;
              headline: string | null;
              leader_link: string | null;
              role: ParticipantRole | null;
              ownerOfSellerOrg: {
                __typename?: "SellerOrg";
                uid: string;
              } | null;
              teacherForSellerOrg: {
                __typename?: "SellerOrg";
                uid: string;
              } | null;
            }>;
          }>;
        }
    >;
  } | null;
};

export type EnrolledClassDetailsQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type EnrolledClassDetailsQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    filledSpaceCount: number;
    currentUserGiftSlugId: string | null;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    is_self_paced: boolean;
    meetings: Array<{
      __typename: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
      refundableAmountCents: number;
      paidAt: any | null;
      recurring: boolean | null;
      oneOnOneTenderType: Array<TenderType> | null;
      canParentUpdate: boolean | null;
      billedOn: any;
      refundableAmountCredits: number | null;
      rescheduleRequests: Array<{
        __typename: "MeetingRequest";
        uid: string;
        created_at: any;
        expires_at: any;
        start_time: any;
        end_time: any;
        status: MeetingRequestStatus;
        message: string | null;
        is_recurring: boolean;
      }>;
      recurringSchedule: {
        __typename?: "RecurringSchedule";
        uid: string;
        end_at: any | null;
      } | null;
    }>;
    pendingOneOnOneMeetings: Array<{
      __typename?: "EnrollmentMeetingPurchase";
      startTime: any;
      endTime: any;
      uid: string;
      activityUid: string | null;
      enrollmentUid: string | null;
      meetingUid: string | null;
      orderSlugId: string;
      confirmedAt: any | null;
    }> | null;
    meetingRequests: Array<{
      __typename: "MeetingRequest";
      uid: string;
      created_at: any;
      start_time: any;
      end_time: any;
      expires_at: any;
      status: MeetingRequestStatus;
      is_recurring: boolean;
    }>;
    currentUserGiftEnrollments: Array<{
      __typename?: "GiftEnrollment";
      thisWeekPauseDeadline: any | null;
      uid: string;
      giftClaimedAt: any | null;
      createdAt: any;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      withdrawn_at: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      hasPaymentSchedule: boolean;
      isEnded: boolean;
      isPaused: boolean;
      orderSlugId: string | null;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      priceCents: number | null;
      currentUserIsPurchaser: boolean;
      refundableAmountCents: number;
      cancellationType: EnrollmentCancellationType | null;
      isWithdrawn: boolean;
      payments: Array<{
        __typename?: "EnrollmentPayment";
        unrefundedCredits: number | null;
        uid: string;
        amount_cents: number | null;
        order_slug_id: string | null;
        stripe_charge_id: string | null;
        purchase_order_id: string | null;
        esa_order_id: string | null;
        intercom_url: string | null;
        last4: string | null;
        created_at: any | null;
        paid_at: any | null;
        disbursed_at: any | null;
        payout_uid: string | null;
        start_time: any | null;
        end_time: any | null;
        unrefundedCents: number;
        isOngoingRefundable: boolean;
        voucher_name: string | null;
        pricing_offer_uid: string | null;
        credit_transaction_uid: string | null;
        credit_account_type: string | null;
        coupon_code_uid: string | null;
        currency_code: CurrencyCode | null;
        exchange_rate: number | null;
        invoice_uid: string | null;
        funding_program_invoice_uid: string | null;
        service_fee_percentage: number | null;
        couponCode: {
          __typename?: "CouponCode";
          code: string;
          coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
        } | null;
        pricingOffer: {
          __typename?: "PricingOffer";
          name: string;
          buyerOrgName: string | null;
          isFinancialAid: boolean;
        } | null;
      }>;
      refundPolicy: {
        __typename?: "RefundPolicy";
        creditDescription: string | null;
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
      upcomingPausedMeeting: { __typename?: "Meeting"; start_time: any } | null;
    }>;
    currentUserEnrollments: Array<{
      __typename?: "Enrollment";
      thisWeekPauseDeadline: any | null;
      uid: string;
      section_uid: string | null;
      price_cents: number | null;
      priceCents: number | null;
      created_at: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      withdrawnAt: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      isPrepay: boolean;
      hasCompletedLesson: boolean;
      hasPostedComment: boolean;
      refundableAmountCents: number;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      usersCanCommunicate: boolean;
      purchasedAsGift: boolean;
      cancellationType: EnrollmentCancellationType | null;
      isWithdrawn: boolean;
      payments: Array<{
        __typename?: "EnrollmentPayment";
        unrefundedCredits: number | null;
        uid: string;
        amount_cents: number | null;
        order_slug_id: string | null;
        stripe_charge_id: string | null;
        purchase_order_id: string | null;
        esa_order_id: string | null;
        intercom_url: string | null;
        last4: string | null;
        created_at: any | null;
        paid_at: any | null;
        disbursed_at: any | null;
        payout_uid: string | null;
        start_time: any | null;
        end_time: any | null;
        unrefundedCents: number;
        isOngoingRefundable: boolean;
        voucher_name: string | null;
        pricing_offer_uid: string | null;
        credit_transaction_uid: string | null;
        credit_account_type: string | null;
        coupon_code_uid: string | null;
        currency_code: CurrencyCode | null;
        exchange_rate: number | null;
        invoice_uid: string | null;
        funding_program_invoice_uid: string | null;
        service_fee_percentage: number | null;
        couponCode: {
          __typename?: "CouponCode";
          code: string;
          coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
        } | null;
        pricingOffer: {
          __typename?: "PricingOffer";
          name: string;
          buyerOrgName: string | null;
          isFinancialAid: boolean;
        } | null;
      }>;
      refundPolicy: {
        __typename?: "RefundPolicy";
        creditDescription: string | null;
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      siblings: Array<{
        __typename?: "Sibling";
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
        };
        currentOrLastSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          uid: string;
          activity_uid: string;
          start_time: any | null;
          end_time: any | null;
          teacher_support_start_time: any | null;
          startsAtNight: boolean | null;
          is_cross_listed: boolean;
          size_max: number | null;
          size_min: number | null;
          isPublished: boolean | null;
          price_cents: number | null;
          priceCredits: number | null;
          published_at: any | null;
          updated_at: any;
          canceled_at: any | null;
          deleted_at: any | null;
          ongoing_stopped_at: any | null;
          duration_minutes: number | null;
          usesOutschoolVideoChat: boolean;
          usersCanSendPrivateMessage: boolean;
          currentUserCanManage: boolean;
          isBuyable: boolean;
          allowsTeacherTransfer: boolean;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            deleted_at: any | null;
            created_at: any | null;
          } | null;
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          details: {
            __typename?: "SectionDetails";
            autoScheduledDraft: boolean | null;
          };
          prepaidOngoingPeriodOptions: Array<{
            __typename?: "Period";
            startOfIsoWeek: any;
            endOfIsoWeek: any;
          }> | null;
        };
      }>;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
        scheduleType: PaymentScheduleTypes;
        amountCents: number | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
      upcomingPausedMeeting: { __typename?: "Meeting"; start_time: any } | null;
    }>;
    enrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      price_cents: number | null;
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      section: {
        __typename?: "Section";
        uid: string;
        leader: {
          __typename?: "Leader";
          uid: string;
          teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        };
      } | null;
    }>;
    activity: {
      __typename?: "Activity";
      allowWaitlist: boolean | null;
      upsell_activity_uid: string | null;
      archived_at: any | null;
      requested_listing_at: any | null;
      hasTeacherSchedule: boolean;
      isIncludedWithMembership: boolean;
      is_ongoing_weekly: boolean;
      uid: string;
      assessment: string | null;
      class_experience: string | null;
      has_external_resources: boolean | null;
      homework: string | null;
      learning_goals: string | null;
      materials: string | null;
      parental_guidance: string | null;
      sources: string | null;
      title: string;
      titleTranslated: string | null;
      weekly_meetings: number | null;
      welcomeAttachmentCount: number | null;
      why_me: string | null;
      duration_minutes: number | null;
      suggestedWeeklyMeetings: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      slug_id: string;
      summary: string | null;
      age_min: number | null;
      age_max: number | null;
      published_at: any | null;
      price_cents: number | null;
      averageStarRating: number | null;
      reviewCount: number;
      isClub: boolean;
      esaStatus: EsaStatus;
      duration_weeks: number | null;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      size_max: number | null;
      allows_recurring_payment: boolean | null;
      approvalStatus: {
        __typename?: "ActivityApprovalStatus";
        action: string;
        message_to_teacher: string | null;
      } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        created_at: any | null;
        photo: string | null;
        suspended_at: any | null;
        cityState: string | null;
        socialOptOut: boolean;
        is_crosslister: boolean | null;
        timeZone: string | null;
        hasAvailabilitySet: boolean;
        approved: boolean;
        hasBackgroundCheckExpired: boolean | null;
        reviewCount: number;
        averageActivityStarRating: number | null;
        hasListings: boolean;
        details: {
          __typename?: "LeaderDetails";
          about: string | null;
          headline: string | null;
          headlineTranslated: string | null;
          countryOfResidence: string | null;
        };
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: {
          __typename?: "SellerOrg";
          uid: string;
          name: string;
        } | null;
      };
      attributes: Array<{
        __typename?: "EntityAttribute";
        key: string;
        value: string;
        entity_type: string;
        source: string | null;
      }>;
      externalResources: Array<{
        __typename?: "ExternalResource";
        uid: string;
        name: string;
      }>;
      details: { __typename?: "ActivityDetails"; asyncTime: string | null };
      clubGuidelines: {
        __typename?: "WelcomeMessage";
        text: string | null;
      } | null;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
        creditDescription: string | null;
      };
      enrollableTimes: Array<{
        __typename?: "EnrollableTime";
        startTime: any;
        endTime: any;
        teacher: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          hasBackgroundCheckExpired: boolean | null;
          teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        };
      }>;
    };
    currentUserPublicReview: {
      __typename?: "PublicReview";
      uid: string;
      section_uid: string;
      currentUserCanEdit: boolean;
      currentUserCanRespond: boolean;
      activity_star_rating: number | null;
      currentUserMarkedHelpful: boolean | null;
      markedHelpfulCount: number;
      created_at: any;
      teacher_response: string | null;
      teacher_responded_at: any | null;
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      details: {
        __typename?: "PublicReviewDetails";
        publicReview: string | null;
      } | null;
      activity: {
        __typename?: "Activity";
        uid: string;
        isClub: boolean;
        slug_id: string;
        title: string;
        user_uid: string;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          leader_link: string | null;
          photo: string | null;
        };
      } | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      leader_link: string | null;
      timeZone: string | null;
      details: { __typename?: "LeaderDetails"; headline: string | null };
    };
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
    }>;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
    } | null;
  } | null;
};

export type UserWithGiftCardsQueryVariables = Exact<{
  uid: Scalars["String"];
}>;

export type UserWithGiftCardsQuery = {
  __typename?: "Query";
  user: {
    __typename?: "User";
    name: string | null;
    giftCardsPurchased: Array<{
      __typename?: "GiftCard";
      uid: string;
      createdAt: any;
      orderSlugId: string;
      amountCents: number;
      note: string | null;
      recipientName: string;
      recipientEmail: string;
      purchaserName: string;
      purchaserEmail: string;
      confirmedAt: any | null;
      redeemedAt: any | null;
      deliveredAt: any | null;
      deletedAt: any | null;
      redemptionCode: string | null;
      deliverAfter: any;
      deliveryTimezone: string;
      status: GiftCardStatus;
      isCancelable: boolean;
      isEditable: boolean;
    }>;
  } | null;
};

export type FeaturedTeachersQueryVariables = Exact<{ [key: string]: never }>;

export type FeaturedTeachersQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    popularTeachers: Array<{
      __typename?: "Leader";
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      reviewCount: number;
      averageActivityStarRating: number | null;
      hasListings: boolean;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    }> | null;
  };
};

export type LearnerVerificationQueryVariables = Exact<{
  start?: InputMaybe<Scalars["DateTime"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
}>;

export type LearnerVerificationQuery = {
  __typename?: "Query";
  unverifiedClubEnrollments: Array<{
    __typename?: "Enrollment";
    uid: string;
    createdAt: any;
    recordingForClubsVerificationFlaggedAt: any | null;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      recentAttendances: Array<{
        __typename?: "Attendance";
        uid: string;
      } | null>;
    } | null;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      learners_verified_at: any | null;
    };
    section: {
      __typename?: "Section";
      uid: string;
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        titleTranslated: string | null;
      };
    } | null;
    clubVerificationVideo: {
      __typename?: "Attachment";
      uid: string;
      created_at: any;
      file: { __typename?: "File"; url: string; thumbUrl: string | null };
    } | null;
  }>;
};

export type ApproveClubIntroductionMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
}>;

export type ApproveClubIntroductionMutation = {
  __typename?: "Mutation";
  approveClubIntroduction: boolean;
};

export type RejectClubIntroductionMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
}>;

export type RejectClubIntroductionMutation = {
  __typename?: "Mutation";
  rejectClubIntroduction: boolean;
};

export type FlagClubIntroductionMutationVariables = Exact<{
  enrollmentUid: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
}>;

export type FlagClubIntroductionMutation = {
  __typename?: "Mutation";
  flagClubIntroduction: boolean;
};

export type CreateSetupIntentMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreateSetupIntentMutation = {
  __typename?: "Mutation";
  createSetupIntent: {
    __typename?: "SetupIntent";
    setupIntentClientId: string;
  };
};

export type RecordPaymentMethodForSubscriptionV2MutationVariables = Exact<{
  paymentMethodId: Scalars["String"];
  stripeCouponId?: InputMaybe<Scalars["String"]>;
}>;

export type RecordPaymentMethodForSubscriptionV2Mutation = {
  __typename?: "Mutation";
  recordPaymentMethodForSubscriptionV2: {
    __typename?: "RecordPaymentMethodResult";
    canUseStoredCredit: boolean;
    canUseStripeCoupon: boolean;
  };
};

export type UpdateBillingAddressMutationVariables = Exact<{
  addressInfo?: InputMaybe<StripeAddressInput>;
}>;

export type UpdateBillingAddressMutation = {
  __typename?: "Mutation";
  updateBillingAddress: {
    __typename?: "User";
    uid: string;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  };
};

export type CreateStripeSubscriptionMutationVariables = Exact<{
  packageUid: Scalars["ID"];
  paymentMethodId?: InputMaybe<Scalars["String"]>;
  paymentBehavior?: InputMaybe<PaymentBehavior>;
  promoCode?: InputMaybe<Scalars["String"]>;
  termsOfServiceAcceptance: Scalars["Boolean"];
  pricingOffer?: InputMaybe<PricingOfferInput>;
  creditAccountCents?: InputMaybe<Scalars["Int"]>;
}>;

export type CreateStripeSubscriptionMutation = {
  __typename?: "Mutation";
  createStripeSubscription: {
    __typename?: "CreateStripeSubscriptionResult";
    stripeSubscriptionId: string;
    termsOfServiceAcceptance: boolean;
    paymentIntentClientSecret: string | null;
  };
};

export type StripeSubscriptionInvoicePreviewQueryVariables = Exact<{
  packageUid: Scalars["ID"];
  promoCode?: InputMaybe<Scalars["String"]>;
}>;

export type StripeSubscriptionInvoicePreviewQuery = {
  __typename?: "Query";
  stripeSubscriptionInvoicePreview: {
    __typename?: "StripeSubscriptionInvoicePreviewResult";
    invoice: {
      __typename?: "StripeSubscriptionInvoice";
      subtotal: number;
      total: number;
      amountDue: number;
      totalDiscountAmounts: Array<{
        __typename?: "StripeInvoiceTotalDiscountAmount";
        amount: number;
        discount: string;
      } | null>;
      discount: {
        __typename?: "StripeInvoiceDiscount";
        id: string;
        coupon: {
          __typename?: "StripeDiscountCoupon";
          id: string;
          amountOff: number | null;
          percentOff: number | null;
        };
      } | null;
    };
    appliedCoupon: {
      __typename?: "StripeCouponValidity";
      id: string | null;
      promoCode: string | null;
      isValid: boolean;
      errorMessage: string | null;
    } | null;
  };
};

export type SubscriptionPricingBreakdownQueryVariables = Exact<{
  packageUid: Scalars["ID"];
  promoCode?: InputMaybe<Scalars["String"]>;
}>;

export type SubscriptionPricingBreakdownQuery = {
  __typename?: "Query";
  subscriptionPricingBreakdown: {
    __typename?: "SubscriptionPricingBreakdownResult";
    breakdown: {
      __typename?: "SubscriptionPricingBreakdown";
      totalCents: number;
      subtotalCents: number;
      taxCents: number;
      taxCalculationId: string | null;
      pricingOfferCents: number;
      creditAccountCents: number;
      couponCents: number;
      stripeCents: number;
      canUseCreditAccount: boolean;
      canUsePricingOffer: boolean;
      canUseOtherFunds: boolean;
      pricingOffer: {
        __typename?: "PricingOffer";
        uid: string;
        buyerOrgName: string | null;
        remainingCapCents: number | null;
      } | null;
    };
    appliedCoupon: {
      __typename?: "StripeCouponValidity";
      id: string | null;
      promoCode: string | null;
      isValid: boolean;
      errorMessage: string | null;
      coupon: {
        __typename?: "StripeDiscountCoupon";
        id: string;
        discountType: StripeDiscountType;
        amountOff: number | null;
        percentOff: number | null;
        durationMonths: number | null;
      } | null;
    } | null;
  };
};

export type OutreachCouponQueryVariables = Exact<{ [key: string]: never }>;

export type OutreachCouponQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    outreachCouponCode: string | null;
  } | null;
};

export type OutreachTeacherCouponQueryVariables = Exact<{
  [key: string]: never;
}>;

export type OutreachTeacherCouponQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    teacherOutreachCouponCode: string | null;
  } | null;
};

export type MembershipEnrollmentQueryVariables = Exact<{
  slugId: Scalars["String"];
}>;

export type MembershipEnrollmentQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    titleTranslated: string | null;
    weekly_meetings: number | null;
    duration_weeks: number | null;
    is_ongoing_weekly: boolean;
    isClub: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    published_at: any | null;
    hasTeacherSchedule: boolean;
    size_max: number | null;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  };
};

export type ListByFirstListedAtQueryVariables = Exact<{
  startAtDate: Scalars["Date"];
  endAtDate: Scalars["Date"];
}>;

export type ListByFirstListedAtQuery = {
  __typename?: "Query";
  listByFirstListedAt: Array<{
    __typename?: "Activity";
    uid: string;
    title: string;
    slug_id: string;
    isClub: boolean;
  }>;
};

export type OnboardTeachersPage_UserFragment = {
  __typename?: "User";
  uid: string;
  name: string | null;
  adminActions: Array<{
    __typename?: "AdminUserAction";
    uid: string;
    created_at: any;
    action: string;
    notes: string | null;
    customValue: string | null;
    admin: { __typename?: "User"; uid: string; name: string | null };
  }>;
  latestTeacherApplication: {
    __typename?: "TeacherApplication";
    uid: string;
    legal_name: string | null;
    status: TeacherApplicationStatus;
    submitted_at: any | null;
    reviewed_at: any | null;
    teaching_experience: string | null;
    teaching_credentials: string | null;
    class_types: string | null;
    online_profiles: string | null;
    sample_classes: string | null;
    class_subjects: Array<string | null> | null;
    age_ranges_taught: Array<string | null> | null;
    years_of_experience: string | null;
    how_did_you_hear_about_us: string | null;
    experience_types: Array<string | null> | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  } | null;
};

export type OnboardTeachersPageQueryQueryVariables = Exact<{
  uid: Scalars["String"];
}>;

export type OnboardTeachersPageQueryQuery = {
  __typename?: "Query";
  user: {
    __typename?: "User";
    uid: string;
    name: string | null;
    adminActions: Array<{
      __typename?: "AdminUserAction";
      uid: string;
      created_at: any;
      action: string;
      notes: string | null;
      customValue: string | null;
      admin: { __typename?: "User"; uid: string; name: string | null };
    }>;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
  } | null;
};

export type OnboardTeachersAddAdminUserActionMutationVariables = Exact<{
  userUid: Scalars["ID"];
  action: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
}>;

export type OnboardTeachersAddAdminUserActionMutation = {
  __typename?: "Mutation";
  addAdminUserAction: {
    __typename?: "AdminUserAction";
    uid: string;
    created_at: any;
    action: string;
    notes: string | null;
    customValue: string | null;
    admin: { __typename?: "User"; uid: string; name: string | null };
    user: {
      __typename?: "User";
      uid: string;
      name: string | null;
      adminActions: Array<{
        __typename?: "AdminUserAction";
        uid: string;
        created_at: any;
        action: string;
        notes: string | null;
        customValue: string | null;
        admin: { __typename?: "User"; uid: string; name: string | null };
      }>;
      latestTeacherApplication: {
        __typename?: "TeacherApplication";
        uid: string;
        legal_name: string | null;
        status: TeacherApplicationStatus;
        submitted_at: any | null;
        reviewed_at: any | null;
        teaching_experience: string | null;
        teaching_credentials: string | null;
        class_types: string | null;
        online_profiles: string | null;
        sample_classes: string | null;
        class_subjects: Array<string | null> | null;
        age_ranges_taught: Array<string | null> | null;
        years_of_experience: string | null;
        how_did_you_hear_about_us: string | null;
        experience_types: Array<string | null> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      } | null;
    };
  };
};

export type ParentProfileQueryVariables = Exact<{
  uid?: InputMaybe<Scalars["ID"]>;
}>;

export type ParentProfileQuery = {
  __typename?: "Query";
  publicProfile: {
    __typename?: "PublicProfile";
    parent: {
      __typename?: "Parent";
      slug_id: string | null;
      reviewCount: number;
      uniqueActivityCount: number;
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
      sectionsWithCurrentUser: Array<{
        __typename?: "Section";
        filledSpaceCount: number;
        uid: string;
        activity_uid: string;
        start_time: any | null;
        end_time: any | null;
        teacher_support_start_time: any | null;
        startsAtNight: boolean | null;
        is_cross_listed: boolean;
        size_max: number | null;
        size_min: number | null;
        isPublished: boolean | null;
        price_cents: number | null;
        priceCredits: number | null;
        published_at: any | null;
        updated_at: any;
        canceled_at: any | null;
        deleted_at: any | null;
        ongoing_stopped_at: any | null;
        duration_minutes: number | null;
        usesOutschoolVideoChat: boolean;
        usersCanSendPrivateMessage: boolean;
        currentUserCanManage: boolean;
        isBuyable: boolean;
        allowsTeacherTransfer: boolean;
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        }>;
        activity: {
          __typename?: "Activity";
          uid: string;
          slug_id: string;
          user_uid: string;
          title: string;
          titleTranslated: string | null;
          url: string;
          path: string;
          class_experience: string | null;
          learning_goals: string | null;
          learningGoals: Array<string>;
          assessment: string | null;
          homework: string | null;
          grading_policy: string | null;
          prerequisites: string | null;
          published_at: any | null;
          is_online: boolean;
          age_min: number | null;
          age_max: number | null;
          english_proficiency_level: EnglishProficiencyLevel | null;
          grade_level_min: string | null;
          grade_level_max: string | null;
          size_min: number | null;
          size_max: number | null;
          duration_minutes: number | null;
          duration_weeks: number | null;
          weekly_meetings: number | null;
          price_cents: number | null;
          priceCredits: number | null;
          summary: string | null;
          summaryTranslated: string | null;
          is_ongoing_weekly: boolean;
          subject: string | null;
          languageOfInstruction: any | null;
          summaryForLearners: string | null;
          allowWaitlist: boolean | null;
          isClub: boolean;
          isAutoSchedulingEnabled: boolean | null;
          autoSchedulingDaysNoticeMin: number | null;
          autoSchedulingDaysNoticeMax: number | null;
          allows_recurring_payment: boolean | null;
          allows_late_enrollments_for_fixed_length_classes: boolean;
          allowsFutureOngoingEnrollments: boolean;
          has_building_content: boolean | null;
          hasTeacherSchedule: boolean;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          isOneTime: boolean;
          classFormat: EducatorSelectedFormat;
          classroomType: ClassroomType;
          isIncludedWithMembership: boolean;
          strictAgeRange: {
            __typename?: "AgeRangeType";
            min: number;
            max: number;
          } | null;
          proficiency_level: {
            __typename?: "ProficiencyLevel";
            level: Array<string | null> | null;
            text: string | null;
          } | null;
          refundPolicy: {
            __typename?: "RefundPolicy";
            name: string;
            description: string;
            type: RefundPolicyType;
          };
          photo: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
          photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
        };
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          leader_link: string | null;
          created_at: any | null;
          photo: string | null;
          suspended_at: any | null;
          cityState: string | null;
          socialOptOut: boolean;
          is_crosslister: boolean | null;
          timeZone: string | null;
          hasAvailabilitySet: boolean;
          approved: boolean;
          hasBackgroundCheckExpired: boolean | null;
          reviewCount: number;
          averageActivityStarRating: number | null;
          hasListings: boolean;
          details: {
            __typename?: "LeaderDetails";
            about: string | null;
            headline: string | null;
            headlineTranslated: string | null;
            countryOfResidence: string | null;
          };
          ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
          teacherForSellerOrg: {
            __typename?: "SellerOrg";
            uid: string;
            name: string;
          } | null;
        };
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
          deleted_at: any | null;
          created_at: any | null;
        } | null;
        details: {
          __typename?: "SectionDetails";
          autoScheduledDraft: boolean | null;
        };
        prepaidOngoingPeriodOptions: Array<{
          __typename?: "Period";
          startOfIsoWeek: any;
          endOfIsoWeek: any;
        }> | null;
      }>;
    } | null;
  } | null;
};

export type PostPurchasePageRecommendationsQueryVariables = Exact<{
  skipRating: Scalars["Boolean"];
  withRecentReviews: Scalars["Boolean"];
}>;

export type PostPurchasePageRecommendationsQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    personalizedRecommendations: Array<{
      __typename?: "Listing";
      insertionId: string | null;
      sectionCount: number;
      openSectionCount: number;
      upcomingSectionCount: number;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        averageActivityStarRating: number | null;
        reviewCount: number;
        educatorTiers: Array<EducatorTier>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
            fileSize: number | null;
          };
        } | null;
        credentials: Array<{
          __typename?: "TeacherCredential";
          uid: string;
          degreeType: DegreeType | null;
          degreeSubject: DegreeSubject | null;
        }>;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      };
      activity: {
        __typename?: "Activity";
        uid: string;
        isIncludedWithMembership: boolean;
        averageStarRating?: number | null;
        reviewCount: number;
        age_min: number | null;
        age_max: number | null;
        duration_minutes: number | null;
        duration_weeks: number | null;
        weekly_meetings: number | null;
        price_cents: number | null;
        priceCreditsPerMeeting: number | null;
        quickSummary: string | null;
        isClub: boolean;
        isFlexSchedule: boolean;
        isSelfPaced: boolean;
        isOneTime: boolean;
        hasTeacherSchedule: boolean;
        size_max: number | null;
        user_uid: string;
        slug_id: string;
        title: string;
        titleTranslated: string | null;
        url: string;
        path: string;
        summary: string | null;
        summaryTranslated: string | null;
        is_ongoing_weekly: boolean;
        subject: string | null;
        recentReviews?: Array<{
          __typename?: "PublicReview";
          uid: string;
          activity_star_rating: number | null;
          details: {
            __typename?: "PublicReviewDetails";
            publicReview: string | null;
          } | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            publicName: string | null;
          };
        }>;
        clubSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          clubPostCount: number;
        } | null;
        syllabus: {
          __typename?: "Syllabus";
          uid: string;
          lessons: Array<{ __typename?: "Lesson"; uid: string }>;
        } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
        } | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        savedClassLists: Array<{
          __typename?: "SavedClassList";
          uid: string;
          lastAddedToAt: any | null;
        }>;
      };
      nextSection: {
        __typename?: "Section";
        uid: string;
        size_max: number | null;
        filledSpaceCount: number;
        start_time: any | null;
        end_time: any | null;
        nextOngoingMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
          end_time: any;
        } | null;
      } | null;
    }>;
  };
};

export type PrivateClassMessagesPageQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
  hasLearner: Scalars["Boolean"];
}>;

export type PrivateClassMessagesPageQuery = {
  __typename?: "Query";
  learner?: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    isVerified: boolean;
    isBlocked: boolean | null;
    blockedByUserUid: string | null;
    blockedAt: any | null;
  } | null;
  section: {
    __typename?: "Section";
    filledSpaceCount: number;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    currentUserEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      section_uid: string | null;
      price_cents: number | null;
      priceCents: number | null;
      created_at: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      withdrawnAt: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      isPaused: boolean;
      isEnded: boolean;
      isPrepay: boolean;
      hasCompletedLesson: boolean;
      hasPostedComment: boolean;
      refundableAmountCents: number;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      usersCanCommunicate: boolean;
      purchasedAsGift: boolean;
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      siblings: Array<{
        __typename?: "Sibling";
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
        };
        currentOrLastSection: {
          __typename?: "Section";
          filledSpaceCount: number;
          uid: string;
          activity_uid: string;
          start_time: any | null;
          end_time: any | null;
          teacher_support_start_time: any | null;
          startsAtNight: boolean | null;
          is_cross_listed: boolean;
          size_max: number | null;
          size_min: number | null;
          isPublished: boolean | null;
          price_cents: number | null;
          priceCredits: number | null;
          published_at: any | null;
          updated_at: any;
          canceled_at: any | null;
          deleted_at: any | null;
          ongoing_stopped_at: any | null;
          duration_minutes: number | null;
          usesOutschoolVideoChat: boolean;
          usersCanSendPrivateMessage: boolean;
          currentUserCanManage: boolean;
          isBuyable: boolean;
          allowsTeacherTransfer: boolean;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            deleted_at: any | null;
            created_at: any | null;
          } | null;
          leader: { __typename?: "Leader"; uid: string; name: string | null };
          details: {
            __typename?: "SectionDetails";
            autoScheduledDraft: boolean | null;
          };
          prepaidOngoingPeriodOptions: Array<{
            __typename?: "Period";
            startOfIsoWeek: any;
            endOfIsoWeek: any;
          }> | null;
        };
      }>;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
        scheduleType: PaymentScheduleTypes;
        amountCents: number | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
    }>;
    activity: {
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        created_at: any | null;
        photo: string | null;
        suspended_at: any | null;
        cityState: string | null;
        socialOptOut: boolean;
        is_crosslister: boolean | null;
        timeZone: string | null;
        hasAvailabilitySet: boolean;
        approved: boolean;
        hasBackgroundCheckExpired: boolean | null;
        reviewCount: number;
        averageActivityStarRating: number | null;
        hasListings: boolean;
        details: {
          __typename?: "LeaderDetails";
          about: string | null;
          headline: string | null;
          headlineTranslated: string | null;
          countryOfResidence: string | null;
        };
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: {
          __typename?: "SellerOrg";
          uid: string;
          name: string;
        } | null;
      };
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
  } | null;
};

export type CurrentUserLearnerUidQueryVariables = Exact<{
  enrollmentUid: Scalars["String"];
}>;

export type CurrentUserLearnerUidQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    enrollment: {
      __typename?: "Enrollment";
      uid: string;
      learner: { __typename?: "Learner"; uid: string } | null;
    };
  } | null;
};

export type CreateReviewMutationVariables = Exact<{
  feedbackInput: FeedbackInput;
}>;

export type CreateReviewMutation = {
  __typename?: "Mutation";
  createOrUpdateFeedback: { __typename?: "Feedback"; uid: string };
};

export type ReviewSectionQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type ReviewSectionQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      slug_id: string;
      isClub: boolean;
    };
    currentUserFeedback: {
      __typename?: "Feedback";
      uid: string;
      publicReview: string | null;
      activity_star_rating: number | null;
      leaderFeedback: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        conversionStatus: string | null;
        file: { __typename?: "File"; filename: string; url: string };
      }>;
    } | null;
  } | null;
};

export type ReviewTeacherPageQueryVariables = Exact<{
  uid: Scalars["String"];
}>;

export type ReviewTeacherPageQuery = {
  __typename?: "Query";
  user: {
    __typename?: "User";
    uid: string;
    teacher_approved_at: any | null;
    teacher_featured_at: any | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    location: { __typename?: "Location"; address: string | null } | null;
    details: { __typename?: "UserDetails"; browserTimeZone: string | null };
    adminActions: Array<{
      __typename?: "AdminUserAction";
      uid: string;
      created_at: any;
      action: string;
      notes: string | null;
      customValue: string | null;
      admin: { __typename?: "User"; uid: string; name: string | null };
    }>;
    leaderActivities: Array<{
      __typename?: "Activity";
      uid: string;
      title: string;
    }>;
    approvalCriteria: Array<{
      __typename?: "ApprovalCriterion";
      description: string;
      value: ApprovalCriterionValue;
    }>;
    leader: {
      __typename?: "Leader";
      uid: string;
      leader_link: string | null;
      name: string | null;
      photo: string | null;
      reviewCount: number;
      successfulClassCount: number;
      video: {
        __typename?: "Attachment";
        file: { __typename?: "File"; url: string; thumbUrl: string | null };
      } | null;
      details: {
        __typename?: "LeaderDetails";
        headline: string | null;
        about: string | null;
      };
      tags: {
        __typename?: "TeacherTagsConnection";
        edges: Array<{
          __typename?: "TeacherTagEdge";
          node: { __typename?: "Tag"; uid: string; key: string; value: string };
        }>;
      };
    } | null;
  } | null;
};

export type NextTeacherToReviewQueryVariables = Exact<{ [key: string]: never }>;

export type NextTeacherToReviewQuery = {
  __typename?: "Query";
  nextTeacherToReview: { __typename?: "User"; uid: string } | null;
};

export type AddAdminUserActionReviewTeacherMutationVariables = Exact<{
  userUid: Scalars["ID"];
  action: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
}>;

export type AddAdminUserActionReviewTeacherMutation = {
  __typename?: "Mutation";
  addAdminUserAction: {
    __typename?: "AdminUserAction";
    uid: string;
    created_at: any;
    action: string;
    notes: string | null;
    customValue: string | null;
  };
};

export type SectionAdminQueryQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  enrollmentsLimit?: InputMaybe<Scalars["Int"]>;
  enrollmentsOffset?: InputMaybe<Scalars["Int"]>;
  meetingsLimit?: InputMaybe<Scalars["Int"]>;
  meetingsOffset?: InputMaybe<Scalars["Int"]>;
  meetingsSortOrder?: InputMaybe<SortOrder>;
  meetingsStartBefore?: InputMaybe<Scalars["DateTime"]>;
}>;

export type SectionAdminQueryQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    filledSpaceCount: number;
    uid: string;
    start_time: any | null;
    end_time: any | null;
    activity_uid: string;
    teacher_support_start_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    priceCredits: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    created_at: any;
    validEnrollmentCount: number;
    isAutoCanceled: boolean;
    currentUserIsOwner: boolean;
    paidAmount: number | null;
    notes: string | null;
    standardPayoutCents: number;
    is_self_paced: boolean;
    leader: {
      __typename?: "Leader";
      name: string | null;
      uid: string;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      reviewCount: number;
      averageActivityStarRating: number | null;
      hasListings: boolean;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    };
    activity: {
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      subject: string | null;
      title: string;
      titleTranslated: string | null;
      price_cents: number | null;
      isClub: boolean;
      duration_weeks: number | null;
      is_ongoing_weekly: boolean;
      weekly_meetings: number | null;
      user_uid: string;
      url: string;
      path: string;
      class_experience: string | null;
      learning_goals: string | null;
      learningGoals: Array<string>;
      assessment: string | null;
      homework: string | null;
      grading_policy: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      english_proficiency_level: EnglishProficiencyLevel | null;
      grade_level_min: string | null;
      grade_level_max: string | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      priceCredits: number | null;
      summary: string | null;
      summaryTranslated: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      allowWaitlist: boolean | null;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      allows_recurring_payment: boolean | null;
      allows_late_enrollments_for_fixed_length_classes: boolean;
      allowsFutureOngoingEnrollments: boolean;
      has_building_content: boolean | null;
      hasTeacherSchedule: boolean;
      isFlexSchedule: boolean;
      isSelfPaced: boolean;
      isOneTime: boolean;
      classFormat: EducatorSelectedFormat;
      classroomType: ClassroomType;
      isIncludedWithMembership: boolean;
      saveCount: number | null;
      archived_at: any | null;
      upsell_activity_uid: string | null;
      why_me: string | null;
      parental_guidance: string | null;
      sources: string | null;
      materials: string | null;
      hasSections: boolean;
      has_external_resources: boolean | null;
      photo: {
        __typename?: "Attachment";
        fileUrl: string;
        uid: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      strictAgeRange: {
        __typename?: "AgeRangeType";
        min: number;
        max: number;
      } | null;
      proficiency_level: {
        __typename?: "ProficiencyLevel";
        level: Array<string | null> | null;
        text: string | null;
      } | null;
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
        type: RefundPolicyType;
      };
      photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
      details: { __typename?: "ActivityDetails"; asyncTime: string | null };
      leaderDetails: {
        __typename?: "ActivityLeaderDetails";
        uid: string;
        requestedListingAt: any | null;
        welcomeMessage: {
          __typename?: "WelcomeMessage";
          text: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
            };
          }> | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
            };
          } | null;
        } | null;
      };
      externalResources: Array<{
        __typename?: "ExternalResource";
        uid: string;
        name: string;
        url: string | null;
      }>;
    };
    feedbacks: Array<{
      __typename?: "FeedbackForLeader";
      uid: string;
      activity_star_rating: number | null;
      created_at: any;
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        email: string | null;
        photo: string | null;
        timeZone: string | null;
      };
      details: {
        __typename?: "FeedbackForLeaderDetails";
        leaderFeedback: string | null;
      };
    }>;
    messages: Array<{
      __typename?: "Message";
      uid: string;
      subject: string | null;
      action: string | null;
      content: string | null;
      created_at: any;
      activity_uid: string | null;
      section_uid: string | null;
      thread_uid: string;
      sender: {
        __typename?: "Sender";
        uid: string;
        name: string | null;
        photo: string | null;
      };
      participants: Array<{
        __typename?: "Participant";
        uid: string;
        name: string | null;
        photo: string | null;
        timeZone: string | null;
        headline: string | null;
        leader_link: string | null;
        isLearner: boolean;
        role: ParticipantRole | null;
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      }>;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      } | null;
    }>;
    pendingOneOnOneMeetingOrdersForAdmin: Array<{
      __typename?: "EnrollmentMeetingPurchaseInfoForOrderSlug";
      confirmedAt: any | null;
      createdAt: any;
      orderSlugId: string;
      startTime: any;
      endTime: any;
      weeks: number;
    }>;
    enrollments: {
      __typename?: "EnrollmentsForAdmin";
      total: number;
      data: Array<{
        __typename?: "Enrollment";
        refundableAmountCents: number;
        uid: string;
        ongoingStartTime: any | null;
        ongoing_start_time: any | null;
        ongoingEndTime: any | null;
        ongoing_end_time: any | null;
        ongoingStoppedAt: any | null;
        ongoing_stopped_at: any | null;
        orderSlugId: string | null;
        isEnded: boolean;
        isPaused: boolean;
        isPrepay: boolean;
        created_at: any | null;
        createdAt: any;
        withdrawn_at: any | null;
        withdrawnAt: any | null;
        confirmed_at: any | null;
        confirmedAt: any | null;
        currency_code: CurrencyCode;
        exchange_rate: number;
        hasPaymentSchedule: boolean;
        isPendingEsaOrder: boolean;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
        } | null;
        parent: {
          __typename?: "Parent";
          uid: string;
          name: string | null;
          email: string | null;
          photo: string | null;
          timeZone: string | null;
        };
        payments: Array<{
          __typename?: "EnrollmentPayment";
          uid: string;
          paid_at: any | null;
          purchase_order_id: string | null;
          esa_order_id: string | null;
          amount_cents: number | null;
          amount_credits: number | null;
          order_slug_id: string | null;
          intercom_url: string | null;
          disbursed_at: any | null;
          payout_uid: string | null;
          start_time: any | null;
          end_time: any | null;
          unrefundedCents: number;
          unrefundedCredits: number | null;
          voucher_name: string | null;
          last4: string | null;
          stripe_charge_id: string | null;
          credit_transaction_uid: string | null;
          credit_account_type: string | null;
          coupon_code_uid: string | null;
          pricing_offer_uid: string | null;
          invoice_uid: string | null;
          currency_code: CurrencyCode | null;
          exchange_rate: number | null;
          funding_program_invoice_uid: string | null;
          service_fee_percentage: number | null;
          oneOnOneMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
          } | null;
          organization: {
            __typename?: "Organization";
            uid: string;
            name: string;
            state: string | null;
            logoUrl: string | null;
            urlName: string | null;
          } | null;
          refunds: Array<{
            __typename?: "EnrollmentPaymentRefund";
            uid: string;
            user_uid: string;
            amount_cents: number;
            amount_credits: number | null;
            refunded_at: any | null;
            reason: string | null;
            user_role: string | null;
            note: string | null;
            reduces_teacher_payout: boolean;
            amount_in_local_currency: number | null;
            currency_code: CurrencyCode | null;
            exchange_rate: number | null;
            addOutschoolCreditTransaction: {
              __typename?: "CreditTransaction";
              uid: string;
              amount_cents: number;
              expiresAt: any | null;
              unspentCents: number | null;
            } | null;
          }>;
          couponCode: {
            __typename?: "CouponCode";
            code: string;
            coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
          } | null;
        }>;
        lastSectionTransfer: {
          __typename?: "SectionTransfer";
          timestamp: any;
          fromSection: {
            __typename?: "Section";
            uid: string;
            start_time: any | null;
            end_time: any | null;
          } | null;
        } | null;
        ongoingSectionTransferredFrom: {
          __typename?: "SectionTransfer";
          timestamp: any;
          fromSection: {
            __typename?: "Section";
            uid: string;
            start_time: any | null;
            end_time: any | null;
          } | null;
        } | null;
        refundPolicy: { __typename?: "RefundPolicy"; name: string } | null;
        details: { __typename?: "EnrollmentDetails"; message: string | null };
        fundingProgramInvoice: {
          __typename?: "FundingProgramInvoice";
          uid: string;
          awardId: string;
        } | null;
      }>;
    };
    unclaimedGiftEnrollments: Array<{
      __typename?: "GiftEnrollment";
      uid: string;
      giftClaimedAt: any | null;
      createdAt: any;
      confirmedAt: any | null;
      withdrawnAt: any | null;
      withdrawn_at: any | null;
      ongoingStoppedAt: any | null;
      ongoingStartTime: any | null;
      ongoingEndTime: any | null;
      ongoing_stopped_at: any | null;
      currency_code: CurrencyCode;
      exchange_rate: number;
      amount_in_local_currency: number;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      hasPaymentSchedule: boolean;
      isEnded: boolean;
      isPaused: boolean;
      orderSlugId: string | null;
      canBeWithdrawn: boolean;
      canBeStopped: boolean;
      canBePaused: boolean;
      priceCents: number | null;
      currentUserIsPurchaser: boolean;
      refundableAmountCents: number;
      payments: Array<{
        __typename?: "EnrollmentPayment";
        uid: string;
        amount_cents: number | null;
        amount_credits: number | null;
        order_slug_id: string | null;
        intercom_url: string | null;
        paid_at: any | null;
        disbursed_at: any | null;
        payout_uid: string | null;
        start_time: any | null;
        end_time: any | null;
        unrefundedCents: number;
        unrefundedCredits: number | null;
        voucher_name: string | null;
        last4: string | null;
        stripe_charge_id: string | null;
        purchase_order_id: string | null;
        credit_transaction_uid: string | null;
        credit_account_type: string | null;
        coupon_code_uid: string | null;
        pricing_offer_uid: string | null;
        esa_order_id: string | null;
        invoice_uid: string | null;
        currency_code: CurrencyCode | null;
        exchange_rate: number | null;
        funding_program_invoice_uid: string | null;
        service_fee_percentage: number | null;
        created_at: any | null;
        isOngoingRefundable: boolean;
        oneOnOneMeeting: {
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        } | null;
        organization: {
          __typename?: "Organization";
          uid: string;
          name: string;
          state: string | null;
          logoUrl: string | null;
          urlName: string | null;
        } | null;
        refunds: Array<{
          __typename?: "EnrollmentPaymentRefund";
          uid: string;
          user_uid: string;
          amount_cents: number;
          amount_credits: number | null;
          refunded_at: any | null;
          reason: string | null;
          user_role: string | null;
          note: string | null;
          reduces_teacher_payout: boolean;
          amount_in_local_currency: number | null;
          currency_code: CurrencyCode | null;
          exchange_rate: number | null;
          addOutschoolCreditTransaction: {
            __typename?: "CreditTransaction";
            uid: string;
            amount_cents: number;
            expiresAt: any | null;
            unspentCents: number | null;
          } | null;
        }>;
        couponCode: {
          __typename?: "CouponCode";
          code: string;
          coupon: { __typename?: "Coupon"; couponType: CouponType } | null;
        } | null;
        pricingOffer: {
          __typename?: "PricingOffer";
          name: string;
          buyerOrgName: string | null;
          isFinancialAid: boolean;
        } | null;
      }>;
      lastSectionTransfer: {
        __typename?: "SectionTransfer";
        timestamp: any;
        fromSection: {
          __typename?: "Section";
          uid: string;
          start_time: any | null;
          end_time: any | null;
        } | null;
      } | null;
      ongoingSectionTransferredFrom: {
        __typename?: "SectionTransfer";
        timestamp: any;
        fromSection: {
          __typename?: "Section";
          uid: string;
          start_time: any | null;
          end_time: any | null;
        } | null;
      } | null;
      parent: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      } | null;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      } | null;
      buyer: {
        __typename?: "Parent";
        uid: string;
        name: string | null;
        photo: string | null;
        publicName: string | null;
        introduction: string | null;
        created_at: any | null;
        deleted_at: any | null;
        timeZone: string | null;
        socialOptOut: boolean;
        consent_to_share_class_history: boolean | null;
        consent_to_share_favourites: boolean | null;
      };
      pricingOffer: {
        __typename?: "PricingOffer";
        name: string;
        buyerOrgName: string | null;
        isFinancialAid: boolean;
      } | null;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
      refundPolicy: {
        __typename?: "RefundPolicy";
        type: RefundPolicyType;
        name: string;
        description: string;
      } | null;
      paymentSchedule: {
        __typename?: "PaymentSchedule";
        uid: string;
        stoppedAt: any | null;
        endTime: any | null;
      } | null;
      pauseWindow: {
        __typename?: "EnrollmentPauseWindow";
        uid: string;
        startDate: any;
        endDate: any;
        canBeCanceled: boolean;
        pauseReason: string;
      } | null;
    }>;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
      teacherAttendance: {
        __typename?: "TeacherAttendance";
        uid: string;
        created_at: any;
      } | null;
      attendances: Array<{
        __typename?: "Attendance";
        uid: string;
        created_at: any;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            name: string | null;
            email: string | null;
            photo: string | null;
            timeZone: string | null;
          };
        };
      }>;
    }>;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
    checklist: {
      __typename?: "SectionChecklist";
      autoCanceledAt: any | null;
      grandfatheredAt2017Rate: boolean | null;
    };
    zoomMeeting: { __typename?: "ZoomMeeting"; zoom_id: string | null } | null;
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
    }>;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
    } | null;
  } | null;
};

export type AttendanceQueryQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  meetingsLimit?: InputMaybe<Scalars["Int"]>;
  meetingsOffset?: InputMaybe<Scalars["Int"]>;
  meetingsSortOrder?: InputMaybe<SortOrder>;
  meetingsStartBefore?: InputMaybe<Scalars["DateTime"]>;
}>;

export type AttendanceQueryQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
      teacherAttendance: {
        __typename?: "TeacherAttendance";
        uid: string;
        created_at: any;
      } | null;
      attendances: Array<{
        __typename?: "Attendance";
        uid: string;
        created_at: any;
        learner: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
          age: number | null;
          avatar: string | null;
          pronoun: string | null;
          intro: string | null;
          deleted_at: any | null;
          isVerified: boolean;
          isBlocked: boolean | null;
          blockedByUserUid: string | null;
          blockedAt: any | null;
          parent: {
            __typename?: "Parent";
            uid: string;
            name: string | null;
            email: string | null;
            photo: string | null;
            timeZone: string | null;
          };
        };
      }>;
    }>;
  } | null;
};

export type RecreateZoomMeetingMutationVariables = Exact<{
  sectionUid: Scalars["String"];
}>;

export type RecreateZoomMeetingMutation = {
  __typename?: "Mutation";
  recreateZoomMeeting: boolean;
};

export type SectionLessonsPageLayoutQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type SectionLessonsPageLayoutQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    published_at: any | null;
    deleted_at: any | null;
    canceled_at: any | null;
    start_time: any | null;
    end_time: any | null;
    startsAtNight: boolean | null;
    is_self_paced: boolean;
    currentUserCanManage: boolean;
    activity: {
      __typename?: "Activity";
      uid: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      is_ongoing_weekly: boolean;
      weekly_meetings: number | null;
      duration_weeks: number | null;
      isClub: boolean;
      published_at: any | null;
      hasTeacherSchedule: boolean;
      isSelfPaced: boolean;
    };
    sectionLessons: Array<{
      __typename?: "SectionLesson";
      uid: string;
      orderInSection: number;
      title: string;
      classPosts: Array<{
        __typename?: "ClassPost";
        uid: string;
        title: string | null;
        publishAt: any;
        blockType: BlockType | null;
      }>;
      assignmentClassPosts: Array<{
        __typename?: "AssignmentClassPost";
        uid: string;
        title: string;
        publishAt: any;
        submissionRequirement: SubmissionRequirementType;
      }>;
    }> | null;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    } | null;
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
    }>;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
    } | null;
  } | null;
  classroom: {
    __typename?: "Classroom";
    uid: string;
    section: {
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
    };
    currentUserEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
    }>;
  };
};

export type SectionLessonsPageThreadsQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type SectionLessonsPageThreadsQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    classPostThreads: Array<{
      __typename?: "Thread";
      uid: string;
      isRead: boolean;
      classPost: {
        __typename?: "ClassPost";
        uid: string;
        unreadCount: number | null;
      } | null;
      learningAssignmentClassPost: {
        __typename?: "AssignmentClassPost";
        uid: string;
        unreadCount: number | null;
      } | null;
      messages: Array<{
        __typename?: "PrivateClassMessage";
        uid: string;
        thread_uid: string;
        sentAt: any;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    }>;
    assignmentThreads: Array<{
      __typename?: "Thread";
      uid: string;
      isRead: boolean;
      classPost: {
        __typename?: "ClassPost";
        uid: string;
        unreadCount: number | null;
      } | null;
      learningAssignmentClassPost: {
        __typename?: "AssignmentClassPost";
        uid: string;
        unreadCount: number | null;
      } | null;
      messages: Array<{
        __typename?: "PrivateClassMessage";
        uid: string;
        thread_uid: string;
        sentAt: any;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    }>;
  } | null;
};

export type Section_LessonPostFragmentFragment = {
  __typename?: "LessonPost";
  uid: string;
  title: string | null;
  lessonUid: string;
  orderInLesson: number;
  deleted_at: any | null;
  is_posted_for_enrollments: boolean;
  is_posted_for_subscriptions: boolean;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type Section_AssignmentLessonPostFragmentFragment = {
  __typename?: "AssignmentLessonPost";
  uid: string;
  title: string | null;
  lessonUid: string;
  orderInLesson: number;
  deleted_at: any | null;
  submissionRequirement: SubmissionRequirementType;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type Section_AssignmentClassPostFragment = {
  __typename?: "AssignmentClassPost";
  uid: string;
  title: string;
  created_at: any;
  deleted_at: any | null;
  publishAt: any;
  dueDate: any | null;
  submissionRequirement: SubmissionRequirementType;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
  lesson: { __typename?: "Lesson"; uid: string; title: string | null } | null;
  lessonPost: {
    __typename?: "AssignmentLessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    submissionRequirement: SubmissionRequirementType;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  } | null;
};

export type ClassPost_LessonFragment = {
  __typename?: "Lesson";
  uid: string;
  title: string | null;
  description: string | null;
  week_number: number;
  order_within_week: number;
  lessonNumber: number | null;
  unit: {
    __typename?: "Unit";
    uid: string;
    title: string | null;
    unitNumber: number | null;
  } | null;
};

export type SectionPosts_LessonFragment = {
  __typename?: "Lesson";
  uid: string;
  title: string | null;
  description: string | null;
  week_number: number;
  order_within_week: number;
  lessonNumber: number | null;
  unlocksAt: any | null;
  meetings: Array<{
    __typename?: "Meeting";
    uid: string;
    start_time: any;
  }> | null;
  unit: {
    __typename?: "Unit";
    uid: string;
    title: string | null;
    unitNumber: number | null;
  } | null;
  lessonPosts: Array<{
    __typename?: "LessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    is_posted_for_enrollments: boolean;
    is_posted_for_subscriptions: boolean;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  }>;
  classPosts: Array<{
    __typename?: "ClassPost";
    publishAt: any;
    uid: string;
    isWelcomePost: boolean;
    title: string | null;
    promotedAt: any | null;
    pinnedAt: any | null;
    mentionedEnrollmentUids: Array<string>;
    backgroundColor: string | null;
    score: number | null;
    lessonPost: {
      __typename?: "LessonPost";
      uid: string;
      title: string | null;
      lessonUid: string;
      orderInLesson: number;
      deleted_at: any | null;
      is_posted_for_enrollments: boolean;
      is_posted_for_subscriptions: boolean;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    } | null;
    lesson: {
      __typename?: "Lesson";
      uid: string;
      title: string | null;
      description: string | null;
      week_number: number;
      order_within_week: number;
      lessonNumber: number | null;
      unit: {
        __typename?: "Unit";
        uid: string;
        title: string | null;
        unitNumber: number | null;
      } | null;
    } | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    commentsPreview: {
      __typename?: "CommentsPreview";
      remainingCommentsCount: number;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  }> | null;
  assignmentClassPosts: Array<{
    __typename?: "AssignmentClassPost";
    uid: string;
    title: string;
    created_at: any;
    deleted_at: any | null;
    publishAt: any;
    dueDate: any | null;
    submissionRequirement: SubmissionRequirementType;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    lesson: { __typename?: "Lesson"; uid: string; title: string | null } | null;
    lessonPost: {
      __typename?: "AssignmentLessonPost";
      uid: string;
      title: string | null;
      lessonUid: string;
      orderInLesson: number;
      deleted_at: any | null;
      submissionRequirement: SubmissionRequirementType;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    } | null;
  }>;
  assignmentLessonPosts: Array<{
    __typename?: "AssignmentLessonPost";
    uid: string;
    title: string | null;
    lessonUid: string;
    orderInLesson: number;
    deleted_at: any | null;
    submissionRequirement: SubmissionRequirementType;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  }>;
};

export type SectionPosts_SectionLessonFragment = {
  __typename?: "SectionLesson";
  uid: string;
  type: SectionLessonType;
  title: string;
  start_time: any | null;
  lesson: {
    __typename?: "Lesson";
    uid: string;
    title: string | null;
    description: string | null;
    week_number: number;
    order_within_week: number;
    lessonNumber: number | null;
    unlocksAt: any | null;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    }> | null;
    unit: {
      __typename?: "Unit";
      uid: string;
      title: string | null;
      unitNumber: number | null;
    } | null;
    lessonPosts: Array<{
      __typename?: "LessonPost";
      uid: string;
      title: string | null;
      lessonUid: string;
      orderInLesson: number;
      deleted_at: any | null;
      is_posted_for_enrollments: boolean;
      is_posted_for_subscriptions: boolean;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }>;
    classPosts: Array<{
      __typename?: "ClassPost";
      publishAt: any;
      uid: string;
      isWelcomePost: boolean;
      title: string | null;
      promotedAt: any | null;
      pinnedAt: any | null;
      mentionedEnrollmentUids: Array<string>;
      backgroundColor: string | null;
      score: number | null;
      lessonPost: {
        __typename?: "LessonPost";
        uid: string;
        title: string | null;
        lessonUid: string;
        orderInLesson: number;
        deleted_at: any | null;
        is_posted_for_enrollments: boolean;
        is_posted_for_subscriptions: boolean;
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      } | null;
      lesson: {
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        description: string | null;
        week_number: number;
        order_within_week: number;
        lessonNumber: number | null;
        unit: {
          __typename?: "Unit";
          uid: string;
          title: string | null;
          unitNumber: number | null;
        } | null;
      } | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      commentsPreview: {
        __typename?: "CommentsPreview";
        remainingCommentsCount: number;
        comments: Array<{
          __typename?: "ClassPostComment";
          uid: string;
          sendAt: any;
          mentionedEnrollmentUids: Array<string>;
          mentionedTeacherUid: string | null;
          backgroundColor: string | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      };
    }> | null;
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
      title: string;
      created_at: any;
      deleted_at: any | null;
      publishAt: any;
      dueDate: any | null;
      submissionRequirement: SubmissionRequirementType;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      lesson: {
        __typename?: "Lesson";
        uid: string;
        title: string | null;
      } | null;
      lessonPost: {
        __typename?: "AssignmentLessonPost";
        uid: string;
        title: string | null;
        lessonUid: string;
        orderInLesson: number;
        deleted_at: any | null;
        submissionRequirement: SubmissionRequirementType;
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      } | null;
    }>;
    assignmentLessonPosts: Array<{
      __typename?: "AssignmentLessonPost";
      uid: string;
      title: string | null;
      lessonUid: string;
      orderInLesson: number;
      deleted_at: any | null;
      submissionRequirement: SubmissionRequirementType;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }>;
  } | null;
};

export type SectionPostManagementQueryQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type SectionPostManagementQueryQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    hasFrozenSyllabus: boolean;
    uid: string;
    published_at: any | null;
    deleted_at: any | null;
    canceled_at: any | null;
    start_time: any | null;
    end_time: any | null;
    startsAtNight: boolean | null;
    is_self_paced: boolean;
    currentUserCanManage: boolean;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      layoutVersion: number;
      currentLesson: {
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        description: string | null;
        week_number: number;
        order_within_week: number;
        lessonNumber: number | null;
        unlocksAt: any | null;
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        }> | null;
        unit: {
          __typename?: "Unit";
          uid: string;
          title: string | null;
          unitNumber: number | null;
        } | null;
        lessonPosts: Array<{
          __typename?: "LessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          is_posted_for_enrollments: boolean;
          is_posted_for_subscriptions: boolean;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
        classPosts: Array<{
          __typename?: "ClassPost";
          publishAt: any;
          uid: string;
          isWelcomePost: boolean;
          title: string | null;
          promotedAt: any | null;
          pinnedAt: any | null;
          mentionedEnrollmentUids: Array<string>;
          backgroundColor: string | null;
          score: number | null;
          lessonPost: {
            __typename?: "LessonPost";
            uid: string;
            title: string | null;
            lessonUid: string;
            orderInLesson: number;
            deleted_at: any | null;
            is_posted_for_enrollments: boolean;
            is_posted_for_subscriptions: boolean;
            messageContent: {
              __typename?: "MessageContent";
              uid: string;
              text: string | null;
              originalMimeType: TextMimeType;
              externalVideoUrl: string | null;
              editedAt: any | null;
              htmlText: string | null;
              attachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              imageAttachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              video: {
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              } | null;
            };
          } | null;
          lesson: {
            __typename?: "Lesson";
            uid: string;
            title: string | null;
            description: string | null;
            week_number: number;
            order_within_week: number;
            lessonNumber: number | null;
            unit: {
              __typename?: "Unit";
              uid: string;
              title: string | null;
              unitNumber: number | null;
            } | null;
          } | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
          commentsPreview: {
            __typename?: "CommentsPreview";
            remainingCommentsCount: number;
            comments: Array<{
              __typename?: "ClassPostComment";
              uid: string;
              sendAt: any;
              mentionedEnrollmentUids: Array<string>;
              mentionedTeacherUid: string | null;
              backgroundColor: string | null;
              sender: {
                __typename?: "MessageSender";
                uid: string;
                name: string | null;
                photo: string | null;
                avatar: string | null;
                isLearner: boolean;
              };
              messageContent: {
                __typename?: "MessageContent";
                uid: string;
                text: string | null;
                originalMimeType: TextMimeType;
                externalVideoUrl: string | null;
                editedAt: any | null;
                htmlText: string | null;
                attachments: Array<{
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                }>;
                imageAttachments: Array<{
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                }>;
                video: {
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                } | null;
              };
            }>;
          };
        }> | null;
        assignmentClassPosts: Array<{
          __typename?: "AssignmentClassPost";
          uid: string;
          title: string;
          created_at: any;
          deleted_at: any | null;
          publishAt: any;
          dueDate: any | null;
          submissionRequirement: SubmissionRequirementType;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
          lesson: {
            __typename?: "Lesson";
            uid: string;
            title: string | null;
          } | null;
          lessonPost: {
            __typename?: "AssignmentLessonPost";
            uid: string;
            title: string | null;
            lessonUid: string;
            orderInLesson: number;
            deleted_at: any | null;
            submissionRequirement: SubmissionRequirementType;
            messageContent: {
              __typename?: "MessageContent";
              uid: string;
              text: string | null;
              originalMimeType: TextMimeType;
              externalVideoUrl: string | null;
              editedAt: any | null;
              htmlText: string | null;
              attachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              imageAttachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              video: {
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              } | null;
            };
          } | null;
        }>;
        assignmentLessonPosts: Array<{
          __typename?: "AssignmentLessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          submissionRequirement: SubmissionRequirementType;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      } | null;
      units: Array<{
        __typename?: "Unit";
        uid: string;
        title: string | null;
        unitNumber: number | null;
      }>;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        description: string | null;
        week_number: number;
        order_within_week: number;
        lessonNumber: number | null;
        unlocksAt: any | null;
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        }> | null;
        unit: {
          __typename?: "Unit";
          uid: string;
          title: string | null;
          unitNumber: number | null;
        } | null;
        lessonPosts: Array<{
          __typename?: "LessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          is_posted_for_enrollments: boolean;
          is_posted_for_subscriptions: boolean;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
        classPosts: Array<{
          __typename?: "ClassPost";
          publishAt: any;
          uid: string;
          isWelcomePost: boolean;
          title: string | null;
          promotedAt: any | null;
          pinnedAt: any | null;
          mentionedEnrollmentUids: Array<string>;
          backgroundColor: string | null;
          score: number | null;
          lessonPost: {
            __typename?: "LessonPost";
            uid: string;
            title: string | null;
            lessonUid: string;
            orderInLesson: number;
            deleted_at: any | null;
            is_posted_for_enrollments: boolean;
            is_posted_for_subscriptions: boolean;
            messageContent: {
              __typename?: "MessageContent";
              uid: string;
              text: string | null;
              originalMimeType: TextMimeType;
              externalVideoUrl: string | null;
              editedAt: any | null;
              htmlText: string | null;
              attachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              imageAttachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              video: {
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              } | null;
            };
          } | null;
          lesson: {
            __typename?: "Lesson";
            uid: string;
            title: string | null;
            description: string | null;
            week_number: number;
            order_within_week: number;
            lessonNumber: number | null;
            unit: {
              __typename?: "Unit";
              uid: string;
              title: string | null;
              unitNumber: number | null;
            } | null;
          } | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
          commentsPreview: {
            __typename?: "CommentsPreview";
            remainingCommentsCount: number;
            comments: Array<{
              __typename?: "ClassPostComment";
              uid: string;
              sendAt: any;
              mentionedEnrollmentUids: Array<string>;
              mentionedTeacherUid: string | null;
              backgroundColor: string | null;
              sender: {
                __typename?: "MessageSender";
                uid: string;
                name: string | null;
                photo: string | null;
                avatar: string | null;
                isLearner: boolean;
              };
              messageContent: {
                __typename?: "MessageContent";
                uid: string;
                text: string | null;
                originalMimeType: TextMimeType;
                externalVideoUrl: string | null;
                editedAt: any | null;
                htmlText: string | null;
                attachments: Array<{
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                }>;
                imageAttachments: Array<{
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                }>;
                video: {
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                } | null;
              };
            }>;
          };
        }> | null;
        assignmentClassPosts: Array<{
          __typename?: "AssignmentClassPost";
          uid: string;
          title: string;
          created_at: any;
          deleted_at: any | null;
          publishAt: any;
          dueDate: any | null;
          submissionRequirement: SubmissionRequirementType;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
          lesson: {
            __typename?: "Lesson";
            uid: string;
            title: string | null;
          } | null;
          lessonPost: {
            __typename?: "AssignmentLessonPost";
            uid: string;
            title: string | null;
            lessonUid: string;
            orderInLesson: number;
            deleted_at: any | null;
            submissionRequirement: SubmissionRequirementType;
            messageContent: {
              __typename?: "MessageContent";
              uid: string;
              text: string | null;
              originalMimeType: TextMimeType;
              externalVideoUrl: string | null;
              editedAt: any | null;
              htmlText: string | null;
              attachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              imageAttachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              video: {
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              } | null;
            };
          } | null;
        }>;
        assignmentLessonPosts: Array<{
          __typename?: "AssignmentLessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          submissionRequirement: SubmissionRequirementType;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      }>;
    } | null;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      duration_weeks: number | null;
      isSelfPaced: boolean;
      isFlexSchedule: boolean;
      archived_at: any | null;
      published_at: any | null;
      requested_listing_at: any | null;
      user_uid: string;
      titleTranslated: string | null;
      is_ongoing_weekly: boolean;
      weekly_meetings: number | null;
      isClub: boolean;
      hasTeacherSchedule: boolean;
      approvalStatus: {
        __typename?: "ActivityApprovalStatus";
        action: string;
        message_to_teacher: string | null;
      } | null;
    };
    sectionLessons: Array<{
      __typename?: "SectionLesson";
      uid: string;
      type: SectionLessonType;
      title: string;
      start_time: any | null;
      lesson: {
        __typename?: "Lesson";
        uid: string;
        title: string | null;
        description: string | null;
        week_number: number;
        order_within_week: number;
        lessonNumber: number | null;
        unlocksAt: any | null;
        meetings: Array<{
          __typename?: "Meeting";
          uid: string;
          start_time: any;
        }> | null;
        unit: {
          __typename?: "Unit";
          uid: string;
          title: string | null;
          unitNumber: number | null;
        } | null;
        lessonPosts: Array<{
          __typename?: "LessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          is_posted_for_enrollments: boolean;
          is_posted_for_subscriptions: boolean;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
        classPosts: Array<{
          __typename?: "ClassPost";
          publishAt: any;
          uid: string;
          isWelcomePost: boolean;
          title: string | null;
          promotedAt: any | null;
          pinnedAt: any | null;
          mentionedEnrollmentUids: Array<string>;
          backgroundColor: string | null;
          score: number | null;
          lessonPost: {
            __typename?: "LessonPost";
            uid: string;
            title: string | null;
            lessonUid: string;
            orderInLesson: number;
            deleted_at: any | null;
            is_posted_for_enrollments: boolean;
            is_posted_for_subscriptions: boolean;
            messageContent: {
              __typename?: "MessageContent";
              uid: string;
              text: string | null;
              originalMimeType: TextMimeType;
              externalVideoUrl: string | null;
              editedAt: any | null;
              htmlText: string | null;
              attachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              imageAttachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              video: {
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              } | null;
            };
          } | null;
          lesson: {
            __typename?: "Lesson";
            uid: string;
            title: string | null;
            description: string | null;
            week_number: number;
            order_within_week: number;
            lessonNumber: number | null;
            unit: {
              __typename?: "Unit";
              uid: string;
              title: string | null;
              unitNumber: number | null;
            } | null;
          } | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
          commentsPreview: {
            __typename?: "CommentsPreview";
            remainingCommentsCount: number;
            comments: Array<{
              __typename?: "ClassPostComment";
              uid: string;
              sendAt: any;
              mentionedEnrollmentUids: Array<string>;
              mentionedTeacherUid: string | null;
              backgroundColor: string | null;
              sender: {
                __typename?: "MessageSender";
                uid: string;
                name: string | null;
                photo: string | null;
                avatar: string | null;
                isLearner: boolean;
              };
              messageContent: {
                __typename?: "MessageContent";
                uid: string;
                text: string | null;
                originalMimeType: TextMimeType;
                externalVideoUrl: string | null;
                editedAt: any | null;
                htmlText: string | null;
                attachments: Array<{
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                }>;
                imageAttachments: Array<{
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                }>;
                video: {
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                } | null;
              };
            }>;
          };
        }> | null;
        assignmentClassPosts: Array<{
          __typename?: "AssignmentClassPost";
          uid: string;
          title: string;
          created_at: any;
          deleted_at: any | null;
          publishAt: any;
          dueDate: any | null;
          submissionRequirement: SubmissionRequirementType;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
          lesson: {
            __typename?: "Lesson";
            uid: string;
            title: string | null;
          } | null;
          lessonPost: {
            __typename?: "AssignmentLessonPost";
            uid: string;
            title: string | null;
            lessonUid: string;
            orderInLesson: number;
            deleted_at: any | null;
            submissionRequirement: SubmissionRequirementType;
            messageContent: {
              __typename?: "MessageContent";
              uid: string;
              text: string | null;
              originalMimeType: TextMimeType;
              externalVideoUrl: string | null;
              editedAt: any | null;
              htmlText: string | null;
              attachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              imageAttachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              video: {
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              } | null;
            };
          } | null;
        }>;
        assignmentLessonPosts: Array<{
          __typename?: "AssignmentLessonPost";
          uid: string;
          title: string | null;
          lessonUid: string;
          orderInLesson: number;
          deleted_at: any | null;
          submissionRequirement: SubmissionRequirementType;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      } | null;
    }> | null;
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    } | null;
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
    }>;
  } | null;
};

export type ActivityFromSectionQueryVariables = Exact<{
  sectionUid?: InputMaybe<Scalars["ID"]>;
}>;

export type ActivityFromSectionQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    title: string;
    isClub: boolean;
  };
};

export type SellerOrgDashboardQueryQueryVariables = Exact<{
  start: Scalars["DateTime"];
  end: Scalars["DateTime"];
}>;

export type SellerOrgDashboardQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    followerCount: number;
    name: string | null;
    introduction: string | null;
    created_at: any;
    photo: string | null;
    leader_link: string | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
    } | null;
    conversations: Array<
      | {
          __typename?: "MessageThread";
          uid: string;
          messages: Array<{
            __typename?: "Message";
            uid: string;
            created_at: any;
            subject: string | null;
            content: string | null;
            sender: {
              __typename?: "Sender";
              uid: string;
              name: string | null;
              photo: string | null;
              headline: string | null;
              leader_link: string | null;
              timeZone: string | null;
            };
          }>;
        }
      | { __typename?: "PrivateClassThread" }
    >;
    leader: {
      __typename?: "Leader";
      publishedClassCount: number;
      uid: string;
      metrics: {
        __typename?: "LeaderMetrics";
        activeSections: number;
        repurchaseRate: number | null;
        averageActivityStarRating: number | null;
        learnersTaught: number;
      };
      listings: Array<{
        __typename?: "Listing";
        activity: { __typename?: "Activity"; uid: string; canEnroll: boolean };
      }>;
    } | null;
    teacherMeetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      sectionSequenceNumber: number;
      section: {
        __typename?: "Section";
        uid: string;
        filledSpaceCount: number;
        meetingCount: number;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
        };
      };
    }>;
  } | null;
};

export type SellerOrgTeacherDetailsQueryVariables = Exact<{
  startAfter: Scalars["DateTime"];
}>;

export type SellerOrgTeacherDetailsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      teachers: Array<{
        __typename?: "User";
        uid: string;
        name: string | null;
        email: string | null;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          orgTeacherMetrics: {
            __typename?: "OrgTeacherMetrics";
            averageRating: number | null;
            totalSections: number;
            pastSections: number;
            futureSections: number;
            totalMeetings: number;
            attendedMeetings: number;
            lateMeetings: number;
            unattendedMeetings: number;
            totalEnrollments: number;
            totalReviews: number;
            firstSectionStart: any | null;
            latestSectionStart: any | null;
          };
        } | null;
      }>;
    } | null;
  } | null;
};

export type SellerOrgClassStartTimesQueryVariables = Exact<{
  startAfter: Scalars["DateTime"];
  startBefore: Scalars["DateTime"];
  endAfter?: InputMaybe<Scalars["DateTime"]>;
  endBefore?: InputMaybe<Scalars["DateTime"]>;
}>;

export type SellerOrgClassStartTimesQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      meetings: {
        __typename?: "MeetingConnection";
        edges: Array<{
          __typename?: "MeetingEdge";
          node: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
            startStatus: MeetingStartStatus;
            section: {
              __typename?: "Section";
              uid: string;
              activity: {
                __typename?: "Activity";
                uid: string;
                title: string;
                titleTranslated: string | null;
              };
              leader: {
                __typename?: "Leader";
                uid: string;
                name: string | null;
              };
            };
            teacherAttendance: {
              __typename?: "TeacherAttendance";
              uid: string;
              attendedAt: any;
            } | null;
          };
        }>;
      };
    } | null;
  } | null;
};

export type SellerOrgTeacherClubsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars["String"]>;
  activityType?: InputMaybe<CreateActivityType>;
}>;

export type SellerOrgTeacherClubsQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    sections: Array<{
      __typename?: "Section";
      uid: string;
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        titleTranslated: string | null;
        saveCount: number | null;
        archived_at: any | null;
        published_at: any | null;
        requested_listing_at: any | null;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        approvalStatus: {
          __typename?: "ActivityApprovalStatus";
          action: string;
          message_to_teacher: string | null;
        } | null;
      };
    }>;
  } | null;
};

export type SinglePostQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  classPostUid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type SinglePostQuery = {
  __typename?: "Query";
  classroom: {
    __typename?: "Classroom";
    uid: string;
    usersCanPost: boolean;
    usersCanComment: boolean;
    currentUserEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      usersCanCommunicate: boolean;
      learner: { __typename?: "Learner"; uid: string } | null;
    }>;
    section: {
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
      currentUserCanManage: boolean;
      filledSpaceCount: number;
      usesOutschoolVideoChat: boolean;
      published_at: any | null;
      deleted_at: any | null;
      canceled_at: any | null;
      startsAtNight: boolean | null;
      is_self_paced: boolean;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
      } | null;
      assignmentClassPosts: Array<{
        __typename?: "AssignmentClassPost";
        uid: string;
      }>;
      syllabus: {
        __typename?: "Syllabus";
        uid: string;
        published_at: string | null;
        layoutVersion: number;
      } | null;
    };
    postByUid: {
      __typename?: "ClassPost";
      uid: string;
      publishAt: any;
      isWelcomePost: boolean;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    } | null;
    activity: {
      __typename?: "Activity";
      archived_at: any | null;
      published_at: any | null;
      requested_listing_at: any | null;
      uid: string;
      user_uid: string;
      title: string;
      titleTranslated: string | null;
      is_ongoing_weekly: boolean;
      weekly_meetings: number | null;
      duration_weeks: number | null;
      isClub: boolean;
      hasTeacherSchedule: boolean;
      isSelfPaced: boolean;
      leader: {
        __typename?: "Leader";
        uid: string;
        leader_link: string | null;
      };
      approvalStatus: {
        __typename?: "ActivityApprovalStatus";
        action: string;
        message_to_teacher: string | null;
      } | null;
    };
    mentionNames: Array<{
      __typename?: "MentionName";
      id: string;
      display: string;
      avatar: string | null;
      learnerUid: string | null;
      startTime: any | null;
    }>;
  };
};

export type UpdateLessonMutationVariables = Exact<{
  lessonUid: Scalars["ID"];
  updates: LessonInput;
}>;

export type UpdateLessonMutation = {
  __typename?: "Mutation";
  updateLesson: {
    __typename?: "Syllabus";
    uid: string;
    lessons: Array<{
      __typename?: "Lesson";
      uid: string;
      title: string | null;
      description: string | null;
      unit: { __typename?: "Unit"; uid: string; title: string | null } | null;
    }>;
  };
};

export type AddLessonMutationVariables = Exact<{
  syllabusUid: Scalars["ID"];
  previousLessonUid: Scalars["ID"];
}>;

export type AddLessonMutation = {
  __typename?: "Mutation";
  addLesson: {
    __typename?: "Syllabus";
    uid: string;
    lessons: Array<{
      __typename?: "Lesson";
      uid: string;
      week_number: number;
      order_within_week: number;
      unit: { __typename?: "Unit"; uid: string } | null;
    }>;
  };
};

export type DeleteLessonMutationVariables = Exact<{
  lessonUid: Scalars["ID"];
}>;

export type DeleteLessonMutation = {
  __typename?: "Mutation";
  deleteLesson: {
    __typename?: "Syllabus";
    uid: string;
    lessons: Array<{ __typename?: "Lesson"; order_within_week: number }>;
  };
};

export type UpdateUnitMutationVariables = Exact<{
  unitUid: Scalars["ID"];
  updates: UnitInput;
}>;

export type UpdateUnitMutation = {
  __typename?: "Mutation";
  updateUnit: {
    __typename?: "Syllabus";
    uid: string;
    units: Array<{ __typename?: "Unit"; title: string | null }>;
  };
};

export type DeleteUnitMutationVariables = Exact<{
  syllabusUid: Scalars["ID"];
  unitUid: Scalars["ID"];
}>;

export type DeleteUnitMutation = {
  __typename?: "Mutation";
  deleteUnit: {
    __typename?: "Syllabus";
    uid: string;
    units: Array<{ __typename?: "Unit"; uid: string }>;
  };
};

export type RemoveUnitsMutationVariables = Exact<{
  syllabusUid: Scalars["ID"];
}>;

export type RemoveUnitsMutation = {
  __typename?: "Mutation";
  removeUnits: {
    __typename?: "Syllabus";
    uid: string;
    lessons: Array<{
      __typename?: "Lesson";
      unit: { __typename?: "Unit"; uid: string } | null;
    }>;
    units: Array<{ __typename?: "Unit"; uid: string }>;
  };
};

export type PublishSyllabusMutationVariables = Exact<{
  syllabusUid: Scalars["ID"];
}>;

export type PublishSyllabusMutation = {
  __typename?: "Mutation";
  publishSyllabus: { __typename?: "Syllabus"; uid: string };
};

export type IntroduceUnitsMutationVariables = Exact<{
  syllabusUid: Scalars["ID"];
}>;

export type IntroduceUnitsMutation = {
  __typename?: "Mutation";
  introduceUnits: {
    __typename?: "Syllabus";
    uid: string;
    lessons: Array<{
      __typename?: "Lesson";
      uid: string;
      unit: { __typename?: "Unit"; uid: string } | null;
    }>;
    units: Array<{ __typename?: "Unit"; uid: string }>;
  };
};

export type AddUnitMutationVariables = Exact<{
  syllabusUid: Scalars["ID"];
}>;

export type AddUnitMutation = {
  __typename?: "Mutation";
  addUnit: {
    __typename?: "Syllabus";
    uid: string;
    units: Array<{
      __typename?: "Unit";
      uid: string;
      learning_syllabus_uid: string;
    }>;
  };
};

export type CreateNewVersionMutationVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type CreateNewVersionMutation = {
  __typename?: "Mutation";
  createSyllabus: { __typename?: "Syllabus"; uid: string };
};

export type DeleteVersionOfSyllabusMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  syllabusVersionUid?: InputMaybe<Scalars["ID"]>;
}>;

export type DeleteVersionOfSyllabusMutation = {
  __typename?: "Mutation";
  deleteSyllabus: { __typename?: "Syllabus"; uid: string };
};

export type SyllabusEditPageQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type SyllabusEditPageQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    user_uid: string;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    duration_minutes: number | null;
    title: string;
    isClub: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isPublished: boolean;
    wasPublishedInThePast: boolean;
    syllabus: {
      __typename?: "Syllabus";
      uid: string;
      published_at: string | null;
      isFrozen: boolean;
      numVersions: number;
      lessons: Array<{
        __typename?: "Lesson";
        uid: string;
        order_within_week: number;
        week_number: number;
        title: string | null;
        description: string | null;
        lessonNumber: number | null;
        unit: { __typename?: "Unit"; uid: string; title: string | null } | null;
      }>;
      units: Array<{
        __typename?: "Unit";
        uid: string;
        title: string | null;
        unitNumber: number | null;
        learning_syllabus_uid: string;
      }>;
    } | null;
    selfPacedMigration: {
      __typename?: "SelfPacedMigrationStatus";
      hasConsented: boolean;
      consentedAt: any | null;
    } | null;
    leader: { __typename?: "Leader"; uid: string; publishedClassCount: number };
  };
};

export type AcceptInviteToSellerOrgMutationVariables = Exact<{
  userUid: Scalars["ID"];
  token: Scalars["String"];
  password: Scalars["String"];
}>;

export type AcceptInviteToSellerOrgMutation = {
  __typename?: "Mutation";
  acceptInviteToSellerOrg: {
    __typename?: "AuthenticationV2";
    sessionToken: string;
    refreshToken: string;
  };
};

export type TeacherAvailabilityQueryVariables = Exact<{
  start: Scalars["DateTime"];
  end: Scalars["DateTime"];
}>;

export type TeacherAvailabilityQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    teacherAvailability: {
      __typename?: "Availability";
      updated_at: any | null;
      hourlyTimetable: {
        __typename?: "HourlyTimetable";
        mon: Array<number>;
        tue: Array<number>;
        wed: Array<number>;
        thu: Array<number>;
        fri: Array<number>;
        sat: Array<number>;
        sun: Array<number>;
      } | null;
    } | null;
    teacherUnavailableBlocks: Array<{
      __typename?: "UnavailableBlock";
      uid: string;
      startTime: any;
      endTime: any;
    }>;
    leader: {
      __typename?: "Leader";
      uid: string;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingBufferMinutes: number | null;
    } | null;
  } | null;
};

export type AddTeacherUnavailableBlockMutationMutationVariables = Exact<{
  unavailableBlock: UnavailableBlockInput;
}>;

export type AddTeacherUnavailableBlockMutationMutation = {
  __typename?: "Mutation";
  addTeacherUnavailableBlock: {
    __typename?: "UnavailableBlock";
    uid: string;
    startTime: any;
    endTime: any;
  };
};

export type DeleteTeacherUnavailableBlockMutationMutationVariables = Exact<{
  unavailableBlockUid: Scalars["ID"];
}>;

export type DeleteTeacherUnavailableBlockMutationMutation = {
  __typename?: "Mutation";
  deleteTeacherUnavailableBlock: boolean;
};

export type AutoScheduleSettingsClassesListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AutoScheduleSettingsClassesListQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    activities: Array<{
      __typename?: "Activity";
      uid: string;
      title: string;
      age_max: number | null;
      age_min: number | null;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      weekly_meetings: number | null;
      duration_minutes: number | null;
      isClub: boolean;
      duration_weeks: number | null;
      is_ongoing_weekly: boolean;
      size_max: number | null;
      hasTeacherSchedule: boolean;
    }>;
  } | null;
};

export type BulkSendMessageToUserMutationVariables = Exact<{
  messageInput: MessageInput;
  recipientUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type BulkSendMessageToUserMutation = {
  __typename?: "Mutation";
  sendMessage: { __typename?: "Message"; uid: string };
};

export type TeacherDashboardQueryQueryVariables = Exact<{
  start: Scalars["DateTime"];
  end: Scalars["DateTime"];
}>;

export type TeacherDashboardQueryQuery = {
  __typename?: "Query";
  teacherCredentials: Array<{
    __typename?: "TeacherCredential";
    uid: string;
    certificateExpireDate: any | null;
    certificateDoesNotExpire: boolean | null;
    credentialType: CredentialType;
  } | null> | null;
  currentUser: {
    __typename?: "User";
    uid: string;
    isTeacherUnlisted: boolean;
    teacher_approved_at: any | null;
    confirmedEnrollmentCount: number;
    publicSectionCount: number;
    hasCompletedRequiredProfessionalLearning: boolean;
    backgroundChecked: boolean;
    background_check_started_at: any | null;
    background_checked_at: any | null;
    idVerificationStatus: IdvStatus;
    canTeacherStartBackgroundCheck: boolean;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    followerCount: number;
    publicSectionCountIncludingUnpublished: number;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    leaderActivities: Array<{
      __typename?: "Activity";
      uid: string;
      published_at: any | null;
      isSelfPaced: boolean;
      hasTeacherSchedule: boolean;
      size_max: number | null;
      requested_listing_at: any | null;
      approvalStatus: {
        __typename?: "ActivityApprovalStatus";
        action: string;
      } | null;
    }>;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      status: TeacherApplicationStatus;
      legal_name: string | null;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    location: {
      __typename?: "Location";
      timeZone: string | null;
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      state: string | null;
    } | null;
    conversations: Array<
      | {
          __typename?: "MessageThread";
          uid: string;
          messages: Array<{
            __typename?: "Message";
            uid: string;
            created_at: any;
            subject: string | null;
            content: string | null;
            sender: {
              __typename?: "Sender";
              uid: string;
              name: string | null;
              photo: string | null;
              headline: string | null;
              leader_link: string | null;
              timeZone: string | null;
            };
          }>;
        }
      | { __typename?: "PrivateClassThread" }
    >;
    teacherMeetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      sectionSequenceNumber: number;
      section: {
        __typename?: "Section";
        uid: string;
        filledSpaceCount: number;
        meetingCount: number;
        pausedLearnerCount: number;
        leader: { __typename?: "Leader"; uid: string; name: string | null };
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          titleTranslated: string | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
        };
      };
    }>;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
      metrics: {
        __typename?: "LeaderMetrics";
        activeSections: number;
        repurchaseRate: number | null;
        averageActivityStarRating: number | null;
        learnersTaught: number;
      };
      listings: Array<{
        __typename?: "Listing";
        activity: { __typename?: "Activity"; uid: string; canEnroll: boolean };
      }>;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  } | null;
};

export type UserProfessionalLearningQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UserProfessionalLearningQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    completed_trainings: Array<string> | null;
  } | null;
};

export type MarkExternalActivityCompleteMutationVariables = Exact<{
  externalActivityId: Scalars["String"];
  source: ExternalActivitySource;
}>;

export type MarkExternalActivityCompleteMutation = {
  __typename?: "Mutation";
  markExternalActivityComplete: boolean | null;
};

export type TeacherPublicProfileQueryQueryVariables = Exact<{
  uid?: InputMaybe<Scalars["ID"]>;
  leader_link?: InputMaybe<Scalars["String"]>;
  userTimeZone: Scalars["String"];
  skipRating: Scalars["Boolean"];
}>;

export type TeacherPublicProfileQueryQuery = {
  __typename?: "Query";
  publicProfile: {
    __typename?: "PublicProfile";
    uid: string;
    leader: {
      __typename?: "Leader";
      showCalendar: boolean | null;
      teacher_approved_at: any | null;
      reviewCount: number;
      averageActivityStarRating: number | null;
      successfulClassCount: number;
      educatorTiers: Array<EducatorTier>;
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      hasListings: boolean;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      classOfferingTimeRange: {
        __typename?: "ClassOfferingTimeRange";
        start: string;
        end: string;
      } | null;
      listings: Array<{
        __typename?: "Listing";
        insertionId: string | null;
        activity: {
          __typename?: "Activity";
          hasTeacherSchedule: boolean;
          uid: string;
          user_uid: string;
          title: string;
          url: string;
          path: string;
          summary: string | null;
          summaryTranslated: string | null;
          quickSummary: string | null;
          weekly_meetings: number | null;
          duration_weeks: number | null;
          is_ongoing_weekly: boolean;
          isClub: boolean;
          published_at: any | null;
          size_max: number | null;
          size_min: number | null;
          allows_recurring_payment: boolean | null;
          averageStarRating?: number | null;
          reviewCount: number;
          age_min: number | null;
          age_max: number | null;
          duration_minutes: number | null;
          price_cents: number | null;
          priceCreditsPerMeeting: number | null;
          isFlexSchedule: boolean;
          isSelfPaced: boolean;
          canEnroll: boolean;
          isIncludedWithMembership: boolean;
          isOneTime: boolean;
          titleTranslated: string | null;
          slug_id: string;
          subject: string | null;
          syllabus: {
            __typename?: "Syllabus";
            uid: string;
            lessons: Array<{ __typename?: "Lesson"; uid: string }>;
          } | null;
          clubSection: {
            __typename?: "Section";
            filledSpaceCount: number;
            clubPostCount: number;
          } | null;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
          } | null;
          savedClassLists: Array<{
            __typename?: "SavedClassList";
            uid: string;
            lastAddedToAt: any | null;
          }>;
        };
        sections: Array<{
          __typename?: "Section";
          start_time: any | null;
          end_time: any | null;
        }>;
        nextSection: {
          __typename?: "Section";
          uid: string;
          size_max: number | null;
          filledSpaceCount: number;
          start_time: any | null;
          end_time: any | null;
          nextOngoingMeeting: {
            __typename?: "Meeting";
            uid: string;
            start_time: any;
            end_time: any;
          } | null;
        } | null;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
          leader_link: string | null;
          averageActivityStarRating: number | null;
          reviewCount: number;
          educatorTiers: Array<EducatorTier>;
          ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        };
      }>;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    } | null;
  } | null;
};

export type UnfollowConfirmationQueryVariables = Exact<{
  leaderUid?: InputMaybe<Scalars["ID"]>;
}>;

export type UnfollowConfirmationQuery = {
  __typename?: "Query";
  publicProfile: {
    __typename?: "PublicProfile";
    uid: string;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      suspended_at: any | null;
      cityState: string | null;
      socialOptOut: boolean;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      hasBackgroundCheckExpired: boolean | null;
      reviewCount: number;
      averageActivityStarRating: number | null;
      hasListings: boolean;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        headlineTranslated: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    } | null;
  } | null;
};

export type UnscheduleRequestConfirmationQueryVariables = Exact<{
  activityUid?: InputMaybe<Scalars["ID"]>;
}>;

export type UnscheduleRequestConfirmationQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    titleTranslated: string | null;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    learningGoals: Array<string>;
    assessment: string | null;
    homework: string | null;
    grading_policy: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    english_proficiency_level: EnglishProficiencyLevel | null;
    grade_level_min: string | null;
    grade_level_max: string | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    priceCredits: number | null;
    summary: string | null;
    summaryTranslated: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    allowWaitlist: boolean | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    allows_recurring_payment: boolean | null;
    allows_late_enrollments_for_fixed_length_classes: boolean;
    allowsFutureOngoingEnrollments: boolean;
    has_building_content: boolean | null;
    hasTeacherSchedule: boolean;
    isFlexSchedule: boolean;
    isSelfPaced: boolean;
    isOneTime: boolean;
    classFormat: EducatorSelectedFormat;
    classroomType: ClassroomType;
    isIncludedWithMembership: boolean;
    strictAgeRange: {
      __typename?: "AgeRangeType";
      min: number;
      max: number;
    } | null;
    proficiency_level: {
      __typename?: "ProficiencyLevel";
      level: Array<string | null> | null;
      text: string | null;
    } | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
      type: RefundPolicyType;
    };
    photo: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
  };
};

export type UserUpdateAdminMutationVariables = Exact<{
  uid: Scalars["ID"];
  updates: UserAdminInput;
}>;

export type UserUpdateAdminMutation = {
  __typename?: "Mutation";
  updateUserAdmin: {
    __typename?: "User";
    roles: Array<string> | null;
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  };
};

export type UserAdminLinkQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type UserAdminLinkQuery = {
  __typename?: "Query";
  switchUserLink: string;
};

export type BulkCreateAccountsMutationVariables = Exact<{
  organizationUid: Scalars["ID"];
  data: Array<CreateAccountInput> | CreateAccountInput;
  options?: InputMaybe<BulkCreateAccountOptions>;
}>;

export type BulkCreateAccountsMutation = {
  __typename?: "Mutation";
  bulkCreateAccounts: Array<{
    __typename?: "CreateAccountResult";
    parentName: string | null;
    parentEmail: string | null;
    learnerName: string | null;
    learnerAge: number | null;
    learnerEmail: string | null;
    comments: string | null;
  }>;
};

export type SubmitClubIntroductionMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  videoUid: Scalars["ID"];
}>;

export type SubmitClubIntroductionMutation = {
  __typename?: "Mutation";
  submitClubIntroduction: boolean;
};

export type ClubMustSubmitIntroQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type ClubMustSubmitIntroQuery = {
  __typename?: "Query";
  club: {
    __typename?: "Club";
    uid: string;
    currentLearnerHasSubmittedIntroductionForClub: boolean;
  };
};

export type AcceptGuidelinesMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type AcceptGuidelinesMutation = {
  __typename?: "Mutation";
  acceptGuidelinesForSection: boolean;
};

export type ClubGuidelinesQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type ClubGuidelinesQuery = {
  __typename?: "Query";
  club: {
    __typename?: "Club";
    uid: string;
    currentLearnerMustAcceptGuidelines: boolean;
  };
};

export type ThreadUnreadFragment = {
  __typename?: "Thread";
  unreadCount: number;
};

export type CurrentLearnerNeedsConsentQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrentLearnerNeedsConsentQuery = {
  __typename?: "Query";
  currentLearnerNeedsConsent: {
    __typename?: "LearnerConsentNeeds";
    needsHealthConsent: boolean;
  };
};

export type SetCurrentLearnerConsentMutationVariables = Exact<{
  hasHealthConsent?: InputMaybe<Scalars["Boolean"]>;
}>;

export type SetCurrentLearnerConsentMutation = {
  __typename?: "Mutation";
  setCurrentLearnerConsent: { __typename?: "CurrentLearner"; uid: string };
};

export type LoginLearnerWithAppleMutationVariables = Exact<{
  code: Scalars["String"];
}>;

export type LoginLearnerWithAppleMutation = {
  __typename?: "Mutation";
  loginOrCreateAccountWithAppleV2:
    | { __typename: "LoginError"; error: CreateOrLoginError }
    | {
        __typename: "LoginResultV2";
        isNewUser: boolean;
        authentication: {
          __typename?: "AuthenticationV2";
          sessionToken: string;
          refreshToken: string;
        };
      };
};

export type CanReviewUpcomingMeetingQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type CanReviewUpcomingMeetingQuery = {
  __typename?: "Query";
  canReviewUpcomingMeeting: boolean | null;
};

export type LearnerActivityLeaderQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type LearnerActivityLeaderQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    activity: {
      __typename?: "Activity";
      uid: string;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
      };
    };
  } | null;
};

export type SetLearnerInterfacePreferenceMutationVariables = Exact<{
  name: Scalars["String"];
  value: Scalars["JSON"];
}>;

export type SetLearnerInterfacePreferenceMutation = {
  __typename?: "Mutation";
  setLearnerInterfacePreference: boolean;
};

export type CurrentLearnerRecommendedTopicsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrentLearnerRecommendedTopicsQuery = {
  __typename?: "Query";
  currentLearnerRecommendedTopics: Array<{
    __typename?: "Topic";
    uid: string;
    label: string;
    image_url: string;
  }>;
};

export type EnrollmentToReviewSoonFragmentFragment = {
  __typename?: "Enrollment";
  uid: string;
  section: {
    __typename?: "Section";
    uid: string;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      subject: string | null;
      is_ongoing_weekly: boolean;
    };
  } | null;
};

export type SubmitInterestedInTakingMoreClassesAboutTopicMutationVariables =
  Exact<{
    learnerSectionReviewInput: LearnerSectionReviewInput;
  }>;

export type SubmitInterestedInTakingMoreClassesAboutTopicMutation = {
  __typename?: "Mutation";
  createOrUpdateLearnerSectionReview: {
    __typename?: "LearnerSectionReview";
    uid: string;
    name: ReviewName | null;
    response: {
      __typename?: "LearnerReviewResponse";
      vote: string | null;
    } | null;
  };
};

export type MarkClubPostViewedMutationVariables = Exact<{
  classPostUid: Scalars["ID"];
}>;

export type MarkClubPostViewedMutation = {
  __typename?: "Mutation";
  markClubPostViewed: boolean;
};

export type ReviewActivityQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type ReviewActivityQuery = {
  __typename?: "Query";
  activityBySectionUidIfLatestMeetingNotReviewed: {
    __typename?: "Activity";
    uid: string;
    titleTranslated: string | null;
    leader: {
      __typename?: "Leader";
      name: string | null;
      photo: string | null;
    };
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  } | null;
};

export type MeetingReviewMutationMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
  rating: Scalars["Int"];
  type: MeetingReviewType;
}>;

export type MeetingReviewMutationMutation = {
  __typename?: "Mutation";
  createMeetingReview: {
    __typename?: "MeetingReview";
    uid: string;
    learnerUid: string;
    rating: number;
    meetingUid: string;
    sectionUid: string;
    type: MeetingReviewType;
  };
};

export type StartTeacherSupportMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type StartTeacherSupportMutation = {
  __typename?: "Mutation";
  startTeacherSupport: {
    __typename?: "Section";
    uid: string;
    teacher_support_start_time: any | null;
    end_time: any | null;
  } | null;
};

export type CurrentLearnerFragmentFragment = {
  __typename?: "CurrentLearner";
  uid: string;
  name: string | null;
  email: string | null;
  username: string | null;
  age: number | null;
  avatar: string | null;
  unlockedAvatars: Array<string>;
  pronoun: string | null;
  accessLevel: LearnerAccessLevel;
  intro: string | null;
  timeZone: string;
  optedOutOfPersonalizedRecommendationsAt: any | null;
  hasMarketingConsent: boolean | null;
  hasHealthConsent: boolean | null;
  hasUpcomingScheduleEvent: boolean;
  isLoginEnabled: boolean;
  isVerified: boolean;
  parent: {
    __typename?: "Parent";
    uid: string;
    name: string | null;
    photo: string | null;
    publicName: string | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
  };
  siblings: Array<{
    __typename?: "Child";
    uid: string;
    name: string | null;
    avatar: string | null;
    age: number | null;
  }>;
  enrollmentToReviewSoon: {
    __typename?: "Enrollment";
    uid: string;
    section: {
      __typename?: "Section";
      uid: string;
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        subject: string | null;
        is_ongoing_weekly: boolean;
      };
    } | null;
  } | null;
  experiments: Array<{
    __typename?: "LearnerExperiment";
    name: string;
    variant: string;
  }>;
  interfacePreferences: Array<{
    __typename?: "LearnerInterfacePreference";
    name: string;
    value: any;
  }>;
};

export type CurrentLearnerQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentLearnerQuery = {
  __typename?: "Query";
  currentLearner: {
    __typename?: "CurrentLearner";
    uid: string;
    name: string | null;
    email: string | null;
    username: string | null;
    age: number | null;
    avatar: string | null;
    unlockedAvatars: Array<string>;
    pronoun: string | null;
    accessLevel: LearnerAccessLevel;
    intro: string | null;
    timeZone: string;
    optedOutOfPersonalizedRecommendationsAt: any | null;
    hasMarketingConsent: boolean | null;
    hasHealthConsent: boolean | null;
    hasUpcomingScheduleEvent: boolean;
    isLoginEnabled: boolean;
    isVerified: boolean;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    };
    siblings: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      avatar: string | null;
      age: number | null;
    }>;
    enrollmentToReviewSoon: {
      __typename?: "Enrollment";
      uid: string;
      section: {
        __typename?: "Section";
        uid: string;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          subject: string | null;
          is_ongoing_weekly: boolean;
        };
      } | null;
    } | null;
    experiments: Array<{
      __typename?: "LearnerExperiment";
      name: string;
      variant: string;
    }>;
    interfacePreferences: Array<{
      __typename?: "LearnerInterfacePreference";
      name: string;
      value: any;
    }>;
  };
};

export type LearnerAppActivityFragmentFragment = {
  __typename?: "Activity";
  uid: string;
  slug_id: string;
  user_uid: string;
  title: string;
  class_experience: string | null;
  learning_goals: string | null;
  assessment: string | null;
  homework: string | null;
  prerequisites: string | null;
  published_at: any | null;
  is_online: boolean;
  age_min: number | null;
  age_max: number | null;
  size_min: number | null;
  size_max: number | null;
  duration_minutes: number | null;
  duration_weeks: number | null;
  weekly_meetings: number | null;
  price_cents: number | null;
  summary: string | null;
  is_ongoing_weekly: boolean;
  subject: string | null;
  languageOfInstruction: any | null;
  summaryForLearners: string | null;
  isClub: boolean;
  isAutoSchedulingEnabled: boolean | null;
  autoSchedulingDaysNoticeMin: number | null;
  autoSchedulingDaysNoticeMax: number | null;
  hasTeacherSchedule: boolean;
  refundPolicy: {
    __typename?: "RefundPolicy";
    name: string;
    description: string;
  };
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type ClubOnboardingBannerQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ClubOnboardingBannerQuery = {
  __typename?: "Query";
  currentLearner: {
    __typename?: "CurrentLearner";
    uid: string;
    about_me: string | null;
    hasWrittenClubPost: boolean | null;
    hasWrittenClubPostComment: boolean | null;
  };
};

export type LearnerSearchActivityByTopicSearchResultsQueryVariables = Exact<{
  topicUid?: InputMaybe<Scalars["ID"]>;
  cursor?: InputMaybe<Scalars["String"]>;
  activityExperiences?: InputMaybe<
    Array<ActivityExperience> | ActivityExperience
  >;
}>;

export type LearnerSearchActivityByTopicSearchResultsQuery = {
  __typename?: "Query";
  learnerSearchActivityByTopic: {
    __typename?: "LearnerActivityByTopicSearch";
    cursor: string | null;
    topicLabel: string | null;
    activities: Array<{
      __typename?: "Activity";
      uid: string;
      title: string;
      slug_id: string;
      price_cents: number | null;
      age_max: number | null;
      age_min: number | null;
      isClub: boolean;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
      };
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      videoForLearners: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    }>;
  };
};

export type LearnerActivityDetailsQueryVariables = Exact<{
  uid?: InputMaybe<Scalars["ID"]>;
  slugId?: InputMaybe<Scalars["String"]>;
}>;

export type LearnerActivityDetailsQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    class_experience: string | null;
    summary: string | null;
    summaryForLearners: string | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    age_min: number | null;
    age_max: number | null;
    size_max: number | null;
    hasTeacherSchedule: boolean;
    price_cents: number | null;
    weekly_meetings: number | null;
    is_ongoing_weekly: boolean;
    isClub: boolean;
    slug_id: string;
    promotableSections: Array<{
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
      price_cents: number | null;
    }>;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
    video: {
      __typename?: "Attachment";
      videoThumbnailUrl: string | null;
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    videoForLearners: {
      __typename?: "Attachment";
      videoThumbnailUrl: string | null;
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      leader_link: string | null;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
      };
      video: {
        __typename?: "Attachment";
        videoThumbnailUrl: string | null;
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    sampleClubPosts: Array<{
      __typename?: "SampleClubPost";
      text: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      }> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
        };
      } | null;
      comments: Array<{
        __typename?: "SampleClubPostComment";
        text: string | null;
      }>;
    }> | null;
  };
};

export type LearnerListingRecommendationsQueryVariables = Exact<{
  shuffle?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
}>;

export type LearnerListingRecommendationsQuery = {
  __typename?: "Query";
  featured: {
    __typename?: "Featured";
    perLearnerRecommendations: Array<{
      __typename?: "Listing";
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        slug_id: string;
        price_cents: number | null;
        age_max: number | null;
        age_min: number | null;
        isClub: boolean;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
        };
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
        videoForLearners: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }>;
  };
};

export type LearnerActivitySearchResultFragmentFragment = {
  __typename?: "Activity";
  uid: string;
  title: string;
  slug_id: string;
  price_cents: number | null;
  age_max: number | null;
  age_min: number | null;
  isClub: boolean;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
  leader: {
    __typename?: "Leader";
    uid: string;
    name: string | null;
    photo: string | null;
  };
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
  videoForLearners: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
};

export type LearnerClassroomAssignmentClassPostsBySectionAndLessonQueryVariables =
  Exact<{
    sectionUid: Scalars["ID"];
    lessonUid: Scalars["ID"];
  }>;

export type LearnerClassroomAssignmentClassPostsBySectionAndLessonQuery = {
  __typename?: "Query";
  assignmentClassPosts: Array<{
    __typename?: "AssignmentClassPost";
    uid: string;
    title: string;
    submissionRequirement: SubmissionRequirementType;
    publishAt: any;
    dueDate: any | null;
    user: { __typename?: "User"; uid: string; name: string | null };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    comments: Array<{
      __typename?: "AssignmentClassPostComment";
      uid: string;
      sentAt: any;
      isSubmission: boolean | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }>;
  }> | null;
};

export type LearnerClassroomAssignmentClassPostsBySectionQueryVariables =
  Exact<{
    sectionUid: Scalars["ID"];
  }>;

export type LearnerClassroomAssignmentClassPostsBySectionQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
      title: string;
      submissionRequirement: SubmissionRequirementType;
      publishAt: any;
      dueDate: any | null;
      user: { __typename?: "User"; uid: string; name: string | null };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      comments: Array<{
        __typename?: "AssignmentClassPostComment";
        uid: string;
        sentAt: any;
        threadForLearnerUid: string;
        isSubmission: boolean | null;
        replies: Array<{
          __typename?: "AssignmentClassPostComment";
          uid: string;
          sentAt: any;
          threadForLearnerUid: string;
          isSubmission: boolean | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }> | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
      lesson: {
        __typename?: "Lesson";
        uid: string;
        lessonNumber: number | null;
      } | null;
    }>;
  } | null;
};

export type LearnerCommentOnAssignmentMutationVariables = Exact<{
  assignmentClassPostUid: Scalars["ID"];
  messageContentInput: MessageContentInput;
}>;

export type LearnerCommentOnAssignmentMutation = {
  __typename?: "Mutation";
  addAssignmentClassPostComment: {
    __typename?: "AssignmentClassPostComment";
    uid: string;
    sentAt: any;
    isSubmission: boolean | null;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type LearnerClassroomPostsQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  start?: InputMaybe<Scalars["DateTime"]>;
  end?: InputMaybe<Scalars["DateTime"]>;
  plainText?: InputMaybe<Scalars["Boolean"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  postsFilter?: InputMaybe<ClassroomPostFilter>;
}>;

export type LearnerClassroomPostsQuery = {
  __typename?: "Query";
  classroom: {
    __typename?: "Classroom";
    uid: string;
    usersCanPost: boolean;
    usersCanComment: boolean;
    posts: Array<{
      __typename?: "ClassPost";
      uid: string;
      isWelcomePost: boolean;
      publishAt: any;
      title: string | null;
      promotedAt: any | null;
      pinnedAt: any | null;
      mentionedEnrollmentUids: Array<string>;
      backgroundColor: string | null;
      score: number | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      commentsPreview: {
        __typename?: "CommentsPreview";
        remainingCommentsCount: number;
        comments: Array<{
          __typename?: "ClassPostComment";
          uid: string;
          sendAt: any;
          mentionedEnrollmentUids: Array<string>;
          mentionedTeacherUid: string | null;
          backgroundColor: string | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      };
    }>;
    unpublishedPosts: Array<{
      __typename?: "ClassPost";
      uid: string;
      isWelcomePost: boolean;
      publishAt: any;
      title: string | null;
      promotedAt: any | null;
      pinnedAt: any | null;
      mentionedEnrollmentUids: Array<string>;
      backgroundColor: string | null;
      score: number | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      commentsPreview: {
        __typename?: "CommentsPreview";
        remainingCommentsCount: number;
        comments: Array<{
          __typename?: "ClassPostComment";
          uid: string;
          sendAt: any;
          mentionedEnrollmentUids: Array<string>;
          mentionedTeacherUid: string | null;
          backgroundColor: string | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      };
    }>;
    activity: {
      __typename?: "Activity";
      user_uid: string;
      leader: {
        __typename?: "Leader";
        uid: string;
        leader_link: string | null;
        name: string | null;
      };
    };
    section: {
      __typename?: "Section";
      currentUserCanManage: boolean;
      uid: string;
      meetings: Array<{
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
        recordingAvailability: RecordingAvailability;
        recordingRequests: Array<{
          __typename?: "RecordingRequest";
          requestedAt: any;
          message: string;
          requestedBy: {
            __typename?: "Learner";
            uid: string;
            name: string | null;
          };
        }>;
        classRecordings: Array<
          | {
              __typename?: "ClassRecording";
              uid: string;
              startTime: any;
              endTime: any;
            }
          | {
              __typename?: "ZoomRecording";
              uid: string;
              startTime: any;
              endTime: any;
            }
        >;
        attendances: Array<{
          __typename?: "Attendance";
          learner: { __typename?: "Learner"; name: string | null };
        }>;
      }>;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
    };
    mentionNames: Array<{
      __typename?: "MentionName";
      id: string;
      display: string;
      avatar: string | null;
      learnerUid: string | null;
      startTime: any | null;
    }>;
  };
};

export type LearnerClassroomSectionLessonFragmentFragment = {
  __typename?: "SectionLesson";
  uid: string;
  type: SectionLessonType;
  orderInSection: number;
  isCompleted: boolean;
  isLocked: boolean;
  lessonStatus: LearningStatementsVerb;
  isCancelled: boolean;
  title: string;
  description: string | null;
  start_time: any | null;
  lesson: { __typename?: "Lesson"; uid: string; isMissed: boolean } | null;
  unit: {
    __typename?: "Unit";
    uid: string;
    title: string | null;
    unitNumber: number | null;
  } | null;
  liveMeetingDetails: {
    __typename?: "LessonLiveMeeting";
    uid: string;
    enrollmentUid: string | null;
    classRecordingUids: Array<string | null>;
    sectionStartTime: any | null;
    meetingStartTime: any | null;
    meetingEndTime: any | null;
    meetingsCount: number;
    usersCanHaveLiveMeeting: boolean | null;
  } | null;
  assignmentClassPosts: Array<{
    __typename?: "AssignmentClassPost";
    uid: string;
    title: string;
    publishAt: any;
    isSubmitted: boolean;
  }>;
  classPosts: Array<{
    __typename?: "ClassPost";
    uid: string;
    title: string | null;
    publishAt: any;
    estimatedDuration: number | null;
    blockType: BlockType | null;
    learnerState: {
      __typename?: "ClassPostLearnerState";
      videoProgress: number;
      videoWatchCount: number;
      completedAt: any | null;
      heartedAt: any | null;
      lastViewedAt: any;
    } | null;
  }>;
};

export type LearnerClassroomLessonFragmentFragment = {
  __typename?: "Lesson";
  uid: string;
  title: string | null;
  description: string | null;
  week_number: number;
  order_within_week: number;
  lessonNumber: number | null;
  lessonStatus: LearningStatementsVerb | null;
  isCompleted: boolean;
  isLocked: boolean;
  isMissed: boolean;
  unit: {
    __typename?: "Unit";
    uid: string;
    title: string | null;
    unitNumber: number | null;
  } | null;
  meetings: Array<{
    __typename?: "Meeting";
    uid: string;
    start_time: any;
  }> | null;
};

export type LearnerClassroomSyllabusFragmentFragment = {
  __typename?: "Syllabus";
  uid: string;
  published_at: string | null;
  layoutVersion: number;
  currentLesson: {
    __typename?: "Lesson";
    uid: string;
    title: string | null;
    description: string | null;
    week_number: number;
    order_within_week: number;
    lessonNumber: number | null;
    lessonStatus: LearningStatementsVerb | null;
    isCompleted: boolean;
    isLocked: boolean;
    isMissed: boolean;
    unit: {
      __typename?: "Unit";
      uid: string;
      title: string | null;
      unitNumber: number | null;
    } | null;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    }> | null;
  } | null;
  lessons: Array<{
    __typename?: "Lesson";
    uid: string;
    lessonNumber: number | null;
    title: string | null;
    description: string | null;
    week_number: number;
    order_within_week: number;
    lessonStatus: LearningStatementsVerb | null;
    isCompleted: boolean;
    isLocked: boolean;
    isMissed: boolean;
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
      title: string;
      submissionRequirement: SubmissionRequirementType;
      dueDate: any | null;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      comments: Array<{
        __typename?: "AssignmentClassPostComment";
        uid: string;
        sentAt: any;
        isSubmission: boolean | null;
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    }>;
    unit: {
      __typename?: "Unit";
      uid: string;
      title: string | null;
      unitNumber: number | null;
    } | null;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
    }> | null;
  }>;
};

export type LearnerClassroomSectionFragmentFragment = {
  __typename?: "Section";
  uid: string;
  start_time: any | null;
  end_time: any | null;
  teacher_support_start_time: any | null;
  canceled_at: any | null;
  is_self_paced: boolean;
  filledSpaceCount: number;
  usesOutschoolVideoChat: boolean;
  currentUserHasAttendances: boolean;
  nextOngoingMeeting: {
    __typename?: "Meeting";
    uid: string;
    start_time: any;
  } | null;
  leader: { __typename?: "Leader"; uid: string; name: string | null };
  assignmentClassPosts: Array<{
    __typename?: "AssignmentClassPost";
    uid: string;
    title: string;
    submissionRequirement: SubmissionRequirementType;
    dueDate: any | null;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    comments: Array<{
      __typename?: "AssignmentClassPostComment";
      uid: string;
      sentAt: any;
      isSubmission: boolean | null;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }>;
  }>;
  currentSectionLesson: {
    __typename?: "SectionLesson";
    uid: string;
    type: SectionLessonType;
    orderInSection: number;
    isCompleted: boolean;
    isLocked: boolean;
    lessonStatus: LearningStatementsVerb;
    isCancelled: boolean;
    title: string;
    description: string | null;
    start_time: any | null;
    lesson: { __typename?: "Lesson"; uid: string; isMissed: boolean } | null;
    unit: {
      __typename?: "Unit";
      uid: string;
      title: string | null;
      unitNumber: number | null;
    } | null;
    liveMeetingDetails: {
      __typename?: "LessonLiveMeeting";
      uid: string;
      enrollmentUid: string | null;
      classRecordingUids: Array<string | null>;
      sectionStartTime: any | null;
      meetingStartTime: any | null;
      meetingEndTime: any | null;
      meetingsCount: number;
      usersCanHaveLiveMeeting: boolean | null;
    } | null;
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
      title: string;
      publishAt: any;
      isSubmitted: boolean;
    }>;
    classPosts: Array<{
      __typename?: "ClassPost";
      uid: string;
      title: string | null;
      publishAt: any;
      estimatedDuration: number | null;
      blockType: BlockType | null;
      learnerState: {
        __typename?: "ClassPostLearnerState";
        videoProgress: number;
        videoWatchCount: number;
        completedAt: any | null;
        heartedAt: any | null;
        lastViewedAt: any;
      } | null;
    }>;
  } | null;
  sectionLessons: Array<{
    __typename?: "SectionLesson";
    uid: string;
    type: SectionLessonType;
    orderInSection: number;
    isCompleted: boolean;
    isLocked: boolean;
    lessonStatus: LearningStatementsVerb;
    isCancelled: boolean;
    title: string;
    description: string | null;
    start_time: any | null;
    lesson: { __typename?: "Lesson"; uid: string; isMissed: boolean } | null;
    unit: {
      __typename?: "Unit";
      uid: string;
      title: string | null;
      unitNumber: number | null;
    } | null;
    liveMeetingDetails: {
      __typename?: "LessonLiveMeeting";
      uid: string;
      enrollmentUid: string | null;
      classRecordingUids: Array<string | null>;
      sectionStartTime: any | null;
      meetingStartTime: any | null;
      meetingEndTime: any | null;
      meetingsCount: number;
      usersCanHaveLiveMeeting: boolean | null;
    } | null;
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
      title: string;
      publishAt: any;
      isSubmitted: boolean;
    }>;
    classPosts: Array<{
      __typename?: "ClassPost";
      uid: string;
      title: string | null;
      publishAt: any;
      estimatedDuration: number | null;
      blockType: BlockType | null;
      learnerState: {
        __typename?: "ClassPostLearnerState";
        videoProgress: number;
        videoWatchCount: number;
        completedAt: any | null;
        heartedAt: any | null;
        lastViewedAt: any;
      } | null;
    }>;
  }> | null;
  syllabus: {
    __typename?: "Syllabus";
    uid: string;
    published_at: string | null;
    layoutVersion: number;
    currentLesson: {
      __typename?: "Lesson";
      uid: string;
      title: string | null;
      description: string | null;
      week_number: number;
      order_within_week: number;
      lessonNumber: number | null;
      lessonStatus: LearningStatementsVerb | null;
      isCompleted: boolean;
      isLocked: boolean;
      isMissed: boolean;
      unit: {
        __typename?: "Unit";
        uid: string;
        title: string | null;
        unitNumber: number | null;
      } | null;
      meetings: Array<{
        __typename?: "Meeting";
        uid: string;
        start_time: any;
      }> | null;
    } | null;
    lessons: Array<{
      __typename?: "Lesson";
      uid: string;
      lessonNumber: number | null;
      title: string | null;
      description: string | null;
      week_number: number;
      order_within_week: number;
      lessonStatus: LearningStatementsVerb | null;
      isCompleted: boolean;
      isLocked: boolean;
      isMissed: boolean;
      assignmentClassPosts: Array<{
        __typename?: "AssignmentClassPost";
        uid: string;
        title: string;
        submissionRequirement: SubmissionRequirementType;
        dueDate: any | null;
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
        comments: Array<{
          __typename?: "AssignmentClassPostComment";
          uid: string;
          sentAt: any;
          isSubmission: boolean | null;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      }>;
      unit: {
        __typename?: "Unit";
        uid: string;
        title: string | null;
        unitNumber: number | null;
      } | null;
      meetings: Array<{
        __typename?: "Meeting";
        uid: string;
        start_time: any;
      }> | null;
    }>;
  } | null;
};

export type LearnerClassroomActivityFragmentFragment = {
  __typename?: "Activity";
  uid: string;
  user_uid: string;
  title: string;
  is_ongoing_weekly: boolean;
  hasTeacherSchedule: boolean;
  weekly_meetings: number | null;
  is_online: boolean;
  duration_weeks: number | null;
  isClub: boolean;
  published_at: any | null;
  isSelfPaced: boolean;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
  leader: {
    __typename?: "Leader";
    uid: string;
    name: string | null;
    leader_link: string | null;
    photo: string | null;
  };
};

export type LearnerClassroomQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
}>;

export type LearnerClassroomQuery = {
  __typename?: "Query";
  classroom: {
    __typename?: "Classroom";
    uid: string;
    usersCanHaveLiveMeeting: boolean;
    currentLearnerEnrollments: Array<{
      __typename?: "Enrollment";
      uid: string;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      isPaused: boolean;
    }>;
    learners: Array<{
      __typename?: "LearnerProfile";
      uid: string;
      name: string | null;
      avatar: string | null;
    }>;
    section: {
      __typename?: "Section";
      uid: string;
      start_time: any | null;
      end_time: any | null;
      teacher_support_start_time: any | null;
      canceled_at: any | null;
      is_self_paced: boolean;
      filledSpaceCount: number;
      usesOutschoolVideoChat: boolean;
      currentUserHasAttendances: boolean;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
      } | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      assignmentClassPosts: Array<{
        __typename?: "AssignmentClassPost";
        uid: string;
        title: string;
        submissionRequirement: SubmissionRequirementType;
        dueDate: any | null;
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
        comments: Array<{
          __typename?: "AssignmentClassPostComment";
          uid: string;
          sentAt: any;
          isSubmission: boolean | null;
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      }>;
      currentSectionLesson: {
        __typename?: "SectionLesson";
        uid: string;
        type: SectionLessonType;
        orderInSection: number;
        isCompleted: boolean;
        isLocked: boolean;
        lessonStatus: LearningStatementsVerb;
        isCancelled: boolean;
        title: string;
        description: string | null;
        start_time: any | null;
        lesson: {
          __typename?: "Lesson";
          uid: string;
          isMissed: boolean;
        } | null;
        unit: {
          __typename?: "Unit";
          uid: string;
          title: string | null;
          unitNumber: number | null;
        } | null;
        liveMeetingDetails: {
          __typename?: "LessonLiveMeeting";
          uid: string;
          enrollmentUid: string | null;
          classRecordingUids: Array<string | null>;
          sectionStartTime: any | null;
          meetingStartTime: any | null;
          meetingEndTime: any | null;
          meetingsCount: number;
          usersCanHaveLiveMeeting: boolean | null;
        } | null;
        assignmentClassPosts: Array<{
          __typename?: "AssignmentClassPost";
          uid: string;
          title: string;
          publishAt: any;
          isSubmitted: boolean;
        }>;
        classPosts: Array<{
          __typename?: "ClassPost";
          uid: string;
          title: string | null;
          publishAt: any;
          estimatedDuration: number | null;
          blockType: BlockType | null;
          learnerState: {
            __typename?: "ClassPostLearnerState";
            videoProgress: number;
            videoWatchCount: number;
            completedAt: any | null;
            heartedAt: any | null;
            lastViewedAt: any;
          } | null;
        }>;
      } | null;
      sectionLessons: Array<{
        __typename?: "SectionLesson";
        uid: string;
        type: SectionLessonType;
        orderInSection: number;
        isCompleted: boolean;
        isLocked: boolean;
        lessonStatus: LearningStatementsVerb;
        isCancelled: boolean;
        title: string;
        description: string | null;
        start_time: any | null;
        lesson: {
          __typename?: "Lesson";
          uid: string;
          isMissed: boolean;
        } | null;
        unit: {
          __typename?: "Unit";
          uid: string;
          title: string | null;
          unitNumber: number | null;
        } | null;
        liveMeetingDetails: {
          __typename?: "LessonLiveMeeting";
          uid: string;
          enrollmentUid: string | null;
          classRecordingUids: Array<string | null>;
          sectionStartTime: any | null;
          meetingStartTime: any | null;
          meetingEndTime: any | null;
          meetingsCount: number;
          usersCanHaveLiveMeeting: boolean | null;
        } | null;
        assignmentClassPosts: Array<{
          __typename?: "AssignmentClassPost";
          uid: string;
          title: string;
          publishAt: any;
          isSubmitted: boolean;
        }>;
        classPosts: Array<{
          __typename?: "ClassPost";
          uid: string;
          title: string | null;
          publishAt: any;
          estimatedDuration: number | null;
          blockType: BlockType | null;
          learnerState: {
            __typename?: "ClassPostLearnerState";
            videoProgress: number;
            videoWatchCount: number;
            completedAt: any | null;
            heartedAt: any | null;
            lastViewedAt: any;
          } | null;
        }>;
      }> | null;
      syllabus: {
        __typename?: "Syllabus";
        uid: string;
        published_at: string | null;
        layoutVersion: number;
        currentLesson: {
          __typename?: "Lesson";
          uid: string;
          title: string | null;
          description: string | null;
          week_number: number;
          order_within_week: number;
          lessonNumber: number | null;
          lessonStatus: LearningStatementsVerb | null;
          isCompleted: boolean;
          isLocked: boolean;
          isMissed: boolean;
          unit: {
            __typename?: "Unit";
            uid: string;
            title: string | null;
            unitNumber: number | null;
          } | null;
          meetings: Array<{
            __typename?: "Meeting";
            uid: string;
            start_time: any;
          }> | null;
        } | null;
        lessons: Array<{
          __typename?: "Lesson";
          uid: string;
          lessonNumber: number | null;
          title: string | null;
          description: string | null;
          week_number: number;
          order_within_week: number;
          lessonStatus: LearningStatementsVerb | null;
          isCompleted: boolean;
          isLocked: boolean;
          isMissed: boolean;
          assignmentClassPosts: Array<{
            __typename?: "AssignmentClassPost";
            uid: string;
            title: string;
            submissionRequirement: SubmissionRequirementType;
            dueDate: any | null;
            messageContent: {
              __typename?: "MessageContent";
              uid: string;
              text: string | null;
              originalMimeType: TextMimeType;
              externalVideoUrl: string | null;
              editedAt: any | null;
              htmlText: string | null;
              attachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              imageAttachments: Array<{
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              }>;
              video: {
                __typename?: "Attachment";
                uid: string;
                fileUrl: string;
                videoThumbnailUrl: string | null;
                conversionStatus: string | null;
                created_at: any;
                file: {
                  __typename?: "File";
                  filename: string;
                  mimetype: string | null;
                  size: number;
                  url: string;
                  thumbUrl: string | null;
                };
              } | null;
            };
            comments: Array<{
              __typename?: "AssignmentClassPostComment";
              uid: string;
              sentAt: any;
              isSubmission: boolean | null;
              messageContent: {
                __typename?: "MessageContent";
                uid: string;
                text: string | null;
                originalMimeType: TextMimeType;
                externalVideoUrl: string | null;
                editedAt: any | null;
                htmlText: string | null;
                attachments: Array<{
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                }>;
                imageAttachments: Array<{
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                }>;
                video: {
                  __typename?: "Attachment";
                  uid: string;
                  fileUrl: string;
                  videoThumbnailUrl: string | null;
                  conversionStatus: string | null;
                  created_at: any;
                  file: {
                    __typename?: "File";
                    filename: string;
                    mimetype: string | null;
                    size: number;
                    url: string;
                    thumbUrl: string | null;
                  };
                } | null;
              };
            }>;
          }>;
          unit: {
            __typename?: "Unit";
            uid: string;
            title: string | null;
            unitNumber: number | null;
          } | null;
          meetings: Array<{
            __typename?: "Meeting";
            uid: string;
            start_time: any;
          }> | null;
        }>;
      } | null;
    };
    activity: {
      __typename?: "Activity";
      uid: string;
      user_uid: string;
      title: string;
      is_ongoing_weekly: boolean;
      hasTeacherSchedule: boolean;
      weekly_meetings: number | null;
      is_online: boolean;
      duration_weeks: number | null;
      isClub: boolean;
      published_at: any | null;
      isSelfPaced: boolean;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        photo: string | null;
      };
    };
  };
};

export type LearnerDashboard_SectionFragment = {
  __typename?: "Section";
  uid: string;
  start_time: any | null;
  end_time: any | null;
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    subject: string | null;
    duration_weeks: number | null;
    summary: string | null;
    weekly_meetings: number | null;
    is_ongoing_weekly: boolean;
    isClub: boolean;
    isFlexSchedule: boolean;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  };
  leader: { __typename?: "Leader"; uid: string; name: string | null };
};

export type LearnerKeywordSearchResultsQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]>;
  cursor?: InputMaybe<Scalars["String"]>;
  activityExperiences?: InputMaybe<
    Array<ActivityExperience> | ActivityExperience
  >;
}>;

export type LearnerKeywordSearchResultsQuery = {
  __typename?: "Query";
  learnerSearchKeyword: {
    __typename?: "LearnerKeywordSearch";
    cursor: string | null;
    activities: Array<{
      __typename?: "Activity";
      uid: string;
      title: string;
      slug_id: string;
      price_cents: number | null;
      age_max: number | null;
      age_min: number | null;
      isClub: boolean;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
      };
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      videoForLearners: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    }>;
  };
};

export type LearnerLeaderFragmentFragment = {
  __typename?: "Leader";
  uid: string;
  name: string | null;
  photo: string | null;
  leader_link: string | null;
  details: {
    __typename?: "LeaderDetails";
    about: string | null;
    headline: string | null;
  };
  video: {
    __typename?: "Attachment";
    videoThumbnailUrl: string | null;
    uid: string;
    fileUrl: string;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
};

export type MarkLearnerNotificationsReadMutationVariables = Exact<{
  uids: Array<Scalars["ID"]> | Scalars["ID"];
  after: Scalars["DateTime"];
}>;

export type MarkLearnerNotificationsReadMutation = {
  __typename?: "Mutation";
  markNotificationRead: {
    __typename?: "MarkNotificationReadResult";
    learnerHasUnreadNotifications: boolean;
  };
};

type NotificationFragment_AssignmentNotification_Fragment = {
  __typename: "AssignmentNotification";
  uid: string;
  createdAt: any;
  status: NotificationStatus;
  sender:
    | {
        __typename?: "LearnerSender";
        uid: string;
        name: string;
        avatar: string | null;
      }
    | {
        __typename?: "UserSender";
        uid: string;
        name: string;
        photo: string | null;
      };
};

type NotificationFragment_ClassPostNotification_Fragment = {
  __typename: "ClassPostNotification";
  uid: string;
  createdAt: any;
  status: NotificationStatus;
  sender:
    | {
        __typename?: "LearnerSender";
        uid: string;
        name: string;
        avatar: string | null;
      }
    | {
        __typename?: "UserSender";
        uid: string;
        name: string;
        photo: string | null;
      };
};

type NotificationFragment_ClubNotification_Fragment = {
  __typename: "ClubNotification";
  uid: string;
  createdAt: any;
  status: NotificationStatus;
  sender:
    | {
        __typename?: "LearnerSender";
        uid: string;
        name: string;
        avatar: string | null;
      }
    | {
        __typename?: "UserSender";
        uid: string;
        name: string;
        photo: string | null;
      };
};

type NotificationFragment_PrivateClassMessageNotification_Fragment = {
  __typename: "PrivateClassMessageNotification";
  uid: string;
  createdAt: any;
  status: NotificationStatus;
  sender:
    | {
        __typename?: "LearnerSender";
        uid: string;
        name: string;
        avatar: string | null;
      }
    | {
        __typename?: "UserSender";
        uid: string;
        name: string;
        photo: string | null;
      };
};

export type NotificationFragmentFragment =
  | NotificationFragment_AssignmentNotification_Fragment
  | NotificationFragment_ClassPostNotification_Fragment
  | NotificationFragment_ClubNotification_Fragment
  | NotificationFragment_PrivateClassMessageNotification_Fragment;

export type PrivateClassMessageNotificationFragmentFragment = {
  __typename: "PrivateClassMessageNotification";
  privateClassMessageUid: string;
  isClub: boolean;
  uid: string;
  createdAt: any;
  status: NotificationStatus;
  privateClassMessageSectionUid: string;
  privateClassMessageThreadUid: string | null;
  sender:
    | {
        __typename?: "LearnerSender";
        uid: string;
        name: string;
        avatar: string | null;
      }
    | {
        __typename?: "UserSender";
        uid: string;
        name: string;
        photo: string | null;
      };
};

export type ClassPostNotificationFragmentFragment = {
  __typename: "ClassPostNotification";
  uid: string;
  createdAt: any;
  status: NotificationStatus;
  classPostNotificationAction: ClassPostNotificationAction;
  classroomClassPostUid: string;
  classroomSectionUid: string;
  sender:
    | {
        __typename?: "LearnerSender";
        uid: string;
        name: string;
        avatar: string | null;
      }
    | {
        __typename?: "UserSender";
        uid: string;
        name: string;
        photo: string | null;
      };
};

export type AssignmentNotificationFragmentFragment = {
  __typename: "AssignmentNotification";
  assignmentUid: string;
  commentUid: string | null;
  uid: string;
  createdAt: any;
  status: NotificationStatus;
  assignmentNotificationAction: AssignmentNotificationAction;
  assignmentSectionUid: string;
  sender:
    | {
        __typename?: "LearnerSender";
        uid: string;
        name: string;
        avatar: string | null;
      }
    | {
        __typename?: "UserSender";
        uid: string;
        name: string;
        photo: string | null;
      };
};

export type ClubNotificationFragmentFragment = {
  __typename: "ClubNotification";
  classPostCommentUid: string | null;
  threadParentCommentUid: string | null;
  uid: string;
  createdAt: any;
  status: NotificationStatus;
  clubNotificationAction: ClubNotificationAction;
  clubClassPostUid: string;
  clubSectionUid: string;
  sender:
    | {
        __typename?: "LearnerSender";
        uid: string;
        name: string;
        avatar: string | null;
      }
    | {
        __typename?: "UserSender";
        uid: string;
        name: string;
        photo: string | null;
      };
};

export type LearnerNotificationsQueryVariables = Exact<{
  direction: CursorDirection;
  cursor?: InputMaybe<Scalars["DateTime"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  after: Scalars["DateTime"];
  skipHasUnreadNotifications: Scalars["Boolean"];
}>;

export type LearnerNotificationsQuery = {
  __typename?: "Query";
  learnerHasUnreadNotifications?: boolean;
  learnerNotifications: {
    __typename?: "LearnerNotificationConnection";
    pageInfo: {
      __typename?: "LearnerNotificationsPageInfo";
      hasNextPage: boolean;
      direction: CursorDirection;
    };
    results: Array<
      | {
          __typename: "AssignmentNotification";
          assignmentUid: string;
          commentUid: string | null;
          uid: string;
          createdAt: any;
          status: NotificationStatus;
          assignmentNotificationAction: AssignmentNotificationAction;
          assignmentSectionUid: string;
          sender:
            | {
                __typename?: "LearnerSender";
                uid: string;
                name: string;
                avatar: string | null;
              }
            | {
                __typename?: "UserSender";
                uid: string;
                name: string;
                photo: string | null;
              };
        }
      | {
          __typename: "ClassPostNotification";
          uid: string;
          createdAt: any;
          status: NotificationStatus;
          classPostNotificationAction: ClassPostNotificationAction;
          classroomClassPostUid: string;
          classroomSectionUid: string;
          sender:
            | {
                __typename?: "LearnerSender";
                uid: string;
                name: string;
                avatar: string | null;
              }
            | {
                __typename?: "UserSender";
                uid: string;
                name: string;
                photo: string | null;
              };
        }
      | {
          __typename: "ClubNotification";
          classPostCommentUid: string | null;
          threadParentCommentUid: string | null;
          uid: string;
          createdAt: any;
          status: NotificationStatus;
          clubNotificationAction: ClubNotificationAction;
          clubClassPostUid: string;
          clubSectionUid: string;
          sender:
            | {
                __typename?: "LearnerSender";
                uid: string;
                name: string;
                avatar: string | null;
              }
            | {
                __typename?: "UserSender";
                uid: string;
                name: string;
                photo: string | null;
              };
        }
      | {
          __typename: "PrivateClassMessageNotification";
          privateClassMessageUid: string;
          isClub: boolean;
          uid: string;
          createdAt: any;
          status: NotificationStatus;
          privateClassMessageSectionUid: string;
          privateClassMessageThreadUid: string | null;
          sender:
            | {
                __typename?: "LearnerSender";
                uid: string;
                name: string;
                avatar: string | null;
              }
            | {
                __typename?: "UserSender";
                uid: string;
                name: string;
                photo: string | null;
              };
        }
    >;
  };
};

export type CurrentLearnerRecommendedTeachersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type CurrentLearnerRecommendedTeachersQuery = {
  __typename?: "Query";
  currentLearnerRecommendedTeachers: {
    __typename?: "RecommendedTeachers";
    recommendationType: TeacherRecommendationType | null;
    teachers: Array<{
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      leader_link: string | null;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
      };
      video: {
        __typename?: "Attachment";
        videoThumbnailUrl: string | null;
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    }>;
  };
};

export type CurrentLearnerSavedActivitiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrentLearnerSavedActivitiesQuery = {
  __typename?: "Query";
  currentLearner: {
    __typename?: "CurrentLearner";
    uid: string;
    savedActivities: Array<{
      __typename?: "SavedActivity";
      uid: string;
      activity_uid: string;
      created_at: any;
      listing: {
        __typename?: "Listing";
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          slug_id: string;
          price_cents: number | null;
          age_max: number | null;
          age_min: number | null;
          isClub: boolean;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          leader: {
            __typename?: "Leader";
            uid: string;
            name: string | null;
            photo: string | null;
          };
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
          videoForLearners: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      };
    }>;
  };
};

export type LearnerSaveActivityMutationVariables = Exact<{
  activityUid: Scalars["ID"];
  referer?: InputMaybe<Scalars["String"]>;
  attribution?: InputMaybe<Attribution>;
}>;

export type LearnerSaveActivityMutation = {
  __typename?: "Mutation";
  saveActivity: {
    __typename?: "SavedActivity";
    uid: string;
    activity_uid: string;
    created_at: any;
    listing: {
      __typename?: "Listing";
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        slug_id: string;
        price_cents: number | null;
        age_max: number | null;
        age_min: number | null;
        isClub: boolean;
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
        };
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
        videoForLearners: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    };
  };
};

export type LearnerUnsaveActivityMutationVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type LearnerUnsaveActivityMutation = {
  __typename?: "Mutation";
  unsaveActivity: boolean;
};

export type CurrentLearnerScheduleEventsQueryVariables = Exact<{
  start: Scalars["DateTime"];
  end?: InputMaybe<Scalars["DateTime"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  withPaused?: InputMaybe<Scalars["Boolean"]>;
  withNotStarted?: InputMaybe<Scalars["Boolean"]>;
}>;

export type CurrentLearnerScheduleEventsQuery = {
  __typename?: "Query";
  currentLearnerScheduleEvents: {
    __typename?: "ScheduleEvents";
    events: Array<{
      __typename?: "ScheduleEvent";
      uid: string;
      endTime: any;
      startTime: any;
      section: {
        __typename?: "Section";
        uid: string;
        start_time: any | null;
        end_time: any | null;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          subject: string | null;
          duration_weeks: number | null;
          summary: string | null;
          weekly_meetings: number | null;
          is_ongoing_weekly: boolean;
          isClub: boolean;
          isFlexSchedule: boolean;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
        };
        leader: { __typename?: "Leader"; uid: string; name: string | null };
      };
      enrollment: {
        __typename?: "Enrollment";
        uid: string;
        isPaused: boolean;
      } | null;
    }>;
  };
};

export type LearnerSimilarListingsByTfIdfQueryVariables = Exact<{
  activityUid: Scalars["ID"];
}>;

export type LearnerSimilarListingsByTfIdfQuery = {
  __typename?: "Query";
  listing: {
    __typename?: "Listing";
    similarListings: {
      __typename?: "SimilarListings";
      tfidf: Array<{
        __typename?: "Listing";
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          slug_id: string;
          price_cents: number | null;
          age_max: number | null;
          age_min: number | null;
          isClub: boolean;
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          leader: {
            __typename?: "Leader";
            uid: string;
            name: string | null;
            photo: string | null;
          };
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
          videoForLearners: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  } | null;
};

export type LearnerSingleAssignmentPostQueryVariables = Exact<{
  assignmentClassPostUid: Scalars["ID"];
}>;

export type LearnerSingleAssignmentPostQuery = {
  __typename?: "Query";
  assignmentClassPost: {
    __typename?: "AssignmentClassPost";
    uid: string;
    title: string;
    publishAt: any;
    submissionRequirement: SubmissionRequirementType;
    dueDate: any | null;
    user: {
      __typename?: "User";
      uid: string;
      name: string | null;
      photo: string | null;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    comments: Array<{
      __typename?: "AssignmentClassPostComment";
      uid: string;
      sentAt: any;
      isSubmission: boolean | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      replies: Array<{
        __typename?: "AssignmentClassPostComment";
        uid: string;
        sentAt: any;
        isSubmission: boolean | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }> | null;
    }>;
  } | null;
};

export type LearnerSinglePostQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  classPostUid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type LearnerSinglePostQuery = {
  __typename?: "Query";
  classroom: {
    __typename?: "Classroom";
    uid: string;
    usersCanComment: boolean;
    postByUid: {
      __typename?: "ClassPost";
      uid: string;
      title: string | null;
      estimatedDuration: number | null;
      blockType: BlockType | null;
      publishAt: any;
      isWelcomePost: boolean;
      learnerState: {
        __typename?: "ClassPostLearnerState";
        videoProgress: number;
        videoWatchCount: number;
        completedAt: any | null;
        heartedAt: any | null;
        lastViewedAt: any;
      } | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    } | null;
    mentionNames: Array<{
      __typename?: "MentionName";
      id: string;
      display: string;
      avatar: string | null;
      learnerUid: string | null;
      startTime: any | null;
    }>;
  };
};

export type LearnerSupportTopicsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LearnerSupportTopicsQuery = {
  __typename?: "Query";
  learnerSupportTopics: Array<{
    __typename?: "LearnerSupportTopic";
    title: string;
    description: string;
    type: LearnerSupportType;
    prompt: string | null;
    placeholder: string;
  }>;
};

export type SubmitLearnerSupportIssueMutationVariables = Exact<{
  issueType: LearnerSupportType;
  text?: InputMaybe<Scalars["String"]>;
}>;

export type SubmitLearnerSupportIssueMutation = {
  __typename?: "Mutation";
  submitLearnerSupportIssue: boolean;
};

export type GetLearnerToParentTransferTokenMutationVariables = Exact<{
  password?: InputMaybe<Scalars["String"]>;
}>;

export type GetLearnerToParentTransferTokenMutation = {
  __typename?: "Mutation";
  learnerToParentTransferToken: {
    __typename?: "AuthTransfer";
    transferToken: string | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
  };
};

export type GetLearnerToSiblingTransferTokenMutationVariables = Exact<{
  siblingUid: Scalars["ID"];
}>;

export type GetLearnerToSiblingTransferTokenMutation = {
  __typename?: "Mutation";
  learnerToSiblingTransferToken: {
    __typename?: "AuthTransferToken";
    transferToken: string;
  };
};

export type LearnerPrivateClassMessagesPageQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type LearnerPrivateClassMessagesPageQuery = {
  __typename?: "Query";
  currentLearner: {
    __typename?: "CurrentLearner";
    uid: string;
    name: string | null;
    email: string | null;
    username: string | null;
    age: number | null;
    avatar: string | null;
    unlockedAvatars: Array<string>;
    pronoun: string | null;
    accessLevel: LearnerAccessLevel;
    intro: string | null;
    timeZone: string;
    optedOutOfPersonalizedRecommendationsAt: any | null;
    hasMarketingConsent: boolean | null;
    hasHealthConsent: boolean | null;
    hasUpcomingScheduleEvent: boolean;
    isLoginEnabled: boolean;
    isVerified: boolean;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    };
    siblings: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      avatar: string | null;
      age: number | null;
    }>;
    enrollmentToReviewSoon: {
      __typename?: "Enrollment";
      uid: string;
      section: {
        __typename?: "Section";
        uid: string;
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          subject: string | null;
          is_ongoing_weekly: boolean;
        };
      } | null;
    } | null;
    experiments: Array<{
      __typename?: "LearnerExperiment";
      name: string;
      variant: string;
    }>;
    interfacePreferences: Array<{
      __typename?: "LearnerInterfacePreference";
      name: string;
      value: any;
    }>;
  };
  section: {
    __typename?: "Section";
    filledSpaceCount: number;
    uid: string;
    activity_uid: string;
    start_time: any | null;
    end_time: any | null;
    startsAtNight: boolean | null;
    is_cross_listed: boolean;
    size_max: number | null;
    size_min: number | null;
    isPublished: boolean | null;
    price_cents: number | null;
    published_at: any | null;
    updated_at: any;
    canceled_at: any | null;
    deleted_at: any | null;
    ongoing_stopped_at: any | null;
    duration_minutes: number | null;
    usesOutschoolVideoChat: boolean;
    usersCanSendPrivateMessage: boolean;
    currentUserCanManage: boolean;
    isBuyable: boolean;
    allowsTeacherTransfer: boolean;
    currentLearnerEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      section_uid: string | null;
      created_at: any | null;
      confirmed_at: any | null;
      confirmedAt: any | null;
      withdrawn_at: any | null;
      withdrawnAt: any | null;
      usersCanCommunicate: boolean;
      details: {
        __typename?: "EnrollmentDetails";
        name: string | null;
        age: string | null;
        attendedAt: any | null;
        message: string | null;
      };
    };
    activity: {
      __typename?: "Activity";
      uid: string;
      slug_id: string;
      user_uid: string;
      title: string;
      class_experience: string | null;
      learning_goals: string | null;
      assessment: string | null;
      homework: string | null;
      prerequisites: string | null;
      published_at: any | null;
      is_online: boolean;
      age_min: number | null;
      age_max: number | null;
      size_min: number | null;
      size_max: number | null;
      duration_minutes: number | null;
      duration_weeks: number | null;
      weekly_meetings: number | null;
      price_cents: number | null;
      summary: string | null;
      is_ongoing_weekly: boolean;
      subject: string | null;
      languageOfInstruction: any | null;
      summaryForLearners: string | null;
      isClub: boolean;
      isAutoSchedulingEnabled: boolean | null;
      autoSchedulingDaysNoticeMin: number | null;
      autoSchedulingDaysNoticeMax: number | null;
      hasTeacherSchedule: boolean;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        leader_link: string | null;
        created_at: any | null;
        photo: string | null;
        suspended_at: any | null;
        cityState: string | null;
        socialOptOut: boolean;
        is_crosslister: boolean | null;
        timeZone: string | null;
        hasAvailabilitySet: boolean;
        approved: boolean;
        hasBackgroundCheckExpired: boolean | null;
        details: {
          __typename?: "LeaderDetails";
          about: string | null;
          headline: string | null;
          headlineTranslated: string | null;
          countryOfResidence: string | null;
        };
        ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
        teacherForSellerOrg: {
          __typename?: "SellerOrg";
          uid: string;
          name: string;
        } | null;
      };
      refundPolicy: {
        __typename?: "RefundPolicy";
        name: string;
        description: string;
      };
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
    };
    nextOngoingMeeting: {
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      deleted_at: any | null;
      created_at: any | null;
    } | null;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
    details: {
      __typename?: "SectionDetails";
      autoScheduledDraft: boolean | null;
      onlineClassroom: {
        __typename?: "OnlineClassroom";
        type: string | null;
        url: string | null;
      } | null;
    };
    prepaidOngoingPeriodOptions: Array<{
      __typename?: "Period";
      startOfIsoWeek: any;
      endOfIsoWeek: any;
    }> | null;
  } | null;
};

export type LearnerSectionFragmentFragment = {
  __typename?: "Section";
  uid: string;
  activity_uid: string;
  start_time: any | null;
  end_time: any | null;
  startsAtNight: boolean | null;
  is_cross_listed: boolean;
  size_max: number | null;
  size_min: number | null;
  isPublished: boolean | null;
  price_cents: number | null;
  published_at: any | null;
  updated_at: any;
  canceled_at: any | null;
  deleted_at: any | null;
  ongoing_stopped_at: any | null;
  duration_minutes: number | null;
  usesOutschoolVideoChat: boolean;
  usersCanSendPrivateMessage: boolean;
  currentUserCanManage: boolean;
  isBuyable: boolean;
  allowsTeacherTransfer: boolean;
  nextOngoingMeeting: {
    __typename?: "Meeting";
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
  } | null;
  leader: { __typename?: "Leader"; uid: string; name: string | null };
  details: {
    __typename?: "SectionDetails";
    autoScheduledDraft: boolean | null;
  };
  prepaidOngoingPeriodOptions: Array<{
    __typename?: "Period";
    startOfIsoWeek: any;
    endOfIsoWeek: any;
  }> | null;
};

export type LearnerSearchTeacherActivitiesQueryVariables = Exact<{
  teacherUid: Scalars["ID"];
}>;

export type LearnerSearchTeacherActivitiesQuery = {
  __typename?: "Query";
  learnerSearchTeacherActivities: {
    __typename?: "LearnerSearchTeacherActivities";
    cursor: string | null;
    activities: Array<{
      __typename?: "Activity";
      uid: string;
      title: string;
      slug_id: string;
      price_cents: number | null;
      age_max: number | null;
      age_min: number | null;
      isClub: boolean;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
      };
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      videoForLearners: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    }>;
  };
};

export type LearnerTeacherPublicProfileQueryVariables = Exact<{
  leaderLink?: InputMaybe<Scalars["String"]>;
}>;

export type LearnerTeacherPublicProfileQuery = {
  __typename?: "Query";
  publicProfileNew: {
    __typename?: "PublicProfile";
    uid: string;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      leader_link: string | null;
      details: { __typename?: "LeaderDetails"; about: string | null };
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
  } | null;
};

export type ThreadDetailQueryVariables = Exact<{
  threadUid: Scalars["ID"];
}>;

export type ThreadDetailQuery = {
  __typename?: "Query";
  thread: {
    __typename?: "Thread";
    uid: string;
    classPost: {
      __typename?: "ClassPost";
      uid: string;
      title: string | null;
    } | null;
    learningAssignmentClassPost: {
      __typename?: "AssignmentClassPost";
      uid: string;
      title: string;
    } | null;
    messages: Array<{
      __typename?: "PrivateClassMessage";
      uid: string;
      sentAt: any;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }>;
  };
};

export type ThreadsForSectionQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  searchQuery?: InputMaybe<Scalars["String"]>;
}>;

export type ThreadsForSectionQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    end_time: any | null;
    unreadThreadsCount: number;
    threads: Array<{
      __typename?: "Thread";
      uid: string;
      unreadCount: number;
      classPost: {
        __typename?: "ClassPost";
        uid: string;
        title: string | null;
        blockType: BlockType | null;
      } | null;
      learningAssignmentClassPost: {
        __typename?: "AssignmentClassPost";
        uid: string;
        title: string;
      } | null;
      latestMessage: {
        __typename?: "PrivateClassMessage";
        uid: string;
        sentAt: any;
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            file: { __typename?: "File"; mimetype: string | null };
          }>;
          video: { __typename?: "Attachment"; uid: string } | null;
        };
      } | null;
    }>;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
    };
  } | null;
};

export type UpdateClassPostLearnerStateMutationVariables = Exact<{
  classPostUid: Scalars["ID"];
  videoProgress?: InputMaybe<Scalars["Int"]>;
  videoWatchCount?: InputMaybe<Scalars["Int"]>;
  markComplete?: InputMaybe<Scalars["Boolean"]>;
  hearted?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UpdateClassPostLearnerStateMutation = {
  __typename?: "Mutation";
  updateClassPostLearnerState: {
    __typename?: "ClassPostLearnerState";
    videoProgress: number;
    videoWatchCount: number;
    completedAt: any | null;
    heartedAt: any | null;
    lastViewedAt: any;
  };
};

export type VerifyLearnerTransferMutationVariables = Exact<{
  token: Scalars["String"];
  isLearnerLogin: Scalars["Boolean"];
}>;

export type VerifyLearnerTransferMutation = {
  __typename?: "Mutation";
  verifyLearnerTransfer:
    | {
        __typename?: "AuthenticationV2";
        refreshToken: string;
        sessionToken: string;
      }
    | { __typename?: "AuthenticationV1"; sessionToken: string };
};

export type SaveAvatarMutationVariables = Exact<{
  imageCdnUrl: Scalars["String"];
  name: Scalars["String"];
  description: Scalars["String"];
  creatureType: Scalars["String"];
}>;

export type SaveAvatarMutation = {
  __typename?: "Mutation";
  saveAvatar: {
    __typename?: "LearnerAvatar";
    uid: string;
    learnerUid: string;
    attachmentUid: string;
    description: string | null;
    animals: Array<string>;
    creatureType: string | null;
    createdAt: any;
  };
};

export type ClearAvatarsMutationVariables = Exact<{ [key: string]: never }>;

export type ClearAvatarsMutation = {
  __typename?: "Mutation";
  clearAvatars: boolean;
};

export type StartAvatarGenerationMutationVariables = Exact<{
  creatureType: Scalars["String"];
  style: Scalars["String"];
  background: Scalars["String"];
  gender?: InputMaybe<Scalars["String"]>;
  ageRange?: InputMaybe<Scalars["String"]>;
  hairColor?: InputMaybe<Scalars["String"]>;
  skinColor?: InputMaybe<Scalars["String"]>;
}>;

export type StartAvatarGenerationMutation = {
  __typename?: "Mutation";
  startAvatarGeneration: {
    __typename?: "AvatarGenerationStartResult";
    generationId: string;
    name: string;
    description: string;
  };
};

export type CheckAvatarGenerationQueryVariables = Exact<{
  generationId: Scalars["String"];
  avatarName: Scalars["String"];
  creatureType: Scalars["String"];
}>;

export type CheckAvatarGenerationQuery = {
  __typename?: "Query";
  checkAvatarGeneration: {
    __typename?: "AvatarGenerationStatusResult";
    status: string;
    imageUrl: string | null;
  };
};

export type LearnerClassPostList_ClassroomFragment = {
  __typename?: "Classroom";
  usersCanPost: boolean;
  usersCanComment: boolean;
  posts: Array<{
    __typename?: "ClassPost";
    uid: string;
    isWelcomePost: boolean;
    publishAt: any;
    title: string | null;
    promotedAt: any | null;
    pinnedAt: any | null;
    mentionedEnrollmentUids: Array<string>;
    backgroundColor: string | null;
    score: number | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    commentsPreview: {
      __typename?: "CommentsPreview";
      remainingCommentsCount: number;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  }>;
  unpublishedPosts: Array<{
    __typename?: "ClassPost";
    uid: string;
    isWelcomePost: boolean;
    publishAt: any;
    title: string | null;
    promotedAt: any | null;
    pinnedAt: any | null;
    mentionedEnrollmentUids: Array<string>;
    backgroundColor: string | null;
    score: number | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    commentsPreview: {
      __typename?: "CommentsPreview";
      remainingCommentsCount: number;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  }>;
  activity: {
    __typename?: "Activity";
    user_uid: string;
    leader: {
      __typename?: "Leader";
      uid: string;
      leader_link: string | null;
      name: string | null;
    };
  };
  section: {
    __typename?: "Section";
    currentUserCanManage: boolean;
    uid: string;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      recordingAvailability: RecordingAvailability;
      recordingRequests: Array<{
        __typename?: "RecordingRequest";
        requestedAt: any;
        message: string;
        requestedBy: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        };
      }>;
      classRecordings: Array<
        | {
            __typename?: "ClassRecording";
            uid: string;
            startTime: any;
            endTime: any;
          }
        | {
            __typename?: "ZoomRecording";
            uid: string;
            startTime: any;
            endTime: any;
          }
      >;
      attendances: Array<{
        __typename?: "Attendance";
        learner: { __typename?: "Learner"; name: string | null };
      }>;
    }>;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
  };
  mentionNames: Array<{
    __typename?: "MentionName";
    id: string;
    display: string;
    avatar: string | null;
    learnerUid: string | null;
    startTime: any | null;
  }>;
};

export type MarkLessonCompleteMutationVariables = Exact<{
  recordingUid: Scalars["ID"];
}>;

export type MarkLessonCompleteMutation = {
  __typename?: "Mutation";
  markLessonCompleteFromClassRecording: boolean;
};

export type MarkLessonCompleteButtonMutationVariables = Exact<{
  lessonUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
}>;

export type MarkLessonCompleteButtonMutation = {
  __typename?: "Mutation";
  markLessonCompleteForLearner: boolean;
};

export type ClassCardContents_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  title: string;
  weekly_meetings: number | null;
  duration_weeks: number | null;
  is_ongoing_weekly: boolean;
  isClub: boolean;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type ClassCardContents_ScheduleEventFragment = {
  __typename?: "ScheduleEvent";
  uid: string;
  startTime: any;
  endTime: any;
  section: { __typename?: "Section"; uid: string };
  enrollment: {
    __typename?: "Enrollment";
    uid: string;
    isPaused: boolean;
  } | null;
};

export type ClubCardContents_ClubFragment = {
  __typename?: "Club";
  uid: string;
  currentLearnerPostCount: number;
  currentLearnerPostReplyCount: number;
  promotedPostCount: number;
  activity: {
    __typename?: "Activity";
    uid: string;
    title: string;
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  };
};

export type ListLearnerClubsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  countCommentsAfter?: InputMaybe<Scalars["DateTime"]>;
}>;

export type ListLearnerClubsQuery = {
  __typename?: "Query";
  currentLearnerClubs: Array<{
    __typename?: "Club";
    uid: string;
    currentLearnerPostCount: number;
    currentLearnerPostReplyCount: number;
    promotedPostCount: number;
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
    };
  }>;
};

export type EventTime_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  isClub: boolean;
  weekly_meetings: number | null;
  duration_weeks: number | null;
};

export type EventCard_ActivityFragment = {
  __typename?: "Activity";
  uid: string;
  title: string;
  isClub: boolean;
  weekly_meetings: number | null;
  duration_weeks: number | null;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type SaveLearnerMixTopicMutationVariables = Exact<{
  input: SaveLearnerMixTopicInput;
}>;

export type SaveLearnerMixTopicMutation = {
  __typename?: "Mutation";
  saveLearnerMixTopic: { __typename?: "LearnerMixTopic"; uid: string };
};

export type DeleteLearnerMixTopicMutationVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type DeleteLearnerMixTopicMutation = {
  __typename?: "Mutation";
  deleteLearnerMixTopic: boolean;
};

export type CreateQuizTopicFromMixTopicMutationVariables = Exact<{
  mixTopicUid: Scalars["ID"];
  topicName?: InputMaybe<Scalars["String"]>;
}>;

export type CreateQuizTopicFromMixTopicMutation = {
  __typename?: "Mutation";
  createQuizTopicFromMixTopic: {
    __typename?: "QuizWriterTopicSuggestion";
    uid: string;
  };
};

export type GenerateLearnerMixTopicMutationVariables = Exact<{
  sourceTopics: Array<Scalars["String"]> | Scalars["String"];
}>;

export type GenerateLearnerMixTopicMutation = {
  __typename?: "Mutation";
  generateLearnerMixTopic: {
    __typename?: "GeneratedLearnerMixTopic";
    sourceTopics: Array<string>;
    title: string;
    description: string;
    generationId: string;
  };
};

export type PollGeneratedImageQueryVariables = Exact<{
  generationId: Scalars["String"];
  title: Scalars["String"];
}>;

export type PollGeneratedImageQuery = {
  __typename?: "Query";
  pollGeneratedImage: {
    __typename?: "PollGeneratedImageResult";
    imageUrl: string;
  };
};

export type LearnerMixTopicsQueryVariables = Exact<{ [key: string]: never }>;

export type LearnerMixTopicsQuery = {
  __typename?: "Query";
  learnerMixTopics: Array<{
    __typename?: "LearnerMixTopic";
    uid: string;
    title: string;
    description: string;
    attachmentUrl: string;
  }>;
};

export type DefaultMixTopicsQueryVariables = Exact<{ [key: string]: never }>;

export type DefaultMixTopicsQuery = {
  __typename?: "Query";
  defaultMixTopics: Array<{
    __typename?: "DefaultMixTopic";
    id: string;
    title: string;
    description: string;
  }>;
};

export type LearnerQuizWriterTopicSuggestionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LearnerQuizWriterTopicSuggestionsQuery = {
  __typename?: "Query";
  quizWriterTopicSuggestions: Array<{
    __typename?: "QuizWriterTopicSuggestion";
    uid: string;
    name: string;
    showAsUnlocked: boolean;
  }>;
};

export type LearnerQuizWriterTopicSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]>;
}>;

export type LearnerQuizWriterTopicSearchQuery = {
  __typename?: "Query";
  quizWriterTopicSearch: Array<{
    __typename?: "QuizWriterTopicSuggestion";
    uid: string;
    name: string;
    showAsUnlocked: boolean;
  }>;
};

export type LearnerQuizDeleteLearnerTopicMutationVariables = Exact<{
  topicUid: Scalars["ID"];
}>;

export type LearnerQuizDeleteLearnerTopicMutation = {
  __typename?: "Mutation";
  deleteLearnerTopic: boolean;
};

export type LearnerQuizStartQuizAttemptMutationVariables = Exact<{
  quizUid: Scalars["ID"];
}>;

export type LearnerQuizStartQuizAttemptMutation = {
  __typename?: "Mutation";
  startQuizAttempt: {
    __typename?: "QuizAttempt";
    uid: string;
    quizUid: string;
    learnerUid: string;
    createdAt: any;
    updatedAt: any;
    attempt: {
      __typename?: "QuizAttemptPayload";
      completed: boolean | null;
      selectedAnswers: Array<{
        __typename?: "QuizAttemptAnswerSelection";
        questionIndex: number;
        optionIndex: number;
      }>;
      answeredCorrectByIndex: Array<{
        __typename?: "QuizAttemptCorrectness";
        questionIndex: number;
        correct: boolean;
      }>;
    } | null;
  };
};

export type LearnerQuizUpdateQuizAttemptMutationVariables = Exact<{
  attemptUid: Scalars["ID"];
  attempt: QuizAttemptPatchInput;
}>;

export type LearnerQuizUpdateQuizAttemptMutation = {
  __typename?: "Mutation";
  updateQuizAttempt: {
    __typename?: "QuizAttempt";
    uid: string;
    quizUid: string;
    learnerUid: string;
    createdAt: any;
    updatedAt: any;
    attempt: {
      __typename?: "QuizAttemptPayload";
      completed: boolean | null;
      selectedAnswers: Array<{
        __typename?: "QuizAttemptAnswerSelection";
        questionIndex: number;
        optionIndex: number;
      }>;
      answeredCorrectByIndex: Array<{
        __typename?: "QuizAttemptCorrectness";
        questionIndex: number;
        correct: boolean;
      }>;
    } | null;
  };
};

export type LearnerQuizCompleteQuizAttemptMutationVariables = Exact<{
  attemptUid: Scalars["ID"];
}>;

export type LearnerQuizCompleteQuizAttemptMutation = {
  __typename?: "Mutation";
  completeQuizAttempt: {
    __typename?: "QuizAttempt";
    uid: string;
    quizUid: string;
    learnerUid: string;
    createdAt: any;
    updatedAt: any;
    attempt: {
      __typename?: "QuizAttemptPayload";
      completed: boolean | null;
      selectedAnswers: Array<{
        __typename?: "QuizAttemptAnswerSelection";
        questionIndex: number;
        optionIndex: number;
      }>;
      answeredCorrectByIndex: Array<{
        __typename?: "QuizAttemptCorrectness";
        questionIndex: number;
        correct: boolean;
      }>;
    } | null;
  };
};

export type SaveNewLearnerPasswordMutationVariables = Exact<{
  currentPassword: Scalars["String"];
  newPassword: Scalars["String"];
}>;

export type SaveNewLearnerPasswordMutation = {
  __typename?: "Mutation";
  changeLoggedInLearnerPassword: boolean;
};

export type GetCouponQueryVariables = Exact<{
  couponID: Scalars["String"];
}>;

export type GetCouponQuery = {
  __typename?: "Query";
  coupon: { __typename?: "Coupon"; name: string; createdBy: string | null };
};

export type ActivityFragmentFragment = {
  __typename?: "Activity";
  uid: string;
  slug_id: string;
  user_uid: string;
  title: string;
  titleTranslated: string | null;
  url: string;
  path: string;
  class_experience: string | null;
  learning_goals: string | null;
  learningGoals: Array<string>;
  assessment: string | null;
  homework: string | null;
  grading_policy: string | null;
  prerequisites: string | null;
  published_at: any | null;
  is_online: boolean;
  age_min: number | null;
  age_max: number | null;
  english_proficiency_level: EnglishProficiencyLevel | null;
  grade_level_min: string | null;
  grade_level_max: string | null;
  size_min: number | null;
  size_max: number | null;
  duration_minutes: number | null;
  duration_weeks: number | null;
  weekly_meetings: number | null;
  price_cents: number | null;
  priceCredits: number | null;
  summary: string | null;
  summaryTranslated: string | null;
  is_ongoing_weekly: boolean;
  subject: string | null;
  languageOfInstruction: any | null;
  summaryForLearners: string | null;
  allowWaitlist: boolean | null;
  isClub: boolean;
  isAutoSchedulingEnabled: boolean | null;
  autoSchedulingDaysNoticeMin: number | null;
  autoSchedulingDaysNoticeMax: number | null;
  allows_recurring_payment: boolean | null;
  allows_late_enrollments_for_fixed_length_classes: boolean;
  allowsFutureOngoingEnrollments: boolean;
  has_building_content: boolean | null;
  hasTeacherSchedule: boolean;
  isFlexSchedule: boolean;
  isSelfPaced: boolean;
  isOneTime: boolean;
  classFormat: EducatorSelectedFormat;
  classroomType: ClassroomType;
  isIncludedWithMembership: boolean;
  strictAgeRange: {
    __typename?: "AgeRangeType";
    min: number;
    max: number;
  } | null;
  proficiency_level: {
    __typename?: "ProficiencyLevel";
    level: Array<string | null> | null;
    text: string | null;
  } | null;
  refundPolicy: {
    __typename?: "RefundPolicy";
    name: string;
    description: string;
    type: RefundPolicyType;
  };
  photo: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
  photoSquare: { __typename?: "Attachment"; fileUrl: string } | null;
};

export type AddClassPostMutationVariables = Exact<{
  classPostInput: ClassPostInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type AddClassPostMutation = {
  __typename?: "Mutation";
  addClassPost: {
    __typename?: "ClassPost";
    uid: string;
    isWelcomePost: boolean;
    publishAt: any;
    title: string | null;
    promotedAt: any | null;
    pinnedAt: any | null;
    mentionedEnrollmentUids: Array<string>;
    backgroundColor: string | null;
    score: number | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    commentsPreview: {
      __typename?: "CommentsPreview";
      remainingCommentsCount: number;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  };
};

export type AddClassPostForLessonMutationVariables = Exact<{
  classPostForLessonInput: ClassPostForLessonInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type AddClassPostForLessonMutation = {
  __typename?: "Mutation";
  addClassPostForLesson: {
    __typename?: "ClassPost";
    uid: string;
    isWelcomePost: boolean;
    publishAt: any;
    title: string | null;
    promotedAt: any | null;
    pinnedAt: any | null;
    mentionedEnrollmentUids: Array<string>;
    backgroundColor: string | null;
    score: number | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    commentsPreview: {
      __typename?: "CommentsPreview";
      remainingCommentsCount: number;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  };
};

export type AddAssignmentClassPostMutationVariables = Exact<{
  createAssignmentClassPostInput: CreateAssignmentClassPostInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type AddAssignmentClassPostMutation = {
  __typename?: "Mutation";
  addAssignmentClassPost: {
    __typename?: "AssignmentClassPost";
    uid: string;
    title: string;
    created_at: any;
    deleted_at: any | null;
    publishAt: any;
    dueDate: any | null;
    submissionRequirement: SubmissionRequirementType;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    lesson: { __typename?: "Lesson"; uid: string; title: string | null } | null;
    lessonPost: {
      __typename?: "AssignmentLessonPost";
      uid: string;
      title: string | null;
      lessonUid: string;
      orderInLesson: number;
      deleted_at: any | null;
      submissionRequirement: SubmissionRequirementType;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    } | null;
  };
};

export type DeleteAssignmentClassPostMutationVariables = Exact<{
  uid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type DeleteAssignmentClassPostMutation = {
  __typename?: "Mutation";
  deleteAssignmentClassPost: {
    __typename?: "AssignmentClassPost";
    uid: string;
    title: string;
    created_at: any;
    deleted_at: any | null;
    publishAt: any;
    dueDate: any | null;
    submissionRequirement: SubmissionRequirementType;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    lesson: { __typename?: "Lesson"; uid: string; title: string | null } | null;
    lessonPost: {
      __typename?: "AssignmentLessonPost";
      uid: string;
      title: string | null;
      lessonUid: string;
      orderInLesson: number;
      deleted_at: any | null;
      submissionRequirement: SubmissionRequirementType;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    } | null;
  };
};

export type UpdateAssignmentClassPostMutationVariables = Exact<{
  uid: Scalars["ID"];
  updateAssignmentClassPostInput: UpdateAssignmentClassPostInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UpdateAssignmentClassPostMutation = {
  __typename?: "Mutation";
  updateAssignmentClassPost: {
    __typename?: "AssignmentClassPost";
    uid: string;
    title: string;
    created_at: any;
    deleted_at: any | null;
    publishAt: any;
    dueDate: any | null;
    submissionRequirement: SubmissionRequirementType;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    lesson: { __typename?: "Lesson"; uid: string; title: string | null } | null;
    lessonPost: {
      __typename?: "AssignmentLessonPost";
      uid: string;
      title: string | null;
      lessonUid: string;
      orderInLesson: number;
      deleted_at: any | null;
      submissionRequirement: SubmissionRequirementType;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    } | null;
  };
};

export type DeleteClassPostMutationVariables = Exact<{
  classPostUid: Scalars["ID"];
}>;

export type DeleteClassPostMutation = {
  __typename?: "Mutation";
  deleteClassPost: boolean | null;
};

export type RequestPasswordChangeMutationVariables = Exact<{
  emailOrUsername: Scalars["String"];
}>;

export type RequestPasswordChangeMutation = {
  __typename?: "Mutation";
  requestPasswordChange: boolean;
};

export type GetMagicLoginLinkMutationVariables = Exact<{
  email: Scalars["String"];
}>;

export type GetMagicLoginLinkMutation = {
  __typename?: "Mutation";
  getMagicLoginLink: boolean;
};

export type LoginWithMagicLinkMutationVariables = Exact<{
  token: Scalars["String"];
}>;

export type LoginWithMagicLinkMutation = {
  __typename?: "Mutation";
  loginWithMagicLink:
    | {
        __typename: "AuthenticationV2";
        refreshToken: string;
        sessionToken: string;
        learnerTransferToken: string | null;
      }
    | {
        __typename: "AuthenticationV1";
        sessionToken: string;
        learnerTransferToken: string | null;
      };
};

export type RequestPinChangeMutationVariables = Exact<{
  email: Scalars["String"];
}>;

export type RequestPinChangeMutation = {
  __typename?: "Mutation";
  requestPinChange: boolean;
};

export type VerifyParentTransferMutationVariables = Exact<{
  token: Scalars["String"];
  isParentLogin: Scalars["Boolean"];
}>;

export type VerifyParentTransferMutation = {
  __typename?: "Mutation";
  verifyParentTransfer:
    | {
        __typename?: "AuthenticationV2";
        refreshToken: string;
        sessionToken: string;
      }
    | { __typename?: "AuthenticationV1"; sessionToken: string };
};

export type ClassPostFragmentFragment = {
  __typename?: "ClassPost";
  uid: string;
  isWelcomePost: boolean;
  publishAt: any;
  sender: {
    __typename?: "MessageSender";
    uid: string;
    name: string | null;
    photo: string | null;
    avatar: string | null;
    isLearner: boolean;
  };
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type SearchSuggestionsQueryVariables = Exact<{
  query: Scalars["String"];
  size?: InputMaybe<Scalars["Int"]>;
}>;

export type SearchSuggestionsQuery = {
  __typename?: "Query";
  searchSuggestions: {
    __typename?: "SearchSuggestions";
    topicSuggestions: Array<{
      __typename?: "Topic";
      uid: string;
      label: string;
      category: string | null;
    }>;
    teacherSuggestions: Array<{
      __typename?: "Leader";
      uid: string;
      name: string | null;
      photo: string | null;
      leader_link: string | null;
    }>;
  };
};

export type SectionRecordingsQueryVariables = Exact<{
  uid: Scalars["ID"];
}>;

export type SectionRecordingsQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    classRecordings: Array<
      | {
          __typename?: "ClassRecording";
          uid: string;
          startTime: any;
          endTime: any;
        }
      | {
          __typename?: "ZoomRecording";
          uid: string;
          startTime: any;
          endTime: any;
        }
    >;
  } | null;
};

export type CurrentUserAttachmentFragmentFragment = {
  __typename?: "Attachment";
  uid: string;
  fileUrl: string;
  conversionStatus: string | null;
  created_at: any;
  file: {
    __typename?: "File";
    filename: string;
    mimetype: string | null;
    size: number;
    url: string;
    thumbUrl: string | null;
  };
};

export type CurrentUserTeacherApplicationFragmentFragment = {
  __typename?: "TeacherApplication";
  uid: string;
  legal_name: string | null;
  status: TeacherApplicationStatus;
  submitted_at: any | null;
  reviewed_at: any | null;
  teaching_experience: string | null;
  teaching_credentials: string | null;
  class_types: string | null;
  online_profiles: string | null;
  sample_classes: string | null;
  class_subjects: Array<string | null> | null;
  age_ranges_taught: Array<string | null> | null;
  years_of_experience: string | null;
  how_did_you_hear_about_us: string | null;
  experience_types: Array<string | null> | null;
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
};

export type ChildFragmentFragment = {
  __typename?: "Child";
  uid: string;
  name: string | null;
  age: number | null;
  birthMonth: number | null;
  date_of_birth: any | null;
  birthYear: number | null;
  email: string | null;
  avatar: string | null;
  unlockedAvatars: Array<string>;
  pronoun: string | null;
  intro: string | null;
  deleted_at: any | null;
  email_confirmed_at: any | null;
  hasMarketingConsent: boolean | null;
  hasHealthConsent: boolean | null;
  isLoginEnabled: boolean;
  username: string | null;
  hasPassword: boolean;
  hasEsaMembership: boolean;
  esaMembershipProgram: string | null;
  attributes: Array<{
    __typename?: "EntityAttribute";
    uid: string;
    key: string;
    value: string;
    source: string | null;
  }>;
  entityAvailabilitySchedule: {
    __typename?: "EntityAvailabilitySchedule";
    entityAvailabilities: Array<{
      __typename?: "EntityAvailability";
      startHour: number;
      startMinute: number;
      day: number;
      endHour: number;
      endMinute: number;
      uid: string;
    }>;
  } | null;
};

export type CurrentUserChildFragmentFragment = {
  __typename?: "Child";
  uid: string;
  name: string | null;
  age: number | null;
  birthMonth: number | null;
  date_of_birth: any | null;
  birthYear: number | null;
  email: string | null;
  avatar: string | null;
  unlockedAvatars: Array<string>;
  pronoun: string | null;
  intro: string | null;
  deleted_at: any | null;
  email_confirmed_at: any | null;
  hasMarketingConsent: boolean | null;
  hasHealthConsent: boolean | null;
  isLoginEnabled: boolean;
  username: string | null;
  hasPassword: boolean;
  hasEsaMembership: boolean;
  esaMembershipProgram: string | null;
  attributes: Array<{
    __typename?: "EntityAttribute";
    uid: string;
    key: string;
    value: string;
    source: string | null;
  }>;
  entityAvailabilitySchedule: {
    __typename?: "EntityAvailabilitySchedule";
    entityAvailabilities: Array<{
      __typename?: "EntityAvailability";
      startHour: number;
      startMinute: number;
      day: number;
      endHour: number;
      endMinute: number;
      uid: string;
    }>;
  } | null;
};

export type PricingOfferFragmentFragment = {
  __typename?: "PricingOffer";
  uid: string;
  name: string;
  userLimitCents: number;
  purchaseLimitCents: number | null;
  totalCapCents: number;
  startAfter: any;
  endBy: any;
  buyerOrgName: string | null;
  isTotalCapReached: boolean;
  remainingCapCents: number | null;
  requirePaymentMethod: boolean;
  isOfferLimitReached: boolean;
  userOfferEmail: string | null;
  discount: number | null;
  isFinancialAid: boolean;
};

export type DefaultScheduleFiltersFragmentFragment = {
  __typename?: "UserScheduleFilters";
  startAfter: string | null;
  endBy: string | null;
  startAfterTime: number | null;
  endByTime: number | null;
  dow: string | null;
};

export type InterfacePreferencesFragmentFragment = {
  __typename?: "InterfacePreferences";
  activityFormatDescriptionFlexHidden: boolean;
  activityFormatDescriptionOngoingHidden: boolean;
  activityFormatDescriptionOneTimeHidden: boolean;
  activityFormatDescriptionMultiDayHidden: boolean;
  defaultScheduleFilters: {
    __typename?: "UserScheduleFilters";
    startAfter: string | null;
    endBy: string | null;
    startAfterTime: number | null;
    endByTime: number | null;
    dow: string | null;
  };
};

export type FullCurrentUserFragmentFragment = {
  __typename?: "User";
  uid: string;
  slug_id: string;
  name: string | null;
  email: string | null;
  isLearnerModeEnabled: boolean | null;
  confirmed_at: any | null;
  subscribed_at: any | null;
  email_bounced_at: any | null;
  default_currency: string | null;
  phone: string | null;
  photo: string | null;
  leader_subscribed_at: any | null;
  calendar_uid: string;
  intercomUserHash: string | null;
  payout_email: string | null;
  owner_of_seller_org_uid: string | null;
  admin_for_organization_uid: string | null;
  do_not_sell_my_personal_info: boolean;
  background_checked_at: any | null;
  background_check_started_at: any | null;
  interview_scheduled_at: any | null;
  interviewed_at: any | null;
  classroom_training_scheduled_at: any | null;
  classroom_trained_at: any | null;
  latestLegalName: string | null;
  hasCompletedRequiredProfessionalLearning: boolean;
  hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
  hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
  teacher_approved_at: any | null;
  is_crosslister: boolean | null;
  introduction: string | null;
  created_at: any;
  updated_at: any;
  deleted_at: any | null;
  suspended_at: any | null;
  is_admin: boolean | null;
  learner_uses_parent_mode: boolean;
  leader_link: string | null;
  unreadMessageThreadsCount: number;
  unreadPrivateClassMessageThreadsCount: number;
  unreadAssignmentCommentThreadsCount: number;
  roles: Array<string> | null;
  locale: UserLocale;
  isRecordingAutopostEnabled: boolean | null;
  learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
  anonymousId: string | null;
  wasReferred: boolean;
  isEducatorBetaTester: boolean | null;
  consented_to_coppa_notice_at: any | null;
  hasVerifiedIdentity: boolean | null;
  consent_to_share_class_history: boolean | null;
  consent_to_share_favourites: boolean | null;
  privacy_state: string | null;
  hasAcceptedNewPrivacyTerms: boolean;
  profile_link_uid: string | null;
  hasSubscription: boolean;
  hasEverSubscribed: boolean;
  hasEsaMembership: boolean;
  esaMembershipPrograms: Array<string> | null;
  canPayWithSubscriptionCredits: boolean;
  upgradablePackages: Array<number | null> | null;
  requiresMembershipForEnrollment: boolean | null;
  hasUsedPublicFunding: boolean | null;
  isCharterUser: boolean | null;
  otherEmailDetails: Array<{
    __typename?: "OtherEmailDetails";
    uid: string;
    email: string;
    confirmed_at: any | null;
  } | null> | null;
  firstPaidEnrollment: {
    __typename?: "Enrollment";
    uid: string;
    confirmed_at: any | null;
  } | null;
  details: {
    __typename?: "UserDetails";
    about: string | null;
    headline: string | null;
    countryOfResidence: string | null;
    introduction: string | null;
    browserTimeZone: string | null;
    timeRangeAfterSchool: boolean | null;
    timeRangeSchool: boolean | null;
    timeRangeWeekend: boolean | null;
    socialOptOut: boolean | null;
    howFoundOutschool: string | null;
    howFoundOutschoolOther: string | null;
    educationApproach: string | null;
    adminDashboardUrl: string | null;
    experiments: Array<string | null> | null;
    bannerClosedAt: string | null;
  };
  location: {
    __typename?: "Location";
    address: string | null;
    city: string | null;
    lat: number | null;
    lng: number | null;
    timeZone: string | null;
    state: string | null;
  } | null;
  organizationAdmin: {
    __typename?: "OrganizationAdmin";
    organization: {
      __typename?: "Organization";
      uid: string;
      name: string;
      type: OrganizationType;
    };
  } | null;
  children: Array<{
    __typename?: "Child";
    uid: string;
    name: string | null;
    age: number | null;
    birthMonth: number | null;
    date_of_birth: any | null;
    birthYear: number | null;
    email: string | null;
    avatar: string | null;
    unlockedAvatars: Array<string>;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    email_confirmed_at: any | null;
    hasMarketingConsent: boolean | null;
    hasHealthConsent: boolean | null;
    isLoginEnabled: boolean;
    username: string | null;
    hasPassword: boolean;
    hasEsaMembership: boolean;
    esaMembershipProgram: string | null;
    attributes: Array<{
      __typename?: "EntityAttribute";
      uid: string;
      key: string;
      value: string;
      source: string | null;
    }>;
    entityAvailabilitySchedule: {
      __typename?: "EntityAvailabilitySchedule";
      entityAvailabilities: Array<{
        __typename?: "EntityAvailability";
        startHour: number;
        startMinute: number;
        day: number;
        endHour: number;
        endMinute: number;
        uid: string;
      }>;
    } | null;
  }>;
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
  interfacePreferences: {
    __typename?: "InterfacePreferences";
    activityFormatDescriptionFlexHidden: boolean;
    activityFormatDescriptionOngoingHidden: boolean;
    activityFormatDescriptionOneTimeHidden: boolean;
    activityFormatDescriptionMultiDayHidden: boolean;
    defaultScheduleFilters: {
      __typename?: "UserScheduleFilters";
      startAfter: string | null;
      endBy: string | null;
      startAfterTime: number | null;
      endByTime: number | null;
      dow: string | null;
    };
  };
  schoolClosure: {
    __typename?: "SchoolClosure";
    application_status: FfapApplicationStatus | null;
    needs_assistance: boolean | null;
  } | null;
  pricingOffer: {
    __typename?: "PricingOffer";
    uid: string;
    name: string;
    userLimitCents: number;
    purchaseLimitCents: number | null;
    totalCapCents: number;
    startAfter: any;
    endBy: any;
    buyerOrgName: string | null;
    isTotalCapReached: boolean;
    remainingCapCents: number | null;
    requirePaymentMethod: boolean;
    isOfferLimitReached: boolean;
    userOfferEmail: string | null;
    discount: number | null;
    isFinancialAid: boolean;
  } | null;
  sellerOrg: {
    __typename?: "SellerOrg";
    uid: string;
    name: string;
    leader_link: string | null;
    currentUserIsOwner: boolean | null;
    currentUserIsTeacher: boolean | null;
    hasApprovedTeacherAccountForOwner: boolean | null;
  } | null;
  latestSellerOrgApplication: {
    __typename?: "SellerOrgApplication";
    uid: string;
    status: SellerOrgApplicationStatus;
    appliedAt: any | null;
    createdAt: any | null;
    approvedAt: any | null;
    rejectedAt: any | null;
    contractSignedAt: any | null;
    adminResponse: string | null;
  } | null;
  latestTeacherApplication: {
    __typename?: "TeacherApplication";
    uid: string;
    legal_name: string | null;
    status: TeacherApplicationStatus;
    submitted_at: any | null;
    reviewed_at: any | null;
    teaching_experience: string | null;
    teaching_credentials: string | null;
    class_types: string | null;
    online_profiles: string | null;
    sample_classes: string | null;
    class_subjects: Array<string | null> | null;
    age_ranges_taught: Array<string | null> | null;
    years_of_experience: string | null;
    how_did_you_hear_about_us: string | null;
    experience_types: Array<string | null> | null;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  } | null;
  leader: {
    __typename?: "Leader";
    uid: string;
    showCalendar: boolean | null;
    mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
  } | null;
  selfElectedStateFundingProgram: {
    __typename?: "SelfElectedStateFundingProgram";
    stateAbbreviation: string;
    stateName: string;
    fundingOptions: {
      __typename?: "SelfElectedStateFundingOptions";
      charter: boolean;
      reimbursement: boolean;
      statePortal: boolean;
      selfPay: boolean;
      otherProgramName: string | null;
      stateProgramName: string | null;
      stateDebitCard: boolean | null;
    };
  } | null;
  billingAddress: {
    __typename?: "BillingAddress";
    country: string | null;
    postalCode: string | null;
  } | null;
};

export type CurrentUserQueryQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQueryQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  } | null;
};

export type FundingProgramPropertiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FundingProgramPropertiesQuery = {
  __typename?: "Query";
  fundingProgramProperties: Array<{
    __typename?: "FundingProgramProperties";
    abbreviation: string;
    fundingState: string | null;
    isClassWallet: boolean;
    institution: string | null;
    programName: string;
    programNameLong: string;
    programNameAbbr: string;
    programUrl: string | null;
    programEndDate: any | null;
    waitPeriodDays: number;
    landingPagePath: string | null;
  }>;
};

type LoginErrorOrResultFragment_LoginError_Fragment = {
  __typename: "LoginError";
  error: CreateOrLoginError;
};

type LoginErrorOrResultFragment_LoginResult_Fragment = {
  __typename: "LoginResult";
  isNewUser: boolean;
  authentication: { __typename?: "AuthenticationV1"; sessionToken: string };
};

export type LoginErrorOrResultFragmentFragment =
  | LoginErrorOrResultFragment_LoginError_Fragment
  | LoginErrorOrResultFragment_LoginResult_Fragment;

type LoginErrorOrResultFragmentV2_LoginError_Fragment = {
  __typename: "LoginError";
  error: CreateOrLoginError;
};

type LoginErrorOrResultFragmentV2_LoginResultV2_Fragment = {
  __typename: "LoginResultV2";
  isNewUser: boolean;
  authentication: {
    __typename?: "AuthenticationV2";
    sessionToken: string;
    refreshToken: string;
  };
};

export type LoginErrorOrResultFragmentV2Fragment =
  | LoginErrorOrResultFragmentV2_LoginError_Fragment
  | LoginErrorOrResultFragmentV2_LoginResultV2_Fragment;

export type LoginOrCreateAccountWithAppleV2MutationVariables = Exact<{
  code: Scalars["String"];
  name?: InputMaybe<Scalars["String"]>;
  createOptions?: InputMaybe<CreateAccountWithProviderInput>;
  osRef?: InputMaybe<OsRefInput>;
}>;

export type LoginOrCreateAccountWithAppleV2Mutation = {
  __typename?: "Mutation";
  loginOrCreateAccountWithAppleV2:
    | { __typename: "LoginError"; error: CreateOrLoginError }
    | {
        __typename: "LoginResultV2";
        isNewUser: boolean;
        authentication: {
          __typename?: "AuthenticationV2";
          sessionToken: string;
          refreshToken: string;
        };
      };
};

export type LoginWithGoogleOneTapMutationVariables = Exact<{
  idToken: Scalars["String"];
  createOptions?: InputMaybe<CreateAccountWithProviderInput>;
  osRef?: InputMaybe<OsRefInput>;
}>;

export type LoginWithGoogleOneTapMutation = {
  __typename?: "Mutation";
  loginOrCreateAccountWithGoogle:
    | { __typename: "LoginError"; error: CreateOrLoginError }
    | {
        __typename: "LoginResult";
        isNewUser: boolean;
        authentication: {
          __typename?: "AuthenticationV1";
          sessionToken: string;
        };
      };
};

export type LoginWithGoogleOneTapV2MutationVariables = Exact<{
  idToken: Scalars["String"];
  createOptions?: InputMaybe<CreateAccountWithProviderInput>;
  osRef?: InputMaybe<OsRefInput>;
}>;

export type LoginWithGoogleOneTapV2Mutation = {
  __typename?: "Mutation";
  loginOrCreateAccountWithGoogleV2:
    | { __typename: "LoginError"; error: CreateOrLoginError }
    | {
        __typename: "LoginResultV2";
        isNewUser: boolean;
        authentication: {
          __typename?: "AuthenticationV2";
          sessionToken: string;
          refreshToken: string;
        };
      };
};

export type SessionRefreshV2MutationVariables = Exact<{
  refreshToken?: InputMaybe<Scalars["String"]>;
  browserTimeZone?: InputMaybe<Scalars["String"]>;
  doNotTrack?: InputMaybe<Scalars["Boolean"]>;
  refreshSource?: InputMaybe<TokenRefreshSource>;
}>;

export type SessionRefreshV2Mutation = {
  __typename?: "Mutation";
  refreshV2: {
    __typename: "AuthenticationV2";
    refreshToken: string;
    sessionToken: string;
  };
};

export type SignupModalQueryVariables = Exact<{
  activityUid?: InputMaybe<Scalars["ID"]>;
  activitySlugId?: InputMaybe<Scalars["String"]>;
  skipActivity: Scalars["Boolean"];
  referrerSlugId?: InputMaybe<Scalars["String"]>;
  skipReferrer: Scalars["Boolean"];
  leaderUid?: InputMaybe<Scalars["ID"]>;
  leaderLink?: InputMaybe<Scalars["String"]>;
  skipLeader: Scalars["Boolean"];
}>;

export type SignupModalQuery = {
  __typename?: "Query";
  activity?: {
    __typename?: "Activity";
    uid: string;
    slug_id: string;
    user_uid: string;
    title: string;
    url: string;
    path: string;
    class_experience: string | null;
    learning_goals: string | null;
    assessment: string | null;
    homework: string | null;
    prerequisites: string | null;
    published_at: any | null;
    is_online: boolean;
    age_min: number | null;
    age_max: number | null;
    size_min: number | null;
    size_max: number | null;
    duration_minutes: number | null;
    duration_weeks: number | null;
    weekly_meetings: number | null;
    price_cents: number | null;
    summary: string | null;
    is_ongoing_weekly: boolean;
    subject: string | null;
    languageOfInstruction: any | null;
    summaryForLearners: string | null;
    isClub: boolean;
    isAutoSchedulingEnabled: boolean | null;
    autoSchedulingDaysNoticeMin: number | null;
    autoSchedulingDaysNoticeMax: number | null;
    hasTeacherSchedule: boolean;
    allows_recurring_payment: boolean | null;
    refundPolicy: {
      __typename?: "RefundPolicy";
      name: string;
      description: string;
    };
    photo: { __typename?: "Attachment"; fileUrl: string } | null;
  };
  leader: {
    __typename?: "PublicProfile";
    uid: string;
    leader: { __typename?: "Leader"; name: string | null } | null;
  } | null;
  referrer: {
    __typename?: "PublicProfile";
    uid: string;
    parent: {
      __typename?: "Parent";
      uid: string;
      name: string | null;
      photo: string | null;
      publicName: string | null;
      introduction: string | null;
      created_at: any | null;
      deleted_at: any | null;
      timeZone: string | null;
      socialOptOut: boolean;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      name: string | null;
      leader_link: string | null;
      created_at: any | null;
      photo: string | null;
      cityState: string | null;
      is_crosslister: boolean | null;
      timeZone: string | null;
      hasAvailabilitySet: boolean;
      approved: boolean;
      socialOptOut: boolean;
      hasBackgroundCheckExpired: boolean | null;
      details: {
        __typename?: "LeaderDetails";
        about: string | null;
        headline: string | null;
        countryOfResidence: string | null;
      };
      ownerOfSellerOrg: { __typename?: "SellerOrg"; uid: string } | null;
      teacherForSellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
      } | null;
    } | null;
  } | null;
};

export type UpdateCurrentUserPublicFundingMutationVariables = Exact<{
  details?: InputMaybe<UserDetailsInput>;
}>;

export type UpdateCurrentUserPublicFundingMutation = {
  __typename?: "Mutation";
  updateCurrentUser: {
    __typename?: "User";
    uid: string;
    slug_id: string;
    name: string | null;
    email: string | null;
    isLearnerModeEnabled: boolean | null;
    confirmed_at: any | null;
    subscribed_at: any | null;
    email_bounced_at: any | null;
    default_currency: string | null;
    phone: string | null;
    photo: string | null;
    leader_subscribed_at: any | null;
    calendar_uid: string;
    intercomUserHash: string | null;
    payout_email: string | null;
    owner_of_seller_org_uid: string | null;
    admin_for_organization_uid: string | null;
    do_not_sell_my_personal_info: boolean;
    background_checked_at: any | null;
    background_check_started_at: any | null;
    interview_scheduled_at: any | null;
    interviewed_at: any | null;
    classroom_training_scheduled_at: any | null;
    classroom_trained_at: any | null;
    latestLegalName: string | null;
    hasCompletedRequiredProfessionalLearning: boolean;
    hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
    hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
    teacher_approved_at: any | null;
    is_crosslister: boolean | null;
    introduction: string | null;
    created_at: any;
    updated_at: any;
    deleted_at: any | null;
    suspended_at: any | null;
    is_admin: boolean | null;
    learner_uses_parent_mode: boolean;
    leader_link: string | null;
    unreadMessageThreadsCount: number;
    unreadPrivateClassMessageThreadsCount: number;
    unreadAssignmentCommentThreadsCount: number;
    roles: Array<string> | null;
    locale: UserLocale;
    isRecordingAutopostEnabled: boolean | null;
    learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
    anonymousId: string | null;
    wasReferred: boolean;
    isEducatorBetaTester: boolean | null;
    consented_to_coppa_notice_at: any | null;
    hasVerifiedIdentity: boolean | null;
    consent_to_share_class_history: boolean | null;
    consent_to_share_favourites: boolean | null;
    privacy_state: string | null;
    hasAcceptedNewPrivacyTerms: boolean;
    profile_link_uid: string | null;
    hasSubscription: boolean;
    hasEverSubscribed: boolean;
    hasEsaMembership: boolean;
    esaMembershipPrograms: Array<string> | null;
    canPayWithSubscriptionCredits: boolean;
    upgradablePackages: Array<number | null> | null;
    requiresMembershipForEnrollment: boolean | null;
    hasUsedPublicFunding: boolean | null;
    isCharterUser: boolean | null;
    otherEmailDetails: Array<{
      __typename?: "OtherEmailDetails";
      uid: string;
      email: string;
      confirmed_at: any | null;
    } | null> | null;
    firstPaidEnrollment: {
      __typename?: "Enrollment";
      uid: string;
      confirmed_at: any | null;
    } | null;
    details: {
      __typename?: "UserDetails";
      about: string | null;
      headline: string | null;
      countryOfResidence: string | null;
      introduction: string | null;
      browserTimeZone: string | null;
      timeRangeAfterSchool: boolean | null;
      timeRangeSchool: boolean | null;
      timeRangeWeekend: boolean | null;
      socialOptOut: boolean | null;
      howFoundOutschool: string | null;
      howFoundOutschoolOther: string | null;
      educationApproach: string | null;
      adminDashboardUrl: string | null;
      experiments: Array<string | null> | null;
      bannerClosedAt: string | null;
    };
    location: {
      __typename?: "Location";
      address: string | null;
      city: string | null;
      lat: number | null;
      lng: number | null;
      timeZone: string | null;
      state: string | null;
    } | null;
    organizationAdmin: {
      __typename?: "OrganizationAdmin";
      organization: {
        __typename?: "Organization";
        uid: string;
        name: string;
        type: OrganizationType;
      };
    } | null;
    children: Array<{
      __typename?: "Child";
      uid: string;
      name: string | null;
      age: number | null;
      birthMonth: number | null;
      date_of_birth: any | null;
      birthYear: number | null;
      email: string | null;
      avatar: string | null;
      unlockedAvatars: Array<string>;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      email_confirmed_at: any | null;
      hasMarketingConsent: boolean | null;
      hasHealthConsent: boolean | null;
      isLoginEnabled: boolean;
      username: string | null;
      hasPassword: boolean;
      hasEsaMembership: boolean;
      esaMembershipProgram: string | null;
      attributes: Array<{
        __typename?: "EntityAttribute";
        uid: string;
        key: string;
        value: string;
        source: string | null;
      }>;
      entityAvailabilitySchedule: {
        __typename?: "EntityAvailabilitySchedule";
        entityAvailabilities: Array<{
          __typename?: "EntityAvailability";
          startHour: number;
          startMinute: number;
          day: number;
          endHour: number;
          endMinute: number;
          uid: string;
        }>;
      } | null;
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
    interfacePreferences: {
      __typename?: "InterfacePreferences";
      activityFormatDescriptionFlexHidden: boolean;
      activityFormatDescriptionOngoingHidden: boolean;
      activityFormatDescriptionOneTimeHidden: boolean;
      activityFormatDescriptionMultiDayHidden: boolean;
      defaultScheduleFilters: {
        __typename?: "UserScheduleFilters";
        startAfter: string | null;
        endBy: string | null;
        startAfterTime: number | null;
        endByTime: number | null;
        dow: string | null;
      };
    };
    schoolClosure: {
      __typename?: "SchoolClosure";
      application_status: FfapApplicationStatus | null;
      needs_assistance: boolean | null;
    } | null;
    pricingOffer: {
      __typename?: "PricingOffer";
      uid: string;
      name: string;
      userLimitCents: number;
      purchaseLimitCents: number | null;
      totalCapCents: number;
      startAfter: any;
      endBy: any;
      buyerOrgName: string | null;
      isTotalCapReached: boolean;
      remainingCapCents: number | null;
      requirePaymentMethod: boolean;
      isOfferLimitReached: boolean;
      userOfferEmail: string | null;
      discount: number | null;
      isFinancialAid: boolean;
    } | null;
    sellerOrg: {
      __typename?: "SellerOrg";
      uid: string;
      name: string;
      leader_link: string | null;
      currentUserIsOwner: boolean | null;
      currentUserIsTeacher: boolean | null;
      hasApprovedTeacherAccountForOwner: boolean | null;
    } | null;
    latestSellerOrgApplication: {
      __typename?: "SellerOrgApplication";
      uid: string;
      status: SellerOrgApplicationStatus;
      appliedAt: any | null;
      createdAt: any | null;
      approvedAt: any | null;
      rejectedAt: any | null;
      contractSignedAt: any | null;
      adminResponse: string | null;
    } | null;
    latestTeacherApplication: {
      __typename?: "TeacherApplication";
      uid: string;
      legal_name: string | null;
      status: TeacherApplicationStatus;
      submitted_at: any | null;
      reviewed_at: any | null;
      teaching_experience: string | null;
      teaching_credentials: string | null;
      class_types: string | null;
      online_profiles: string | null;
      sample_classes: string | null;
      class_subjects: Array<string | null> | null;
      age_ranges_taught: Array<string | null> | null;
      years_of_experience: string | null;
      how_did_you_hear_about_us: string | null;
      experience_types: Array<string | null> | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    } | null;
    leader: {
      __typename?: "Leader";
      uid: string;
      showCalendar: boolean | null;
      mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
    } | null;
    selfElectedStateFundingProgram: {
      __typename?: "SelfElectedStateFundingProgram";
      stateAbbreviation: string;
      stateName: string;
      fundingOptions: {
        __typename?: "SelfElectedStateFundingOptions";
        charter: boolean;
        reimbursement: boolean;
        statePortal: boolean;
        selfPay: boolean;
        otherProgramName: string | null;
        stateProgramName: string | null;
        stateDebitCard: boolean | null;
      };
    } | null;
    billingAddress: {
      __typename?: "BillingAddress";
      country: string | null;
      postalCode: string | null;
    } | null;
  };
};

export type CreateAccountMutationVariables = Exact<{
  name?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  password: Scalars["String"];
  attribution?: InputMaybe<Attribution>;
  browserTimeZone?: InputMaybe<Scalars["String"]>;
  locale?: InputMaybe<UserLocale>;
  isLeader?: InputMaybe<Scalars["Boolean"]>;
  subscribe?: InputMaybe<Scalars["Boolean"]>;
  isGiftCardSignup?: InputMaybe<Scalars["Boolean"]>;
  shouldNotSellPersonalInfo?: InputMaybe<Scalars["Boolean"]>;
  sellerOrgPrimaryContactName?: InputMaybe<Scalars["String"]>;
  osRef?: InputMaybe<OsRefInput>;
  defaultLearnerAttributes?: InputMaybe<LearnerAttributes>;
  requiresMembershipForEnrollment?: InputMaybe<Scalars["Boolean"]>;
  integrityToken?: InputMaybe<Scalars["String"]>;
  selfElectedStateFundingProgram?: InputMaybe<SelfElectedStateFundingProgramInput>;
}>;

export type CreateAccountMutation = {
  __typename?: "Mutation";
  createAccountWithEmailPassword: {
    __typename?: "AuthenticationResult";
    uid: string;
    sessionToken: string;
    refreshToken: string;
    currentUser: {
      __typename?: "User";
      uid: string;
      slug_id: string;
      name: string | null;
      email: string | null;
      isLearnerModeEnabled: boolean | null;
      confirmed_at: any | null;
      subscribed_at: any | null;
      email_bounced_at: any | null;
      default_currency: string | null;
      phone: string | null;
      photo: string | null;
      leader_subscribed_at: any | null;
      calendar_uid: string;
      intercomUserHash: string | null;
      payout_email: string | null;
      owner_of_seller_org_uid: string | null;
      admin_for_organization_uid: string | null;
      do_not_sell_my_personal_info: boolean;
      background_checked_at: any | null;
      background_check_started_at: any | null;
      interview_scheduled_at: any | null;
      interviewed_at: any | null;
      classroom_training_scheduled_at: any | null;
      classroom_trained_at: any | null;
      latestLegalName: string | null;
      hasCompletedRequiredProfessionalLearning: boolean;
      hasCompletedClassContentPoliciesOrgAdminTraining: boolean;
      hasCompletedSafetyAndPrivacyOrgAdminTraining: boolean;
      teacher_approved_at: any | null;
      is_crosslister: boolean | null;
      introduction: string | null;
      created_at: any;
      updated_at: any;
      deleted_at: any | null;
      suspended_at: any | null;
      is_admin: boolean | null;
      learner_uses_parent_mode: boolean;
      leader_link: string | null;
      unreadMessageThreadsCount: number;
      unreadPrivateClassMessageThreadsCount: number;
      unreadAssignmentCommentThreadsCount: number;
      roles: Array<string> | null;
      locale: UserLocale;
      isRecordingAutopostEnabled: boolean | null;
      learnerModeSwitchAuthRequirement: LearnerModeSwitchAuthRequirement | null;
      anonymousId: string | null;
      wasReferred: boolean;
      isEducatorBetaTester: boolean | null;
      consented_to_coppa_notice_at: any | null;
      hasVerifiedIdentity: boolean | null;
      consent_to_share_class_history: boolean | null;
      consent_to_share_favourites: boolean | null;
      privacy_state: string | null;
      hasAcceptedNewPrivacyTerms: boolean;
      profile_link_uid: string | null;
      hasSubscription: boolean;
      hasEverSubscribed: boolean;
      hasEsaMembership: boolean;
      esaMembershipPrograms: Array<string> | null;
      canPayWithSubscriptionCredits: boolean;
      upgradablePackages: Array<number | null> | null;
      requiresMembershipForEnrollment: boolean | null;
      hasUsedPublicFunding: boolean | null;
      isCharterUser: boolean | null;
      otherEmailDetails: Array<{
        __typename?: "OtherEmailDetails";
        uid: string;
        email: string;
        confirmed_at: any | null;
      } | null> | null;
      firstPaidEnrollment: {
        __typename?: "Enrollment";
        uid: string;
        confirmed_at: any | null;
      } | null;
      details: {
        __typename?: "UserDetails";
        about: string | null;
        headline: string | null;
        countryOfResidence: string | null;
        introduction: string | null;
        browserTimeZone: string | null;
        timeRangeAfterSchool: boolean | null;
        timeRangeSchool: boolean | null;
        timeRangeWeekend: boolean | null;
        socialOptOut: boolean | null;
        howFoundOutschool: string | null;
        howFoundOutschoolOther: string | null;
        educationApproach: string | null;
        adminDashboardUrl: string | null;
        experiments: Array<string | null> | null;
        bannerClosedAt: string | null;
      };
      location: {
        __typename?: "Location";
        address: string | null;
        city: string | null;
        lat: number | null;
        lng: number | null;
        timeZone: string | null;
        state: string | null;
      } | null;
      organizationAdmin: {
        __typename?: "OrganizationAdmin";
        organization: {
          __typename?: "Organization";
          uid: string;
          name: string;
          type: OrganizationType;
        };
      } | null;
      children: Array<{
        __typename?: "Child";
        uid: string;
        name: string | null;
        age: number | null;
        birthMonth: number | null;
        date_of_birth: any | null;
        birthYear: number | null;
        email: string | null;
        avatar: string | null;
        unlockedAvatars: Array<string>;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        email_confirmed_at: any | null;
        hasMarketingConsent: boolean | null;
        hasHealthConsent: boolean | null;
        isLoginEnabled: boolean;
        username: string | null;
        hasPassword: boolean;
        hasEsaMembership: boolean;
        esaMembershipProgram: string | null;
        attributes: Array<{
          __typename?: "EntityAttribute";
          uid: string;
          key: string;
          value: string;
          source: string | null;
        }>;
        entityAvailabilitySchedule: {
          __typename?: "EntityAvailabilitySchedule";
          entityAvailabilities: Array<{
            __typename?: "EntityAvailability";
            startHour: number;
            startMinute: number;
            day: number;
            endHour: number;
            endMinute: number;
            uid: string;
          }>;
        } | null;
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      interfacePreferences: {
        __typename?: "InterfacePreferences";
        activityFormatDescriptionFlexHidden: boolean;
        activityFormatDescriptionOngoingHidden: boolean;
        activityFormatDescriptionOneTimeHidden: boolean;
        activityFormatDescriptionMultiDayHidden: boolean;
        defaultScheduleFilters: {
          __typename?: "UserScheduleFilters";
          startAfter: string | null;
          endBy: string | null;
          startAfterTime: number | null;
          endByTime: number | null;
          dow: string | null;
        };
      };
      schoolClosure: {
        __typename?: "SchoolClosure";
        application_status: FfapApplicationStatus | null;
        needs_assistance: boolean | null;
      } | null;
      pricingOffer: {
        __typename?: "PricingOffer";
        uid: string;
        name: string;
        userLimitCents: number;
        purchaseLimitCents: number | null;
        totalCapCents: number;
        startAfter: any;
        endBy: any;
        buyerOrgName: string | null;
        isTotalCapReached: boolean;
        remainingCapCents: number | null;
        requirePaymentMethod: boolean;
        isOfferLimitReached: boolean;
        userOfferEmail: string | null;
        discount: number | null;
        isFinancialAid: boolean;
      } | null;
      sellerOrg: {
        __typename?: "SellerOrg";
        uid: string;
        name: string;
        leader_link: string | null;
        currentUserIsOwner: boolean | null;
        currentUserIsTeacher: boolean | null;
        hasApprovedTeacherAccountForOwner: boolean | null;
      } | null;
      latestSellerOrgApplication: {
        __typename?: "SellerOrgApplication";
        uid: string;
        status: SellerOrgApplicationStatus;
        appliedAt: any | null;
        createdAt: any | null;
        approvedAt: any | null;
        rejectedAt: any | null;
        contractSignedAt: any | null;
        adminResponse: string | null;
      } | null;
      latestTeacherApplication: {
        __typename?: "TeacherApplication";
        uid: string;
        legal_name: string | null;
        status: TeacherApplicationStatus;
        submitted_at: any | null;
        reviewed_at: any | null;
        teaching_experience: string | null;
        teaching_credentials: string | null;
        class_types: string | null;
        online_profiles: string | null;
        sample_classes: string | null;
        class_subjects: Array<string | null> | null;
        age_ranges_taught: Array<string | null> | null;
        years_of_experience: string | null;
        how_did_you_hear_about_us: string | null;
        experience_types: Array<string | null> | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      } | null;
      leader: {
        __typename?: "Leader";
        uid: string;
        showCalendar: boolean | null;
        mainToolbarPinnedTabs: Array<MainToolbarPinnedTabs> | null;
      } | null;
      selfElectedStateFundingProgram: {
        __typename?: "SelfElectedStateFundingProgram";
        stateAbbreviation: string;
        stateName: string;
        fundingOptions: {
          __typename?: "SelfElectedStateFundingOptions";
          charter: boolean;
          reimbursement: boolean;
          statePortal: boolean;
          selfPay: boolean;
          otherProgramName: string | null;
          stateProgramName: string | null;
          stateDebitCard: boolean | null;
        };
      } | null;
      billingAddress: {
        __typename?: "BillingAddress";
        country: string | null;
        postalCode: string | null;
      } | null;
    };
  } | null;
};

export type ListingPhoto_ActivityFragment = {
  __typename?: "Activity";
  isClub: boolean;
  photo: { __typename?: "Attachment"; fileUrl: string } | null;
  clubSection: {
    __typename?: "Section";
    filledSpaceCount: number;
    clubPostCount: number;
  } | null;
};

export type TeacherMeetingRecapEnabledSettingQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TeacherMeetingRecapEnabledSettingQuery = {
  __typename?: "Query";
  teacherMarketingSettings: {
    __typename?: "TeacherMarketingSettings";
    ai_meeting_summary_is_on: boolean;
  } | null;
};

export type GetMeetingRecapQueryVariables = Exact<{
  meetingUid: Scalars["ID"];
}>;

export type GetMeetingRecapQuery = {
  __typename?: "Query";
  meetingAiSummary: {
    __typename?: "MeetingAiSummary";
    meeting_uid: string;
    ai_summary_text: string;
    edited_summary_text: string | null;
    is_skipped: boolean;
    sent_at: any | null;
    deleted_at: any | null;
  } | null;
};

export type UpdateMeetingRecapMutationVariables = Exact<{
  meetingUid: Scalars["ID"];
  input: MeetingAiSummaryPatchInput;
}>;

export type UpdateMeetingRecapMutation = {
  __typename?: "Mutation";
  updateMeetingAiSummary: {
    __typename?: "MeetingAiSummary";
    edited_summary_text: string | null;
    is_skipped: boolean;
  } | null;
};

export type AssignmentCommentFragment = {
  __typename?: "AssignmentClassPostComment";
  uid: string;
  sentAt: any;
  threadForLearnerUid: string;
  isSubmission: boolean | null;
  sender: {
    __typename?: "MessageSender";
    uid: string;
    name: string | null;
    photo: string | null;
    avatar: string | null;
    isLearner: boolean;
  };
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type AssignmentCommentThreadFragment = {
  __typename?: "AssignmentClassPostComment";
  uid: string;
  sentAt: any;
  threadForLearnerUid: string;
  isSubmission: boolean | null;
  replies: Array<{
    __typename?: "AssignmentClassPostComment";
    uid: string;
    sentAt: any;
    threadForLearnerUid: string;
    isSubmission: boolean | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  }> | null;
  sender: {
    __typename?: "MessageSender";
    uid: string;
    name: string | null;
    photo: string | null;
    avatar: string | null;
    isLearner: boolean;
  };
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type AssignmentSummaryAssignmentTitleFragment = {
  __typename?: "AssignmentClassPost";
  title: string;
  publishAt: any;
  submissionRequirement: SubmissionRequirementType;
  dueDate: any | null;
  lesson: {
    __typename?: "Lesson";
    uid: string;
    lessonNumber: number | null;
  } | null;
};

export type AssignmentSummaryAssignmentDescriptionFragment = {
  __typename?: "AssignmentClassPost";
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type AssignmentSummaryCardAssignmentFragment = {
  __typename?: "AssignmentClassPost";
  uid: string;
  title: string;
  publishAt: any;
  submissionRequirement: SubmissionRequirementType;
  dueDate: any | null;
  lesson: {
    __typename?: "Lesson";
    uid: string;
    lessonNumber: number | null;
  } | null;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type AssignmentTrackerAssignmentFragment = {
  __typename?: "AssignmentClassPost";
  uid: string;
  title: string;
  submissionRequirement: SubmissionRequirementType;
  dueDate: any | null;
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
  comments: Array<{
    __typename?: "AssignmentClassPostComment";
    uid: string;
    sentAt: any;
    isSubmission: boolean | null;
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  }>;
};

export type AssignmentTrackerSyllabusFragment = {
  __typename?: "Syllabus";
  uid: string;
  published_at: string | null;
  lessons: Array<{
    __typename?: "Lesson";
    uid: string;
    lessonNumber: number | null;
    assignmentClassPosts: Array<{
      __typename?: "AssignmentClassPost";
      uid: string;
      title: string;
      submissionRequirement: SubmissionRequirementType;
      dueDate: any | null;
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      comments: Array<{
        __typename?: "AssignmentClassPostComment";
        uid: string;
        sentAt: any;
        isSubmission: boolean | null;
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    }>;
  }>;
};

export type CurrentLearnerAvatarFragmentFragment = {
  __typename: "CurrentLearner";
  avatar: string | null;
};

export type AttachmentFragmentFragment = {
  __typename?: "Attachment";
  uid: string;
  fileUrl: string;
  videoThumbnailUrl: string | null;
  conversionStatus: string | null;
  created_at: any;
  file: {
    __typename?: "File";
    filename: string;
    mimetype: string | null;
    size: number;
    url: string;
    thumbUrl: string | null;
  };
};

export type AttendanceFragmentFragment = {
  __typename?: "Attendance";
  uid: string;
  created_at: any;
};

export type MeetingPost_ActivityFragment = {
  __typename?: "Activity";
  leader: { __typename?: "Leader"; uid: string; name: string | null };
};

export type MeetingPost_SectionFragment = {
  __typename?: "Section";
  uid: string;
  leader: { __typename?: "Leader"; uid: string; name: string | null };
};

export type MeetingPost_MeetingFragment = {
  __typename?: "Meeting";
  uid: string;
  start_time: any;
  end_time: any;
  recordingAvailability: RecordingAvailability;
  recordingRequests: Array<{
    __typename?: "RecordingRequest";
    requestedAt: any;
    message: string;
    requestedBy: { __typename?: "Learner"; uid: string; name: string | null };
  }>;
  classRecordings: Array<
    | {
        __typename?: "ClassRecording";
        uid: string;
        startTime: any;
        endTime: any;
      }
    | {
        __typename?: "ZoomRecording";
        uid: string;
        startTime: any;
        endTime: any;
      }
  >;
  attendances: Array<{
    __typename?: "Attendance";
    learner: { __typename?: "Learner"; name: string | null };
  }>;
};

export type MeetingPost_LearnerFragment = {
  __typename?: "Learner";
  uid: string;
};

export type ClassPost_AttachmentFragment = {
  __typename?: "Attachment";
  uid: string;
  fileUrl: string;
  videoThumbnailUrl: string | null;
  conversionStatus: string | null;
  created_at: any;
  file: {
    __typename?: "File";
    filename: string;
    mimetype: string | null;
    size: number;
    url: string;
    thumbUrl: string | null;
  };
};

export type ClassPost_SenderFragment = {
  __typename?: "MessageSender";
  uid: string;
  name: string | null;
  photo: string | null;
  avatar: string | null;
  isLearner: boolean;
};

export type ClassPost_MessageContentFragment = {
  __typename?: "MessageContent";
  uid: string;
  text: string | null;
  originalMimeType: TextMimeType;
  externalVideoUrl: string | null;
  editedAt: any | null;
  htmlText: string | null;
  attachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
  imageAttachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
};

export type ClassPost_CommentFragment = {
  __typename?: "ClassPostComment";
  uid: string;
  sendAt: any;
  mentionedEnrollmentUids: Array<string>;
  mentionedTeacherUid: string | null;
  backgroundColor: string | null;
  sender: {
    __typename?: "MessageSender";
    uid: string;
    name: string | null;
    photo: string | null;
    avatar: string | null;
    isLearner: boolean;
  };
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type ClassPost_ClassPostWithOnlyCommentsFragment = {
  __typename?: "ClassPost";
  uid: string;
  comments: Array<{
    __typename?: "ClassPostComment";
    uid: string;
    sendAt: any;
    mentionedEnrollmentUids: Array<string>;
    mentionedTeacherUid: string | null;
    backgroundColor: string | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  }>;
};

export type ClassPost_ClassPostWithCommentsFragment = {
  __typename?: "ClassPost";
  publishAt: any;
  isWelcomePost: boolean;
  uid: string;
  sender: {
    __typename?: "MessageSender";
    uid: string;
    name: string | null;
    photo: string | null;
    avatar: string | null;
    isLearner: boolean;
  };
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
  comments: Array<{
    __typename?: "ClassPostComment";
    uid: string;
    sendAt: any;
    mentionedEnrollmentUids: Array<string>;
    mentionedTeacherUid: string | null;
    backgroundColor: string | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  }>;
};

export type ClassPost_LearnerFragment = {
  __typename?: "Learner";
  uid: string;
  name: string | null;
};

export type ClassPost_ClassPostFragment = {
  __typename?: "ClassPost";
  uid: string;
  isWelcomePost: boolean;
  publishAt: any;
  title: string | null;
  promotedAt: any | null;
  pinnedAt: any | null;
  mentionedEnrollmentUids: Array<string>;
  backgroundColor: string | null;
  score: number | null;
  sender: {
    __typename?: "MessageSender";
    uid: string;
    name: string | null;
    photo: string | null;
    avatar: string | null;
    isLearner: boolean;
  };
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
  commentsPreview: {
    __typename?: "CommentsPreview";
    remainingCommentsCount: number;
    comments: Array<{
      __typename?: "ClassPostComment";
      uid: string;
      sendAt: any;
      mentionedEnrollmentUids: Array<string>;
      mentionedTeacherUid: string | null;
      backgroundColor: string | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
    }>;
  };
};

export type ClassPost_ActivityFragment = {
  __typename?: "Activity";
  user_uid: string;
  leader: { __typename?: "Leader"; uid: string; leader_link: string | null };
};

export type ClassPost_SectionFragment = {
  __typename?: "Section";
  uid: string;
  currentUserCanManage: boolean;
  leader: { __typename?: "Leader"; uid: string };
};

export type ClassPost_MentionNamesFragment = {
  __typename?: "MentionName";
  id: string;
  display: string;
  avatar: string | null;
  learnerUid: string | null;
  startTime: any | null;
};

export type ClassPostList_MeetingFragment = {
  __typename?: "Meeting";
  uid: string;
  start_time: any;
  end_time: any;
  recordingAvailability: RecordingAvailability;
  recordingRequests: Array<{
    __typename?: "RecordingRequest";
    requestedAt: any;
    message: string;
    requestedBy: { __typename?: "Learner"; uid: string; name: string | null };
  }>;
  classRecordings: Array<
    | {
        __typename?: "ClassRecording";
        uid: string;
        startTime: any;
        endTime: any;
      }
    | {
        __typename?: "ZoomRecording";
        uid: string;
        startTime: any;
        endTime: any;
      }
  >;
  attendances: Array<{
    __typename?: "Attendance";
    learner: { __typename?: "Learner"; name: string | null };
  }>;
};

export type ClassPostList_ClassroomFragment = {
  __typename?: "Classroom";
  usersCanPost: boolean;
  usersCanComment: boolean;
  posts: Array<{
    __typename?: "ClassPost";
    uid: string;
    isWelcomePost: boolean;
    publishAt: any;
    title: string | null;
    promotedAt: any | null;
    pinnedAt: any | null;
    mentionedEnrollmentUids: Array<string>;
    backgroundColor: string | null;
    score: number | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    commentsPreview: {
      __typename?: "CommentsPreview";
      remainingCommentsCount: number;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  }>;
  unpublishedPosts: Array<{
    __typename?: "ClassPost";
    uid: string;
    isWelcomePost: boolean;
    publishAt: any;
    title: string | null;
    promotedAt: any | null;
    pinnedAt: any | null;
    mentionedEnrollmentUids: Array<string>;
    backgroundColor: string | null;
    score: number | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    commentsPreview: {
      __typename?: "CommentsPreview";
      remainingCommentsCount: number;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  }>;
  activity: {
    __typename?: "Activity";
    user_uid: string;
    leader: {
      __typename?: "Leader";
      uid: string;
      leader_link: string | null;
      name: string | null;
    };
  };
  section: {
    __typename?: "Section";
    currentUserCanManage: boolean;
    uid: string;
    meetings: Array<{
      __typename?: "Meeting";
      uid: string;
      start_time: any;
      end_time: any;
      recordingAvailability: RecordingAvailability;
      recordingRequests: Array<{
        __typename?: "RecordingRequest";
        requestedAt: any;
        message: string;
        requestedBy: {
          __typename?: "Learner";
          uid: string;
          name: string | null;
        };
      }>;
      classRecordings: Array<
        | {
            __typename?: "ClassRecording";
            uid: string;
            startTime: any;
            endTime: any;
          }
        | {
            __typename?: "ZoomRecording";
            uid: string;
            startTime: any;
            endTime: any;
          }
      >;
      attendances: Array<{
        __typename?: "Attendance";
        learner: { __typename?: "Learner"; name: string | null };
      }>;
    }>;
    leader: { __typename?: "Leader"; uid: string; name: string | null };
  };
  mentionNames: Array<{
    __typename?: "MentionName";
    id: string;
    display: string;
    avatar: string | null;
    learnerUid: string | null;
    startTime: any | null;
  }>;
};

export type ClassPostList_LearnerFragment = {
  __typename?: "Learner";
  uid: string;
  name: string | null;
};

export type ClassroomLearnerList_ProfileFragment = {
  __typename?: "LearnerProfile";
  uid: string;
  name: string | null;
  avatar: string | null;
};

export type LearnerFragmentFragment = {
  __typename?: "Learner";
  uid: string;
  name: string | null;
  age: number | null;
  avatar: string | null;
  pronoun: string | null;
  intro: string | null;
  deleted_at: any | null;
  isVerified: boolean;
  isBlocked: boolean | null;
  blockedByUserUid: string | null;
  blockedAt: any | null;
};

export type MeetingFragmentFragment = {
  __typename?: "Meeting";
  uid: string;
  start_time: any;
  end_time: any;
  deleted_at: any | null;
  created_at: any | null;
};

export type OneOnOneMeetingFragmentFragment = {
  __typename?: "Meeting";
  refundableAmountCents: number;
  paidAt: any | null;
  recurring: boolean | null;
};

export type MeetingWithAttendancesAndRecordingsFragment = {
  __typename?: "Meeting";
  recordingAvailability: RecordingAvailability;
  uid: string;
  start_time: any;
  end_time: any;
  deleted_at: any | null;
  created_at: any | null;
  attendances: Array<{
    __typename?: "Attendance";
    uid: string;
    created_at: any;
    learner: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    };
  }>;
  classRecordings: Array<
    | {
        __typename?: "ClassRecording";
        uid: string;
        recordingId: string;
        startTime: any;
        endTime: any;
      }
    | {
        __typename?: "ZoomRecording";
        uid: string;
        recordingId: string;
        startTime: any;
        endTime: any;
      }
  >;
  recordingRequests: Array<{
    __typename?: "RecordingRequest";
    requestedAt: any;
    message: string;
    requestedBy: {
      __typename?: "Learner";
      uid: string;
      name: string | null;
      age: number | null;
      avatar: string | null;
      pronoun: string | null;
      intro: string | null;
      deleted_at: any | null;
      isVerified: boolean;
      isBlocked: boolean | null;
      blockedByUserUid: string | null;
      blockedAt: any | null;
    };
  }>;
};

export type MessageContentFragmentFragment = {
  __typename?: "MessageContent";
  uid: string;
  text: string | null;
  originalMimeType: TextMimeType;
  externalVideoUrl: string | null;
  editedAt: any | null;
  htmlText: string | null;
  attachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
  imageAttachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
};

export type MessageContentWithMentionsFragmentFragment = {
  __typename?: "MessageContent";
  uid: string;
  text: string | null;
  originalMimeType: TextMimeType;
  externalVideoUrl: string | null;
  htmlText: string | null;
  attachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
  imageAttachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  }>;
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  } | null;
};

export type MessageSenderFragmentFragment = {
  __typename?: "MessageSender";
  uid: string;
  name: string | null;
  photo: string | null;
  avatar: string | null;
  isLearner: boolean;
};

export type PrivateClassMessageFragmentFragment = {
  __typename?: "PrivateClassMessage";
  uid: string;
  thread_uid: string;
  sentAt: any;
  sender: {
    __typename?: "MessageSender";
    uid: string;
    name: string | null;
    photo: string | null;
    avatar: string | null;
    isLearner: boolean;
  };
  messageContent: {
    __typename?: "MessageContent";
    uid: string;
    text: string | null;
    originalMimeType: TextMimeType;
    externalVideoUrl: string | null;
    editedAt: any | null;
    htmlText: string | null;
    attachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    imageAttachments: Array<{
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    }>;
    video: {
      __typename?: "Attachment";
      uid: string;
      fileUrl: string;
      videoThumbnailUrl: string | null;
      conversionStatus: string | null;
      created_at: any;
      file: {
        __typename?: "File";
        filename: string;
        mimetype: string | null;
        size: number;
        url: string;
        thumbUrl: string | null;
      };
    } | null;
  };
};

export type RecordingRequestFragmentFragment = {
  __typename?: "RecordingRequest";
  requestedAt: any;
  message: string;
  requestedBy: {
    __typename?: "Learner";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    pronoun: string | null;
    intro: string | null;
    deleted_at: any | null;
    isVerified: boolean;
    isBlocked: boolean | null;
    blockedByUserUid: string | null;
    blockedAt: any | null;
  };
};

export type DeleteAssignmentClassPostCommentMutationVariables = Exact<{
  commentUid: Scalars["ID"];
}>;

export type DeleteAssignmentClassPostCommentMutation = {
  __typename?: "Mutation";
  deleteAssignmentClassPostComment: {
    __typename?: "AssignmentClassPostComment";
    uid: string;
  };
};

export type AddAttachmentMutationVariables = Exact<{
  file: FileInput;
  convert?: InputMaybe<Scalars["Boolean"]>;
}>;

export type AddAttachmentMutation = {
  __typename?: "Mutation";
  addAttachment: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    conversionStatus: string | null;
    created_at: any;
    file: {
      __typename?: "File";
      filename: string;
      mimetype: string | null;
      size: number;
      url: string;
      thumbUrl: string | null;
    };
  };
};

export type UpdateClassPostInClubMutationVariables = Exact<{
  classPostUid: Scalars["ID"];
  messageContentInput?: InputMaybe<MessageContentInput>;
  title?: InputMaybe<Scalars["String"]>;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UpdateClassPostInClubMutation = {
  __typename?: "Mutation";
  updateClassPost: {
    __typename?: "ClassPost";
    uid: string;
    isWelcomePost: boolean;
    publishAt: any;
    title: string | null;
    promotedAt: any | null;
    pinnedAt: any | null;
    mentionedEnrollmentUids: Array<string>;
    backgroundColor: string | null;
    score: number | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    commentsPreview: {
      __typename?: "CommentsPreview";
      remainingCommentsCount: number;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    };
  };
};

export type UpdateClassPostCommentMutationVariables = Exact<{
  classPostCommentUid: Scalars["ID"];
  messageContentInput?: InputMaybe<MessageContentInput>;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UpdateClassPostCommentMutation = {
  __typename?: "Mutation";
  updateClassPostComment: {
    __typename?: "ClassPostComment";
    uid: string;
    sendAt: any;
    mentionedEnrollmentUids: Array<string>;
    mentionedTeacherUid: string | null;
    backgroundColor: string | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type AddClassPostCommentMutationVariables = Exact<{
  classPostCommentInput: ClassPostCommentInput;
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type AddClassPostCommentMutation = {
  __typename?: "Mutation";
  addClassPostComment: {
    __typename?: "ClassPostComment";
    uid: string;
    sendAt: any;
    mentionedEnrollmentUids: Array<string>;
    mentionedTeacherUid: string | null;
    backgroundColor: string | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type DeleteClassPostCommentMutationVariables = Exact<{
  classPostCommentUid: Scalars["ID"];
}>;

export type DeleteClassPostCommentMutation = {
  __typename?: "Mutation";
  deleteClassPostComment: boolean | null;
};

export type AddClassPostCommentReplyMutationVariables = Exact<{
  classPostCommentReplyInput: ClassPostCommentReplyInput;
}>;

export type AddClassPostCommentReplyMutation = {
  __typename?: "Mutation";
  addClassPostCommentReply: {
    __typename?: "ClassPostComment";
    uid: string;
    sendAt: any;
    mentionedEnrollmentUids: Array<string>;
    mentionedTeacherUid: string | null;
    backgroundColor: string | null;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type PromoteClassPostMutationVariables = Exact<{
  classPostUid: Scalars["ID"];
}>;

export type PromoteClassPostMutation = {
  __typename?: "Mutation";
  promoteClassPost: boolean | null;
};

export type PinClassPostMutationVariables = Exact<{
  classPostUid: Scalars["ID"];
}>;

export type PinClassPostMutation = {
  __typename?: "Mutation";
  pinClassPost: boolean;
};

export type UnpinClassPostMutationVariables = Exact<{
  classPostUid: Scalars["ID"];
}>;

export type UnpinClassPostMutation = {
  __typename?: "Mutation";
  unpinClassPost: boolean;
};

export type SetMeetingRecordingsShownMutationVariables = Exact<{
  meetingUid: Scalars["ID"];
  isShown: Scalars["Boolean"];
  reason?: InputMaybe<Scalars["String"]>;
}>;

export type SetMeetingRecordingsShownMutation = {
  __typename?: "Mutation";
  setMeetingRecordingsShown: {
    __typename?: "Meeting";
    recordingAvailability: RecordingAvailability;
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
    attendances: Array<{
      __typename?: "Attendance";
      uid: string;
      created_at: any;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
    }>;
    classRecordings: Array<
      | {
          __typename?: "ClassRecording";
          uid: string;
          recordingId: string;
          startTime: any;
          endTime: any;
        }
      | {
          __typename?: "ZoomRecording";
          uid: string;
          recordingId: string;
          startTime: any;
          endTime: any;
        }
    >;
    recordingRequests: Array<{
      __typename?: "RecordingRequest";
      requestedAt: any;
      message: string;
      requestedBy: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
    }>;
  };
};

export type RequestMeetingRecordingsShownMutationVariables = Exact<{
  meetingUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
  message?: InputMaybe<Scalars["String"]>;
}>;

export type RequestMeetingRecordingsShownMutation = {
  __typename?: "Mutation";
  requestMeetingRecordingsShown: {
    __typename?: "Meeting";
    recordingAvailability: RecordingAvailability;
    uid: string;
    start_time: any;
    end_time: any;
    deleted_at: any | null;
    created_at: any | null;
    attendances: Array<{
      __typename?: "Attendance";
      uid: string;
      created_at: any;
      learner: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
    }>;
    classRecordings: Array<
      | {
          __typename?: "ClassRecording";
          uid: string;
          recordingId: string;
          startTime: any;
          endTime: any;
        }
      | {
          __typename?: "ZoomRecording";
          uid: string;
          recordingId: string;
          startTime: any;
          endTime: any;
        }
    >;
    recordingRequests: Array<{
      __typename?: "RecordingRequest";
      requestedAt: any;
      message: string;
      requestedBy: {
        __typename?: "Learner";
        uid: string;
        name: string | null;
        age: number | null;
        avatar: string | null;
        pronoun: string | null;
        intro: string | null;
        deleted_at: any | null;
        isVerified: boolean;
        isBlocked: boolean | null;
        blockedByUserUid: string | null;
        blockedAt: any | null;
      };
    }>;
  };
};

export type AddPrivateClassMessageMutationVariables = Exact<{
  privateClassMessageInput: PrivateClassMessageInput;
}>;

export type AddPrivateClassMessageMutation = {
  __typename?: "Mutation";
  addPrivateClassMessage: {
    __typename?: "PrivateClassMessage";
    uid: string;
    thread_uid: string;
    sentAt: any;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  };
};

export type ClubPostQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  classPostUid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
  creationDateSortOrder?: InputMaybe<SortOrder>;
}>;

export type ClubPostQuery = {
  __typename?: "Query";
  club: {
    __typename?: "Club";
    uid: string;
    currentLearnerIsVerified: boolean;
    currentLearnerMustAcceptGuidelines: boolean;
    currentLearnerHasSubmittedIntroductionForClub: boolean;
    currentUserCanParticipate: boolean;
    section: {
      __typename?: "Section";
      uid: string;
      currentUserCanManage: boolean;
    };
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      titleTranslated: string | null;
      user_uid: string;
      isClub: boolean;
      videoForLearners: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      clubGuidelines: {
        __typename?: "WelcomeMessage";
        text: string | null;
      } | null;
    };
    postByUid: {
      __typename?: "ClassPost";
      uid: string;
      title: string | null;
      promotedAt: any | null;
      pinnedAt: any | null;
      backgroundColor: string | null;
      mentionedEnrollmentUids: Array<string>;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        replies: Array<{
          __typename?: "ClassPostComment";
          uid: string;
          sendAt: any;
          mentionedEnrollmentUids: Array<string>;
          mentionedTeacherUid: string | null;
          backgroundColor: string | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    } | null;
    mentionNames: Array<{
      __typename?: "MentionName";
      id: string;
      display: string;
      avatar: string | null;
      learnerUid: string | null;
      startTime: any | null;
    }>;
  };
};

export type ClubPostAndCommentBackgroundColorsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ClubPostAndCommentBackgroundColorsQuery = {
  __typename?: "Query";
  clubPostAndCommentBackgroundColors: Array<string>;
};

export type DeleteClassRecordingInsightsMutationVariables = Exact<{
  uids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type DeleteClassRecordingInsightsMutation = {
  __typename?: "Mutation";
  deleteClassRecordingInsights: boolean;
};

export type ClassRecordingStatusQueryVariables = Exact<{
  recordingUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
}>;

export type ClassRecordingStatusQuery = {
  __typename?: "Query";
  section: {
    __typename?: "Section";
    uid: string;
    classRecording:
      | {
          __typename?: "ClassRecording";
          readyToPlay: boolean | null;
          isExpired: boolean;
          uid: string;
          playUrl: string | null;
          speakingTimes: Array<{
            __typename?: "SpeakingTimeMarkers";
            learnerSpeaker: { __typename?: "Child"; uid: string } | null;
            educatorSpeaker: { __typename?: "Leader"; uid: string } | null;
            speakingTimeMarkers: Array<{
              __typename?: "SpeakingTimeMarker";
              time: number;
              duration: number;
              speakerName: string;
            }>;
          }>;
          actionItems: Array<{
            __typename?: "ClassRecordingInsight";
            uid: string;
            shortSummary: string;
            longSummary: string;
            videoStartTimestamp: string | null;
            videoEndTimestamp: string | null;
          }>;
          teacherMoments: Array<{
            __typename?: "ClassRecordingInsight";
            uid: string;
            shortSummary: string;
            longSummary: string;
            videoStartTimestamp: string | null;
            videoEndTimestamp: string | null;
            thumbnailUrl: string | null;
          }>;
          insightsProgress: {
            __typename?: "ClassRecordingInsightsProgress";
            recapGeneration: {
              __typename?: "ClassRecordingInsightsGenerationStatus";
              startedAt: any | null;
              failedAt: any | null;
              completedAt: any | null;
            } | null;
            actionItemsGeneration: {
              __typename?: "ClassRecordingInsightsGenerationStatus";
              startedAt: any | null;
              failedAt: any | null;
              completedAt: any | null;
            } | null;
            teacherMomentsGeneration: {
              __typename?: "ClassRecordingInsightsGenerationStatus";
              startedAt: any | null;
              failedAt: any | null;
              completedAt: any | null;
            } | null;
          };
        }
      | { __typename?: "ZoomRecording"; uid: string; playUrl: string };
  } | null;
};

export type AllClassPostCommentsQueryQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  classPostUid: Scalars["ID"];
  plainText?: InputMaybe<Scalars["Boolean"]>;
}>;

export type AllClassPostCommentsQueryQuery = {
  __typename?: "Query";
  classroom: {
    __typename?: "Classroom";
    uid: string;
    postByUid: {
      __typename?: "ClassPost";
      uid: string;
      comments: Array<{
        __typename?: "ClassPostComment";
        uid: string;
        sendAt: any;
        mentionedEnrollmentUids: Array<string>;
        mentionedTeacherUid: string | null;
        backgroundColor: string | null;
        sender: {
          __typename?: "MessageSender";
          uid: string;
          name: string | null;
          photo: string | null;
          avatar: string | null;
          isLearner: boolean;
        };
        messageContent: {
          __typename?: "MessageContent";
          uid: string;
          text: string | null;
          originalMimeType: TextMimeType;
          externalVideoUrl: string | null;
          editedAt: any | null;
          htmlText: string | null;
          attachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          imageAttachments: Array<{
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          }>;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            conversionStatus: string | null;
            created_at: any;
            file: {
              __typename?: "File";
              filename: string;
              mimetype: string | null;
              size: number;
              url: string;
              thumbUrl: string | null;
            };
          } | null;
        };
      }>;
    } | null;
  };
};

export type PrivateClassMessagesQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
}>;

export type PrivateClassMessagesQuery = {
  __typename?: "Query";
  privateClassMessages: Array<{
    __typename?: "PrivateClassMessage";
    uid: string;
    thread_uid: string;
    sentAt: any;
    sender: {
      __typename?: "MessageSender";
      uid: string;
      name: string | null;
      photo: string | null;
      avatar: string | null;
      isLearner: boolean;
    };
    messageContent: {
      __typename?: "MessageContent";
      uid: string;
      text: string | null;
      originalMimeType: TextMimeType;
      externalVideoUrl: string | null;
      editedAt: any | null;
      htmlText: string | null;
      attachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      imageAttachments: Array<{
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      }>;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
  }>;
};

export type LiveMeetingButtonQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
}>;

export type LiveMeetingButtonQuery = {
  __typename?: "Query";
  joinMeeting: {
    __typename?: "JoinMeeting";
    uid: string;
    canManage: boolean;
    meetingStartTime: any | null;
    meetingEndTime: any | null;
    usersCanHaveLiveMeeting: boolean | null;
    isFlexSchedule: boolean;
    meetingsCount: number;
    sectionStartTime: any | null;
    enrollmentUid: string | null;
    isSellerOrg: boolean | null;
  };
};

export type LearnerLiveMeetingQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
  lessonUid: Scalars["ID"];
}>;

export type LearnerLiveMeetingQuery = {
  __typename?: "Query";
  lessonLiveMeeting: {
    __typename?: "LessonLiveMeeting";
    uid: string;
    enrollmentUid: string | null;
    classRecordingUids: Array<string | null>;
    sectionStartTime: any | null;
    meetingStartTime: any | null;
    meetingEndTime: any | null;
    meetingsCount: number;
    usersCanHaveLiveMeeting: boolean | null;
  };
};

export type JoinNextMeetingQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  enrollmentUid?: InputMaybe<Scalars["ID"]>;
}>;

export type JoinNextMeetingQuery = {
  __typename?: "Query";
  joinNextMeeting: {
    __typename?: "NextMeeting";
    uid: string;
    currentUserCanManage: boolean;
    url: string;
    shouldMarkAttendance: boolean;
  };
};

export type LearnerProfileQueryVariables = Exact<{
  learnerUid: Scalars["ID"];
}>;

export type LearnerProfileQuery = {
  __typename?: "Query";
  learnerProfile: {
    __typename?: "LearnerProfile";
    uid: string;
    name: string | null;
    age: number | null;
    avatar: string | null;
    unlockedAvatars: Array<string>;
    pronoun: string | null;
    aboutMe: string | null;
    isProfileAgeHidden: boolean;
    isProfileLocationHidden: boolean;
    location: {
      __typename?: "ApproximateLocation";
      state: string | null;
      country: string | null;
    } | null;
    favoritedClassList: {
      __typename?: "SavedClassList";
      listings: Array<{
        __typename?: "Listing";
        activity: {
          __typename?: "Activity";
          uid: string;
          title: string;
          slug_id: string;
          age_min: number | null;
          age_max: number | null;
          isClub: boolean;
          leader: {
            __typename?: "Leader";
            uid: string;
            name: string | null;
            photo: string | null;
            leader_link: string | null;
            details: { __typename?: "LeaderDetails"; headline: string | null };
          };
          photo: { __typename?: "Attachment"; fileUrl: string } | null;
          video: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            file: { __typename?: "File"; url: string };
          } | null;
          videoForLearners: {
            __typename?: "Attachment";
            uid: string;
            fileUrl: string;
            videoThumbnailUrl: string | null;
            file: { __typename?: "File"; url: string };
          } | null;
        };
      } | null>;
    } | null;
  };
};

export type CurrentLearnerPastActivitiesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type CurrentLearnerPastActivitiesQuery = {
  __typename?: "Query";
  currentLearnerPastActivities: {
    __typename?: "PaginatedPastActivities";
    totalResults: number;
    activities: Array<{
      __typename?: "Activity";
      uid: string;
      title: string;
      slug_id: string;
      age_min: number | null;
      age_max: number | null;
      isClub: boolean;
      leader: {
        __typename?: "Leader";
        uid: string;
        name: string | null;
        photo: string | null;
        leader_link: string | null;
        details: { __typename?: "LeaderDetails"; headline: string | null };
      };
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      video: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        file: { __typename?: "File"; url: string };
      } | null;
      videoForLearners: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        file: { __typename?: "File"; url: string };
      } | null;
    }>;
  };
};

export type SaveFavoriteClassToProfileMutationVariables = Exact<{
  activityUids: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type SaveFavoriteClassToProfileMutation = {
  __typename?: "Mutation";
  saveLearnerProfileClasses: {
    __typename?: "SavedClassList";
    listings: Array<{
      __typename?: "Listing";
      activity: {
        __typename?: "Activity";
        uid: string;
        title: string;
        age_min: number | null;
        age_max: number | null;
        isClub: boolean;
        leader: {
          __typename?: "Leader";
          uid: string;
          name: string | null;
          photo: string | null;
          leader_link: string | null;
          details: { __typename?: "LeaderDetails"; headline: string | null };
        };
        photo: { __typename?: "Attachment"; fileUrl: string } | null;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: { __typename?: "File"; url: string };
        } | null;
        videoForLearners: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          file: { __typename?: "File"; url: string };
        } | null;
      };
    } | null>;
  };
};

export type SaveLearnerProfileMutationVariables = Exact<{
  profileInput: LearnerProfileInput;
}>;

export type SaveLearnerProfileMutation = {
  __typename?: "Mutation";
  saveLearnerProfile: {
    __typename?: "LearnerProfile";
    uid: string;
    avatar: string | null;
    aboutMe: string | null;
  };
};

export type SaveLearnerProfileSettingsMutationVariables = Exact<{
  learnerProfileSettingsInput: LearnerProfileSettingsInput;
}>;

export type SaveLearnerProfileSettingsMutation = {
  __typename?: "Mutation";
  saveLearnerProfileSettings: boolean;
};

export type ClassroomRecordingQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  recordingUid: Scalars["ID"];
}>;

export type ClassroomRecordingQuery = {
  __typename?: "Query";
  learnersForParentInSection: Array<{
    __typename?: "Learner";
    uid: string;
  } | null>;
  classroom: {
    __typename?: "Classroom";
    uid: string;
    usersCanPost: boolean;
    activity: {
      __typename?: "Activity";
      uid: string;
      user_uid: string;
      title: string;
      weekly_meetings: number | null;
      duration_weeks: number | null;
      is_ongoing_weekly: boolean;
      slug_id: string;
      isClub: boolean;
      published_at: any | null;
      hasTeacherSchedule: boolean;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
    };
    section: {
      __typename?: "Section";
      uid: string;
      currentUserCanManage: boolean;
      start_time: any | null;
      end_time: any | null;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
        end_time: any;
      } | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      classRecording:
        | {
            __typename?: "ClassRecording";
            isExpired: boolean;
            exceedsDurationLimit: boolean;
            playUrl: string | null;
            uid: string;
            startTime: any;
            endTime: any;
            meeting: {
              __typename?: "Meeting";
              hasAiSummary: boolean;
              uid: string;
              start_time: any;
              end_time: any;
              recordingAvailability: RecordingAvailability;
              recordingRequests: Array<{
                __typename?: "RecordingRequest";
                requestedAt: any;
                message: string;
                requestedBy: {
                  __typename?: "Learner";
                  uid: string;
                  name: string | null;
                };
              }>;
              classRecordings: Array<
                | {
                    __typename?: "ClassRecording";
                    uid: string;
                    startTime: any;
                    endTime: any;
                  }
                | {
                    __typename?: "ZoomRecording";
                    uid: string;
                    startTime: any;
                    endTime: any;
                  }
              >;
              attendances: Array<{
                __typename?: "Attendance";
                learner: { __typename?: "Learner"; name: string | null };
              }>;
            } | null;
          }
        | {
            __typename?: "ZoomRecording";
            uid: string;
            startTime: any;
            endTime: any;
            meeting: {
              __typename?: "Meeting";
              hasAiSummary: boolean;
              uid: string;
              start_time: any;
              end_time: any;
              recordingAvailability: RecordingAvailability;
              recordingRequests: Array<{
                __typename?: "RecordingRequest";
                requestedAt: any;
                message: string;
                requestedBy: {
                  __typename?: "Learner";
                  uid: string;
                  name: string | null;
                };
              }>;
              classRecordings: Array<
                | {
                    __typename?: "ClassRecording";
                    uid: string;
                    startTime: any;
                    endTime: any;
                  }
                | {
                    __typename?: "ZoomRecording";
                    uid: string;
                    startTime: any;
                    endTime: any;
                  }
              >;
              attendances: Array<{
                __typename?: "Attendance";
                learner: { __typename?: "Learner"; name: string | null };
              }>;
            } | null;
          };
    };
  };
};

export type ClubQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  start?: InputMaybe<Scalars["DateTime"]>;
  end?: InputMaybe<Scalars["DateTime"]>;
  score?: InputMaybe<Scalars["Float"]>;
  plainText?: InputMaybe<Scalars["Boolean"]>;
  hasCurrentUserEnrollments: Scalars["Boolean"];
  postLimit?: InputMaybe<Scalars["Int"]>;
  scoreFrom?: InputMaybe<Scalars["DateTime"]>;
}>;

export type ClubQuery = {
  __typename?: "Query";
  club: {
    __typename?: "Club";
    uid: string;
    currentLearnerIsVerified: boolean;
    currentLearnerMustAcceptGuidelines: boolean;
    currentLearnerHasSubmittedIntroductionForClub: boolean;
    currentUserCanParticipate: boolean;
    section: {
      __typename?: "Section";
      uid: string;
      published_at: any | null;
      deleted_at: any | null;
      canceled_at: any | null;
      start_time: any | null;
      end_time: any | null;
      size_max: number | null;
      currentUserCanManage: boolean;
      nextOngoingMeeting: {
        __typename?: "Meeting";
        uid: string;
        start_time: any;
      } | null;
    };
    activity: {
      __typename?: "Activity";
      uid: string;
      title: string;
      titleTranslated: string | null;
      description: string | null;
      user_uid: string;
      isClub: boolean;
      published_at: any | null;
      is_ongoing_weekly: boolean;
      weekly_meetings: number | null;
      photo: { __typename?: "Attachment"; fileUrl: string } | null;
      videoForLearners: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      leader: { __typename?: "Leader"; uid: string; name: string | null };
      clubGuidelines: {
        __typename?: "WelcomeMessage";
        text: string | null;
      } | null;
      clubBannerImage: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
      clubWelcomeVideo: {
        __typename?: "Attachment";
        uid: string;
        fileUrl: string;
        videoThumbnailUrl: string | null;
        conversionStatus: string | null;
        created_at: any;
        file: {
          __typename?: "File";
          filename: string;
          mimetype: string | null;
          size: number;
          url: string;
          thumbUrl: string | null;
        };
      } | null;
    };
    pinnedPosts: Array<{
      __typename?: "ClassPost";
      uid: string;
      isWelcomePost: boolean;
      publishAt: any;
      title: string | null;
      promotedAt: any | null;
      pinnedAt: any | null;
      mentionedEnrollmentUids: Array<string>;
      backgroundColor: string | null;
      score: number | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      commentsPreview: {
        __typename?: "CommentsPreview";
        remainingCommentsCount: number;
        comments: Array<{
          __typename?: "ClassPostComment";
          uid: string;
          sendAt: any;
          mentionedEnrollmentUids: Array<string>;
          mentionedTeacherUid: string | null;
          backgroundColor: string | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      };
    }>;
    posts: Array<{
      __typename?: "ClassPost";
      uid: string;
      isWelcomePost: boolean;
      publishAt: any;
      title: string | null;
      promotedAt: any | null;
      pinnedAt: any | null;
      mentionedEnrollmentUids: Array<string>;
      backgroundColor: string | null;
      score: number | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      commentsPreview: {
        __typename?: "CommentsPreview";
        remainingCommentsCount: number;
        comments: Array<{
          __typename?: "ClassPostComment";
          uid: string;
          sendAt: any;
          mentionedEnrollmentUids: Array<string>;
          mentionedTeacherUid: string | null;
          backgroundColor: string | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      };
    }>;
    mentionNames: Array<{
      __typename?: "MentionName";
      id: string;
      display: string;
      avatar: string | null;
      learnerUid: string | null;
      startTime: any | null;
    }>;
    currentUserEnrollments?: Array<{
      __typename?: "Enrollment";
      uid: string;
      ongoing_start_time: any | null;
      ongoing_end_time: any | null;
      isPaused: boolean;
      isEnded: boolean;
      usersCanCommunicate: boolean;
      learner: { __typename?: "Learner"; uid: string } | null;
    }>;
  };
};

export type ClubPostsQueryVariables = Exact<{
  sectionUid: Scalars["ID"];
  start?: InputMaybe<Scalars["DateTime"]>;
  end?: InputMaybe<Scalars["DateTime"]>;
  plainText?: InputMaybe<Scalars["Boolean"]>;
  postLimit?: InputMaybe<Scalars["Int"]>;
  score?: InputMaybe<Scalars["Float"]>;
  scoreFrom?: InputMaybe<Scalars["DateTime"]>;
}>;

export type ClubPostsQuery = {
  __typename?: "Query";
  club: {
    __typename?: "Club";
    posts: Array<{
      __typename?: "ClassPost";
      uid: string;
      isWelcomePost: boolean;
      publishAt: any;
      title: string | null;
      promotedAt: any | null;
      pinnedAt: any | null;
      mentionedEnrollmentUids: Array<string>;
      backgroundColor: string | null;
      score: number | null;
      sender: {
        __typename?: "MessageSender";
        uid: string;
        name: string | null;
        photo: string | null;
        avatar: string | null;
        isLearner: boolean;
      };
      messageContent: {
        __typename?: "MessageContent";
        uid: string;
        text: string | null;
        originalMimeType: TextMimeType;
        externalVideoUrl: string | null;
        editedAt: any | null;
        htmlText: string | null;
        attachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        imageAttachments: Array<{
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        }>;
        video: {
          __typename?: "Attachment";
          uid: string;
          fileUrl: string;
          videoThumbnailUrl: string | null;
          conversionStatus: string | null;
          created_at: any;
          file: {
            __typename?: "File";
            filename: string;
            mimetype: string | null;
            size: number;
            url: string;
            thumbUrl: string | null;
          };
        } | null;
      };
      commentsPreview: {
        __typename?: "CommentsPreview";
        remainingCommentsCount: number;
        comments: Array<{
          __typename?: "ClassPostComment";
          uid: string;
          sendAt: any;
          mentionedEnrollmentUids: Array<string>;
          mentionedTeacherUid: string | null;
          backgroundColor: string | null;
          sender: {
            __typename?: "MessageSender";
            uid: string;
            name: string | null;
            photo: string | null;
            avatar: string | null;
            isLearner: boolean;
          };
          messageContent: {
            __typename?: "MessageContent";
            uid: string;
            text: string | null;
            originalMimeType: TextMimeType;
            externalVideoUrl: string | null;
            editedAt: any | null;
            htmlText: string | null;
            attachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            imageAttachments: Array<{
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            }>;
            video: {
              __typename?: "Attachment";
              uid: string;
              fileUrl: string;
              videoThumbnailUrl: string | null;
              conversionStatus: string | null;
              created_at: any;
              file: {
                __typename?: "File";
                filename: string;
                mimetype: string | null;
                size: number;
                url: string;
                thumbUrl: string | null;
              };
            } | null;
          };
        }>;
      };
    }>;
  };
};

export type AutoMarkAttendanceMutationVariables = Exact<{
  sectionUid?: InputMaybe<Scalars["ID"]>;
}>;

export type AutoMarkAttendanceMutation = {
  __typename?: "Mutation";
  markAttended: boolean;
};

export type AutoMarkTeacherAttendanceMutationVariables = Exact<{
  sectionUid: Scalars["ID"];
}>;

export type AutoMarkTeacherAttendanceMutation = {
  __typename?: "Mutation";
  markTeacherAttended: boolean;
};

export type SampleClubPost_WelcomeMessageFragment = {
  __typename?: "WelcomeMessage";
  text: string | null;
  attachments: Array<{
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    file: { __typename?: "File"; url: string; mimetype: string | null };
  }> | null;
  video: {
    __typename?: "Attachment";
    uid: string;
    fileUrl: string;
    videoThumbnailUrl: string | null;
    file: { __typename?: "File"; url: string; mimetype: string | null };
  } | null;
};

export type GetS3FileUploadUrlMutationVariables = Exact<{
  fileName?: InputMaybe<Scalars["String"]>;
  accessTier?: InputMaybe<FileAccessTier>;
}>;

export type GetS3FileUploadUrlMutation = {
  __typename?: "Mutation";
  getS3FileUploadUrl: {
    __typename?: "FileUploadCredentials";
    uploadUrl: string;
    cdnUrl: string;
    newFileName: string;
  } | null;
};

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Date: any;
  /** A field whose value is an existing 2 or 3 letter ISO 639 language code https://iso639-3.sil.org/code_tables/639/data */
  Iso639: any;
  JSON: any;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  Url: any;
};

export const LearnerModeSwitchAuthRequirement = {
  Password: "password",
  Pin: "pin",
} as const;

export type LearnerModeSwitchAuthRequirement =
  (typeof LearnerModeSwitchAuthRequirement)[keyof typeof LearnerModeSwitchAuthRequirement];
export const LearningStatementsVerb = {
  Completed: "Completed",
  NotStarted: "NotStarted",
  Started: "Started",
  Submitted: "Submitted",
  Viewed: "Viewed",
  Voided: "Voided",
} as const;

export type LearningStatementsVerb =
  (typeof LearningStatementsVerb)[keyof typeof LearningStatementsVerb];
export const TextMimeType = {
  TextHtml: "TEXT_HTML",
  TextMarkdown: "TEXT_MARKDOWN",
  TextPlain: "TEXT_PLAIN",
  TextPlainWithMentions: "TEXT_PLAIN_WITH_MENTIONS",
} as const;

export type TextMimeType = (typeof TextMimeType)[keyof typeof TextMimeType];
export const SubmissionRequirementType = {
  Optional: "optional",
  Recommended: "recommended",
  Required: "required",
} as const;

export type SubmissionRequirementType =
  (typeof SubmissionRequirementType)[keyof typeof SubmissionRequirementType];
export const BlockType = {
  Text: "text",
  Video: "video",
} as const;

export type BlockType = (typeof BlockType)[keyof typeof BlockType];
export type CommentsFilterInput = {
  creationDateSortOrder?: InputMaybe<SortOrder>;
};

export const SortOrder = {
  Ascending: "ascending",
  Descending: "descending",
} as const;

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder];
export type SearchFilters = {
  activityRatingMin?: InputMaybe<Scalars["Float"]>;
  /**
   * A list of strings that are matched without analysis to normalized values
   * from the activities.tags column
   */
  adminTags?: InputMaybe<Array<Scalars["String"]>>;
  age?: InputMaybe<Scalars["String"]>;
  availableTimes?: InputMaybe<Array<SearchFilterExcludeTimeWindow>>;
  capacityMax?: InputMaybe<Scalars["Int"]>;
  capacityMin?: InputMaybe<Scalars["Int"]>;
  curriculums?: InputMaybe<Array<Scalars["String"]>>;
  delivery?: InputMaybe<Scalars["String"]>;
  dow?: InputMaybe<Scalars["String"]>;
  durationSessionMax?: InputMaybe<Scalars["Int"]>;
  durationSessionMin?: InputMaybe<Scalars["Int"]>;
  durationWeeksMax?: InputMaybe<Scalars["Int"]>;
  durationWeeksMin?: InputMaybe<Scalars["Int"]>;
  enabledBooleanFilters?: InputMaybe<Scalars["String"]>;
  endBy?: InputMaybe<Scalars["String"]>;
  endByTime?: InputMaybe<Scalars["Float"]>;
  englishProficiencyLevel?: InputMaybe<EnglishProficiencyLevel>;
  /**
   * Boolean to exclude activities with the new 1-1 format in search results
   * Default: false
   */
  excludeNewOneOnOneFormat?: InputMaybe<Scalars["Boolean"]>;
  /** only returns recurring 1 on 1 classes */
  excludeNonOngoingOneOnOne?: InputMaybe<Scalars["Boolean"]>;
  excludeTimeWindows?: InputMaybe<Array<SearchFilterExcludeTimeWindow>>;
  format?: InputMaybe<Scalars["String"]>;
  fundingPrograms?: InputMaybe<Array<Scalars["String"]>>;
  gradeLevel?: InputMaybe<Scalars["String"]>;
  hasAssessment?: InputMaybe<Scalars["Boolean"]>;
  hasFilledOutUniqueLearningNeeds?: InputMaybe<Scalars["Boolean"]>;
  hasGrades?: InputMaybe<Scalars["Boolean"]>;
  hasHomework?: InputMaybe<Scalars["Boolean"]>;
  /** Whether to filter listings that are included with membership */
  includedWithMembership?: InputMaybe<Scalars["Boolean"]>;
  includeInProgressFixedLengthLiveFormat?: InputMaybe<Scalars["Boolean"]>;
  /** Deprecated. Use format instead */
  includeSelfPaced?: InputMaybe<Scalars["Boolean"]>;
  isAvailable?: InputMaybe<Scalars["Boolean"]>;
  languageOfInstruction?: InputMaybe<Scalars["String"]>;
  /** UID of the learner this search is specifically for. */
  learnerUid?: InputMaybe<Scalars["String"]>;
  learningNeeds?: InputMaybe<Array<Scalars["String"]>>;
  listUid?: InputMaybe<Scalars["String"]>;
  /** @deprecated No longer used. Use listUid instead. */
  listUids?: InputMaybe<Array<Scalars["String"]>>;
  /**
   * A list of strings, to be matched against the activity title.
   *
   * Example: to search for winter holiday classes, a multiTermQuery could be:
   * ["Hanukkah", "Christmas", "Winter Solstice"]
   */
  multiTermQuery?: InputMaybe<Array<Scalars["String"]>>;
  order?: InputMaybe<Scalars["String"]>;
  priceCreditsPerCourseMax?: InputMaybe<Scalars["Int"]>;
  priceCreditsPerCourseMin?: InputMaybe<Scalars["Int"]>;
  priceCreditsPerMeetingMax?: InputMaybe<Scalars["Int"]>;
  priceCreditsPerMeetingMin?: InputMaybe<Scalars["Int"]>;
  pricePerCourseMax?: InputMaybe<Scalars["Int"]>;
  pricePerCourseMin?: InputMaybe<Scalars["Int"]>;
  pricePerMeetingMax?: InputMaybe<Scalars["Int"]>;
  pricePerMeetingMin?: InputMaybe<Scalars["Int"]>;
  /** A string query, matched against various fields in the activites ES index */
  q?: InputMaybe<Scalars["String"]>;
  /**
   * A number used to be able to reproduce randomized search results on
   * no query searches
   */
  seed?: InputMaybe<Scalars["Int"]>;
  showListings?: InputMaybe<Scalars["Int"]>;
  standards?: InputMaybe<Array<Scalars["String"]>>;
  starred?: InputMaybe<Scalars["Boolean"]>;
  startAfter?: InputMaybe<Scalars["String"]>;
  startAfterTime?: InputMaybe<Scalars["Float"]>;
  startBefore?: InputMaybe<Scalars["String"]>;
  teacherRatingMin?: InputMaybe<Scalars["Float"]>;
  theme?: InputMaybe<Scalars["String"]>;
  time?: InputMaybe<Scalars["String"]>;
  timeOfDay?: InputMaybe<Scalars["String"]>;
  timeZone?: InputMaybe<Scalars["String"]>;
  topics?: InputMaybe<Array<Scalars["String"]>>;
  uniqueLearningNeeds?: InputMaybe<Scalars["String"]>;
  userName?: InputMaybe<Scalars["String"]>;
  userUid?: InputMaybe<Scalars["String"]>;
  weeklyMeetingsMax?: InputMaybe<Scalars["Int"]>;
  weeklyMeetingsMin?: InputMaybe<Scalars["Int"]>;
};

export type SearchFilterExcludeTimeWindow = {
  dow: Scalars["Int"];
  endHour: Scalars["Int"];
  endMinute: Scalars["Int"];
  startHour: Scalars["Int"];
  startMinute: Scalars["Int"];
};

export const EnglishProficiencyLevel = {
  A0: "A0",
  A05: "A05",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  PreA1: "PRE_A1",
} as const;

export type EnglishProficiencyLevel =
  (typeof EnglishProficiencyLevel)[keyof typeof EnglishProficiencyLevel];
export const TeacherCertificateDiscipline = {
  ElementaryEducation: "ElementaryEducation",
  EnglishOrLanguageArts: "EnglishOrLanguageArts",
  EnglishToSpeakersOfOtherLanguages: "EnglishToSpeakersOfOtherLanguages",
  ForeignLanguage: "ForeignLanguage",
  HealthOrPe: "HealthOrPE",
  Mathematics: "Mathematics",
  MusicOrTheaterOrArts: "MusicOrTheaterOrArts",
  Other: "Other",
  Science: "Science",
  SecondaryEducation: "SecondaryEducation",
  SocialStudiesOrHistory: "SocialStudiesOrHistory",
  SpecialEducation: "SpecialEducation",
} as const;

export type TeacherCertificateDiscipline =
  (typeof TeacherCertificateDiscipline)[keyof typeof TeacherCertificateDiscipline];
export const TeacherCertificateState = {
  Alabama: "Alabama",
  Alaska: "Alaska",
  Arizona: "Arizona",
  Arkansas: "Arkansas",
  California: "California",
  Colorado: "Colorado",
  Connecticut: "Connecticut",
  Delaware: "Delaware",
  DistrictOfColumbia: "DistrictOfColumbia",
  Florida: "Florida",
  Georgia: "Georgia",
  Hawaii: "Hawaii",
  Idaho: "Idaho",
  Illinois: "Illinois",
  Indiana: "Indiana",
  Iowa: "Iowa",
  Kansas: "Kansas",
  Kentucky: "Kentucky",
  Louisiana: "Louisiana",
  Maine: "Maine",
  Maryland: "Maryland",
  Massachusetts: "Massachusetts",
  Michigan: "Michigan",
  Minnesota: "Minnesota",
  Mississippi: "Mississippi",
  Missouri: "Missouri",
  Montana: "Montana",
  Nebraska: "Nebraska",
  Nevada: "Nevada",
  NewHampshire: "NewHampshire",
  NewJersey: "NewJersey",
  NewMexico: "NewMexico",
  NewYork: "NewYork",
  NorthCarolina: "NorthCarolina",
  NorthDakota: "NorthDakota",
  NotInUs: "NotInUS",
  Ohio: "Ohio",
  Oklahoma: "Oklahoma",
  Oregon: "Oregon",
  Pennsylvania: "Pennsylvania",
  RhodeIsland: "RhodeIsland",
  SouthCarolina: "SouthCarolina",
  SouthDakota: "SouthDakota",
  Tennessee: "Tennessee",
  Texas: "Texas",
  Utah: "Utah",
  Vermont: "Vermont",
  Virginia: "Virginia",
  Washington: "Washington",
  WestVirginia: "WestVirginia",
  Wisconsin: "Wisconsin",
  Wyoming: "Wyoming",
} as const;

export type TeacherCertificateState =
  (typeof TeacherCertificateState)[keyof typeof TeacherCertificateState];
export const CredentialType = {
  CollegeDegree: "CollegeDegree",
  Other: "Other",
  TeachingCertificate: "TeachingCertificate",
} as const;

export type CredentialType =
  (typeof CredentialType)[keyof typeof CredentialType];
export const DegreeSubject = {
  Accounting: "Accounting",
  ActuarialScience: "ActuarialScience",
  Advertising: "Advertising",
  AerospaceEngineering: "AerospaceEngineering",
  Agriculture: "Agriculture",
  AmericanStudies: "AmericanStudies",
  AnimalScience: "AnimalScience",
  Anthropology: "Anthropology",
  Architecture: "Architecture",
  ArtAndDesign: "ArtAndDesign",
  ArtHistoryCriticismAndConservation: "ArtHistoryCriticismAndConservation",
  AsianStudiesCivilization: "AsianStudiesCivilization",
  BehavioralScience: "BehavioralScience",
  Biochemistry: "Biochemistry",
  BiologyBiologicalSciences: "BiologyBiologicalSciences",
  BiomedicalSciences: "BiomedicalSciences",
  BotanyPlantBiology: "BotanyPlantBiology",
  BusinessAdministrationAndManagement: "BusinessAdministrationAndManagement",
  BusinessCommerce: "BusinessCommerce",
  ChemicalEngineering: "ChemicalEngineering",
  Chemistry: "Chemistry",
  CivilEngineering: "CivilEngineering",
  Communications: "Communications",
  ComputerEngineering: "ComputerEngineering",
  ComputerScience: "ComputerScience",
  ConstructionManagement: "ConstructionManagement",
  CriminalJustice: "CriminalJustice",
  Dance: "Dance",
  EarlyChildhoodEducation: "EarlyChildhoodEducation",
  Economics: "Economics",
  Education: "Education",
  ElectricalEngineering: "ElectricalEngineering",
  ElementaryEducation: "ElementaryEducation",
  EngineeringGeneral: "EngineeringGeneral",
  English: "English",
  EnglishLanguageAndLiterature: "EnglishLanguageAndLiterature",
  EnvironmentalScience: "EnvironmentalScience",
  EthnicStudies: "EthnicStudies",
  ExerciseScience: "ExerciseScience",
  FamilyAndConsumerSciencesHumanSciences:
    "FamilyAndConsumerSciencesHumanSciences",
  FashionMerchandising: "FashionMerchandising",
  FilmCinemaVideoStudies: "FilmCinemaVideoStudies",
  Finance: "Finance",
  FineStudioArts: "FineStudioArts",
  ForeignLanguage: "ForeignLanguage",
  ForensicScienceAndTechnology: "ForensicScienceAndTechnology",
  Forestry: "Forestry",
  Genetics: "Genetics",
  GeologyEarthScience: "GeologyEarthScience",
  GraphicDesign: "GraphicDesign",
  HealthAndPhysicalEducationFitness: "HealthAndPhysicalEducationFitness",
  HealthOrPe: "HealthOrPE",
  HealthProfessionsAndRelatedPrograms: "HealthProfessionsAndRelatedPrograms",
  HealthServicesAlliedHealthHealthSciences:
    "HealthServicesAlliedHealthHealthSciences",
  History: "History",
  Horticulture: "Horticulture",
  HospitalAndHealthCareFacilitiesAdministrationManagement:
    "HospitalAndHealthCareFacilitiesAdministrationManagement",
  HospitalityManagement: "HospitalityManagement",
  HumanDevelopmentFamilyStudies: "HumanDevelopmentFamilyStudies",
  HumanResourcesManagement: "HumanResourcesManagement",
  InformationTechnology: "InformationTechnology",
  InteriorDesign: "InteriorDesign",
  InternationalBusiness: "InternationalBusiness",
  InternationalRelations: "InternationalRelations",
  Journalism: "Journalism",
  Kinesiology: "Kinesiology",
  LiberalArtsAndSciences: "LiberalArtsAndSciences",
  Linguistics: "Linguistics",
  ManagementInformationSystems: "ManagementInformationSystems",
  MarineBiology: "MarineBiology",
  Marketing: "Marketing",
  MaterialsScience: "MaterialsScience",
  Math: "Math",
  MechanicalEngineering: "MechanicalEngineering",
  MolecularBiology: "MolecularBiology",
  Music: "Music",
  MusicOrTheaterOrArts: "MusicOrTheaterOrArts",
  Nursing: "Nursing",
  NutritionSciences: "NutritionSciences",
  OccupationalTherapy: "OccupationalTherapy",
  OrganizationalLeadership: "OrganizationalLeadership",
  Other: "Other",
  Philosophy: "Philosophy",
  Physics: "Physics",
  PoliticalScienceAndGovernment: "PoliticalScienceAndGovernment",
  PreMedicinePreMedicalStudies: "PreMedicinePreMedicalStudies",
  Psychology: "Psychology",
  PublicAdministration: "PublicAdministration",
  PublicHealth: "PublicHealth",
  PublicRelations: "PublicRelations",
  RealEstate: "RealEstate",
  ReligiousStudies: "ReligiousStudies",
  Science: "Science",
  SecondaryEducation: "SecondaryEducation",
  SecondarySchoolAdministrationPrincipalship:
    "SecondarySchoolAdministrationPrincipalship",
  SocialSciences: "SocialSciences",
  SocialWork: "SocialWork",
  Sociology: "Sociology",
  SpanishLanguageAndLiterature: "SpanishLanguageAndLiterature",
  SpecialEducation: "SpecialEducation",
  SpeechCommunicationAndRhetoric: "SpeechCommunicationAndRhetoric",
  SpeechLanguagePathologyPathologist: "SpeechLanguagePathologyPathologist",
  SportsManagement: "SportsManagement",
  SupplyChainManagementLogistics: "SupplyChainManagementLogistics",
  TheatreArts: "TheatreArts",
  UrbanAndRegionalPlanning: "UrbanAndRegionalPlanning",
  UrbanStudies: "UrbanStudies",
  VeterinaryTechnology: "VeterinaryTechnology",
  ZoologyAnimalBiology: "ZoologyAnimalBiology",
} as const;

export type DegreeSubject = (typeof DegreeSubject)[keyof typeof DegreeSubject];
export const DegreeType = {
  AssociatesDegree: "AssociatesDegree",
  BachelorsDegree: "BachelorsDegree",
  DoctoralDegree: "DoctoralDegree",
  DoctorOfMedicine: "DoctorOfMedicine",
  JurisDoctor: "JurisDoctor",
  MastersDegree: "MastersDegree",
} as const;

export type DegreeType = (typeof DegreeType)[keyof typeof DegreeType];
export const EducatorTier = {
  NewOnOutschool: "new_on_outschool",
  Popular: "popular",
  RisingStar: "rising_star",
  Star: "star",
} as const;

export type EducatorTier = (typeof EducatorTier)[keyof typeof EducatorTier];
export const MainToolbarPinnedTabs = {
  Availability: "availability",
  Classes: "classes",
  Conversations: "conversations",
  Coupons: "coupons",
  Credentials: "credentials",
  Groups: "groups",
  Insights: "insights",
  Marketing: "marketing",
  Profile: "profile",
  Schedule: "schedule",
  Sections: "sections",
} as const;

export type MainToolbarPinnedTabs =
  (typeof MainToolbarPinnedTabs)[keyof typeof MainToolbarPinnedTabs];
export const ClassFormat = {
  Club: "CLUB",
  Flex: "FLEX",
  MultiDay: "MULTI_DAY",
  OneOnOne: "ONE_ON_ONE",
  OneTime: "ONE_TIME",
  Ongoing: "ONGOING",
  SelfPaced: "SELF_PACED",
} as const;

export type ClassFormat = (typeof ClassFormat)[keyof typeof ClassFormat];
export const SavedClassListStatus = {
  LearnerProfile: "learnerProfile",
  Private: "private",
  Unlisted: "unlisted",
} as const;

export type SavedClassListStatus =
  (typeof SavedClassListStatus)[keyof typeof SavedClassListStatus];
export const EntityAvailabilityEntityType = {
  Learner: "learner",
} as const;

export type EntityAvailabilityEntityType =
  (typeof EntityAvailabilityEntityType)[keyof typeof EntityAvailabilityEntityType];
export type TopicsConnectionCursorInput = {
  created_at: Scalars["DateTime"];
  popularity: Scalars["Int"];
  uid: Scalars["ID"];
};

export const RaceEthnicityType = {
  African: "AFRICAN",
  AfricanAmericanOrCaribbean: "AFRICAN_AMERICAN_OR_CARIBBEAN",
  ApacHawaiian: "APAC_HAWAIIAN",
  EastAsian: "EAST_ASIAN",
  European: "EUROPEAN",
  HispanicLatin: "HISPANIC_LATIN",
  IndigenousAmerican: "INDIGENOUS_AMERICAN",
  MiddleEastern: "MIDDLE_EASTERN",
  Other: "OTHER",
  PreferNotToAnswer: "PREFER_NOT_TO_ANSWER",
  SouthAsian: "SOUTH_ASIAN",
  SoutheastAsian: "SOUTHEAST_ASIAN",
  White: "WHITE",
} as const;

export type RaceEthnicityType =
  (typeof RaceEthnicityType)[keyof typeof RaceEthnicityType];
/** Type of enrollment/order payment. Keep this in sync with knex migration constraint. */
export const TenderType = {
  AppleIap: "apple_iap",
  ClassWallet: "class_wallet",
  Coupon: "coupon",
  EsaMembershipCredit: "esa_membership_credit",
  FundingProgramInvoice: "funding_program_invoice",
  PricingOffer: "pricing_offer",
  PurchaseOrder: "purchase_order",
  StoredCredit: "stored_credit",
  Stripe: "stripe",
  StripeCoupon: "stripe_coupon",
  SubscriptionCredit: "subscription_credit",
} as const;

export type TenderType = (typeof TenderType)[keyof typeof TenderType];
export const RecordingAvailability = {
  Hidden: "hidden",
  Processing: "processing",
  Requestable: "requestable",
  Requested: "requested",
  Shown: "shown",
  Unavailable: "unavailable",
} as const;

export type RecordingAvailability =
  (typeof RecordingAvailability)[keyof typeof RecordingAvailability];
export const MeetingRequestStatus = {
  /** The request has been approved by the parent */
  Confirmed: "Confirmed",
  /** The request has been declined by the parent */
  Declined: "Declined",
  /** The request expired before parent approved or declined */
  Expired: "Expired",
  /** The request must be approved by the parent */
  Pending: "Pending",
} as const;

export type MeetingRequestStatus =
  (typeof MeetingRequestStatus)[keyof typeof MeetingRequestStatus];
export const MeetingStartStatus = {
  LateNoShow: "LateNoShow",
  NotStarted: "NotStarted",
  StartedLate: "StartedLate",
  StartedOnTime: "StartedOnTime",
  Unknown: "Unknown",
} as const;

export type MeetingStartStatus =
  (typeof MeetingStartStatus)[keyof typeof MeetingStartStatus];
export const SectionLessonType = {
  Lesson: "Lesson",
  Meeting: "Meeting",
  MeetingWithLesson: "MeetingWithLesson",
} as const;

export type SectionLessonType =
  (typeof SectionLessonType)[keyof typeof SectionLessonType];
export const EnrollmentCancellationType = {
  AdminAction: "admin_action",
  ParentWithdrew: "parent_withdrew",
  TeacherCanceled: "teacher_canceled",
  Unknown: "unknown",
} as const;

export type EnrollmentCancellationType =
  (typeof EnrollmentCancellationType)[keyof typeof EnrollmentCancellationType];
export const CurrencyCode = {
  Aud: "AUD",
  Cad: "CAD",
  Eur: "EUR",
  Gbp: "GBP",
  Hkd: "HKD",
  Inr: "INR",
  Jpy: "JPY",
  Krw: "KRW",
  Mxn: "MXN",
  Nzd: "NZD",
  Thb: "THB",
  Twd: "TWD",
  Usd: "USD",
} as const;

export type CurrencyCode = (typeof CurrencyCode)[keyof typeof CurrencyCode];
export const CouponClassFormats = {
  Course: "Course",
  EnrichmentOrClub: "EnrichmentOrClub",
  Group: "Group",
  MultiDay: "MultiDay",
  OneOnOne: "OneOnOne",
  OneTime: "OneTime",
  Ongoing: "Ongoing",
  SelfPaced: "SelfPaced",
  Semester: "Semester",
} as const;

export type CouponClassFormats =
  (typeof CouponClassFormats)[keyof typeof CouponClassFormats];
export const CouponType = {
  Outschool: "outschool",
  Teacher: "teacher",
} as const;

export type CouponType = (typeof CouponType)[keyof typeof CouponType];
export const PricingOfferAdminFilter = {
  Active: "Active",
  All: "All",
  Deleted: "Deleted",
} as const;

export type PricingOfferAdminFilter =
  (typeof PricingOfferAdminFilter)[keyof typeof PricingOfferAdminFilter];
export const OrganizationType = {
  CharterSchool: "charter_school",
  CommunityPartner: "community_partner",
  Company: "company",
  CreativeSchoolingOption: "creative_schooling_option",
  EsaOrMicrogrant: "esa_or_microgrant",
  OrgCommunityPartner: "org_community_partner",
  School: "school",
} as const;

export type OrganizationType =
  (typeof OrganizationType)[keyof typeof OrganizationType];
export const GiftCardStatus = {
  Canceled: "Canceled",
  Incomplete: "Incomplete",
  Purchased: "Purchased",
  Redeemed: "Redeemed",
  Sent: "Sent",
} as const;

export type GiftCardStatus =
  (typeof GiftCardStatus)[keyof typeof GiftCardStatus];
export const CreditReferralTransactionType = {
  UserWasReferred: "UserWasReferred",
  UserWasReferrer: "UserWasReferrer",
} as const;

export type CreditReferralTransactionType =
  (typeof CreditReferralTransactionType)[keyof typeof CreditReferralTransactionType];
export const CreditTransactionType = {
  Adjustment: "adjustment",
  Admin: "admin",
  AllowanceWithdrawal: "allowance_withdrawal",
  CreditOffers: "credit_offers",
  EsaMembershipClawback: "esa_membership_clawback",
  EsaMembershipDeposit: "esa_membership_deposit",
  Purchase: "purchase",
  Redemption: "redemption",
  Referral: "referral",
  Refund: "refund",
  Subscription: "subscription",
  SubscriptionDiscardCancelation: "subscription_discard_cancelation",
  SubscriptionDiscardRollover: "subscription_discard_rollover",
  SubscriptionRecoverDiscardedCancelation:
    "subscription_recover_discarded_cancelation",
  Urbansitter: "urbansitter",
  Voucher: "voucher",
} as const;

export type CreditTransactionType =
  (typeof CreditTransactionType)[keyof typeof CreditTransactionType];
export const PaymentScheduleTypes = {
  MonthlyFirst: "MonthlyFirst",
  WeeklySunday: "WeeklySunday",
} as const;

export type PaymentScheduleTypes =
  (typeof PaymentScheduleTypes)[keyof typeof PaymentScheduleTypes];
export const PaymentScheduleStatus = {
  AlreadyPaid: "AlreadyPaid",
  AwaitingPayment: "AwaitingPayment",
  Ended: "Ended",
  NotYetStarted: "NotYetStarted",
} as const;

export type PaymentScheduleStatus =
  (typeof PaymentScheduleStatus)[keyof typeof PaymentScheduleStatus];
export const RefundPolicyType = {
  Flexible: "flexible",
  Limited: "limited",
  Moderate: "moderate",
  Variable: "variable",
} as const;

export type RefundPolicyType =
  (typeof RefundPolicyType)[keyof typeof RefundPolicyType];
export const EnrollmentFilter = {
  OneOnOne: "OneOnOne",
} as const;

export type EnrollmentFilter =
  (typeof EnrollmentFilter)[keyof typeof EnrollmentFilter];
export const EnrollmentStatus = {
  Absent: "Absent",
  Attended: "Attended",
  Confirmed: "Confirmed",
  Ended: "Ended",
  Enrolled: "Enrolled",
  Paused: "Paused",
  StartingSoon: "StartingSoon",
  Waitlisted: "Waitlisted",
  Withdrawn: "Withdrawn",
} as const;

export type EnrollmentStatus =
  (typeof EnrollmentStatus)[keyof typeof EnrollmentStatus];
export type MeetingRequestFilters = {
  /**
   * Only return meeting requests whose start_time is after Date.
   * Defaults to "now()"
   */
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  /**
   * Only return meeting requests whose start_time before Date
   * Defaults to no filter
   */
  startBefore?: InputMaybe<Scalars["DateTime"]>;
  /**
   * Only return meetings whose status matches this.
   * N.B., Meetings are always "confirmed" so other statuses will exclude all Meetings
   */
  status?: InputMaybe<MeetingRequestStatus>;
};

export const MeetingFilter = {
  All: "All",
  Enrolled: "Enrolled",
} as const;

export type MeetingFilter = (typeof MeetingFilter)[keyof typeof MeetingFilter];
export const ParticipantRole = {
  /** The learner */
  Learner: "Learner",
  /** None of the above; possibly an org Group moderator */
  Other: "Other",
  /** The parent */
  Parent: "Parent",
  /** The owner of the seller org this message's section belongs to, if any */
  SellerOrgOwner: "SellerOrgOwner",
  /** The teacher of this message's section */
  Teacher: "Teacher",
} as const;

export type ParticipantRole =
  (typeof ParticipantRole)[keyof typeof ParticipantRole];
export const ThreadScope = {
  All: "All",
  Block: "Block",
} as const;

export type ThreadScope = (typeof ThreadScope)[keyof typeof ThreadScope];
export const BlockThreadType = {
  Assignment: "Assignment",
  ClassPost: "ClassPost",
} as const;

export type BlockThreadType =
  (typeof BlockThreadType)[keyof typeof BlockThreadType];
export const WaitlistSource = {
  UnpauseFailure: "unpause_failure",
  UserInitiated: "user_initiated",
} as const;

export type WaitlistSource =
  (typeof WaitlistSource)[keyof typeof WaitlistSource];
export const ApprovalCriterionValue = {
  Negative: "negative",
  Neutral: "neutral",
  Positive: "positive",
} as const;

export type ApprovalCriterionValue =
  (typeof ApprovalCriterionValue)[keyof typeof ApprovalCriterionValue];
export const Audience = {
  Learners: "learners",
  Parents: "parents",
} as const;

export type Audience = (typeof Audience)[keyof typeof Audience];
export type ConversationFiltersInput = {
  activityUid?: InputMaybe<Scalars["ID"]>;
  participantUids?: InputMaybe<Array<Scalars["ID"]>>;
  searchTerms?: InputMaybe<Array<Scalars["String"]>>;
};

export const MessageSelection = {
  All: "all",
  Spam: "spam",
  Unread: "unread",
} as const;

export type MessageSelection =
  (typeof MessageSelection)[keyof typeof MessageSelection];
export const CreditAccountType = {
  EsaMembership: "EsaMembership",
  OsCash: "OSCash",
  Subscription: "Subscription",
} as const;

export type CreditAccountType =
  (typeof CreditAccountType)[keyof typeof CreditAccountType];
export const CreditAccountStatus = {
  Available: "Available",
  InvalidSharedPaymentMethod: "InvalidSharedPaymentMethod",
  RequiresConfirmedPrimaryEmail: "RequiresConfirmedPrimaryEmail",
} as const;

export type CreditAccountStatus =
  (typeof CreditAccountStatus)[keyof typeof CreditAccountStatus];
export const UserEnrollmentsFilters = {
  All: "All",
  Confirmed: "Confirmed",
} as const;

export type UserEnrollmentsFilters =
  (typeof UserEnrollmentsFilters)[keyof typeof UserEnrollmentsFilters];
export const IdvStatus = {
  Accept: "ACCEPT",
  NotStarted: "NOT_STARTED",
  Reject: "REJECT",
  RejectMany: "REJECT_MANY",
  Review: "REVIEW",
  Started: "STARTED",
} as const;

export type IdvStatus = (typeof IdvStatus)[keyof typeof IdvStatus];
export const SellerOrgApplicationStatus = {
  Applied: "applied",
  Approved: "approved",
  Interested: "interested",
  Rejected: "rejected",
} as const;

export type SellerOrgApplicationStatus =
  (typeof SellerOrgApplicationStatus)[keyof typeof SellerOrgApplicationStatus];
export const TeacherApplicationStatus = {
  Approved: "approved",
  Created: "created",
  Declined: "declined",
  Submitted: "submitted",
} as const;

export type TeacherApplicationStatus =
  (typeof TeacherApplicationStatus)[keyof typeof TeacherApplicationStatus];
export const CreateActivityType = {
  Class: "Class",
  Club: "Club",
} as const;

export type CreateActivityType =
  (typeof CreateActivityType)[keyof typeof CreateActivityType];
export const UserLocale = {
  En: "en",
  Es: "es",
  Es_419: "es_419",
  Ja: "ja",
  Ko: "ko",
  ZhTw: "zh_TW",
} as const;

export type UserLocale = (typeof UserLocale)[keyof typeof UserLocale];
export const OutreachReferralStatus = {
  /** Teachers earn a payout when their referred user renews their membership. */
  MembershipRenewed: "membership_renewed",
  /** Referred user has signed up for a membership, but not yet renewed. */
  MembershipStarted: "membership_started",
  /** Referred user has created an account, but not yet signed up for a membership. */
  SignedUp: "signed_up",
} as const;

export type OutreachReferralStatus =
  (typeof OutreachReferralStatus)[keyof typeof OutreachReferralStatus];
export const PaymentMethodType = {
  Card: "Card",
} as const;

export type PaymentMethodType =
  (typeof PaymentMethodType)[keyof typeof PaymentMethodType];
export const ParentReferralStatus = {
  CreditClaimed: "credit_claimed",
  CreditEarned: "credit_earned",
  SignedUp: "signed_up",
} as const;

export type ParentReferralStatus =
  (typeof ParentReferralStatus)[keyof typeof ParentReferralStatus];
export const TeacherReferralStatus = {
  ApplicationDeclined: "application_declined",
  EligibleForPayOut: "eligible_for_pay_out",
  PaidOut: "paid_out",
  TeacherApplied: "teacher_applied",
  TeacherApproved: "teacher_approved",
} as const;

export type TeacherReferralStatus =
  (typeof TeacherReferralStatus)[keyof typeof TeacherReferralStatus];
export const FfapApplicationStatus = {
  Approved: "approved",
  Declined: "declined",
  Pending: "pending",
} as const;

export type FfapApplicationStatus =
  (typeof FfapApplicationStatus)[keyof typeof FfapApplicationStatus];
export const EducatorSelectedFormat = {
  Course: "Course",
  EnrichmentOrClub: "EnrichmentOrClub",
  OneTime: "OneTime",
  Tutoring: "Tutoring",
} as const;

export type EducatorSelectedFormat =
  (typeof EducatorSelectedFormat)[keyof typeof EducatorSelectedFormat];
/** Defines how the classroom appears */
export const ClassroomType = {
  Group: "Group",
  OneOnOne: "OneOnOne",
  SelfPaced: "SelfPaced",
} as const;

export type ClassroomType = (typeof ClassroomType)[keyof typeof ClassroomType];
export const DeliveryType = {
  Camp: "CAMP",
  Club: "CLUB",
  OneOnOneClass: "ONE_ON_ONE_CLASS",
  OneTimeClass: "ONE_TIME_CLASS",
  OngoingClass: "ONGOING_CLASS",
  SemesterCourse: "SEMESTER_COURSE",
  ShortCourse: "SHORT_COURSE",
} as const;

export type DeliveryType = (typeof DeliveryType)[keyof typeof DeliveryType];
export type EnrollmentParamsInput = {
  isActive?: InputMaybe<Scalars["Boolean"]>;
  orderByNextMeeting?: InputMaybe<Scalars["Boolean"]>;
};

export const EsaStatus = {
  Approved: "Approved",
  NotApproved: "NotApproved",
} as const;

export type EsaStatus = (typeof EsaStatus)[keyof typeof EsaStatus];
export const ExternalResourcePolicy = {
  /** Allowed for all ages without parental consent */
  Allowed: "ALLOWED",
  /** Allowed for all ages, parental consent required under age 13 */
  AllowedWithConsent: "ALLOWED_WITH_CONSENT",
  /** Allowed for all ages, parental consent required under age 16 */
  AllowedWithConsentUnder_16: "ALLOWED_WITH_CONSENT_UNDER_16",
  /** Disallowed for all ages */
  Disallowed: "DISALLOWED",
  /** Allowed for ages 13+, disallowed under age 13 */
  DisallowedUnder_13: "DISALLOWED_UNDER_13",
  /** Allowed for ages 16+, disallowed under age 16 */
  DisallowedUnder_16: "DISALLOWED_UNDER_16",
  /** This resource hasn't been reviewed */
  Unvetted: "UNVETTED",
} as const;

export type ExternalResourcePolicy =
  (typeof ExternalResourcePolicy)[keyof typeof ExternalResourcePolicy];
export const SectionFilter = {
  Bookable: "Bookable",
  BookableOrSoldOut: "BookableOrSoldOut",
  Cancelled: "Cancelled",
  Past: "Past",
  Promotable: "Promotable",
  Upcoming: "Upcoming",
} as const;

export type SectionFilter = (typeof SectionFilter)[keyof typeof SectionFilter];
export type SectionSearchInput = {
  daysOfWeek?: InputMaybe<Array<DaysOfWeek>>;
  endBy?: InputMaybe<Scalars["DateTime"]>;
  endByTime?: InputMaybe<Scalars["Float"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  startAfterTime?: InputMaybe<Scalars["Float"]>;
  startBefore?: InputMaybe<Scalars["DateTime"]>;
  userTimeZone?: InputMaybe<Scalars["String"]>;
};

export const DaysOfWeek = {
  Fri: "Fri",
  Mon: "Mon",
  Sat: "Sat",
  Sun: "Sun",
  Thu: "Thu",
  Tue: "Tue",
  Wed: "Wed",
} as const;

export type DaysOfWeek = (typeof DaysOfWeek)[keyof typeof DaysOfWeek];
export const ListingPriceFrequency = {
  PerClass: "PER_CLASS",
  PerMonth: "PER_MONTH",
  PerSession: "PER_SESSION",
  PerWeek: "PER_WEEK",
} as const;

export type ListingPriceFrequency =
  (typeof ListingPriceFrequency)[keyof typeof ListingPriceFrequency];
export const ModalType = {
  Welcome: "WELCOME",
} as const;

export type ModalType = (typeof ModalType)[keyof typeof ModalType];
export type PricingBreakdownInput = {
  activityUid?: InputMaybe<Scalars["String"]>;
  bulkMeetingDurationWeeks?: InputMaybe<Scalars["Int"]>;
  buyingLearnerUids?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  buyingUserUid?: InputMaybe<Scalars["String"]>;
  canScheduleContinuously?: InputMaybe<Scalars["Boolean"]>;
  charterAdminEnrollmentInput?: InputMaybe<CharterAdminEnrollmentInput>;
  couponCode?: InputMaybe<Scalars["String"]>;
  donationCents?: InputMaybe<Scalars["Int"]>;
  enrollableMeetings?: InputMaybe<Array<BulkFutureMeetingInput>>;
  enrollmentCount?: InputMaybe<Scalars["Int"]>;
  isAcceptingGiftEnrollment?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Indicates that all weeks for the ongoing class (from ongoing_start_time to ongoing_end_time) must be prepaid.
   * Defaults to "true" for backwards compatibility
   */
  isPrepaidOngoingEnrollment?: InputMaybe<Scalars["Boolean"]>;
  isUsingPurchaseOrder?: InputMaybe<Scalars["Boolean"]>;
  isWeeklyPayment?: InputMaybe<Scalars["Boolean"]>;
  numCredits?: InputMaybe<Scalars["Int"]>;
  ongoingEndTime?: InputMaybe<Scalars["DateTime"]>;
  ongoingStartTime?: InputMaybe<Scalars["DateTime"]>;
  paymentOption?: InputMaybe<PaymentOption>;
  prepayDurationWeeks?: InputMaybe<Scalars["Int"]>;
  purchaseOrderCoverage?: InputMaybe<Scalars["DateTime"]>;
  sectionUid?: InputMaybe<Scalars["String"]>;
  teacherUid?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type CharterAdminEnrollmentInput = {
  email: Scalars["String"];
  learnerName: Scalars["String"];
  name: Scalars["String"];
};

export type BulkFutureMeetingInput = {
  endTime: Scalars["DateTime"];
  isAvailable: Scalars["Boolean"];
  startTime: Scalars["DateTime"];
};

export type PaymentOption = {
  pricingOfferName?: InputMaybe<Scalars["String"]>;
  type: TenderType;
};

export const CouponState = {
  InvalidActivityFormatNotAllowed: "InvalidActivityFormatNotAllowed",
  InvalidActivityNotEligible: "InvalidActivityNotEligible",
  InvalidAlreadyRedeemed: "InvalidAlreadyRedeemed",
  InvalidCode: "InvalidCode",
  InvalidExpired: "InvalidExpired",
  InvalidMinimumPurchaseNotMet: "InvalidMinimumPurchaseNotMet",
  InvalidNoDiscount: "InvalidNoDiscount",
  InvalidNotStarted: "InvalidNotStarted",
  InvalidOnlyTeacherCouponsForSubscribers:
    "InvalidOnlyTeacherCouponsForSubscribers",
  InvalidTooManyCouponCodeUses: "InvalidTooManyCouponCodeUses",
  InvalidTooManyUsesByUser: "InvalidTooManyUsesByUser",
  InvalidTooManyUsesTotal: "InvalidTooManyUsesTotal",
  InvalidUserNotConfirmed: "InvalidUserNotConfirmed",
  InvalidUserNotEligible: "InvalidUserNotEligible",
  InvalidUserNotEligibleClassFormat: "InvalidUserNotEligibleClassFormat",
  NoCoupon: "NoCoupon",
  Valid: "Valid",
} as const;

export type CouponState = (typeof CouponState)[keyof typeof CouponState];
export const CreditAccountState = {
  InvalidClassNotApprovedForProgram: "InvalidClassNotApprovedForProgram",
  InvalidFundingProgram: "InvalidFundingProgram",
  InvalidNoCreditAccount: "InvalidNoCreditAccount",
  InvalidNoDiscount: "InvalidNoDiscount",
  InvalidNoOpenBalance: "InvalidNoOpenBalance",
  InvalidSharedPaymentMethod: "InvalidSharedPaymentMethod",
  InvalidSubscriptionNotActive: "InvalidSubscriptionNotActive",
  InvalidUnconfirmedEmail: "InvalidUnconfirmedEmail",
  InvalidWhenAcceptingGiftEnrollment: "InvalidWhenAcceptingGiftEnrollment",
  Valid: "Valid",
} as const;

export type CreditAccountState =
  (typeof CreditAccountState)[keyof typeof CreditAccountState];
export const PricingOfferState = {
  InvalidBuyoutSection: "InvalidBuyoutSection",
  InvalidDate: "InvalidDate",
  InvalidEducator: "InvalidEducator",
  InvalidNoDiscount: "InvalidNoDiscount",
  InvalidOverTotalCap: "InvalidOverTotalCap",
  InvalidOverUserCap: "InvalidOverUserCap",
  InvalidUnconfirmedEmail: "InvalidUnconfirmedEmail",
  InvalidWhenAcceptingGiftEnrollment: "InvalidWhenAcceptingGiftEnrollment",
  InvalidWithDonationPurchase: "InvalidWithDonationPurchase",
  NoPricingOffer: "NoPricingOffer",
  ValidBuyerOrg: "ValidBuyerOrg",
  ValidFinancialAid: "ValidFinancialAid",
} as const;

export type PricingOfferState =
  (typeof PricingOfferState)[keyof typeof PricingOfferState];
export const BulkPricingBreakdownItemStatus = {
  ErrorInvalidActivityType: "ERROR_INVALID_ACTIVITY_TYPE",
  ErrorNotAvailable: "ERROR_NOT_AVAILABLE",
  ErrorUnknown: "ERROR_UNKNOWN",
  Success: "SUCCESS",
} as const;

export type BulkPricingBreakdownItemStatus =
  (typeof BulkPricingBreakdownItemStatus)[keyof typeof BulkPricingBreakdownItemStatus];
export type MeetingConflictsQueryInput = {
  ignoreMeetingUids?: InputMaybe<Array<Scalars["ID"]>>;
  range: StartEndTime;
  /** A unique ID that the client can use to identify which range matched this */
  uid: Scalars["ID"];
};

export type StartEndTime = {
  end_time: Scalars["DateTime"];
  start_time: Scalars["DateTime"];
};

export const ClassroomPostFilter = {
  /** Both posts associated with lessons and not */
  All: "All",
  /** Only posts not associated with a lesson */
  Announcements: "Announcements",
  /** Only posts associated with a lesson */
  OnlyForLessons: "OnlyForLessons",
} as const;

export type ClassroomPostFilter =
  (typeof ClassroomPostFilter)[keyof typeof ClassroomPostFilter];
export const ClassroomPostOrder = {
  Chronological: "Chronological",
  ReverseChronological: "ReverseChronological",
} as const;

export type ClassroomPostOrder =
  (typeof ClassroomPostOrder)[keyof typeof ClassroomPostOrder];
export type CouponCodeListFilter = {
  code?: InputMaybe<Scalars["String"]>;
  couponType: CouponType;
  couponUid?: InputMaybe<Scalars["String"]>;
  createdBy?: InputMaybe<Scalars["ID"]>;
  status?: InputMaybe<CouponListFilterStatus>;
};

export const CouponListFilterStatus = {
  Active: "Active",
  All: "All",
  Inactive: "Inactive",
} as const;

export type CouponListFilterStatus =
  (typeof CouponListFilterStatus)[keyof typeof CouponListFilterStatus];
export type CouponListFilter = {
  couponType: CouponType;
  createdBy?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<CouponListFilterStatus>;
};

export const LearnerAccessLevel = {
  Full: "Full",
  Limited: "Limited",
  Restricted: "Restricted",
} as const;

export type LearnerAccessLevel =
  (typeof LearnerAccessLevel)[keyof typeof LearnerAccessLevel];
export const TeacherRecommendationType = {
  CurrentLearnersFavoriteTeachers: "CurrentLearnersFavoriteTeachers",
  PopularAndCurrentLearnerFavoriteTeachers:
    "PopularAndCurrentLearnerFavoriteTeachers",
  PopularTeachers: "PopularTeachers",
  SimilarTeachers: "SimilarTeachers",
} as const;

export type TeacherRecommendationType =
  (typeof TeacherRecommendationType)[keyof typeof TeacherRecommendationType];
export const CreditOfferType = {
  /** The 200 credit offer for churned users */
  ChurnedUser200CreditOffer: "ChurnedUser200CreditOffer",
} as const;

export type CreditOfferType =
  (typeof CreditOfferType)[keyof typeof CreditOfferType];
export type InterestTopicSearchFilters = {
  startAfter?: InputMaybe<Scalars["String"]>;
  startBefore?: InputMaybe<Scalars["String"]>;
  timeZone?: InputMaybe<Scalars["String"]>;
};

export const EducatorInsightsDownloadPeriod = {
  AllTime: "ALL_TIME",
  Annual: "ANNUAL",
  Monthly: "MONTHLY",
} as const;

export type EducatorInsightsDownloadPeriod =
  (typeof EducatorInsightsDownloadPeriod)[keyof typeof EducatorInsightsDownloadPeriod];
/**
 * Payout insights CSV. Null payoutYear selects all years (payoutMonth ignored).
 * Non-null payoutYear with null payoutMonth selects the whole payout year.
 * Seller org owners may set instructorUserId to download one org teacher; omit or null for all educators.
 * Sub-org teachers must omit instructorUserId (server always uses their own user id).
 */
export type EducatorPayoutInsightsDownloadInput = {
  instructorUserId?: InputMaybe<Scalars["ID"]>;
  payoutMonth?: InputMaybe<Scalars["Int"]>;
  payoutYear?: InputMaybe<Scalars["Int"]>;
};

export type GetPayoutsCsvUrlInput = {
  leaderUserId?: InputMaybe<Scalars["String"]>;
  payoutMonth: Scalars["Int"];
  payoutYear: Scalars["Int"];
};

export const TnsAccountStatus = {
  Open: "Open",
  OtherSuspended: "OtherSuspended",
  TnsSuspended: "TnsSuspended",
} as const;

export type TnsAccountStatus =
  (typeof TnsAccountStatus)[keyof typeof TnsAccountStatus];
export const TnsAction = {
  ImmediateRemoval: "ImmediateRemoval",
  RemoveStrike: "RemoveStrike",
  Strike: "Strike",
  ToWatchTrend: "ToWatchTrend",
  UndoImmediateRemoval: "UndoImmediateRemoval",
  Warning: "Warning",
} as const;

export type TnsAction = (typeof TnsAction)[keyof typeof TnsAction];
export const TnsActionCategory = {
  ClassroomSecurityIssues: "ClassroomSecurityIssues",
  ContentManagementPii: "ContentManagementPii",
  TeacherDangerousBehavior: "TeacherDangerousBehavior",
  TeacherMisbehaviorFraud: "TeacherMisbehaviorFraud",
} as const;

export type TnsActionCategory =
  (typeof TnsActionCategory)[keyof typeof TnsActionCategory];
/**
 * Which direction to paginate in.
 * Past returns notifications between cursor and the start of time
 * Future returns notifications between cursor and the end of time
 */
export const CursorDirection = {
  Future: "Future",
  Past: "Past",
} as const;

export type CursorDirection =
  (typeof CursorDirection)[keyof typeof CursorDirection];
/** The status of the notification.  "Seen" is currently unused */
export const NotificationStatus = {
  New: "New",
  Read: "Read",
  Seen: "Seen",
} as const;

export type NotificationStatus =
  (typeof NotificationStatus)[keyof typeof NotificationStatus];
/** Represents what type of class post notification happened */
export const AssignmentNotificationAction = {
  NewAssignment: "NewAssignment",
  NewAssignmentComment: "NewAssignmentComment",
} as const;

export type AssignmentNotificationAction =
  (typeof AssignmentNotificationAction)[keyof typeof AssignmentNotificationAction];
/** Represents what type of class post notification happened */
export const ClassPostNotificationAction = {
  Mentioned: "Mentioned",
  NewClassPost: "NewClassPost",
  NewClassPostComment: "NewClassPostComment",
} as const;

export type ClassPostNotificationAction =
  (typeof ClassPostNotificationAction)[keyof typeof ClassPostNotificationAction];
/** Represents what type of club notification happened */
export const ClubNotificationAction = {
  Mentioned: "Mentioned",
  PostPromoted: "PostPromoted",
  RepliedToComment: "RepliedToComment",
  RepliedToPost: "RepliedToPost",
} as const;

export type ClubNotificationAction =
  (typeof ClubNotificationAction)[keyof typeof ClubNotificationAction];
export type LearnerActivityByTopicSearchInput = {
  activityExperiences?: InputMaybe<Array<ActivityExperience>>;
  topicUid?: InputMaybe<Scalars["ID"]>;
};

export const ActivityExperience = {
  Classroom: "Classroom",
  Club: "Club",
} as const;

export type ActivityExperience =
  (typeof ActivityExperience)[keyof typeof ActivityExperience];
export type LearnerKeywordSearchInput = {
  activityExperiences?: InputMaybe<Array<ActivityExperience>>;
  query?: InputMaybe<Scalars["String"]>;
};

export type LearnerSearchSuggestionsInput = {
  query: Scalars["String"];
};

export const LearnerSupportType = {
  Glitch: "GLITCH",
  IFeelUnsafe: "I_FEEL_UNSAFE",
  OtherLearnerBadBehavior: "OTHER_LEARNER_BAD_BEHAVIOR",
  OtherLearnerNeedsHelp: "OTHER_LEARNER_NEEDS_HELP",
} as const;

export type LearnerSupportType =
  (typeof LearnerSupportType)[keyof typeof LearnerSupportType];
export const ActivityReviewQueue = {
  Escalated: "Escalated",
  HighRisk: "HighRisk",
  Regular: "Regular",
  ReReview: "ReReview",
  ReReviewEscalated: "ReReviewEscalated",
} as const;

export type ActivityReviewQueue =
  (typeof ActivityReviewQueue)[keyof typeof ActivityReviewQueue];
export const MessageThreadAction = {
  ParentToClass: "parentToClass",
  ParentToParent: "parentToParent",
  ParentToTeacher: "parentToTeacher",
  PrivateClassMessage: "privateClassMessage",
  TeacherToParent: "teacherToParent",
  TeacherToTeacher: "teacherToTeacher",
  Unknown: "unknown",
} as const;

export type MessageThreadAction =
  (typeof MessageThreadAction)[keyof typeof MessageThreadAction];
export const ActivityReviewMode = {
  Orgs: "orgs",
  Regular: "regular",
  Skipped: "skipped",
  Subject: "subject",
} as const;

export type ActivityReviewMode =
  (typeof ActivityReviewMode)[keyof typeof ActivityReviewMode];
export const OrganizationAdminFilter = {
  Active: "Active",
  All: "All",
  Deleted: "Deleted",
} as const;

export type OrganizationAdminFilter =
  (typeof OrganizationAdminFilter)[keyof typeof OrganizationAdminFilter];
export type DateFilterInput = {
  fromDate?: InputMaybe<Scalars["DateTime"]>;
  toDate?: InputMaybe<Scalars["DateTime"]>;
};

export type SearchSuggestionsInput = {
  query: Scalars["String"];
};

export const ConversationFilterType = {
  Activity: "activity",
  Participant: "participant",
  Search: "search",
  Thread: "thread",
} as const;

export type ConversationFilterType =
  (typeof ConversationFilterType)[keyof typeof ConversationFilterType];
export const CustomSearchUseCase = {
  PitchPageSearch: "PITCH_PAGE_SEARCH",
  TeacherPullSearch: "TEACHER_PULL_SEARCH",
  TutorMatchSearch: "TUTOR_MATCH_SEARCH",
} as const;

export type CustomSearchUseCase =
  (typeof CustomSearchUseCase)[keyof typeof CustomSearchUseCase];
/**
 * Experimental
 * Different types of filters that could be applied on the server-side.
 * Used by the client to signal which types of auto applied filters
 * it does not want the server-side to apply.
 */
export const AutoAppliedFilterType = {
  GradeLevels: "GradeLevels",
} as const;

export type AutoAppliedFilterType =
  (typeof AutoAppliedFilterType)[keyof typeof AutoAppliedFilterType];
export const PromotedExperimentGroup = {
  Control: "control",
  Holdout: "holdout",
  Treatment: "treatment",
} as const;

export type PromotedExperimentGroup =
  (typeof PromotedExperimentGroup)[keyof typeof PromotedExperimentGroup];
/** Deprecated - No longer in use */
export const SearchObjective = {
  AvailableListings: "available_listings",
  UnavailableListings: "unavailable_listings",
} as const;

export type SearchObjective =
  (typeof SearchObjective)[keyof typeof SearchObjective];
export const SearchUseCase = {
  CategoryContent: "CATEGORY_CONTENT",
  CdpAsClp: "CDP_AS_CLP",
  Custom: "CUSTOM",
  Discover: "DISCOVER",
  Feed: "FEED",
  RelatedContent: "RELATED_CONTENT",
  Search: "SEARCH",
} as const;

export type SearchUseCase = (typeof SearchUseCase)[keyof typeof SearchUseCase];
export const StripeDiscountType = {
  /** OUTreach promo code for OUTreach referral program */
  Outreach: "Outreach",
  /** Generic promo code, likely from a marketing campaign */
  Promo: "Promo",
} as const;

export type StripeDiscountType =
  (typeof StripeDiscountType)[keyof typeof StripeDiscountType];
export const CurrentSubscriptionStatus = {
  Active: "Active",
  Canceled: "Canceled",
  PastDue: "PastDue",
  Paused: "Paused",
} as const;

export type CurrentSubscriptionStatus =
  (typeof CurrentSubscriptionStatus)[keyof typeof CurrentSubscriptionStatus];
export const NextBillingCycleSubscriptionStatus = {
  CancelScheduled: "CancelScheduled",
  PauseScheduled: "PauseScheduled",
} as const;

export type NextBillingCycleSubscriptionStatus =
  (typeof NextBillingCycleSubscriptionStatus)[keyof typeof NextBillingCycleSubscriptionStatus];
export const StripeConnectedAccountStatus = {
  InProgress: "IN_PROGRESS",
  NotStarted: "NOT_STARTED",
  RequiresAction: "REQUIRES_ACTION",
  UnderReview: "UNDER_REVIEW",
  Verified: "VERIFIED",
} as const;

export type StripeConnectedAccountStatus =
  (typeof StripeConnectedAccountStatus)[keyof typeof StripeConnectedAccountStatus];
export const TransactionType = {
  ClassWallet: "ClassWallet",
  Credit: "Credit",
  Order: "Order",
} as const;

export type TransactionType =
  (typeof TransactionType)[keyof typeof TransactionType];
export type BulkOrderInput = {
  attribution?: InputMaybe<Attribution>;
  cartUid?: InputMaybe<Scalars["String"]>;
  charterParentInput?: InputMaybe<EnrollmentCharterParentInput>;
  currency_code?: InputMaybe<CurrencyCode>;
  enrollmentInputs: Array<BulkEnrollmentInput>;
  exchange_rate?: InputMaybe<Scalars["Float"]>;
  impressionId?: InputMaybe<Scalars["String"]>;
  learnerPlanUid?: InputMaybe<Scalars["ID"]>;
  message?: InputMaybe<Scalars["String"]>;
  organizationUid?: InputMaybe<Scalars["ID"]>;
  purchaseOrderCoverage?: InputMaybe<Scalars["DateTime"]>;
};

export type Attribution = {
  activity_uid?: InputMaybe<Scalars["String"]>;
  addressBar?: InputMaybe<Scalars["Boolean"]>;
  addressBarUserSlugId?: InputMaybe<Scalars["String"]>;
  anonymousId?: InputMaybe<Scalars["String"]>;
  awc?: InputMaybe<Scalars["String"]>;
  campaign?: InputMaybe<Scalars["String"]>;
  campaignId?: InputMaybe<Scalars["String"]>;
  content?: InputMaybe<Scalars["String"]>;
  created_at?: InputMaybe<Scalars["DateTime"]>;
  landingPage?: InputMaybe<Scalars["String"]>;
  manualReferralType?: InputMaybe<Scalars["String"]>;
  medium?: InputMaybe<Scalars["String"]>;
  referer?: InputMaybe<Scalars["String"]>;
  ruid?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<Scalars["String"]>;
  term?: InputMaybe<Scalars["String"]>;
  usid?: InputMaybe<Scalars["String"]>;
};

export type EnrollmentCharterParentInput = {
  email: Scalars["String"];
  name: Scalars["String"];
};

export type BulkEnrollmentInput = {
  activityUid: Scalars["ID"];
  canScheduleContinuously?: InputMaybe<Scalars["Boolean"]>;
  endTime?: InputMaybe<Scalars["DateTime"]>;
  enrollableMeetings?: InputMaybe<Array<BulkFutureMeetingInput>>;
  isGift?: InputMaybe<Scalars["Boolean"]>;
  isOneOnOneInput?: InputMaybe<Scalars["Boolean"]>;
  isWeeklyPayment?: InputMaybe<Scalars["Boolean"]>;
  learner?: InputMaybe<EnrollmentLearnerInput>;
  meetingDurationWeeks?: InputMaybe<Scalars["Int"]>;
  oneOnOneDuration?: InputMaybe<Scalars["DateTime"]>;
  ongoingEndTime?: InputMaybe<Scalars["DateTime"]>;
  ongoingStartTime?: InputMaybe<Scalars["DateTime"]>;
  orgTeacherUid?: InputMaybe<Scalars["ID"]>;
  pricing_offer?: InputMaybe<Scalars["String"]>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
  selfPacedStartTime?: InputMaybe<Scalars["DateTime"]>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
  uid?: InputMaybe<Scalars["ID"]>;
};

export type EnrollmentLearnerInput = {
  age: Scalars["Int"];
  avatar?: InputMaybe<Scalars["String"]>;
  date_of_birth?: InputMaybe<Scalars["DateTime"]>;
  name: Scalars["String"];
  uid?: InputMaybe<Scalars["ID"]>;
};

export type CouponOrderInput = {
  activityUid: Scalars["ID"];
};

export type FundingProgramInvoiceInput = {
  awardId: Scalars["String"];
  childFirstName: Scalars["String"];
  childLastName: Scalars["String"];
  parentFirstName: Scalars["String"];
  parentLastName: Scalars["String"];
};

export type MeetingSuggestionInput = {
  endTime: Scalars["DateTime"];
  startTime: Scalars["DateTime"];
};

export type DeviceActivationInfo = {
  /** The app version of the device */
  appVersion: Scalars["String"];
  /** The token which authorizes us to send push notifications to this device */
  deviceToken: Scalars["String"];
  /**
   * If auth token is for a learner, you cannot set this value.  Learner uid is
   * implied based on the auth token provided.
   *
   * If auth token is for a user (parent) and learnerUid is set, the device
   * is associated with a specific learner, and we will only push notifications
   * for a given learner.  If it is not set, the notifications will be sent to
   * the parent.
   */
  learnerUid?: InputMaybe<Scalars["ID"]>;
  /** The OS version of the device */
  osVersion: Scalars["String"];
  /** Which platform this device is on.  One of iOS or Android. */
  platform: DevicePlatform;
  /**
   * What categories of notifications are supported by this device.
   * The backend will only send categories of notifications that are in the provided array.
   * Defaults to [PrivateClassMessage, ClassPost, ClassPostComment, Meeting]
   */
  supportedNotifications?: InputMaybe<Array<SupportedNotifications>>;
};

export const DevicePlatform = {
  /** Device is Android, and we should use FCM */
  Android: "Android",
  /** Device is iOS, and we should use APNs */
  IOs: "iOS",
} as const;

export type DevicePlatform =
  (typeof DevicePlatform)[keyof typeof DevicePlatform];
export const SupportedNotifications = {
  AssignmentPost: "AssignmentPost",
  AssignmentPostComment: "AssignmentPostComment",
  ClassPost: "ClassPost",
  ClassPostComment: "ClassPostComment",
  Meeting: "Meeting",
  PrivateClassMessage: "PrivateClassMessage",
  UserMessage: "UserMessage",
} as const;

export type SupportedNotifications =
  (typeof SupportedNotifications)[keyof typeof SupportedNotifications];
/** Rejection type for re-review rejection with incident */
export const ReReviewRejectionType = {
  Incident: "incident",
  TnsWarning: "tns_warning",
  Warning: "warning",
} as const;

export type ReReviewRejectionType =
  (typeof ReReviewRejectionType)[keyof typeof ReReviewRejectionType];
export type CreateAssignmentClassPostInput = {
  dueDate?: InputMaybe<Scalars["DateTime"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  messageContent: MessageContentInput;
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  sectionUid: Scalars["ID"];
  submissionRequirement?: InputMaybe<SubmissionRequirementType>;
  title: Scalars["String"];
};

export type MessageContentInput = {
  attachmentUids?: InputMaybe<Array<Scalars["ID"]>>;
  externalVideoUrl?: InputMaybe<Scalars["String"]>;
  imageAttachmentUids?: InputMaybe<Array<Scalars["ID"]>>;
  mentionsUids?: InputMaybe<Array<Scalars["String"]>>;
  text?: InputMaybe<Scalars["String"]>;
  textMimeType?: InputMaybe<TextMimeType>;
  videoUid?: InputMaybe<Scalars["ID"]>;
};

export type CreateAssignmentLessonPostInput = {
  lessonUid: Scalars["ID"];
  messageContent: MessageContentInput;
  orderInLesson: Scalars["Int"];
  title: Scalars["String"];
};

export type FileInput = {
  filename?: InputMaybe<Scalars["String"]>;
  handle?: InputMaybe<Scalars["ID"]>;
  mimetype?: InputMaybe<Scalars["String"]>;
  originalPath?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  source?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
  url?: InputMaybe<Scalars["String"]>;
};

export type BulkGiftCardsInput = {
  amountCentsPerGiftCard: Scalars["Int"];
  numGiftCards: Scalars["Int"];
  paidForBy: Scalars["String"];
  purchasedForReason: Scalars["String"];
};

export type ChildInput = {
  age?: InputMaybe<Scalars["Int"]>;
  attributes?: InputMaybe<Array<LearnerAttribute>>;
  availableTimes?: InputMaybe<Array<EntityAvailabilityInput>>;
  avatar?: InputMaybe<Scalars["String"]>;
  birthMonth?: InputMaybe<Scalars["Int"]>;
  birthYear?: InputMaybe<Scalars["Int"]>;
  date_of_birth?: InputMaybe<Scalars["DateTime"]>;
  email?: InputMaybe<Scalars["String"]>;
  hasHealthConsent?: InputMaybe<Scalars["Boolean"]>;
  hasMarketingConsent?: InputMaybe<Scalars["Boolean"]>;
  interestTopics?: InputMaybe<Array<Scalars["ID"]>>;
  intro?: InputMaybe<Scalars["String"]>;
  isLoginEnabled?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  optedOutOfPersonalizedRecommendationsAt?: InputMaybe<Scalars["DateTime"]>;
  password?: InputMaybe<Scalars["String"]>;
  pronoun?: InputMaybe<Scalars["String"]>;
  raceEthnicity?: InputMaybe<Array<RaceEthnicityType>>;
  uid?: InputMaybe<Scalars["ID"]>;
  username?: InputMaybe<Scalars["String"]>;
};

export type LearnerAttribute = {
  key?: InputMaybe<Scalars["String"]>;
  value?: InputMaybe<Scalars["String"]>;
};

export type EntityAvailabilityInput = {
  day: Scalars["Int"];
  endHour: Scalars["Int"];
  endMinute: Scalars["Int"];
  startHour: Scalars["Int"];
  startMinute: Scalars["Int"];
  uid?: InputMaybe<Scalars["ID"]>;
};

export type ClassPostInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  blockType?: InputMaybe<BlockType>;
  estimatedDuration?: InputMaybe<Scalars["Int"]>;
  messageContent: MessageContentInput;
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  sectionUid: Scalars["ID"];
  title?: InputMaybe<Scalars["String"]>;
};

export type ClassPostCommentInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  classPostUid: Scalars["ID"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
  messageContent: MessageContentInput;
};

export type ClassPostCommentReplyInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  classPostUid: Scalars["ID"];
  messageContentInput: MessageContentInput;
  threadParentCommentUid: Scalars["ID"];
};

export type ClassPostForLessonInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  blockType?: InputMaybe<BlockType>;
  estimatedDuration?: InputMaybe<Scalars["Int"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  messageContent: MessageContentInput;
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  sectionUid: Scalars["ID"];
  title?: InputMaybe<Scalars["String"]>;
};

export type DonationInput = {
  amountCents: Scalars["Int"];
  orderSlugId: Scalars["ID"];
};

export type ExternalResourceInput = {
  name?: InputMaybe<Scalars["String"]>;
  url?: InputMaybe<Scalars["String"]>;
};

export type GiftCardInputWithDeliveryDate = {
  amountCents: Scalars["Int"];
  deliverAfter?: InputMaybe<Scalars["DateTime"]>;
  deliveryTimezone: Scalars["String"];
  note?: InputMaybe<Scalars["String"]>;
  orderSlugId: Scalars["ID"];
  recipientEmail: Scalars["String"];
  recipientName: Scalars["String"];
  senderEmail: Scalars["String"];
  senderName: Scalars["String"];
};

export type CreateLessonPostInput = {
  blockType?: InputMaybe<BlockType>;
  estimatedDuration?: InputMaybe<Scalars["Int"]>;
  lessonUid: Scalars["ID"];
  messageContent: MessageContentInput;
  orderInLesson: Scalars["Int"];
  title: Scalars["String"];
};

export type PrivateClassMessageInput = {
  classPostUid?: InputMaybe<Scalars["ID"]>;
  learnerUid: Scalars["ID"];
  learningAssignmentClassPostUid?: InputMaybe<Scalars["ID"]>;
  messageContentInput: MessageContentInput;
  sectionUid: Scalars["ID"];
  threadUid?: InputMaybe<Scalars["ID"]>;
};

export type UserQuizTypeAndValueInput = {
  type: Scalars["String"];
  value?: InputMaybe<Scalars["String"]>;
  /**
   * example:
   * [
   *   [{type: "gradeLevel", value: 9}, {type: "subject", value: "math"}],
   *   [{type: "gradeLevel", value: 9}, {type: "subject", value: "english"}]
   * ]
   */
  valueLists?: InputMaybe<
    Array<InputMaybe<Array<InputMaybe<UserQuizTypeAndValue>>>>
  >;
};

export type UserQuizTypeAndValue = {
  type: Scalars["String"];
  value: Scalars["String"];
};

export type UnavailableBlockInput = {
  endTime: Scalars["DateTime"];
  startTime: Scalars["DateTime"];
};

export type TeacherTagInput = {
  uid: Scalars["ID"];
};

export type CreateAccountInput = {
  learnerAge?: InputMaybe<Scalars["Int"]>;
  learnerEmail?: InputMaybe<Scalars["String"]>;
  learnerName?: InputMaybe<Scalars["String"]>;
  learnerPassword?: InputMaybe<Scalars["String"]>;
  parentEmail?: InputMaybe<Scalars["String"]>;
  parentName?: InputMaybe<Scalars["String"]>;
  password?: InputMaybe<Scalars["String"]>;
};

export type BulkCreateAccountOptions = {
  defaultTimeZone?: InputMaybe<Scalars["String"]>;
  learnerUsesParentMode?: InputMaybe<Scalars["Boolean"]>;
  persistChanges?: InputMaybe<Scalars["Boolean"]>;
  sendCoppaEmails?: InputMaybe<Scalars["Boolean"]>;
  unsubscribe?: InputMaybe<Scalars["Boolean"]>;
};

export type LearnerAttributes = {
  availableTimes?: InputMaybe<Array<InputMaybe<AvailableTime>>>;
  avatar?: InputMaybe<Scalars["String"]>;
  birthMonth?: InputMaybe<Scalars["Int"]>;
  birthYear?: InputMaybe<Scalars["Int"]>;
  classSizes?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  hasHealthConsent?: InputMaybe<Scalars["Boolean"]>;
  hasMarketingConsent?: InputMaybe<Scalars["Boolean"]>;
  learnerName?: InputMaybe<Scalars["String"]>;
  learningFormats?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  learningNeeds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  schoolingApproach?: InputMaybe<Scalars["String"]>;
  subjects?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type AvailableTime = {
  day?: InputMaybe<Scalars["Int"]>;
  endHour?: InputMaybe<Scalars["Int"]>;
  endMinute?: InputMaybe<Scalars["Int"]>;
  startHour?: InputMaybe<Scalars["Int"]>;
  startMinute?: InputMaybe<Scalars["Int"]>;
  uid?: InputMaybe<Scalars["ID"]>;
};

export type OsRefInput = {
  a8?: InputMaybe<Scalars["String"]>;
  anonymousId?: InputMaybe<Scalars["String"]>;
  attributionVersionNumber?: InputMaybe<Scalars["Int"]>;
  bing_msclkid?: InputMaybe<Scalars["String"]>;
  campaignId?: InputMaybe<Scalars["String"]>;
  cookieAddressBarTrackingId?: InputMaybe<Scalars["String"]>;
  cookieAddressBarUserSlugId?: InputMaybe<Scalars["String"]>;
  couponCode?: InputMaybe<Scalars["String"]>;
  currentUrl?: InputMaybe<Scalars["String"]>;
  google_dclid?: InputMaybe<Scalars["String"]>;
  google_gbraid?: InputMaybe<Scalars["String"]>;
  google_gclid?: InputMaybe<Scalars["String"]>;
  google_wbraid?: InputMaybe<Scalars["String"]>;
  landingPage?: InputMaybe<Scalars["String"]>;
  meta_fbclid?: InputMaybe<Scalars["String"]>;
  noResetReason?: InputMaybe<Scalars["String"]>;
  originalReferrer?: InputMaybe<Scalars["String"]>;
  otherAddressBarTrackingId?: InputMaybe<Scalars["String"]>;
  otherAddressBarUserSlugId?: InputMaybe<Scalars["String"]>;
  pageViewNumberOfSession?: InputMaybe<Scalars["Int"]>;
  previousUrl?: InputMaybe<Scalars["String"]>;
  resetReason?: InputMaybe<Scalars["String"]>;
  resetTimestamp?: InputMaybe<Scalars["String"]>;
  ruid?: InputMaybe<Scalars["String"]>;
  tiktok_ttclid?: InputMaybe<Scalars["String"]>;
  trackingSessionUid?: InputMaybe<Scalars["String"]>;
  usid?: InputMaybe<Scalars["String"]>;
  utm_campaign?: InputMaybe<Scalars["String"]>;
  utm_content?: InputMaybe<Scalars["String"]>;
  utm_medium?: InputMaybe<Scalars["String"]>;
  utm_source?: InputMaybe<Scalars["String"]>;
  utm_term?: InputMaybe<Scalars["String"]>;
};

export type SelfElectedStateFundingProgramInput = {
  fundingOptions: SelfElectedStateFundingOptionsInput;
  source?: InputMaybe<Scalars["String"]>;
  stateAbbreviation: Scalars["String"];
  stateName: Scalars["String"];
};

export type SelfElectedStateFundingOptionsInput = {
  charter: Scalars["Boolean"];
  otherProgramName?: InputMaybe<Scalars["String"]>;
  reimbursement: Scalars["Boolean"];
  selfPay: Scalars["Boolean"];
  stateDebitCard?: InputMaybe<Scalars["Boolean"]>;
  statePortal: Scalars["Boolean"];
  stateProgramName?: InputMaybe<Scalars["String"]>;
};

export type ActivityDetailsInput = {
  /** @deprecated Use Syllabus.layoutVersion instead. */
  asyncRenderVersion?: InputMaybe<Scalars["Int"]>;
  asyncTime?: InputMaybe<Scalars["String"]>;
  /** @deprecated Use Syllabus.layoutVersion instead. */
  asyncVersion?: InputMaybe<Scalars["Int"]>;
  isAIUsedForContentCreation?: InputMaybe<Scalars["Boolean"]>;
  materials?: InputMaybe<Scalars["String"]>;
  photo?: InputMaybe<Scalars["String"]>;
  photoSquare?: InputMaybe<Scalars["String"]>;
  unpublishReason?: InputMaybe<Scalars["String"]>;
};

export type TimetableInput = {
  fri: TimetableTimesInput;
  mon: TimetableTimesInput;
  sat: TimetableTimesInput;
  sun: TimetableTimesInput;
  thu: TimetableTimesInput;
  tue: TimetableTimesInput;
  wed: TimetableTimesInput;
};

export type TimetableTimesInput = {
  f12_4: Scalars["Boolean"];
  f4_8: Scalars["Boolean"];
  f8_12: Scalars["Boolean"];
};

export type CouponActivityConstraintsInput = {
  activitiesUids: Array<Scalars["ID"]>;
};

export type CouponCreateInput = {
  classFormatsAllowed?: InputMaybe<Array<InputMaybe<CouponClassFormats>>>;
  couponType: CouponType;
  description?: InputMaybe<Scalars["String"]>;
  expiresAt: Scalars["DateTime"];
  isBuyerFirstPurchaseOfClassFormatOnly?: InputMaybe<Scalars["Boolean"]>;
  isFirstPurchaseOnly: Scalars["Boolean"];
  maxAmountCentsPerUse?: InputMaybe<Scalars["Int"]>;
  maxUses?: InputMaybe<Scalars["Int"]>;
  maxUsesPerUser?: InputMaybe<Scalars["Int"]>;
  minPurchaseAmountCents?: InputMaybe<Scalars["Int"]>;
  name: Scalars["String"];
  percentOff?: InputMaybe<Scalars["Int"]>;
  startsAt: Scalars["DateTime"];
  subjectsAllowed?: InputMaybe<Array<Scalars["String"]>>;
};

export type CouponCodeCreateInput = {
  code: Scalars["String"];
};

export type CreateCreditPurchaseOrderInput = {
  amountCents: Scalars["Int"];
  amountGrantedCents: Scalars["Int"];
};

export type EnrollmentMeetingPurchaseOrderInput = {
  activityUid: Scalars["ID"];
  attribution?: InputMaybe<Attribution>;
  charterParentInput?: InputMaybe<EnrollmentCharterParentInput>;
  currency_code?: InputMaybe<CurrencyCode>;
  endTime?: InputMaybe<Scalars["DateTime"]>;
  enrollmentInputs: Array<EnrollmentInput>;
  enrollmentUid?: InputMaybe<Scalars["ID"]>;
  exchange_rate?: InputMaybe<Scalars["Float"]>;
  ignoresTeacherAvailability?: InputMaybe<Scalars["Boolean"]>;
  impressionId?: InputMaybe<Scalars["String"]>;
  meetingRequestUids?: InputMaybe<Array<Scalars["String"]>>;
  message?: InputMaybe<Scalars["String"]>;
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  prepayDurationWeeks?: InputMaybe<Scalars["Int"]>;
  prepayMeetings?: InputMaybe<Array<FutureMeetingInputInfo>>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export type EnrollmentInput = {
  amountInLocalCurrency?: InputMaybe<Scalars["Int"]>;
  isGift?: InputMaybe<Scalars["Boolean"]>;
  learner?: InputMaybe<EnrollmentLearnerInput>;
  price_cents: Scalars["Int"];
  pricing_offer?: InputMaybe<Scalars["String"]>;
};

export type FutureMeetingInputInfo = {
  end_time: Scalars["DateTime"];
  start_time: Scalars["DateTime"];
};

export type OrderInput = {
  activityUid: Scalars["ID"];
  amount_in_local_currency?: InputMaybe<Scalars["Int"]>;
  attribution?: InputMaybe<Attribution>;
  charterParentInput?: InputMaybe<EnrollmentCharterParentInput>;
  charterSchoolUid?: InputMaybe<Scalars["ID"]>;
  currency_code?: InputMaybe<CurrencyCode>;
  enrollmentInputs: Array<EnrollmentInput>;
  exchange_rate?: InputMaybe<Scalars["Float"]>;
  impressionId?: InputMaybe<Scalars["String"]>;
  isWeeklyPayment?: InputMaybe<Scalars["Boolean"]>;
  message?: InputMaybe<Scalars["String"]>;
  ongoingEndTime?: InputMaybe<Scalars["DateTime"]>;
  ongoingStartTime?: InputMaybe<Scalars["DateTime"]>;
  organizationUid?: InputMaybe<Scalars["ID"]>;
  purchaseOrderCoverage?: InputMaybe<Scalars["DateTime"]>;
  schoolClosure?: InputMaybe<SchoolClosureInput>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
  selfPacedStartTime?: InputMaybe<Scalars["DateTime"]>;
};

export type SchoolClosureInput = {
  affected?: InputMaybe<Scalars["Boolean"]>;
  city: Scalars["String"];
  covid: Scalars["Boolean"];
  household_size: Scalars["Int"];
  income: Scalars["String"];
  lunch: Scalars["Boolean"];
  name: Scalars["String"];
  noschool: Scalars["Boolean"];
  school_closed?: InputMaybe<Scalars["Boolean"]>;
  state: Scalars["String"];
};

export type EsaCreditPurchaseLearnerInput = {
  age?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type CreateLearnerLearningStatementsInput = {
  learnerUid: Scalars["ID"];
  objectType: LearningStatementsObjectType;
  objectUid: Scalars["String"];
  verb: LearningStatementsVerb;
};

export const LearningStatementsObjectType = {
  AssignmentClassPost: "AssignmentClassPost",
  LearningStatement: "LearningStatement",
  Lesson: "Lesson",
} as const;

export type LearningStatementsObjectType =
  (typeof LearningStatementsObjectType)[keyof typeof LearningStatementsObjectType];
export const MeetingReviewType = {
  Post: "post",
  Pre: "pre",
} as const;

export type MeetingReviewType =
  (typeof MeetingReviewType)[keyof typeof MeetingReviewType];
export type MeetingDetails = {
  end_time: Scalars["DateTime"];
  lesson_uid?: InputMaybe<Scalars["ID"]>;
  start_time: Scalars["DateTime"];
};

export type CreateBundleInput = {
  bundleElements: Array<NewBundleElementInput>;
  description?: InputMaybe<Scalars["String"]>;
  isOrdered: Scalars["Boolean"];
  publishedAt?: InputMaybe<Scalars["DateTime"]>;
  thumbnail?: InputMaybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type NewBundleElementInput = {
  activityUid: Scalars["ID"];
  orderInBundle: Scalars["Int"];
};

export type CreateBundleElementInput = {
  activityUid: Scalars["ID"];
  bundleUid: Scalars["ID"];
  orderInBundle: Scalars["Int"];
};

export type CreateOrganizationInput = {
  address?: InputMaybe<Scalars["String"]>;
  invoiceEmail?: InputMaybe<Scalars["String"]>;
  logoUrl?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  taxExempt?: InputMaybe<Scalars["Boolean"]>;
  techSupportEmail?: InputMaybe<Scalars["String"]>;
  totalCapCents?: InputMaybe<Scalars["Int"]>;
  trustSafetyEmail?: InputMaybe<Scalars["String"]>;
  type: OrganizationType;
  urlName?: InputMaybe<Scalars["String"]>;
};

export type FeedbackInput = {
  activity_star_rating: Scalars["Int"];
  attachments?: InputMaybe<Array<Scalars["ID"]>>;
  attachmentUids?: InputMaybe<Array<Scalars["ID"]>>;
  attribution?: InputMaybe<Attribution>;
  leaderFeedback?: InputMaybe<Scalars["String"]>;
  outschool_rating?: InputMaybe<Scalars["Int"]>;
  outschoolFeedback?: InputMaybe<Scalars["String"]>;
  publicReview?: InputMaybe<Scalars["String"]>;
  section_uid: Scalars["ID"];
};

export type LearnerSectionReviewInput = {
  attribution?: InputMaybe<Attribution>;
  enrollmentUid: Scalars["ID"];
  name: ReviewName;
  response: LearnerReviewResponseInput;
};

export const ReviewName = {
  InterestedInTakingMoreClassesAboutTopic:
    "interestedInTakingMoreClassesAboutTopic",
  SoughtOutWaysToLearnMoreAboutTopic: "soughtOutWaysToLearnMoreAboutTopic",
} as const;

export type ReviewName = (typeof ReviewName)[keyof typeof ReviewName];
export type LearnerReviewResponseInput = {
  vote?: InputMaybe<Scalars["String"]>;
};

export type CreatePaymentScheduleInput = {
  initialPaymentAmountCents?: InputMaybe<Scalars["Int"]>;
  initialPaymentRelativePeriod?: InputMaybe<RelativePeriodOptions>;
  lineItemUid: Scalars["String"];
  orderSlugId?: InputMaybe<Scalars["String"]>;
  recurringPaymentAmountCents: Scalars["Int"];
  scheduledPaymentLineItemType: ScheduledPaymentLineItemType;
  scheduleEndTime?: InputMaybe<Scalars["DateTime"]>;
  scheduleStartTime: Scalars["DateTime"];
  scheduleType: PaymentScheduleTypes;
};

export const RelativePeriodOptions = {
  Current: "Current",
  Next: "Next",
  Previous: "Previous",
} as const;

export type RelativePeriodOptions =
  (typeof RelativePeriodOptions)[keyof typeof RelativePeriodOptions];
export const ScheduledPaymentLineItemType = {
  ClubSubscriptions: "ClubSubscriptions",
  OneOnOneSchedules: "OneOnOneSchedules",
  WeeklyClassPayments: "WeeklyClassPayments",
} as const;

export type ScheduledPaymentLineItemType =
  (typeof ScheduledPaymentLineItemType)[keyof typeof ScheduledPaymentLineItemType];
export type CreatePricingOfferInput = {
  buyerOrgName: Scalars["String"];
  discount?: InputMaybe<Scalars["Float"]>;
  eligibleEmailDomains: Array<Scalars["String"]>;
  endBy: Scalars["DateTime"];
  excludedEmailAddresses: Array<Scalars["String"]>;
  includedEmailAddresses: Array<Scalars["String"]>;
  isFinancialAid: Scalars["Boolean"];
  organizationUid?: InputMaybe<Scalars["ID"]>;
  requirePaymentMethod: Scalars["Boolean"];
  startAfter: Scalars["DateTime"];
  totalCapCents: Scalars["Int"];
  userLimitCents: Scalars["Int"];
};

export const StripeConnectedAccountSessionComponentType = {
  AccountManagement: "account_management",
  AccountOnboarding: "account_onboarding",
  NotificationBanner: "notification_banner",
} as const;

export type StripeConnectedAccountSessionComponentType =
  (typeof StripeConnectedAccountSessionComponentType)[keyof typeof StripeConnectedAccountSessionComponentType];
/** Payment behavior options for Stripe subscription creation */
export const PaymentBehavior = {
  /** Allow incomplete payments and return payment intent for user action */
  DefaultIncomplete: "default_incomplete",
  /** Return an error if the payment requires additional user action */
  ErrorIfIncomplete: "error_if_incomplete",
} as const;

export type PaymentBehavior =
  (typeof PaymentBehavior)[keyof typeof PaymentBehavior];
/** Input for pricing offer payment */
export type PricingOfferInput = {
  /** Amount in cents to be paid by pricing offers */
  pricingOfferCents: Scalars["Int"];
  /** Pricing offer UID to use for payment */
  uid: Scalars["ID"];
};

export type CollegeDegreeCredentialInput = {
  degreeAdditionalInfo?: InputMaybe<Scalars["String"]>;
  degreeInstitution: Scalars["String"];
  degreeIssueDate?: InputMaybe<Scalars["DateTime"]>;
  degreeSubject: DegreeSubject;
  degreeType: DegreeType;
};

export type CredentialFileInput = {
  filename?: InputMaybe<Scalars["String"]>;
  /** @deprecated Use s3Key */
  handle?: InputMaybe<Scalars["ID"]>;
  mimetype?: InputMaybe<Scalars["String"]>;
  s3_key?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  source?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
  /** @deprecated Use s3Key */
  url?: InputMaybe<Scalars["String"]>;
};

export type OtherCredentialInput = {
  otherDetails: Scalars["String"];
  otherType: Scalars["String"];
};

export type TeacherCertificateCredentialInput = {
  certificateDiscipline: TeacherCertificateDiscipline;
  certificateDoesNotExpire?: InputMaybe<Scalars["Boolean"]>;
  certificateExpireDate?: InputMaybe<Scalars["DateTime"]>;
  certificateIssueDate?: InputMaybe<Scalars["DateTime"]>;
  certificateNumber: Scalars["String"];
  certificateSecondaryDiscipline?: InputMaybe<TeacherCertificateDiscipline>;
  certificateState: TeacherCertificateState;
};

export type CreateWaitlistSeatInput = {
  learner: WaitlistLearner;
  parentUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
  waitlistSource?: InputMaybe<WaitlistSource>;
};

export type WaitlistLearner = {
  age: Scalars["Int"];
  date_of_birth?: InputMaybe<Scalars["DateTime"]>;
  name: Scalars["String"];
  uid?: InputMaybe<Scalars["String"]>;
};

export const ReportLength = {
  /** Two or three paragraphs "long" */
  FewParagraphs: "FewParagraphs",
  /** Only one paragraph "short" */
  OneParagraph: "OneParagraph",
} as const;

export type ReportLength = (typeof ReportLength)[keyof typeof ReportLength];
export const FileAccessTier = {
  Public: "Public",
  Secured: "Secured",
} as const;

export type FileAccessTier =
  (typeof FileAccessTier)[keyof typeof FileAccessTier];
export type PostLoginOption = {
  /** @deprecated Use birthMonth and birthYear in defaultLearnerAttributes instead */
  defaultLearnerAge?: InputMaybe<Scalars["Int"]>;
  /** @deprecated Check for existence of defaultLearnerAttributes instead */
  isOnboardingSignup?: InputMaybe<Scalars["Boolean"]>;
  /** @deprecated Check for existence of defaultLearnerAttributes instead */
  shouldCreateDefaultLearner?: InputMaybe<Scalars["Boolean"]>;
};

/** Which client is attempting to log in */
export const LoginClient = {
  AndroidLearnerApp: "androidLearnerApp",
  IOsLearnerApp: "iOSLearnerApp",
  Web: "Web",
} as const;

export type LoginClient = (typeof LoginClient)[keyof typeof LoginClient];
export type CreateAccountWithProviderInput = {
  attribution?: InputMaybe<Attribution>;
  browserTimeZone?: InputMaybe<Scalars["String"]>;
  /** @deprecated Use birthMonth and birthYear in defaultLearnerAttributes instead */
  defaultLearnerAge?: InputMaybe<Scalars["Int"]>;
  defaultLearnerAttributes?: InputMaybe<LearnerAttributes>;
  isGiftCardSignup?: InputMaybe<Scalars["Boolean"]>;
  isLeader?: InputMaybe<Scalars["Boolean"]>;
  /** @deprecated Check for existence of defaultLearnerAttributes instead */
  isOnboardingSignup?: InputMaybe<Scalars["Boolean"]>;
  locale?: InputMaybe<UserLocale>;
  /** @deprecated Opt out via selfElectedStateFundingProgram instead */
  requiresMembershipForEnrollment?: InputMaybe<Scalars["Boolean"]>;
  selfElectedStateFundingProgram?: InputMaybe<SelfElectedStateFundingProgramInput>;
  /** @deprecated Check for existence of defaultLearnerAttributes instead */
  shouldCreateDefaultLearner?: InputMaybe<Scalars["Boolean"]>;
  subscribe?: InputMaybe<Scalars["Boolean"]>;
};

export const CreateOrLoginError = {
  AccountAlreadyExists: "AccountAlreadyExists",
  AccountAlreadyLinked: "AccountAlreadyLinked",
  AccountCreationNotAllowed: "AccountCreationNotAllowed",
  AccountLocked: "AccountLocked",
  AccountNotFound: "AccountNotFound",
  AccountSuspended: "AccountSuspended",
  IncorrectApp: "IncorrectApp",
  InvalidEmail: "InvalidEmail",
  InvalidName: "InvalidName",
  InvalidPermissions: "InvalidPermissions",
  LearnerAccountLinkFailed: "LearnerAccountLinkFailed",
  SocialLoginNotAllowed: "SocialLoginNotAllowed",
  UnknownError: "UnknownError",
} as const;

export type CreateOrLoginError =
  (typeof CreateOrLoginError)[keyof typeof CreateOrLoginError];
export type AssignmentClassPostCommentThreadInput = {
  assignmentClassPostUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
};

export const ExternalActivitySource = {
  Mux: "mux",
  Policies: "policies",
} as const;

export type ExternalActivitySource =
  (typeof ExternalActivitySource)[keyof typeof ExternalActivitySource];
export type PauseOngoingEnrollmentInput = {
  dates: Array<DateRange>;
  enrollmentUid: Scalars["ID"];
};

export type DateRange = {
  endDate: Scalars["DateTime"];
  startDate: Scalars["DateTime"];
};

export const TokenRefreshSource = {
  Apollo: "Apollo",
  Client: "Client",
  LearnerApp: "LearnerApp",
} as const;

export type TokenRefreshSource =
  (typeof TokenRefreshSource)[keyof typeof TokenRefreshSource];
export const RefundType = {
  AddOutschoolCredit: "AddOutschoolCredit",
  StandardRefund: "StandardRefund",
} as const;

export type RefundType = (typeof RefundType)[keyof typeof RefundType];
export type SaveLearnerMixTopicInput = {
  description: Scalars["String"];
  imageUrl: Scalars["String"];
  sourceTopics: Array<Scalars["String"]>;
  title: Scalars["String"];
};

export type LearnerProfileInput = {
  aboutMe?: InputMaybe<Scalars["String"]>;
  avatar?: InputMaybe<Scalars["String"]>;
};

export type LearnerProfileSettingsInput = {
  isProfileAgeHidden?: InputMaybe<Scalars["Boolean"]>;
  isProfileLocationHidden?: InputMaybe<Scalars["Boolean"]>;
};

export type MessageInput = {
  activityUid?: InputMaybe<Scalars["ID"]>;
  bulkGroupUid?: InputMaybe<Scalars["ID"]>;
  content?: InputMaybe<Scalars["String"]>;
  details: MessageInputDetails;
  messageContentInput?: InputMaybe<MessageContentInput>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
};

export type MessageInputDetails = {
  action: Scalars["String"];
  activityTitle?: InputMaybe<Scalars["String"]>;
  activityUrl?: InputMaybe<Scalars["String"]>;
  classScheduleRequestUid?: InputMaybe<Scalars["ID"]>;
  leaderName?: InputMaybe<Scalars["ID"]>;
  leaderUid?: InputMaybe<Scalars["ID"]>;
  parentName?: InputMaybe<Scalars["String"]>;
  parentUid?: InputMaybe<Scalars["ID"]>;
  section?: InputMaybe<Scalars["String"]>;
  sectionUrl?: InputMaybe<Scalars["String"]>;
  studentName?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  teacherAdminUrl?: InputMaybe<Scalars["String"]>;
};

export type ProgressReportDetailsInput = {
  didChangeGeneratedReport: Scalars["Boolean"];
  didGenerateReport: Scalars["Boolean"];
  originalNotes: Scalars["String"];
  reportLength: ReportLength;
};

export type BulkPurchaseRecurringMeetingsInfo = {
  durationWeeks?: InputMaybe<Scalars["Int"]>;
  enrollmentUid: Scalars["ID"];
};

export type PurchaseRecurringMeetingsInfo = {
  /**
   * The total number of weeks this enrollment time should repeat. If omitted, the enrollment
   * time will be considered continuous and repeated until either the parent or teacher
   * cancel the enrollment time.
   */
  durationWeeks?: InputMaybe<Scalars["Int"]>;
};

export type StopPaymentScheduleInput = {
  scheduledPaymentLineItemType: ScheduledPaymentLineItemType;
  scheduleUid: Scalars["String"];
  stoppedReason: Scalars["String"];
};

export type UserSavedActivity = {
  activityUid: Scalars["ID"];
  savedAt: Scalars["DateTime"];
};

export const SurpriseMeVariants = {
  Random: "Random",
  Recommendations: "Recommendations",
} as const;

export type SurpriseMeVariants =
  (typeof SurpriseMeVariants)[keyof typeof SurpriseMeVariants];
export type TrackAnalyticsInitializedProperties = {
  analyticsLoadDuration?: InputMaybe<Scalars["Int"]>;
  analyticsMode?: InputMaybe<Scalars["String"]>;
  analyticsModeSource?: InputMaybe<Scalars["String"]>;
  analyticsModeSourceOverride?: InputMaybe<Scalars["String"]>;
  analyticsStatus?: InputMaybe<Scalars["String"]>;
  app?: InputMaybe<Scalars["String"]>;
  botCheck?: InputMaybe<Scalars["Boolean"]>;
  cloudflareBotScore?: InputMaybe<Scalars["Int"]>;
  cloudflareBotVerified?: InputMaybe<Scalars["Boolean"]>;
  cloudflareThreatScore?: InputMaybe<Scalars["Int"]>;
  deviceUid?: InputMaybe<Scalars["String"]>;
  height?: InputMaybe<Scalars["Int"]>;
  initializationDuration?: InputMaybe<Scalars["Int"]>;
  isBot?: InputMaybe<Scalars["Boolean"]>;
  isMobile?: InputMaybe<Scalars["Boolean"]>;
  modeResolutionDuration?: InputMaybe<Scalars["Int"]>;
  pageCategory?: InputMaybe<Scalars["String"]>;
  pageImpressionId?: InputMaybe<Scalars["String"]>;
  pageLoadId?: InputMaybe<Scalars["String"]>;
  pageName?: InputMaybe<Scalars["String"]>;
  pagePath?: InputMaybe<Scalars["String"]>;
  pluginLoadDuration?: InputMaybe<Scalars["Int"]>;
  width?: InputMaybe<Scalars["Int"]>;
};

export type TrackClassPageImpressionInput = {
  activityUid: Scalars["String"];
  sectionUid?: InputMaybe<Scalars["String"]>;
};

export type TrackNewBuyerAcquiredProperties = {
  amount: Scalars["Int"];
  fbp?: InputMaybe<Scalars["String"]>;
  orderId?: InputMaybe<Scalars["String"]>;
  osRef?: InputMaybe<OsRefInput>;
};

export type TrackOrderCompletedProperties = {
  cartUid?: InputMaybe<Scalars["String"]>;
  enrollmentConfirmedAt: Scalars["DateTime"];
  fbp?: InputMaybe<Scalars["String"]>;
  isBulkCheckout?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  orderId: Scalars["String"];
  osRef?: InputMaybe<OsRefInput>;
  price: Scalars["Int"];
  productId: Scalars["String"];
  quantity: Scalars["Int"];
  total: Scalars["Int"];
};

export type TrackPageLoadProperties = {
  anonymousId?: InputMaybe<Scalars["String"]>;
  app?: InputMaybe<Scalars["String"]>;
  cloudflare_bot_score?: InputMaybe<Scalars["Int"]>;
  cloudflare_bot_verified?: InputMaybe<Scalars["Boolean"]>;
  cloudflare_threat_score?: InputMaybe<Scalars["Int"]>;
  is_bot?: InputMaybe<Scalars["Boolean"]>;
  isMobile?: InputMaybe<Scalars["Boolean"]>;
  loggedInUserExperimentUid?: InputMaybe<Scalars["String"]>;
  loggedOutUserExperimentUid?: InputMaybe<Scalars["String"]>;
  pageLoadId?: InputMaybe<Scalars["String"]>;
  pageName?: InputMaybe<Scalars["String"]>;
  pagePath?: InputMaybe<Scalars["String"]>;
};

export type TrackSubscriptionInterestProperties = {
  email: Scalars["String"];
  osRef?: InputMaybe<OsRefInput>;
  package: Scalars["String"];
};

export type TrackUserAttributionSurveyResponseInput = {
  additionalDetails?: InputMaybe<Scalars["String"]>;
  response: Scalars["String"];
};

export type TrackUserCreatedProperties = {
  fbp?: InputMaybe<Scalars["String"]>;
  osRef?: InputMaybe<OsRefInput>;
};

export type UnpauseOngoingEnrollmentsPausedForPaymentFailureInput = {
  enrollmentUids: Array<Scalars["ID"]>;
  pauseEndDate?: InputMaybe<Scalars["Date"]>;
};

export type ActivityInput = {
  age_max?: InputMaybe<Scalars["Int"]>;
  age_min?: InputMaybe<Scalars["Int"]>;
  allows_late_enrollment?: InputMaybe<Scalars["Boolean"]>;
  allows_late_enrollments_for_fixed_length_classes?: InputMaybe<
    Scalars["Boolean"]
  >;
  allows_recurring_payment?: InputMaybe<Scalars["Boolean"]>;
  assessment?: InputMaybe<Scalars["String"]>;
  attributes?: InputMaybe<Array<EntityAttributeInput>>;
  auto_scheduling_days_notice_max?: InputMaybe<Scalars["Int"]>;
  auto_scheduling_days_notice_min?: InputMaybe<Scalars["Int"]>;
  class_experience?: InputMaybe<Scalars["String"]>;
  classFormat?: InputMaybe<EducatorSelectedFormat>;
  club_banner_image_uid?: InputMaybe<Scalars["ID"]>;
  club_welcome_video_uid?: InputMaybe<Scalars["ID"]>;
  description?: InputMaybe<Scalars["String"]>;
  disclaimer?: InputMaybe<Scalars["String"]>;
  duration_minutes?: InputMaybe<Scalars["Int"]>;
  duration_weeks?: InputMaybe<Scalars["Int"]>;
  english_proficiency_level?: InputMaybe<EnglishProficiencyLevel>;
  grade_level_max?: InputMaybe<Scalars["String"]>;
  grade_level_min?: InputMaybe<Scalars["String"]>;
  grading_policy?: InputMaybe<Scalars["String"]>;
  has_building_content?: InputMaybe<Scalars["Boolean"]>;
  homework?: InputMaybe<Scalars["String"]>;
  is_auto_scheduling_enabled?: InputMaybe<Scalars["Boolean"]>;
  is_ongoing_weekly?: InputMaybe<Scalars["Boolean"]>;
  is_online?: InputMaybe<Scalars["Boolean"]>;
  is_waitlist_allowed?: InputMaybe<Scalars["Boolean"]>;
  isArchived?: InputMaybe<Scalars["Boolean"]>;
  isPublished?: InputMaybe<Scalars["Boolean"]>;
  isSelfPaced?: InputMaybe<Scalars["Boolean"]>;
  isSelfPacedEnrollmentEnabled?: InputMaybe<Scalars["Boolean"]>;
  language_of_instruction?: InputMaybe<Scalars["Iso639"]>;
  learning_goals?: InputMaybe<Scalars["String"]>;
  parental_guidance?: InputMaybe<Scalars["String"]>;
  photo?: InputMaybe<Scalars["String"]>;
  photo_square_uid?: InputMaybe<Scalars["ID"]>;
  photo_uid?: InputMaybe<Scalars["ID"]>;
  prerequisites?: InputMaybe<Scalars["String"]>;
  price_cents?: InputMaybe<Scalars["Int"]>;
  pricingAdjustments?: InputMaybe<PricingAdjustmentInput>;
  proficiency_level?: InputMaybe<ProficiencyLevelInput>;
  refund_policy_type?: InputMaybe<RefundPolicyType>;
  sample_club_post?: InputMaybe<WelcomeMessageInput>;
  sampleClubPosts?: InputMaybe<Array<SampleClubPostInput>>;
  selfPacedMigration?: InputMaybe<SelfPacedMigrationStatusInput>;
  size_max?: InputMaybe<Scalars["Int"]>;
  size_min?: InputMaybe<Scalars["Int"]>;
  sources?: InputMaybe<Scalars["String"]>;
  strictAgeRange?: InputMaybe<AgeRangeInput>;
  subject?: InputMaybe<Scalars["String"]>;
  suggestedWeeklyMeetings?: InputMaybe<Scalars["Int"]>;
  summary?: InputMaybe<Scalars["String"]>;
  summary_for_learners?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  upsell_activity_uid?: InputMaybe<Scalars["ID"]>;
  video_for_learners_uid?: InputMaybe<Scalars["ID"]>;
  video_uid?: InputMaybe<Scalars["ID"]>;
  weekly_meetings?: InputMaybe<Scalars["Int"]>;
  welcome_message?: InputMaybe<WelcomeMessageInput>;
  why_me?: InputMaybe<Scalars["String"]>;
};

export type EntityAttributeInput = {
  key: Scalars["String"];
  source?: InputMaybe<Scalars["String"]>;
  value?: InputMaybe<Scalars["String"]>;
};

export type PricingAdjustmentInput = {
  weeklySurchargePercentage?: InputMaybe<Scalars["Float"]>;
};

export type ProficiencyLevelInput = {
  level?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  text?: InputMaybe<Scalars["String"]>;
};

export type WelcomeMessageInput = {
  attachments?: InputMaybe<Array<Scalars["ID"]>>;
  text?: InputMaybe<Scalars["String"]>;
  video?: InputMaybe<Scalars["ID"]>;
};

export type SampleClubPostInput = {
  attachments?: InputMaybe<Array<Scalars["ID"]>>;
  comments?: InputMaybe<Array<SampleClubPostCommentInput>>;
  text?: InputMaybe<Scalars["String"]>;
  video?: InputMaybe<Scalars["ID"]>;
};

export type SampleClubPostCommentInput = {
  text: Scalars["String"];
};

export type SelfPacedMigrationStatusInput = {
  gitCommitSha: Scalars["String"];
  hasConsented: Scalars["Boolean"];
};

export type AgeRangeInput = {
  max: Scalars["Int"];
  min: Scalars["Int"];
};

export type UpdateAssignmentClassPostInput = {
  dueDate?: InputMaybe<Scalars["DateTime"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  messageContentInput?: InputMaybe<MessageContentInput>;
  /** Deprecated: use reorderLessonItems instead. */
  orderInLesson?: InputMaybe<Scalars["Int"]>;
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
  submissionRequirement?: InputMaybe<SubmissionRequirementType>;
  title?: InputMaybe<Scalars["String"]>;
};

export type UpdateAssignmentLessonPostInput = {
  isClassListingVideoPreview?: InputMaybe<Scalars["Boolean"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  messageContent?: InputMaybe<MessageContentInput>;
  orderInLesson?: InputMaybe<Scalars["Int"]>;
  submissionRequirement?: InputMaybe<SubmissionRequirementType>;
  title?: InputMaybe<Scalars["String"]>;
};

/**
 * Based on Stripe customer address:
 * https://docs.stripe.com/api/customers/update#update_customer-address
 */
export type StripeAddressInput = {
  /** City, district, suburb, town, or village. */
  city?: InputMaybe<Scalars["String"]>;
  /** A two-letter country code (ISO 3166-1 alpha-2) */
  country?: InputMaybe<Scalars["String"]>;
  /** Address line 1, such as the street, PO Box, or company name. */
  line1?: InputMaybe<Scalars["String"]>;
  /** Address line 2, such as the apartment, suite, unit, or building. */
  line2?: InputMaybe<Scalars["String"]>;
  /** ZIP or postal code. */
  postalCode?: InputMaybe<Scalars["String"]>;
  /** State, county, province, or region (ISO 3166-2). */
  state?: InputMaybe<Scalars["String"]>;
};

export type UpdateBundleInput = {
  description?: InputMaybe<Scalars["String"]>;
  discount?: InputMaybe<Scalars["Float"]>;
  isOrdered?: InputMaybe<Scalars["Boolean"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]>;
  thumbnail?: InputMaybe<Scalars["String"]>;
  thumbnail_uid?: InputMaybe<Scalars["ID"]>;
  title?: InputMaybe<Scalars["String"]>;
  /**
   * Some context for expected fields inside of updatedBundleElements:
   * if a BundleElement existed before this update mutation expects the object to have a uid, a activityUid and orderInBundle
   * if a BundleElement is new: the mutation expects the object to have a activityUid and orderInBundle
   */
  updatedBundleElements: Array<UpdateBundleElementInput>;
};

export type UpdateBundleElementInput = {
  activityUid: Scalars["ID"];
  orderInBundle: Scalars["Int"];
  uid?: InputMaybe<Scalars["ID"]>;
};

export type CouponUpdateInput = {
  deletedAt?: InputMaybe<Scalars["DateTime"]>;
  expiresAt?: InputMaybe<Scalars["DateTime"]>;
  minPurchaseAmountCents?: InputMaybe<Scalars["Int"]>;
};

export type UserDetailsInput = {
  about?: InputMaybe<Scalars["String"]>;
  bannerClosedAt?: InputMaybe<Scalars["String"]>;
  browserTimeZone?: InputMaybe<Scalars["String"]>;
  countryOfResidence?: InputMaybe<Scalars["String"]>;
  headline?: InputMaybe<Scalars["String"]>;
  howFoundOutschool?: InputMaybe<Scalars["String"]>;
  howFoundOutschoolOther?: InputMaybe<Scalars["String"]>;
  introduction?: InputMaybe<Scalars["String"]>;
  membershipRolloutPhase?: InputMaybe<Scalars["String"]>;
  requiresMembershipForEnrollment?: InputMaybe<Scalars["Boolean"]>;
  selfElectedStateFundingProgram?: InputMaybe<SelfElectedStateFundingProgramInput>;
  socialOptOut?: InputMaybe<Scalars["Boolean"]>;
  timeRangeAfterSchool?: InputMaybe<Scalars["Boolean"]>;
  timeRangeSchool?: InputMaybe<Scalars["Boolean"]>;
  timeRangeWeekend?: InputMaybe<Scalars["Boolean"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type LocationInput = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  geo?: InputMaybe<Scalars["String"]>;
  lat?: InputMaybe<Scalars["Float"]>;
  lng?: InputMaybe<Scalars["Float"]>;
  placeDescription?: InputMaybe<Scalars["String"]>;
  placeName?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  timeZone?: InputMaybe<Scalars["String"]>;
};

export type TeacherAttributesInput = {
  autoSchedulingBufferMinutes?: InputMaybe<Scalars["Int"]>;
  isAutoSchedulingEnabled?: InputMaybe<Scalars["Boolean"]>;
  mainToolbarPinnedTabs?: InputMaybe<Array<MainToolbarPinnedTabs>>;
  showCalendar?: InputMaybe<Scalars["Boolean"]>;
};

export type AdminEnrollmentPaymentRefundInput = {
  action: AdminEnrollmentPaymentRefundActionType;
  adminNoteType?: InputMaybe<AdminEnrollmentPaymentRefundNoteType>;
  notes?: InputMaybe<Scalars["String"]>;
};

export const AdminEnrollmentPaymentRefundActionType = {
  ReducesTeacherPayoutFalse: "REDUCES_TEACHER_PAYOUT_FALSE",
  ReducesTeacherPayoutTrue: "REDUCES_TEACHER_PAYOUT_TRUE",
} as const;

export type AdminEnrollmentPaymentRefundActionType =
  (typeof AdminEnrollmentPaymentRefundActionType)[keyof typeof AdminEnrollmentPaymentRefundActionType];
export const AdminEnrollmentPaymentRefundNoteType = {
  RefundUpdateAuditLog: "REFUND_UPDATE_AUDIT_LOG",
} as const;

export type AdminEnrollmentPaymentRefundNoteType =
  (typeof AdminEnrollmentPaymentRefundNoteType)[keyof typeof AdminEnrollmentPaymentRefundNoteType];
export type EnrollmentPaymentRefundInput = {
  reason: Scalars["String"];
  reduces_teacher_payout: Scalars["Boolean"];
  refunded_at?: InputMaybe<Scalars["DateTime"]>;
};

/** uid - entity availability schedule uid */
export type UpdateEntityAvailabilityScheduleInput = {
  entityAvailabilities: Array<EntityAvailabilityInput>;
  uid: Scalars["ID"];
};

export type GiftCardUpdateInput = {
  deliverAfter?: InputMaybe<Scalars["DateTime"]>;
  note?: InputMaybe<Scalars["String"]>;
  recipientEmail?: InputMaybe<Scalars["String"]>;
  recipientName?: InputMaybe<Scalars["String"]>;
  senderEmail?: InputMaybe<Scalars["String"]>;
  senderName?: InputMaybe<Scalars["String"]>;
};

export type LessonInput = {
  description?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  unitUid?: InputMaybe<Scalars["ID"]>;
};

export type UpdateLessonPostInput = {
  blockType?: InputMaybe<BlockType>;
  estimatedDuration?: InputMaybe<Scalars["Int"]>;
  isClassListingVideoPreview?: InputMaybe<Scalars["Boolean"]>;
  isPostedForEnrollments?: InputMaybe<Scalars["Boolean"]>;
  isPostedForSubscriptions?: InputMaybe<Scalars["Boolean"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  messageContent?: InputMaybe<MessageContentInput>;
  orderInLesson?: InputMaybe<Scalars["Int"]>;
  title?: InputMaybe<Scalars["String"]>;
};

export type MeetingAiSummaryPatchInput = {
  deleted_at?: InputMaybe<Scalars["DateTime"]>;
  edited_summary_text?: InputMaybe<Scalars["String"]>;
  is_skipped?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateMeetingInput = {
  endTime?: InputMaybe<Scalars["DateTime"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  meetingUid: Scalars["ID"];
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdateMeetingLessonInput = {
  lessonUid?: InputMaybe<Scalars["ID"]>;
  meetingUid: Scalars["ID"];
};

export type UpdateOrganizationInput = {
  address?: InputMaybe<Scalars["String"]>;
  invoiceEmail?: InputMaybe<Scalars["String"]>;
  logoUrl?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  notes?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  taxExempt?: InputMaybe<Scalars["Boolean"]>;
  techSupportEmail?: InputMaybe<Scalars["String"]>;
  totalCapCents?: InputMaybe<Scalars["Int"]>;
  trustSafetyEmail?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<OrganizationType>;
  urlName?: InputMaybe<Scalars["String"]>;
};

export type UpdatePricingOfferInput = {
  buyerOrgName?: InputMaybe<Scalars["String"]>;
  discount?: InputMaybe<Scalars["Float"]>;
  eligibleEmailDomains?: InputMaybe<Array<Scalars["String"]>>;
  endBy?: InputMaybe<Scalars["DateTime"]>;
  excludedEmailAddresses?: InputMaybe<Array<Scalars["String"]>>;
  includedEmailAddresses?: InputMaybe<Array<Scalars["String"]>>;
  isFinancialAid?: InputMaybe<Scalars["Boolean"]>;
  organizationUid?: InputMaybe<Scalars["ID"]>;
  requirePaymentMethod?: InputMaybe<Scalars["Boolean"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  totalCapCents?: InputMaybe<Scalars["Int"]>;
  userLimitCents?: InputMaybe<Scalars["Int"]>;
};

/**
 * Partial update applied via shallow merge into the stored attempt object.
 * Omitted fields are left unchanged.
 */
export type QuizAttemptPatchInput = {
  answeredCorrectByIndex?: InputMaybe<Array<QuizAttemptCorrectnessInput>>;
  completed?: InputMaybe<Scalars["Boolean"]>;
  selectedAnswers?: InputMaybe<Array<QuizAttemptAnswerSelectionInput>>;
};

export type QuizAttemptCorrectnessInput = {
  correct: Scalars["Boolean"];
  questionIndex: Scalars["Int"];
};

export type QuizAttemptAnswerSelectionInput = {
  optionIndex: Scalars["Int"];
  questionIndex: Scalars["Int"];
};

export type ActivityScheduleSettingsInput = {
  maximumNotice?: InputMaybe<Scalars["String"]>;
  mininumNotice?: InputMaybe<Scalars["String"]>;
  suggestedWeeklyMeetings?: InputMaybe<Scalars["Int"]>;
};

export type LeaderSectionDetailInput = {
  date?: InputMaybe<Scalars["String"]>;
  originalEndTime?: InputMaybe<Scalars["DateTime"]>;
};

export type OnlineClassroomInput = {
  type?: InputMaybe<Scalars["String"]>;
  url?: InputMaybe<Scalars["String"]>;
};

export type LeaderSectionInput = {
  end_time?: InputMaybe<Scalars["DateTime"]>;
  isCanceled?: InputMaybe<Scalars["Boolean"]>;
  isDeleted?: InputMaybe<Scalars["Boolean"]>;
  isPublished?: InputMaybe<Scalars["Boolean"]>;
  price_cents?: InputMaybe<Scalars["Int"]>;
  size_max?: InputMaybe<Scalars["Int"]>;
  start_time?: InputMaybe<Scalars["DateTime"]>;
  user_uid?: InputMaybe<Scalars["ID"]>;
};

export type SectionAdminInput = {
  notes?: InputMaybe<Scalars["String"]>;
};

export type UpdateSellerOrgAgreementInput = {
  agreementTemplateUid?: InputMaybe<Scalars["ID"]>;
  contractSignedBy?: InputMaybe<Scalars["String"]>;
  contractSignerTitle?: InputMaybe<Scalars["String"]>;
  legalAddress?: InputMaybe<Scalars["String"]>;
  legalEntityType?: InputMaybe<Scalars["String"]>;
  legalName?: InputMaybe<Scalars["String"]>;
  legalState?: InputMaybe<Scalars["String"]>;
  ownsBackgroundChecks?: InputMaybe<Scalars["Boolean"]>;
};

export type SellerOrgApplicationInput = {
  additionalInfo?: InputMaybe<Scalars["String"]>;
  alreadyApprovedTeacher?: InputMaybe<Scalars["Boolean"]>;
  alreadyApprovedTeacherEmail?: InputMaybe<Scalars["String"]>;
  classesInfo?: InputMaybe<Scalars["String"]>;
  countries?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  firstClassDescription?: InputMaybe<Scalars["String"]>;
  learnersInfo?: InputMaybe<Scalars["String"]>;
  learnerTypes?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberOfClassesPerWeek?: InputMaybe<Scalars["String"]>;
  numberOfStudentsOnAverage?: InputMaybe<Scalars["String"]>;
  numberOfTeachers?: InputMaybe<Scalars["String"]>;
  organizationPhone?: InputMaybe<Scalars["String"]>;
  primaryContactName?: InputMaybe<Scalars["String"]>;
  primaryContactTitle?: InputMaybe<Scalars["String"]>;
  publicReviews?: InputMaybe<Scalars["String"]>;
  sourcedFrom?: InputMaybe<Scalars["String"]>;
  teachersInfo?: InputMaybe<Scalars["String"]>;
  timeInBusiness?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  typeDetail?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
  whenFounded?: InputMaybe<Scalars["String"]>;
};

export type TeacherApplicationInput = {
  age_ranges_taught?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  class_subjects?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  class_types?: InputMaybe<Scalars["String"]>;
  experience_types?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  how_did_you_hear_about_us?: InputMaybe<Scalars["String"]>;
  legal_name?: InputMaybe<Scalars["String"]>;
  online_profiles?: InputMaybe<Scalars["String"]>;
  sample_classes?: InputMaybe<Scalars["String"]>;
  teaching_credentials?: InputMaybe<Scalars["String"]>;
  teaching_experience?: InputMaybe<Scalars["String"]>;
  teaching_motivation?: InputMaybe<Scalars["String"]>;
  video_uid?: InputMaybe<Scalars["ID"]>;
  years_of_experience?: InputMaybe<Scalars["String"]>;
};

export type AvailabilityInput = {
  hourlyTimetable: HourlyTimetableInput;
};

export type HourlyTimetableInput = {
  fri: Array<Scalars["Int"]>;
  mon: Array<Scalars["Int"]>;
  sat: Array<Scalars["Int"]>;
  sun: Array<Scalars["Int"]>;
  thu: Array<Scalars["Int"]>;
  tue: Array<Scalars["Int"]>;
  wed: Array<Scalars["Int"]>;
};

export type ScheduleInput = {
  bufferTime?: InputMaybe<Scalars["String"]>;
  meetingsStartTimeIncrementsInMinutes?: InputMaybe<Scalars["Int"]>;
};

export type AvailableTimesInput = {
  endTime: Scalars["DateTime"];
  isRecurring: Scalars["Boolean"];
  isUnavailable: Scalars["Boolean"];
  startTime: Scalars["DateTime"];
};

export type UnitInput = {
  title?: InputMaybe<Scalars["String"]>;
};

export type UserAdminInput = {
  is_crosslister?: InputMaybe<Scalars["Boolean"]>;
  leader_link?: InputMaybe<Scalars["String"]>;
};

export const ValidateMeetingRequestsForPurchaseError = {
  /** Cannot accept reschedule requests via Mutation.settleOrderEnrollmentMeetingPurchase.  Use Mutation.acceptMeetingReschedule */
  CannotAcceptRescheduleRequestsForPurchase:
    "CannotAcceptRescheduleRequestsForPurchase",
  /** Enrollment meeting purchase record not found */
  EnrollmentMeetingPurchaseRecordNotFound:
    "EnrollmentMeetingPurchaseRecordNotFound",
  /** One or more meeting requests have been deleted */
  MeetingRequestDeleted: "MeetingRequestDeleted",
  /** Meeting requests do not belong to purchased activity */
  MeetingRequestDoesNotBelongToActivity:
    "MeetingRequestDoesNotBelongToActivity",
  /** Meeting requests do not belong to purchased section */
  MeetingRequestDoesNotBelongToSection: "MeetingRequestDoesNotBelongToSection",
  /** Meeting requests are not pending */
  MeetingRequestIsNotPending: "MeetingRequestIsNotPending",
  /** No meeting tied to enrollment meeting purchase */
  NoMeetingFoundForEnrollmentMeetingPurchase:
    "NoMeetingFoundForEnrollmentMeetingPurchase",
  /** Only some meeting requests in batch are recurring */
  OnlySomeMeetingRequestsAreRecurring: "OnlySomeMeetingRequestsAreRecurring",
  /** Not supported needs fixing: See https://outschool.atlassian.net/browse/ESP-2819 */
  RecurringMeetingRequestsNotSupported: "RecurringMeetingRequestsNotSupported",
  /** Purchased time slot was not the first request chronologically */
  TimeSlotChronologyMismatch: "TimeSlotChronologyMismatch",
  /** Did not purchase a time slot that is the same as one of the meeting requests */
  TimeSlotMeetingRequestMismatch: "TimeSlotMeetingRequestMismatch",
} as const;

export type ValidateMeetingRequestsForPurchaseError =
  (typeof ValidateMeetingRequestsForPurchaseError)[keyof typeof ValidateMeetingRequestsForPurchaseError];
export type AppleAttestationInput = {
  attestation: Scalars["String"];
  challenge: Scalars["String"];
  keyId: Scalars["String"];
};

export type AdminUserActionInput = {
  action: Scalars["String"];
  customValue?: InputMaybe<Scalars["String"]>;
  notes?: InputMaybe<Scalars["String"]>;
  user_uid: Scalars["ID"];
};

export type AdminUserIncidentInput = {
  category?: InputMaybe<Scalars["String"]>;
  notes?: InputMaybe<Scalars["String"]>;
};

export const CacheControlScope = {
  Private: "PRIVATE",
  Public: "PUBLIC",
} as const;

export type CacheControlScope =
  (typeof CacheControlScope)[keyof typeof CacheControlScope];
export const EnrollmentPauseWindowReason = {
  PaymentFailure: "payment_failure",
  UserAction: "user_action",
} as const;

export type EnrollmentPauseWindowReason =
  (typeof EnrollmentPauseWindowReason)[keyof typeof EnrollmentPauseWindowReason];
export type InterfacePreferencesInput = {
  activityFormatDescriptionFlexHidden?: InputMaybe<Scalars["Boolean"]>;
  activityFormatDescriptionMultiDayHidden?: InputMaybe<Scalars["Boolean"]>;
  activityFormatDescriptionOneTimeHidden?: InputMaybe<Scalars["Boolean"]>;
  activityFormatDescriptionOngoingHidden?: InputMaybe<Scalars["Boolean"]>;
  defaultScheduleFilters?: InputMaybe<UserScheduleFiltersInput>;
};

export type UserScheduleFiltersInput = {
  dow?: InputMaybe<Scalars["String"]>;
  endBy?: InputMaybe<Scalars["String"]>;
  endByTime?: InputMaybe<Scalars["Float"]>;
  startAfter?: InputMaybe<Scalars["String"]>;
  startAfterTime?: InputMaybe<Scalars["Float"]>;
  startBefore?: InputMaybe<Scalars["String"]>;
};

export type PhotoDimensions = {
  height?: InputMaybe<Scalars["Int"]>;
  width?: InputMaybe<Scalars["Int"]>;
};

export type SchoolClosureInputV2 = {
  affected: Scalars["Boolean"];
  application_status?: InputMaybe<FfapApplicationStatus>;
  hispanic_latino: Scalars["Boolean"];
  household_size: Scalars["Int"];
  household_size_3_to_18: Scalars["Int"];
  how_did_you_hear: Scalars["String"];
  income: Scalars["String"];
  interested_in_research: Scalars["Boolean"];
  interested_in_sharing: Scalars["Boolean"];
  learning_environments: Array<Scalars["String"]>;
  primary_language: Scalars["String"];
  race_ethnicity: Array<Scalars["String"]>;
  reliable_internet: Scalars["Boolean"];
  zip_code: Scalars["String"];
};

export const SignupInitiator = {
  User: "user",
} as const;

export type SignupInitiator =
  (typeof SignupInitiator)[keyof typeof SignupInitiator];
export const SuspendedReason = {
  AccountTermination: "AccountTermination",
  EducatorRemovalRequest: "EducatorRemovalRequest",
  FamilyTermsofServiceViolation: "FamilyTermsofServiceViolation",
  InactiveAccount: "InactiveAccount",
  PolicyViolation: "PolicyViolation",
  SuspiciousActivity: "SuspiciousActivity",
  TemporarySuspension: "TemporarySuspension",
  TooManyFailedLoginAttempts: "TooManyFailedLoginAttempts",
  TrustAndSafetySuspension: "TrustAndSafetySuspension",
  UserRequestFullDeletion: "UserRequestFullDeletion",
} as const;

export type SuspendedReason =
  (typeof SuspendedReason)[keyof typeof SuspendedReason];
export type TagInput = {
  key: Scalars["String"];
  value: Scalars["String"];
};
